import _get from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/get";
import _createForOfIteratorHelper from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _wrapNativeSuper from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _objectWithoutProperties2 from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _arrayLikeToArray2 from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray";
import _toArray from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/toArray";
import _classCallCheck2 from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass2 from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn2 from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _isNativeReflectConstruct2 from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct";
import _getPrototypeOf2 from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits2 from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/inherits";
import _toConsumableArray2 from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty2 from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var _excluded4 = ["refKey", "ref"],
  _excluded5 = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"],
  _excluded6 = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"],
  _excluded7 = ["refKey", "ref"],
  _excluded8 = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"],
  _excluded9 = ["isInitialMount", "highlightedIndex", "items", "environment"],
  _excluded0 = ["onMouseLeave", "refKey", "ref"],
  _excluded1 = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"],
  _excluded10 = ["onClick", "onPress", "refKey", "ref"],
  _excluded11 = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "refKey", "ref"],
  _excluded12 = ["refKey", "ref"];
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf2(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _callSuper(t, o, e) { return o = _getPrototypeOf2(o), _possibleConstructorReturn2(t, _isNativeReflectConstruct2() ? Reflect.construct(o, e || [], _getPrototypeOf2(t).constructor) : o.apply(t, e)); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import React$2, { createContext, useState, useEffect, useContext, useMemo, Children, forwardRef, createElement, useImperativeHandle, useRef, useCallback, Component, useLayoutEffect, cloneElement, useReducer, memo, Fragment, createRef, Suspense } from 'react';
import require$$0$1 from 'path';
import { createPortal } from 'react-dom';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var isMergeableObject$2 = function isMergeableObject(value) {
  return isNonNullObject$2(value) && !isSpecial$2(value);
};
function isNonNullObject$2(value) {
  return !!value && typeof value === 'object';
}
function isSpecial$2(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement$2(value);
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol$2 = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE$2 = canUseSymbol$2 ? Symbol.for('react.element') : 0xeac7;
function isReactElement$2(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE$2;
}
function emptyTarget$2(val) {
  return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified$2(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge$2(emptyTarget$2(value), value, options) : value;
}
function defaultArrayMerge$2(target, source, options) {
  return target.concat(source).map(function (element) {
    return cloneUnlessOtherwiseSpecified$2(element, options);
  });
}
function getMergeFunction(key, options) {
  if (!options.customMerge) {
    return deepmerge$2;
  }
  var customMerge = options.customMerge(key);
  return typeof customMerge === 'function' ? customMerge : deepmerge$2;
}
function getEnumerableOwnPropertySymbols(target) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
    return Object.propertyIsEnumerable.call(target, symbol);
  }) : [];
}
function getKeys(target) {
  return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}
function propertyIsOnObject(object, property) {
  try {
    return property in object;
  } catch (_) {
    return false;
  }
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
  return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
  && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
  && Object.propertyIsEnumerable.call(target, key)); // and also unsafe if they're nonenumerable.
}
function mergeObject$2(target, source, options) {
  var destination = {};
  if (options.isMergeableObject(target)) {
    getKeys(target).forEach(function (key) {
      destination[key] = cloneUnlessOtherwiseSpecified$2(target[key], options);
    });
  }
  getKeys(source).forEach(function (key) {
    if (propertyIsUnsafe(target, key)) {
      return;
    }
    if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
      destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
    } else {
      destination[key] = cloneUnlessOtherwiseSpecified$2(source[key], options);
    }
  });
  return destination;
}
function deepmerge$2(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge$2;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject$2;
  // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
  // implementations can use it. The caller may not replace it.
  options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified$2;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified$2(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject$2(target, source, options);
  }
}
deepmerge$2.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error('first argument should be an array');
  }
  return array.reduce(function (prev, next) {
    return deepmerge$2(prev, next, options);
  }, {});
};
var deepmerge_1$2 = deepmerge$2;
var cjs = deepmerge_1$2;
var PoppinsBold = "data:font/ttf;base64,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";
var PoppinsLight = "data:font/ttf;base64,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";
var PoppinsMedium = "data:font/ttf;base64,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";
var PoppinsRegular = "data:font/ttf;base64,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";
var PoppinsSemiBold = "data:font/ttf;base64,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";
var classnames$1 = {
  exports: {}
};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
  /* global define */

  (function () {
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes = '';
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (arg) {
          classes = appendClass(classes, parseValue(arg));
        }
      }
      return classes;
    }
    function parseValue(arg) {
      if (typeof arg === 'string' || typeof arg === 'number') {
        return arg;
      }
      if (typeof arg !== 'object') {
        return '';
      }
      if (Array.isArray(arg)) {
        return classNames.apply(null, arg);
      }
      if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
        return arg.toString();
      }
      var classes = '';
      for (var key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes = appendClass(classes, key);
        }
      }
      return classes;
    }
    function appendClass(value, newClass) {
      if (!newClass) {
        return value;
      }
      if (value) {
        return value + ' ' + newClass;
      }
      return value + newClass;
    }
    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames$1);
var classnames = classnames$1.exports;
var DefaultLoaderModel = {
  color: 'rgb(240, 95, 62)'
};
var styles$M = {
  "loader": "loader-module_loader__ozJxu"
};
var BaseLoader = function BaseLoader(_ref6) {
  var _ref6$size = _ref6.size,
    size = _ref6$size === void 0 ? '24px' : _ref6$size,
    _ref6$color = _ref6.color,
    color = _ref6$color === void 0 ? DefaultLoaderModel.color : _ref6$color,
    _ref6$className = _ref6.className,
    className = _ref6$className === void 0 ? '' : _ref6$className;
  var borderColor = "".concat(String(color), " transparent transparent transparent");
  return React$2.createElement("span", {
    className: classnames(styles$M.loader, className),
    style: {
      fontSize: size
    }
  }, React$2.createElement("div", {
    style: {
      borderColor: borderColor
    }
  }), React$2.createElement("div", {
    style: {
      borderColor: borderColor
    }
  }), React$2.createElement("div", {
    style: {
      borderColor: borderColor
    }
  }), React$2.createElement("div", {
    style: {
      borderColor: borderColor
    }
  }));
};
var DefaultAlertModel = {
  standard: {
    background: '#FEF9F0',
    border: '#A9B9DF'
  },
  success: {
    background: '#FEF9F0',
    border: '#4FA353'
  },
  info: {
    background: '#FEF9F0',
    border: '#A9B9DF'
  },
  warning: {
    background: '#FEF9F0',
    border: '#F7B519'
  },
  error: {
    background: '#FEF9F0',
    border: '#F15E40'
  }
};
var toInlineStyle$1 = function toInlineStyle$1() {
  var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    backgroundColor: model === null || model === void 0 ? void 0 : model.background,
    borderColor: model === null || model === void 0 ? void 0 : model.border
  };
};
var DefaultButtonModel = {
  primary: {
    borderRadius: '4px',
    background: 'black',
    foreground: '#FACBD7',
    hover: {
      background: 'black',
      foreground: '#FFFFFF' // TODO styleguide... check blacks and greys too...
    },
    disabled: {
      background: '#888888',
      foreground: '#FACBD7'
    }
  },
  secondary: {
    borderRadius: '4px',
    background: 'transparent',
    foreground: 'black',
    hover: {
      background: 'transparent',
      foreground: 'black'
    },
    disabled: {
      background: 'transparent',
      foreground: '#888888'
    }
  },
  tertiary: {
    borderRadius: '4px',
    background: 'white',
    foreground: 'black',
    border: 'solid 1px black',
    hover: {
      background: 'black',
      foreground: '#FFFFFF'
    },
    disabled: {
      background: 'white',
      foreground: '#888888'
    }
  }
};
var toInlineStyle = function toInlineStyle() {
  var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    backgroundColor: model.background,
    color: model.foreground,
    fill: model.foreground,
    border: model.border
  };
};
var asset$2 = "data:image/svg+xml,%3Csvg%20width%3D%22200%22%20height%3D%2210%22%20viewBox%3D%220%200%20200%2010%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M0%201C8.33%201%208.33%208.96%2016.66%208.96C24.99%208.96%2024.99%201%2033.31%201C41.64%201%2041.64%208.96%2049.98%208.96C58.31%208.96%2058.31%201%2066.63%201C74.94%201%2074.94%208.96%2083.25%208.96C91.58%208.96%2091.58%201%2099.92%201C108.24%201%20108.24%208.96%20116.56%208.96C124.89%208.96%20124.89%201%20133.23%201C141.57%201%20141.57%208.96%20149.91%208.96C158.24%208.96%20158.24%201%20166.57%201C174.92%201%20174.92%208.96%20183.27%208.96C191.64%208.96%20191.64%201%20200%201%22%20stroke%3D%22%23A9B9DF%22%20stroke-width%3D%222%22%20stroke-miterlimit%3D%2210%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";
var DefaultDividerModel = {
  src: asset$2
};
var DefaultFormBodyModel = {
  text: {
    color: '#F15E40'
  },
  checkbox: {
    color: '#4DC44D'
  },
  borderColor: '#a9b9df',
  error: {
    color: '#F15E40'
  },
  address: {
    copy: {
      manualLink: 'Enter address manually',
      invalid: 'Address should be valid',
      select: 'Select a country',
      prompt: 'Start typing your address or postcode',
      lookupError: 'Postcode lookup error. Please enter address manually.'
    }
  }
};
var DefaultFormHeaderModel = {
  background: '#FFF5E2'
};
var DefaultFormModel = {
  header: DefaultFormHeaderModel,
  body: DefaultFormBodyModel,
  title: "Let's get that gift to you",
  subtitle: 'Enter your delivery address and we’ll get your gift delivered to you in 3 - 5 working days!',
  confirmButtonText: 'ORDER NOW'
};
var GiftWrapType;
(function (GiftWrapType) {
  GiftWrapType["None"] = "no-gift-wrapping";
  GiftWrapType["Default"] = "default-gift-wrapping";
  GiftWrapType["Snow"] = "snow-gift-wrapping";
  GiftWrapType["RedStripes"] = "red-stripes-gift-wrapping";
  GiftWrapType["BlueStars"] = "blue-stars-gift-wrapping";
  GiftWrapType["ChristmasTrees"] = "christmas-trees-gift-wrapping";
  GiftWrapType["ChristmasWreath"] = "christmas-wreath-gift-wrapping";
  GiftWrapType["RemoteImage"] = "remote-image";
})(GiftWrapType || (GiftWrapType = {}));
var DefaultGiftWrapModel = {
  wrapping: GiftWrapType.Default
};
var asset$1 = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20407%20155%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23f05f3f%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M25.26%2C15.27h12.96c1.66%2C0%2C2.98%2C1.65%2C2.9%2C3.63l-1.48%2C40.79c-.08%2C2.06%2C2.24%2C2.76%2C3.01%2C.91%2C3.67-8.84%2C10.67-19.89%2C22.67-19.89%2C14.32%2C0%2C20.82%2C9.13%2C20.82%2C41.35v26.52c0%2C1.92-1.3%2C3.49-2.9%2C3.49h-11.67c-1.6%2C0-2.9-1.56-2.9-3.49v-18.18c0-19.5-3.76-25.86-12.9-25.86s-15.95%2C13.27-15.95%2C32.36v11.68c0%2C1.92-1.3%2C3.49-2.9%2C3.49h-11.67c-1.6%2C0-2.9-1.56-2.9-3.49V18.75c0-1.92%2C1.3-3.48%2C2.9-3.48%22%2F%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M155.37%2C112.07h-12.83c-1.7%2C0-3.03-1.75-2.89-3.78l.82-11.54c.15-2.06-2.16-2.89-2.97-1.06-3.77%2C8.59-10.66%2C18.59-22.29%2C18.59-14.22%2C0-20.72-9.13-20.72-41.35v-26.53c0-1.92%2C1.3-3.48%2C2.9-3.48h11.67c1.6%2C0%2C2.9%2C1.56%2C2.9%2C3.48v22.75c0%2C14.27%2C3.66%2C21.88%2C12.8%2C21.88s16.04-9.29%2C16.04-28.86v-16.25c0-1.45%2C1.3-3.01%2C2.9-3.01h11.67c1.6%2C0%2C2.9%2C1.56%2C2.9%2C3.48v62.19c0%2C1.92-1.3%2C3.48-2.9%2C3.48%22%2F%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M173.23%2C131.91v-15.31c0-1.94%2C1.72-3.17%2C3.15-2.26%2C4.97%2C3.15%2C12.87%2C6.59%2C21.23%2C6.59%2C13%2C0%2C18.88-6.64%2C19.51-18.74%2C0-.04%2C.02-.08%2C.03-.11%2C.36-2.04-1.89-3.13-2.88-1.42-4.56%2C7.91-12.45%2C11.98-21.54%2C11.98-16.04%2C0-27.01-13.28-27.01-35.69s11.07-36.23%2C26.1-36.23c12.31%2C0%2C19.39%2C8.72%2C23.1%2C15.78%2C.88%2C1.66%2C3.03%2C.8%2C2.91-1.16l-.51-8.68c-.11-2.01%2C1.21-3.73%2C2.9-3.73h11.25c1.6%2C0%2C2.9%2C1.56%2C2.9%2C3.49v57.37c0%2C25.03-13.82%2C35.95-33.82%2C35.95-9.91%2C0-17.75-1.58-25.01-4.13-1.37-.48-2.31-1.98-2.31-3.7m41.74-54.68c0-11.89-7.92-17.7-16.35-17.7s-16.04%2C5.81-16.04%2C17.7%2C7.41%2C18.25%2C16.04%2C18.25%2C16.35-6.22%2C16.35-18.25%22%2F%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M248.36%2C131.91v-15.31c0-1.94%2C1.72-3.17%2C3.15-2.26%2C4.97%2C3.15%2C12.87%2C6.59%2C21.23%2C6.59%2C13%2C0%2C18.88-6.64%2C19.51-18.74%2C0-.04%2C.02-.08%2C.03-.11%2C.36-2.04-1.89-3.13-2.88-1.42-4.56%2C7.91-12.45%2C11.98-21.54%2C11.98-16.04%2C0-27.01-13.28-27.01-35.69s11.07-36.23%2C26.1-36.23c12.31%2C0%2C19.39%2C8.72%2C23.1%2C15.78%2C.88%2C1.66%2C3.03%2C.8%2C2.91-1.16l-.51-8.68c-.12-2.01%2C1.21-3.73%2C2.9-3.73h11.25c1.6%2C0%2C2.9%2C1.56%2C2.9%2C3.49v57.37c0%2C25.03-13.82%2C35.95-33.82%2C35.95-9.91%2C0-17.75-1.58-25.01-4.13-1.37-.48-2.31-1.98-2.31-3.7m41.74-54.68c0-11.89-7.92-17.7-16.35-17.7s-16.04%2C5.81-16.04%2C17.7%2C7.41%2C18.25%2C16.04%2C18.25%2C16.35-6.22%2C16.35-18.25%22%2F%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M323.5%2C131.91v-15.31c0-1.94%2C1.72-3.17%2C3.15-2.26%2C4.97%2C3.15%2C12.87%2C6.59%2C21.23%2C6.59%2C13%2C0%2C18.88-6.64%2C19.51-18.74%2C0-.04%2C.02-.08%2C.03-.11%2C.36-2.04-1.89-3.13-2.88-1.42-4.56%2C7.91-12.45%2C11.98-21.54%2C11.98-16.04%2C0-27.01-13.28-27.01-35.69s11.07-36.23%2C26.1-36.23c12.31%2C0%2C19.39%2C8.72%2C23.1%2C15.78%2C.88%2C1.66%2C3.03%2C.8%2C2.91-1.16l-.51-8.68c-.12-2.01%2C1.21-3.73%2C2.9-3.73h11.25c1.6%2C0%2C2.9%2C1.56%2C2.9%2C3.49v57.37c0%2C25.03-13.82%2C35.95-33.82%2C35.95-9.91%2C0-17.75-1.58-25.01-4.13-1.37-.48-2.31-1.98-2.31-3.7m41.74-54.68c0-11.89-7.92-17.7-16.35-17.7s-16.04%2C5.81-16.04%2C17.7%2C7.41%2C18.25%2C16.04%2C18.25%2C16.35-6.22%2C16.35-18.25%22%2F%3E%3C%2Fsvg%3E";
var DefaultLogoModel = {
  src: asset$1,
  height: '40px'
};
var bulletAsset = "data:image/svg+xml,%3Csvg%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2012%2011%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M6.5871%200.679459L7.57957%203.6543C7.60904%203.74458%207.65941%203.82665%207.72658%203.89381C7.79374%203.96098%207.87581%204.01135%207.96609%204.04082L10.9227%205.07338C11.0771%205.12702%2011.2041%205.23956%2011.2758%205.38643C11.3476%205.53329%2011.3583%205.70255%2011.3057%205.85723C11.2742%205.94636%2011.2232%206.0273%2011.1564%206.09414C11.0895%206.16097%2011.0086%206.21201%2010.9194%206.2435L7.96713%207.27051C7.87676%207.30158%207.79468%207.35285%207.72712%207.42041C7.65955%207.48797%207.60829%207.57006%207.57721%207.66043L6.58667%2010.6346C6.54565%2010.7578%206.46691%2010.8649%206.36161%2010.9408C6.2563%2011.0167%206.12976%2011.0575%205.99992%2011.0575C5.87007%2011.0574%205.74351%2011.0165%205.63815%2010.9406C5.5328%2010.8646%205.45399%2010.7574%205.4129%2010.6342L4.43137%207.66306C4.39925%207.57322%204.34759%207.49162%204.28011%207.42414C4.21264%207.35667%204.13104%207.30501%204.0412%207.27289L1.08457%206.24033C0.962545%206.19881%200.856509%206.12022%200.781273%206.01553C0.706036%205.91085%200.665356%205.78531%200.664913%205.65644C0.66447%205.52756%200.704287%205.40179%200.778802%205.2967C0.853317%205.1916%200.958811%205.11241%201.08055%205.07021L4.0438%204.03956C4.13293%204.00806%204.21388%203.95703%204.28071%203.89019C4.34755%203.82336%204.39858%203.74241%204.43008%203.65329L5.41333%200.679081C5.45435%200.555911%205.53308%200.448794%205.63839%200.372904C5.7437%200.297014%205.87024%200.256199%206.00008%200.256241C6.12993%200.256283%206.25649%200.29718%206.36185%200.373137C6.4672%200.449095%206.54601%200.556263%206.5871%200.679459Z%22%20fill%3D%22%23A9B9DF%22%2F%3E%3C%2Fsvg%3E";
var DefaultMarkdownModel = {
  bulletAsset: bulletAsset,
  blockquote: {
    backgroundColor: '#FEF9F0',
    borderColor: '#F7B519'
  }
};
var DefaultPanelModel = {
  background: 'rgb(254, 249, 240)'
};
var DefaultReactionModel = {
  enabled: true,
  quickEmojis: ['🙌', '🤩', '🤗', '🥹', '🫶'],
  colors: {
    received: '#fff5e2',
    sent: 'rgb(238, 240, 248)'
  },
  copy: {
    heading: {
      template: 'Say thanks to {{{sender}}}',
      static: 'Say thanks'
    },
    picker: {
      title: 'Send Reaction',
      subtitle: {
        template: "We'll share your emoji reaction with {{{sender}}}",
        static: "We'll share your emoji reaction with the sender"
      }
    },
    comment: {
      heading: 'Add a thank you message',
      button: 'SEND MESSAGE',
      labels: {
        name: 'Your name',
        message: 'Your message'
      },
      placeholders: {
        message: 'Show your appreciation here...'
      }
    }
  }
};
var DefaultTypographyModel = {
  Title: {
    fontFamily: 'PoppinsSemiBold',
    fontSize: '24px',
    lineHeight: '36px'
  },
  Heading_1: {
    fontFamily: 'PoppinsSemiBold',
    fontSize: '18px',
    lineHeight: '27px'
  },
  Heading_2: {
    fontFamily: 'PoppinsRegular',
    fontSize: '18px',
    lineHeight: '27px'
  },
  Heading_3: {
    fontFamily: 'PoppinsSemiBold',
    fontSize: '16px',
    lineHeight: '24px'
  },
  Heading_4: {
    fontFamily: 'PoppinsRegular',
    fontSize: '16px',
    lineHeight: '24px'
  },
  Body_1: {
    fontFamily: 'PoppinsMedium',
    fontSize: '14px',
    lineHeight: '21px'
  },
  Body_2: {
    fontFamily: 'PoppinsRegular',
    fontSize: '14px',
    lineHeight: '21px'
  },
  Body_3: {
    fontFamily: 'PoppinsLight',
    fontSize: '14px',
    lineHeight: '21px'
  },
  Body_4: {
    fontFamily: 'PoppinsBold',
    fontSize: '14px',
    lineHeight: '21px'
  },
  Small_1: {
    fontFamily: 'PoppinsRegular',
    fontSize: '12px',
    lineHeight: '18px'
  },
  Small_2: {
    fontFamily: 'PoppinsBold',
    fontSize: '12px',
    lineHeight: '18px'
  },
  Lede: {
    fontFamily: 'PoppinsMedium',
    fontSize: '14px',
    lineHeight: '21px'
  },
  Footer_1: {
    fontFamily: 'PoppinsMedium',
    fontSize: '10px',
    lineHeight: '15px'
  },
  Footer_2: {
    fontFamily: 'PoppinsRegular',
    fontSize: '10px',
    lineHeight: '15px'
  },
  Notice: {
    fontFamily: 'PoppinsSemiBold',
    fontSize: '12px',
    lineHeight: '18px'
  },
  Button: {
    fontFamily: 'PoppinsBold',
    fontSize: '16px',
    lineHeight: '24px'
  },
  Help: {
    fontFamily: 'PoppinsMedium',
    fontSize: '12px',
    lineHeight: '18px'
  },
  FormError: {
    fontFamily: 'PoppinsLight',
    fontSize: '12px',
    lineHeight: '15px'
  }
};
var DefaultCookieBannerModel = {
  heading: 'Our Use of Cookies',
  body: "We use necessary cookies to make our site work. We'd also like to set cookies that help us make improvements to the site. These will be set only if you accept.",
  accept: 'Accept all cookies',
  deny: 'Reject all cookies'
};
var DefaultOperatorModel = {
  name: 'huggg',
  website: 'https://huggg.me',
  privacy: 'https://huggg.me/privacy/',
  legal: '© Huggg Limited, registered in England and Wales Company #09579886. Registered office: 71 Queen Victoria Street, London, EC4V 4BE',
  support: 'Please contact support@huggg.me.',
  showHugggSupportLinks: true,
  showHugggPromotions: true,
  exposeApiErrorMessages: true,
  productNoun: null,
  siteTitle: 'huggg',
  faviconPath: '/favicon',
  maskIcon: {
    href: '/favicon/safari-pinned-tab.svg',
    color: '#5bbad5'
  },
  logoSrc: null,
  isWelfare: false
};
var DefaultThemeModel = {
  name: 'default',
  operator: DefaultOperatorModel,
  isWelfare: false,
  landingPageButtonCopy: 'GIFT DETAILS',
  shouldShowPoweredByHuggg: false,
  typography: DefaultTypographyModel,
  loader: DefaultLoaderModel,
  button: DefaultButtonModel,
  form: DefaultFormModel,
  alert: DefaultAlertModel,
  markdown: DefaultMarkdownModel,
  panel: DefaultPanelModel,
  divider: DefaultDividerModel,
  logo: DefaultLogoModel,
  giftWrap: DefaultGiftWrapModel,
  reaction: DefaultReactionModel,
  cookieBanner: DefaultCookieBannerModel
};
var ThemeContext = createContext(DefaultThemeModel);
var ThemeContextProvider = function ThemeContextProvider(_ref7) {
  var theme = _ref7.theme,
    modelLoader = _ref7.modelLoader,
    children = _ref7.children;
  var _useState2 = useState(DefaultThemeModel),
    _useState3 = _slicedToArray(_useState2, 2),
    model = _useState3[0],
    setModel = _useState3[1];
  var _useState4 = useState(true),
    _useState5 = _slicedToArray(_useState4, 2),
    loadingModel = _useState5[0],
    setLoadingModel = _useState5[1];
  var _useState6 = useState(true),
    _useState7 = _slicedToArray(_useState6, 2),
    loadingFonts = _useState7[0],
    setLoadingFonts = _useState7[1];
  useEffect(function () {
    var addFont = function addFont(font) {
      // The browser Font Loading API supports add; TypeScript 4.9 omits it from FontFaceSet.
      document.fonts.add(font);
    };
    var loadFonts = function loadFonts() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
        var toLoad, fonts;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              toLoad = [{
                family: 'PoppinsLight',
                url: PoppinsLight
              }, {
                family: 'PoppinsMedium',
                url: PoppinsMedium
              }, {
                family: 'PoppinsRegular',
                url: PoppinsRegular
              }, {
                family: 'PoppinsSemiBold',
                url: PoppinsSemiBold
              }, {
                family: 'PoppinsBold',
                url: PoppinsBold
              }];
              fonts = toLoad.map(function (_ref8) {
                var family = _ref8.family,
                  url = _ref8.url;
                return new FontFace(family, "url(".concat(url, ")"));
              });
              _context.n = 1;
              return Promise.all(fonts.map(function (font) {
                return font.load().then(addFont);
              }));
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
    };
    void loadFonts().then(function () {
      setLoadingFonts(false);
    }).catch(function (ex) {
      // Font loading runs in the browser, where no service logger is available.
      // oxlint-disable-next-line no-console
      console.warn("there was an error loading fonts: ".concat(String(ex)));
      setLoadingFonts(false);
    });
  }, []);
  useEffect(function () {
    var fetchModel = function fetchModel(theme) {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, modelLoader(theme));
          }
        }, _callee2);
      }));
    };
    setLoadingModel(true);
    void fetchModel(theme).then(function (model) {
      if (!model) {
        throw new Error("no model was returned for the ".concat(theme, " theme"));
      }
      var merged = cjs(DefaultThemeModel, model, {
        arrayMerge: function arrayMerge(_destinationArray, sourceArray) {
          return sourceArray;
        }
      });
      setModel(merged);
      setLoadingModel(false);
    }).catch(function (ex) {
      // Theme bootstrap failures are reported in browser diagnostics before a model is available.
      // oxlint-disable-next-line eslint/no-console
      console.warn("there was an error loading the theme model: ".concat(String(ex)));
      setModel(DefaultThemeModel);
      setLoadingModel(false);
    });
  }, [theme]);
  return loadingFonts || loadingModel ? React$2.createElement(BaseLoader, null) : React$2.createElement(ThemeContext.Provider, {
    value: model
  }, children);
};
var useThemeContext = function useThemeContext() {
  return useContext(ThemeContext);
};
var TypographyVariant;
(function (TypographyVariant) {
  TypographyVariant["Title"] = "Title";
  TypographyVariant["Heading_1"] = "Heading_1";
  TypographyVariant["Heading_2"] = "Heading_2";
  TypographyVariant["Heading_3"] = "Heading_3";
  TypographyVariant["Heading_4"] = "Heading_4";
  TypographyVariant["Body_1"] = "Body_1";
  TypographyVariant["Body_2"] = "Body_2";
  TypographyVariant["Body_3"] = "Body_3";
  TypographyVariant["Body_4"] = "Body_4";
  TypographyVariant["Small_1"] = "Small_1";
  TypographyVariant["Small_2"] = "Small_2";
  TypographyVariant["Lede"] = "Lede";
  TypographyVariant["Footer_1"] = "Footer_1";
  TypographyVariant["Footer_2"] = "Footer_2";
  TypographyVariant["Notice"] = "Notice";
  TypographyVariant["Button"] = "Button";
  TypographyVariant["Help"] = "Help";
  TypographyVariant["FormError"] = "FormError";
})(TypographyVariant || (TypographyVariant = {}));
var Typography = function Typography(_ref9) {
  var variant = _ref9.variant,
    children = _ref9.children,
    styleFromProps = _ref9.style,
    className = _ref9.className;
  // Legacy JavaScript theme providers may omit typography.
  var _useThemeContext = useThemeContext(),
    _useThemeContext$typo = _useThemeContext.typography,
    typography = _useThemeContext$typo === void 0 ? {} : _useThemeContext$typo;
  var value = Array.isArray(children) ? children : [children];
  var style = Object.assign(Object.assign({}, typography[variant]), styleFromProps);
  return React$2.createElement("div", {
    style: style,
    className: className
  }, value.map(function (child) {
    return child;
  }));
};
var getTypography = function getTypography(variant) {
  return function (props) {
    return React$2.createElement(Typography, Object.assign({
      variant: variant
    }, props));
  };
};
// TODO these all need to be PascalCase not Snake_Case
var Title = getTypography(TypographyVariant.Title);
var Heading_1 = getTypography(TypographyVariant.Heading_1);
var Heading_2 = getTypography(TypographyVariant.Heading_2);
var Heading_3 = getTypography(TypographyVariant.Heading_3);
var Heading_4 = getTypography(TypographyVariant.Heading_4);
var Body_1 = getTypography(TypographyVariant.Body_1);
var Body_2 = getTypography(TypographyVariant.Body_2);
var Body_3 = getTypography(TypographyVariant.Body_3);
var Body_4 = getTypography(TypographyVariant.Body_4);
var Small_1 = getTypography(TypographyVariant.Small_1);
var Small_2 = getTypography(TypographyVariant.Small_2);
var Lede = getTypography(TypographyVariant.Lede);
var Footer_1 = getTypography(TypographyVariant.Footer_1);
var Footer_2 = getTypography(TypographyVariant.Footer_2);
var Notice = getTypography(TypographyVariant.Notice);
var Button$1 = getTypography(TypographyVariant.Button);
var Help = getTypography(TypographyVariant.Help);
var FormError = getTypography(TypographyVariant.FormError);
var FontFamily;
(function (FontFamily) {
  FontFamily["PoppinsLight"] = "PoppinsLight";
  FontFamily["PoppinsMedium"] = "PoppinsMedium";
  FontFamily["PoppinsRegular"] = "PoppinsRegular";
  FontFamily["PoppinsSemiBold"] = "PoppinsSemiBold";
  FontFamily["PoppinsBold"] = "PoppinsBold";
})(FontFamily || (FontFamily = {}));
var styles$L = {
  "container": "accordion-module_container__6Meqy",
  "rowContainer": "accordion-module_rowContainer__GehE3",
  "row": "accordion-module_row__n-M2q",
  "stateIcon": "accordion-module_stateIcon__WuB-x",
  "content": "accordion-module_content__YSlY-"
};
var AccordionStateIcon = function AccordionStateIcon(_ref0) {
  var open = _ref0.open;
  return React$2.createElement("div", {
    className: styles$L.stateIcon,
    style: open ? {
      transform: 'rotate(45deg)'
    } : {}
  }, React$2.createElement("svg", {
    width: "24",
    height: "20",
    fill: "none"
  }, React$2.createElement("g", {
    stroke: "#000",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React$2.createElement("path", {
    d: "M12 19V5"
  }), React$2.createElement("path", {
    d: "M5 12H19"
  }))));
};
var AccordionRow = function AccordionRow(_ref1) {
  var heading = _ref1.heading,
    onOpen = _ref1.onOpen,
    onClose = _ref1.onClose,
    _ref1$startOpen = _ref1.startOpen,
    startOpen = _ref1$startOpen === void 0 ? false : _ref1$startOpen,
    children = _ref1.children;
  var _useState8 = useState(startOpen),
    _useState9 = _slicedToArray(_useState8, 2),
    open = _useState9[0],
    setOpen = _useState9[1];
  // TODO pressed / focus / hover should be different, like the toggle
  var onExpandChange = function onExpandChange() {
    var value = !open;
    setOpen(value);
    if (value) {
      if (onOpen) {
        onOpen();
      }
    } else {
      if (onClose) {
        onClose();
      }
    }
  };
  var HeadingTypography = useMemo(function () {
    return open ? Heading_1 : Heading_2;
  }, [open]);
  var maxHeight = '75vh';
  return React$2.createElement("div", {
    key: "heading".concat(startOpen),
    className: styles$L.rowContainer
  }, React$2.createElement("button", {
    className: styles$L.row,
    onClick: onExpandChange,
    style: open ? {
      boxShadow: '0 1px 0 #EEF0F8'
    } : {}
  }, React$2.createElement(HeadingTypography, null, heading), React$2.createElement(AccordionStateIcon, {
    open: open
  })), React$2.createElement("div", {
    className: styles$L.content,
    style: open ? {
      maxHeight: maxHeight,
      visibility: 'visible',
      marginTop: '1px'
    } : {
      visibility: 'hidden',
      paddingTop: 0,
      paddingBottom: 0
    }
  }, children));
};
var Accordion = function Accordion(_ref10) {
  var rows = _ref10.rows;
  return React$2.createElement("div", {
    className: styles$L.container
  }, rows.map(function (row) {
    return React$2.createElement(AccordionRow, Object.assign({
      key: row.heading
    }, row), row.children);
  }));
};
var styles$K = {
  "container": "alert-module_container__cM1a-",
  "title": "alert-module_title__iOe0H"
};
var AlertVariant;
(function (AlertVariant) {
  AlertVariant["Success"] = "success";
  AlertVariant["Info"] = "info";
  AlertVariant["Warning"] = "warning";
  AlertVariant["Error"] = "error";
  AlertVariant["Standard"] = "standard";
})(AlertVariant || (AlertVariant = {}));
var VariantAlert = function VariantAlert(_ref11) {
  var title = _ref11.title,
    message = _ref11.message,
    variant = _ref11.variant,
    children = _ref11.children,
    className = _ref11.className;
  var _useThemeContext2 = useThemeContext(),
    alert = _useThemeContext2.alert;
  return React$2.createElement("div", {
    style: toInlineStyle$1(alert[variant]),
    className: classnames(className, styles$K.container)
  }, title && React$2.createElement(Body_1, {
    className: classnames(_defineProperty2({}, styles$K.title, Boolean(message)))
  }, title), Boolean(message) && React$2.createElement(Body_3, null, message), children);
};
var getVariant = function getVariant(variant) {
  return function (props) {
    return React$2.createElement(VariantAlert, Object.assign({
      variant: variant
    }, props));
  };
};
var StandardAlert = getVariant(AlertVariant.Standard);
var SuccessAlert = getVariant(AlertVariant.Success);
var InfoAlert = getVariant(AlertVariant.Info);
var WarningAlert = getVariant(AlertVariant.Warning);
var ErrorAlert = getVariant(AlertVariant.Error);
var styles$J = {
  "container": "arrow-module_container__H5mEB",
  "arrow": "arrow-module_arrow__oRA6l",
  "backwards": "arrow-module_backwards__3csSR",
  "background": "arrow-module_background__iS8hp"
};

// TODO tests...
var Arrow = function Arrow(_ref12) {
  var _ref12$backwards = _ref12.backwards,
    backwards = _ref12$backwards === void 0 ? false : _ref12$backwards,
    _ref12$background = _ref12.background,
    background = _ref12$background === void 0 ? false : _ref12$background;
  return React$2.createElement("div", {
    className: classnames(styles$J.container, _defineProperty2(_defineProperty2({}, styles$J.backwards, backwards), styles$J.background, background))
  }, React$2.createElement("div", {
    style: background ? {
      fill: 'white'
    } : {},
    className: classnames(styles$J.arrow)
  }, React$2.createElement("svg", {
    width: "20",
    height: "15",
    viewBox: "0 0 20 15"
  }, React$2.createElement("path", {
    d: "M18.48 6.85999C14.96 5.99999 12.59 3.62999 12.59 0.959991H11.09C11.09 3.28999 12.44 5.40999 14.66 6.83999H0V8.33999H14.66C12.45 9.76999 11.09 11.89 11.09 14.22H12.59C12.59 11.55 14.96 9.17999 18.48 8.31999C18.82 8.23999 19.05 7.93999 19.05 7.58999C19.05 7.23999 18.81 6.93999 18.48 6.85999Z"
  }))));
};
var Loader = function Loader(_ref13) {
  var size = _ref13.size,
    className = _ref13.className;
  var _useThemeContext3 = useThemeContext(),
    loader = _useThemeContext3.loader;
  return React$2.createElement(BaseLoader, {
    className: className,
    size: size,
    color: loader.color
  });
};
var styles$I = {
  "button": "button-module_button__WDVlB",
  "disabled": "button-module_disabled__c0pm5"
};
var ButtonArrowState;
(function (ButtonArrowState) {
  ButtonArrowState["Forwards"] = "forwards";
  ButtonArrowState["Backwards"] = "backwards";
  ButtonArrowState["None"] = "none";
})(ButtonArrowState || (ButtonArrowState = {}));
var ButtonType;
(function (ButtonType) {
  ButtonType["Reset"] = "reset";
  ButtonType["Button"] = "button";
  ButtonType["Submit"] = "submit";
})(ButtonType || (ButtonType = {}));
var BaseButton = function BaseButton(_ref14) {
  var className = _ref14.className,
    style = _ref14.style,
    label = _ref14.label,
    _onClick = _ref14.onClick,
    onMouseOver = _ref14.onMouseOver,
    onMouseOut = _ref14.onMouseOut,
    _ref14$disabled = _ref14.disabled,
    disabled = _ref14$disabled === void 0 ? false : _ref14$disabled,
    _ref14$loading = _ref14.loading,
    loading = _ref14$loading === void 0 ? false : _ref14$loading,
    _ref14$type = _ref14.type,
    type = _ref14$type === void 0 ? ButtonType.Button : _ref14$type,
    _ref14$arrow = _ref14.arrow,
    arrow = _ref14$arrow === void 0 ? ButtonArrowState.Forwards : _ref14$arrow,
    children = _ref14.children,
    testId = _ref14['data-test-id'],
    fontFamily = _ref14.fontFamily;
  var renderButtonLabel = function renderButtonLabel() {
    return React$2.createElement(React$2.Fragment, null, arrow === ButtonArrowState.Backwards && React$2.createElement(Arrow, {
      backwards: true
    }), React$2.createElement(Button$1, {
      style: fontFamily ? {
        fontFamily: fontFamily
      } : undefined
    }, label), arrow === ButtonArrowState.Forwards && React$2.createElement(Arrow, null));
  };
  var renderButtonContent = function renderButtonContent() {
    switch (true) {
      case loading:
        {
          return React$2.createElement(Loader, null);
        }
      case Boolean(children):
        {
          var value = Array.isArray(children) ? children : [children];
          return React$2.createElement("div", null, value.map(function (child) {
            return child;
          }));
        }
      default:
        {
          return renderButtonLabel();
        }
    }
  };
  return React$2.createElement("button", {
    "data-test-id": testId,
    className: classnames(styles$I.button, className, _defineProperty2({}, styles$I.disabled, disabled)),
    type: type,
    onClick: function onClick() {
      if (_onClick && !(loading || disabled)) {
        _onClick();
      }
    },
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut,
    disabled: disabled,
    style: style
  }, renderButtonContent());
};
var ButtonVariant;
(function (ButtonVariant) {
  ButtonVariant["Primary"] = "primary";
  ButtonVariant["Secondary"] = "secondary";
  ButtonVariant["Tertiary"] = "tertiary";
})(ButtonVariant || (ButtonVariant = {}));
var VariantButton = function VariantButton(_ref15) {
  var className = _ref15.className,
    label = _ref15.label,
    arrow = _ref15.arrow,
    onClick = _ref15.onClick,
    disabled = _ref15.disabled,
    type = _ref15.type,
    propsStyle = _ref15.style,
    variant = _ref15.variant,
    loading = _ref15.loading,
    children = _ref15.children,
    testId = _ref15['data-test-id'],
    fontFamily = _ref15.fontFamily;
  var _useState0 = useState(false),
    _useState1 = _slicedToArray(_useState0, 2),
    isHovering = _useState1[0],
    setIsHovering = _useState1[1];
  var _useThemeContext4 = useThemeContext(),
    button = _useThemeContext4.button;
  var getStyle = function getStyle() {
    var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var style = {};
    switch (true) {
      case disabled:
        style = toInlineStyle(model.disabled);
        break;
      case isHovering:
        style = toInlineStyle(model.hover);
        break;
      default:
        style = toInlineStyle(model);
        break;
    }
    return Object.assign(Object.assign(Object.assign({}, style), {
      borderRadius: model.borderRadius
    }), propsStyle);
  };
  return React$2.createElement(BaseButton, {
    className: className,
    type: type,
    onClick: onClick,
    onMouseOver: function onMouseOver() {
      setIsHovering(true);
    },
    onMouseOut: function onMouseOut() {
      setIsHovering(false);
    },
    disabled: disabled,
    style: getStyle(button[variant]),
    label: label,
    arrow: arrow,
    loading: loading,
    children: children,
    "data-test-id": testId,
    fontFamily: fontFamily
  });
};
var getButton = function getButton(variant) {
  return function (props) {
    return React$2.createElement(VariantButton, Object.assign({
      variant: variant
    }, props));
  };
};
var PrimaryButton = getButton(ButtonVariant.Primary);
var SecondaryButton = getButton(ButtonVariant.Secondary);
var TertiaryButton = getButton(ButtonVariant.Tertiary);
function ownKeys(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function _objectSpread2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? ownKeys(Object(r), !0).forEach(function (t) {
      _defineProperty$1(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var r = 0; r < t.length; r++) {
    var i = t[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function _createClass(e, t, r) {
  return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty$1(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function _extends$6() {
  return (_extends$6 = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }).apply(this, arguments);
}
function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && _setPrototypeOf$1(e, t);
}
function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function _setPrototypeOf$1(e, t) {
  return (_setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}
function _objectWithoutPropertiesLoose$3(e, t) {
  if (null == e) return {};
  var r,
    i,
    n = {},
    s = Object.keys(e);
  for (i = 0; i < s.length; i++) r = s[i], t.indexOf(r) >= 0 || (n[r] = e[r]);
  return n;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var r,
    i,
    n = _objectWithoutPropertiesLoose$3(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (i = 0; i < s.length; i++) r = s[i], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function _assertThisInitialized$1(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _possibleConstructorReturn(e, t) {
  if (t && ("object" == typeof t || "function" == typeof t)) return t;
  if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(e);
}
function _createSuper(e) {
  var t = _isNativeReflectConstruct();
  return function () {
    var r,
      i = _getPrototypeOf(e);
    if (t) {
      var n = _getPrototypeOf(this).constructor;
      r = Reflect.construct(i, arguments, n);
    } else r = i.apply(this, arguments);
    return _possibleConstructorReturn(this, r);
  };
}
function _toConsumableArray(e) {
  return _arrayWithoutHoles(e) || _iterableToArray(e) || _unsupportedIterableToArray$1(e) || _nonIterableSpread();
}
function _arrayWithoutHoles(e) {
  if (Array.isArray(e)) return _arrayLikeToArray$1(e);
}
function _iterableToArray(e) {
  if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
}
function _unsupportedIterableToArray$1(e, t) {
  if (e) {
    if ("string" == typeof e) return _arrayLikeToArray$1(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _arrayLikeToArray$1(e, t) : void 0;
  }
}
function _arrayLikeToArray$1(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, i = new Array(t); r < t; r++) i[r] = e[r];
  return i;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function createCommonjsModule(e, t) {
  return t = {
    exports: {}
  }, e(t, t.exports), t.exports;
}
function emptyFunction() {}
function emptyFunctionWithReset() {}
function cn(e) {
  return e.map(function (e) {
    return !1 === e ? null : e;
  }).join(" ").replace(/\s+/g, " ").trim();
}
function slideSize(e, t) {
  return 100 / e * t / t;
}
function slideTraySize(e, t) {
  return 100 * e / t;
}
function pct(e) {
  return "".concat(e, "%");
}
function equal$1(e, t, r) {
  if (e === t) return !0;
  var i = types$5[jkrosoType(e)],
    n = types$5[jkrosoType(t)];
  return !(!i || i !== n) && i(e, t, r);
}
function memoGaurd(e) {
  return function (t, r, i) {
    if (!i) return e(t, r, []);
    for (var n, s = i.length; n = i[--s];) if (n[0] === t && n[1] === r) return !0;
    return e(t, r, i);
  };
}
function arrayEqual(e, t, r) {
  var i = e.length;
  if (i !== t.length) return !1;
  for (r.push([e, t]); i--;) if (!equal$1(e[i], t[i], r)) return !1;
  return !0;
}
function objectEqual(e, t, r) {
  if ("function" == typeof e.equal) return r.push([e, t]), e.equal(t, r);
  var i = getEnumerableProperties(e),
    n = getEnumerableProperties(t),
    s = i.length;
  if (s !== n.length) return !1;
  for (i.sort(), n.sort(); s--;) if (i[s] !== n[s]) return !1;
  for (r.push([e, t]), s = i.length; s--;) {
    var o = i[s];
    if (!equal$1(e[o], t[o], r)) return !1;
  }
  return !0;
}
function getEnumerableProperties(e) {
  var t = [];
  for (var r in e) "constructor" !== r && t.push(r);
  return t;
}
function isNonNullObject$1(e) {
  return !!e && "object" == typeof e;
}
function isSpecial$1(e) {
  var t = Object.prototype.toString.call(e);
  return "[object RegExp]" === t || "[object Date]" === t || isReactElement$1(e);
}
function isReactElement$1(e) {
  return e.$$typeof === REACT_ELEMENT_TYPE$1;
}
function emptyTarget$1(e) {
  return Array.isArray(e) ? [] : {};
}
function cloneUnlessOtherwiseSpecified$1(e, t) {
  return !1 !== t.clone && t.isMergeableObject(e) ? deepmerge$1(emptyTarget$1(e), e, t) : e;
}
function defaultArrayMerge$1(e, t, r) {
  return e.concat(t).map(function (e) {
    return cloneUnlessOtherwiseSpecified$1(e, r);
  });
}
function mergeObject$1(e, t, r) {
  var i = {};
  return r.isMergeableObject(e) && Object.keys(e).forEach(function (t) {
    i[t] = cloneUnlessOtherwiseSpecified$1(e[t], r);
  }), Object.keys(t).forEach(function (n) {
    r.isMergeableObject(t[n]) && e[n] ? i[n] = deepmerge$1(e[n], t[n], r) : i[n] = cloneUnlessOtherwiseSpecified$1(t[n], r);
  }), i;
}
function deepmerge$1(e, t, r) {
  (r = r || {}).arrayMerge = r.arrayMerge || defaultArrayMerge$1, r.isMergeableObject = r.isMergeableObject || isMergeableObject$1;
  var i = Array.isArray(t);
  return i === Array.isArray(e) ? i ? r.arrayMerge(e, t, r) : mergeObject$1(e, t, r) : cloneUnlessOtherwiseSpecified$1(t, r);
}
function WithStore(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {
      return {};
    },
    r = function (r) {
      function i(e, r) {
        var s;
        return _classCallCheck(this, i), s = n.call(this, e, r), s.state = t(_objectSpread2({}, r.state)), s.updateStateProps = s.updateStateProps.bind(_assertThisInitialized$1(s)), s;
      }
      _inherits(i, r);
      var n = _createSuper(i);
      return _createClass(i, [{
        key: "componentDidMount",
        value: function value() {
          this.context.subscribe(this.updateStateProps);
        }
      }, {
        key: "shouldComponentUpdate",
        value: function value(e, t) {
          return !equals$1(t, this.state) || !equals$1(e, this.props);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.context.unsubscribe(this.updateStateProps);
        }
      }, {
        key: "updateStateProps",
        value: function value() {
          this.setState(t(_objectSpread2({}, this.context.state)));
        }
      }, {
        key: "render",
        value: function value() {
          var t = this,
            r = deepmerge_1$1(this.state, this.props);
          return React$2.createElement(e, _extends$6({
            ref: function ref(e) {
              t.instance = e;
            }
          }, r, {
            carouselStore: {
              getStoreState: this.context.getStoreState,
              masterSpinnerError: this.context.masterSpinnerError,
              masterSpinnerSuccess: this.context.masterSpinnerSuccess,
              setStoreState: this.context.setStoreState,
              subscribeMasterSpinner: this.context.subscribeMasterSpinner,
              unsubscribeAllMasterSpinner: this.context.unsubscribeAllMasterSpinner,
              unsubscribeMasterSpinner: this.context.unsubscribeMasterSpinner
            }
          }), this.props.children);
        }
      }]), i;
    }(React$2.Component);
  return _defineProperty$1(r, "contextType", Context$1), _defineProperty$1(r, "propTypes", {
    children: CarouselPropTypes.children
  }), _defineProperty$1(r, "defaultProps", {
    children: null
  }), r;
}
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
  ReactPropTypesSecret_1$1 = ReactPropTypesSecret;
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims$1 = function factoryWithThrowingShims$1() {
    function e(e, t, r, i, n, s) {
      if (s !== ReactPropTypesSecret_1$1) {
        var o = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw o.name = "Invariant Violation", o;
      }
    }
    function t() {
      return e;
    }
    e.isRequired = e;
    var r = {
      array: e,
      bigint: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    return r.PropTypes = r, r;
  },
  propTypes$2 = createCommonjsModule(function (e) {
    e.exports = factoryWithThrowingShims$1();
  }),
  LOADING = "loading",
  SUCCESS = "success",
  ERROR = "error",
  CarouselPropTypes = {
    children: propTypes$2.oneOfType([propTypes$2.arrayOf(propTypes$2.node), propTypes$2.node]),
    direction: propTypes$2.oneOf(["forward", "backward"]),
    height: function height(e, t) {
      var r = e[t];
      return "vertical" !== e.orientation || null !== r && "number" == typeof r ? null : new Error("Missing required property '".concat(t, "' when orientation is vertical.  You must supply a number representing the height in pixels"));
    },
    orientation: propTypes$2.oneOf(["horizontal", "vertical"]),
    isBgImage: function isBgImage(e, t) {
      return !0 === e[t] && "img" === e.tag ? new Error("HTML img elements should not have a backgroundImage.  Please use ".concat(t, " for other block-level HTML tags, like div, a, section, etc...")) : null;
    }
  },
  boundedRange = function boundedRange(e) {
    var t = e.min,
      r = e.max,
      i = e.x;
    return Math.min(r, Math.max(t, i));
  },
  s = {
    buttonBack: "buttonBack___1mlaL"
  },
  _excluded$2 = ["carouselStore", "className", "currentSlide", "disabled", "onClick", "step", "totalSlides", "visibleSlides", "infinite"],
  ButtonBack = function (e) {
    function t(e) {
      var i;
      return _classCallCheck(this, t), i = r.call(this, e), i.handleOnClick = i.handleOnClick.bind(_assertThisInitialized$1(i)), i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "handleOnClick",
      value: function value(e) {
        var t = this.props,
          r = t.carouselStore,
          i = t.currentSlide,
          n = t.onClick,
          s = t.step,
          o = t.infinite,
          a = t.visibleSlides,
          l = t.totalSlides - a,
          c = Math.max(i - s, 0);
        o && (c = 0 === i ? l : c), r.setStoreState({
          currentSlide: c,
          isPlaying: !1
        }, null !== n && n.call(this, e));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          r = (e.carouselStore, e.className),
          i = (e.currentSlide, e.disabled, e.onClick, e.step, e.totalSlides, e.visibleSlides, e.infinite),
          n = _objectWithoutProperties(e, _excluded$2),
          o = cn([s.buttonBack, "carousel__back-button", r]),
          a = t.setDisabled(this.props.disabled, this.props.currentSlide, i);
        return React$2.createElement("button", _extends$6({
          type: "button",
          "aria-label": "previous",
          className: o,
          onClick: this.handleOnClick,
          disabled: a
        }, n), this.props.children);
      }
    }], [{
      key: "setDisabled",
      value: function value(e, t, r) {
        return null !== e ? e : 0 === t && !r;
      }
    }]), t;
  }(React$2.Component);
_defineProperty$1(ButtonBack, "propTypes", {
  carouselStore: propTypes$2.object.isRequired,
  children: CarouselPropTypes.children.isRequired,
  className: propTypes$2.string,
  currentSlide: propTypes$2.number.isRequired,
  disabled: propTypes$2.bool,
  onClick: propTypes$2.func,
  step: propTypes$2.number.isRequired,
  totalSlides: propTypes$2.number.isRequired,
  visibleSlides: propTypes$2.number.isRequired,
  infinite: propTypes$2.bool
}), _defineProperty$1(ButtonBack, "defaultProps", {
  className: null,
  disabled: null,
  onClick: null,
  infinite: !1
});
var jkrosoType = createCommonjsModule(function (e, t) {
  var r = {}.toString,
    i = "undefined" != typeof window ? window.Node : Function;
  e.exports = t = function t(e) {
    var t = typeof e;
    if ("object" != t) return t;
    if (t = n[r.call(e)], "object" == t) return e instanceof Map ? "map" : e instanceof Set ? "set" : "object";
    if (t) return t;
    if (e instanceof i) switch (e.nodeType) {
      case 1:
        return "element";
      case 3:
        return "text-node";
      case 9:
        return "document";
      case 11:
        return "document-fragment";
      default:
        return "dom-node";
    }
  };
  var n = t.types = {
    "[object Function]": "function",
    "[object Date]": "date",
    "[object RegExp]": "regexp",
    "[object Arguments]": "arguments",
    "[object Array]": "array",
    "[object Set]": "set",
    "[object String]": "string",
    "[object Null]": "null",
    "[object Undefined]": "undefined",
    "[object Number]": "number",
    "[object Boolean]": "boolean",
    "[object Object]": "object",
    "[object Map]": "map",
    "[object Text]": "text-node",
    "[object Uint8Array]": "bit-array",
    "[object Uint16Array]": "bit-array",
    "[object Uint32Array]": "bit-array",
    "[object Uint8ClampedArray]": "bit-array",
    "[object Error]": "error",
    "[object FormData]": "form-data",
    "[object File]": "file",
    "[object Blob]": "blob"
  };
});
jkrosoType.types;
var types$5 = {};
types$5.number = function (e, t) {
  return e !== e && t !== t;
}, types$5.function = function (e, t, r) {
  return e.toString() === t.toString() && types$5.object(e, t, r) && equal$1(e.prototype, t.prototype);
}, types$5.date = function (e, t) {
  return +e == +t;
}, types$5.regexp = function (e, t) {
  return e.toString() === t.toString();
}, types$5.element = function (e, t) {
  return e.outerHTML === t.outerHTML;
}, types$5.textnode = function (e, t) {
  return e.textContent === t.textContent;
}, types$5.arguments = types$5["bit-array"] = types$5.array = memoGaurd(arrayEqual), types$5.object = memoGaurd(objectEqual);
var equals$1 = equal$1,
  isMergeableObject$1 = function isMergeableObject$1(e) {
    return isNonNullObject$1(e) && !isSpecial$1(e);
  },
  canUseSymbol$1 = "function" == typeof Symbol && Symbol.for,
  REACT_ELEMENT_TYPE$1 = canUseSymbol$1 ? Symbol.for("react.element") : 60103;
deepmerge$1.all = function (e, t) {
  if (!Array.isArray(e)) throw new Error("first argument should be an array");
  return e.reduce(function (e, r) {
    return deepmerge$1(e, r, t);
  }, {});
};
var deepmerge_1$1 = deepmerge$1,
  Context$1 = React$2.createContext(),
  deepFreeze = function e(t) {
    return Object.freeze(t), Object.getOwnPropertyNames(t).forEach(function (r) {
      !t.hasOwnProperty(r) || null === t[r] || "object" != typeof t[r] && "function" != typeof t[r] || Object.isFrozen(t[r]) || e(t[r]);
    }), t;
  },
  DEFAULT_STATE = {
    masterSpinnerFinished: !1
  },
  Store = function () {
    function e(t) {
      _classCallCheck(this, e), this.state = deepFreeze(deepmerge_1$1(DEFAULT_STATE, t)), this.subscriptions = [], this.masterSpinnerSubscriptions = {}, this.setStoreState = this.setStoreState.bind(this), this.getStoreState = this.getStoreState.bind(this), this.subscribe = this.subscribe.bind(this), this.unsubscribe = this.unsubscribe.bind(this), this.updateSubscribers = this.updateSubscribers.bind(this), this.subscribeMasterSpinner = this.subscribeMasterSpinner.bind(this), this.unsubscribeMasterSpinner = this.unsubscribeMasterSpinner.bind(this), this.unsubscribeAllMasterSpinner = this.unsubscribeAllMasterSpinner.bind(this), this.masterSpinnerSuccess = this.masterSpinnerSuccess.bind(this), this.masterSpinnerError = this.masterSpinnerError.bind(this);
    }
    return _createClass(e, [{
      key: "setStoreState",
      value: function value(e, t) {
        this.state = deepFreeze(deepmerge_1$1(this.state, e)), this.updateSubscribers(t);
      }
    }, {
      key: "getStoreState",
      value: function value() {
        return deepmerge_1$1({}, this.state);
      }
    }, {
      key: "subscribe",
      value: function value(e) {
        this.subscriptions.push(e);
      }
    }, {
      key: "unsubscribe",
      value: function value(e) {
        var t = this.subscriptions.indexOf(e);
        -1 !== t && this.subscriptions.splice(t, 1);
      }
    }, {
      key: "updateSubscribers",
      value: function value(e) {
        this.subscriptions.forEach(function (e) {
          return e();
        }), "function" == typeof e && e(this.getStoreState());
      }
    }, {
      key: "subscribeMasterSpinner",
      value: function value(e) {
        -1 === Object.keys(this.masterSpinnerSubscriptions).indexOf(e) && (this.masterSpinnerSubscriptions[e] = {
          success: !1,
          error: !1,
          complete: !1
        });
      }
    }, {
      key: "unsubscribeMasterSpinner",
      value: function value(e) {
        return -1 !== Object.keys(this.masterSpinnerSubscriptions).indexOf(e) && (this.setMasterSpinnerFinished(), delete this.masterSpinnerSubscriptions[e]);
      }
    }, {
      key: "unsubscribeAllMasterSpinner",
      value: function value() {
        this.masterSpinnerSubscriptions = {}, this.setMasterSpinnerFinished();
      }
    }, {
      key: "masterSpinnerSuccess",
      value: function value(e) {
        this.masterSpinnerSubscriptions[e].success = !0, this.masterSpinnerSubscriptions[e].complete = !0, this.setMasterSpinnerFinished();
      }
    }, {
      key: "masterSpinnerError",
      value: function value(e) {
        this.masterSpinnerSubscriptions[e].error = !0, this.masterSpinnerSubscriptions[e].complete = !0, this.setMasterSpinnerFinished();
      }
    }, {
      key: "setMasterSpinnerFinished",
      value: function value() {
        this.setStoreState({
          masterSpinnerFinished: this.isMasterSpinnerFinished()
        });
      }
    }, {
      key: "isMasterSpinnerFinished",
      value: function value() {
        var e = this;
        return 0 === Object.keys(this.masterSpinnerSubscriptions).filter(function (t) {
          return !0 !== e.masterSpinnerSubscriptions[t].complete;
        }).length;
      }
    }]), e;
  }(),
  _excluded$1$1 = ["children", "className", "currentSlide", "disableAnimation", "disableKeyboard", "hasMasterSpinner", "interval", "isPageScrollLocked", "isPlaying", "lockOnWindowScroll", "naturalSlideHeight", "naturalSlideWidth", "orientation", "playDirection", "step", "dragStep", "tag", "totalSlides", "touchEnabled", "dragEnabled", "visibleSlides", "infinite", "isIntrinsicHeight"],
  _class,
  CarouselProvider = (_class = function (e) {
    function t(e) {
      var i;
      if (_classCallCheck(this, t), i = r.call(this, e), e.isIntrinsicHeight && "horizontal" !== e.orientation) throw Error('isIntrinsicHeight can only be used in "horizontal" orientation. See Readme for more information.');
      var n = {
        currentSlide: e.currentSlide,
        disableAnimation: e.disableAnimation,
        disableKeyboard: e.disableKeyboard,
        hasMasterSpinner: e.hasMasterSpinner,
        imageErrorCount: 0,
        imageSuccessCount: 0,
        interval: e.interval,
        isPageScrollLocked: e.isPageScrollLocked,
        isPlaying: e.isPlaying,
        lockOnWindowScroll: e.lockOnWindowScroll,
        masterSpinnerThreshold: 0,
        naturalSlideHeight: e.naturalSlideHeight,
        naturalSlideWidth: e.naturalSlideWidth,
        orientation: e.orientation,
        playDirection: e.playDirection,
        privateUnDisableAnimation: !1,
        slideSize: slideSize(e.totalSlides, e.visibleSlides),
        slideTraySize: slideTraySize(e.totalSlides, e.visibleSlides),
        step: e.step,
        dragStep: e.dragStep,
        totalSlides: e.totalSlides,
        touchEnabled: e.touchEnabled,
        dragEnabled: e.dragEnabled,
        visibleSlides: e.visibleSlides,
        infinite: e.infinite,
        isIntrinsicHeight: e.isIntrinsicHeight
      };
      return i.carouselStore = new Store(n), i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "componentDidUpdate",
      value: function value(e) {
        var t = this,
          r = {};
        ["currentSlide", "disableAnimation", "disableKeyboard", "hasMasterSpinner", "interval", "isPlaying", "naturalSlideHeight", "naturalSlideWidth", "lockOnWindowScroll", "orientation", "playDirection", "step", "dragStep", "totalSlides", "touchEnabled", "dragEnabled", "visibleSlides"].forEach(function (i) {
          e[i] !== t.props[i] && (r[i] = t.props[i]);
        }), this.props.currentSlide !== e.currentSlide && !this.props.disableAnimation && (r.disableAnimation = !0, r.privateUnDisableAnimation = !0), this.props.totalSlides === e.totalSlides && this.props.visibleSlides === e.visibleSlides || (r.slideSize = slideSize(this.props.totalSlides, this.props.visibleSlides), r.slideTraySize = slideTraySize(this.props.totalSlides, this.props.visibleSlides)), this.carouselStore.state.currentSlide >= this.props.totalSlides && (r.currentSlide = Math.max(this.props.totalSlides - 1, 0)), Object.keys(r).length > 0 && this.carouselStore.setStoreState(r);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.carouselStore.unsubscribeAllMasterSpinner();
      }
    }, {
      key: "getStore",
      value: function value() {
        return this.carouselStore;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = (e.children, e.className, e.currentSlide, e.disableAnimation, e.disableKeyboard, e.hasMasterSpinner, e.interval, e.isPageScrollLocked, e.isPlaying, e.lockOnWindowScroll, e.naturalSlideHeight, e.naturalSlideWidth, e.orientation, e.playDirection, e.step, e.dragStep, e.tag),
          r = (e.totalSlides, e.touchEnabled, e.dragEnabled, e.visibleSlides, e.infinite, e.isIntrinsicHeight, _objectWithoutProperties(e, _excluded$1$1)),
          i = cn(["carousel", this.props.className]);
        return React$2.createElement(t, _extends$6({
          className: i
        }, r), React$2.createElement(Context$1.Provider, {
          value: this.carouselStore
        }, this.props.children));
      }
    }]), t;
  }(React$2.Component), _defineProperty$1(_class, "propTypes", {
    children: CarouselPropTypes.children.isRequired,
    className: propTypes$2.string,
    currentSlide: propTypes$2.number,
    disableAnimation: propTypes$2.bool,
    disableKeyboard: propTypes$2.bool,
    hasMasterSpinner: propTypes$2.bool,
    interval: propTypes$2.number,
    isPageScrollLocked: propTypes$2.bool,
    isPlaying: propTypes$2.bool,
    lockOnWindowScroll: propTypes$2.bool,
    naturalSlideHeight: propTypes$2.number.isRequired,
    naturalSlideWidth: propTypes$2.number.isRequired,
    orientation: CarouselPropTypes.orientation,
    playDirection: CarouselPropTypes.direction,
    step: propTypes$2.number,
    dragStep: propTypes$2.number,
    tag: propTypes$2.string,
    totalSlides: propTypes$2.number.isRequired,
    touchEnabled: propTypes$2.bool,
    dragEnabled: propTypes$2.bool,
    visibleSlides: propTypes$2.number,
    infinite: propTypes$2.bool,
    isIntrinsicHeight: propTypes$2.bool
  }), _defineProperty$1(_class, "defaultProps", {
    className: null,
    currentSlide: 0,
    disableAnimation: !1,
    disableKeyboard: !1,
    hasMasterSpinner: !1,
    interval: 5e3,
    isPageScrollLocked: !1,
    isPlaying: !1,
    lockOnWindowScroll: !1,
    orientation: "horizontal",
    playDirection: "forward",
    step: 1,
    dragStep: 1,
    tag: "div",
    touchEnabled: !0,
    dragEnabled: !0,
    visibleSlides: 1,
    infinite: !1,
    isIntrinsicHeight: !1
  }), _class);
Context$1.Consumer;
var index$1 = WithStore(ButtonBack, function (e) {
    return {
      currentSlide: e.currentSlide,
      step: e.step,
      totalSlides: e.totalSlides,
      visibleSlides: e.visibleSlides,
      infinite: e.infinite
    };
  }),
  s$1 = {
    buttonFirst: "buttonFirst___2rhFr"
  },
  _excluded$2$1 = ["carouselStore", "className", "currentSlide", "disabled", "onClick", "totalSlides"],
  _class$1,
  ButtonFirst = (_class$1 = function (e) {
    function t() {
      var e;
      return _classCallCheck(this, t), e = r.call(this), e.handleOnClick = e.handleOnClick.bind(_assertThisInitialized$1(e)), e;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "handleOnClick",
      value: function value(e) {
        var t = this.props,
          r = t.carouselStore,
          i = t.onClick;
        r.setStoreState({
          currentSlide: 0,
          isPlaying: !1
        }, null !== i && i.call(this, e));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = (e.carouselStore, e.className),
          r = e.currentSlide,
          i = e.disabled,
          n = (e.onClick, e.totalSlides, _objectWithoutProperties(e, _excluded$2$1)),
          s = cn([s$1.buttonFirst, "carousel__first-button", t]),
          o = null !== i ? i : 0 === r;
        return React$2.createElement("button", _extends$6({
          type: "button",
          "aria-label": "first",
          className: s,
          onClick: this.handleOnClick,
          disabled: o
        }, n), this.props.children);
      }
    }]), t;
  }(React$2.Component), _defineProperty$1(_class$1, "propTypes", {
    carouselStore: propTypes$2.object.isRequired,
    children: CarouselPropTypes.children.isRequired,
    className: propTypes$2.string,
    currentSlide: propTypes$2.number.isRequired,
    disabled: propTypes$2.bool,
    onClick: propTypes$2.func,
    totalSlides: propTypes$2.number.isRequired
  }), _defineProperty$1(_class$1, "defaultProps", {
    className: null,
    disabled: null,
    onClick: null
  }), _class$1);
WithStore(ButtonFirst, function (e) {
  return {
    currentSlide: e.currentSlide,
    totalSlides: e.totalSlides
  };
});
var s$2 = {
    buttonLast: "buttonLast___2yuh0"
  },
  _excluded$3 = ["carouselStore", "className", "currentSlide", "disabled", "onClick", "totalSlides", "visibleSlides"],
  _class$2,
  ButtonLast = (_class$2 = function (e) {
    function t() {
      var e;
      return _classCallCheck(this, t), e = r.call(this), e.handleOnClick = e.handleOnClick.bind(_assertThisInitialized$1(e)), e;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "handleOnClick",
      value: function value(e) {
        var t = this.props,
          r = t.carouselStore,
          i = t.onClick,
          n = t.totalSlides,
          s = t.visibleSlides;
        r.setStoreState({
          currentSlide: n - s,
          isPlaying: !1
        }, null !== i && i.call(this, e));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = (e.carouselStore, e.className),
          r = e.currentSlide,
          i = e.disabled,
          n = (e.onClick, e.totalSlides),
          s = e.visibleSlides,
          o = _objectWithoutProperties(e, _excluded$3),
          a = cn([s$2.buttonLast, "carousel__last-button", t]),
          l = null !== i ? i : r >= n - s;
        return React$2.createElement("button", _extends$6({
          type: "button",
          "aria-label": "last",
          className: a,
          onClick: this.handleOnClick,
          disabled: l
        }, o), this.props.children);
      }
    }]), t;
  }(React$2.Component), _defineProperty$1(_class$2, "propTypes", {
    carouselStore: propTypes$2.object.isRequired,
    children: CarouselPropTypes.children.isRequired,
    className: propTypes$2.string,
    currentSlide: propTypes$2.number.isRequired,
    disabled: propTypes$2.bool,
    onClick: propTypes$2.func,
    totalSlides: propTypes$2.number.isRequired,
    visibleSlides: propTypes$2.number.isRequired
  }), _defineProperty$1(_class$2, "defaultProps", {
    className: null,
    disabled: null,
    onClick: null
  }), _class$2);
WithStore(ButtonLast, function (e) {
  return {
    currentSlide: e.currentSlide,
    totalSlides: e.totalSlides,
    visibleSlides: e.visibleSlides
  };
});
var s$3 = {
    buttonNext: "buttonNext___2mOCa"
  },
  _excluded$4 = ["carouselStore", "className", "currentSlide", "disabled", "onClick", "step", "totalSlides", "visibleSlides", "infinite"],
  _class$3,
  ButtonNext = (_class$3 = function (e) {
    function t(e) {
      var i;
      return _classCallCheck(this, t), i = r.call(this, e), i.handleOnClick = i.handleOnClick.bind(_assertThisInitialized$1(i)), i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "handleOnClick",
      value: function value(e) {
        var t = this.props,
          r = t.currentSlide,
          i = t.onClick,
          n = t.step,
          s = t.carouselStore,
          o = t.infinite,
          a = t.totalSlides - t.visibleSlides,
          l = n + r,
          c = Math.min(l, a);
        o && (c = a === r ? 0 : c), s.setStoreState({
          currentSlide: c,
          isPlaying: !1
        }, null !== i && i.call(this, e));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          r = (e.carouselStore, e.className),
          i = e.currentSlide,
          n = e.disabled,
          s = (e.onClick, e.step, e.totalSlides),
          o = e.visibleSlides,
          a = e.infinite,
          l = _objectWithoutProperties(e, _excluded$4),
          c = cn([s$3.buttonNext, "carousel__next-button", r]),
          u = t.setDisabled(n, i, o, s, a);
        return React$2.createElement("button", _extends$6({
          type: "button",
          "aria-label": "next",
          className: c,
          onClick: this.handleOnClick,
          disabled: u
        }, l), this.props.children);
      }
    }], [{
      key: "setDisabled",
      value: function value(e, t, r, i, n) {
        return null !== e ? e : t >= i - r && !n;
      }
    }]), t;
  }(React$2.PureComponent), _defineProperty$1(_class$3, "propTypes", {
    carouselStore: propTypes$2.object.isRequired,
    children: CarouselPropTypes.children.isRequired,
    className: propTypes$2.string,
    currentSlide: propTypes$2.number.isRequired,
    disabled: propTypes$2.bool,
    onClick: propTypes$2.func,
    step: propTypes$2.number.isRequired,
    totalSlides: propTypes$2.number.isRequired,
    visibleSlides: propTypes$2.number.isRequired,
    infinite: propTypes$2.bool
  }), _defineProperty$1(_class$3, "defaultProps", {
    className: null,
    disabled: null,
    onClick: null,
    infinite: !1
  }), _class$3),
  index$3 = WithStore(ButtonNext, function (e) {
    return {
      currentSlide: e.currentSlide,
      step: e.step,
      totalSlides: e.totalSlides,
      visibleSlides: e.visibleSlides,
      infinite: e.infinite
    };
  }),
  s$4 = {
    buttonNext: "buttonNext___3Lm3s"
  },
  _excluded$5 = ["carouselStore", "children", "childrenPaused", "childrenPlaying", "className", "isPlaying", "onClick"],
  _class$4,
  ButtonPlay = (_class$4 = function (e) {
    function t(e) {
      var i;
      return _classCallCheck(this, t), i = r.call(this, e), i.handleOnClick = i.handleOnClick.bind(_assertThisInitialized$1(i)), i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "handleOnClick",
      value: function value(e) {
        var t = this.props.onClick;
        this.props.carouselStore.setStoreState({
          isPlaying: !this.props.isPlaying
        }, null !== t && t.call(this, e));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = (e.carouselStore, e.children, e.childrenPaused),
          r = e.childrenPlaying,
          i = e.className,
          n = e.isPlaying,
          s = (e.onClick, _objectWithoutProperties(e, _excluded$5)),
          o = cn([s$4.buttonNext, "carousel__play-button", i]);
        return React$2.createElement("button", _extends$6({
          type: "button",
          "aria-label": "play",
          className: o,
          onClick: this.handleOnClick
        }, s), n && r, !n && t, this.props.children);
      }
    }]), t;
  }(React$2.PureComponent), _defineProperty$1(_class$4, "propTypes", {
    carouselStore: propTypes$2.object.isRequired,
    children: propTypes$2.node,
    childrenPaused: propTypes$2.node,
    childrenPlaying: propTypes$2.node,
    className: propTypes$2.string,
    isPlaying: propTypes$2.bool.isRequired,
    onClick: propTypes$2.func
  }), _defineProperty$1(_class$4, "defaultProps", {
    children: null,
    childrenPaused: null,
    childrenPlaying: null,
    className: null,
    onClick: null
  }), _class$4);
WithStore(ButtonPlay, function (e) {
  return {
    isPlaying: e.isPlaying
  };
});
var s$5 = {
    dot: "dot___3c3SI"
  },
  _excluded$6 = ["carouselStore", "children", "className", "currentSlide", "disabled", "onClick", "selected", "slide", "totalSlides", "visibleSlides"],
  _class$5,
  Dot$1 = (_class$5 = function (e) {
    function t(e) {
      var i;
      return _classCallCheck(this, t), i = r.call(this, e), i.handleOnClick = i.handleOnClick.bind(_assertThisInitialized$1(i)), i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "handleOnClick",
      value: function value(e) {
        var t = this.props,
          r = t.carouselStore,
          i = t.onClick,
          n = t.slide,
          s = t.totalSlides,
          o = t.visibleSlides,
          a = n >= s - o ? s - o : n;
        r.setStoreState({
          currentSlide: a,
          isPlaying: !1
        }, null !== i && i.call(this, e));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = (e.carouselStore, e.children, e.className),
          r = e.currentSlide,
          i = e.disabled,
          n = (e.onClick, e.selected),
          s = e.slide,
          o = (e.totalSlides, e.visibleSlides),
          a = _objectWithoutProperties(e, _excluded$6),
          l = s >= r && s < r + o,
          c = "boolean" == typeof n ? n : l,
          u = !0 === l,
          p = "boolean" == typeof i ? i : u,
          d = cn([s$5.dot, c && s$5.dotSelected, "carousel__dot", "carousel__dot--".concat(s), c && "carousel__dot--selected", t]);
        return React$2.createElement("button", _extends$6({
          "aria-label": "slide dot",
          type: "button",
          onClick: this.handleOnClick,
          className: d,
          disabled: p
        }, a), this.props.children);
      }
    }]), t;
  }(React$2.Component), _defineProperty$1(_class$5, "propTypes", {
    carouselStore: propTypes$2.object.isRequired,
    children: CarouselPropTypes.children,
    className: propTypes$2.string,
    currentSlide: propTypes$2.number.isRequired,
    disabled: propTypes$2.bool,
    onClick: propTypes$2.func,
    selected: propTypes$2.bool,
    slide: propTypes$2.number.isRequired,
    totalSlides: propTypes$2.number.isRequired,
    visibleSlides: propTypes$2.number.isRequired
  }), _defineProperty$1(_class$5, "defaultProps", {
    children: null,
    className: null,
    disabled: null,
    onClick: null,
    selected: null
  }), _class$5),
  Dot$1$1 = WithStore(Dot$1, function (e) {
    return {
      currentSlide: e.currentSlide,
      totalSlides: e.totalSlides,
      visibleSlides: e.visibleSlides
    };
  }),
  s$6 = {},
  _excluded$7 = ["renderDots"],
  _excluded2 = ["carouselStore", "children", "className", "currentSlide", "dotNumbers", "totalSlides", "visibleSlides", "disableActiveDots", "showAsSelectedForCurrentSlideOnly", "renderDots"],
  _class$6,
  DotGroup = (_class$6 = function (e) {
    function t() {
      return _classCallCheck(this, t), r.apply(this, arguments);
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "renderDots",
      value: function value() {
        var e = this.props,
          t = e.currentSlide,
          r = e.totalSlides,
          i = e.visibleSlides,
          n = e.disableActiveDots,
          s = e.showAsSelectedForCurrentSlideOnly,
          o = e.renderDots;
        if (o) {
          var a = this.props;
          a.renderDots;
          return o(_objectWithoutProperties(a, _excluded$7));
        }
        for (var l = [], c = 0; c < r; c += 1) {
          var u = c >= t && c < t + i,
            p = c === t,
            d = s ? p : u,
            h = c >= r - i ? r - i : c;
          l.push(React$2.createElement(Dot$1$1, {
            key: c,
            slide: h,
            selected: d,
            disabled: !!n && d
          }, React$2.createElement("span", {
            className: cn["carousel__dot-group-dot"]
          }, this.props.dotNumbers && c + 1)));
        }
        return l;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = (e.carouselStore, e.children),
          r = e.className,
          i = (e.currentSlide, e.dotNumbers, e.totalSlides, e.visibleSlides, e.disableActiveDots, e.showAsSelectedForCurrentSlideOnly, e.renderDots, _objectWithoutProperties(e, _excluded2)),
          n = cn([s$6.DotGroup, "carousel__dot-group", r]);
        return React$2.createElement("div", _extends$6({
          className: n
        }, i), this.renderDots(), t);
      }
    }]), t;
  }(React$2.Component), _defineProperty$1(_class$6, "propTypes", {
    children: CarouselPropTypes.children,
    className: propTypes$2.string,
    currentSlide: propTypes$2.number.isRequired,
    carouselStore: propTypes$2.object.isRequired,
    totalSlides: propTypes$2.number.isRequired,
    visibleSlides: propTypes$2.number.isRequired,
    dotNumbers: propTypes$2.bool,
    disableActiveDots: propTypes$2.bool,
    showAsSelectedForCurrentSlideOnly: propTypes$2.bool,
    renderDots: propTypes$2.func
  }), _defineProperty$1(_class$6, "defaultProps", {
    children: null,
    className: null,
    dotNumbers: !1,
    disableActiveDots: !0,
    showAsSelectedForCurrentSlideOnly: !1,
    renderDots: null
  }), _class$6),
  index$5 = WithStore(DotGroup, function (e) {
    return {
      currentSlide: e.currentSlide,
      totalSlides: e.totalSlides,
      visibleSlides: e.visibleSlides
    };
  }),
  s$7 = {
    image: "image___xtQGH"
  },
  _excluded$8 = ["src", "alt"],
  _excluded2$1 = ["carouselStore", "children", "className", "hasMasterSpinner", "isBgImage", "onError", "onLoad", "renderError", "renderLoading", "style", "tag"],
  Image$1 = function (e) {
    function t(e) {
      var i;
      return _classCallCheck(this, t), i = r.call(this, e), i.state = {
        imageStatus: LOADING
      }, i.handleImageLoad = i.handleImageLoad.bind(_assertThisInitialized$1(i)), i.handleImageError = i.handleImageError.bind(_assertThisInitialized$1(i)), i.image = null, i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "componentDidMount",
      value: function value() {
        t.subscribeMasterSpinner(this.props), this.initImage();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        e.src !== this.props.src && (t.unsubscribeMasterSpinner(e), t.subscribeMasterSpinner(this.props), this.initImage());
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        t.unsubscribeMasterSpinner(this.props), this.image.removeEventListener("load", this.handleImageLoad), this.image.removeEventListener("error", this.handleImageError), this.image = null;
      }
    }, {
      key: "initImage",
      value: function value() {
        if (this.setState({
          imageStatus: LOADING
        }), this.image = document.createElement("img"), this.image.addEventListener("load", this.handleImageLoad, !1), this.image.addEventListener("error", this.handleImageError, !1), this.image.src = this.props.src, this.image.readyState || this.image.complete) {
          var e = this.image.src;
          this.image.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==", this.image.src = e;
        }
      }
    }, {
      key: "handleImageLoad",
      value: function value(e) {
        this.setState({
          imageStatus: SUCCESS
        }), this.props.hasMasterSpinner && this.props.carouselStore.masterSpinnerSuccess(this.props.src), this.props.onLoad && this.props.onLoad(e);
      }
    }, {
      key: "handleImageError",
      value: function value(e) {
        this.setState({
          imageStatus: ERROR
        }), this.props.hasMasterSpinner && this.props.carouselStore.masterSpinnerError(this.props.src), this.props.onError && this.props.onError(e);
      }
    }, {
      key: "tempTag",
      value: function value() {
        return "img" === this.props.tag ? "div" : this.props.tag;
      }
    }, {
      key: "customRender",
      value: function value(e) {
        return "function" == typeof this.props[e] ? this.props[e]() : this.props.children;
      }
    }, {
      key: "renderLoading",
      value: function value(e) {
        var t = this.tempTag(),
          r = cn([s$7.image, s$7.imageLoading, "carousel__image", this.props.isBgImage && "carousel__image--with-background", "carousel__image--loading", this.props.className]);
        return React$2.createElement(t, _extends$6({
          className: r
        }, e), this.customRender("renderLoading"));
      }
    }, {
      key: "renderError",
      value: function value(e) {
        var t = this.tempTag(),
          r = cn([s$7.image, s$7.imageError, "carousel__image", this.props.isBgImage && "carousel__image--with-background", "carousel__image--error", this.props.className]);
        return React$2.createElement(t, _extends$6({
          className: r
        }, e), this.customRender("renderError"));
      }
    }, {
      key: "renderSuccess",
      value: function value(e) {
        var t = this.props,
          r = t.style,
          i = t.tag,
          n = cn([s$7.image, "carousel__image", this.props.isBgImage && "carousel__image--with-background", "carousel__image--success", this.props.className]),
          s = _extends$6({}, r),
          o = e;
        if ("img" !== i) {
          var a = e.src;
          e.alt;
          o = _objectWithoutProperties(e, _excluded$8), s = _extends$6({}, r, {
            backgroundImage: 'url("'.concat(a, '")'),
            backgroundSize: "cover"
          });
        }
        return React$2.createElement(i, _extends$6({
          className: n,
          style: s
        }, o), this.props.children);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = (e.carouselStore, e.children, e.className, e.hasMasterSpinner, e.isBgImage, e.onError, e.onLoad, e.renderError, e.renderLoading, e.style, e.tag, _objectWithoutProperties(e, _excluded2$1));
        switch (this.state.imageStatus) {
          case LOADING:
            return this.renderLoading(t);
          case SUCCESS:
            return this.renderSuccess(t);
          case ERROR:
            return this.renderError(t);
          default:
            throw new Error("unknown value for this.state.imageStatus");
        }
      }
    }], [{
      key: "subscribeMasterSpinner",
      value: function value(e) {
        e.hasMasterSpinner && e.carouselStore.subscribeMasterSpinner(e.src);
      }
    }, {
      key: "unsubscribeMasterSpinner",
      value: function value(e) {
        e.hasMasterSpinner && e.carouselStore.unsubscribeMasterSpinner(e.src);
      }
    }]), t;
  }(React$2.Component);
_defineProperty$1(Image$1, "propTypes", {
  alt: propTypes$2.string,
  carouselStore: propTypes$2.object.isRequired,
  children: CarouselPropTypes.children,
  className: propTypes$2.string,
  hasMasterSpinner: propTypes$2.bool.isRequired,
  isBgImage: CarouselPropTypes.isBgImage,
  onError: propTypes$2.func,
  onLoad: propTypes$2.func,
  renderError: propTypes$2.func,
  renderLoading: propTypes$2.func,
  src: propTypes$2.string.isRequired,
  style: propTypes$2.object,
  tag: propTypes$2.string
}), _defineProperty$1(Image$1, "defaultProps", {
  alt: "",
  children: null,
  className: null,
  isBgImage: !1,
  onError: null,
  onLoad: null,
  renderError: null,
  renderLoading: null,
  style: null,
  tag: "img"
});
var Image$1$1 = WithStore(Image$1, function (e) {
    return {
      hasMasterSpinner: e.hasMasterSpinner,
      orientation: e.orientation
    };
  }),
  s$8 = {
    spinner: "spinner___27VUp",
    spin: "spin___S3UuE"
  },
  _excluded$9 = ["className"],
  _class$7,
  Spinner = (_class$7 = function (e) {
    function t() {
      return _classCallCheck(this, t), r.apply(this, arguments);
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.className,
          r = _objectWithoutProperties(e, _excluded$9),
          i = cn([s$8.spinner, "carousel__spinner", t]);
        return React$2.createElement("div", _extends$6({
          className: i
        }, r));
      }
    }]), t;
  }(React$2.PureComponent), _defineProperty$1(_class$7, "propTypes", {
    className: propTypes$2.string
  }), _defineProperty$1(_class$7, "defaultProps", {
    className: null
  }), _class$7),
  s$9 = {
    container: "container___2O72F",
    overlay: "overlay___IV4qY",
    hover: "hover___MYy31",
    zoom: "zoom___3kqYk",
    loading: "loading___1pvNI",
    imageLoadingSpinnerContainer: "imageLoadingSpinnerContainer___3UIPD"
  },
  _excluded$a = ["alt", "bgImageProps", "bgImageTag", "carouselStore", "className", "imageClassName", "overlayClassName", "isPinchZoomEnabled", "spinner", "src", "srcZoomed", "tag"],
  _class$8,
  MOUSE_SCALE = 2,
  MAX_TOUCH_SCALE = 3,
  ImageWithZoom = (_class$8 = function (e) {
    function t(e) {
      var i;
      return _classCallCheck(this, t), i = r.call(this, e), i.state = {
        isImageLoading: !0,
        isImageLoadingError: !0,
        isHovering: !1,
        isZooming: !1,
        x: null,
        y: null,
        scale: 1
      }, i.tpCache = {}, i.handleImageComplete = i.handleImageComplete.bind(_assertThisInitialized$1(i)), i.handleImageLoadError = i.handleImageLoadError.bind(_assertThisInitialized$1(i)), i.handleOnMouseMove = i.handleOnMouseMove.bind(_assertThisInitialized$1(i)), i.handleOnMouseOut = i.handleOnMouseOut.bind(_assertThisInitialized$1(i)), i.handleOnMouseOver = i.handleOnMouseOver.bind(_assertThisInitialized$1(i)), i.handleOnTouchEnd = i.handleOnTouchEnd.bind(_assertThisInitialized$1(i)), i.handleOnTouchMove = i.handleOnTouchMove.bind(_assertThisInitialized$1(i)), i.handleOnTouchStart = i.handleOnTouchStart.bind(_assertThisInitialized$1(i)), i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "componentDidUpdate",
      value: function value(e, t) {
        !1 === t.isZooming && !0 === this.state.isZooming && this.props.carouselStore.setStoreState({
          isPageScrollLocked: !0
        }), !0 === t.isZooming && !1 === this.state.isZooming && this.props.carouselStore.setStoreState({
          isPageScrollLocked: !1
        });
      }
    }, {
      key: "handleImageComplete",
      value: function value(e) {
        this.setState({
          isImageLoading: !1
        }), this.props && this.props.onLoad && this.props.onLoad(e);
      }
    }, {
      key: "handleImageLoadError",
      value: function value(e) {
        this.setState({
          isImageLoadingError: !0,
          isImageLoading: !1
        }), this.props && this.props.onError && this.props.onError(e);
      }
    }, {
      key: "handleOnMouseOver",
      value: function value() {
        this.state.isZooming || this.setState({
          isHovering: !0,
          scale: MOUSE_SCALE
        });
      }
    }, {
      key: "handleOnMouseOut",
      value: function value() {
        this.state.isZooming || this.setState({
          isHovering: !1,
          scale: 1
        });
      }
    }, {
      key: "handleOnMouseMove",
      value: function value(e) {
        if (!this.state.isZooming) {
          var t = pct(e.nativeEvent.offsetX / e.target.offsetWidth * 100),
            r = pct(e.nativeEvent.offsetY / e.target.offsetHeight * 100);
          this.setState({
            x: t,
            y: r
          });
        }
      }
    }, {
      key: "handleOnTouchStart",
      value: function value(e) {
        var t = this;
        this.props.isPinchZoomEnabled && (_toConsumableArray(e.targetTouches).forEach(function (e) {
          t.tpCache[e.identifier] = {
            clientX: e.clientX,
            clientY: e.clientY
          };
        }), this.setState(function (e) {
          return {
            isZooming: e.isZooming || Object.keys(t.tpCache).length > 1
          };
        }));
      }
    }, {
      key: "handleOnTouchMove",
      value: function value(e) {
        var r = this;
        if (this.state.isZooming) {
          e.persist();
          var i = _toConsumableArray(e.targetTouches).filter(function (e) {
            return r.tpCache[e.identifier];
          }).slice(0, 2);
          if (2 === i.length) {
            e.stopPropagation();
            var n = e.target.getBoundingClientRect(),
              s = i[0].identifier,
              o = i[1].identifier,
              a = {
                x1: this.tpCache[s].clientX,
                y1: this.tpCache[s].clientY,
                x2: this.tpCache[o].clientX,
                y2: this.tpCache[o].clientY
              };
            a.distance = t.distanceBetweenTwoTouches(_objectSpread2({}, a));
            var l = t.midpointBetweenTwoTouches(_objectSpread2({}, a));
            a.cx = l.x, a.cy = l.y;
            var c = {
              x1: i[0].clientX,
              y1: i[0].clientY,
              x2: i[1].clientX,
              y2: i[1].clientY
            };
            c.distance = t.distanceBetweenTwoTouches(_objectSpread2({}, c));
            var u = t.midpointBetweenTwoTouches(_objectSpread2({}, c));
            c.cx = u.x, c.cy = u.y;
            var p = pct(boundedRange({
                min: 0,
                max: 100,
                x: (c.cx - n.left) / n.width * 100
              })),
              d = pct(boundedRange({
                min: 0,
                max: 100,
                x: (c.cy - n.top) / n.height * 100
              })),
              h = function h(e) {
                return boundedRange({
                  min: 1,
                  max: MAX_TOUCH_SCALE,
                  x: e.scale + (c.distance - a.distance) / 100
                });
              };
            this.setState(function (e) {
              return {
                isZooming: 1 !== h(e),
                scale: h(e),
                x: p,
                y: d
              };
            });
          }
        }
      }
    }, {
      key: "handleOnTouchEnd",
      value: function value(e) {
        var t = this;
        this.props.isPinchZoomEnabled && (_toConsumableArray(e.changedTouches).forEach(function (e) {
          delete t.tpCache[e.identifier];
        }), 0 === Object.keys(this.tpCache).length && this.setState({
          isZooming: !1
        }));
      }
    }, {
      key: "renderLoading",
      value: function value() {
        if (this.state.isImageLoading) {
          var e = this.props.spinner;
          return React$2.createElement("div", {
            className: cn([s$9.imageLoadingSpinnerContainer, "carousel__image-loading-spinner-container"])
          }, e && e(), !e && React$2.createElement(Spinner, null));
        }
        return null;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.alt,
          r = e.bgImageProps,
          i = e.bgImageTag,
          n = (e.carouselStore, e.className),
          s = e.imageClassName,
          o = e.overlayClassName,
          a = (e.isPinchZoomEnabled, e.spinner, e.src),
          l = e.srcZoomed,
          c = e.tag,
          u = _objectWithoutProperties(e, _excluded$a),
          p = cn([s$9.container, n]),
          d = cn([s$9.image, "carousel__zoom-image", s]),
          h = cn([s$9.overlay, "carousel__zoom-image-overlay", this.state.isHovering && s$9.hover, this.state.isZooming && s$9.zoom, this.state.isHovering && "carousel__zoom-image-overlay--hovering", this.state.isZooming && "carousel__zoom-image-overlay--zooming", o]),
          y = {};
        return (this.state.isHovering || this.state.isZooming) && (y.transformOrigin = "".concat(this.state.x, " ").concat(this.state.y), y.transform = "scale(".concat(this.state.scale, ")")), React$2.createElement(c, _extends$6({
          className: p
        }, u), React$2.createElement(Image$1$1, _extends$6({
          alt: t,
          className: d,
          tag: i,
          src: a,
          onLoad: this.handleImageComplete,
          onError: this.handleImageLoadError
        }, r)), React$2.createElement(Image$1$1, {
          className: h,
          tag: "div",
          src: l || a,
          style: y,
          isBgImage: !0,
          onFocus: this.handleOnMouseOver,
          onMouseOver: this.handleOnMouseOver,
          onBlur: this.handleOnMouseOut,
          onMouseOut: this.handleOnMouseOut,
          onMouseMove: this.handleOnMouseMove,
          onTouchStart: this.handleOnTouchStart,
          onTouchEnd: this.handleOnTouchEnd,
          onTouchMove: this.handleOnTouchMove
        }), this.renderLoading());
      }
    }], [{
      key: "midpointBetweenTwoTouches",
      value: function value(e) {
        var t = e.x1,
          r = e.y1;
        return {
          x: (t + e.x2) / 2,
          y: (r + e.y2) / 2
        };
      }
    }, {
      key: "distanceBetweenTwoTouches",
      value: function value(e) {
        var t = e.x1,
          r = e.y1,
          i = e.x2,
          n = e.y2;
        return Math.sqrt(Math.pow(i - t, 2) + Math.pow(n - r, 2));
      }
    }]), t;
  }(React$2.Component), _defineProperty$1(_class$8, "propTypes", {
    alt: propTypes$2.string,
    bgImageProps: propTypes$2.object,
    bgImageTag: propTypes$2.string,
    carouselStore: propTypes$2.object.isRequired,
    className: propTypes$2.string,
    imageClassName: propTypes$2.string,
    overlayClassName: propTypes$2.string,
    spinner: propTypes$2.func,
    onLoad: propTypes$2.func,
    onError: propTypes$2.func,
    src: propTypes$2.string.isRequired,
    srcZoomed: propTypes$2.string,
    tag: propTypes$2.string,
    isPinchZoomEnabled: propTypes$2.bool
  }), _defineProperty$1(_class$8, "defaultProps", {
    alt: void 0,
    bgImageProps: {},
    bgImageTag: "div",
    className: null,
    imageClassName: null,
    overlayClassName: null,
    isPinchZoomEnabled: !0,
    spinner: null,
    onLoad: null,
    onError: null,
    srcZoomed: null,
    tag: "div"
  }), _class$8);
WithStore(ImageWithZoom, function () {
  return {};
});
var s$a = {
    slide: "slide___3-Nqo",
    slideHorizontal: "slideHorizontal___1NzNV",
    slideInner: "slideInner___2mfX9",
    focusRing: "focusRing___1airF"
  },
  _excluded$b = ["ariaLabel", "carouselStore", "children", "className", "classNameHidden", "classNameVisible", "currentSlide", "index", "innerClassName", "innerTag", "naturalSlideHeight", "naturalSlideWidth", "onBlur", "onFocus", "orientation", "slideSize", "style", "tag", "totalSlides", "visibleSlides", "isIntrinsicHeight"],
  _class$9,
  Slide = (_class$9 = function (e) {
    function t(e) {
      var i;
      return _classCallCheck(this, t), i = r.call(this, e), i.handleOnFocus = i.handleOnFocus.bind(_assertThisInitialized$1(i)), i.handleOnBlur = i.handleOnBlur.bind(_assertThisInitialized$1(i)), i.state = {
        focused: !1
      }, i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "isVisible",
      value: function value() {
        var e = this.props,
          t = e.currentSlide,
          r = e.index,
          i = e.visibleSlides;
        return r >= t && r < t + i;
      }
    }, {
      key: "handleOnFocus",
      value: function value(e) {
        var t = this,
          r = this.props.onFocus;
        this.setState({
          focused: !0
        }, function () {
          null !== r && r.call(t, e);
        });
      }
    }, {
      key: "handleOnBlur",
      value: function value(e) {
        var t = this,
          r = this.props.onBlur;
        this.setState({
          focused: !1
        }, function () {
          null !== r && r.call(t, e);
        });
      }
    }, {
      key: "renderFocusRing",
      value: function value() {
        return this.state.focused ? React$2.createElement("div", {
          className: [s$a.focusRing, "carousel__slide-focus-ring"].join(" ")
        }) : null;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
          t = this.props,
          r = t.ariaLabel,
          i = (t.carouselStore, t.children, t.className),
          n = t.classNameHidden,
          s = t.classNameVisible,
          o = (t.currentSlide, t.index, t.innerClassName),
          a = t.innerTag,
          l = t.naturalSlideHeight,
          c = t.naturalSlideWidth,
          u = (t.onBlur, t.onFocus, t.orientation),
          p = t.slideSize,
          d = t.style,
          h = t.tag,
          y = t.totalSlides,
          S = (t.visibleSlides, t.isIntrinsicHeight),
          b = _objectWithoutProperties(t, _excluded$b),
          m = {};
        "horizontal" === u ? (m.width = pct(p), m.paddingBottom = pct(100 * l / (c * y))) : (m.width = pct(100), m.paddingBottom = pct(100 * l / c));
        var f = {};
        S && ("horizontal" === u ? m.height = "unset" : m.width = "unset", m.paddingBottom = "unset", f.position = "unset");
        var g = _extends$6({}, m, d),
          v = this.isVisible(),
          _ = cn([s$a.slide, "horizontal" === u && s$a.slideHorizontal, "carousel__slide", this.state.focused && "carousel__slide--focused", v && s, v && "carousel__slide--visible", !v && n, !v && "carousel__slide--hidden", i]),
          T = cn([s$a.slideInner, "carousel__inner-slide", o]);
        return React$2.createElement(h, _extends$6({
          ref: function ref(t) {
            e.tagRef = t;
          },
          "aria-selected": this.isVisible(),
          "aria-label": r,
          role: this.props.role,
          onFocus: this.handleOnFocus,
          onBlur: this.handleOnBlur,
          className: _,
          style: g
        }, b), React$2.createElement(a, {
          ref: function ref(t) {
            e.innerTagRef = t;
          },
          className: T,
          style: f
        }, this.props.children, this.renderFocusRing()));
      }
    }]), t;
  }(React$2.PureComponent), _defineProperty$1(_class$9, "propTypes", {
    ariaLabel: propTypes$2.string,
    carouselStore: propTypes$2.object,
    children: CarouselPropTypes.children,
    className: propTypes$2.string,
    classNameHidden: propTypes$2.string,
    classNameVisible: propTypes$2.string,
    currentSlide: propTypes$2.number.isRequired,
    index: propTypes$2.number.isRequired,
    innerClassName: propTypes$2.string,
    innerTag: propTypes$2.string,
    naturalSlideHeight: propTypes$2.number.isRequired,
    naturalSlideWidth: propTypes$2.number.isRequired,
    onBlur: propTypes$2.func,
    onFocus: propTypes$2.func,
    orientation: CarouselPropTypes.orientation.isRequired,
    slideSize: propTypes$2.number.isRequired,
    role: propTypes$2.string,
    style: propTypes$2.object,
    tag: propTypes$2.string,
    totalSlides: propTypes$2.number.isRequired,
    visibleSlides: propTypes$2.number.isRequired,
    isIntrinsicHeight: propTypes$2.bool
  }), _defineProperty$1(_class$9, "defaultProps", {
    ariaLabel: "slide",
    carouselStore: null,
    children: null,
    className: null,
    classNameHidden: null,
    classNameVisible: null,
    innerClassName: null,
    innerTag: "div",
    onBlur: null,
    onFocus: null,
    role: "option",
    style: {},
    tag: "div",
    isIntrinsicHeight: !1
  }), _class$9),
  index$7 = WithStore(Slide, function (e) {
    return {
      currentSlide: e.currentSlide,
      naturalSlideHeight: e.naturalSlideHeight,
      naturalSlideWidth: e.naturalSlideWidth,
      orientation: e.orientation,
      slideSize: e.slideSize,
      totalSlides: e.totalSlides,
      visibleSlides: e.visibleSlides,
      isIntrinsicHeight: e.isIntrinsicHeight
    };
  }),
  GetScrollParent = function () {
    function e() {
      _classCallCheck(this, e);
    }
    return _createClass(e, [{
      key: "parents",
      value: function value(e, t) {
        return null === e.parentNode ? t : this.parents(e.parentNode, t.concat([e]));
      }
    }, {
      key: "scrollParent",
      value: function value(t) {
        for (var r = this.parents(t.parentNode, []), i = 0; i < r.length; i += 1) if (e.scroll(r[i])) return r[i];
        return document.scrollingElement || document.documentElement;
      }
    }, {
      key: "getScrollParent",
      value: function value(t) {
        return e.isNodeValid(t) ? this.scrollParent(t) : null;
      }
    }], [{
      key: "style",
      value: function value(e, t) {
        return getComputedStyle(e, null).getPropertyValue(t);
      }
    }, {
      key: "overflow",
      value: function value(t) {
        return e.style(t, "overflow") + e.style(t, "overflow-y") + e.style(t, "overflow-x");
      }
    }, {
      key: "scroll",
      value: function value(t) {
        return /(auto|scroll)/.test(e.overflow(t));
      }
    }, {
      key: "isNodeValid",
      value: function value(e) {
        return e instanceof HTMLElement || e instanceof SVGElement;
      }
    }]), e;
  }(),
  s$b = {
    horizontalSlider: "horizontalSlider___281Ls",
    touchDisabled: "touchDisabled___2qs4y",
    horizontalSliderTray: "horizontalSliderTray___1L-0W",
    verticalSlider: "verticalSlider___34ZFD",
    verticalSliderTray: "verticalSliderTray___267D8",
    verticalTray: "verticalTray___12Key",
    verticalSlideTrayWrap: "verticalSlideTrayWrap___2nO7o",
    sliderTray: "sliderTray___-vHFQ",
    sliderAnimation: "sliderAnimation___300FY",
    masterSpinnerContainer: "masterSpinnerContainer___1Z6hB"
  },
  _excluded$c = ["ariaLabel", "carouselStore", "children", "className", "classNameAnimation", "classNameTray", "classNameTrayWrap", "currentSlide", "disableAnimation", "disableKeyboard", "dragEnabled", "hasMasterSpinner", "interval", "isPageScrollLocked", "isPlaying", "lockOnWindowScroll", "masterSpinnerFinished", "moveThreshold", "naturalSlideHeight", "naturalSlideWidth", "onMasterSpinner", "orientation", "playDirection", "privateUnDisableAnimation", "slideSize", "slideTraySize", "spinner", "style", "totalSlides", "touchEnabled", "trayProps", "trayTag", "visibleSlides", "isIntrinsicHeight"],
  _excluded2$2 = ["dragStep", "step", "infinite", "preventVerticalScrollOnTouch", "preventingVerticalScroll", "horizontalPixelThreshold", "verticalPixelThreshold"],
  _excluded3 = ["className", "onClickCapture", "onMouseDown", "onTouchCancel", "onTouchEnd", "onTouchMove", "onTouchStart", "ref", "style"],
  _class$a,
  Slider = (_class$a = function (e) {
    function t(e) {
      var i;
      return _classCallCheck(this, t), i = r.call(this, e), i.getSliderRef = i.getSliderRef.bind(_assertThisInitialized$1(i)), i.handleDocumentScroll = i.handleDocumentScroll.bind(_assertThisInitialized$1(i)), i.handleOnClickCapture = i.handleOnClickCapture.bind(_assertThisInitialized$1(i)), i.handleOnKeyDown = i.handleOnKeyDown.bind(_assertThisInitialized$1(i)), i.handleOnMouseDown = i.handleOnMouseDown.bind(_assertThisInitialized$1(i)), i.handleOnMouseMove = i.handleOnMouseMove.bind(_assertThisInitialized$1(i)), i.handleOnMouseUp = i.handleOnMouseUp.bind(_assertThisInitialized$1(i)), i.handleOnTouchCancel = i.handleOnTouchCancel.bind(_assertThisInitialized$1(i)), i.handleOnTouchEnd = i.handleOnTouchEnd.bind(_assertThisInitialized$1(i)), i.handleOnTouchMove = i.handleOnTouchMove.bind(_assertThisInitialized$1(i)), i.handleOnTouchStart = i.handleOnTouchStart.bind(_assertThisInitialized$1(i)), i.playBackward = i.playBackward.bind(_assertThisInitialized$1(i)), i.playForward = i.playForward.bind(_assertThisInitialized$1(i)), i.callCallback = i.callCallback.bind(_assertThisInitialized$1(i)), i.blockWindowScroll = i.blockWindowScroll.bind(_assertThisInitialized$1(i)), i.state = {
        cancelNextClick: !1,
        deltaX: 0,
        deltaY: 0,
        isBeingMouseDragged: !1,
        isBeingTouchDragged: !1,
        preventingVerticalScroll: !1,
        startX: 0,
        startY: 0
      }, i.interval = null, i.isDocumentScrolling = null, i.moveTimer = null, i.originalOverflow = null, i.scrollParent = null, i.scrollStopTimer = null, i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "componentDidMount",
      value: function value() {
        this.props.lockOnWindowScroll && window.addEventListener("scroll", this.handleDocumentScroll, !1), (this.props.touchEnabled || this.props.preventVerticalScrollOnTouch) && window.addEventListener("touchmove", this.blockWindowScroll, !1), document.documentElement.addEventListener("mouseleave", this.handleOnMouseUp, !1), document.documentElement.addEventListener("mousemove", this.handleOnMouseMove, !1), document.documentElement.addEventListener("mouseup", this.handleOnMouseUp, !1), this.props.isPlaying && this.play();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        !e.isPlaying && this.props.isPlaying && this.play(), e.isPlaying && !this.props.isPlaying && this.stop(), !e.isPageScrollLocked && this.props.isPageScrollLocked && this.lockScroll(), e.isPageScrollLocked && !this.props.isPageScrollLocked && this.unlockScroll(), !1 === e.privateUnDisableAnimation && !0 === this.props.privateUnDisableAnimation && this.props.carouselStore.setStoreState({
          privateUnDisableAnimation: !1,
          disableAnimation: !1
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        document.documentElement.removeEventListener("mouseleave", this.handleOnMouseUp, !1), document.documentElement.removeEventListener("mousemove", this.handleOnMouseMove, !1), document.documentElement.removeEventListener("mouseup", this.handleOnMouseUp, !1), window.removeEventListener("scroll", this.handleDocumentScroll, !1), window.removeEventListener("touchmove", this.blockWindowScroll, !1), this.stop(), window.cancelAnimationFrame.call(window, this.moveTimer), window.clearTimeout(this.scrollStopTimer), this.isDocumentScrolling = null, this.moveTimer = null, this.scrollStopTimer = null;
      }
    }, {
      key: "getSliderRef",
      value: function value(e) {
        if (this.sliderTrayElement = e, e && window) {
          var t = e.closest(".carousel");
          t && (this.rtl = "rtl" === window.getComputedStyle(t, null).getPropertyValue("direction"));
        }
      }
    }, {
      key: "fakeOnDragStart",
      value: function value(e) {
        var t = e.screenX,
          r = e.screenY,
          i = e.touchDrag,
          n = void 0 !== i && i,
          s = e.mouseDrag,
          o = void 0 !== s && s;
        this.props.carouselStore.setStoreState({
          isPlaying: !1
        }), window.cancelAnimationFrame.call(window, this.moveTimer), "vertical" === this.props.orientation && this.props.carouselStore.setStoreState({
          isPageScrollLocked: !0
        }), this.setState({
          isBeingTouchDragged: n,
          isBeingMouseDragged: o,
          startX: t,
          startY: r
        });
      }
    }, {
      key: "fakeOnDragMove",
      value: function value(e, t) {
        var r = this;
        window.cancelAnimationFrame.call(window, this.moveTimer), this.moveTimer = window.requestAnimationFrame.call(window, function () {
          r.setState(function (i) {
            return {
              deltaX: (e - i.startX) * (r.rtl ? -1 : 1),
              deltaY: t - i.startY,
              preventingVerticalScroll: Math.abs(t - i.startY) <= r.props.verticalPixelThreshold && Math.abs(e - i.startX) >= r.props.horizontalPixelThreshold
            };
          });
        });
      }
    }, {
      key: "fakeOnDragEnd",
      value: function value() {
        window.cancelAnimationFrame.call(window, this.moveTimer), this.computeCurrentSlide(), "vertical" === this.props.orientation && this.props.carouselStore.setStoreState({
          isPageScrollLocked: !1
        }), this.setState({
          deltaX: 0,
          deltaY: 0,
          isBeingTouchDragged: !1,
          isBeingMouseDragged: !1
        }), this.isDocumentScrolling = !this.props.lockOnWindowScroll && null;
      }
    }, {
      key: "callCallback",
      value: function value(e, t) {
        var r = this.props.trayProps;
        r && "function" == typeof r[e] && (t.persist(), r[e](t));
      }
    }, {
      key: "handleOnMouseDown",
      value: function value(e) {
        if (!this.props.dragEnabled) return void this.callCallback("onMouseDown", e);
        e.preventDefault(), this.fakeOnDragStart({
          screenX: e.screenX,
          screenY: e.screenY,
          mouseDrag: !0
        }), this.callCallback("onMouseDown", e);
      }
    }, {
      key: "handleOnMouseMove",
      value: function value(e) {
        this.state.isBeingMouseDragged && (this.setState({
          cancelNextClick: !0
        }), e.preventDefault(), this.fakeOnDragMove(e.screenX, e.screenY));
      }
    }, {
      key: "handleOnMouseUp",
      value: function value(e) {
        this.state.isBeingMouseDragged && (e.preventDefault(), this.fakeOnDragEnd());
      }
    }, {
      key: "handleOnClickCapture",
      value: function value(e) {
        if (!this.state.cancelNextClick) return void this.callCallback("onClickCapture", e);
        e.preventDefault(), this.setState({
          cancelNextClick: !1
        }), this.callCallback("onClickCapture", e);
      }
    }, {
      key: "handleOnTouchStart",
      value: function value(e) {
        if (!this.props.touchEnabled) return void this.callCallback("onTouchStart", e);
        "vertical" === this.props.orientation && e.preventDefault();
        var t = e.targetTouches[0];
        this.fakeOnDragStart({
          screenX: t.screenX,
          screenY: t.screenY,
          touchDrag: !0
        }), this.callCallback("onTouchStart", e);
      }
    }, {
      key: "handleDocumentScroll",
      value: function value() {
        var e = this;
        this.props.touchEnabled && (this.isDocumentScrolling = !0, window.clearTimeout(this.scrollStopTimer), this.scrollStopTimer = window.setTimeout(function () {
          e.isDocumentScrolling = !1;
        }, 66));
      }
    }, {
      key: "handleOnTouchMove",
      value: function value(e) {
        if (!this.props.touchEnabled || this.props.lockOnWindowScroll && this.isDocumentScrolling) return void this.callCallback("onTouchMove", e);
        var t = e.targetTouches[0];
        t && (this.fakeOnDragMove(t.screenX, t.screenY), this.callCallback("onTouchMove", e));
      }
    }, {
      key: "forward",
      value: function value() {
        var e = this.props,
          t = e.currentSlide,
          r = e.step,
          i = e.totalSlides,
          n = e.visibleSlides;
        return Math.min(t + r, i - n);
      }
    }, {
      key: "backward",
      value: function value() {
        var e = this.props,
          t = e.currentSlide,
          r = e.step;
        return Math.max(t - r, 0);
      }
    }, {
      key: "handleOnKeyDown",
      value: function value(e) {
        var t = e.keyCode,
          r = this.props,
          i = r.carouselStore,
          n = r.currentSlide,
          s = r.disableKeyboard,
          o = r.totalSlides,
          a = r.visibleSlides,
          l = {};
        !0 === s || o <= a || (37 === t && (e.preventDefault(), this.focus(), l.currentSlide = Math.max(0, n - 1), l.isPlaying = !1), 39 === t && (e.preventDefault(), this.focus(), l.currentSlide = Math.min(o - a, n + 1), l.isPlaying = !1), i.setStoreState(l));
      }
    }, {
      key: "playForward",
      value: function value() {
        var e = this.props,
          t = e.carouselStore,
          r = e.currentSlide;
        t.setStoreState({
          currentSlide: this.forward() === r ? 0 : this.forward()
        });
      }
    }, {
      key: "playBackward",
      value: function value() {
        var e = this.props,
          t = e.carouselStore,
          r = e.currentSlide,
          i = e.totalSlides,
          n = e.visibleSlides;
        t.setStoreState({
          currentSlide: this.backward() === r ? i - n : this.backward()
        });
      }
    }, {
      key: "play",
      value: function value() {
        var e = this.props.playDirection;
        this.interval = setInterval("forward" === e ? this.playForward : this.playBackward, this.props.interval);
      }
    }, {
      key: "stop",
      value: function value() {
        window.clearInterval(this.interval), this.interval = null;
      }
    }, {
      key: "lockScroll",
      value: function value() {
        var e = new GetScrollParent();
        this.scrollParent = e.getScrollParent(this.sliderTrayElement), this.scrollParent && (this.originalOverflow = this.originalOverflow || this.scrollParent.style.overflow, this.scrollParent.style.overflow = "hidden");
      }
    }, {
      key: "unlockScroll",
      value: function value() {
        this.scrollParent && (this.scrollParent.style.overflow = this.originalOverflow, this.originalOverflow = null, this.scrollParent = null);
      }
    }, {
      key: "blockWindowScroll",
      value: function value(e) {
        this.state.preventingVerticalScroll && (e.preventDefault(), e.stopImmediatePropagation());
      }
    }, {
      key: "computeCurrentSlide",
      value: function value() {
        var e = t.slideSizeInPx(this.props.orientation, this.sliderTrayElement.clientWidth, this.sliderTrayElement.clientHeight, this.props.totalSlides),
          r = t.slidesMoved(this.props.moveThreshold, this.props.orientation, this.state.deltaX, this.state.deltaY, e, this.props.dragStep),
          i = this.props.totalSlides - Math.min(this.props.totalSlides, this.props.visibleSlides),
          n = boundedRange({
            min: 0,
            max: i,
            x: this.props.currentSlide + r
          });
        this.props.infinite && (this.props.currentSlide >= i && r > 0 && (n = 0), 0 === this.props.currentSlide && r < 0 && (n = i)), this.props.carouselStore.setStoreState({
          currentSlide: n
        });
      }
    }, {
      key: "focus",
      value: function value() {
        this.sliderElement.focus();
      }
    }, {
      key: "handleOnTouchEnd",
      value: function value(e) {
        this.endTouchMove(), this.callCallback("onTouchEnd", e);
      }
    }, {
      key: "handleOnTouchCancel",
      value: function value(e) {
        this.endTouchMove(), this.callCallback("onTouchCancel", e);
      }
    }, {
      key: "endTouchMove",
      value: function value() {
        this.props.touchEnabled && this.fakeOnDragEnd();
      }
    }, {
      key: "renderMasterSpinner",
      value: function value() {
        var e = this.props,
          t = e.hasMasterSpinner,
          r = e.masterSpinnerFinished,
          i = e.spinner;
        return t && !r ? ("function" == typeof this.props.onMasterSpinner && this.props.onMasterSpinner(), React$2.createElement("div", {
          className: cn([s$b.masterSpinnerContainer, "carousel__master-spinner-container"])
        }, i && i(), !i && React$2.createElement(Spinner, null))) : null;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
          t = this.props,
          r = t.ariaLabel,
          i = (t.carouselStore, t.children),
          n = t.className,
          s = t.classNameAnimation,
          o = t.classNameTray,
          a = t.classNameTrayWrap,
          l = t.currentSlide,
          c = t.disableAnimation,
          u = (t.disableKeyboard, t.dragEnabled, t.hasMasterSpinner, t.interval, t.isPageScrollLocked, t.isPlaying, t.lockOnWindowScroll, t.masterSpinnerFinished, t.moveThreshold, t.naturalSlideHeight),
          p = t.naturalSlideWidth,
          d = (t.onMasterSpinner, t.orientation),
          h = (t.playDirection, t.privateUnDisableAnimation, t.slideSize),
          y = t.slideTraySize,
          S = (t.spinner, t.style),
          b = (t.totalSlides, t.touchEnabled),
          m = t.trayProps,
          f = t.trayTag,
          g = t.visibleSlides,
          v = t.isIntrinsicHeight,
          _ = _objectWithoutProperties(t, _excluded$c),
          T = _extends$6({}, S),
          k = {};
        "vertical" === d && (k.height = 0, k.paddingBottom = pct(100 * u * g / p), k.width = pct(100));
        var C = {},
          O = pct(h * l * -1);
        (this.state.isBeingTouchDragged || this.state.isBeingMouseDragged || c) && (C.transition = "none"), v && (C.display = "flex", C.alignItems = "stretch"), "vertical" === d ? (C.transform = "translateY(".concat(O, ") translateY(").concat(this.state.deltaY, "px)"), C.width = pct(100), C.flexDirection = "column") : (C.width = pct(y), C.transform = "translateX(".concat(O, ") translateX(").concat(this.state.deltaX, "px)"), C.flexDirection = "row");
        var P = cn(["vertical" === d ? s$b.verticalSlider : s$b.horizontalSlider, !b && s$b.touchDisabled, "carousel__slider", "vertical" === d ? "carousel__slider--vertical" : "carousel__slider--horizontal", n]),
          E = cn([s$b.sliderTrayWrap, "carousel__slider-tray-wrapper", "vertical" === d ? s$b.verticalSlideTrayWrap : s$b.horizontalTrayWrap, "vertical" === d ? "carousel__slider-tray-wrap--vertical" : "carousel__slider-tray-wrap--horizontal", a]),
          w = cn([s$b.sliderTray, s || s$b.sliderAnimation, "carousel__slider-tray", "vertical" === d ? s$b.verticalTray : s$b.horizontalTray, "vertical" === d ? "carousel__slider-tray--vertical" : "carousel__slider-tray--horizontal", o]),
          M = (_.dragStep, _.step, _.infinite, _.preventVerticalScrollOnTouch, _.preventingVerticalScroll, _.horizontalPixelThreshold, _.verticalPixelThreshold, _objectWithoutProperties(_, _excluded2$2)),
          x = (m.className, m.onClickCapture, m.onMouseDown, m.onTouchCancel, m.onTouchEnd, m.onTouchMove, m.onTouchStart, m.ref, m.style, _objectWithoutProperties(m, _excluded3));
        return React$2.createElement("div", _extends$6({
          ref: function ref(t) {
            e.sliderElement = t;
          },
          className: P,
          "aria-live": "polite",
          "aria-label": r,
          role: this.props.role,
          style: T,
          onKeyDown: this.handleOnKeyDown
        }, M), React$2.createElement("div", {
          className: E,
          style: k
        }, React$2.createElement(f, _extends$6({
          ref: this.getSliderRef,
          className: w,
          style: C,
          onTouchStart: this.handleOnTouchStart,
          onTouchMove: this.handleOnTouchMove,
          onTouchEnd: this.handleOnTouchEnd,
          onTouchCancel: this.handleOnTouchCancel,
          onMouseDown: this.handleOnMouseDown,
          onClickCapture: this.handleOnClickCapture
        }, x), i), this.renderMasterSpinner()));
      }
    }], [{
      key: "slideSizeInPx",
      value: function value(e, t, r, i) {
        return ("horizontal" === e ? t : r) / i;
      }
    }, {
      key: "slidesMoved",
      value: function value(e, t, r, i, n, s) {
        var o = "horizontal" === t ? r : i,
          a = Math.abs(Math.round(o / n)),
          l = Math.abs(o) >= n * e ? s : 0,
          c = Math.max(l, a);
        if (o < 0) return c;
        var u = -c;
        return 0 === u ? 0 : u;
      }
    }]), t;
  }(React$2.Component), _defineProperty$1(_class$a, "propTypes", {
    ariaLabel: propTypes$2.string,
    carouselStore: propTypes$2.object.isRequired,
    children: propTypes$2.node.isRequired,
    className: propTypes$2.string,
    classNameAnimation: propTypes$2.string,
    classNameTray: propTypes$2.string,
    classNameTrayWrap: propTypes$2.string,
    currentSlide: propTypes$2.number.isRequired,
    disableAnimation: propTypes$2.bool,
    disableKeyboard: propTypes$2.bool,
    dragEnabled: propTypes$2.bool.isRequired,
    dragStep: propTypes$2.number,
    hasMasterSpinner: propTypes$2.bool.isRequired,
    infinite: propTypes$2.bool,
    interval: propTypes$2.number.isRequired,
    isPageScrollLocked: propTypes$2.bool.isRequired,
    isPlaying: propTypes$2.bool.isRequired,
    lockOnWindowScroll: propTypes$2.bool.isRequired,
    preventVerticalScrollOnTouch: propTypes$2.bool,
    horizontalPixelThreshold: propTypes$2.number,
    verticalPixelThreshold: propTypes$2.number,
    masterSpinnerFinished: propTypes$2.bool.isRequired,
    moveThreshold: propTypes$2.number,
    naturalSlideHeight: propTypes$2.number.isRequired,
    naturalSlideWidth: propTypes$2.number.isRequired,
    onMasterSpinner: propTypes$2.func,
    orientation: CarouselPropTypes.orientation.isRequired,
    playDirection: CarouselPropTypes.direction.isRequired,
    privateUnDisableAnimation: propTypes$2.bool,
    role: propTypes$2.string,
    slideSize: propTypes$2.number.isRequired,
    slideTraySize: propTypes$2.number.isRequired,
    spinner: propTypes$2.func,
    step: propTypes$2.number.isRequired,
    style: propTypes$2.object,
    totalSlides: propTypes$2.number.isRequired,
    touchEnabled: propTypes$2.bool.isRequired,
    trayProps: propTypes$2.shape({
      className: propTypes$2.string,
      onClickCapture: propTypes$2.func,
      onMouseDown: propTypes$2.func,
      onTouchCancel: propTypes$2.func,
      onTouchEnd: propTypes$2.func,
      onTouchMove: propTypes$2.func,
      onTouchStart: propTypes$2.func,
      ref: propTypes$2.shape({}),
      style: propTypes$2.string
    }),
    trayTag: propTypes$2.string,
    visibleSlides: propTypes$2.number,
    isIntrinsicHeight: propTypes$2.bool
  }), _defineProperty$1(_class$a, "defaultProps", {
    ariaLabel: "slider",
    className: null,
    classNameAnimation: null,
    classNameTray: null,
    classNameTrayWrap: null,
    disableAnimation: !1,
    disableKeyboard: !1,
    dragStep: 1,
    infinite: !1,
    preventVerticalScrollOnTouch: !0,
    horizontalPixelThreshold: 15,
    verticalPixelThreshold: 10,
    moveThreshold: .1,
    onMasterSpinner: null,
    privateUnDisableAnimation: !1,
    role: "listbox",
    spinner: null,
    style: {},
    trayProps: {},
    trayTag: "div",
    visibleSlides: 1,
    isIntrinsicHeight: !1
  }), _class$a),
  index$8 = WithStore(Slider, function (e) {
    return {
      currentSlide: e.currentSlide,
      disableAnimation: e.disableAnimation,
      privateUnDisableAnimation: e.privateUnDisableAnimation,
      disableKeyboard: e.disableKeyboard,
      dragEnabled: e.dragEnabled,
      hasMasterSpinner: e.hasMasterSpinner,
      infinite: e.infinite,
      interval: e.interval,
      isPageScrollLocked: e.isPageScrollLocked,
      isPlaying: e.isPlaying,
      lockOnWindowScroll: e.lockOnWindowScroll,
      preventingVerticalScroll: e.preventingVerticalScroll,
      masterSpinnerFinished: e.masterSpinnerFinished,
      naturalSlideHeight: e.naturalSlideHeight,
      naturalSlideWidth: e.naturalSlideWidth,
      orientation: e.orientation,
      playDirection: e.playDirection,
      slideSize: e.slideSize,
      slideTraySize: e.slideTraySize,
      step: e.step,
      dragStep: e.dragStep,
      totalSlides: e.totalSlides,
      touchEnabled: e.touchEnabled,
      visibleSlides: e.visibleSlides,
      isIntrinsicHeight: e.isIntrinsicHeight
    };
  });
var styles$H = {
  "container": "chevron-module_container__Cxmvu",
  "chevron": "chevron-module_chevron__SZ4n0",
  "backwards": "chevron-module_backwards__BIvBU",
  "background": "chevron-module_background__q4STw"
};
var Chevron = function Chevron(_ref16) {
  var _ref16$backwards = _ref16.backwards,
    backwards = _ref16$backwards === void 0 ? false : _ref16$backwards,
    _ref16$background = _ref16.background,
    background = _ref16$background === void 0 ? false : _ref16$background;
  return React$2.createElement("div", {
    className: classnames(styles$H.container, _defineProperty2(_defineProperty2({}, styles$H.backwards, backwards), styles$H.background, background))
  }, React$2.createElement("div", {
    style: background ? {
      fill: 'white'
    } : {},
    className: classnames(styles$H.chevron)
  }, React$2.createElement("svg", {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    strokeWidth: "2",
    stroke: "white",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React$2.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), React$2.createElement("polyline", {
    points: "9 6 15 12 9 18"
  }))));
};
var styles$G = {
  "container": "carousel-module_container__htIIU",
  "button": "carousel-module_button__-Gkom",
  "slider": "carousel-module_slider__RrDTz",
  "sliderTray": "carousel-module_sliderTray__OMdQs",
  "slide": "carousel-module_slide__u7W7T",
  "slideInner": "carousel-module_slideInner__NdThC",
  "dots": "carousel-module_dots__p6Dpd"
};
var CarouselButtonType;
(function (CarouselButtonType) {
  CarouselButtonType["Arrow"] = "arrow";
  CarouselButtonType["Chevron"] = "chevron";
})(CarouselButtonType || (CarouselButtonType = {}));
var Carousel = function Carousel(_ref17) {
  var children = _ref17.children,
    _ref17$buttons = _ref17.buttons,
    buttons = _ref17$buttons === void 0 ? CarouselButtonType.Arrow : _ref17$buttons,
    _ref17$dots = _ref17.dots,
    dots = _ref17$dots === void 0 ? true : _ref17$dots,
    _ref17$preview = _ref17.preview,
    preview = _ref17$preview === void 0 ? true : _ref17$preview,
    _ref17$dragEnabled = _ref17.dragEnabled,
    dragEnabled = _ref17$dragEnabled === void 0 ? true : _ref17$dragEnabled,
    _ref17$isPlaying = _ref17.isPlaying,
    isPlaying = _ref17$isPlaying === void 0 ? false : _ref17$isPlaying,
    _ref17$interval = _ref17.interval,
    interval = _ref17$interval === void 0 ? 3000 : _ref17$interval,
    _ref17$className = _ref17.className,
    className = _ref17$className === void 0 ? '' : _ref17$className;
  var arrayChildren = Children.toArray(children);
  var Buttons = function Buttons() {
    if (buttons === false) return null;
    return buttons === CarouselButtonType.Arrow ? React$2.createElement(React$2.Fragment, null, React$2.createElement(index$1, {
      className: styles$G.button
    }, React$2.createElement("div", null, React$2.createElement(Arrow, {
      backwards: true,
      background: true
    }))), React$2.createElement(index$3, {
      className: styles$G.button
    }, React$2.createElement("div", null, React$2.createElement(Arrow, {
      background: true
    })))) : React$2.createElement(React$2.Fragment, null, React$2.createElement(index$1, {
      className: styles$G.button
    }, React$2.createElement("div", null, React$2.createElement(Chevron, {
      backwards: true,
      background: true
    }))), React$2.createElement(index$3, {
      className: styles$G.button
    }, React$2.createElement("div", null, React$2.createElement(Chevron, {
      background: true
    }))));
  };
  return React$2.createElement("div", {
    className: styles$G.container
  }, React$2.createElement(CarouselProvider, {
    naturalSlideWidth: 1,
    naturalSlideHeight: 1,
    isIntrinsicHeight: true,
    totalSlides: arrayChildren.length,
    dragEnabled: dragEnabled,
    touchEnabled: dragEnabled,
    isPlaying: isPlaying,
    interval: interval
  }, React$2.createElement(index$8, {
    className: classnames(_defineProperty2({}, styles$G.slider, preview), className),
    classNameTray: classnames(_defineProperty2({}, styles$G.sliderTray, preview)),
    preventVerticalScrollOnTouch: true,
    verticalPixelThreshold: 25
  }, arrayChildren.map(function (child, index) {
    return React$2.createElement(index$7, {
      key: index,
      className: styles$G.slide,
      innerClassName: styles$G.slideInner,
      index: index
    }, child);
  })), Buttons(), dots && arrayChildren.length > 1 && React$2.createElement(index$5, {
    className: styles$G.dots
  })));
};
var styles$F = {
  "checkmark": "checkmark-module_checkmark__so4Fa"
};

/**
 * The branded tick shown inside a themed checkbox. It is layered over a real
 * `<input type="checkbox">` (whose native tick is hidden with
 * `appearance: none`) inside a `position: relative` container, and fades in when
 * checked. Shared by `CheckboxControl` and `ConfirmationGate` so their
 * checkboxes look identical; `color` comes from the theme's `checkbox.color`.
 */
var Checkmark = function Checkmark(_ref18) {
  var checked = _ref18.checked,
    color = _ref18.color;
  return React$2.createElement("svg", {
    style: {
      fill: color,
      opacity: checked ? 1 : 0
    },
    className: styles$F.checkmark,
    viewBox: "0 0 122.881 122.88"
  }, React$2.createElement("g", null, React$2.createElement("path", {
    d: "M7.246,0h108.389c1.992,0,3.805,0.815,5.117,2.128s2.129,3.125,2.129,5.117 v108.388c0,1.993-0.816,3.805-2.129,5.117c-1.313,1.313-3.125,2.129-5.117,2.129H7.246c-1.993,0-3.804-0.815-5.118-2.129 C0.815,119.438,0,117.627,0,115.634V7.246c0-1.993,0.815-3.804,2.128-5.117C3.442,0.815,5.253,0,7.246,0L7.246,0z M32.036,68.054 l0.011,0.01l0.006,0.006l0.012,0.01v0.001l16.98,15.397c0.399,0.361,0.852,0.629,1.329,0.803c0.496,0.181,1.018,0.261,1.536,0.241 c0.503-0.019,1.003-0.131,1.47-0.334c0.451-0.196,0.873-0.479,1.241-0.848l0.012-0.01l0.033-0.028l0.001-0.001 c0.012-0.011,0.023-0.021,0.032-0.03l36.346-38.065c0.379-0.398,0.66-0.853,0.846-1.334v0c0.193-0.5,0.281-1.033,0.27-1.561 c-0.014-0.528-0.129-1.055-0.348-1.547c-0.209-0.473-0.514-0.913-0.91-1.291L90.9,39.471c-0.396-0.378-0.852-0.66-1.334-0.845l0,0 c-0.5-0.192-1.031-0.282-1.561-0.269c-0.527,0.013-1.055,0.129-1.545,0.347c-0.473,0.209-0.912,0.513-1.291,0.91l-0.002,0.001 L51.642,74.729l-0.09,0.094l-0.097-0.087l-13.972-12.67c-0.406-0.367-0.867-0.638-1.354-0.812c-0.505-0.18-1.036-0.256-1.562-0.23 c-0.523,0.026-1.042,0.154-1.524,0.381c-0.464,0.219-0.895,0.53-1.262,0.932l-0.003,0.003c-0.007,0.007-0.016,0.017-0.024,0.026 l-0.002,0.003c-0.363,0.405-0.629,0.864-0.8,1.348c-0.178,0.501-0.253,1.029-0.227,1.552c0.026,0.523,0.153,1.042,0.379,1.523 C31.323,67.256,31.634,67.687,32.036,68.054L32.036,68.054L32.036,68.054z"
  })));
};
var asset = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M12%2021C16.9706%2021%2021%2016.9706%2021%2012C21%207.02944%2016.9706%203%2012%203C7.02944%203%203%207.02944%203%2012C3%2016.9706%207.02944%2021%2012%2021Z%22%20stroke%3D%22%23666666%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10%2010L14%2014M14%2010L10%2014%22%20stroke%3D%22%23666666%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";
var styles$E = {
  "image": "close-cross-module_image__xndiy"
};
var CloseCross = function CloseCross(_ref19) {
  var _onClick2 = _ref19.onClick,
    _ref19$size = _ref19.size,
    size = _ref19$size === void 0 ? '24px' : _ref19$size,
    className = _ref19.className;
  return React$2.createElement("img", {
    src: asset,
    onClick: function onClick() {
      if (_onClick2) {
        _onClick2();
      }
    },
    className: classnames(styles$E.image, className),
    style: {
      width: size,
      height: size
    },
    alt: ""
  });
};
var vfile$2 = {
  exports: {}
};
var own$a = {}.hasOwnProperty;
var unistUtilStringifyPosition = stringify$3;
function stringify$3(value) {
  // Nothing.
  if (!value || typeof value !== 'object') {
    return '';
  }

  // Node.
  if (own$a.call(value, 'position') || own$a.call(value, 'type')) {
    return position$3(value.position);
  }

  // Position.
  if (own$a.call(value, 'start') || own$a.call(value, 'end')) {
    return position$3(value);
  }

  // Point.
  if (own$a.call(value, 'line') || own$a.call(value, 'column')) {
    return point(value);
  }

  // ?
  return '';
}
function point(point) {
  if (!point || typeof point !== 'object') {
    point = {};
  }
  return index(point.line) + ':' + index(point.column);
}
function position$3(pos) {
  if (!pos || typeof pos !== 'object') {
    pos = {};
  }
  return point(pos.start) + '-' + point(pos.end);
}
function index(value) {
  return value && typeof value === 'number' ? value : 1;
}
var stringify$2 = unistUtilStringifyPosition;
var vfileMessage = VMessage$1;

// Inherit from `Error#`.
function VMessagePrototype() {}
VMessagePrototype.prototype = Error.prototype;
VMessage$1.prototype = new VMessagePrototype();

// Message properties.
var proto$2 = VMessage$1.prototype;
proto$2.file = '';
proto$2.name = '';
proto$2.reason = '';
proto$2.message = '';
proto$2.stack = '';
proto$2.fatal = null;
proto$2.column = null;
proto$2.line = null;

// Construct a new VMessage.
//
// Note: We cannot invoke `Error` on the created context, as that adds readonly
// `line` and `column` attributes on Safari 9, thus throwing and failing the
// data.
function VMessage$1(reason, position, origin) {
  var parts;
  var range;
  var location;
  if (typeof position === 'string') {
    origin = position;
    position = null;
  }
  parts = parseOrigin(origin);
  range = stringify$2(position) || '1:1';
  location = {
    start: {
      line: null,
      column: null
    },
    end: {
      line: null,
      column: null
    }
  };

  // Node.
  if (position && position.position) {
    position = position.position;
  }
  if (position) {
    // Position.
    if (position.start) {
      location = position;
      position = position.start;
    } else {
      // Point.
      location.start = position;
    }
  }
  if (reason.stack) {
    this.stack = reason.stack;
    reason = reason.message;
  }
  this.message = reason;
  this.name = range;
  this.reason = reason;
  this.line = position ? position.line : null;
  this.column = position ? position.column : null;
  this.location = location;
  this.source = parts[0];
  this.ruleId = parts[1];
}
function parseOrigin(origin) {
  var result = [null, null];
  var index;
  if (typeof origin === 'string') {
    index = origin.indexOf(':');
    if (index === -1) {
      result[1] = origin;
    } else {
      result[0] = origin.slice(0, index);
      result[1] = origin.slice(index + 1);
    }
  }
  return result;
}
var minpath = {
  exports: {}
};
(function (module) {
  module.exports = require$$0$1;
})(minpath);
var minproc = process;

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

var isBuffer$4 = function isBuffer(obj) {
  return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};
var p = minpath.exports;
var proc = minproc;
var buffer$1 = isBuffer$4;
var core = VFile$1;
var own$9 = {}.hasOwnProperty;

// Order of setting (least specific to most), we need this because otherwise
// `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
// stem can be set.
var order$1 = ['history', 'path', 'basename', 'stem', 'extname', 'dirname'];
VFile$1.prototype.toString = toString$a;

// Access full path (`~/index.min.js`).
Object.defineProperty(VFile$1.prototype, 'path', {
  get: getPath,
  set: setPath
});

// Access parent path (`~`).
Object.defineProperty(VFile$1.prototype, 'dirname', {
  get: getDirname,
  set: setDirname
});

// Access basename (`index.min.js`).
Object.defineProperty(VFile$1.prototype, 'basename', {
  get: getBasename,
  set: setBasename
});

// Access extname (`.js`).
Object.defineProperty(VFile$1.prototype, 'extname', {
  get: getExtname,
  set: setExtname
});

// Access stem (`index.min`).
Object.defineProperty(VFile$1.prototype, 'stem', {
  get: getStem,
  set: setStem
});

// Construct a new file.
function VFile$1(options) {
  var prop;
  var index;
  if (!options) {
    options = {};
  } else if (typeof options === 'string' || buffer$1(options)) {
    options = {
      contents: options
    };
  } else if ('message' in options && 'messages' in options) {
    return options;
  }
  if (!(this instanceof VFile$1)) {
    return new VFile$1(options);
  }
  this.data = {};
  this.messages = [];
  this.history = [];
  this.cwd = proc.cwd();

  // Set path related properties in the correct order.
  index = -1;
  while (++index < order$1.length) {
    prop = order$1[index];
    if (own$9.call(options, prop)) {
      this[prop] = options[prop];
    }
  }

  // Set non-path related properties.
  for (prop in options) {
    if (order$1.indexOf(prop) < 0) {
      this[prop] = options[prop];
    }
  }
}
function getPath() {
  return this.history[this.history.length - 1];
}
function setPath(path) {
  assertNonEmpty(path, 'path');
  if (this.path !== path) {
    this.history.push(path);
  }
}
function getDirname() {
  return typeof this.path === 'string' ? p.dirname(this.path) : undefined;
}
function setDirname(dirname) {
  assertPath(this.path, 'dirname');
  this.path = p.join(dirname || '', this.basename);
}
function getBasename() {
  return typeof this.path === 'string' ? p.basename(this.path) : undefined;
}
function setBasename(basename) {
  assertNonEmpty(basename, 'basename');
  assertPart(basename, 'basename');
  this.path = p.join(this.dirname || '', basename);
}
function getExtname() {
  return typeof this.path === 'string' ? p.extname(this.path) : undefined;
}
function setExtname(extname) {
  assertPart(extname, 'extname');
  assertPath(this.path, 'extname');
  if (extname) {
    if (extname.charCodeAt(0) !== 46 /* `.` */) {
      throw new Error('`extname` must start with `.`');
    }
    if (extname.indexOf('.', 1) > -1) {
      throw new Error('`extname` cannot contain multiple dots');
    }
  }
  this.path = p.join(this.dirname, this.stem + (extname || ''));
}
function getStem() {
  return typeof this.path === 'string' ? p.basename(this.path, this.extname) : undefined;
}
function setStem(stem) {
  assertNonEmpty(stem, 'stem');
  assertPart(stem, 'stem');
  this.path = p.join(this.dirname || '', stem + (this.extname || ''));
}

// Get the value of the file.
function toString$a(encoding) {
  return (this.contents || '').toString(encoding);
}

// Assert that `part` is not a path (i.e., does not contain `p.sep`).
function assertPart(part, name) {
  if (part && part.indexOf(p.sep) > -1) {
    throw new Error('`' + name + '` cannot be a path: did not expect `' + p.sep + '`');
  }
}

// Assert that `part` is not empty.
function assertNonEmpty(part, name) {
  if (!part) {
    throw new Error('`' + name + '` cannot be empty');
  }
}

// Assert `path` exists.
function assertPath(path, name) {
  if (!path) {
    throw new Error('Setting `' + name + '` requires `path` to be set too');
  }
}
var VMessage = vfileMessage;
var VFile = core;
var lib$1 = VFile;
VFile.prototype.message = message;
VFile.prototype.info = info$1;
VFile.prototype.fail = fail;

// Create a message with `reason` at `position`.
// When an error is passed in as `reason`, copies the stack.
function message(reason, position, origin) {
  var message = new VMessage(reason, position, origin);
  if (this.path) {
    message.name = this.path + ':' + message.name;
    message.file = this.path;
  }
  message.fatal = false;
  this.messages.push(message);
  return message;
}

// Fail: creates a vmessage, associates it with the file, and throws it.
function fail() {
  var message = this.message.apply(this, arguments);
  message.fatal = true;
  throw message;
}

// Info: creates a vmessage, associates it with the file, and marks the fatality
// as null.
function info$1() {
  var message = this.message.apply(this, arguments);
  message.fatal = null;
  return message;
}
(function (module) {
  module.exports = lib$1;
})(vfile$2);
var bail_1 = bail$1;
function bail$1(err) {
  if (err) {
    throw err;
  }
}
var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty$3 = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;
var isArray$c = function isArray(arr) {
  if (typeof Array.isArray === 'function') {
    return Array.isArray(arr);
  }
  return toStr.call(arr) === '[object Array]';
};
var isPlainObject$2 = function isPlainObject(obj) {
  if (!obj || toStr.call(obj) !== '[object Object]') {
    return false;
  }
  var hasOwnConstructor = hasOwn.call(obj, 'constructor');
  var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
  // Not own constructor property must be Object
  if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
    return false;
  }

  // Own properties are enumerated firstly, so to speed up,
  // if last one is own, then all properties are own.
  var key;
  for (key in obj) {/**/}
  return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
  if (defineProperty$3 && options.name === '__proto__') {
    defineProperty$3(target, options.name, {
      enumerable: true,
      configurable: true,
      value: options.newValue,
      writable: true
    });
  } else {
    target[options.name] = options.newValue;
  }
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
  if (name === '__proto__') {
    if (!hasOwn.call(obj, name)) {
      return void 0;
    } else if (gOPD) {
      // In early versions of node, obj['__proto__'] is buggy when obj has
      // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
      return gOPD(obj, name).value;
    }
  }
  return obj[name];
};
var extend$2 = function extend() {
  var options, name, src, copy, copyIsArray, clone;
  var target = arguments[0];
  var i = 1;
  var length = arguments.length;
  var deep = false;

  // Handle a deep copy situation
  if (typeof target === 'boolean') {
    deep = target;
    target = arguments[1] || {};
    // skip the boolean and the target
    i = 2;
  }
  if (target == null || typeof target !== 'object' && typeof target !== 'function') {
    target = {};
  }
  for (; i < length; ++i) {
    options = arguments[i];
    // Only deal with non-null/undefined values
    if (options != null) {
      // Extend the base object
      for (name in options) {
        src = getProperty(target, name);
        copy = getProperty(options, name);

        // Prevent never-ending loop
        if (target !== copy) {
          // Recurse if we're merging plain objects or arrays
          if (deep && copy && (isPlainObject$2(copy) || (copyIsArray = isArray$c(copy)))) {
            if (copyIsArray) {
              copyIsArray = false;
              clone = src && isArray$c(src) ? src : [];
            } else {
              clone = src && isPlainObject$2(src) ? src : {};
            }

            // Never move original objects, clone them
            setProperty(target, {
              name: name,
              newValue: extend(deep, clone, copy)
            });

            // Don't bring in undefined values
          } else if (typeof copy !== 'undefined') {
            setProperty(target, {
              name: name,
              newValue: copy
            });
          }
        }
      }
    }
  }

  // Return the modified object
  return target;
};
var isPlainObj = function isPlainObj(value) {
  if (Object.prototype.toString.call(value) !== '[object Object]') {
    return false;
  }
  var prototype = Object.getPrototypeOf(value);
  return prototype === null || prototype === Object.prototype;
};
var slice$2 = [].slice;
var wrap_1$1 = wrap$7;

// Wrap `fn`.
// Can be sync or async; return a promise, receive a completion handler, return
// new values and errors.
function wrap$7(fn, callback) {
  var invoked;
  return wrapped;
  function wrapped() {
    var params = slice$2.call(arguments, 0);
    var callback = fn.length > params.length;
    var result;
    if (callback) {
      params.push(done);
    }
    try {
      result = fn.apply(null, params);
    } catch (error) {
      // Well, this is quite the pickle.
      // `fn` received a callback and invoked it (thus continuing the pipeline),
      // but later also threw an error.
      // We’re not about to restart the pipeline again, so the only thing left
      // to do is to throw the thing instead.
      if (callback && invoked) {
        throw error;
      }
      return done(error);
    }
    if (!callback) {
      if (result && typeof result.then === 'function') {
        result.then(then, done);
      } else if (result instanceof Error) {
        done(result);
      } else {
        then(result);
      }
    }
  }

  // Invoke `next`, only once.
  function done() {
    if (!invoked) {
      invoked = true;
      callback.apply(null, arguments);
    }
  }

  // Invoke `done` with one value.
  // Tracks if an error is passed, too.
  function then(value) {
    done(null, value);
  }
}
var wrap$6 = wrap_1$1;
var trough_1 = trough$1;
trough$1.wrap = wrap$6;
var slice$1 = [].slice;

// Create new middleware.
function trough$1() {
  var fns = [];
  var middleware = {};
  middleware.run = run;
  middleware.use = use;
  return middleware;

  // Run `fns`.  Last argument must be a completion handler.
  function run() {
    var index = -1;
    var input = slice$1.call(arguments, 0, -1);
    var done = arguments[arguments.length - 1];
    if (typeof done !== 'function') {
      throw new Error('Expected function as last argument, not ' + done);
    }
    next.apply(null, [null].concat(input));

    // Run the next `fn`, if any.
    function next(err) {
      var fn = fns[++index];
      var params = slice$1.call(arguments, 0);
      var values = params.slice(1);
      var length = input.length;
      var pos = -1;
      if (err) {
        done(err);
        return;
      }

      // Copy non-nully input into values.
      while (++pos < length) {
        if (values[pos] === null || values[pos] === undefined) {
          values[pos] = input[pos];
        }
      }
      input = values;

      // Next or done.
      if (fn) {
        wrap$6(fn, next).apply(null, input);
      } else {
        done.apply(null, [null].concat(input));
      }
    }
  }

  // Add `fn` to the list.
  function use(fn) {
    if (typeof fn !== 'function') {
      throw new Error('Expected `fn` to be a function, not ' + fn);
    }
    fns.push(fn);
    return middleware;
  }
}
var bail = bail_1;
var buffer = isBuffer$4;
var extend$1 = extend$2;
var plain = isPlainObj;
var trough = trough_1;
var vfile$1 = vfile$2.exports;

// Expose a frozen processor.
var unified_1 = unified$1().freeze();
var slice = [].slice;
var own$8 = {}.hasOwnProperty;

// Process pipeline.
var pipeline = trough().use(pipelineParse).use(pipelineRun).use(pipelineStringify);
function pipelineParse(p, ctx) {
  ctx.tree = p.parse(ctx.file);
}
function pipelineRun(p, ctx, next) {
  p.run(ctx.tree, ctx.file, done);
  function done(error, tree, file) {
    if (error) {
      next(error);
    } else {
      ctx.tree = tree;
      ctx.file = file;
      next();
    }
  }
}
function pipelineStringify(p, ctx) {
  var result = p.stringify(ctx.tree, ctx.file);
  if (result === undefined || result === null) ;else if (typeof result === 'string' || buffer(result)) {
    if ('value' in ctx.file) {
      ctx.file.value = result;
    }
    ctx.file.contents = result;
  } else {
    ctx.file.result = result;
  }
}

// Function to create the first processor.
function unified$1() {
  var attachers = [];
  var transformers = trough();
  var namespace = {};
  var freezeIndex = -1;
  var frozen;

  // Data management.
  processor.data = data;

  // Lock.
  processor.freeze = freeze;

  // Plugins.
  processor.attachers = attachers;
  processor.use = use;

  // API.
  processor.parse = parse;
  processor.stringify = stringify;
  processor.run = run;
  processor.runSync = runSync;
  processor.process = process;
  processor.processSync = processSync;

  // Expose.
  return processor;

  // Create a new processor based on the processor in the current scope.
  function processor() {
    var destination = unified$1();
    var index = -1;
    while (++index < attachers.length) {
      destination.use.apply(null, attachers[index]);
    }
    destination.data(extend$1(true, {}, namespace));
    return destination;
  }

  // Freeze: used to signal a processor that has finished configuration.
  //
  // For example, take unified itself: it’s frozen.
  // Plugins should not be added to it.
  // Rather, it should be extended, by invoking it, before modifying it.
  //
  // In essence, always invoke this when exporting a processor.
  function freeze() {
    var values;
    var transformer;
    if (frozen) {
      return processor;
    }
    while (++freezeIndex < attachers.length) {
      values = attachers[freezeIndex];
      if (values[1] === false) {
        continue;
      }
      if (values[1] === true) {
        values[1] = undefined;
      }
      transformer = values[0].apply(processor, values.slice(1));
      if (typeof transformer === 'function') {
        transformers.use(transformer);
      }
    }
    frozen = true;
    freezeIndex = Infinity;
    return processor;
  }

  // Data management.
  // Getter / setter for processor-specific informtion.
  function data(key, value) {
    if (typeof key === 'string') {
      // Set `key`.
      if (arguments.length === 2) {
        assertUnfrozen('data', frozen);
        namespace[key] = value;
        return processor;
      }

      // Get `key`.
      return own$8.call(namespace, key) && namespace[key] || null;
    }

    // Set space.
    if (key) {
      assertUnfrozen('data', frozen);
      namespace = key;
      return processor;
    }

    // Get space.
    return namespace;
  }

  // Plugin management.
  //
  // Pass it:
  // *   an attacher and options,
  // *   a preset,
  // *   a list of presets, attachers, and arguments (list of attachers and
  //     options).
  function use(value) {
    var settings;
    assertUnfrozen('use', frozen);
    if (value === null || value === undefined) ;else if (typeof value === 'function') {
      addPlugin.apply(null, arguments);
    } else if (typeof value === 'object') {
      if ('length' in value) {
        addList(value);
      } else {
        addPreset(value);
      }
    } else {
      throw new Error('Expected usable value, not `' + value + '`');
    }
    if (settings) {
      namespace.settings = extend$1(namespace.settings || {}, settings);
    }
    return processor;
    function addPreset(result) {
      addList(result.plugins);
      if (result.settings) {
        settings = extend$1(settings || {}, result.settings);
      }
    }
    function add(value) {
      if (typeof value === 'function') {
        addPlugin(value);
      } else if (typeof value === 'object') {
        if ('length' in value) {
          addPlugin.apply(null, value);
        } else {
          addPreset(value);
        }
      } else {
        throw new Error('Expected usable value, not `' + value + '`');
      }
    }
    function addList(plugins) {
      var index = -1;
      if (plugins === null || plugins === undefined) ;else if (typeof plugins === 'object' && 'length' in plugins) {
        while (++index < plugins.length) {
          add(plugins[index]);
        }
      } else {
        throw new Error('Expected a list of plugins, not `' + plugins + '`');
      }
    }
    function addPlugin(plugin, value) {
      var entry = find(plugin);
      if (entry) {
        if (plain(entry[1]) && plain(value)) {
          value = extend$1(true, entry[1], value);
        }
        entry[1] = value;
      } else {
        attachers.push(slice.call(arguments));
      }
    }
  }
  function find(plugin) {
    var index = -1;
    while (++index < attachers.length) {
      if (attachers[index][0] === plugin) {
        return attachers[index];
      }
    }
  }

  // Parse a file (in string or vfile representation) into a unist node using
  // the `Parser` on the processor.
  function parse(doc) {
    var file = vfile$1(doc);
    var Parser;
    freeze();
    Parser = processor.Parser;
    assertParser('parse', Parser);
    if (newable(Parser, 'parse')) {
      return new Parser(String(file), file).parse();
    }
    return Parser(String(file), file); // eslint-disable-line new-cap
  }

  // Run transforms on a unist node representation of a file (in string or
  // vfile representation), async.
  function run(node, file, cb) {
    assertNode(node);
    freeze();
    if (!cb && typeof file === 'function') {
      cb = file;
      file = null;
    }
    if (!cb) {
      return new Promise(executor);
    }
    executor(null, cb);
    function executor(resolve, reject) {
      transformers.run(node, vfile$1(file), done);
      function done(error, tree, file) {
        tree = tree || node;
        if (error) {
          reject(error);
        } else if (resolve) {
          resolve(tree);
        } else {
          cb(null, tree, file);
        }
      }
    }
  }

  // Run transforms on a unist node representation of a file (in string or
  // vfile representation), sync.
  function runSync(node, file) {
    var result;
    var complete;
    run(node, file, done);
    assertDone('runSync', 'run', complete);
    return result;
    function done(error, tree) {
      complete = true;
      result = tree;
      bail(error);
    }
  }

  // Stringify a unist node representation of a file (in string or vfile
  // representation) into a string using the `Compiler` on the processor.
  function stringify(node, doc) {
    var file = vfile$1(doc);
    var Compiler;
    freeze();
    Compiler = processor.Compiler;
    assertCompiler('stringify', Compiler);
    assertNode(node);
    if (newable(Compiler, 'compile')) {
      return new Compiler(node, file).compile();
    }
    return Compiler(node, file); // eslint-disable-line new-cap
  }

  // Parse a file (in string or vfile representation) into a unist node using
  // the `Parser` on the processor, then run transforms on that node, and
  // compile the resulting node using the `Compiler` on the processor, and
  // store that result on the vfile.
  function process(doc, cb) {
    freeze();
    assertParser('process', processor.Parser);
    assertCompiler('process', processor.Compiler);
    if (!cb) {
      return new Promise(executor);
    }
    executor(null, cb);
    function executor(resolve, reject) {
      var file = vfile$1(doc);
      pipeline.run(processor, {
        file: file
      }, done);
      function done(error) {
        if (error) {
          reject(error);
        } else if (resolve) {
          resolve(file);
        } else {
          cb(null, file);
        }
      }
    }
  }

  // Process the given document (in string or vfile representation), sync.
  function processSync(doc) {
    var file;
    var complete;
    freeze();
    assertParser('processSync', processor.Parser);
    assertCompiler('processSync', processor.Compiler);
    file = vfile$1(doc);
    process(file, done);
    assertDone('processSync', 'process', complete);
    return file;
    function done(error) {
      complete = true;
      bail(error);
    }
  }
}

// Check if `value` is a constructor.
function newable(value, name) {
  return typeof value === 'function' && value.prototype && (
  // A function with keys in its prototype is probably a constructor.
  // Classes’ prototype methods are not enumerable, so we check if some value
  // exists in the prototype.
  keys$5(value.prototype) || name in value.prototype);
}

// Check if `value` is an object with keys.
function keys$5(value) {
  var key;
  for (key in value) {
    return true;
  }
  return false;
}

// Assert a parser is available.
function assertParser(name, Parser) {
  if (typeof Parser !== 'function') {
    throw new Error('Cannot `' + name + '` without `Parser`');
  }
}

// Assert a compiler is available.
function assertCompiler(name, Compiler) {
  if (typeof Compiler !== 'function') {
    throw new Error('Cannot `' + name + '` without `Compiler`');
  }
}

// Assert the processor is not frozen.
function assertUnfrozen(name, frozen) {
  if (frozen) {
    throw new Error('Cannot invoke `' + name + '` on a frozen processor.\nCreate a new processor first, by invoking it: use `processor()` instead of `processor`.');
  }
}

// Assert `node` is a unist node.
function assertNode(node) {
  if (!node || typeof node.type !== 'string') {
    throw new Error('Expected node, got `' + node + '`');
  }
}

// Assert that `complete` is `true`.
function assertDone(name, asyncName, complete) {
  if (!complete) {
    throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
  }
}
var mdastUtilFromMarkdown = {
  exports: {}
};
var mdastUtilToString = toString$9;

// Get the text content of a node.
// Prefer the node’s plain-text fields, otherwise serialize its children,
// and if the given value is an array, serialize the nodes in it.
function toString$9(node) {
  return node && (node.value || node.alt || node.title || 'children' in node && all$d(node.children) || 'length' in node && all$d(node)) || '';
}
function all$d(values) {
  var result = [];
  var index = -1;
  while (++index < values.length) {
    result[index] = toString$9(values[index]);
  }
  return result.join('');
}
var assign$5 = Object.assign;
var assign_1 = assign$5;
var own$7 = {}.hasOwnProperty;
var hasOwnProperty$n = own$7;
function normalizeIdentifier$3(value) {
  return value // Collapse Markdown whitespace.
  .replace(/[\t\n\r ]+/g, ' ') // Trim.
  .replace(/^ | $/g, '') // Some characters are considered “uppercase”, but if their lowercase
  // counterpart is uppercased will result in a different uppercase
  // character.
  // Hence, to get that form, we perform both lower- and uppercase.
  // Upper case makes sure keys will not interact with default prototypal
  // methods: no object method is uppercase.
  .toLowerCase().toUpperCase();
}
var normalizeIdentifier_1 = normalizeIdentifier$3;
var fromCharCode$4 = String.fromCharCode;
var fromCharCode_1 = fromCharCode$4;
var fromCharCode$3 = fromCharCode_1;
function safeFromInt$1(value, base) {
  var code = parseInt(value, base);
  if (
  // C0 except for HT, LF, FF, CR, space
  code < 9 || code === 11 || code > 13 && code < 32 ||
  // Control character (DEL) of the basic block and C1 controls.
  code > 126 && code < 160 ||
  // Lone high surrogates and low surrogates.
  code > 55295 && code < 57344 ||
  // Noncharacters.
  code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 ||
  // Out of range
  code > 1114111) {
    return "\uFFFD";
  }
  return fromCharCode$3(code);
}
var safeFromInt_1 = safeFromInt$1;
var content$3 = {};
function markdownLineEnding$k(code) {
  return code < -2;
}
var markdownLineEnding_1 = markdownLineEnding$k;
function markdownSpace$9(code) {
  return code === -2 || code === -1 || code === 32;
}
var markdownSpace_1 = markdownSpace$9;
var markdownSpace$8 = markdownSpace_1;
function spaceFactory$1(effects, ok, type, max) {
  var limit = max ? max - 1 : Infinity;
  var size = 0;
  return start;
  function start(code) {
    if (markdownSpace$8(code)) {
      effects.enter(type);
      return prefix(code);
    }
    return ok(code);
  }
  function prefix(code) {
    if (markdownSpace$8(code) && size++ < limit) {
      effects.consume(code);
      return prefix;
    }
    effects.exit(type);
    return ok(code);
  }
}
var factorySpace$h = spaceFactory$1;
Object.defineProperty(content$3, '__esModule', {
  value: true
});
var markdownLineEnding$j = markdownLineEnding_1;
var factorySpace$g = factorySpace$h;
var tokenize$2 = initializeContent;
function initializeContent(effects) {
  var contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
  var previous;
  return contentStart;
  function afterContentStartConstruct(code) {
    if (code === null) {
      effects.consume(code);
      return;
    }
    effects.enter('lineEnding');
    effects.consume(code);
    effects.exit('lineEnding');
    return factorySpace$g(effects, contentStart, 'linePrefix');
  }
  function paragraphInitial(code) {
    effects.enter('paragraph');
    return lineStart(code);
  }
  function lineStart(code) {
    var token = effects.enter('chunkText', {
      contentType: 'text',
      previous: previous
    });
    if (previous) {
      previous.next = token;
    }
    previous = token;
    return data(code);
  }
  function data(code) {
    if (code === null) {
      effects.exit('chunkText');
      effects.exit('paragraph');
      effects.consume(code);
      return;
    }
    if (markdownLineEnding$j(code)) {
      effects.consume(code);
      effects.exit('chunkText');
      return lineStart;
    } // Data.

    effects.consume(code);
    return data;
  }
}
content$3.tokenize = tokenize$2;
var document$3 = {};
var markdownLineEnding$i = markdownLineEnding_1;
var factorySpace$f = factorySpace$h;
var partialBlankLine$4 = {
  tokenize: tokenizePartialBlankLine,
  partial: true
};
function tokenizePartialBlankLine(effects, ok, nok) {
  return factorySpace$f(effects, afterWhitespace, 'linePrefix');
  function afterWhitespace(code) {
    return code === null || markdownLineEnding$i(code) ? ok(code) : nok(code);
  }
}
var partialBlankLine_1 = partialBlankLine$4;
Object.defineProperty(document$3, '__esModule', {
  value: true
});
var markdownLineEnding$h = markdownLineEnding_1;
var factorySpace$e = factorySpace$h;
var partialBlankLine$3 = partialBlankLine_1;
var tokenize$1 = initializeDocument;
var containerConstruct = {
  tokenize: tokenizeContainer
};
var lazyFlowConstruct = {
  tokenize: tokenizeLazyFlow
};
function initializeDocument(effects) {
  var self = this;
  var stack = [];
  var continued = 0;
  var inspectConstruct = {
    tokenize: tokenizeInspect,
    partial: true
  };
  var inspectResult;
  var childFlow;
  var childToken;
  return start;
  function start(code) {
    if (continued < stack.length) {
      self.containerState = stack[continued][1];
      return effects.attempt(stack[continued][0].continuation, documentContinue, documentContinued)(code);
    }
    return documentContinued(code);
  }
  function documentContinue(code) {
    continued++;
    return start(code);
  }
  function documentContinued(code) {
    // If we’re in a concrete construct (such as when expecting another line of
    // HTML, or we resulted in lazy content), we can immediately start flow.
    if (inspectResult && inspectResult.flowContinue) {
      return flowStart(code);
    }
    self.interrupt = childFlow && childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
    self.containerState = {};
    return effects.attempt(containerConstruct, containerContinue, flowStart)(code);
  }
  function containerContinue(code) {
    stack.push([self.currentConstruct, self.containerState]);
    self.containerState = undefined;
    return documentContinued(code);
  }
  function flowStart(code) {
    if (code === null) {
      exitContainers(0, true);
      effects.consume(code);
      return;
    }
    childFlow = childFlow || self.parser.flow(self.now());
    effects.enter('chunkFlow', {
      contentType: 'flow',
      previous: childToken,
      _tokenizer: childFlow
    });
    return flowContinue(code);
  }
  function flowContinue(code) {
    if (code === null) {
      continueFlow(effects.exit('chunkFlow'));
      return flowStart(code);
    }
    if (markdownLineEnding$h(code)) {
      effects.consume(code);
      continueFlow(effects.exit('chunkFlow'));
      return effects.check(inspectConstruct, documentAfterPeek);
    }
    effects.consume(code);
    return flowContinue;
  }
  function documentAfterPeek(code) {
    exitContainers(inspectResult.continued, inspectResult && inspectResult.flowEnd);
    continued = 0;
    return start(code);
  }
  function continueFlow(token) {
    if (childToken) childToken.next = token;
    childToken = token;
    childFlow.lazy = inspectResult && inspectResult.lazy;
    childFlow.defineSkip(token.start);
    childFlow.write(self.sliceStream(token));
  }
  function exitContainers(size, end) {
    var index = stack.length; // Close the flow.

    if (childFlow && end) {
      childFlow.write([null]);
      childToken = childFlow = undefined;
    } // Exit open containers.

    while (index-- > size) {
      self.containerState = stack[index][1];
      stack[index][0].exit.call(self, effects);
    }
    stack.length = size;
  }
  function tokenizeInspect(effects, ok) {
    var subcontinued = 0;
    inspectResult = {};
    return inspectStart;
    function inspectStart(code) {
      if (subcontinued < stack.length) {
        self.containerState = stack[subcontinued][1];
        return effects.attempt(stack[subcontinued][0].continuation, inspectContinue, inspectLess)(code);
      } // If we’re continued but in a concrete flow, we can’t have more
      // containers.

      if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
        inspectResult.flowContinue = true;
        return inspectDone(code);
      }
      self.interrupt = childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
      self.containerState = {};
      return effects.attempt(containerConstruct, inspectFlowEnd, inspectDone)(code);
    }
    function inspectContinue(code) {
      subcontinued++;
      return self.containerState._closeFlow ? inspectFlowEnd(code) : inspectStart(code);
    }
    function inspectLess(code) {
      if (childFlow.currentConstruct && childFlow.currentConstruct.lazy) {
        // Maybe another container?
        self.containerState = {};
        return effects.attempt(containerConstruct, inspectFlowEnd,
        // Maybe flow, or a blank line?
        effects.attempt(lazyFlowConstruct, inspectFlowEnd, effects.check(partialBlankLine$3, inspectFlowEnd, inspectLazy)))(code);
      } // Otherwise we’re interrupting.

      return inspectFlowEnd(code);
    }
    function inspectLazy(code) {
      // Act as if all containers are continued.
      subcontinued = stack.length;
      inspectResult.lazy = true;
      inspectResult.flowContinue = true;
      return inspectDone(code);
    } // We’re done with flow if we have more containers, or an interruption.

    function inspectFlowEnd(code) {
      inspectResult.flowEnd = true;
      return inspectDone(code);
    }
    function inspectDone(code) {
      inspectResult.continued = subcontinued;
      self.interrupt = self.containerState = undefined;
      return ok(code);
    }
  }
}
function tokenizeContainer(effects, ok, nok) {
  return factorySpace$e(effects, effects.attempt(this.parser.constructs.document, ok, nok), 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
}
function tokenizeLazyFlow(effects, ok, nok) {
  return factorySpace$e(effects, effects.lazy(this.parser.constructs.flow, ok, nok), 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
}
document$3.tokenize = tokenize$1;
var flow$4 = {};

// Counts tabs based on their expanded size, and CR+LF as one character.

function sizeChunks$2(chunks) {
  var index = -1;
  var size = 0;
  while (++index < chunks.length) {
    size += typeof chunks[index] === 'string' ? chunks[index].length : 1;
  }
  return size;
}
var sizeChunks_1 = sizeChunks$2;
var sizeChunks$1 = sizeChunks_1;
function prefixSize$5(events, type) {
  var tail = events[events.length - 1];
  if (!tail || tail[1].type !== type) return 0;
  return sizeChunks$1(tail[2].sliceStream(tail[1]));
}
var prefixSize_1 = prefixSize$5;
var splice$4 = [].splice;
var splice_1 = splice$4;
var splice$3 = splice_1;

// causes a stack overflow in V8 when trying to insert 100k items for instance.

function chunkedSplice$9(list, start, remove, items) {
  var end = list.length;
  var chunkStart = 0;
  var parameters; // Make start between zero and `end` (included).

  if (start < 0) {
    start = -start > end ? 0 : end + start;
  } else {
    start = start > end ? end : start;
  }
  remove = remove > 0 ? remove : 0; // No need to chunk the items if there’s only a couple (10k) items.

  if (items.length < 10000) {
    parameters = Array.from(items);
    parameters.unshift(start, remove);
    splice$3.apply(list, parameters);
  } else {
    // Delete `remove` items starting from `start`
    if (remove) splice$3.apply(list, [start, remove]); // Insert the items in chunks to not cause stack overflows.

    while (chunkStart < items.length) {
      parameters = items.slice(chunkStart, chunkStart + 10000);
      parameters.unshift(start, 0);
      splice$3.apply(list, parameters);
      chunkStart += 10000;
      start += 10000;
    }
  }
}
var chunkedSplice_1 = chunkedSplice$9;
var assign$4 = assign_1;
function shallow$7(object) {
  return assign$4({}, object);
}
var shallow_1 = shallow$7;
var assign$3 = assign_1;
var chunkedSplice$8 = chunkedSplice_1;
var shallow$6 = shallow_1;
function subtokenize$2(events) {
  var jumps = {};
  var index = -1;
  var event;
  var lineIndex;
  var otherIndex;
  var otherEvent;
  var parameters;
  var subevents;
  var more;
  while (++index < events.length) {
    while (index in jumps) {
      index = jumps[index];
    }
    event = events[index]; // Add a hook for the GFM tasklist extension, which needs to know if text
    // is in the first content of a list item.

    if (index && event[1].type === 'chunkFlow' && events[index - 1][1].type === 'listItemPrefix') {
      subevents = event[1]._tokenizer.events;
      otherIndex = 0;
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === 'lineEndingBlank') {
        otherIndex += 2;
      }
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === 'content') {
        while (++otherIndex < subevents.length) {
          if (subevents[otherIndex][1].type === 'content') {
            break;
          }
          if (subevents[otherIndex][1].type === 'chunkText') {
            subevents[otherIndex][1].isInFirstContentOfListItem = true;
            otherIndex++;
          }
        }
      }
    } // Enter.

    if (event[0] === 'enter') {
      if (event[1].contentType) {
        assign$3(jumps, subcontent(events, index));
        index = jumps[index];
        more = true;
      }
    } // Exit.
    else if (event[1]._container || event[1]._movePreviousLineEndings) {
      otherIndex = index;
      lineIndex = undefined;
      while (otherIndex--) {
        otherEvent = events[otherIndex];
        if (otherEvent[1].type === 'lineEnding' || otherEvent[1].type === 'lineEndingBlank') {
          if (otherEvent[0] === 'enter') {
            if (lineIndex) {
              events[lineIndex][1].type = 'lineEndingBlank';
            }
            otherEvent[1].type = 'lineEnding';
            lineIndex = otherIndex;
          }
        } else {
          break;
        }
      }
      if (lineIndex) {
        // Fix position.
        event[1].end = shallow$6(events[lineIndex][1].start); // Switch container exit w/ line endings.

        parameters = events.slice(lineIndex, index);
        parameters.unshift(event);
        chunkedSplice$8(events, lineIndex, index - lineIndex + 1, parameters);
      }
    }
  }
  return !more;
}
function subcontent(events, eventIndex) {
  var token = events[eventIndex][1];
  var context = events[eventIndex][2];
  var startPosition = eventIndex - 1;
  var startPositions = [];
  var tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
  var childEvents = tokenizer.events;
  var jumps = [];
  var gaps = {};
  var stream;
  var previous;
  var index;
  var entered;
  var end;
  var adjust; // Loop forward through the linked tokens to pass them in order to the
  // subtokenizer.

  while (token) {
    // Find the position of the event for this token.
    while (events[++startPosition][1] !== token) {
      // Empty.
    }
    startPositions.push(startPosition);
    if (!token._tokenizer) {
      stream = context.sliceStream(token);
      if (!token.next) {
        stream.push(null);
      }
      if (previous) {
        tokenizer.defineSkip(token.start);
      }
      if (token.isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = true;
      }
      tokenizer.write(stream);
      if (token.isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = undefined;
      }
    } // Unravel the next token.

    previous = token;
    token = token.next;
  } // Now, loop back through all events (and linked tokens), to figure out which
  // parts belong where.

  token = previous;
  index = childEvents.length;
  while (index--) {
    // Make sure we’ve at least seen something (final eol is part of the last
    // token).
    if (childEvents[index][0] === 'enter') {
      entered = true;
    } else if (
    // Find a void token that includes a break.
    entered && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
      add(childEvents.slice(index + 1, end));
      // Help GC.
      token._tokenizer = token.next = undefined;
      token = token.previous;
      end = index + 1;
    }
  }

  // Help GC.
  tokenizer.events = token._tokenizer = token.next = undefined; // Do head:

  add(childEvents.slice(0, end));
  index = -1;
  adjust = 0;
  while (++index < jumps.length) {
    gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
    adjust += jumps[index][1] - jumps[index][0] - 1;
  }
  return gaps;
  function add(slice) {
    var start = startPositions.pop();
    jumps.unshift([start, start + slice.length - 1]);
    chunkedSplice$8(events, start, 2, slice);
  }
}
var subtokenize_1 = subtokenize$2;
var markdownLineEnding$g = markdownLineEnding_1;
var prefixSize$4 = prefixSize_1;
var subtokenize$1 = subtokenize_1;
var factorySpace$d = factorySpace$h;

// No name because it must not be turned off.
var content$2 = {
  tokenize: tokenizeContent,
  resolve: resolveContent,
  interruptible: true,
  lazy: true
};
var continuationConstruct = {
  tokenize: tokenizeContinuation,
  partial: true
}; // Content is transparent: it’s parsed right now. That way, definitions are also
// parsed right now: before text in paragraphs (specifically, media) are parsed.

function resolveContent(events) {
  subtokenize$1(events);
  return events;
}
function tokenizeContent(effects, ok) {
  var previous;
  return start;
  function start(code) {
    effects.enter('content');
    previous = effects.enter('chunkContent', {
      contentType: 'content'
    });
    return data(code);
  }
  function data(code) {
    if (code === null) {
      return contentEnd(code);
    }
    if (markdownLineEnding$g(code)) {
      return effects.check(continuationConstruct, contentContinue, contentEnd)(code);
    } // Data.

    effects.consume(code);
    return data;
  }
  function contentEnd(code) {
    effects.exit('chunkContent');
    effects.exit('content');
    return ok(code);
  }
  function contentContinue(code) {
    effects.consume(code);
    effects.exit('chunkContent');
    previous = previous.next = effects.enter('chunkContent', {
      contentType: 'content',
      previous: previous
    });
    return data;
  }
}
function tokenizeContinuation(effects, ok, nok) {
  var self = this;
  return startLookahead;
  function startLookahead(code) {
    effects.enter('lineEnding');
    effects.consume(code);
    effects.exit('lineEnding');
    return factorySpace$d(effects, prefixed, 'linePrefix');
  }
  function prefixed(code) {
    if (code === null || markdownLineEnding$g(code)) {
      return nok(code);
    }
    if (self.parser.constructs.disable.null.indexOf('codeIndented') > -1 || prefixSize$4(self.events, 'linePrefix') < 4) {
      return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
    return ok(code);
  }
}
var content_1 = content$2;
Object.defineProperty(flow$4, '__esModule', {
  value: true
});
var content$1 = content_1;
var factorySpace$c = factorySpace$h;
var partialBlankLine$2 = partialBlankLine_1;
var tokenize = initializeFlow;
function initializeFlow(effects) {
  var self = this;
  var initial = effects.attempt(
  // Try to parse a blank line.
  partialBlankLine$2, atBlankEnding,
  // Try to parse initial flow (essentially, only code).
  effects.attempt(this.parser.constructs.flowInitial, afterConstruct, factorySpace$c(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt(content$1, afterConstruct)), 'linePrefix')));
  return initial;
  function atBlankEnding(code) {
    if (code === null) {
      effects.consume(code);
      return;
    }
    effects.enter('lineEndingBlank');
    effects.consume(code);
    effects.exit('lineEndingBlank');
    self.currentConstruct = undefined;
    return initial;
  }
  function afterConstruct(code) {
    if (code === null) {
      effects.consume(code);
      return;
    }
    effects.enter('lineEnding');
    effects.consume(code);
    effects.exit('lineEnding');
    self.currentConstruct = undefined;
    return initial;
  }
}
flow$4.tokenize = tokenize;
var text$5 = {};
Object.defineProperty(text$5, '__esModule', {
  value: true
});
var assign$2 = assign_1;
var shallow$5 = shallow_1;
var text$4 = initializeFactory('text');
var string$2 = initializeFactory('string');
var resolver = {
  resolveAll: createResolver()
};
function initializeFactory(field) {
  return {
    tokenize: initializeText,
    resolveAll: createResolver(field === 'text' ? resolveAllLineSuffixes : undefined)
  };
  function initializeText(effects) {
    var self = this;
    var constructs = this.parser.constructs[field];
    var text = effects.attempt(constructs, start, notText);
    return start;
    function start(code) {
      return atBreak(code) ? text(code) : notText(code);
    }
    function notText(code) {
      if (code === null) {
        effects.consume(code);
        return;
      }
      effects.enter('data');
      effects.consume(code);
      return data;
    }
    function data(code) {
      if (atBreak(code)) {
        effects.exit('data');
        return text(code);
      } // Data.

      effects.consume(code);
      return data;
    }
    function atBreak(code) {
      var list = constructs[code];
      var index = -1;
      if (code === null) {
        return true;
      }
      if (list) {
        while (++index < list.length) {
          if (!list[index].previous || list[index].previous.call(self, self.previous)) {
            return true;
          }
        }
      }
    }
  }
}
function createResolver(extraResolver) {
  return resolveAllText;
  function resolveAllText(events, context) {
    var index = -1;
    var enter; // A rather boring computation (to merge adjacent `data` events) which
    // improves mm performance by 29%.

    while (++index <= events.length) {
      if (enter === undefined) {
        if (events[index] && events[index][1].type === 'data') {
          enter = index;
          index++;
        }
      } else if (!events[index] || events[index][1].type !== 'data') {
        // Don’t do anything if there is one data token.
        if (index !== enter + 2) {
          events[enter][1].end = events[index - 1][1].end;
          events.splice(enter + 2, index - enter - 2);
          index = enter + 2;
        }
        enter = undefined;
      }
    }
    return extraResolver ? extraResolver(events, context) : events;
  }
} // A rather ugly set of instructions which again looks at chunks in the input
// stream.
// The reason to do this here is that it is *much* faster to parse in reverse.
// And that we can’t hook into `null` to split the line suffix before an EOF.
// To do: figure out if we can make this into a clean utility, or even in core.
// As it will be useful for GFMs literal autolink extension (and maybe even
// tables?)

function resolveAllLineSuffixes(events, context) {
  var eventIndex = -1;
  var chunks;
  var data;
  var chunk;
  var index;
  var bufferIndex;
  var size;
  var tabs;
  var token;
  while (++eventIndex <= events.length) {
    if ((eventIndex === events.length || events[eventIndex][1].type === 'lineEnding') && events[eventIndex - 1][1].type === 'data') {
      data = events[eventIndex - 1][1];
      chunks = context.sliceStream(data);
      index = chunks.length;
      bufferIndex = -1;
      size = 0;
      tabs = undefined;
      while (index--) {
        chunk = chunks[index];
        if (typeof chunk === 'string') {
          bufferIndex = chunk.length;
          while (chunk.charCodeAt(bufferIndex - 1) === 32) {
            size++;
            bufferIndex--;
          }
          if (bufferIndex) break;
          bufferIndex = -1;
        } // Number
        else if (chunk === -2) {
          tabs = true;
          size++;
        } else if (chunk === -1) ;else {
          // Replacement character, exit.
          index++;
          break;
        }
      }
      if (size) {
        token = {
          type: eventIndex === events.length || tabs || size < 2 ? 'lineSuffix' : 'hardBreakTrailing',
          start: {
            line: data.end.line,
            column: data.end.column - size,
            offset: data.end.offset - size,
            _index: data.start._index + index,
            _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
          },
          end: shallow$5(data.end)
        };
        data.end = shallow$5(token.start);
        if (data.start.offset === data.end.offset) {
          assign$2(data, token);
        } else {
          events.splice(eventIndex, 0, ['enter', token, context], ['exit', token, context]);
          eventIndex += 2;
        }
      }
      eventIndex++;
    }
  }
  return events;
}
text$5.resolver = resolver;
text$5.string = string$2;
text$5.text = text$4;
function miniflat$3(value) {
  return value === null || value === undefined ? [] : 'length' in value ? value : [value];
}
var miniflat_1 = miniflat$3;
var hasOwnProperty$m = hasOwnProperty$n;
var chunkedSplice$7 = chunkedSplice_1;
var miniflat$2 = miniflat_1;
function combineExtensions$1(extensions) {
  var all = {};
  var index = -1;
  while (++index < extensions.length) {
    extension$2(all, extensions[index]);
  }
  return all;
}
function extension$2(all, extension) {
  var hook;
  var left;
  var right;
  var code;
  for (hook in extension) {
    left = hasOwnProperty$m.call(all, hook) ? all[hook] : all[hook] = {};
    right = extension[hook];
    for (code in right) {
      left[code] = constructs$2(miniflat$2(right[code]), hasOwnProperty$m.call(left, code) ? left[code] : []);
    }
  }
}
function constructs$2(list, existing) {
  var index = -1;
  var before = [];
  while (++index < list.length) {
    (list[index].add === 'after' ? existing : before).push(list[index]);
  }
  chunkedSplice$7(existing, 0, 0, before);
  return existing;
}
var combineExtensions_1 = combineExtensions$1;
var chunkedSplice$6 = chunkedSplice_1;
function chunkedPush$3(list, items) {
  if (list.length) {
    chunkedSplice$6(list, list.length, 0, items);
    return list;
  }
  return items;
}
var chunkedPush_1 = chunkedPush$3;
function resolveAll$4(constructs, events, context) {
  var called = [];
  var index = -1;
  var resolve;
  while (++index < constructs.length) {
    resolve = constructs[index].resolveAll;
    if (resolve && called.indexOf(resolve) < 0) {
      events = resolve(events, context);
      called.push(resolve);
    }
  }
  return events;
}
var resolveAll_1 = resolveAll$4;
var fromCharCode$2 = fromCharCode_1;
function serializeChunks$1(chunks) {
  var index = -1;
  var result = [];
  var chunk;
  var value;
  var atTab;
  while (++index < chunks.length) {
    chunk = chunks[index];
    if (typeof chunk === 'string') {
      value = chunk;
    } else if (chunk === -5) {
      value = '\r';
    } else if (chunk === -4) {
      value = '\n';
    } else if (chunk === -3) {
      value = '\r' + '\n';
    } else if (chunk === -2) {
      value = '\t';
    } else if (chunk === -1) {
      if (atTab) continue;
      value = ' ';
    } else {
      // Currently only replacement character.
      value = fromCharCode$2(chunk);
    }
    atTab = chunk === -2;
    result.push(value);
  }
  return result.join('');
}
var serializeChunks_1 = serializeChunks$1;
function sliceChunks$1(chunks, token) {
  var startIndex = token.start._index;
  var startBufferIndex = token.start._bufferIndex;
  var endIndex = token.end._index;
  var endBufferIndex = token.end._bufferIndex;
  var view;
  if (startIndex === endIndex) {
    view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)];
  } else {
    view = chunks.slice(startIndex, endIndex);
    if (startBufferIndex > -1) {
      view[0] = view[0].slice(startBufferIndex);
    }
    if (endBufferIndex > 0) {
      view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
  }
  return view;
}
var sliceChunks_1 = sliceChunks$1;
var assign$1 = assign_1;
var markdownLineEnding$f = markdownLineEnding_1;
var chunkedPush$2 = chunkedPush_1;
var chunkedSplice$5 = chunkedSplice_1;
var miniflat$1 = miniflat_1;
var resolveAll$3 = resolveAll_1;
var serializeChunks = serializeChunks_1;
var shallow$4 = shallow_1;
var sliceChunks = sliceChunks_1;

// Create a tokenizer.
// Tokenizers deal with one type of data (e.g., containers, flow, text).
// The parser is the object dealing with it all.
// `initialize` works like other constructs, except that only its `tokenize`
// function is used, in which case it doesn’t receive an `ok` or `nok`.
// `from` can be given to set the point before the first character, although
// when further lines are indented, they must be set with `defineSkip`.
function createTokenizer$1(parser, initialize, from) {
  var point = from ? shallow$4(from) : {
    line: 1,
    column: 1,
    offset: 0
  };
  var columnStart = {};
  var resolveAllConstructs = [];
  var chunks = [];
  var stack = [];
  var effects = {
    consume: consume,
    enter: enter,
    exit: exit,
    attempt: constructFactory(onsuccessfulconstruct),
    check: constructFactory(onsuccessfulcheck),
    interrupt: constructFactory(onsuccessfulcheck, {
      interrupt: true
    }),
    lazy: constructFactory(onsuccessfulcheck, {
      lazy: true
    })
  }; // State and tools for resolving and serializing.

  var context = {
    previous: null,
    events: [],
    parser: parser,
    sliceStream: sliceStream,
    sliceSerialize: sliceSerialize,
    now: now,
    defineSkip: skip,
    write: write
  }; // The state function.

  var state = initialize.tokenize.call(context, effects); // Track which character we expect to be consumed, to catch bugs.

  if (initialize.resolveAll) {
    resolveAllConstructs.push(initialize);
  } // Store where we are in the input stream.

  point._index = 0;
  point._bufferIndex = -1;
  return context;
  function write(slice) {
    chunks = chunkedPush$2(chunks, slice);
    main(); // Exit if we’re not done, resolve might change stuff.

    if (chunks[chunks.length - 1] !== null) {
      return [];
    }
    addResult(initialize, 0); // Otherwise, resolve, and exit.

    context.events = resolveAll$3(resolveAllConstructs, context.events, context);
    return context.events;
  } //
  // Tools.
  //

  function sliceSerialize(token) {
    return serializeChunks(sliceStream(token));
  }
  function sliceStream(token) {
    return sliceChunks(chunks, token);
  }
  function now() {
    return shallow$4(point);
  }
  function skip(value) {
    columnStart[value.line] = value.column;
    accountForPotentialSkip();
  } //
  // State management.
  //
  // Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
  // `consume`).
  // Here is where we walk through the chunks, which either include strings of
  // several characters, or numerical character codes.
  // The reason to do this in a loop instead of a call is so the stack can
  // drain.

  function main() {
    var chunkIndex;
    var chunk;
    while (point._index < chunks.length) {
      chunk = chunks[point._index]; // If we’re in a buffer chunk, loop through it.

      if (typeof chunk === 'string') {
        chunkIndex = point._index;
        if (point._bufferIndex < 0) {
          point._bufferIndex = 0;
        }
        while (point._index === chunkIndex && point._bufferIndex < chunk.length) {
          go(chunk.charCodeAt(point._bufferIndex));
        }
      } else {
        go(chunk);
      }
    }
  } // Deal with one code.

  function go(code) {
    state = state(code);
  } // Move a character forward.

  function consume(code) {
    if (markdownLineEnding$f(code)) {
      point.line++;
      point.column = 1;
      point.offset += code === -3 ? 2 : 1;
      accountForPotentialSkip();
    } else if (code !== -1) {
      point.column++;
      point.offset++;
    } // Not in a string chunk.

    if (point._bufferIndex < 0) {
      point._index++;
    } else {
      point._bufferIndex++; // At end of string chunk.

      if (point._bufferIndex === chunks[point._index].length) {
        point._bufferIndex = -1;
        point._index++;
      }
    } // Expose the previous character.

    context.previous = code; // Mark as consumed.
  } // Start a token.

  function enter(type, fields) {
    var token = fields || {};
    token.type = type;
    token.start = now();
    context.events.push(['enter', token, context]);
    stack.push(token);
    return token;
  } // Stop a token.

  function exit(type) {
    var token = stack.pop();
    token.end = now();
    context.events.push(['exit', token, context]);
    return token;
  } // Use results.

  function onsuccessfulconstruct(construct, info) {
    addResult(construct, info.from);
  } // Discard results.

  function onsuccessfulcheck(construct, info) {
    info.restore();
  } // Factory to attempt/check/interrupt.

  function constructFactory(onreturn, fields) {
    return hook; // Handle either an object mapping codes to constructs, a list of
    // constructs, or a single construct.

    function hook(constructs, returnState, bogusState) {
      var listOfConstructs;
      var constructIndex;
      var currentConstruct;
      var info;
      return constructs.tokenize || 'length' in constructs ? handleListOfConstructs(miniflat$1(constructs)) : handleMapOfConstructs;
      function handleMapOfConstructs(code) {
        if (code in constructs || null in constructs) {
          return handleListOfConstructs(constructs.null ? /* c8 ignore next */
          miniflat$1(constructs[code]).concat(miniflat$1(constructs.null)) : constructs[code])(code);
        }
        return bogusState(code);
      }
      function handleListOfConstructs(list) {
        listOfConstructs = list;
        constructIndex = 0;
        return handleConstruct(list[constructIndex]);
      }
      function handleConstruct(construct) {
        return start;
        function start(code) {
          // To do: not nede to store if there is no bogus state, probably?
          // Currently doesn’t work because `inspect` in document does a check
          // w/o a bogus, which doesn’t make sense. But it does seem to help perf
          // by not storing.
          info = store();
          currentConstruct = construct;
          if (!construct.partial) {
            context.currentConstruct = construct;
          }
          if (construct.name && context.parser.constructs.disable.null.indexOf(construct.name) > -1) {
            return nok();
          }
          return construct.tokenize.call(fields ? assign$1({}, context, fields) : context, effects, ok, nok)(code);
        }
      }
      function ok(code) {
        onreturn(currentConstruct, info);
        return returnState;
      }
      function nok(code) {
        info.restore();
        if (++constructIndex < listOfConstructs.length) {
          return handleConstruct(listOfConstructs[constructIndex]);
        }
        return bogusState;
      }
    }
  }
  function addResult(construct, from) {
    if (construct.resolveAll && resolveAllConstructs.indexOf(construct) < 0) {
      resolveAllConstructs.push(construct);
    }
    if (construct.resolve) {
      chunkedSplice$5(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
    }
    if (construct.resolveTo) {
      context.events = construct.resolveTo(context.events, context);
    }
  }
  function store() {
    var startPoint = now();
    var startPrevious = context.previous;
    var startCurrentConstruct = context.currentConstruct;
    var startEventsIndex = context.events.length;
    var startStack = Array.from(stack);
    return {
      restore: restore,
      from: startEventsIndex
    };
    function restore() {
      point = startPoint;
      context.previous = startPrevious;
      context.currentConstruct = startCurrentConstruct;
      context.events.length = startEventsIndex;
      stack = startStack;
      accountForPotentialSkip();
    }
  }
  function accountForPotentialSkip() {
    if (point.line in columnStart && point.column < 2) {
      point.column = columnStart[point.line];
      point.offset += columnStart[point.line] - 1;
    }
  }
}
var createTokenizer_1 = createTokenizer$1;
var constructs$1 = {};
function markdownLineEndingOrSpace$9(code) {
  return code < 0 || code === 32;
}
var markdownLineEndingOrSpace_1 = markdownLineEndingOrSpace$9;

// This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
var unicodePunctuation$4 = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
var unicodePunctuationRegex$1 = unicodePunctuation$4;
var fromCharCode$1 = fromCharCode_1;
function regexCheck$8(regex) {
  return check;
  function check(code) {
    return regex.test(fromCharCode$1(code));
  }
}
var regexCheck_1 = regexCheck$8;
var unicodePunctuationRegex = unicodePunctuationRegex$1;
var regexCheck$7 = regexCheck_1;

// In fact adds to the bundle size.

var unicodePunctuation$3 = regexCheck$7(unicodePunctuationRegex);
var unicodePunctuation_1 = unicodePunctuation$3;
var regexCheck$6 = regexCheck_1;
var unicodeWhitespace$3 = regexCheck$6(/\s/);
var unicodeWhitespace_1 = unicodeWhitespace$3;
var markdownLineEndingOrSpace$8 = markdownLineEndingOrSpace_1;
var unicodePunctuation$2 = unicodePunctuation_1;
var unicodeWhitespace$2 = unicodeWhitespace_1;

// Classify whether a character is unicode whitespace, unicode punctuation, or
// anything else.
// Used for attention (emphasis, strong), whose sequences can open or close
// based on the class of surrounding characters.
function classifyCharacter$2(code) {
  if (code === null || markdownLineEndingOrSpace$8(code) || unicodeWhitespace$2(code)) {
    return 1;
  }
  if (unicodePunctuation$2(code)) {
    return 2;
  }
}
var classifyCharacter_1 = classifyCharacter$2;

// chunks (replacement characters, tabs, or line endings).

function movePoint$1(point, offset) {
  point.column += offset;
  point.offset += offset;
  point._bufferIndex += offset;
  return point;
}
var movePoint_1 = movePoint$1;
var chunkedPush$1 = chunkedPush_1;
var chunkedSplice$4 = chunkedSplice_1;
var classifyCharacter$1 = classifyCharacter_1;
var movePoint = movePoint_1;
var resolveAll$2 = resolveAll_1;
var shallow$3 = shallow_1;
var attention$1 = {
  name: 'attention',
  tokenize: tokenizeAttention,
  resolveAll: resolveAllAttention
};
function resolveAllAttention(events, context) {
  var index = -1;
  var open;
  var group;
  var text;
  var openingSequence;
  var closingSequence;
  var use;
  var nextEvents;
  var offset; // Walk through all events.
  //
  // Note: performance of this is fine on an mb of normal markdown, but it’s
  // a bottleneck for malicious stuff.

  while (++index < events.length) {
    // Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
      open = index; // Now walk back to find an opener.

      while (open--) {
        // Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open &&
        // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
          // If the opening can close or the closing can open,
          // and the close size *is not* a multiple of three,
          // but the sum of the opening and closing size *is* multiple of three,
          // then don’t match.
          if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) {
            continue;
          } // Number of markers to use from the sequence.

          use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
          openingSequence = {
            type: use > 1 ? 'strongSequence' : 'emphasisSequence',
            start: movePoint(shallow$3(events[open][1].end), -use),
            end: shallow$3(events[open][1].end)
          };
          closingSequence = {
            type: use > 1 ? 'strongSequence' : 'emphasisSequence',
            start: shallow$3(events[index][1].start),
            end: movePoint(shallow$3(events[index][1].start), use)
          };
          text = {
            type: use > 1 ? 'strongText' : 'emphasisText',
            start: shallow$3(events[open][1].end),
            end: shallow$3(events[index][1].start)
          };
          group = {
            type: use > 1 ? 'strong' : 'emphasis',
            start: shallow$3(openingSequence.start),
            end: shallow$3(closingSequence.end)
          };
          events[open][1].end = shallow$3(openingSequence.start);
          events[index][1].start = shallow$3(closingSequence.end);
          nextEvents = []; // If there are more markers in the opening, add them before.

          if (events[open][1].end.offset - events[open][1].start.offset) {
            nextEvents = chunkedPush$1(nextEvents, [['enter', events[open][1], context], ['exit', events[open][1], context]]);
          } // Opening.

          nextEvents = chunkedPush$1(nextEvents, [['enter', group, context], ['enter', openingSequence, context], ['exit', openingSequence, context], ['enter', text, context]]); // Between.

          nextEvents = chunkedPush$1(nextEvents, resolveAll$2(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context)); // Closing.

          nextEvents = chunkedPush$1(nextEvents, [['exit', text, context], ['enter', closingSequence, context], ['exit', closingSequence, context], ['exit', group, context]]); // If there are more markers in the closing, add them after.

          if (events[index][1].end.offset - events[index][1].start.offset) {
            offset = 2;
            nextEvents = chunkedPush$1(nextEvents, [['enter', events[index][1], context], ['exit', events[index][1], context]]);
          } else {
            offset = 0;
          }
          chunkedSplice$4(events, open - 1, index - open + 3, nextEvents);
          index = open + nextEvents.length - offset - 2;
          break;
        }
      }
    }
  } // Remove remaining sequences.

  index = -1;
  while (++index < events.length) {
    if (events[index][1].type === 'attentionSequence') {
      events[index][1].type = 'data';
    }
  }
  return events;
}
function tokenizeAttention(effects, ok) {
  var before = classifyCharacter$1(this.previous);
  var marker;
  return start;
  function start(code) {
    effects.enter('attentionSequence');
    marker = code;
    return sequence(code);
  }
  function sequence(code) {
    var token;
    var after;
    var open;
    var close;
    if (code === marker) {
      effects.consume(code);
      return sequence;
    }
    token = effects.exit('attentionSequence');
    after = classifyCharacter$1(code);
    open = !after || after === 2 && before;
    close = !before || before === 2 && after;
    token._open = marker === 42 ? open : open && (before || !close);
    token._close = marker === 42 ? close : close && (after || !open);
    return ok(code);
  }
}
var attention_1 = attention$1;
var regexCheck$5 = regexCheck_1;
var asciiAlpha$4 = regexCheck$5(/[A-Za-z]/);
var asciiAlpha_1 = asciiAlpha$4;
var regexCheck$4 = regexCheck_1;
var asciiAlphanumeric$5 = regexCheck$4(/[\dA-Za-z]/);
var asciiAlphanumeric_1 = asciiAlphanumeric$5;
var regexCheck$3 = regexCheck_1;
var asciiAtext$1 = regexCheck$3(/[#-'*+\--9=?A-Z^-~]/);
var asciiAtext_1 = asciiAtext$1;

// Note: EOF is seen as ASCII control here, because `null < 32 == true`.
function asciiControl$3(code) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code < 32 || code === 127
  );
}
var asciiControl_1 = asciiControl$3;
var asciiAlpha$3 = asciiAlpha_1;
var asciiAlphanumeric$4 = asciiAlphanumeric_1;
var asciiAtext = asciiAtext_1;
var asciiControl$2 = asciiControl_1;
var autolink$2 = {
  name: 'autolink',
  tokenize: tokenizeAutolink
};
function tokenizeAutolink(effects, ok, nok) {
  var size = 1;
  return start;
  function start(code) {
    effects.enter('autolink');
    effects.enter('autolinkMarker');
    effects.consume(code);
    effects.exit('autolinkMarker');
    effects.enter('autolinkProtocol');
    return open;
  }
  function open(code) {
    if (asciiAlpha$3(code)) {
      effects.consume(code);
      return schemeOrEmailAtext;
    }
    return asciiAtext(code) ? emailAtext(code) : nok(code);
  }
  function schemeOrEmailAtext(code) {
    return code === 43 || code === 45 || code === 46 || asciiAlphanumeric$4(code) ? schemeInsideOrEmailAtext(code) : emailAtext(code);
  }
  function schemeInsideOrEmailAtext(code) {
    if (code === 58) {
      effects.consume(code);
      return urlInside;
    }
    if ((code === 43 || code === 45 || code === 46 || asciiAlphanumeric$4(code)) && size++ < 32) {
      effects.consume(code);
      return schemeInsideOrEmailAtext;
    }
    return emailAtext(code);
  }
  function urlInside(code) {
    if (code === 62) {
      effects.exit('autolinkProtocol');
      return end(code);
    }
    if (code === 32 || code === 60 || asciiControl$2(code)) {
      return nok(code);
    }
    effects.consume(code);
    return urlInside;
  }
  function emailAtext(code) {
    if (code === 64) {
      effects.consume(code);
      size = 0;
      return emailAtSignOrDot;
    }
    if (asciiAtext(code)) {
      effects.consume(code);
      return emailAtext;
    }
    return nok(code);
  }
  function emailAtSignOrDot(code) {
    return asciiAlphanumeric$4(code) ? emailLabel(code) : nok(code);
  }
  function emailLabel(code) {
    if (code === 46) {
      effects.consume(code);
      size = 0;
      return emailAtSignOrDot;
    }
    if (code === 62) {
      // Exit, then change the type.
      effects.exit('autolinkProtocol').type = 'autolinkEmail';
      return end(code);
    }
    return emailValue(code);
  }
  function emailValue(code) {
    if ((code === 45 || asciiAlphanumeric$4(code)) && size++ < 63) {
      effects.consume(code);
      return code === 45 ? emailValue : emailLabel;
    }
    return nok(code);
  }
  function end(code) {
    effects.enter('autolinkMarker');
    effects.consume(code);
    effects.exit('autolinkMarker');
    effects.exit('autolink');
    return ok;
  }
}
var autolink_1 = autolink$2;
var markdownSpace$7 = markdownSpace_1;
var factorySpace$b = factorySpace$h;
var blockQuote$1 = {
  name: 'blockQuote',
  tokenize: tokenizeBlockQuoteStart,
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit: exit$1
};
function tokenizeBlockQuoteStart(effects, ok, nok) {
  var self = this;
  return start;
  function start(code) {
    if (code === 62) {
      if (!self.containerState.open) {
        effects.enter('blockQuote', {
          _container: true
        });
        self.containerState.open = true;
      }
      effects.enter('blockQuotePrefix');
      effects.enter('blockQuoteMarker');
      effects.consume(code);
      effects.exit('blockQuoteMarker');
      return after;
    }
    return nok(code);
  }
  function after(code) {
    if (markdownSpace$7(code)) {
      effects.enter('blockQuotePrefixWhitespace');
      effects.consume(code);
      effects.exit('blockQuotePrefixWhitespace');
      effects.exit('blockQuotePrefix');
      return ok;
    }
    effects.exit('blockQuotePrefix');
    return ok(code);
  }
}
function tokenizeBlockQuoteContinuation(effects, ok, nok) {
  return factorySpace$b(effects, effects.attempt(blockQuote$1, ok, nok), 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
}
function exit$1(effects) {
  effects.exit('blockQuote');
}
var blockQuote_1 = blockQuote$1;
var regexCheck$2 = regexCheck_1;
var asciiPunctuation$1 = regexCheck$2(/[!-/:-@[-`{-~]/);
var asciiPunctuation_1 = asciiPunctuation$1;
var asciiPunctuation = asciiPunctuation_1;
var characterEscape$1 = {
  name: 'characterEscape',
  tokenize: tokenizeCharacterEscape
};
function tokenizeCharacterEscape(effects, ok, nok) {
  return start;
  function start(code) {
    effects.enter('characterEscape');
    effects.enter('escapeMarker');
    effects.consume(code);
    effects.exit('escapeMarker');
    return open;
  }
  function open(code) {
    if (asciiPunctuation(code)) {
      effects.enter('characterEscapeValue');
      effects.consume(code);
      effects.exit('characterEscapeValue');
      effects.exit('characterEscape');
      return ok;
    }
    return nok(code);
  }
}
var characterEscape_1 = characterEscape$1;
var AEli = "Æ";
var AElig = "Æ";
var AM = "&";
var AMP = "&";
var Aacut = "Á";
var Aacute = "Á";
var Abreve = "Ă";
var Acir = "Â";
var Acirc = "Â";
var Acy = "А";
var Afr = "𝔄";
var Agrav = "À";
var Agrave = "À";
var Alpha = "Α";
var Amacr = "Ā";
var And = "⩓";
var Aogon = "Ą";
var Aopf = "𝔸";
var ApplyFunction = "⁡";
var Arin = "Å";
var Aring = "Å";
var Ascr = "𝒜";
var Assign = "≔";
var Atild = "Ã";
var Atilde = "Ã";
var Aum = "Ä";
var Auml = "Ä";
var Backslash = "∖";
var Barv = "⫧";
var Barwed = "⌆";
var Bcy = "Б";
var Because = "∵";
var Bernoullis = "ℬ";
var Beta = "Β";
var Bfr = "𝔅";
var Bopf = "𝔹";
var Breve = "˘";
var Bscr = "ℬ";
var Bumpeq = "≎";
var CHcy = "Ч";
var COP = "©";
var COPY = "©";
var Cacute = "Ć";
var Cap = "⋒";
var CapitalDifferentialD = "ⅅ";
var Cayleys = "ℭ";
var Ccaron = "Č";
var Ccedi = "Ç";
var Ccedil = "Ç";
var Ccirc = "Ĉ";
var Cconint = "∰";
var Cdot = "Ċ";
var Cedilla = "¸";
var CenterDot = "·";
var Cfr = "ℭ";
var Chi = "Χ";
var CircleDot = "⊙";
var CircleMinus = "⊖";
var CirclePlus = "⊕";
var CircleTimes = "⊗";
var ClockwiseContourIntegral = "∲";
var CloseCurlyDoubleQuote = "”";
var CloseCurlyQuote = "’";
var Colon = "∷";
var Colone = "⩴";
var Congruent = "≡";
var Conint = "∯";
var ContourIntegral = "∮";
var Copf = "ℂ";
var Coproduct = "∐";
var CounterClockwiseContourIntegral = "∳";
var Cross = "⨯";
var Cscr = "𝒞";
var Cup = "⋓";
var CupCap = "≍";
var DD = "ⅅ";
var DDotrahd = "⤑";
var DJcy = "Ђ";
var DScy = "Ѕ";
var DZcy = "Џ";
var Dagger = "‡";
var Darr = "↡";
var Dashv = "⫤";
var Dcaron = "Ď";
var Dcy = "Д";
var Del = "∇";
var Delta = "Δ";
var Dfr = "𝔇";
var DiacriticalAcute = "´";
var DiacriticalDot = "˙";
var DiacriticalDoubleAcute = "˝";
var DiacriticalGrave = "`";
var DiacriticalTilde = "˜";
var Diamond = "⋄";
var DifferentialD = "ⅆ";
var Dopf = "𝔻";
var Dot = "¨";
var DotDot = "⃜";
var DotEqual = "≐";
var DoubleContourIntegral = "∯";
var DoubleDot = "¨";
var DoubleDownArrow = "⇓";
var DoubleLeftArrow = "⇐";
var DoubleLeftRightArrow = "⇔";
var DoubleLeftTee = "⫤";
var DoubleLongLeftArrow = "⟸";
var DoubleLongLeftRightArrow = "⟺";
var DoubleLongRightArrow = "⟹";
var DoubleRightArrow = "⇒";
var DoubleRightTee = "⊨";
var DoubleUpArrow = "⇑";
var DoubleUpDownArrow = "⇕";
var DoubleVerticalBar = "∥";
var DownArrow = "↓";
var DownArrowBar = "⤓";
var DownArrowUpArrow = "⇵";
var DownBreve = "̑";
var DownLeftRightVector = "⥐";
var DownLeftTeeVector = "⥞";
var DownLeftVector = "↽";
var DownLeftVectorBar = "⥖";
var DownRightTeeVector = "⥟";
var DownRightVector = "⇁";
var DownRightVectorBar = "⥗";
var DownTee = "⊤";
var DownTeeArrow = "↧";
var Downarrow = "⇓";
var Dscr = "𝒟";
var Dstrok = "Đ";
var ENG = "Ŋ";
var ET = "Ð";
var ETH = "Ð";
var Eacut = "É";
var Eacute = "É";
var Ecaron = "Ě";
var Ecir = "Ê";
var Ecirc = "Ê";
var Ecy = "Э";
var Edot = "Ė";
var Efr = "𝔈";
var Egrav = "È";
var Egrave = "È";
var Element$1 = "∈";
var Emacr = "Ē";
var EmptySmallSquare = "◻";
var EmptyVerySmallSquare = "▫";
var Eogon = "Ę";
var Eopf = "𝔼";
var Epsilon = "Ε";
var Equal = "⩵";
var EqualTilde = "≂";
var Equilibrium = "⇌";
var Escr = "ℰ";
var Esim = "⩳";
var Eta = "Η";
var Eum = "Ë";
var Euml = "Ë";
var Exists = "∃";
var ExponentialE = "ⅇ";
var Fcy = "Ф";
var Ffr = "𝔉";
var FilledSmallSquare = "◼";
var FilledVerySmallSquare = "▪";
var Fopf = "𝔽";
var ForAll = "∀";
var Fouriertrf = "ℱ";
var Fscr = "ℱ";
var GJcy = "Ѓ";
var G = ">";
var GT = ">";
var Gamma = "Γ";
var Gammad = "Ϝ";
var Gbreve = "Ğ";
var Gcedil = "Ģ";
var Gcirc = "Ĝ";
var Gcy = "Г";
var Gdot = "Ġ";
var Gfr = "𝔊";
var Gg = "⋙";
var Gopf = "𝔾";
var GreaterEqual = "≥";
var GreaterEqualLess = "⋛";
var GreaterFullEqual = "≧";
var GreaterGreater = "⪢";
var GreaterLess = "≷";
var GreaterSlantEqual = "⩾";
var GreaterTilde = "≳";
var Gscr = "𝒢";
var Gt = "≫";
var HARDcy = "Ъ";
var Hacek = "ˇ";
var Hat = "^";
var Hcirc = "Ĥ";
var Hfr = "ℌ";
var HilbertSpace = "ℋ";
var Hopf = "ℍ";
var HorizontalLine = "─";
var Hscr = "ℋ";
var Hstrok = "Ħ";
var HumpDownHump = "≎";
var HumpEqual = "≏";
var IEcy = "Е";
var IJlig = "Ĳ";
var IOcy = "Ё";
var Iacut = "Í";
var Iacute = "Í";
var Icir = "Î";
var Icirc = "Î";
var Icy = "И";
var Idot = "İ";
var Ifr = "ℑ";
var Igrav = "Ì";
var Igrave = "Ì";
var Im = "ℑ";
var Imacr = "Ī";
var ImaginaryI = "ⅈ";
var Implies = "⇒";
var Int = "∬";
var Integral = "∫";
var Intersection = "⋂";
var InvisibleComma = "⁣";
var InvisibleTimes = "⁢";
var Iogon = "Į";
var Iopf = "𝕀";
var Iota = "Ι";
var Iscr = "ℐ";
var Itilde = "Ĩ";
var Iukcy = "І";
var Ium = "Ï";
var Iuml = "Ï";
var Jcirc = "Ĵ";
var Jcy = "Й";
var Jfr = "𝔍";
var Jopf = "𝕁";
var Jscr = "𝒥";
var Jsercy = "Ј";
var Jukcy = "Є";
var KHcy = "Х";
var KJcy = "Ќ";
var Kappa = "Κ";
var Kcedil = "Ķ";
var Kcy = "К";
var Kfr = "𝔎";
var Kopf = "𝕂";
var Kscr = "𝒦";
var LJcy = "Љ";
var L$1 = "<";
var LT = "<";
var Lacute = "Ĺ";
var Lambda = "Λ";
var Lang = "⟪";
var Laplacetrf = "ℒ";
var Larr = "↞";
var Lcaron = "Ľ";
var Lcedil = "Ļ";
var Lcy = "Л";
var LeftAngleBracket = "⟨";
var LeftArrow = "←";
var LeftArrowBar = "⇤";
var LeftArrowRightArrow = "⇆";
var LeftCeiling = "⌈";
var LeftDoubleBracket = "⟦";
var LeftDownTeeVector = "⥡";
var LeftDownVector = "⇃";
var LeftDownVectorBar = "⥙";
var LeftFloor = "⌊";
var LeftRightArrow = "↔";
var LeftRightVector = "⥎";
var LeftTee = "⊣";
var LeftTeeArrow = "↤";
var LeftTeeVector = "⥚";
var LeftTriangle = "⊲";
var LeftTriangleBar = "⧏";
var LeftTriangleEqual = "⊴";
var LeftUpDownVector = "⥑";
var LeftUpTeeVector = "⥠";
var LeftUpVector = "↿";
var LeftUpVectorBar = "⥘";
var LeftVector = "↼";
var LeftVectorBar = "⥒";
var Leftarrow = "⇐";
var Leftrightarrow = "⇔";
var LessEqualGreater = "⋚";
var LessFullEqual = "≦";
var LessGreater = "≶";
var LessLess = "⪡";
var LessSlantEqual = "⩽";
var LessTilde = "≲";
var Lfr = "𝔏";
var Ll = "⋘";
var Lleftarrow = "⇚";
var Lmidot = "Ŀ";
var LongLeftArrow = "⟵";
var LongLeftRightArrow = "⟷";
var LongRightArrow = "⟶";
var Longleftarrow = "⟸";
var Longleftrightarrow = "⟺";
var Longrightarrow = "⟹";
var Lopf = "𝕃";
var LowerLeftArrow = "↙";
var LowerRightArrow = "↘";
var Lscr = "ℒ";
var Lsh = "↰";
var Lstrok = "Ł";
var Lt = "≪";
var Mcy = "М";
var MediumSpace = " ";
var Mellintrf = "ℳ";
var Mfr = "𝔐";
var MinusPlus = "∓";
var Mopf = "𝕄";
var Mscr = "ℳ";
var Mu = "Μ";
var NJcy = "Њ";
var Nacute = "Ń";
var Ncaron = "Ň";
var Ncedil = "Ņ";
var Ncy = "Н";
var NegativeMediumSpace = "​";
var NegativeThickSpace = "​";
var NegativeThinSpace = "​";
var NegativeVeryThinSpace = "​";
var NestedGreaterGreater = "≫";
var NestedLessLess = "≪";
var NewLine = "\n";
var Nfr = "𝔑";
var NoBreak = "⁠";
var NonBreakingSpace = " ";
var Nopf = "ℕ";
var Not = "⫬";
var NotCongruent = "≢";
var NotCupCap = "≭";
var NotDoubleVerticalBar = "∦";
var NotElement = "∉";
var NotEqual = "≠";
var NotEqualTilde = "≂̸";
var NotExists = "∄";
var NotGreater = "≯";
var NotGreaterEqual = "≱";
var NotGreaterFullEqual = "≧̸";
var NotGreaterGreater = "≫̸";
var NotGreaterLess = "≹";
var NotGreaterSlantEqual = "⩾̸";
var NotGreaterTilde = "≵";
var NotHumpDownHump = "≎̸";
var NotHumpEqual = "≏̸";
var NotLeftTriangle = "⋪";
var NotLeftTriangleBar = "⧏̸";
var NotLeftTriangleEqual = "⋬";
var NotLess = "≮";
var NotLessEqual = "≰";
var NotLessGreater = "≸";
var NotLessLess = "≪̸";
var NotLessSlantEqual = "⩽̸";
var NotLessTilde = "≴";
var NotNestedGreaterGreater = "⪢̸";
var NotNestedLessLess = "⪡̸";
var NotPrecedes = "⊀";
var NotPrecedesEqual = "⪯̸";
var NotPrecedesSlantEqual = "⋠";
var NotReverseElement = "∌";
var NotRightTriangle = "⋫";
var NotRightTriangleBar = "⧐̸";
var NotRightTriangleEqual = "⋭";
var NotSquareSubset = "⊏̸";
var NotSquareSubsetEqual = "⋢";
var NotSquareSuperset = "⊐̸";
var NotSquareSupersetEqual = "⋣";
var NotSubset = "⊂⃒";
var NotSubsetEqual = "⊈";
var NotSucceeds = "⊁";
var NotSucceedsEqual = "⪰̸";
var NotSucceedsSlantEqual = "⋡";
var NotSucceedsTilde = "≿̸";
var NotSuperset = "⊃⃒";
var NotSupersetEqual = "⊉";
var NotTilde = "≁";
var NotTildeEqual = "≄";
var NotTildeFullEqual = "≇";
var NotTildeTilde = "≉";
var NotVerticalBar = "∤";
var Nscr = "𝒩";
var Ntild = "Ñ";
var Ntilde = "Ñ";
var Nu = "Ν";
var OElig = "Œ";
var Oacut = "Ó";
var Oacute = "Ó";
var Ocir = "Ô";
var Ocirc = "Ô";
var Ocy = "О";
var Odblac = "Ő";
var Ofr = "𝔒";
var Ograv = "Ò";
var Ograve = "Ò";
var Omacr = "Ō";
var Omega = "Ω";
var Omicron = "Ο";
var Oopf = "𝕆";
var OpenCurlyDoubleQuote = "“";
var OpenCurlyQuote = "‘";
var Or = "⩔";
var Oscr = "𝒪";
var Oslas = "Ø";
var Oslash = "Ø";
var Otild = "Õ";
var Otilde = "Õ";
var Otimes = "⨷";
var Oum = "Ö";
var Ouml = "Ö";
var OverBar = "‾";
var OverBrace = "⏞";
var OverBracket = "⎴";
var OverParenthesis = "⏜";
var PartialD = "∂";
var Pcy = "П";
var Pfr = "𝔓";
var Phi = "Φ";
var Pi = "Π";
var PlusMinus = "±";
var Poincareplane = "ℌ";
var Popf = "ℙ";
var Pr = "⪻";
var Precedes = "≺";
var PrecedesEqual = "⪯";
var PrecedesSlantEqual = "≼";
var PrecedesTilde = "≾";
var Prime = "″";
var Product = "∏";
var Proportion = "∷";
var Proportional = "∝";
var Pscr = "𝒫";
var Psi = "Ψ";
var QUO = "\"";
var QUOT = "\"";
var Qfr = "𝔔";
var Qopf = "ℚ";
var Qscr = "𝒬";
var RBarr = "⤐";
var RE = "®";
var REG = "®";
var Racute = "Ŕ";
var Rang = "⟫";
var Rarr = "↠";
var Rarrtl = "⤖";
var Rcaron = "Ř";
var Rcedil = "Ŗ";
var Rcy = "Р";
var Re = "ℜ";
var ReverseElement = "∋";
var ReverseEquilibrium = "⇋";
var ReverseUpEquilibrium = "⥯";
var Rfr = "ℜ";
var Rho = "Ρ";
var RightAngleBracket = "⟩";
var RightArrow = "→";
var RightArrowBar = "⇥";
var RightArrowLeftArrow = "⇄";
var RightCeiling = "⌉";
var RightDoubleBracket = "⟧";
var RightDownTeeVector = "⥝";
var RightDownVector = "⇂";
var RightDownVectorBar = "⥕";
var RightFloor = "⌋";
var RightTee = "⊢";
var RightTeeArrow = "↦";
var RightTeeVector = "⥛";
var RightTriangle = "⊳";
var RightTriangleBar = "⧐";
var RightTriangleEqual = "⊵";
var RightUpDownVector = "⥏";
var RightUpTeeVector = "⥜";
var RightUpVector = "↾";
var RightUpVectorBar = "⥔";
var RightVector = "⇀";
var RightVectorBar = "⥓";
var Rightarrow = "⇒";
var Ropf = "ℝ";
var RoundImplies = "⥰";
var Rrightarrow = "⇛";
var Rscr = "ℛ";
var Rsh = "↱";
var RuleDelayed = "⧴";
var SHCHcy = "Щ";
var SHcy = "Ш";
var SOFTcy = "Ь";
var Sacute = "Ś";
var Sc = "⪼";
var Scaron = "Š";
var Scedil = "Ş";
var Scirc = "Ŝ";
var Scy = "С";
var Sfr = "𝔖";
var ShortDownArrow = "↓";
var ShortLeftArrow = "←";
var ShortRightArrow = "→";
var ShortUpArrow = "↑";
var Sigma = "Σ";
var SmallCircle = "∘";
var Sopf = "𝕊";
var Sqrt = "√";
var Square = "□";
var SquareIntersection = "⊓";
var SquareSubset = "⊏";
var SquareSubsetEqual = "⊑";
var SquareSuperset = "⊐";
var SquareSupersetEqual = "⊒";
var SquareUnion = "⊔";
var Sscr = "𝒮";
var Star = "⋆";
var Sub = "⋐";
var Subset = "⋐";
var SubsetEqual = "⊆";
var Succeeds = "≻";
var SucceedsEqual = "⪰";
var SucceedsSlantEqual = "≽";
var SucceedsTilde = "≿";
var SuchThat = "∋";
var Sum = "∑";
var Sup = "⋑";
var Superset = "⊃";
var SupersetEqual = "⊇";
var Supset = "⋑";
var THOR = "Þ";
var THORN = "Þ";
var TRADE = "™";
var TSHcy = "Ћ";
var TScy = "Ц";
var Tab = "\t";
var Tau = "Τ";
var Tcaron = "Ť";
var Tcedil = "Ţ";
var Tcy = "Т";
var Tfr = "𝔗";
var Therefore = "∴";
var Theta = "Θ";
var ThickSpace = "  ";
var ThinSpace = " ";
var Tilde = "∼";
var TildeEqual = "≃";
var TildeFullEqual = "≅";
var TildeTilde = "≈";
var Topf = "𝕋";
var TripleDot = "⃛";
var Tscr = "𝒯";
var Tstrok = "Ŧ";
var Uacut = "Ú";
var Uacute = "Ú";
var Uarr = "↟";
var Uarrocir = "⥉";
var Ubrcy = "Ў";
var Ubreve = "Ŭ";
var Ucir = "Û";
var Ucirc = "Û";
var Ucy = "У";
var Udblac = "Ű";
var Ufr = "𝔘";
var Ugrav = "Ù";
var Ugrave = "Ù";
var Umacr = "Ū";
var UnderBar = "_";
var UnderBrace = "⏟";
var UnderBracket = "⎵";
var UnderParenthesis = "⏝";
var Union = "⋃";
var UnionPlus = "⊎";
var Uogon = "Ų";
var Uopf = "𝕌";
var UpArrow = "↑";
var UpArrowBar = "⤒";
var UpArrowDownArrow = "⇅";
var UpDownArrow = "↕";
var UpEquilibrium = "⥮";
var UpTee = "⊥";
var UpTeeArrow = "↥";
var Uparrow = "⇑";
var Updownarrow = "⇕";
var UpperLeftArrow = "↖";
var UpperRightArrow = "↗";
var Upsi = "ϒ";
var Upsilon = "Υ";
var Uring = "Ů";
var Uscr = "𝒰";
var Utilde = "Ũ";
var Uum = "Ü";
var Uuml = "Ü";
var VDash = "⊫";
var Vbar = "⫫";
var Vcy = "В";
var Vdash = "⊩";
var Vdashl = "⫦";
var Vee = "⋁";
var Verbar = "‖";
var Vert = "‖";
var VerticalBar = "∣";
var VerticalLine = "|";
var VerticalSeparator = "❘";
var VerticalTilde = "≀";
var VeryThinSpace = " ";
var Vfr = "𝔙";
var Vopf = "𝕍";
var Vscr = "𝒱";
var Vvdash = "⊪";
var Wcirc = "Ŵ";
var Wedge = "⋀";
var Wfr = "𝔚";
var Wopf = "𝕎";
var Wscr = "𝒲";
var Xfr = "𝔛";
var Xi = "Ξ";
var Xopf = "𝕏";
var Xscr = "𝒳";
var YAcy = "Я";
var YIcy = "Ї";
var YUcy = "Ю";
var Yacut = "Ý";
var Yacute = "Ý";
var Ycirc = "Ŷ";
var Ycy = "Ы";
var Yfr = "𝔜";
var Yopf = "𝕐";
var Yscr = "𝒴";
var Yuml = "Ÿ";
var ZHcy = "Ж";
var Zacute = "Ź";
var Zcaron = "Ž";
var Zcy = "З";
var Zdot = "Ż";
var ZeroWidthSpace = "​";
var Zeta = "Ζ";
var Zfr = "ℨ";
var Zopf = "ℤ";
var Zscr = "𝒵";
var aacut = "á";
var aacute = "á";
var abreve = "ă";
var ac = "∾";
var acE = "∾̳";
var acd = "∿";
var acir = "â";
var acirc = "â";
var acut = "´";
var acute = "´";
var acy = "а";
var aeli = "æ";
var aelig = "æ";
var af = "⁡";
var afr = "𝔞";
var agrav = "à";
var agrave = "à";
var alefsym = "ℵ";
var aleph = "ℵ";
var alpha = "α";
var amacr = "ā";
var amalg = "⨿";
var am = "&";
var amp = "&";
var and = "∧";
var andand = "⩕";
var andd = "⩜";
var andslope = "⩘";
var andv = "⩚";
var ang = "∠";
var ange = "⦤";
var angle = "∠";
var angmsd = "∡";
var angmsdaa = "⦨";
var angmsdab = "⦩";
var angmsdac = "⦪";
var angmsdad = "⦫";
var angmsdae = "⦬";
var angmsdaf = "⦭";
var angmsdag = "⦮";
var angmsdah = "⦯";
var angrt = "∟";
var angrtvb = "⊾";
var angrtvbd = "⦝";
var angsph = "∢";
var angst = "Å";
var angzarr = "⍼";
var aogon = "ą";
var aopf = "𝕒";
var ap = "≈";
var apE = "⩰";
var apacir = "⩯";
var ape = "≊";
var apid = "≋";
var apos = "'";
var approx = "≈";
var approxeq = "≊";
var arin = "å";
var aring = "å";
var ascr = "𝒶";
var ast = "*";
var asymp = "≈";
var asympeq = "≍";
var atild = "ã";
var atilde = "ã";
var aum = "ä";
var auml = "ä";
var awconint = "∳";
var awint = "⨑";
var bNot = "⫭";
var backcong = "≌";
var backepsilon = "϶";
var backprime = "‵";
var backsim = "∽";
var backsimeq = "⋍";
var barvee = "⊽";
var barwed = "⌅";
var barwedge = "⌅";
var bbrk = "⎵";
var bbrktbrk = "⎶";
var bcong = "≌";
var bcy = "б";
var bdquo = "„";
var becaus = "∵";
var because = "∵";
var bemptyv = "⦰";
var bepsi = "϶";
var bernou = "ℬ";
var beta = "β";
var beth = "ℶ";
var between = "≬";
var bfr = "𝔟";
var bigcap = "⋂";
var bigcirc = "◯";
var bigcup = "⋃";
var bigodot = "⨀";
var bigoplus = "⨁";
var bigotimes = "⨂";
var bigsqcup = "⨆";
var bigstar = "★";
var bigtriangledown = "▽";
var bigtriangleup = "△";
var biguplus = "⨄";
var bigvee = "⋁";
var bigwedge = "⋀";
var bkarow = "⤍";
var blacklozenge = "⧫";
var blacksquare = "▪";
var blacktriangle = "▴";
var blacktriangledown = "▾";
var blacktriangleleft = "◂";
var blacktriangleright = "▸";
var blank = "␣";
var blk12 = "▒";
var blk14 = "░";
var blk34 = "▓";
var block = "█";
var bne = "=⃥";
var bnequiv = "≡⃥";
var bnot = "⌐";
var bopf = "𝕓";
var bot = "⊥";
var bottom = "⊥";
var bowtie = "⋈";
var boxDL = "╗";
var boxDR = "╔";
var boxDl = "╖";
var boxDr = "╓";
var boxH = "═";
var boxHD = "╦";
var boxHU = "╩";
var boxHd = "╤";
var boxHu = "╧";
var boxUL = "╝";
var boxUR = "╚";
var boxUl = "╜";
var boxUr = "╙";
var boxV = "║";
var boxVH = "╬";
var boxVL = "╣";
var boxVR = "╠";
var boxVh = "╫";
var boxVl = "╢";
var boxVr = "╟";
var boxbox = "⧉";
var boxdL = "╕";
var boxdR = "╒";
var boxdl = "┐";
var boxdr = "┌";
var boxh = "─";
var boxhD = "╥";
var boxhU = "╨";
var boxhd = "┬";
var boxhu = "┴";
var boxminus = "⊟";
var boxplus = "⊞";
var boxtimes = "⊠";
var boxuL = "╛";
var boxuR = "╘";
var boxul = "┘";
var boxur = "└";
var boxv = "│";
var boxvH = "╪";
var boxvL = "╡";
var boxvR = "╞";
var boxvh = "┼";
var boxvl = "┤";
var boxvr = "├";
var bprime = "‵";
var breve = "˘";
var brvba = "¦";
var brvbar = "¦";
var bscr = "𝒷";
var bsemi = "⁏";
var bsim = "∽";
var bsime = "⋍";
var bsol = "\\";
var bsolb = "⧅";
var bsolhsub = "⟈";
var bull = "•";
var bullet = "•";
var bump = "≎";
var bumpE = "⪮";
var bumpe = "≏";
var bumpeq = "≏";
var cacute = "ć";
var cap$1 = "∩";
var capand = "⩄";
var capbrcup = "⩉";
var capcap = "⩋";
var capcup = "⩇";
var capdot = "⩀";
var caps = "∩︀";
var caret = "⁁";
var caron = "ˇ";
var ccaps = "⩍";
var ccaron = "č";
var ccedi = "ç";
var ccedil = "ç";
var ccirc = "ĉ";
var ccups = "⩌";
var ccupssm = "⩐";
var cdot = "ċ";
var cedi = "¸";
var cedil = "¸";
var cemptyv = "⦲";
var cen = "¢";
var cent = "¢";
var centerdot = "·";
var cfr = "𝔠";
var chcy = "ч";
var check = "✓";
var checkmark = "✓";
var chi = "χ";
var cir = "○";
var cirE = "⧃";
var circ = "ˆ";
var circeq = "≗";
var circlearrowleft = "↺";
var circlearrowright = "↻";
var circledR = "®";
var circledS = "Ⓢ";
var circledast = "⊛";
var circledcirc = "⊚";
var circleddash = "⊝";
var cire = "≗";
var cirfnint = "⨐";
var cirmid = "⫯";
var cirscir = "⧂";
var clubs = "♣";
var clubsuit = "♣";
var colon$1 = ":";
var colone = "≔";
var coloneq = "≔";
var comma$1 = ",";
var commat = "@";
var comp = "∁";
var compfn = "∘";
var complement = "∁";
var complexes = "ℂ";
var cong = "≅";
var congdot = "⩭";
var conint = "∮";
var copf = "𝕔";
var coprod = "∐";
var cop = "©";
var copy = "©";
var copysr = "℗";
var crarr = "↵";
var cross = "✗";
var cscr = "𝒸";
var csub = "⫏";
var csube = "⫑";
var csup = "⫐";
var csupe = "⫒";
var ctdot = "⋯";
var cudarrl = "⤸";
var cudarrr = "⤵";
var cuepr = "⋞";
var cuesc = "⋟";
var cularr = "↶";
var cularrp = "⤽";
var cup = "∪";
var cupbrcap = "⩈";
var cupcap = "⩆";
var cupcup = "⩊";
var cupdot = "⊍";
var cupor = "⩅";
var cups = "∪︀";
var curarr = "↷";
var curarrm = "⤼";
var curlyeqprec = "⋞";
var curlyeqsucc = "⋟";
var curlyvee = "⋎";
var curlywedge = "⋏";
var curre = "¤";
var curren = "¤";
var curvearrowleft = "↶";
var curvearrowright = "↷";
var cuvee = "⋎";
var cuwed = "⋏";
var cwconint = "∲";
var cwint = "∱";
var cylcty = "⌭";
var dArr = "⇓";
var dHar = "⥥";
var dagger = "†";
var daleth = "ℸ";
var darr = "↓";
var dash$2 = "‐";
var dashv = "⊣";
var dbkarow = "⤏";
var dblac = "˝";
var dcaron = "ď";
var dcy = "д";
var dd = "ⅆ";
var ddagger = "‡";
var ddarr = "⇊";
var ddotseq = "⩷";
var de = "°";
var deg = "°";
var delta = "δ";
var demptyv = "⦱";
var dfisht = "⥿";
var dfr = "𝔡";
var dharl = "⇃";
var dharr = "⇂";
var diam = "⋄";
var diamond = "⋄";
var diamondsuit = "♦";
var diams = "♦";
var die = "¨";
var digamma = "ϝ";
var disin = "⋲";
var div = "÷";
var divid = "÷";
var divide = "÷";
var divideontimes = "⋇";
var divonx = "⋇";
var djcy = "ђ";
var dlcorn = "⌞";
var dlcrop = "⌍";
var dollar = "$";
var dopf = "𝕕";
var dot = "˙";
var doteq = "≐";
var doteqdot = "≑";
var dotminus = "∸";
var dotplus = "∔";
var dotsquare = "⊡";
var doublebarwedge = "⌆";
var downarrow = "↓";
var downdownarrows = "⇊";
var downharpoonleft = "⇃";
var downharpoonright = "⇂";
var drbkarow = "⤐";
var drcorn = "⌟";
var drcrop = "⌌";
var dscr = "𝒹";
var dscy = "ѕ";
var dsol = "⧶";
var dstrok = "đ";
var dtdot = "⋱";
var dtri = "▿";
var dtrif = "▾";
var duarr = "⇵";
var duhar = "⥯";
var dwangle = "⦦";
var dzcy = "џ";
var dzigrarr = "⟿";
var eDDot = "⩷";
var eDot = "≑";
var eacut = "é";
var eacute = "é";
var easter = "⩮";
var ecaron = "ě";
var ecir = "ê";
var ecirc = "ê";
var ecolon = "≕";
var ecy = "э";
var edot = "ė";
var ee = "ⅇ";
var efDot = "≒";
var efr = "𝔢";
var eg = "⪚";
var egrav = "è";
var egrave = "è";
var egs = "⪖";
var egsdot = "⪘";
var el = "⪙";
var elinters = "⏧";
var ell = "ℓ";
var els = "⪕";
var elsdot = "⪗";
var emacr = "ē";
var empty$2 = "∅";
var emptyset = "∅";
var emptyv = "∅";
var emsp13 = " ";
var emsp14 = " ";
var emsp = " ";
var eng = "ŋ";
var ensp = " ";
var eogon = "ę";
var eopf = "𝕖";
var epar = "⋕";
var eparsl = "⧣";
var eplus = "⩱";
var epsi = "ε";
var epsilon = "ε";
var epsiv = "ϵ";
var eqcirc = "≖";
var eqcolon = "≕";
var eqsim = "≂";
var eqslantgtr = "⪖";
var eqslantless = "⪕";
var equals = "=";
var equest = "≟";
var equiv = "≡";
var equivDD = "⩸";
var eqvparsl = "⧥";
var erDot = "≓";
var erarr = "⥱";
var escr = "ℯ";
var esdot = "≐";
var esim = "≂";
var eta = "η";
var et = "ð";
var eth = "ð";
var eum = "ë";
var euml = "ë";
var euro = "€";
var excl = "!";
var exist = "∃";
var expectation = "ℰ";
var exponentiale = "ⅇ";
var fallingdotseq = "≒";
var fcy = "ф";
var female = "♀";
var ffilig = "ﬃ";
var fflig = "ﬀ";
var ffllig = "ﬄ";
var ffr = "𝔣";
var filig = "ﬁ";
var fjlig = "fj";
var flat = "♭";
var fllig = "ﬂ";
var fltns = "▱";
var fnof = "ƒ";
var fopf = "𝕗";
var forall = "∀";
var fork = "⋔";
var forkv = "⫙";
var fpartint = "⨍";
var frac1 = "¼";
var frac12 = "½";
var frac13 = "⅓";
var frac14 = "¼";
var frac15 = "⅕";
var frac16 = "⅙";
var frac18 = "⅛";
var frac23 = "⅔";
var frac25 = "⅖";
var frac3 = "¾";
var frac34 = "¾";
var frac35 = "⅗";
var frac38 = "⅜";
var frac45 = "⅘";
var frac56 = "⅚";
var frac58 = "⅝";
var frac78 = "⅞";
var frasl = "⁄";
var frown = "⌢";
var fscr = "𝒻";
var gE = "≧";
var gEl = "⪌";
var gacute = "ǵ";
var gamma = "γ";
var gammad = "ϝ";
var gap = "⪆";
var gbreve = "ğ";
var gcirc = "ĝ";
var gcy = "г";
var gdot = "ġ";
var ge = "≥";
var gel = "⋛";
var geq = "≥";
var geqq = "≧";
var geqslant = "⩾";
var ges = "⩾";
var gescc = "⪩";
var gesdot = "⪀";
var gesdoto = "⪂";
var gesdotol = "⪄";
var gesl = "⋛︀";
var gesles = "⪔";
var gfr = "𝔤";
var gg = "≫";
var ggg = "⋙";
var gimel = "ℷ";
var gjcy = "ѓ";
var gl = "≷";
var glE = "⪒";
var gla = "⪥";
var glj = "⪤";
var gnE = "≩";
var gnap = "⪊";
var gnapprox = "⪊";
var gne = "⪈";
var gneq = "⪈";
var gneqq = "≩";
var gnsim = "⋧";
var gopf = "𝕘";
var grave = "`";
var gscr = "ℊ";
var gsim = "≳";
var gsime = "⪎";
var gsiml = "⪐";
var g = ">";
var gt = ">";
var gtcc = "⪧";
var gtcir = "⩺";
var gtdot = "⋗";
var gtlPar = "⦕";
var gtquest = "⩼";
var gtrapprox = "⪆";
var gtrarr = "⥸";
var gtrdot = "⋗";
var gtreqless = "⋛";
var gtreqqless = "⪌";
var gtrless = "≷";
var gtrsim = "≳";
var gvertneqq = "≩︀";
var gvnE = "≩︀";
var hArr = "⇔";
var hairsp = " ";
var half = "½";
var hamilt = "ℋ";
var hardcy = "ъ";
var harr = "↔";
var harrcir = "⥈";
var harrw = "↭";
var hbar = "ℏ";
var hcirc = "ĥ";
var hearts = "♥";
var heartsuit = "♥";
var hellip = "…";
var hercon = "⊹";
var hfr = "𝔥";
var hksearow = "⤥";
var hkswarow = "⤦";
var hoarr = "⇿";
var homtht = "∻";
var hookleftarrow = "↩";
var hookrightarrow = "↪";
var hopf = "𝕙";
var horbar = "―";
var hscr = "𝒽";
var hslash = "ℏ";
var hstrok = "ħ";
var hybull = "⁃";
var hyphen = "‐";
var iacut = "í";
var iacute = "í";
var ic = "⁣";
var icir = "î";
var icirc = "î";
var icy = "и";
var iecy = "е";
var iexc = "¡";
var iexcl = "¡";
var iff = "⇔";
var ifr = "𝔦";
var igrav = "ì";
var igrave = "ì";
var ii = "ⅈ";
var iiiint = "⨌";
var iiint = "∭";
var iinfin = "⧜";
var iiota = "℩";
var ijlig = "ĳ";
var imacr = "ī";
var image$1 = "ℑ";
var imagline = "ℐ";
var imagpart = "ℑ";
var imath = "ı";
var imof = "⊷";
var imped = "Ƶ";
var incare = "℅";
var infin = "∞";
var infintie = "⧝";
var inodot = "ı";
var int = "∫";
var intcal = "⊺";
var integers = "ℤ";
var intercal = "⊺";
var intlarhk = "⨗";
var intprod = "⨼";
var iocy = "ё";
var iogon = "į";
var iopf = "𝕚";
var iota = "ι";
var iprod = "⨼";
var iques = "¿";
var iquest = "¿";
var iscr = "𝒾";
var isin = "∈";
var isinE = "⋹";
var isindot = "⋵";
var isins = "⋴";
var isinsv = "⋳";
var isinv = "∈";
var it = "⁢";
var itilde = "ĩ";
var iukcy = "і";
var ium = "ï";
var iuml = "ï";
var jcirc = "ĵ";
var jcy = "й";
var jfr = "𝔧";
var jmath = "ȷ";
var jopf = "𝕛";
var jscr = "𝒿";
var jsercy = "ј";
var jukcy = "є";
var kappa = "κ";
var kappav = "ϰ";
var kcedil = "ķ";
var kcy = "к";
var kfr = "𝔨";
var kgreen = "ĸ";
var khcy = "х";
var kjcy = "ќ";
var kopf = "𝕜";
var kscr = "𝓀";
var lAarr = "⇚";
var lArr = "⇐";
var lAtail = "⤛";
var lBarr = "⤎";
var lE = "≦";
var lEg = "⪋";
var lHar = "⥢";
var lacute = "ĺ";
var laemptyv = "⦴";
var lagran = "ℒ";
var lambda = "λ";
var lang = "⟨";
var langd = "⦑";
var langle = "⟨";
var lap = "⪅";
var laqu = "«";
var laquo = "«";
var larr = "←";
var larrb = "⇤";
var larrbfs = "⤟";
var larrfs = "⤝";
var larrhk = "↩";
var larrlp = "↫";
var larrpl = "⤹";
var larrsim = "⥳";
var larrtl = "↢";
var lat = "⪫";
var latail = "⤙";
var late = "⪭";
var lates = "⪭︀";
var lbarr = "⤌";
var lbbrk = "❲";
var lbrace = "{";
var lbrack = "[";
var lbrke = "⦋";
var lbrksld = "⦏";
var lbrkslu = "⦍";
var lcaron = "ľ";
var lcedil = "ļ";
var lceil = "⌈";
var lcub = "{";
var lcy = "л";
var ldca = "⤶";
var ldquo = "“";
var ldquor = "„";
var ldrdhar = "⥧";
var ldrushar = "⥋";
var ldsh = "↲";
var le = "≤";
var leftarrow = "←";
var leftarrowtail = "↢";
var leftharpoondown = "↽";
var leftharpoonup = "↼";
var leftleftarrows = "⇇";
var leftrightarrow = "↔";
var leftrightarrows = "⇆";
var leftrightharpoons = "⇋";
var leftrightsquigarrow = "↭";
var leftthreetimes = "⋋";
var leg = "⋚";
var leq = "≤";
var leqq = "≦";
var leqslant = "⩽";
var les = "⩽";
var lescc = "⪨";
var lesdot = "⩿";
var lesdoto = "⪁";
var lesdotor = "⪃";
var lesg = "⋚︀";
var lesges = "⪓";
var lessapprox = "⪅";
var lessdot = "⋖";
var lesseqgtr = "⋚";
var lesseqqgtr = "⪋";
var lessgtr = "≶";
var lesssim = "≲";
var lfisht = "⥼";
var lfloor = "⌊";
var lfr = "𝔩";
var lg = "≶";
var lgE = "⪑";
var lhard = "↽";
var lharu = "↼";
var lharul = "⥪";
var lhblk = "▄";
var ljcy = "љ";
var ll = "≪";
var llarr = "⇇";
var llcorner = "⌞";
var llhard = "⥫";
var lltri = "◺";
var lmidot = "ŀ";
var lmoust = "⎰";
var lmoustache = "⎰";
var lnE = "≨";
var lnap = "⪉";
var lnapprox = "⪉";
var lne = "⪇";
var lneq = "⪇";
var lneqq = "≨";
var lnsim = "⋦";
var loang = "⟬";
var loarr = "⇽";
var lobrk = "⟦";
var longleftarrow = "⟵";
var longleftrightarrow = "⟷";
var longmapsto = "⟼";
var longrightarrow = "⟶";
var looparrowleft = "↫";
var looparrowright = "↬";
var lopar = "⦅";
var lopf = "𝕝";
var loplus = "⨭";
var lotimes = "⨴";
var lowast = "∗";
var lowbar = "_";
var loz = "◊";
var lozenge = "◊";
var lozf = "⧫";
var lpar = "(";
var lparlt = "⦓";
var lrarr = "⇆";
var lrcorner = "⌟";
var lrhar = "⇋";
var lrhard = "⥭";
var lrm = "‎";
var lrtri = "⊿";
var lsaquo = "‹";
var lscr = "𝓁";
var lsh = "↰";
var lsim = "≲";
var lsime = "⪍";
var lsimg = "⪏";
var lsqb = "[";
var lsquo = "‘";
var lsquor = "‚";
var lstrok = "ł";
var l$1 = "<";
var lt = "<";
var ltcc = "⪦";
var ltcir = "⩹";
var ltdot = "⋖";
var lthree = "⋋";
var ltimes = "⋉";
var ltlarr = "⥶";
var ltquest = "⩻";
var ltrPar = "⦖";
var ltri = "◃";
var ltrie = "⊴";
var ltrif = "◂";
var lurdshar = "⥊";
var luruhar = "⥦";
var lvertneqq = "≨︀";
var lvnE = "≨︀";
var mDDot = "∺";
var mac = "¯";
var macr = "¯";
var male = "♂";
var malt = "✠";
var maltese = "✠";
var map$3 = "↦";
var mapsto = "↦";
var mapstodown = "↧";
var mapstoleft = "↤";
var mapstoup = "↥";
var marker = "▮";
var mcomma = "⨩";
var mcy = "м";
var mdash = "—";
var measuredangle = "∡";
var mfr = "𝔪";
var mho = "℧";
var micr = "µ";
var micro = "µ";
var mid = "∣";
var midast = "*";
var midcir = "⫰";
var middo = "·";
var middot = "·";
var minus = "−";
var minusb = "⊟";
var minusd = "∸";
var minusdu = "⨪";
var mlcp = "⫛";
var mldr = "…";
var mnplus = "∓";
var models = "⊧";
var mopf = "𝕞";
var mp = "∓";
var mscr = "𝓂";
var mstpos = "∾";
var mu = "μ";
var multimap = "⊸";
var mumap = "⊸";
var nGg = "⋙̸";
var nGt = "≫⃒";
var nGtv = "≫̸";
var nLeftarrow = "⇍";
var nLeftrightarrow = "⇎";
var nLl = "⋘̸";
var nLt = "≪⃒";
var nLtv = "≪̸";
var nRightarrow = "⇏";
var nVDash = "⊯";
var nVdash = "⊮";
var nabla = "∇";
var nacute = "ń";
var nang = "∠⃒";
var nap = "≉";
var napE = "⩰̸";
var napid = "≋̸";
var napos = "ŉ";
var napprox = "≉";
var natur = "♮";
var natural = "♮";
var naturals = "ℕ";
var nbs = " ";
var nbsp = " ";
var nbump = "≎̸";
var nbumpe = "≏̸";
var ncap = "⩃";
var ncaron = "ň";
var ncedil = "ņ";
var ncong = "≇";
var ncongdot = "⩭̸";
var ncup = "⩂";
var ncy = "н";
var ndash = "–";
var ne = "≠";
var neArr = "⇗";
var nearhk = "⤤";
var nearr = "↗";
var nearrow = "↗";
var nedot = "≐̸";
var nequiv = "≢";
var nesear = "⤨";
var nesim = "≂̸";
var nexist = "∄";
var nexists = "∄";
var nfr = "𝔫";
var ngE = "≧̸";
var nge = "≱";
var ngeq = "≱";
var ngeqq = "≧̸";
var ngeqslant = "⩾̸";
var nges = "⩾̸";
var ngsim = "≵";
var ngt = "≯";
var ngtr = "≯";
var nhArr = "⇎";
var nharr = "↮";
var nhpar = "⫲";
var ni = "∋";
var nis = "⋼";
var nisd = "⋺";
var niv = "∋";
var njcy = "њ";
var nlArr = "⇍";
var nlE = "≦̸";
var nlarr = "↚";
var nldr = "‥";
var nle = "≰";
var nleftarrow = "↚";
var nleftrightarrow = "↮";
var nleq = "≰";
var nleqq = "≦̸";
var nleqslant = "⩽̸";
var nles = "⩽̸";
var nless = "≮";
var nlsim = "≴";
var nlt = "≮";
var nltri = "⋪";
var nltrie = "⋬";
var nmid = "∤";
var nopf = "𝕟";
var no = "¬";
var not = "¬";
var notin = "∉";
var notinE = "⋹̸";
var notindot = "⋵̸";
var notinva = "∉";
var notinvb = "⋷";
var notinvc = "⋶";
var notni = "∌";
var notniva = "∌";
var notnivb = "⋾";
var notnivc = "⋽";
var npar = "∦";
var nparallel = "∦";
var nparsl = "⫽⃥";
var npart = "∂̸";
var npolint = "⨔";
var npr = "⊀";
var nprcue = "⋠";
var npre = "⪯̸";
var nprec = "⊀";
var npreceq = "⪯̸";
var nrArr = "⇏";
var nrarr = "↛";
var nrarrc = "⤳̸";
var nrarrw = "↝̸";
var nrightarrow = "↛";
var nrtri = "⋫";
var nrtrie = "⋭";
var nsc = "⊁";
var nsccue = "⋡";
var nsce = "⪰̸";
var nscr = "𝓃";
var nshortmid = "∤";
var nshortparallel = "∦";
var nsim = "≁";
var nsime = "≄";
var nsimeq = "≄";
var nsmid = "∤";
var nspar = "∦";
var nsqsube = "⋢";
var nsqsupe = "⋣";
var nsub = "⊄";
var nsubE = "⫅̸";
var nsube = "⊈";
var nsubset = "⊂⃒";
var nsubseteq = "⊈";
var nsubseteqq = "⫅̸";
var nsucc = "⊁";
var nsucceq = "⪰̸";
var nsup = "⊅";
var nsupE = "⫆̸";
var nsupe = "⊉";
var nsupset = "⊃⃒";
var nsupseteq = "⊉";
var nsupseteqq = "⫆̸";
var ntgl = "≹";
var ntild = "ñ";
var ntilde = "ñ";
var ntlg = "≸";
var ntriangleleft = "⋪";
var ntrianglelefteq = "⋬";
var ntriangleright = "⋫";
var ntrianglerighteq = "⋭";
var nu = "ν";
var num = "#";
var numero = "№";
var numsp = " ";
var nvDash = "⊭";
var nvHarr = "⤄";
var nvap = "≍⃒";
var nvdash = "⊬";
var nvge = "≥⃒";
var nvgt = ">⃒";
var nvinfin = "⧞";
var nvlArr = "⤂";
var nvle = "≤⃒";
var nvlt = "<⃒";
var nvltrie = "⊴⃒";
var nvrArr = "⤃";
var nvrtrie = "⊵⃒";
var nvsim = "∼⃒";
var nwArr = "⇖";
var nwarhk = "⤣";
var nwarr = "↖";
var nwarrow = "↖";
var nwnear = "⤧";
var oS = "Ⓢ";
var oacut = "ó";
var oacute = "ó";
var oast = "⊛";
var ocir = "ô";
var ocirc = "ô";
var ocy = "о";
var odash = "⊝";
var odblac = "ő";
var odiv = "⨸";
var odot = "⊙";
var odsold = "⦼";
var oelig = "œ";
var ofcir = "⦿";
var ofr = "𝔬";
var ogon = "˛";
var ograv = "ò";
var ograve = "ò";
var ogt = "⧁";
var ohbar = "⦵";
var ohm = "Ω";
var oint = "∮";
var olarr = "↺";
var olcir = "⦾";
var olcross = "⦻";
var oline = "‾";
var olt = "⧀";
var omacr = "ō";
var omega = "ω";
var omicron = "ο";
var omid = "⦶";
var ominus = "⊖";
var oopf = "𝕠";
var opar = "⦷";
var operp = "⦹";
var oplus = "⊕";
var or = "∨";
var orarr = "↻";
var ord = "º";
var order = "ℴ";
var orderof = "ℴ";
var ordf = "ª";
var ordm = "º";
var origof = "⊶";
var oror = "⩖";
var orslope = "⩗";
var orv = "⩛";
var oscr = "ℴ";
var oslas = "ø";
var oslash = "ø";
var osol = "⊘";
var otild = "õ";
var otilde = "õ";
var otimes = "⊗";
var otimesas = "⨶";
var oum = "ö";
var ouml = "ö";
var ovbar = "⌽";
var par = "¶";
var para = "¶";
var parallel = "∥";
var parsim = "⫳";
var parsl = "⫽";
var part = "∂";
var pcy = "п";
var percnt = "%";
var period = ".";
var permil = "‰";
var perp = "⊥";
var pertenk = "‱";
var pfr = "𝔭";
var phi = "φ";
var phiv = "ϕ";
var phmmat = "ℳ";
var phone = "☎";
var pi = "π";
var pitchfork = "⋔";
var piv = "ϖ";
var planck = "ℏ";
var planckh = "ℎ";
var plankv = "ℏ";
var plus = "+";
var plusacir = "⨣";
var plusb = "⊞";
var pluscir = "⨢";
var plusdo = "∔";
var plusdu = "⨥";
var pluse = "⩲";
var plusm = "±";
var plusmn = "±";
var plussim = "⨦";
var plustwo = "⨧";
var pm = "±";
var pointint = "⨕";
var popf = "𝕡";
var poun = "£";
var pound = "£";
var pr = "≺";
var prE = "⪳";
var prap = "⪷";
var prcue = "≼";
var pre = "⪯";
var prec = "≺";
var precapprox = "⪷";
var preccurlyeq = "≼";
var preceq = "⪯";
var precnapprox = "⪹";
var precneqq = "⪵";
var precnsim = "⋨";
var precsim = "≾";
var prime = "′";
var primes = "ℙ";
var prnE = "⪵";
var prnap = "⪹";
var prnsim = "⋨";
var prod = "∏";
var profalar = "⌮";
var profline = "⌒";
var profsurf = "⌓";
var prop = "∝";
var propto = "∝";
var prsim = "≾";
var prurel = "⊰";
var pscr = "𝓅";
var psi = "ψ";
var puncsp = " ";
var qfr = "𝔮";
var qint = "⨌";
var qopf = "𝕢";
var qprime = "⁗";
var qscr = "𝓆";
var quaternions = "ℍ";
var quatint = "⨖";
var quest = "?";
var questeq = "≟";
var quo = "\"";
var quot = "\"";
var rAarr = "⇛";
var rArr = "⇒";
var rAtail = "⤜";
var rBarr = "⤏";
var rHar = "⥤";
var race = "∽̱";
var racute = "ŕ";
var radic = "√";
var raemptyv = "⦳";
var rang = "⟩";
var rangd = "⦒";
var range = "⦥";
var rangle = "⟩";
var raqu = "»";
var raquo = "»";
var rarr = "→";
var rarrap = "⥵";
var rarrb = "⇥";
var rarrbfs = "⤠";
var rarrc = "⤳";
var rarrfs = "⤞";
var rarrhk = "↪";
var rarrlp = "↬";
var rarrpl = "⥅";
var rarrsim = "⥴";
var rarrtl = "↣";
var rarrw = "↝";
var ratail = "⤚";
var ratio = "∶";
var rationals = "ℚ";
var rbarr = "⤍";
var rbbrk = "❳";
var rbrace = "}";
var rbrack = "]";
var rbrke = "⦌";
var rbrksld = "⦎";
var rbrkslu = "⦐";
var rcaron = "ř";
var rcedil = "ŗ";
var rceil = "⌉";
var rcub = "}";
var rcy = "р";
var rdca = "⤷";
var rdldhar = "⥩";
var rdquo = "”";
var rdquor = "”";
var rdsh = "↳";
var real = "ℜ";
var realine = "ℛ";
var realpart = "ℜ";
var reals = "ℝ";
var rect = "▭";
var re = "®";
var reg = "®";
var rfisht = "⥽";
var rfloor = "⌋";
var rfr = "𝔯";
var rhard = "⇁";
var rharu = "⇀";
var rharul = "⥬";
var rho = "ρ";
var rhov = "ϱ";
var rightarrow = "→";
var rightarrowtail = "↣";
var rightharpoondown = "⇁";
var rightharpoonup = "⇀";
var rightleftarrows = "⇄";
var rightleftharpoons = "⇌";
var rightrightarrows = "⇉";
var rightsquigarrow = "↝";
var rightthreetimes = "⋌";
var ring = "˚";
var risingdotseq = "≓";
var rlarr = "⇄";
var rlhar = "⇌";
var rlm = "‏";
var rmoust = "⎱";
var rmoustache = "⎱";
var rnmid = "⫮";
var roang = "⟭";
var roarr = "⇾";
var robrk = "⟧";
var ropar = "⦆";
var ropf = "𝕣";
var roplus = "⨮";
var rotimes = "⨵";
var rpar = ")";
var rpargt = "⦔";
var rppolint = "⨒";
var rrarr = "⇉";
var rsaquo = "›";
var rscr = "𝓇";
var rsh = "↱";
var rsqb = "]";
var rsquo = "’";
var rsquor = "’";
var rthree = "⋌";
var rtimes = "⋊";
var rtri = "▹";
var rtrie = "⊵";
var rtrif = "▸";
var rtriltri = "⧎";
var ruluhar = "⥨";
var rx = "℞";
var sacute = "ś";
var sbquo = "‚";
var sc = "≻";
var scE = "⪴";
var scap = "⪸";
var scaron = "š";
var sccue = "≽";
var sce = "⪰";
var scedil = "ş";
var scirc = "ŝ";
var scnE = "⪶";
var scnap = "⪺";
var scnsim = "⋩";
var scpolint = "⨓";
var scsim = "≿";
var scy = "с";
var sdot = "⋅";
var sdotb = "⊡";
var sdote = "⩦";
var seArr = "⇘";
var searhk = "⤥";
var searr = "↘";
var searrow = "↘";
var sec = "§";
var sect = "§";
var semi = ";";
var seswar = "⤩";
var setminus = "∖";
var setmn = "∖";
var sext = "✶";
var sfr = "𝔰";
var sfrown = "⌢";
var sharp = "♯";
var shchcy = "щ";
var shcy = "ш";
var shortmid = "∣";
var shortparallel = "∥";
var sh = "­";
var shy = "­";
var sigma = "σ";
var sigmaf = "ς";
var sigmav = "ς";
var sim = "∼";
var simdot = "⩪";
var sime = "≃";
var simeq = "≃";
var simg = "⪞";
var simgE = "⪠";
var siml = "⪝";
var simlE = "⪟";
var simne = "≆";
var simplus = "⨤";
var simrarr = "⥲";
var slarr = "←";
var smallsetminus = "∖";
var smashp = "⨳";
var smeparsl = "⧤";
var smid = "∣";
var smile = "⌣";
var smt = "⪪";
var smte = "⪬";
var smtes = "⪬︀";
var softcy = "ь";
var sol = "/";
var solb = "⧄";
var solbar = "⌿";
var sopf = "𝕤";
var spades = "♠";
var spadesuit = "♠";
var spar = "∥";
var sqcap = "⊓";
var sqcaps = "⊓︀";
var sqcup = "⊔";
var sqcups = "⊔︀";
var sqsub = "⊏";
var sqsube = "⊑";
var sqsubset = "⊏";
var sqsubseteq = "⊑";
var sqsup = "⊐";
var sqsupe = "⊒";
var sqsupset = "⊐";
var sqsupseteq = "⊒";
var squ = "□";
var square = "□";
var squarf = "▪";
var squf = "▪";
var srarr = "→";
var sscr = "𝓈";
var ssetmn = "∖";
var ssmile = "⌣";
var sstarf = "⋆";
var star = "☆";
var starf = "★";
var straightepsilon = "ϵ";
var straightphi = "ϕ";
var strns = "¯";
var sub = "⊂";
var subE = "⫅";
var subdot = "⪽";
var sube = "⊆";
var subedot = "⫃";
var submult = "⫁";
var subnE = "⫋";
var subne = "⊊";
var subplus = "⪿";
var subrarr = "⥹";
var subset = "⊂";
var subseteq = "⊆";
var subseteqq = "⫅";
var subsetneq = "⊊";
var subsetneqq = "⫋";
var subsim = "⫇";
var subsub = "⫕";
var subsup = "⫓";
var succ = "≻";
var succapprox = "⪸";
var succcurlyeq = "≽";
var succeq = "⪰";
var succnapprox = "⪺";
var succneqq = "⪶";
var succnsim = "⋩";
var succsim = "≿";
var sum = "∑";
var sung = "♪";
var sup = "⊃";
var sup1 = "¹";
var sup2 = "²";
var sup3 = "³";
var supE = "⫆";
var supdot = "⪾";
var supdsub = "⫘";
var supe = "⊇";
var supedot = "⫄";
var suphsol = "⟉";
var suphsub = "⫗";
var suplarr = "⥻";
var supmult = "⫂";
var supnE = "⫌";
var supne = "⊋";
var supplus = "⫀";
var supset = "⊃";
var supseteq = "⊇";
var supseteqq = "⫆";
var supsetneq = "⊋";
var supsetneqq = "⫌";
var supsim = "⫈";
var supsub = "⫔";
var supsup = "⫖";
var swArr = "⇙";
var swarhk = "⤦";
var swarr = "↙";
var swarrow = "↙";
var swnwar = "⤪";
var szli = "ß";
var szlig = "ß";
var target = "⌖";
var tau = "τ";
var tbrk = "⎴";
var tcaron = "ť";
var tcedil = "ţ";
var tcy = "т";
var tdot = "⃛";
var telrec = "⌕";
var tfr = "𝔱";
var there4 = "∴";
var therefore = "∴";
var theta = "θ";
var thetasym = "ϑ";
var thetav = "ϑ";
var thickapprox = "≈";
var thicksim = "∼";
var thinsp = " ";
var thkap = "≈";
var thksim = "∼";
var thor = "þ";
var thorn = "þ";
var tilde = "˜";
var time = "×";
var times = "×";
var timesb = "⊠";
var timesbar = "⨱";
var timesd = "⨰";
var tint = "∭";
var toea = "⤨";
var top = "⊤";
var topbot = "⌶";
var topcir = "⫱";
var topf = "𝕥";
var topfork = "⫚";
var tosa = "⤩";
var tprime = "‴";
var trade = "™";
var triangle = "▵";
var triangledown = "▿";
var triangleleft = "◃";
var trianglelefteq = "⊴";
var triangleq = "≜";
var triangleright = "▹";
var trianglerighteq = "⊵";
var tridot = "◬";
var trie = "≜";
var triminus = "⨺";
var triplus = "⨹";
var trisb = "⧍";
var tritime = "⨻";
var trpezium = "⏢";
var tscr = "𝓉";
var tscy = "ц";
var tshcy = "ћ";
var tstrok = "ŧ";
var twixt = "≬";
var twoheadleftarrow = "↞";
var twoheadrightarrow = "↠";
var uArr = "⇑";
var uHar = "⥣";
var uacut = "ú";
var uacute = "ú";
var uarr = "↑";
var ubrcy = "ў";
var ubreve = "ŭ";
var ucir = "û";
var ucirc = "û";
var ucy = "у";
var udarr = "⇅";
var udblac = "ű";
var udhar = "⥮";
var ufisht = "⥾";
var ufr = "𝔲";
var ugrav = "ù";
var ugrave = "ù";
var uharl = "↿";
var uharr = "↾";
var uhblk = "▀";
var ulcorn = "⌜";
var ulcorner = "⌜";
var ulcrop = "⌏";
var ultri = "◸";
var umacr = "ū";
var um = "¨";
var uml = "¨";
var uogon = "ų";
var uopf = "𝕦";
var uparrow = "↑";
var updownarrow = "↕";
var upharpoonleft = "↿";
var upharpoonright = "↾";
var uplus = "⊎";
var upsi = "υ";
var upsih = "ϒ";
var upsilon = "υ";
var upuparrows = "⇈";
var urcorn = "⌝";
var urcorner = "⌝";
var urcrop = "⌎";
var uring = "ů";
var urtri = "◹";
var uscr = "𝓊";
var utdot = "⋰";
var utilde = "ũ";
var utri = "▵";
var utrif = "▴";
var uuarr = "⇈";
var uum = "ü";
var uuml = "ü";
var uwangle = "⦧";
var vArr = "⇕";
var vBar = "⫨";
var vBarv = "⫩";
var vDash = "⊨";
var vangrt = "⦜";
var varepsilon = "ϵ";
var varkappa = "ϰ";
var varnothing = "∅";
var varphi = "ϕ";
var varpi = "ϖ";
var varpropto = "∝";
var varr = "↕";
var varrho = "ϱ";
var varsigma = "ς";
var varsubsetneq = "⊊︀";
var varsubsetneqq = "⫋︀";
var varsupsetneq = "⊋︀";
var varsupsetneqq = "⫌︀";
var vartheta = "ϑ";
var vartriangleleft = "⊲";
var vartriangleright = "⊳";
var vcy = "в";
var vdash = "⊢";
var vee = "∨";
var veebar = "⊻";
var veeeq = "≚";
var vellip = "⋮";
var verbar = "|";
var vert = "|";
var vfr = "𝔳";
var vltri = "⊲";
var vnsub = "⊂⃒";
var vnsup = "⊃⃒";
var vopf = "𝕧";
var vprop = "∝";
var vrtri = "⊳";
var vscr = "𝓋";
var vsubnE = "⫋︀";
var vsubne = "⊊︀";
var vsupnE = "⫌︀";
var vsupne = "⊋︀";
var vzigzag = "⦚";
var wcirc = "ŵ";
var wedbar = "⩟";
var wedge = "∧";
var wedgeq = "≙";
var weierp = "℘";
var wfr = "𝔴";
var wopf = "𝕨";
var wp = "℘";
var wr = "≀";
var wreath = "≀";
var wscr = "𝓌";
var xcap = "⋂";
var xcirc = "◯";
var xcup = "⋃";
var xdtri = "▽";
var xfr = "𝔵";
var xhArr = "⟺";
var xharr = "⟷";
var xi = "ξ";
var xlArr = "⟸";
var xlarr = "⟵";
var xmap = "⟼";
var xnis = "⋻";
var xodot = "⨀";
var xopf = "𝕩";
var xoplus = "⨁";
var xotime = "⨂";
var xrArr = "⟹";
var xrarr = "⟶";
var xscr = "𝓍";
var xsqcup = "⨆";
var xuplus = "⨄";
var xutri = "△";
var xvee = "⋁";
var xwedge = "⋀";
var yacut = "ý";
var yacute = "ý";
var yacy = "я";
var ycirc = "ŷ";
var ycy = "ы";
var ye = "¥";
var yen = "¥";
var yfr = "𝔶";
var yicy = "ї";
var yopf = "𝕪";
var yscr = "𝓎";
var yucy = "ю";
var yum = "ÿ";
var yuml = "ÿ";
var zacute = "ź";
var zcaron = "ž";
var zcy = "з";
var zdot = "ż";
var zeetrf = "ℨ";
var zeta = "ζ";
var zfr = "𝔷";
var zhcy = "ж";
var zigrarr = "⇝";
var zopf = "𝕫";
var zscr = "𝓏";
var zwj = "‍";
var zwnj = "‌";
var require$$0 = {
  AEli: AEli,
  AElig: AElig,
  AM: AM,
  AMP: AMP,
  Aacut: Aacut,
  Aacute: Aacute,
  Abreve: Abreve,
  Acir: Acir,
  Acirc: Acirc,
  Acy: Acy,
  Afr: Afr,
  Agrav: Agrav,
  Agrave: Agrave,
  Alpha: Alpha,
  Amacr: Amacr,
  And: And,
  Aogon: Aogon,
  Aopf: Aopf,
  ApplyFunction: ApplyFunction,
  Arin: Arin,
  Aring: Aring,
  Ascr: Ascr,
  Assign: Assign,
  Atild: Atild,
  Atilde: Atilde,
  Aum: Aum,
  Auml: Auml,
  Backslash: Backslash,
  Barv: Barv,
  Barwed: Barwed,
  Bcy: Bcy,
  Because: Because,
  Bernoullis: Bernoullis,
  Beta: Beta,
  Bfr: Bfr,
  Bopf: Bopf,
  Breve: Breve,
  Bscr: Bscr,
  Bumpeq: Bumpeq,
  CHcy: CHcy,
  COP: COP,
  COPY: COPY,
  Cacute: Cacute,
  Cap: Cap,
  CapitalDifferentialD: CapitalDifferentialD,
  Cayleys: Cayleys,
  Ccaron: Ccaron,
  Ccedi: Ccedi,
  Ccedil: Ccedil,
  Ccirc: Ccirc,
  Cconint: Cconint,
  Cdot: Cdot,
  Cedilla: Cedilla,
  CenterDot: CenterDot,
  Cfr: Cfr,
  Chi: Chi,
  CircleDot: CircleDot,
  CircleMinus: CircleMinus,
  CirclePlus: CirclePlus,
  CircleTimes: CircleTimes,
  ClockwiseContourIntegral: ClockwiseContourIntegral,
  CloseCurlyDoubleQuote: CloseCurlyDoubleQuote,
  CloseCurlyQuote: CloseCurlyQuote,
  Colon: Colon,
  Colone: Colone,
  Congruent: Congruent,
  Conint: Conint,
  ContourIntegral: ContourIntegral,
  Copf: Copf,
  Coproduct: Coproduct,
  CounterClockwiseContourIntegral: CounterClockwiseContourIntegral,
  Cross: Cross,
  Cscr: Cscr,
  Cup: Cup,
  CupCap: CupCap,
  DD: DD,
  DDotrahd: DDotrahd,
  DJcy: DJcy,
  DScy: DScy,
  DZcy: DZcy,
  Dagger: Dagger,
  Darr: Darr,
  Dashv: Dashv,
  Dcaron: Dcaron,
  Dcy: Dcy,
  Del: Del,
  Delta: Delta,
  Dfr: Dfr,
  DiacriticalAcute: DiacriticalAcute,
  DiacriticalDot: DiacriticalDot,
  DiacriticalDoubleAcute: DiacriticalDoubleAcute,
  DiacriticalGrave: DiacriticalGrave,
  DiacriticalTilde: DiacriticalTilde,
  Diamond: Diamond,
  DifferentialD: DifferentialD,
  Dopf: Dopf,
  Dot: Dot,
  DotDot: DotDot,
  DotEqual: DotEqual,
  DoubleContourIntegral: DoubleContourIntegral,
  DoubleDot: DoubleDot,
  DoubleDownArrow: DoubleDownArrow,
  DoubleLeftArrow: DoubleLeftArrow,
  DoubleLeftRightArrow: DoubleLeftRightArrow,
  DoubleLeftTee: DoubleLeftTee,
  DoubleLongLeftArrow: DoubleLongLeftArrow,
  DoubleLongLeftRightArrow: DoubleLongLeftRightArrow,
  DoubleLongRightArrow: DoubleLongRightArrow,
  DoubleRightArrow: DoubleRightArrow,
  DoubleRightTee: DoubleRightTee,
  DoubleUpArrow: DoubleUpArrow,
  DoubleUpDownArrow: DoubleUpDownArrow,
  DoubleVerticalBar: DoubleVerticalBar,
  DownArrow: DownArrow,
  DownArrowBar: DownArrowBar,
  DownArrowUpArrow: DownArrowUpArrow,
  DownBreve: DownBreve,
  DownLeftRightVector: DownLeftRightVector,
  DownLeftTeeVector: DownLeftTeeVector,
  DownLeftVector: DownLeftVector,
  DownLeftVectorBar: DownLeftVectorBar,
  DownRightTeeVector: DownRightTeeVector,
  DownRightVector: DownRightVector,
  DownRightVectorBar: DownRightVectorBar,
  DownTee: DownTee,
  DownTeeArrow: DownTeeArrow,
  Downarrow: Downarrow,
  Dscr: Dscr,
  Dstrok: Dstrok,
  ENG: ENG,
  ET: ET,
  ETH: ETH,
  Eacut: Eacut,
  Eacute: Eacute,
  Ecaron: Ecaron,
  Ecir: Ecir,
  Ecirc: Ecirc,
  Ecy: Ecy,
  Edot: Edot,
  Efr: Efr,
  Egrav: Egrav,
  Egrave: Egrave,
  Element: Element$1,
  Emacr: Emacr,
  EmptySmallSquare: EmptySmallSquare,
  EmptyVerySmallSquare: EmptyVerySmallSquare,
  Eogon: Eogon,
  Eopf: Eopf,
  Epsilon: Epsilon,
  Equal: Equal,
  EqualTilde: EqualTilde,
  Equilibrium: Equilibrium,
  Escr: Escr,
  Esim: Esim,
  Eta: Eta,
  Eum: Eum,
  Euml: Euml,
  Exists: Exists,
  ExponentialE: ExponentialE,
  Fcy: Fcy,
  Ffr: Ffr,
  FilledSmallSquare: FilledSmallSquare,
  FilledVerySmallSquare: FilledVerySmallSquare,
  Fopf: Fopf,
  ForAll: ForAll,
  Fouriertrf: Fouriertrf,
  Fscr: Fscr,
  GJcy: GJcy,
  G: G,
  GT: GT,
  Gamma: Gamma,
  Gammad: Gammad,
  Gbreve: Gbreve,
  Gcedil: Gcedil,
  Gcirc: Gcirc,
  Gcy: Gcy,
  Gdot: Gdot,
  Gfr: Gfr,
  Gg: Gg,
  Gopf: Gopf,
  GreaterEqual: GreaterEqual,
  GreaterEqualLess: GreaterEqualLess,
  GreaterFullEqual: GreaterFullEqual,
  GreaterGreater: GreaterGreater,
  GreaterLess: GreaterLess,
  GreaterSlantEqual: GreaterSlantEqual,
  GreaterTilde: GreaterTilde,
  Gscr: Gscr,
  Gt: Gt,
  HARDcy: HARDcy,
  Hacek: Hacek,
  Hat: Hat,
  Hcirc: Hcirc,
  Hfr: Hfr,
  HilbertSpace: HilbertSpace,
  Hopf: Hopf,
  HorizontalLine: HorizontalLine,
  Hscr: Hscr,
  Hstrok: Hstrok,
  HumpDownHump: HumpDownHump,
  HumpEqual: HumpEqual,
  IEcy: IEcy,
  IJlig: IJlig,
  IOcy: IOcy,
  Iacut: Iacut,
  Iacute: Iacute,
  Icir: Icir,
  Icirc: Icirc,
  Icy: Icy,
  Idot: Idot,
  Ifr: Ifr,
  Igrav: Igrav,
  Igrave: Igrave,
  Im: Im,
  Imacr: Imacr,
  ImaginaryI: ImaginaryI,
  Implies: Implies,
  Int: Int,
  Integral: Integral,
  Intersection: Intersection,
  InvisibleComma: InvisibleComma,
  InvisibleTimes: InvisibleTimes,
  Iogon: Iogon,
  Iopf: Iopf,
  Iota: Iota,
  Iscr: Iscr,
  Itilde: Itilde,
  Iukcy: Iukcy,
  Ium: Ium,
  Iuml: Iuml,
  Jcirc: Jcirc,
  Jcy: Jcy,
  Jfr: Jfr,
  Jopf: Jopf,
  Jscr: Jscr,
  Jsercy: Jsercy,
  Jukcy: Jukcy,
  KHcy: KHcy,
  KJcy: KJcy,
  Kappa: Kappa,
  Kcedil: Kcedil,
  Kcy: Kcy,
  Kfr: Kfr,
  Kopf: Kopf,
  Kscr: Kscr,
  LJcy: LJcy,
  L: L$1,
  LT: LT,
  Lacute: Lacute,
  Lambda: Lambda,
  Lang: Lang,
  Laplacetrf: Laplacetrf,
  Larr: Larr,
  Lcaron: Lcaron,
  Lcedil: Lcedil,
  Lcy: Lcy,
  LeftAngleBracket: LeftAngleBracket,
  LeftArrow: LeftArrow,
  LeftArrowBar: LeftArrowBar,
  LeftArrowRightArrow: LeftArrowRightArrow,
  LeftCeiling: LeftCeiling,
  LeftDoubleBracket: LeftDoubleBracket,
  LeftDownTeeVector: LeftDownTeeVector,
  LeftDownVector: LeftDownVector,
  LeftDownVectorBar: LeftDownVectorBar,
  LeftFloor: LeftFloor,
  LeftRightArrow: LeftRightArrow,
  LeftRightVector: LeftRightVector,
  LeftTee: LeftTee,
  LeftTeeArrow: LeftTeeArrow,
  LeftTeeVector: LeftTeeVector,
  LeftTriangle: LeftTriangle,
  LeftTriangleBar: LeftTriangleBar,
  LeftTriangleEqual: LeftTriangleEqual,
  LeftUpDownVector: LeftUpDownVector,
  LeftUpTeeVector: LeftUpTeeVector,
  LeftUpVector: LeftUpVector,
  LeftUpVectorBar: LeftUpVectorBar,
  LeftVector: LeftVector,
  LeftVectorBar: LeftVectorBar,
  Leftarrow: Leftarrow,
  Leftrightarrow: Leftrightarrow,
  LessEqualGreater: LessEqualGreater,
  LessFullEqual: LessFullEqual,
  LessGreater: LessGreater,
  LessLess: LessLess,
  LessSlantEqual: LessSlantEqual,
  LessTilde: LessTilde,
  Lfr: Lfr,
  Ll: Ll,
  Lleftarrow: Lleftarrow,
  Lmidot: Lmidot,
  LongLeftArrow: LongLeftArrow,
  LongLeftRightArrow: LongLeftRightArrow,
  LongRightArrow: LongRightArrow,
  Longleftarrow: Longleftarrow,
  Longleftrightarrow: Longleftrightarrow,
  Longrightarrow: Longrightarrow,
  Lopf: Lopf,
  LowerLeftArrow: LowerLeftArrow,
  LowerRightArrow: LowerRightArrow,
  Lscr: Lscr,
  Lsh: Lsh,
  Lstrok: Lstrok,
  Lt: Lt,
  "Map": "⤅",
  Mcy: Mcy,
  MediumSpace: MediumSpace,
  Mellintrf: Mellintrf,
  Mfr: Mfr,
  MinusPlus: MinusPlus,
  Mopf: Mopf,
  Mscr: Mscr,
  Mu: Mu,
  NJcy: NJcy,
  Nacute: Nacute,
  Ncaron: Ncaron,
  Ncedil: Ncedil,
  Ncy: Ncy,
  NegativeMediumSpace: NegativeMediumSpace,
  NegativeThickSpace: NegativeThickSpace,
  NegativeThinSpace: NegativeThinSpace,
  NegativeVeryThinSpace: NegativeVeryThinSpace,
  NestedGreaterGreater: NestedGreaterGreater,
  NestedLessLess: NestedLessLess,
  NewLine: NewLine,
  Nfr: Nfr,
  NoBreak: NoBreak,
  NonBreakingSpace: NonBreakingSpace,
  Nopf: Nopf,
  Not: Not,
  NotCongruent: NotCongruent,
  NotCupCap: NotCupCap,
  NotDoubleVerticalBar: NotDoubleVerticalBar,
  NotElement: NotElement,
  NotEqual: NotEqual,
  NotEqualTilde: NotEqualTilde,
  NotExists: NotExists,
  NotGreater: NotGreater,
  NotGreaterEqual: NotGreaterEqual,
  NotGreaterFullEqual: NotGreaterFullEqual,
  NotGreaterGreater: NotGreaterGreater,
  NotGreaterLess: NotGreaterLess,
  NotGreaterSlantEqual: NotGreaterSlantEqual,
  NotGreaterTilde: NotGreaterTilde,
  NotHumpDownHump: NotHumpDownHump,
  NotHumpEqual: NotHumpEqual,
  NotLeftTriangle: NotLeftTriangle,
  NotLeftTriangleBar: NotLeftTriangleBar,
  NotLeftTriangleEqual: NotLeftTriangleEqual,
  NotLess: NotLess,
  NotLessEqual: NotLessEqual,
  NotLessGreater: NotLessGreater,
  NotLessLess: NotLessLess,
  NotLessSlantEqual: NotLessSlantEqual,
  NotLessTilde: NotLessTilde,
  NotNestedGreaterGreater: NotNestedGreaterGreater,
  NotNestedLessLess: NotNestedLessLess,
  NotPrecedes: NotPrecedes,
  NotPrecedesEqual: NotPrecedesEqual,
  NotPrecedesSlantEqual: NotPrecedesSlantEqual,
  NotReverseElement: NotReverseElement,
  NotRightTriangle: NotRightTriangle,
  NotRightTriangleBar: NotRightTriangleBar,
  NotRightTriangleEqual: NotRightTriangleEqual,
  NotSquareSubset: NotSquareSubset,
  NotSquareSubsetEqual: NotSquareSubsetEqual,
  NotSquareSuperset: NotSquareSuperset,
  NotSquareSupersetEqual: NotSquareSupersetEqual,
  NotSubset: NotSubset,
  NotSubsetEqual: NotSubsetEqual,
  NotSucceeds: NotSucceeds,
  NotSucceedsEqual: NotSucceedsEqual,
  NotSucceedsSlantEqual: NotSucceedsSlantEqual,
  NotSucceedsTilde: NotSucceedsTilde,
  NotSuperset: NotSuperset,
  NotSupersetEqual: NotSupersetEqual,
  NotTilde: NotTilde,
  NotTildeEqual: NotTildeEqual,
  NotTildeFullEqual: NotTildeFullEqual,
  NotTildeTilde: NotTildeTilde,
  NotVerticalBar: NotVerticalBar,
  Nscr: Nscr,
  Ntild: Ntild,
  Ntilde: Ntilde,
  Nu: Nu,
  OElig: OElig,
  Oacut: Oacut,
  Oacute: Oacute,
  Ocir: Ocir,
  Ocirc: Ocirc,
  Ocy: Ocy,
  Odblac: Odblac,
  Ofr: Ofr,
  Ograv: Ograv,
  Ograve: Ograve,
  Omacr: Omacr,
  Omega: Omega,
  Omicron: Omicron,
  Oopf: Oopf,
  OpenCurlyDoubleQuote: OpenCurlyDoubleQuote,
  OpenCurlyQuote: OpenCurlyQuote,
  Or: Or,
  Oscr: Oscr,
  Oslas: Oslas,
  Oslash: Oslash,
  Otild: Otild,
  Otilde: Otilde,
  Otimes: Otimes,
  Oum: Oum,
  Ouml: Ouml,
  OverBar: OverBar,
  OverBrace: OverBrace,
  OverBracket: OverBracket,
  OverParenthesis: OverParenthesis,
  PartialD: PartialD,
  Pcy: Pcy,
  Pfr: Pfr,
  Phi: Phi,
  Pi: Pi,
  PlusMinus: PlusMinus,
  Poincareplane: Poincareplane,
  Popf: Popf,
  Pr: Pr,
  Precedes: Precedes,
  PrecedesEqual: PrecedesEqual,
  PrecedesSlantEqual: PrecedesSlantEqual,
  PrecedesTilde: PrecedesTilde,
  Prime: Prime,
  Product: Product,
  Proportion: Proportion,
  Proportional: Proportional,
  Pscr: Pscr,
  Psi: Psi,
  QUO: QUO,
  QUOT: QUOT,
  Qfr: Qfr,
  Qopf: Qopf,
  Qscr: Qscr,
  RBarr: RBarr,
  RE: RE,
  REG: REG,
  Racute: Racute,
  Rang: Rang,
  Rarr: Rarr,
  Rarrtl: Rarrtl,
  Rcaron: Rcaron,
  Rcedil: Rcedil,
  Rcy: Rcy,
  Re: Re,
  ReverseElement: ReverseElement,
  ReverseEquilibrium: ReverseEquilibrium,
  ReverseUpEquilibrium: ReverseUpEquilibrium,
  Rfr: Rfr,
  Rho: Rho,
  RightAngleBracket: RightAngleBracket,
  RightArrow: RightArrow,
  RightArrowBar: RightArrowBar,
  RightArrowLeftArrow: RightArrowLeftArrow,
  RightCeiling: RightCeiling,
  RightDoubleBracket: RightDoubleBracket,
  RightDownTeeVector: RightDownTeeVector,
  RightDownVector: RightDownVector,
  RightDownVectorBar: RightDownVectorBar,
  RightFloor: RightFloor,
  RightTee: RightTee,
  RightTeeArrow: RightTeeArrow,
  RightTeeVector: RightTeeVector,
  RightTriangle: RightTriangle,
  RightTriangleBar: RightTriangleBar,
  RightTriangleEqual: RightTriangleEqual,
  RightUpDownVector: RightUpDownVector,
  RightUpTeeVector: RightUpTeeVector,
  RightUpVector: RightUpVector,
  RightUpVectorBar: RightUpVectorBar,
  RightVector: RightVector,
  RightVectorBar: RightVectorBar,
  Rightarrow: Rightarrow,
  Ropf: Ropf,
  RoundImplies: RoundImplies,
  Rrightarrow: Rrightarrow,
  Rscr: Rscr,
  Rsh: Rsh,
  RuleDelayed: RuleDelayed,
  SHCHcy: SHCHcy,
  SHcy: SHcy,
  SOFTcy: SOFTcy,
  Sacute: Sacute,
  Sc: Sc,
  Scaron: Scaron,
  Scedil: Scedil,
  Scirc: Scirc,
  Scy: Scy,
  Sfr: Sfr,
  ShortDownArrow: ShortDownArrow,
  ShortLeftArrow: ShortLeftArrow,
  ShortRightArrow: ShortRightArrow,
  ShortUpArrow: ShortUpArrow,
  Sigma: Sigma,
  SmallCircle: SmallCircle,
  Sopf: Sopf,
  Sqrt: Sqrt,
  Square: Square,
  SquareIntersection: SquareIntersection,
  SquareSubset: SquareSubset,
  SquareSubsetEqual: SquareSubsetEqual,
  SquareSuperset: SquareSuperset,
  SquareSupersetEqual: SquareSupersetEqual,
  SquareUnion: SquareUnion,
  Sscr: Sscr,
  Star: Star,
  Sub: Sub,
  Subset: Subset,
  SubsetEqual: SubsetEqual,
  Succeeds: Succeeds,
  SucceedsEqual: SucceedsEqual,
  SucceedsSlantEqual: SucceedsSlantEqual,
  SucceedsTilde: SucceedsTilde,
  SuchThat: SuchThat,
  Sum: Sum,
  Sup: Sup,
  Superset: Superset,
  SupersetEqual: SupersetEqual,
  Supset: Supset,
  THOR: THOR,
  THORN: THORN,
  TRADE: TRADE,
  TSHcy: TSHcy,
  TScy: TScy,
  Tab: Tab,
  Tau: Tau,
  Tcaron: Tcaron,
  Tcedil: Tcedil,
  Tcy: Tcy,
  Tfr: Tfr,
  Therefore: Therefore,
  Theta: Theta,
  ThickSpace: ThickSpace,
  ThinSpace: ThinSpace,
  Tilde: Tilde,
  TildeEqual: TildeEqual,
  TildeFullEqual: TildeFullEqual,
  TildeTilde: TildeTilde,
  Topf: Topf,
  TripleDot: TripleDot,
  Tscr: Tscr,
  Tstrok: Tstrok,
  Uacut: Uacut,
  Uacute: Uacute,
  Uarr: Uarr,
  Uarrocir: Uarrocir,
  Ubrcy: Ubrcy,
  Ubreve: Ubreve,
  Ucir: Ucir,
  Ucirc: Ucirc,
  Ucy: Ucy,
  Udblac: Udblac,
  Ufr: Ufr,
  Ugrav: Ugrav,
  Ugrave: Ugrave,
  Umacr: Umacr,
  UnderBar: UnderBar,
  UnderBrace: UnderBrace,
  UnderBracket: UnderBracket,
  UnderParenthesis: UnderParenthesis,
  Union: Union,
  UnionPlus: UnionPlus,
  Uogon: Uogon,
  Uopf: Uopf,
  UpArrow: UpArrow,
  UpArrowBar: UpArrowBar,
  UpArrowDownArrow: UpArrowDownArrow,
  UpDownArrow: UpDownArrow,
  UpEquilibrium: UpEquilibrium,
  UpTee: UpTee,
  UpTeeArrow: UpTeeArrow,
  Uparrow: Uparrow,
  Updownarrow: Updownarrow,
  UpperLeftArrow: UpperLeftArrow,
  UpperRightArrow: UpperRightArrow,
  Upsi: Upsi,
  Upsilon: Upsilon,
  Uring: Uring,
  Uscr: Uscr,
  Utilde: Utilde,
  Uum: Uum,
  Uuml: Uuml,
  VDash: VDash,
  Vbar: Vbar,
  Vcy: Vcy,
  Vdash: Vdash,
  Vdashl: Vdashl,
  Vee: Vee,
  Verbar: Verbar,
  Vert: Vert,
  VerticalBar: VerticalBar,
  VerticalLine: VerticalLine,
  VerticalSeparator: VerticalSeparator,
  VerticalTilde: VerticalTilde,
  VeryThinSpace: VeryThinSpace,
  Vfr: Vfr,
  Vopf: Vopf,
  Vscr: Vscr,
  Vvdash: Vvdash,
  Wcirc: Wcirc,
  Wedge: Wedge,
  Wfr: Wfr,
  Wopf: Wopf,
  Wscr: Wscr,
  Xfr: Xfr,
  Xi: Xi,
  Xopf: Xopf,
  Xscr: Xscr,
  YAcy: YAcy,
  YIcy: YIcy,
  YUcy: YUcy,
  Yacut: Yacut,
  Yacute: Yacute,
  Ycirc: Ycirc,
  Ycy: Ycy,
  Yfr: Yfr,
  Yopf: Yopf,
  Yscr: Yscr,
  Yuml: Yuml,
  ZHcy: ZHcy,
  Zacute: Zacute,
  Zcaron: Zcaron,
  Zcy: Zcy,
  Zdot: Zdot,
  ZeroWidthSpace: ZeroWidthSpace,
  Zeta: Zeta,
  Zfr: Zfr,
  Zopf: Zopf,
  Zscr: Zscr,
  aacut: aacut,
  aacute: aacute,
  abreve: abreve,
  ac: ac,
  acE: acE,
  acd: acd,
  acir: acir,
  acirc: acirc,
  acut: acut,
  acute: acute,
  acy: acy,
  aeli: aeli,
  aelig: aelig,
  af: af,
  afr: afr,
  agrav: agrav,
  agrave: agrave,
  alefsym: alefsym,
  aleph: aleph,
  alpha: alpha,
  amacr: amacr,
  amalg: amalg,
  am: am,
  amp: amp,
  and: and,
  andand: andand,
  andd: andd,
  andslope: andslope,
  andv: andv,
  ang: ang,
  ange: ange,
  angle: angle,
  angmsd: angmsd,
  angmsdaa: angmsdaa,
  angmsdab: angmsdab,
  angmsdac: angmsdac,
  angmsdad: angmsdad,
  angmsdae: angmsdae,
  angmsdaf: angmsdaf,
  angmsdag: angmsdag,
  angmsdah: angmsdah,
  angrt: angrt,
  angrtvb: angrtvb,
  angrtvbd: angrtvbd,
  angsph: angsph,
  angst: angst,
  angzarr: angzarr,
  aogon: aogon,
  aopf: aopf,
  ap: ap,
  apE: apE,
  apacir: apacir,
  ape: ape,
  apid: apid,
  apos: apos,
  approx: approx,
  approxeq: approxeq,
  arin: arin,
  aring: aring,
  ascr: ascr,
  ast: ast,
  asymp: asymp,
  asympeq: asympeq,
  atild: atild,
  atilde: atilde,
  aum: aum,
  auml: auml,
  awconint: awconint,
  awint: awint,
  bNot: bNot,
  backcong: backcong,
  backepsilon: backepsilon,
  backprime: backprime,
  backsim: backsim,
  backsimeq: backsimeq,
  barvee: barvee,
  barwed: barwed,
  barwedge: barwedge,
  bbrk: bbrk,
  bbrktbrk: bbrktbrk,
  bcong: bcong,
  bcy: bcy,
  bdquo: bdquo,
  becaus: becaus,
  because: because,
  bemptyv: bemptyv,
  bepsi: bepsi,
  bernou: bernou,
  beta: beta,
  beth: beth,
  between: between,
  bfr: bfr,
  bigcap: bigcap,
  bigcirc: bigcirc,
  bigcup: bigcup,
  bigodot: bigodot,
  bigoplus: bigoplus,
  bigotimes: bigotimes,
  bigsqcup: bigsqcup,
  bigstar: bigstar,
  bigtriangledown: bigtriangledown,
  bigtriangleup: bigtriangleup,
  biguplus: biguplus,
  bigvee: bigvee,
  bigwedge: bigwedge,
  bkarow: bkarow,
  blacklozenge: blacklozenge,
  blacksquare: blacksquare,
  blacktriangle: blacktriangle,
  blacktriangledown: blacktriangledown,
  blacktriangleleft: blacktriangleleft,
  blacktriangleright: blacktriangleright,
  blank: blank,
  blk12: blk12,
  blk14: blk14,
  blk34: blk34,
  block: block,
  bne: bne,
  bnequiv: bnequiv,
  bnot: bnot,
  bopf: bopf,
  bot: bot,
  bottom: bottom,
  bowtie: bowtie,
  boxDL: boxDL,
  boxDR: boxDR,
  boxDl: boxDl,
  boxDr: boxDr,
  boxH: boxH,
  boxHD: boxHD,
  boxHU: boxHU,
  boxHd: boxHd,
  boxHu: boxHu,
  boxUL: boxUL,
  boxUR: boxUR,
  boxUl: boxUl,
  boxUr: boxUr,
  boxV: boxV,
  boxVH: boxVH,
  boxVL: boxVL,
  boxVR: boxVR,
  boxVh: boxVh,
  boxVl: boxVl,
  boxVr: boxVr,
  boxbox: boxbox,
  boxdL: boxdL,
  boxdR: boxdR,
  boxdl: boxdl,
  boxdr: boxdr,
  boxh: boxh,
  boxhD: boxhD,
  boxhU: boxhU,
  boxhd: boxhd,
  boxhu: boxhu,
  boxminus: boxminus,
  boxplus: boxplus,
  boxtimes: boxtimes,
  boxuL: boxuL,
  boxuR: boxuR,
  boxul: boxul,
  boxur: boxur,
  boxv: boxv,
  boxvH: boxvH,
  boxvL: boxvL,
  boxvR: boxvR,
  boxvh: boxvh,
  boxvl: boxvl,
  boxvr: boxvr,
  bprime: bprime,
  breve: breve,
  brvba: brvba,
  brvbar: brvbar,
  bscr: bscr,
  bsemi: bsemi,
  bsim: bsim,
  bsime: bsime,
  bsol: bsol,
  bsolb: bsolb,
  bsolhsub: bsolhsub,
  bull: bull,
  bullet: bullet,
  bump: bump,
  bumpE: bumpE,
  bumpe: bumpe,
  bumpeq: bumpeq,
  cacute: cacute,
  cap: cap$1,
  capand: capand,
  capbrcup: capbrcup,
  capcap: capcap,
  capcup: capcup,
  capdot: capdot,
  caps: caps,
  caret: caret,
  caron: caron,
  ccaps: ccaps,
  ccaron: ccaron,
  ccedi: ccedi,
  ccedil: ccedil,
  ccirc: ccirc,
  ccups: ccups,
  ccupssm: ccupssm,
  cdot: cdot,
  cedi: cedi,
  cedil: cedil,
  cemptyv: cemptyv,
  cen: cen,
  cent: cent,
  centerdot: centerdot,
  cfr: cfr,
  chcy: chcy,
  check: check,
  checkmark: checkmark,
  chi: chi,
  cir: cir,
  cirE: cirE,
  circ: circ,
  circeq: circeq,
  circlearrowleft: circlearrowleft,
  circlearrowright: circlearrowright,
  circledR: circledR,
  circledS: circledS,
  circledast: circledast,
  circledcirc: circledcirc,
  circleddash: circleddash,
  cire: cire,
  cirfnint: cirfnint,
  cirmid: cirmid,
  cirscir: cirscir,
  clubs: clubs,
  clubsuit: clubsuit,
  colon: colon$1,
  colone: colone,
  coloneq: coloneq,
  comma: comma$1,
  commat: commat,
  comp: comp,
  compfn: compfn,
  complement: complement,
  complexes: complexes,
  cong: cong,
  congdot: congdot,
  conint: conint,
  copf: copf,
  coprod: coprod,
  cop: cop,
  copy: copy,
  copysr: copysr,
  crarr: crarr,
  cross: cross,
  cscr: cscr,
  csub: csub,
  csube: csube,
  csup: csup,
  csupe: csupe,
  ctdot: ctdot,
  cudarrl: cudarrl,
  cudarrr: cudarrr,
  cuepr: cuepr,
  cuesc: cuesc,
  cularr: cularr,
  cularrp: cularrp,
  cup: cup,
  cupbrcap: cupbrcap,
  cupcap: cupcap,
  cupcup: cupcup,
  cupdot: cupdot,
  cupor: cupor,
  cups: cups,
  curarr: curarr,
  curarrm: curarrm,
  curlyeqprec: curlyeqprec,
  curlyeqsucc: curlyeqsucc,
  curlyvee: curlyvee,
  curlywedge: curlywedge,
  curre: curre,
  curren: curren,
  curvearrowleft: curvearrowleft,
  curvearrowright: curvearrowright,
  cuvee: cuvee,
  cuwed: cuwed,
  cwconint: cwconint,
  cwint: cwint,
  cylcty: cylcty,
  dArr: dArr,
  dHar: dHar,
  dagger: dagger,
  daleth: daleth,
  darr: darr,
  dash: dash$2,
  dashv: dashv,
  dbkarow: dbkarow,
  dblac: dblac,
  dcaron: dcaron,
  dcy: dcy,
  dd: dd,
  ddagger: ddagger,
  ddarr: ddarr,
  ddotseq: ddotseq,
  de: de,
  deg: deg,
  delta: delta,
  demptyv: demptyv,
  dfisht: dfisht,
  dfr: dfr,
  dharl: dharl,
  dharr: dharr,
  diam: diam,
  diamond: diamond,
  diamondsuit: diamondsuit,
  diams: diams,
  die: die,
  digamma: digamma,
  disin: disin,
  div: div,
  divid: divid,
  divide: divide,
  divideontimes: divideontimes,
  divonx: divonx,
  djcy: djcy,
  dlcorn: dlcorn,
  dlcrop: dlcrop,
  dollar: dollar,
  dopf: dopf,
  dot: dot,
  doteq: doteq,
  doteqdot: doteqdot,
  dotminus: dotminus,
  dotplus: dotplus,
  dotsquare: dotsquare,
  doublebarwedge: doublebarwedge,
  downarrow: downarrow,
  downdownarrows: downdownarrows,
  downharpoonleft: downharpoonleft,
  downharpoonright: downharpoonright,
  drbkarow: drbkarow,
  drcorn: drcorn,
  drcrop: drcrop,
  dscr: dscr,
  dscy: dscy,
  dsol: dsol,
  dstrok: dstrok,
  dtdot: dtdot,
  dtri: dtri,
  dtrif: dtrif,
  duarr: duarr,
  duhar: duhar,
  dwangle: dwangle,
  dzcy: dzcy,
  dzigrarr: dzigrarr,
  eDDot: eDDot,
  eDot: eDot,
  eacut: eacut,
  eacute: eacute,
  easter: easter,
  ecaron: ecaron,
  ecir: ecir,
  ecirc: ecirc,
  ecolon: ecolon,
  ecy: ecy,
  edot: edot,
  ee: ee,
  efDot: efDot,
  efr: efr,
  eg: eg,
  egrav: egrav,
  egrave: egrave,
  egs: egs,
  egsdot: egsdot,
  el: el,
  elinters: elinters,
  ell: ell,
  els: els,
  elsdot: elsdot,
  emacr: emacr,
  empty: empty$2,
  emptyset: emptyset,
  emptyv: emptyv,
  emsp13: emsp13,
  emsp14: emsp14,
  emsp: emsp,
  eng: eng,
  ensp: ensp,
  eogon: eogon,
  eopf: eopf,
  epar: epar,
  eparsl: eparsl,
  eplus: eplus,
  epsi: epsi,
  epsilon: epsilon,
  epsiv: epsiv,
  eqcirc: eqcirc,
  eqcolon: eqcolon,
  eqsim: eqsim,
  eqslantgtr: eqslantgtr,
  eqslantless: eqslantless,
  equals: equals,
  equest: equest,
  equiv: equiv,
  equivDD: equivDD,
  eqvparsl: eqvparsl,
  erDot: erDot,
  erarr: erarr,
  escr: escr,
  esdot: esdot,
  esim: esim,
  eta: eta,
  et: et,
  eth: eth,
  eum: eum,
  euml: euml,
  euro: euro,
  excl: excl,
  exist: exist,
  expectation: expectation,
  exponentiale: exponentiale,
  fallingdotseq: fallingdotseq,
  fcy: fcy,
  female: female,
  ffilig: ffilig,
  fflig: fflig,
  ffllig: ffllig,
  ffr: ffr,
  filig: filig,
  fjlig: fjlig,
  flat: flat,
  fllig: fllig,
  fltns: fltns,
  fnof: fnof,
  fopf: fopf,
  forall: forall,
  fork: fork,
  forkv: forkv,
  fpartint: fpartint,
  frac1: frac1,
  frac12: frac12,
  frac13: frac13,
  frac14: frac14,
  frac15: frac15,
  frac16: frac16,
  frac18: frac18,
  frac23: frac23,
  frac25: frac25,
  frac3: frac3,
  frac34: frac34,
  frac35: frac35,
  frac38: frac38,
  frac45: frac45,
  frac56: frac56,
  frac58: frac58,
  frac78: frac78,
  frasl: frasl,
  frown: frown,
  fscr: fscr,
  gE: gE,
  gEl: gEl,
  gacute: gacute,
  gamma: gamma,
  gammad: gammad,
  gap: gap,
  gbreve: gbreve,
  gcirc: gcirc,
  gcy: gcy,
  gdot: gdot,
  ge: ge,
  gel: gel,
  geq: geq,
  geqq: geqq,
  geqslant: geqslant,
  ges: ges,
  gescc: gescc,
  gesdot: gesdot,
  gesdoto: gesdoto,
  gesdotol: gesdotol,
  gesl: gesl,
  gesles: gesles,
  gfr: gfr,
  gg: gg,
  ggg: ggg,
  gimel: gimel,
  gjcy: gjcy,
  gl: gl,
  glE: glE,
  gla: gla,
  glj: glj,
  gnE: gnE,
  gnap: gnap,
  gnapprox: gnapprox,
  gne: gne,
  gneq: gneq,
  gneqq: gneqq,
  gnsim: gnsim,
  gopf: gopf,
  grave: grave,
  gscr: gscr,
  gsim: gsim,
  gsime: gsime,
  gsiml: gsiml,
  g: g,
  gt: gt,
  gtcc: gtcc,
  gtcir: gtcir,
  gtdot: gtdot,
  gtlPar: gtlPar,
  gtquest: gtquest,
  gtrapprox: gtrapprox,
  gtrarr: gtrarr,
  gtrdot: gtrdot,
  gtreqless: gtreqless,
  gtreqqless: gtreqqless,
  gtrless: gtrless,
  gtrsim: gtrsim,
  gvertneqq: gvertneqq,
  gvnE: gvnE,
  hArr: hArr,
  hairsp: hairsp,
  half: half,
  hamilt: hamilt,
  hardcy: hardcy,
  harr: harr,
  harrcir: harrcir,
  harrw: harrw,
  hbar: hbar,
  hcirc: hcirc,
  hearts: hearts,
  heartsuit: heartsuit,
  hellip: hellip,
  hercon: hercon,
  hfr: hfr,
  hksearow: hksearow,
  hkswarow: hkswarow,
  hoarr: hoarr,
  homtht: homtht,
  hookleftarrow: hookleftarrow,
  hookrightarrow: hookrightarrow,
  hopf: hopf,
  horbar: horbar,
  hscr: hscr,
  hslash: hslash,
  hstrok: hstrok,
  hybull: hybull,
  hyphen: hyphen,
  iacut: iacut,
  iacute: iacute,
  ic: ic,
  icir: icir,
  icirc: icirc,
  icy: icy,
  iecy: iecy,
  iexc: iexc,
  iexcl: iexcl,
  iff: iff,
  ifr: ifr,
  igrav: igrav,
  igrave: igrave,
  ii: ii,
  iiiint: iiiint,
  iiint: iiint,
  iinfin: iinfin,
  iiota: iiota,
  ijlig: ijlig,
  imacr: imacr,
  image: image$1,
  imagline: imagline,
  imagpart: imagpart,
  imath: imath,
  imof: imof,
  imped: imped,
  "in": "∈",
  incare: incare,
  infin: infin,
  infintie: infintie,
  inodot: inodot,
  int: int,
  intcal: intcal,
  integers: integers,
  intercal: intercal,
  intlarhk: intlarhk,
  intprod: intprod,
  iocy: iocy,
  iogon: iogon,
  iopf: iopf,
  iota: iota,
  iprod: iprod,
  iques: iques,
  iquest: iquest,
  iscr: iscr,
  isin: isin,
  isinE: isinE,
  isindot: isindot,
  isins: isins,
  isinsv: isinsv,
  isinv: isinv,
  it: it,
  itilde: itilde,
  iukcy: iukcy,
  ium: ium,
  iuml: iuml,
  jcirc: jcirc,
  jcy: jcy,
  jfr: jfr,
  jmath: jmath,
  jopf: jopf,
  jscr: jscr,
  jsercy: jsercy,
  jukcy: jukcy,
  kappa: kappa,
  kappav: kappav,
  kcedil: kcedil,
  kcy: kcy,
  kfr: kfr,
  kgreen: kgreen,
  khcy: khcy,
  kjcy: kjcy,
  kopf: kopf,
  kscr: kscr,
  lAarr: lAarr,
  lArr: lArr,
  lAtail: lAtail,
  lBarr: lBarr,
  lE: lE,
  lEg: lEg,
  lHar: lHar,
  lacute: lacute,
  laemptyv: laemptyv,
  lagran: lagran,
  lambda: lambda,
  lang: lang,
  langd: langd,
  langle: langle,
  lap: lap,
  laqu: laqu,
  laquo: laquo,
  larr: larr,
  larrb: larrb,
  larrbfs: larrbfs,
  larrfs: larrfs,
  larrhk: larrhk,
  larrlp: larrlp,
  larrpl: larrpl,
  larrsim: larrsim,
  larrtl: larrtl,
  lat: lat,
  latail: latail,
  late: late,
  lates: lates,
  lbarr: lbarr,
  lbbrk: lbbrk,
  lbrace: lbrace,
  lbrack: lbrack,
  lbrke: lbrke,
  lbrksld: lbrksld,
  lbrkslu: lbrkslu,
  lcaron: lcaron,
  lcedil: lcedil,
  lceil: lceil,
  lcub: lcub,
  lcy: lcy,
  ldca: ldca,
  ldquo: ldquo,
  ldquor: ldquor,
  ldrdhar: ldrdhar,
  ldrushar: ldrushar,
  ldsh: ldsh,
  le: le,
  leftarrow: leftarrow,
  leftarrowtail: leftarrowtail,
  leftharpoondown: leftharpoondown,
  leftharpoonup: leftharpoonup,
  leftleftarrows: leftleftarrows,
  leftrightarrow: leftrightarrow,
  leftrightarrows: leftrightarrows,
  leftrightharpoons: leftrightharpoons,
  leftrightsquigarrow: leftrightsquigarrow,
  leftthreetimes: leftthreetimes,
  leg: leg,
  leq: leq,
  leqq: leqq,
  leqslant: leqslant,
  les: les,
  lescc: lescc,
  lesdot: lesdot,
  lesdoto: lesdoto,
  lesdotor: lesdotor,
  lesg: lesg,
  lesges: lesges,
  lessapprox: lessapprox,
  lessdot: lessdot,
  lesseqgtr: lesseqgtr,
  lesseqqgtr: lesseqqgtr,
  lessgtr: lessgtr,
  lesssim: lesssim,
  lfisht: lfisht,
  lfloor: lfloor,
  lfr: lfr,
  lg: lg,
  lgE: lgE,
  lhard: lhard,
  lharu: lharu,
  lharul: lharul,
  lhblk: lhblk,
  ljcy: ljcy,
  ll: ll,
  llarr: llarr,
  llcorner: llcorner,
  llhard: llhard,
  lltri: lltri,
  lmidot: lmidot,
  lmoust: lmoust,
  lmoustache: lmoustache,
  lnE: lnE,
  lnap: lnap,
  lnapprox: lnapprox,
  lne: lne,
  lneq: lneq,
  lneqq: lneqq,
  lnsim: lnsim,
  loang: loang,
  loarr: loarr,
  lobrk: lobrk,
  longleftarrow: longleftarrow,
  longleftrightarrow: longleftrightarrow,
  longmapsto: longmapsto,
  longrightarrow: longrightarrow,
  looparrowleft: looparrowleft,
  looparrowright: looparrowright,
  lopar: lopar,
  lopf: lopf,
  loplus: loplus,
  lotimes: lotimes,
  lowast: lowast,
  lowbar: lowbar,
  loz: loz,
  lozenge: lozenge,
  lozf: lozf,
  lpar: lpar,
  lparlt: lparlt,
  lrarr: lrarr,
  lrcorner: lrcorner,
  lrhar: lrhar,
  lrhard: lrhard,
  lrm: lrm,
  lrtri: lrtri,
  lsaquo: lsaquo,
  lscr: lscr,
  lsh: lsh,
  lsim: lsim,
  lsime: lsime,
  lsimg: lsimg,
  lsqb: lsqb,
  lsquo: lsquo,
  lsquor: lsquor,
  lstrok: lstrok,
  l: l$1,
  lt: lt,
  ltcc: ltcc,
  ltcir: ltcir,
  ltdot: ltdot,
  lthree: lthree,
  ltimes: ltimes,
  ltlarr: ltlarr,
  ltquest: ltquest,
  ltrPar: ltrPar,
  ltri: ltri,
  ltrie: ltrie,
  ltrif: ltrif,
  lurdshar: lurdshar,
  luruhar: luruhar,
  lvertneqq: lvertneqq,
  lvnE: lvnE,
  mDDot: mDDot,
  mac: mac,
  macr: macr,
  male: male,
  malt: malt,
  maltese: maltese,
  map: map$3,
  mapsto: mapsto,
  mapstodown: mapstodown,
  mapstoleft: mapstoleft,
  mapstoup: mapstoup,
  marker: marker,
  mcomma: mcomma,
  mcy: mcy,
  mdash: mdash,
  measuredangle: measuredangle,
  mfr: mfr,
  mho: mho,
  micr: micr,
  micro: micro,
  mid: mid,
  midast: midast,
  midcir: midcir,
  middo: middo,
  middot: middot,
  minus: minus,
  minusb: minusb,
  minusd: minusd,
  minusdu: minusdu,
  mlcp: mlcp,
  mldr: mldr,
  mnplus: mnplus,
  models: models,
  mopf: mopf,
  mp: mp,
  mscr: mscr,
  mstpos: mstpos,
  mu: mu,
  multimap: multimap,
  mumap: mumap,
  nGg: nGg,
  nGt: nGt,
  nGtv: nGtv,
  nLeftarrow: nLeftarrow,
  nLeftrightarrow: nLeftrightarrow,
  nLl: nLl,
  nLt: nLt,
  nLtv: nLtv,
  nRightarrow: nRightarrow,
  nVDash: nVDash,
  nVdash: nVdash,
  nabla: nabla,
  nacute: nacute,
  nang: nang,
  nap: nap,
  napE: napE,
  napid: napid,
  napos: napos,
  napprox: napprox,
  natur: natur,
  natural: natural,
  naturals: naturals,
  nbs: nbs,
  nbsp: nbsp,
  nbump: nbump,
  nbumpe: nbumpe,
  ncap: ncap,
  ncaron: ncaron,
  ncedil: ncedil,
  ncong: ncong,
  ncongdot: ncongdot,
  ncup: ncup,
  ncy: ncy,
  ndash: ndash,
  ne: ne,
  neArr: neArr,
  nearhk: nearhk,
  nearr: nearr,
  nearrow: nearrow,
  nedot: nedot,
  nequiv: nequiv,
  nesear: nesear,
  nesim: nesim,
  nexist: nexist,
  nexists: nexists,
  nfr: nfr,
  ngE: ngE,
  nge: nge,
  ngeq: ngeq,
  ngeqq: ngeqq,
  ngeqslant: ngeqslant,
  nges: nges,
  ngsim: ngsim,
  ngt: ngt,
  ngtr: ngtr,
  nhArr: nhArr,
  nharr: nharr,
  nhpar: nhpar,
  ni: ni,
  nis: nis,
  nisd: nisd,
  niv: niv,
  njcy: njcy,
  nlArr: nlArr,
  nlE: nlE,
  nlarr: nlarr,
  nldr: nldr,
  nle: nle,
  nleftarrow: nleftarrow,
  nleftrightarrow: nleftrightarrow,
  nleq: nleq,
  nleqq: nleqq,
  nleqslant: nleqslant,
  nles: nles,
  nless: nless,
  nlsim: nlsim,
  nlt: nlt,
  nltri: nltri,
  nltrie: nltrie,
  nmid: nmid,
  nopf: nopf,
  no: no,
  not: not,
  notin: notin,
  notinE: notinE,
  notindot: notindot,
  notinva: notinva,
  notinvb: notinvb,
  notinvc: notinvc,
  notni: notni,
  notniva: notniva,
  notnivb: notnivb,
  notnivc: notnivc,
  npar: npar,
  nparallel: nparallel,
  nparsl: nparsl,
  npart: npart,
  npolint: npolint,
  npr: npr,
  nprcue: nprcue,
  npre: npre,
  nprec: nprec,
  npreceq: npreceq,
  nrArr: nrArr,
  nrarr: nrarr,
  nrarrc: nrarrc,
  nrarrw: nrarrw,
  nrightarrow: nrightarrow,
  nrtri: nrtri,
  nrtrie: nrtrie,
  nsc: nsc,
  nsccue: nsccue,
  nsce: nsce,
  nscr: nscr,
  nshortmid: nshortmid,
  nshortparallel: nshortparallel,
  nsim: nsim,
  nsime: nsime,
  nsimeq: nsimeq,
  nsmid: nsmid,
  nspar: nspar,
  nsqsube: nsqsube,
  nsqsupe: nsqsupe,
  nsub: nsub,
  nsubE: nsubE,
  nsube: nsube,
  nsubset: nsubset,
  nsubseteq: nsubseteq,
  nsubseteqq: nsubseteqq,
  nsucc: nsucc,
  nsucceq: nsucceq,
  nsup: nsup,
  nsupE: nsupE,
  nsupe: nsupe,
  nsupset: nsupset,
  nsupseteq: nsupseteq,
  nsupseteqq: nsupseteqq,
  ntgl: ntgl,
  ntild: ntild,
  ntilde: ntilde,
  ntlg: ntlg,
  ntriangleleft: ntriangleleft,
  ntrianglelefteq: ntrianglelefteq,
  ntriangleright: ntriangleright,
  ntrianglerighteq: ntrianglerighteq,
  nu: nu,
  num: num,
  numero: numero,
  numsp: numsp,
  nvDash: nvDash,
  nvHarr: nvHarr,
  nvap: nvap,
  nvdash: nvdash,
  nvge: nvge,
  nvgt: nvgt,
  nvinfin: nvinfin,
  nvlArr: nvlArr,
  nvle: nvle,
  nvlt: nvlt,
  nvltrie: nvltrie,
  nvrArr: nvrArr,
  nvrtrie: nvrtrie,
  nvsim: nvsim,
  nwArr: nwArr,
  nwarhk: nwarhk,
  nwarr: nwarr,
  nwarrow: nwarrow,
  nwnear: nwnear,
  oS: oS,
  oacut: oacut,
  oacute: oacute,
  oast: oast,
  ocir: ocir,
  ocirc: ocirc,
  ocy: ocy,
  odash: odash,
  odblac: odblac,
  odiv: odiv,
  odot: odot,
  odsold: odsold,
  oelig: oelig,
  ofcir: ofcir,
  ofr: ofr,
  ogon: ogon,
  ograv: ograv,
  ograve: ograve,
  ogt: ogt,
  ohbar: ohbar,
  ohm: ohm,
  oint: oint,
  olarr: olarr,
  olcir: olcir,
  olcross: olcross,
  oline: oline,
  olt: olt,
  omacr: omacr,
  omega: omega,
  omicron: omicron,
  omid: omid,
  ominus: ominus,
  oopf: oopf,
  opar: opar,
  operp: operp,
  oplus: oplus,
  or: or,
  orarr: orarr,
  ord: ord,
  order: order,
  orderof: orderof,
  ordf: ordf,
  ordm: ordm,
  origof: origof,
  oror: oror,
  orslope: orslope,
  orv: orv,
  oscr: oscr,
  oslas: oslas,
  oslash: oslash,
  osol: osol,
  otild: otild,
  otilde: otilde,
  otimes: otimes,
  otimesas: otimesas,
  oum: oum,
  ouml: ouml,
  ovbar: ovbar,
  par: par,
  para: para,
  parallel: parallel,
  parsim: parsim,
  parsl: parsl,
  part: part,
  pcy: pcy,
  percnt: percnt,
  period: period,
  permil: permil,
  perp: perp,
  pertenk: pertenk,
  pfr: pfr,
  phi: phi,
  phiv: phiv,
  phmmat: phmmat,
  phone: phone,
  pi: pi,
  pitchfork: pitchfork,
  piv: piv,
  planck: planck,
  planckh: planckh,
  plankv: plankv,
  plus: plus,
  plusacir: plusacir,
  plusb: plusb,
  pluscir: pluscir,
  plusdo: plusdo,
  plusdu: plusdu,
  pluse: pluse,
  plusm: plusm,
  plusmn: plusmn,
  plussim: plussim,
  plustwo: plustwo,
  pm: pm,
  pointint: pointint,
  popf: popf,
  poun: poun,
  pound: pound,
  pr: pr,
  prE: prE,
  prap: prap,
  prcue: prcue,
  pre: pre,
  prec: prec,
  precapprox: precapprox,
  preccurlyeq: preccurlyeq,
  preceq: preceq,
  precnapprox: precnapprox,
  precneqq: precneqq,
  precnsim: precnsim,
  precsim: precsim,
  prime: prime,
  primes: primes,
  prnE: prnE,
  prnap: prnap,
  prnsim: prnsim,
  prod: prod,
  profalar: profalar,
  profline: profline,
  profsurf: profsurf,
  prop: prop,
  propto: propto,
  prsim: prsim,
  prurel: prurel,
  pscr: pscr,
  psi: psi,
  puncsp: puncsp,
  qfr: qfr,
  qint: qint,
  qopf: qopf,
  qprime: qprime,
  qscr: qscr,
  quaternions: quaternions,
  quatint: quatint,
  quest: quest,
  questeq: questeq,
  quo: quo,
  quot: quot,
  rAarr: rAarr,
  rArr: rArr,
  rAtail: rAtail,
  rBarr: rBarr,
  rHar: rHar,
  race: race,
  racute: racute,
  radic: radic,
  raemptyv: raemptyv,
  rang: rang,
  rangd: rangd,
  range: range,
  rangle: rangle,
  raqu: raqu,
  raquo: raquo,
  rarr: rarr,
  rarrap: rarrap,
  rarrb: rarrb,
  rarrbfs: rarrbfs,
  rarrc: rarrc,
  rarrfs: rarrfs,
  rarrhk: rarrhk,
  rarrlp: rarrlp,
  rarrpl: rarrpl,
  rarrsim: rarrsim,
  rarrtl: rarrtl,
  rarrw: rarrw,
  ratail: ratail,
  ratio: ratio,
  rationals: rationals,
  rbarr: rbarr,
  rbbrk: rbbrk,
  rbrace: rbrace,
  rbrack: rbrack,
  rbrke: rbrke,
  rbrksld: rbrksld,
  rbrkslu: rbrkslu,
  rcaron: rcaron,
  rcedil: rcedil,
  rceil: rceil,
  rcub: rcub,
  rcy: rcy,
  rdca: rdca,
  rdldhar: rdldhar,
  rdquo: rdquo,
  rdquor: rdquor,
  rdsh: rdsh,
  real: real,
  realine: realine,
  realpart: realpart,
  reals: reals,
  rect: rect,
  re: re,
  reg: reg,
  rfisht: rfisht,
  rfloor: rfloor,
  rfr: rfr,
  rhard: rhard,
  rharu: rharu,
  rharul: rharul,
  rho: rho,
  rhov: rhov,
  rightarrow: rightarrow,
  rightarrowtail: rightarrowtail,
  rightharpoondown: rightharpoondown,
  rightharpoonup: rightharpoonup,
  rightleftarrows: rightleftarrows,
  rightleftharpoons: rightleftharpoons,
  rightrightarrows: rightrightarrows,
  rightsquigarrow: rightsquigarrow,
  rightthreetimes: rightthreetimes,
  ring: ring,
  risingdotseq: risingdotseq,
  rlarr: rlarr,
  rlhar: rlhar,
  rlm: rlm,
  rmoust: rmoust,
  rmoustache: rmoustache,
  rnmid: rnmid,
  roang: roang,
  roarr: roarr,
  robrk: robrk,
  ropar: ropar,
  ropf: ropf,
  roplus: roplus,
  rotimes: rotimes,
  rpar: rpar,
  rpargt: rpargt,
  rppolint: rppolint,
  rrarr: rrarr,
  rsaquo: rsaquo,
  rscr: rscr,
  rsh: rsh,
  rsqb: rsqb,
  rsquo: rsquo,
  rsquor: rsquor,
  rthree: rthree,
  rtimes: rtimes,
  rtri: rtri,
  rtrie: rtrie,
  rtrif: rtrif,
  rtriltri: rtriltri,
  ruluhar: ruluhar,
  rx: rx,
  sacute: sacute,
  sbquo: sbquo,
  sc: sc,
  scE: scE,
  scap: scap,
  scaron: scaron,
  sccue: sccue,
  sce: sce,
  scedil: scedil,
  scirc: scirc,
  scnE: scnE,
  scnap: scnap,
  scnsim: scnsim,
  scpolint: scpolint,
  scsim: scsim,
  scy: scy,
  sdot: sdot,
  sdotb: sdotb,
  sdote: sdote,
  seArr: seArr,
  searhk: searhk,
  searr: searr,
  searrow: searrow,
  sec: sec,
  sect: sect,
  semi: semi,
  seswar: seswar,
  setminus: setminus,
  setmn: setmn,
  sext: sext,
  sfr: sfr,
  sfrown: sfrown,
  sharp: sharp,
  shchcy: shchcy,
  shcy: shcy,
  shortmid: shortmid,
  shortparallel: shortparallel,
  sh: sh,
  shy: shy,
  sigma: sigma,
  sigmaf: sigmaf,
  sigmav: sigmav,
  sim: sim,
  simdot: simdot,
  sime: sime,
  simeq: simeq,
  simg: simg,
  simgE: simgE,
  siml: siml,
  simlE: simlE,
  simne: simne,
  simplus: simplus,
  simrarr: simrarr,
  slarr: slarr,
  smallsetminus: smallsetminus,
  smashp: smashp,
  smeparsl: smeparsl,
  smid: smid,
  smile: smile,
  smt: smt,
  smte: smte,
  smtes: smtes,
  softcy: softcy,
  sol: sol,
  solb: solb,
  solbar: solbar,
  sopf: sopf,
  spades: spades,
  spadesuit: spadesuit,
  spar: spar,
  sqcap: sqcap,
  sqcaps: sqcaps,
  sqcup: sqcup,
  sqcups: sqcups,
  sqsub: sqsub,
  sqsube: sqsube,
  sqsubset: sqsubset,
  sqsubseteq: sqsubseteq,
  sqsup: sqsup,
  sqsupe: sqsupe,
  sqsupset: sqsupset,
  sqsupseteq: sqsupseteq,
  squ: squ,
  square: square,
  squarf: squarf,
  squf: squf,
  srarr: srarr,
  sscr: sscr,
  ssetmn: ssetmn,
  ssmile: ssmile,
  sstarf: sstarf,
  star: star,
  starf: starf,
  straightepsilon: straightepsilon,
  straightphi: straightphi,
  strns: strns,
  sub: sub,
  subE: subE,
  subdot: subdot,
  sube: sube,
  subedot: subedot,
  submult: submult,
  subnE: subnE,
  subne: subne,
  subplus: subplus,
  subrarr: subrarr,
  subset: subset,
  subseteq: subseteq,
  subseteqq: subseteqq,
  subsetneq: subsetneq,
  subsetneqq: subsetneqq,
  subsim: subsim,
  subsub: subsub,
  subsup: subsup,
  succ: succ,
  succapprox: succapprox,
  succcurlyeq: succcurlyeq,
  succeq: succeq,
  succnapprox: succnapprox,
  succneqq: succneqq,
  succnsim: succnsim,
  succsim: succsim,
  sum: sum,
  sung: sung,
  sup: sup,
  sup1: sup1,
  sup2: sup2,
  sup3: sup3,
  supE: supE,
  supdot: supdot,
  supdsub: supdsub,
  supe: supe,
  supedot: supedot,
  suphsol: suphsol,
  suphsub: suphsub,
  suplarr: suplarr,
  supmult: supmult,
  supnE: supnE,
  supne: supne,
  supplus: supplus,
  supset: supset,
  supseteq: supseteq,
  supseteqq: supseteqq,
  supsetneq: supsetneq,
  supsetneqq: supsetneqq,
  supsim: supsim,
  supsub: supsub,
  supsup: supsup,
  swArr: swArr,
  swarhk: swarhk,
  swarr: swarr,
  swarrow: swarrow,
  swnwar: swnwar,
  szli: szli,
  szlig: szlig,
  target: target,
  tau: tau,
  tbrk: tbrk,
  tcaron: tcaron,
  tcedil: tcedil,
  tcy: tcy,
  tdot: tdot,
  telrec: telrec,
  tfr: tfr,
  there4: there4,
  therefore: therefore,
  theta: theta,
  thetasym: thetasym,
  thetav: thetav,
  thickapprox: thickapprox,
  thicksim: thicksim,
  thinsp: thinsp,
  thkap: thkap,
  thksim: thksim,
  thor: thor,
  thorn: thorn,
  tilde: tilde,
  time: time,
  times: times,
  timesb: timesb,
  timesbar: timesbar,
  timesd: timesd,
  tint: tint,
  toea: toea,
  top: top,
  topbot: topbot,
  topcir: topcir,
  topf: topf,
  topfork: topfork,
  tosa: tosa,
  tprime: tprime,
  trade: trade,
  triangle: triangle,
  triangledown: triangledown,
  triangleleft: triangleleft,
  trianglelefteq: trianglelefteq,
  triangleq: triangleq,
  triangleright: triangleright,
  trianglerighteq: trianglerighteq,
  tridot: tridot,
  trie: trie,
  triminus: triminus,
  triplus: triplus,
  trisb: trisb,
  tritime: tritime,
  trpezium: trpezium,
  tscr: tscr,
  tscy: tscy,
  tshcy: tshcy,
  tstrok: tstrok,
  twixt: twixt,
  twoheadleftarrow: twoheadleftarrow,
  twoheadrightarrow: twoheadrightarrow,
  uArr: uArr,
  uHar: uHar,
  uacut: uacut,
  uacute: uacute,
  uarr: uarr,
  ubrcy: ubrcy,
  ubreve: ubreve,
  ucir: ucir,
  ucirc: ucirc,
  ucy: ucy,
  udarr: udarr,
  udblac: udblac,
  udhar: udhar,
  ufisht: ufisht,
  ufr: ufr,
  ugrav: ugrav,
  ugrave: ugrave,
  uharl: uharl,
  uharr: uharr,
  uhblk: uhblk,
  ulcorn: ulcorn,
  ulcorner: ulcorner,
  ulcrop: ulcrop,
  ultri: ultri,
  umacr: umacr,
  um: um,
  uml: uml,
  uogon: uogon,
  uopf: uopf,
  uparrow: uparrow,
  updownarrow: updownarrow,
  upharpoonleft: upharpoonleft,
  upharpoonright: upharpoonright,
  uplus: uplus,
  upsi: upsi,
  upsih: upsih,
  upsilon: upsilon,
  upuparrows: upuparrows,
  urcorn: urcorn,
  urcorner: urcorner,
  urcrop: urcrop,
  uring: uring,
  urtri: urtri,
  uscr: uscr,
  utdot: utdot,
  utilde: utilde,
  utri: utri,
  utrif: utrif,
  uuarr: uuarr,
  uum: uum,
  uuml: uuml,
  uwangle: uwangle,
  vArr: vArr,
  vBar: vBar,
  vBarv: vBarv,
  vDash: vDash,
  vangrt: vangrt,
  varepsilon: varepsilon,
  varkappa: varkappa,
  varnothing: varnothing,
  varphi: varphi,
  varpi: varpi,
  varpropto: varpropto,
  varr: varr,
  varrho: varrho,
  varsigma: varsigma,
  varsubsetneq: varsubsetneq,
  varsubsetneqq: varsubsetneqq,
  varsupsetneq: varsupsetneq,
  varsupsetneqq: varsupsetneqq,
  vartheta: vartheta,
  vartriangleleft: vartriangleleft,
  vartriangleright: vartriangleright,
  vcy: vcy,
  vdash: vdash,
  vee: vee,
  veebar: veebar,
  veeeq: veeeq,
  vellip: vellip,
  verbar: verbar,
  vert: vert,
  vfr: vfr,
  vltri: vltri,
  vnsub: vnsub,
  vnsup: vnsup,
  vopf: vopf,
  vprop: vprop,
  vrtri: vrtri,
  vscr: vscr,
  vsubnE: vsubnE,
  vsubne: vsubne,
  vsupnE: vsupnE,
  vsupne: vsupne,
  vzigzag: vzigzag,
  wcirc: wcirc,
  wedbar: wedbar,
  wedge: wedge,
  wedgeq: wedgeq,
  weierp: weierp,
  wfr: wfr,
  wopf: wopf,
  wp: wp,
  wr: wr,
  wreath: wreath,
  wscr: wscr,
  xcap: xcap,
  xcirc: xcirc,
  xcup: xcup,
  xdtri: xdtri,
  xfr: xfr,
  xhArr: xhArr,
  xharr: xharr,
  xi: xi,
  xlArr: xlArr,
  xlarr: xlarr,
  xmap: xmap,
  xnis: xnis,
  xodot: xodot,
  xopf: xopf,
  xoplus: xoplus,
  xotime: xotime,
  xrArr: xrArr,
  xrarr: xrarr,
  xscr: xscr,
  xsqcup: xsqcup,
  xuplus: xuplus,
  xutri: xutri,
  xvee: xvee,
  xwedge: xwedge,
  yacut: yacut,
  yacute: yacute,
  yacy: yacy,
  ycirc: ycirc,
  ycy: ycy,
  ye: ye,
  yen: yen,
  yfr: yfr,
  yicy: yicy,
  yopf: yopf,
  yscr: yscr,
  yucy: yucy,
  yum: yum,
  yuml: yuml,
  zacute: zacute,
  zcaron: zcaron,
  zcy: zcy,
  zdot: zdot,
  zeetrf: zeetrf,
  zeta: zeta,
  zfr: zfr,
  zhcy: zhcy,
  zigrarr: zigrarr,
  zopf: zopf,
  zscr: zscr,
  zwj: zwj,
  zwnj: zwnj
};
var characterEntities = require$$0;
var decodeEntity_1 = decodeEntity$1;
var own$6 = {}.hasOwnProperty;
function decodeEntity$1(characters) {
  return own$6.call(characterEntities, characters) ? characterEntities[characters] : false;
}
var regexCheck$1 = regexCheck_1;
var asciiDigit$2 = regexCheck$1(/\d/);
var asciiDigit_1 = asciiDigit$2;
var regexCheck = regexCheck_1;
var asciiHexDigit$1 = regexCheck(/[\dA-Fa-f]/);
var asciiHexDigit_1 = asciiHexDigit$1;
var decodeEntity = decodeEntity_1;
var asciiAlphanumeric$3 = asciiAlphanumeric_1;
var asciiDigit$1 = asciiDigit_1;
var asciiHexDigit = asciiHexDigit_1;
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    default: e
  };
}
var decodeEntity__default = /*#__PURE__*/_interopDefaultLegacy(decodeEntity);
var characterReference$1 = {
  name: 'characterReference',
  tokenize: tokenizeCharacterReference
};
function tokenizeCharacterReference(effects, ok, nok) {
  var self = this;
  var size = 0;
  var max;
  var test;
  return start;
  function start(code) {
    effects.enter('characterReference');
    effects.enter('characterReferenceMarker');
    effects.consume(code);
    effects.exit('characterReferenceMarker');
    return open;
  }
  function open(code) {
    if (code === 35) {
      effects.enter('characterReferenceMarkerNumeric');
      effects.consume(code);
      effects.exit('characterReferenceMarkerNumeric');
      return numeric;
    }
    effects.enter('characterReferenceValue');
    max = 31;
    test = asciiAlphanumeric$3;
    return value(code);
  }
  function numeric(code) {
    if (code === 88 || code === 120) {
      effects.enter('characterReferenceMarkerHexadecimal');
      effects.consume(code);
      effects.exit('characterReferenceMarkerHexadecimal');
      effects.enter('characterReferenceValue');
      max = 6;
      test = asciiHexDigit;
      return value;
    }
    effects.enter('characterReferenceValue');
    max = 7;
    test = asciiDigit$1;
    return value(code);
  }
  function value(code) {
    var token;
    if (code === 59 && size) {
      token = effects.exit('characterReferenceValue');
      if (test === asciiAlphanumeric$3 && !decodeEntity__default['default'](self.sliceSerialize(token))) {
        return nok(code);
      }
      effects.enter('characterReferenceMarker');
      effects.consume(code);
      effects.exit('characterReferenceMarker');
      effects.exit('characterReference');
      return ok;
    }
    if (test(code) && size++ < max) {
      effects.consume(code);
      return value;
    }
    return nok(code);
  }
}
var characterReference_1 = characterReference$1;
var markdownLineEnding$e = markdownLineEnding_1;
var markdownLineEndingOrSpace$7 = markdownLineEndingOrSpace_1;
var prefixSize$3 = prefixSize_1;
var factorySpace$a = factorySpace$h;
var codeFenced$1 = {
  name: 'codeFenced',
  tokenize: tokenizeCodeFenced,
  concrete: true
};
function tokenizeCodeFenced(effects, ok, nok) {
  var self = this;
  var closingFenceConstruct = {
    tokenize: tokenizeClosingFence,
    partial: true
  };
  var initialPrefix = prefixSize$3(this.events, 'linePrefix');
  var sizeOpen = 0;
  var marker;
  return start;
  function start(code) {
    effects.enter('codeFenced');
    effects.enter('codeFencedFence');
    effects.enter('codeFencedFenceSequence');
    marker = code;
    return sequenceOpen(code);
  }
  function sequenceOpen(code) {
    if (code === marker) {
      effects.consume(code);
      sizeOpen++;
      return sequenceOpen;
    }
    effects.exit('codeFencedFenceSequence');
    return sizeOpen < 3 ? nok(code) : factorySpace$a(effects, infoOpen, 'whitespace')(code);
  }
  function infoOpen(code) {
    if (code === null || markdownLineEnding$e(code)) {
      return openAfter(code);
    }
    effects.enter('codeFencedFenceInfo');
    effects.enter('chunkString', {
      contentType: 'string'
    });
    return info(code);
  }
  function info(code) {
    if (code === null || markdownLineEndingOrSpace$7(code)) {
      effects.exit('chunkString');
      effects.exit('codeFencedFenceInfo');
      return factorySpace$a(effects, infoAfter, 'whitespace')(code);
    }
    if (code === 96 && code === marker) return nok(code);
    effects.consume(code);
    return info;
  }
  function infoAfter(code) {
    if (code === null || markdownLineEnding$e(code)) {
      return openAfter(code);
    }
    effects.enter('codeFencedFenceMeta');
    effects.enter('chunkString', {
      contentType: 'string'
    });
    return meta(code);
  }
  function meta(code) {
    if (code === null || markdownLineEnding$e(code)) {
      effects.exit('chunkString');
      effects.exit('codeFencedFenceMeta');
      return openAfter(code);
    }
    if (code === 96 && code === marker) return nok(code);
    effects.consume(code);
    return meta;
  }
  function openAfter(code) {
    effects.exit('codeFencedFence');
    return self.interrupt ? ok(code) : content(code);
  }
  function content(code) {
    if (code === null) {
      return after(code);
    }
    if (markdownLineEnding$e(code)) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      return effects.attempt(closingFenceConstruct, after, initialPrefix ? factorySpace$a(effects, content, 'linePrefix', initialPrefix + 1) : content);
    }
    effects.enter('codeFlowValue');
    return contentContinue(code);
  }
  function contentContinue(code) {
    if (code === null || markdownLineEnding$e(code)) {
      effects.exit('codeFlowValue');
      return content(code);
    }
    effects.consume(code);
    return contentContinue;
  }
  function after(code) {
    effects.exit('codeFenced');
    return ok(code);
  }
  function tokenizeClosingFence(effects, ok, nok) {
    var size = 0;
    return factorySpace$a(effects, closingSequenceStart, 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
    function closingSequenceStart(code) {
      effects.enter('codeFencedFence');
      effects.enter('codeFencedFenceSequence');
      return closingSequence(code);
    }
    function closingSequence(code) {
      if (code === marker) {
        effects.consume(code);
        size++;
        return closingSequence;
      }
      if (size < sizeOpen) return nok(code);
      effects.exit('codeFencedFenceSequence');
      return factorySpace$a(effects, closingSequenceEnd, 'whitespace')(code);
    }
    function closingSequenceEnd(code) {
      if (code === null || markdownLineEnding$e(code)) {
        effects.exit('codeFencedFence');
        return ok(code);
      }
      return nok(code);
    }
  }
}
var codeFenced_1 = codeFenced$1;
var markdownLineEnding$d = markdownLineEnding_1;
var chunkedSplice$3 = chunkedSplice_1;
var prefixSize$2 = prefixSize_1;
var factorySpace$9 = factorySpace$h;
var codeIndented$1 = {
  name: 'codeIndented',
  tokenize: tokenizeCodeIndented,
  resolve: resolveCodeIndented
};
var indentedContentConstruct = {
  tokenize: tokenizeIndentedContent,
  partial: true
};
function resolveCodeIndented(events, context) {
  var code = {
    type: 'codeIndented',
    start: events[0][1].start,
    end: events[events.length - 1][1].end
  };
  chunkedSplice$3(events, 0, 0, [['enter', code, context]]);
  chunkedSplice$3(events, events.length, 0, [['exit', code, context]]);
  return events;
}
function tokenizeCodeIndented(effects, ok, nok) {
  return effects.attempt(indentedContentConstruct, afterPrefix, nok);
  function afterPrefix(code) {
    if (code === null) {
      return ok(code);
    }
    if (markdownLineEnding$d(code)) {
      return effects.attempt(indentedContentConstruct, afterPrefix, ok)(code);
    }
    effects.enter('codeFlowValue');
    return content(code);
  }
  function content(code) {
    if (code === null || markdownLineEnding$d(code)) {
      effects.exit('codeFlowValue');
      return afterPrefix(code);
    }
    effects.consume(code);
    return content;
  }
}
function tokenizeIndentedContent(effects, ok, nok) {
  var self = this;
  return factorySpace$9(effects, afterPrefix, 'linePrefix', 4 + 1);
  function afterPrefix(code) {
    if (markdownLineEnding$d(code)) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      return factorySpace$9(effects, afterPrefix, 'linePrefix', 4 + 1);
    }
    return prefixSize$2(self.events, 'linePrefix') < 4 ? nok(code) : ok(code);
  }
}
var codeIndented_1 = codeIndented$1;
var markdownLineEnding$c = markdownLineEnding_1;
var codeText$1 = {
  name: 'codeText',
  tokenize: tokenizeCodeText,
  resolve: resolveCodeText,
  previous: previous$2
};
function resolveCodeText(events) {
  var tailExitIndex = events.length - 4;
  var headEnterIndex = 3;
  var index;
  var enter; // If we start and end with an EOL or a space.

  if ((events[headEnterIndex][1].type === 'lineEnding' || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === 'lineEnding' || events[tailExitIndex][1].type === 'space')) {
    index = headEnterIndex; // And we have data.

    while (++index < tailExitIndex) {
      if (events[index][1].type === 'codeTextData') {
        // Then we have padding.
        events[tailExitIndex][1].type = events[headEnterIndex][1].type = 'codeTextPadding';
        headEnterIndex += 2;
        tailExitIndex -= 2;
        break;
      }
    }
  } // Merge adjacent spaces and data.

  index = headEnterIndex - 1;
  tailExitIndex++;
  while (++index <= tailExitIndex) {
    if (enter === undefined) {
      if (index !== tailExitIndex && events[index][1].type !== 'lineEnding') {
        enter = index;
      }
    } else if (index === tailExitIndex || events[index][1].type === 'lineEnding') {
      events[enter][1].type = 'codeTextData';
      if (index !== enter + 2) {
        events[enter][1].end = events[index - 1][1].end;
        events.splice(enter + 2, index - enter - 2);
        tailExitIndex -= index - enter - 2;
        index = enter + 2;
      }
      enter = undefined;
    }
  }
  return events;
}
function previous$2(code) {
  // If there is a previous code, there will always be a tail.
  return code !== 96 || this.events[this.events.length - 1][1].type === 'characterEscape';
}
function tokenizeCodeText(effects, ok, nok) {
  var sizeOpen = 0;
  var size;
  var token;
  return start;
  function start(code) {
    effects.enter('codeText');
    effects.enter('codeTextSequence');
    return openingSequence(code);
  }
  function openingSequence(code) {
    if (code === 96) {
      effects.consume(code);
      sizeOpen++;
      return openingSequence;
    }
    effects.exit('codeTextSequence');
    return gap(code);
  }
  function gap(code) {
    // EOF.
    if (code === null) {
      return nok(code);
    } // Closing fence?
    // Could also be data.

    if (code === 96) {
      token = effects.enter('codeTextSequence');
      size = 0;
      return closingSequence(code);
    } // Tabs don’t work, and virtual spaces don’t make sense.

    if (code === 32) {
      effects.enter('space');
      effects.consume(code);
      effects.exit('space');
      return gap;
    }
    if (markdownLineEnding$c(code)) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      return gap;
    } // Data.

    effects.enter('codeTextData');
    return data(code);
  } // In code.

  function data(code) {
    if (code === null || code === 32 || code === 96 || markdownLineEnding$c(code)) {
      effects.exit('codeTextData');
      return gap(code);
    }
    effects.consume(code);
    return data;
  } // Closing fence.

  function closingSequence(code) {
    // More.
    if (code === 96) {
      effects.consume(code);
      size++;
      return closingSequence;
    } // Done!

    if (size === sizeOpen) {
      effects.exit('codeTextSequence');
      effects.exit('codeText');
      return ok(code);
    } // More or less accents: mark as data.

    token.type = 'codeTextData';
    return data(code);
  }
}
var codeText_1 = codeText$1;
var asciiControl$1 = asciiControl_1;
var markdownLineEndingOrSpace$6 = markdownLineEndingOrSpace_1;
var markdownLineEnding$b = markdownLineEnding_1;

// eslint-disable-next-line max-params
function destinationFactory(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
  var limit = max || Infinity;
  var balance = 0;
  return start;
  function start(code) {
    if (code === 60) {
      effects.enter(type);
      effects.enter(literalType);
      effects.enter(literalMarkerType);
      effects.consume(code);
      effects.exit(literalMarkerType);
      return destinationEnclosedBefore;
    }
    if (asciiControl$1(code) || code === 41) {
      return nok(code);
    }
    effects.enter(type);
    effects.enter(rawType);
    effects.enter(stringType);
    effects.enter('chunkString', {
      contentType: 'string'
    });
    return destinationRaw(code);
  }
  function destinationEnclosedBefore(code) {
    if (code === 62) {
      effects.enter(literalMarkerType);
      effects.consume(code);
      effects.exit(literalMarkerType);
      effects.exit(literalType);
      effects.exit(type);
      return ok;
    }
    effects.enter(stringType);
    effects.enter('chunkString', {
      contentType: 'string'
    });
    return destinationEnclosed(code);
  }
  function destinationEnclosed(code) {
    if (code === 62) {
      effects.exit('chunkString');
      effects.exit(stringType);
      return destinationEnclosedBefore(code);
    }
    if (code === null || code === 60 || markdownLineEnding$b(code)) {
      return nok(code);
    }
    effects.consume(code);
    return code === 92 ? destinationEnclosedEscape : destinationEnclosed;
  }
  function destinationEnclosedEscape(code) {
    if (code === 60 || code === 62 || code === 92) {
      effects.consume(code);
      return destinationEnclosed;
    }
    return destinationEnclosed(code);
  }
  function destinationRaw(code) {
    if (code === 40) {
      if (++balance > limit) return nok(code);
      effects.consume(code);
      return destinationRaw;
    }
    if (code === 41) {
      if (!balance--) {
        effects.exit('chunkString');
        effects.exit(stringType);
        effects.exit(rawType);
        effects.exit(type);
        return ok(code);
      }
      effects.consume(code);
      return destinationRaw;
    }
    if (code === null || markdownLineEndingOrSpace$6(code)) {
      if (balance) return nok(code);
      effects.exit('chunkString');
      effects.exit(stringType);
      effects.exit(rawType);
      effects.exit(type);
      return ok(code);
    }
    if (asciiControl$1(code)) return nok(code);
    effects.consume(code);
    return code === 92 ? destinationRawEscape : destinationRaw;
  }
  function destinationRawEscape(code) {
    if (code === 40 || code === 41 || code === 92) {
      effects.consume(code);
      return destinationRaw;
    }
    return destinationRaw(code);
  }
}
var factoryDestination$2 = destinationFactory;
var markdownLineEnding$a = markdownLineEnding_1;
var markdownSpace$6 = markdownSpace_1;

// eslint-disable-next-line max-params
function labelFactory(effects, ok, nok, type, markerType, stringType) {
  var self = this;
  var size = 0;
  var data;
  return start;
  function start(code) {
    effects.enter(type);
    effects.enter(markerType);
    effects.consume(code);
    effects.exit(markerType);
    effects.enter(stringType);
    return atBreak;
  }
  function atBreak(code) {
    if (code === null || code === 91 || code === 93 && !data || (/* c8 ignore next */
    code === 94 && /* c8 ignore next */
    !size && /* c8 ignore next */
    '_hiddenFootnoteSupport' in self.parser.constructs) || size > 999) {
      return nok(code);
    }
    if (code === 93) {
      effects.exit(stringType);
      effects.enter(markerType);
      effects.consume(code);
      effects.exit(markerType);
      effects.exit(type);
      return ok;
    }
    if (markdownLineEnding$a(code)) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      return atBreak;
    }
    effects.enter('chunkString', {
      contentType: 'string'
    });
    return label(code);
  }
  function label(code) {
    if (code === null || code === 91 || code === 93 || markdownLineEnding$a(code) || size++ > 999) {
      effects.exit('chunkString');
      return atBreak(code);
    }
    effects.consume(code);
    data = data || !markdownSpace$6(code);
    return code === 92 ? labelEscape : label;
  }
  function labelEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code);
      size++;
      return label;
    }
    return label(code);
  }
}
var factoryLabel$2 = labelFactory;
var markdownLineEnding$9 = markdownLineEnding_1;
var markdownSpace$5 = markdownSpace_1;
var factorySpace$8 = factorySpace$h;
function whitespaceFactory(effects, ok) {
  var seen;
  return start;
  function start(code) {
    if (markdownLineEnding$9(code)) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      seen = true;
      return start;
    }
    if (markdownSpace$5(code)) {
      return factorySpace$8(effects, start, seen ? 'linePrefix' : 'lineSuffix')(code);
    }
    return ok(code);
  }
}
var factoryWhitespace$2 = whitespaceFactory;
var markdownLineEnding$8 = markdownLineEnding_1;
var factorySpace$7 = factorySpace$h;
function titleFactory(effects, ok, nok, type, markerType, stringType) {
  var marker;
  return start;
  function start(code) {
    effects.enter(type);
    effects.enter(markerType);
    effects.consume(code);
    effects.exit(markerType);
    marker = code === 40 ? 41 : code;
    return atFirstTitleBreak;
  }
  function atFirstTitleBreak(code) {
    if (code === marker) {
      effects.enter(markerType);
      effects.consume(code);
      effects.exit(markerType);
      effects.exit(type);
      return ok;
    }
    effects.enter(stringType);
    return atTitleBreak(code);
  }
  function atTitleBreak(code) {
    if (code === marker) {
      effects.exit(stringType);
      return atFirstTitleBreak(marker);
    }
    if (code === null) {
      return nok(code);
    } // Note: blank lines can’t exist in content.

    if (markdownLineEnding$8(code)) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      return factorySpace$7(effects, atTitleBreak, 'linePrefix');
    }
    effects.enter('chunkString', {
      contentType: 'string'
    });
    return title(code);
  }
  function title(code) {
    if (code === marker || code === null || markdownLineEnding$8(code)) {
      effects.exit('chunkString');
      return atTitleBreak(code);
    }
    effects.consume(code);
    return code === 92 ? titleEscape : title;
  }
  function titleEscape(code) {
    if (code === marker || code === 92) {
      effects.consume(code);
      return title;
    }
    return title(code);
  }
}
var factoryTitle$2 = titleFactory;
var markdownLineEnding$7 = markdownLineEnding_1;
var markdownLineEndingOrSpace$5 = markdownLineEndingOrSpace_1;
var normalizeIdentifier$2 = normalizeIdentifier_1;
var factoryDestination$1 = factoryDestination$2;
var factoryLabel$1 = factoryLabel$2;
var factorySpace$6 = factorySpace$h;
var factoryWhitespace$1 = factoryWhitespace$2;
var factoryTitle$1 = factoryTitle$2;
var definition$1 = {
  name: 'definition',
  tokenize: tokenizeDefinition
};
var titleConstruct = {
  tokenize: tokenizeTitle,
  partial: true
};
function tokenizeDefinition(effects, ok, nok) {
  var self = this;
  var identifier;
  return start;
  function start(code) {
    effects.enter('definition');
    return factoryLabel$1.call(self, effects, labelAfter, nok, 'definitionLabel', 'definitionLabelMarker', 'definitionLabelString')(code);
  }
  function labelAfter(code) {
    identifier = normalizeIdentifier$2(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
    if (code === 58) {
      effects.enter('definitionMarker');
      effects.consume(code);
      effects.exit('definitionMarker'); // Note: blank lines can’t exist in content.

      return factoryWhitespace$1(effects, factoryDestination$1(effects, effects.attempt(titleConstruct, factorySpace$6(effects, after, 'whitespace'), factorySpace$6(effects, after, 'whitespace')), nok, 'definitionDestination', 'definitionDestinationLiteral', 'definitionDestinationLiteralMarker', 'definitionDestinationRaw', 'definitionDestinationString'));
    }
    return nok(code);
  }
  function after(code) {
    if (code === null || markdownLineEnding$7(code)) {
      effects.exit('definition');
      if (self.parser.defined.indexOf(identifier) < 0) {
        self.parser.defined.push(identifier);
      }
      return ok(code);
    }
    return nok(code);
  }
}
function tokenizeTitle(effects, ok, nok) {
  return start;
  function start(code) {
    return markdownLineEndingOrSpace$5(code) ? factoryWhitespace$1(effects, before)(code) : nok(code);
  }
  function before(code) {
    if (code === 34 || code === 39 || code === 40) {
      return factoryTitle$1(effects, factorySpace$6(effects, after, 'whitespace'), nok, 'definitionTitle', 'definitionTitleMarker', 'definitionTitleString')(code);
    }
    return nok(code);
  }
  function after(code) {
    return code === null || markdownLineEnding$7(code) ? ok(code) : nok(code);
  }
}
var definition_1 = definition$1;
var markdownLineEnding$6 = markdownLineEnding_1;
var hardBreakEscape$1 = {
  name: 'hardBreakEscape',
  tokenize: tokenizeHardBreakEscape
};
function tokenizeHardBreakEscape(effects, ok, nok) {
  return start;
  function start(code) {
    effects.enter('hardBreakEscape');
    effects.enter('escapeMarker');
    effects.consume(code);
    return open;
  }
  function open(code) {
    if (markdownLineEnding$6(code)) {
      effects.exit('escapeMarker');
      effects.exit('hardBreakEscape');
      return ok(code);
    }
    return nok(code);
  }
}
var hardBreakEscape_1 = hardBreakEscape$1;
var markdownLineEnding$5 = markdownLineEnding_1;
var markdownLineEndingOrSpace$4 = markdownLineEndingOrSpace_1;
var markdownSpace$4 = markdownSpace_1;
var chunkedSplice$2 = chunkedSplice_1;
var factorySpace$5 = factorySpace$h;
var headingAtx$1 = {
  name: 'headingAtx',
  tokenize: tokenizeHeadingAtx,
  resolve: resolveHeadingAtx
};
function resolveHeadingAtx(events, context) {
  var contentEnd = events.length - 2;
  var contentStart = 3;
  var content;
  var text; // Prefix whitespace, part of the opening.

  if (events[contentStart][1].type === 'whitespace') {
    contentStart += 2;
  } // Suffix whitespace, part of the closing.

  if (contentEnd - 2 > contentStart && events[contentEnd][1].type === 'whitespace') {
    contentEnd -= 2;
  }
  if (events[contentEnd][1].type === 'atxHeadingSequence' && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === 'whitespace')) {
    contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
  }
  if (contentEnd > contentStart) {
    content = {
      type: 'atxHeadingText',
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end
    };
    text = {
      type: 'chunkText',
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end,
      contentType: 'text'
    };
    chunkedSplice$2(events, contentStart, contentEnd - contentStart + 1, [['enter', content, context], ['enter', text, context], ['exit', text, context], ['exit', content, context]]);
  }
  return events;
}
function tokenizeHeadingAtx(effects, ok, nok) {
  var self = this;
  var size = 0;
  return start;
  function start(code) {
    effects.enter('atxHeading');
    effects.enter('atxHeadingSequence');
    return fenceOpenInside(code);
  }
  function fenceOpenInside(code) {
    if (code === 35 && size++ < 6) {
      effects.consume(code);
      return fenceOpenInside;
    }
    if (code === null || markdownLineEndingOrSpace$4(code)) {
      effects.exit('atxHeadingSequence');
      return self.interrupt ? ok(code) : headingBreak(code);
    }
    return nok(code);
  }
  function headingBreak(code) {
    if (code === 35) {
      effects.enter('atxHeadingSequence');
      return sequence(code);
    }
    if (code === null || markdownLineEnding$5(code)) {
      effects.exit('atxHeading');
      return ok(code);
    }
    if (markdownSpace$4(code)) {
      return factorySpace$5(effects, headingBreak, 'whitespace')(code);
    }
    effects.enter('atxHeadingText');
    return data(code);
  }
  function sequence(code) {
    if (code === 35) {
      effects.consume(code);
      return sequence;
    }
    effects.exit('atxHeadingSequence');
    return headingBreak(code);
  }
  function data(code) {
    if (code === null || code === 35 || markdownLineEndingOrSpace$4(code)) {
      effects.exit('atxHeadingText');
      return headingBreak(code);
    }
    effects.consume(code);
    return data;
  }
}
var headingAtx_1 = headingAtx$1;

// This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.
var basics = ['address', 'article', 'aside', 'base', 'basefont', 'blockquote', 'body', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dialog', 'dir', 'div', 'dl', 'dt', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hr', 'html', 'iframe', 'legend', 'li', 'link', 'main', 'menu', 'menuitem', 'nav', 'noframes', 'ol', 'optgroup', 'option', 'p', 'param', 'section', 'source', 'summary', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul'];
var htmlBlockNames$1 = basics;

// This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.
var raws = ['pre', 'script', 'style', 'textarea'];
var htmlRawNames$1 = raws;
var asciiAlpha$2 = asciiAlpha_1;
var asciiAlphanumeric$2 = asciiAlphanumeric_1;
var markdownLineEnding$4 = markdownLineEnding_1;
var markdownLineEndingOrSpace$3 = markdownLineEndingOrSpace_1;
var markdownSpace$3 = markdownSpace_1;
var fromCharCode = fromCharCode_1;
var htmlBlockNames = htmlBlockNames$1;
var htmlRawNames = htmlRawNames$1;
var partialBlankLine$1 = partialBlankLine_1;
var htmlFlow$1 = {
  name: 'htmlFlow',
  tokenize: tokenizeHtmlFlow,
  resolveTo: resolveToHtmlFlow,
  concrete: true
};
var nextBlankConstruct = {
  tokenize: tokenizeNextBlank,
  partial: true
};
function resolveToHtmlFlow(events) {
  var index = events.length;
  while (index--) {
    if (events[index][0] === 'enter' && events[index][1].type === 'htmlFlow') {
      break;
    }
  }
  if (index > 1 && events[index - 2][1].type === 'linePrefix') {
    // Add the prefix start to the HTML token.
    events[index][1].start = events[index - 2][1].start; // Add the prefix start to the HTML line token.

    events[index + 1][1].start = events[index - 2][1].start; // Remove the line prefix.

    events.splice(index - 2, 2);
  }
  return events;
}
function tokenizeHtmlFlow(effects, ok, nok) {
  var self = this;
  var kind;
  var startTag;
  var buffer;
  var index;
  var marker;
  return start;
  function start(code) {
    effects.enter('htmlFlow');
    effects.enter('htmlFlowData');
    effects.consume(code);
    return open;
  }
  function open(code) {
    if (code === 33) {
      effects.consume(code);
      return declarationStart;
    }
    if (code === 47) {
      effects.consume(code);
      return tagCloseStart;
    }
    if (code === 63) {
      effects.consume(code);
      kind = 3; // While we’re in an instruction instead of a declaration, we’re on a `?`
      // right now, so we do need to search for `>`, similar to declarations.

      return self.interrupt ? ok : continuationDeclarationInside;
    }
    if (asciiAlpha$2(code)) {
      effects.consume(code);
      buffer = fromCharCode(code);
      startTag = true;
      return tagName;
    }
    return nok(code);
  }
  function declarationStart(code) {
    if (code === 45) {
      effects.consume(code);
      kind = 2;
      return commentOpenInside;
    }
    if (code === 91) {
      effects.consume(code);
      kind = 5;
      buffer = 'CDATA[';
      index = 0;
      return cdataOpenInside;
    }
    if (asciiAlpha$2(code)) {
      effects.consume(code);
      kind = 4;
      return self.interrupt ? ok : continuationDeclarationInside;
    }
    return nok(code);
  }
  function commentOpenInside(code) {
    if (code === 45) {
      effects.consume(code);
      return self.interrupt ? ok : continuationDeclarationInside;
    }
    return nok(code);
  }
  function cdataOpenInside(code) {
    if (code === buffer.charCodeAt(index++)) {
      effects.consume(code);
      return index === buffer.length ? self.interrupt ? ok : continuation : cdataOpenInside;
    }
    return nok(code);
  }
  function tagCloseStart(code) {
    if (asciiAlpha$2(code)) {
      effects.consume(code);
      buffer = fromCharCode(code);
      return tagName;
    }
    return nok(code);
  }
  function tagName(code) {
    if (code === null || code === 47 || code === 62 || markdownLineEndingOrSpace$3(code)) {
      if (code !== 47 && startTag && htmlRawNames.indexOf(buffer.toLowerCase()) > -1) {
        kind = 1;
        return self.interrupt ? ok(code) : continuation(code);
      }
      if (htmlBlockNames.indexOf(buffer.toLowerCase()) > -1) {
        kind = 6;
        if (code === 47) {
          effects.consume(code);
          return basicSelfClosing;
        }
        return self.interrupt ? ok(code) : continuation(code);
      }
      kind = 7; // Do not support complete HTML when interrupting.

      return self.interrupt ? nok(code) : startTag ? completeAttributeNameBefore(code) : completeClosingTagAfter(code);
    }
    if (code === 45 || asciiAlphanumeric$2(code)) {
      effects.consume(code);
      buffer += fromCharCode(code);
      return tagName;
    }
    return nok(code);
  }
  function basicSelfClosing(code) {
    if (code === 62) {
      effects.consume(code);
      return self.interrupt ? ok : continuation;
    }
    return nok(code);
  }
  function completeClosingTagAfter(code) {
    if (markdownSpace$3(code)) {
      effects.consume(code);
      return completeClosingTagAfter;
    }
    return completeEnd(code);
  }
  function completeAttributeNameBefore(code) {
    if (code === 47) {
      effects.consume(code);
      return completeEnd;
    }
    if (code === 58 || code === 95 || asciiAlpha$2(code)) {
      effects.consume(code);
      return completeAttributeName;
    }
    if (markdownSpace$3(code)) {
      effects.consume(code);
      return completeAttributeNameBefore;
    }
    return completeEnd(code);
  }
  function completeAttributeName(code) {
    if (code === 45 || code === 46 || code === 58 || code === 95 || asciiAlphanumeric$2(code)) {
      effects.consume(code);
      return completeAttributeName;
    }
    return completeAttributeNameAfter(code);
  }
  function completeAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code);
      return completeAttributeValueBefore;
    }
    if (markdownSpace$3(code)) {
      effects.consume(code);
      return completeAttributeNameAfter;
    }
    return completeAttributeNameBefore(code);
  }
  function completeAttributeValueBefore(code) {
    if (code === null || code === 60 || code === 61 || code === 62 || code === 96) {
      return nok(code);
    }
    if (code === 34 || code === 39) {
      effects.consume(code);
      marker = code;
      return completeAttributeValueQuoted;
    }
    if (markdownSpace$3(code)) {
      effects.consume(code);
      return completeAttributeValueBefore;
    }
    marker = undefined;
    return completeAttributeValueUnquoted(code);
  }
  function completeAttributeValueQuoted(code) {
    if (code === marker) {
      effects.consume(code);
      return completeAttributeValueQuotedAfter;
    }
    if (code === null || markdownLineEnding$4(code)) {
      return nok(code);
    }
    effects.consume(code);
    return completeAttributeValueQuoted;
  }
  function completeAttributeValueUnquoted(code) {
    if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 62 || code === 96 || markdownLineEndingOrSpace$3(code)) {
      return completeAttributeNameAfter(code);
    }
    effects.consume(code);
    return completeAttributeValueUnquoted;
  }
  function completeAttributeValueQuotedAfter(code) {
    if (code === 47 || code === 62 || markdownSpace$3(code)) {
      return completeAttributeNameBefore(code);
    }
    return nok(code);
  }
  function completeEnd(code) {
    if (code === 62) {
      effects.consume(code);
      return completeAfter;
    }
    return nok(code);
  }
  function completeAfter(code) {
    if (markdownSpace$3(code)) {
      effects.consume(code);
      return completeAfter;
    }
    return code === null || markdownLineEnding$4(code) ? continuation(code) : nok(code);
  }
  function continuation(code) {
    if (code === 45 && kind === 2) {
      effects.consume(code);
      return continuationCommentInside;
    }
    if (code === 60 && kind === 1) {
      effects.consume(code);
      return continuationRawTagOpen;
    }
    if (code === 62 && kind === 4) {
      effects.consume(code);
      return continuationClose;
    }
    if (code === 63 && kind === 3) {
      effects.consume(code);
      return continuationDeclarationInside;
    }
    if (code === 93 && kind === 5) {
      effects.consume(code);
      return continuationCharacterDataInside;
    }
    if (markdownLineEnding$4(code) && (kind === 6 || kind === 7)) {
      return effects.check(nextBlankConstruct, continuationClose, continuationAtLineEnding)(code);
    }
    if (code === null || markdownLineEnding$4(code)) {
      return continuationAtLineEnding(code);
    }
    effects.consume(code);
    return continuation;
  }
  function continuationAtLineEnding(code) {
    effects.exit('htmlFlowData');
    return htmlContinueStart(code);
  }
  function htmlContinueStart(code) {
    if (code === null) {
      return done(code);
    }
    if (markdownLineEnding$4(code)) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      return htmlContinueStart;
    }
    effects.enter('htmlFlowData');
    return continuation(code);
  }
  function continuationCommentInside(code) {
    if (code === 45) {
      effects.consume(code);
      return continuationDeclarationInside;
    }
    return continuation(code);
  }
  function continuationRawTagOpen(code) {
    if (code === 47) {
      effects.consume(code);
      buffer = '';
      return continuationRawEndTag;
    }
    return continuation(code);
  }
  function continuationRawEndTag(code) {
    if (code === 62 && htmlRawNames.indexOf(buffer.toLowerCase()) > -1) {
      effects.consume(code);
      return continuationClose;
    }
    if (asciiAlpha$2(code) && buffer.length < 8) {
      effects.consume(code);
      buffer += fromCharCode(code);
      return continuationRawEndTag;
    }
    return continuation(code);
  }
  function continuationCharacterDataInside(code) {
    if (code === 93) {
      effects.consume(code);
      return continuationDeclarationInside;
    }
    return continuation(code);
  }
  function continuationDeclarationInside(code) {
    if (code === 62) {
      effects.consume(code);
      return continuationClose;
    }
    return continuation(code);
  }
  function continuationClose(code) {
    if (code === null || markdownLineEnding$4(code)) {
      effects.exit('htmlFlowData');
      return done(code);
    }
    effects.consume(code);
    return continuationClose;
  }
  function done(code) {
    effects.exit('htmlFlow');
    return ok(code);
  }
}
function tokenizeNextBlank(effects, ok, nok) {
  return start;
  function start(code) {
    effects.exit('htmlFlowData');
    effects.enter('lineEndingBlank');
    effects.consume(code);
    effects.exit('lineEndingBlank');
    return effects.attempt(partialBlankLine$1, ok, nok);
  }
}
var htmlFlow_1 = htmlFlow$1;
var asciiAlpha$1 = asciiAlpha_1;
var asciiAlphanumeric$1 = asciiAlphanumeric_1;
var markdownLineEnding$3 = markdownLineEnding_1;
var markdownLineEndingOrSpace$2 = markdownLineEndingOrSpace_1;
var markdownSpace$2 = markdownSpace_1;
var factorySpace$4 = factorySpace$h;
var htmlText$1 = {
  name: 'htmlText',
  tokenize: tokenizeHtmlText
};
function tokenizeHtmlText(effects, ok, nok) {
  var self = this;
  var marker;
  var buffer;
  var index;
  var returnState;
  return start;
  function start(code) {
    effects.enter('htmlText');
    effects.enter('htmlTextData');
    effects.consume(code);
    return open;
  }
  function open(code) {
    if (code === 33) {
      effects.consume(code);
      return declarationOpen;
    }
    if (code === 47) {
      effects.consume(code);
      return tagCloseStart;
    }
    if (code === 63) {
      effects.consume(code);
      return instruction;
    }
    if (asciiAlpha$1(code)) {
      effects.consume(code);
      return tagOpen;
    }
    return nok(code);
  }
  function declarationOpen(code) {
    if (code === 45) {
      effects.consume(code);
      return commentOpen;
    }
    if (code === 91) {
      effects.consume(code);
      buffer = 'CDATA[';
      index = 0;
      return cdataOpen;
    }
    if (asciiAlpha$1(code)) {
      effects.consume(code);
      return declaration;
    }
    return nok(code);
  }
  function commentOpen(code) {
    if (code === 45) {
      effects.consume(code);
      return commentStart;
    }
    return nok(code);
  }
  function commentStart(code) {
    if (code === null || code === 62) {
      return nok(code);
    }
    if (code === 45) {
      effects.consume(code);
      return commentStartDash;
    }
    return comment(code);
  }
  function commentStartDash(code) {
    if (code === null || code === 62) {
      return nok(code);
    }
    return comment(code);
  }
  function comment(code) {
    if (code === null) {
      return nok(code);
    }
    if (code === 45) {
      effects.consume(code);
      return commentClose;
    }
    if (markdownLineEnding$3(code)) {
      returnState = comment;
      return atLineEnding(code);
    }
    effects.consume(code);
    return comment;
  }
  function commentClose(code) {
    if (code === 45) {
      effects.consume(code);
      return end;
    }
    return comment(code);
  }
  function cdataOpen(code) {
    if (code === buffer.charCodeAt(index++)) {
      effects.consume(code);
      return index === buffer.length ? cdata : cdataOpen;
    }
    return nok(code);
  }
  function cdata(code) {
    if (code === null) {
      return nok(code);
    }
    if (code === 93) {
      effects.consume(code);
      return cdataClose;
    }
    if (markdownLineEnding$3(code)) {
      returnState = cdata;
      return atLineEnding(code);
    }
    effects.consume(code);
    return cdata;
  }
  function cdataClose(code) {
    if (code === 93) {
      effects.consume(code);
      return cdataEnd;
    }
    return cdata(code);
  }
  function cdataEnd(code) {
    if (code === 62) {
      return end(code);
    }
    if (code === 93) {
      effects.consume(code);
      return cdataEnd;
    }
    return cdata(code);
  }
  function declaration(code) {
    if (code === null || code === 62) {
      return end(code);
    }
    if (markdownLineEnding$3(code)) {
      returnState = declaration;
      return atLineEnding(code);
    }
    effects.consume(code);
    return declaration;
  }
  function instruction(code) {
    if (code === null) {
      return nok(code);
    }
    if (code === 63) {
      effects.consume(code);
      return instructionClose;
    }
    if (markdownLineEnding$3(code)) {
      returnState = instruction;
      return atLineEnding(code);
    }
    effects.consume(code);
    return instruction;
  }
  function instructionClose(code) {
    return code === 62 ? end(code) : instruction(code);
  }
  function tagCloseStart(code) {
    if (asciiAlpha$1(code)) {
      effects.consume(code);
      return tagClose;
    }
    return nok(code);
  }
  function tagClose(code) {
    if (code === 45 || asciiAlphanumeric$1(code)) {
      effects.consume(code);
      return tagClose;
    }
    return tagCloseBetween(code);
  }
  function tagCloseBetween(code) {
    if (markdownLineEnding$3(code)) {
      returnState = tagCloseBetween;
      return atLineEnding(code);
    }
    if (markdownSpace$2(code)) {
      effects.consume(code);
      return tagCloseBetween;
    }
    return end(code);
  }
  function tagOpen(code) {
    if (code === 45 || asciiAlphanumeric$1(code)) {
      effects.consume(code);
      return tagOpen;
    }
    if (code === 47 || code === 62 || markdownLineEndingOrSpace$2(code)) {
      return tagOpenBetween(code);
    }
    return nok(code);
  }
  function tagOpenBetween(code) {
    if (code === 47) {
      effects.consume(code);
      return end;
    }
    if (code === 58 || code === 95 || asciiAlpha$1(code)) {
      effects.consume(code);
      return tagOpenAttributeName;
    }
    if (markdownLineEnding$3(code)) {
      returnState = tagOpenBetween;
      return atLineEnding(code);
    }
    if (markdownSpace$2(code)) {
      effects.consume(code);
      return tagOpenBetween;
    }
    return end(code);
  }
  function tagOpenAttributeName(code) {
    if (code === 45 || code === 46 || code === 58 || code === 95 || asciiAlphanumeric$1(code)) {
      effects.consume(code);
      return tagOpenAttributeName;
    }
    return tagOpenAttributeNameAfter(code);
  }
  function tagOpenAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code);
      return tagOpenAttributeValueBefore;
    }
    if (markdownLineEnding$3(code)) {
      returnState = tagOpenAttributeNameAfter;
      return atLineEnding(code);
    }
    if (markdownSpace$2(code)) {
      effects.consume(code);
      return tagOpenAttributeNameAfter;
    }
    return tagOpenBetween(code);
  }
  function tagOpenAttributeValueBefore(code) {
    if (code === null || code === 60 || code === 61 || code === 62 || code === 96) {
      return nok(code);
    }
    if (code === 34 || code === 39) {
      effects.consume(code);
      marker = code;
      return tagOpenAttributeValueQuoted;
    }
    if (markdownLineEnding$3(code)) {
      returnState = tagOpenAttributeValueBefore;
      return atLineEnding(code);
    }
    if (markdownSpace$2(code)) {
      effects.consume(code);
      return tagOpenAttributeValueBefore;
    }
    effects.consume(code);
    marker = undefined;
    return tagOpenAttributeValueUnquoted;
  }
  function tagOpenAttributeValueQuoted(code) {
    if (code === marker) {
      effects.consume(code);
      return tagOpenAttributeValueQuotedAfter;
    }
    if (code === null) {
      return nok(code);
    }
    if (markdownLineEnding$3(code)) {
      returnState = tagOpenAttributeValueQuoted;
      return atLineEnding(code);
    }
    effects.consume(code);
    return tagOpenAttributeValueQuoted;
  }
  function tagOpenAttributeValueQuotedAfter(code) {
    if (code === 62 || code === 47 || markdownLineEndingOrSpace$2(code)) {
      return tagOpenBetween(code);
    }
    return nok(code);
  }
  function tagOpenAttributeValueUnquoted(code) {
    if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) {
      return nok(code);
    }
    if (code === 62 || markdownLineEndingOrSpace$2(code)) {
      return tagOpenBetween(code);
    }
    effects.consume(code);
    return tagOpenAttributeValueUnquoted;
  } // We can’t have blank lines in content, so no need to worry about empty
  // tokens.

  function atLineEnding(code) {
    effects.exit('htmlTextData');
    effects.enter('lineEnding');
    effects.consume(code);
    effects.exit('lineEnding');
    return factorySpace$4(effects, afterPrefix, 'linePrefix', self.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
  }
  function afterPrefix(code) {
    effects.enter('htmlTextData');
    return returnState(code);
  }
  function end(code) {
    if (code === 62) {
      effects.consume(code);
      effects.exit('htmlTextData');
      effects.exit('htmlText');
      return ok;
    }
    return nok(code);
  }
}
var htmlText_1 = htmlText$1;
var markdownLineEndingOrSpace$1 = markdownLineEndingOrSpace_1;
var chunkedPush = chunkedPush_1;
var chunkedSplice$1 = chunkedSplice_1;
var normalizeIdentifier$1 = normalizeIdentifier_1;
var resolveAll$1 = resolveAll_1;
var shallow$2 = shallow_1;
var factoryDestination = factoryDestination$2;
var factoryLabel = factoryLabel$2;
var factoryTitle = factoryTitle$2;
var factoryWhitespace = factoryWhitespace$2;
var labelEnd$3 = {
  name: 'labelEnd',
  tokenize: tokenizeLabelEnd,
  resolveTo: resolveToLabelEnd,
  resolveAll: resolveAllLabelEnd
};
var resourceConstruct = {
  tokenize: tokenizeResource
};
var fullReferenceConstruct = {
  tokenize: tokenizeFullReference
};
var collapsedReferenceConstruct = {
  tokenize: tokenizeCollapsedReference
};
function resolveAllLabelEnd(events) {
  var index = -1;
  var token;
  while (++index < events.length) {
    token = events[index][1];
    if (!token._used && (token.type === 'labelImage' || token.type === 'labelLink' || token.type === 'labelEnd')) {
      // Remove the marker.
      events.splice(index + 1, token.type === 'labelImage' ? 4 : 2);
      token.type = 'data';
      index++;
    }
  }
  return events;
}
function resolveToLabelEnd(events, context) {
  var index = events.length;
  var offset = 0;
  var group;
  var label;
  var text;
  var token;
  var open;
  var close;
  var media; // Find an opening.

  while (index--) {
    token = events[index][1];
    if (open) {
      // If we see another link, or inactive link label, we’ve been here before.
      if (token.type === 'link' || token.type === 'labelLink' && token._inactive) {
        break;
      } // Mark other link openings as inactive, as we can’t have links in
      // links.

      if (events[index][0] === 'enter' && token.type === 'labelLink') {
        token._inactive = true;
      }
    } else if (close) {
      if (events[index][0] === 'enter' && (token.type === 'labelImage' || token.type === 'labelLink') && !token._balanced) {
        open = index;
        if (token.type !== 'labelLink') {
          offset = 2;
          break;
        }
      }
    } else if (token.type === 'labelEnd') {
      close = index;
    }
  }
  group = {
    type: events[open][1].type === 'labelLink' ? 'link' : 'image',
    start: shallow$2(events[open][1].start),
    end: shallow$2(events[events.length - 1][1].end)
  };
  label = {
    type: 'label',
    start: shallow$2(events[open][1].start),
    end: shallow$2(events[close][1].end)
  };
  text = {
    type: 'labelText',
    start: shallow$2(events[open + offset + 2][1].end),
    end: shallow$2(events[close - 2][1].start)
  };
  media = [['enter', group, context], ['enter', label, context]]; // Opening marker.

  media = chunkedPush(media, events.slice(open + 1, open + offset + 3)); // Text open.

  media = chunkedPush(media, [['enter', text, context]]); // Between.

  media = chunkedPush(media, resolveAll$1(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context)); // Text close, marker close, label close.

  media = chunkedPush(media, [['exit', text, context], events[close - 2], events[close - 1], ['exit', label, context]]); // Reference, resource, or so.

  media = chunkedPush(media, events.slice(close + 1)); // Media close.

  media = chunkedPush(media, [['exit', group, context]]);
  chunkedSplice$1(events, open, events.length, media);
  return events;
}
function tokenizeLabelEnd(effects, ok, nok) {
  var self = this;
  var index = self.events.length;
  var labelStart;
  var defined; // Find an opening.

  while (index--) {
    if ((self.events[index][1].type === 'labelImage' || self.events[index][1].type === 'labelLink') && !self.events[index][1]._balanced) {
      labelStart = self.events[index][1];
      break;
    }
  }
  return start;
  function start(code) {
    if (!labelStart) {
      return nok(code);
    } // It’s a balanced bracket, but contains a link.

    if (labelStart._inactive) return balanced(code);
    defined = self.parser.defined.indexOf(normalizeIdentifier$1(self.sliceSerialize({
      start: labelStart.end,
      end: self.now()
    }))) > -1;
    effects.enter('labelEnd');
    effects.enter('labelMarker');
    effects.consume(code);
    effects.exit('labelMarker');
    effects.exit('labelEnd');
    return afterLabelEnd;
  }
  function afterLabelEnd(code) {
    // Resource: `[asd](fgh)`.
    if (code === 40) {
      return effects.attempt(resourceConstruct, ok, defined ? ok : balanced)(code);
    } // Collapsed (`[asd][]`) or full (`[asd][fgh]`) reference?

    if (code === 91) {
      return effects.attempt(fullReferenceConstruct, ok, defined ? effects.attempt(collapsedReferenceConstruct, ok, balanced) : balanced)(code);
    } // Shortcut reference: `[asd]`?

    return defined ? ok(code) : balanced(code);
  }
  function balanced(code) {
    labelStart._balanced = true;
    return nok(code);
  }
}
function tokenizeResource(effects, ok, nok) {
  return start;
  function start(code) {
    effects.enter('resource');
    effects.enter('resourceMarker');
    effects.consume(code);
    effects.exit('resourceMarker');
    return factoryWhitespace(effects, open);
  }
  function open(code) {
    if (code === 41) {
      return end(code);
    }
    return factoryDestination(effects, destinationAfter, nok, 'resourceDestination', 'resourceDestinationLiteral', 'resourceDestinationLiteralMarker', 'resourceDestinationRaw', 'resourceDestinationString', 3)(code);
  }
  function destinationAfter(code) {
    return markdownLineEndingOrSpace$1(code) ? factoryWhitespace(effects, between)(code) : end(code);
  }
  function between(code) {
    if (code === 34 || code === 39 || code === 40) {
      return factoryTitle(effects, factoryWhitespace(effects, end), nok, 'resourceTitle', 'resourceTitleMarker', 'resourceTitleString')(code);
    }
    return end(code);
  }
  function end(code) {
    if (code === 41) {
      effects.enter('resourceMarker');
      effects.consume(code);
      effects.exit('resourceMarker');
      effects.exit('resource');
      return ok;
    }
    return nok(code);
  }
}
function tokenizeFullReference(effects, ok, nok) {
  var self = this;
  return start;
  function start(code) {
    return factoryLabel.call(self, effects, afterLabel, nok, 'reference', 'referenceMarker', 'referenceString')(code);
  }
  function afterLabel(code) {
    return self.parser.defined.indexOf(normalizeIdentifier$1(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) < 0 ? nok(code) : ok(code);
  }
}
function tokenizeCollapsedReference(effects, ok, nok) {
  return start;
  function start(code) {
    effects.enter('reference');
    effects.enter('referenceMarker');
    effects.consume(code);
    effects.exit('referenceMarker');
    return open;
  }
  function open(code) {
    if (code === 93) {
      effects.enter('referenceMarker');
      effects.consume(code);
      effects.exit('referenceMarker');
      effects.exit('reference');
      return ok;
    }
    return nok(code);
  }
}
var labelEnd_1 = labelEnd$3;
var labelEnd$2 = labelEnd_1;
var labelStartImage$1 = {
  name: 'labelStartImage',
  tokenize: tokenizeLabelStartImage,
  resolveAll: labelEnd$2.resolveAll
};
function tokenizeLabelStartImage(effects, ok, nok) {
  var self = this;
  return start;
  function start(code) {
    effects.enter('labelImage');
    effects.enter('labelImageMarker');
    effects.consume(code);
    effects.exit('labelImageMarker');
    return open;
  }
  function open(code) {
    if (code === 91) {
      effects.enter('labelMarker');
      effects.consume(code);
      effects.exit('labelMarker');
      effects.exit('labelImage');
      return after;
    }
    return nok(code);
  }
  function after(code) {
    /* c8 ignore next */
    return code === 94 && /* c8 ignore next */
    '_hiddenFootnoteSupport' in self.parser.constructs ? /* c8 ignore next */
    nok(code) : ok(code);
  }
}
var labelStartImage_1 = labelStartImage$1;
var labelEnd$1 = labelEnd_1;
var labelStartLink$1 = {
  name: 'labelStartLink',
  tokenize: tokenizeLabelStartLink,
  resolveAll: labelEnd$1.resolveAll
};
function tokenizeLabelStartLink(effects, ok, nok) {
  var self = this;
  return start;
  function start(code) {
    effects.enter('labelLink');
    effects.enter('labelMarker');
    effects.consume(code);
    effects.exit('labelMarker');
    effects.exit('labelLink');
    return after;
  }
  function after(code) {
    /* c8 ignore next */
    return code === 94 && /* c8 ignore next */
    '_hiddenFootnoteSupport' in self.parser.constructs ? /* c8 ignore next */
    nok(code) : ok(code);
  }
}
var labelStartLink_1 = labelStartLink$1;
var factorySpace$3 = factorySpace$h;
var lineEnding$1 = {
  name: 'lineEnding',
  tokenize: tokenizeLineEnding
};
function tokenizeLineEnding(effects, ok) {
  return start;
  function start(code) {
    effects.enter('lineEnding');
    effects.consume(code);
    effects.exit('lineEnding');
    return factorySpace$3(effects, ok, 'linePrefix');
  }
}
var lineEnding_1 = lineEnding$1;
var markdownLineEnding$2 = markdownLineEnding_1;
var markdownSpace$1 = markdownSpace_1;
var factorySpace$2 = factorySpace$h;
var thematicBreak$4 = {
  name: 'thematicBreak',
  tokenize: tokenizeThematicBreak
};
function tokenizeThematicBreak(effects, ok, nok) {
  var size = 0;
  var marker;
  return start;
  function start(code) {
    effects.enter('thematicBreak');
    marker = code;
    return atBreak(code);
  }
  function atBreak(code) {
    if (code === marker) {
      effects.enter('thematicBreakSequence');
      return sequence(code);
    }
    if (markdownSpace$1(code)) {
      return factorySpace$2(effects, atBreak, 'whitespace')(code);
    }
    if (size < 3 || code !== null && !markdownLineEnding$2(code)) {
      return nok(code);
    }
    effects.exit('thematicBreak');
    return ok(code);
  }
  function sequence(code) {
    if (code === marker) {
      effects.consume(code);
      size++;
      return sequence;
    }
    effects.exit('thematicBreakSequence');
    return atBreak(code);
  }
}
var thematicBreak_1$1 = thematicBreak$4;
var asciiDigit = asciiDigit_1;
var markdownSpace = markdownSpace_1;
var prefixSize$1 = prefixSize_1;
var sizeChunks = sizeChunks_1;
var factorySpace$1 = factorySpace$h;
var partialBlankLine = partialBlankLine_1;
var thematicBreak$3 = thematicBreak_1$1;
var list$3 = {
  name: 'list',
  tokenize: tokenizeListStart,
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd
};
var listItemPrefixWhitespaceConstruct = {
  tokenize: tokenizeListItemPrefixWhitespace,
  partial: true
};
var indentConstruct = {
  tokenize: tokenizeIndent,
  partial: true
};
function tokenizeListStart(effects, ok, nok) {
  var self = this;
  var initialSize = prefixSize$1(self.events, 'linePrefix');
  var size = 0;
  return start;
  function start(code) {
    var kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? 'listUnordered' : 'listOrdered');
    if (kind === 'listUnordered' ? !self.containerState.marker || code === self.containerState.marker : asciiDigit(code)) {
      if (!self.containerState.type) {
        self.containerState.type = kind;
        effects.enter(kind, {
          _container: true
        });
      }
      if (kind === 'listUnordered') {
        effects.enter('listItemPrefix');
        return code === 42 || code === 45 ? effects.check(thematicBreak$3, nok, atMarker)(code) : atMarker(code);
      }
      if (!self.interrupt || code === 49) {
        effects.enter('listItemPrefix');
        effects.enter('listItemValue');
        return inside(code);
      }
    }
    return nok(code);
  }
  function inside(code) {
    if (asciiDigit(code) && ++size < 10) {
      effects.consume(code);
      return inside;
    }
    if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
      effects.exit('listItemValue');
      return atMarker(code);
    }
    return nok(code);
  }
  function atMarker(code) {
    effects.enter('listItemMarker');
    effects.consume(code);
    effects.exit('listItemMarker');
    self.containerState.marker = self.containerState.marker || code;
    return effects.check(partialBlankLine,
    // Can’t be empty when interrupting.
    self.interrupt ? nok : onBlank, effects.attempt(listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
  }
  function onBlank(code) {
    self.containerState.initialBlankLine = true;
    initialSize++;
    return endOfPrefix(code);
  }
  function otherPrefix(code) {
    if (markdownSpace(code)) {
      effects.enter('listItemPrefixWhitespace');
      effects.consume(code);
      effects.exit('listItemPrefixWhitespace');
      return endOfPrefix;
    }
    return nok(code);
  }
  function endOfPrefix(code) {
    self.containerState.size = initialSize + sizeChunks(self.sliceStream(effects.exit('listItemPrefix')));
    return ok(code);
  }
}
function tokenizeListContinuation(effects, ok, nok) {
  var self = this;
  self.containerState._closeFlow = undefined;
  return effects.check(partialBlankLine, onBlank, notBlank);
  function onBlank(code) {
    self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine; // We have a blank line.
    // Still, try to consume at most the items size.

    return factorySpace$1(effects, ok, 'listItemIndent', self.containerState.size + 1)(code);
  }
  function notBlank(code) {
    if (self.containerState.furtherBlankLines || !markdownSpace(code)) {
      self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
      return notInCurrentItem(code);
    }
    self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
    return effects.attempt(indentConstruct, ok, notInCurrentItem)(code);
  }
  function notInCurrentItem(code) {
    // While we do continue, we signal that the flow should be closed.
    self.containerState._closeFlow = true; // As we’re closing flow, we’re no longer interrupting.

    self.interrupt = undefined;
    return factorySpace$1(effects, effects.attempt(list$3, ok, nok), 'linePrefix', self.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4)(code);
  }
}
function tokenizeIndent(effects, ok, nok) {
  var self = this;
  return factorySpace$1(effects, afterPrefix, 'listItemIndent', self.containerState.size + 1);
  function afterPrefix(code) {
    return prefixSize$1(self.events, 'listItemIndent') === self.containerState.size ? ok(code) : nok(code);
  }
}
function tokenizeListEnd(effects) {
  effects.exit(this.containerState.type);
}
function tokenizeListItemPrefixWhitespace(effects, ok, nok) {
  var self = this;
  return factorySpace$1(effects, afterPrefix, 'listItemPrefixWhitespace', self.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4 + 1);
  function afterPrefix(code) {
    return markdownSpace(code) || !prefixSize$1(self.events, 'listItemPrefixWhitespace') ? nok(code) : ok(code);
  }
}
var list_1$1 = list$3;
var markdownLineEnding$1 = markdownLineEnding_1;
var shallow$1 = shallow_1;
var factorySpace = factorySpace$h;
var setextUnderline$1 = {
  name: 'setextUnderline',
  tokenize: tokenizeSetextUnderline,
  resolveTo: resolveToSetextUnderline
};
function resolveToSetextUnderline(events, context) {
  var index = events.length;
  var content;
  var text;
  var definition;
  var heading; // Find the opening of the content.
  // It’ll always exist: we don’t tokenize if it isn’t there.

  while (index--) {
    if (events[index][0] === 'enter') {
      if (events[index][1].type === 'content') {
        content = index;
        break;
      }
      if (events[index][1].type === 'paragraph') {
        text = index;
      }
    } // Exit
    else {
      if (events[index][1].type === 'content') {
        // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
      }
      if (!definition && events[index][1].type === 'definition') {
        definition = index;
      }
    }
  }
  heading = {
    type: 'setextHeading',
    start: shallow$1(events[text][1].start),
    end: shallow$1(events[events.length - 1][1].end)
  }; // Change the paragraph to setext heading text.

  events[text][1].type = 'setextHeadingText'; // If we have definitions in the content, we’ll keep on having content,
  // but we need move it.

  if (definition) {
    events.splice(text, 0, ['enter', heading, context]);
    events.splice(definition + 1, 0, ['exit', events[content][1], context]);
    events[content][1].end = shallow$1(events[definition][1].end);
  } else {
    events[content][1] = heading;
  } // Add the heading exit at the end.

  events.push(['exit', heading, context]);
  return events;
}
function tokenizeSetextUnderline(effects, ok, nok) {
  var self = this;
  var index = self.events.length;
  var marker;
  var paragraph; // Find an opening.

  while (index--) {
    // Skip enter/exit of line ending, line prefix, and content.
    // We can now either have a definition or a paragraph.
    if (self.events[index][1].type !== 'lineEnding' && self.events[index][1].type !== 'linePrefix' && self.events[index][1].type !== 'content') {
      paragraph = self.events[index][1].type === 'paragraph';
      break;
    }
  }
  return start;
  function start(code) {
    if (!self.lazy && (self.interrupt || paragraph)) {
      effects.enter('setextHeadingLine');
      effects.enter('setextHeadingLineSequence');
      marker = code;
      return closingSequence(code);
    }
    return nok(code);
  }
  function closingSequence(code) {
    if (code === marker) {
      effects.consume(code);
      return closingSequence;
    }
    effects.exit('setextHeadingLineSequence');
    return factorySpace(effects, closingSequenceEnd, 'lineSuffix')(code);
  }
  function closingSequenceEnd(code) {
    if (code === null || markdownLineEnding$1(code)) {
      effects.exit('setextHeadingLine');
      return ok(code);
    }
    return nok(code);
  }
}
var setextUnderline_1 = setextUnderline$1;
Object.defineProperty(constructs$1, '__esModule', {
  value: true
});
var text$1$1 = text$5;
var attention = attention_1;
var autolink$1 = autolink_1;
var blockQuote = blockQuote_1;
var characterEscape = characterEscape_1;
var characterReference = characterReference_1;
var codeFenced = codeFenced_1;
var codeIndented = codeIndented_1;
var codeText = codeText_1;
var definition = definition_1;
var hardBreakEscape = hardBreakEscape_1;
var headingAtx = headingAtx_1;
var htmlFlow = htmlFlow_1;
var htmlText = htmlText_1;
var labelEnd = labelEnd_1;
var labelStartImage = labelStartImage_1;
var labelStartLink = labelStartLink_1;
var lineEnding = lineEnding_1;
var list$2 = list_1$1;
var setextUnderline = setextUnderline_1;
var thematicBreak$2 = thematicBreak_1$1;
var document$2 = {
  42: list$2,
  // Asterisk
  43: list$2,
  // Plus sign
  45: list$2,
  // Dash
  48: list$2,
  // 0
  49: list$2,
  // 1
  50: list$2,
  // 2
  51: list$2,
  // 3
  52: list$2,
  // 4
  53: list$2,
  // 5
  54: list$2,
  // 6
  55: list$2,
  // 7
  56: list$2,
  // 8
  57: list$2,
  // 9
  62: blockQuote // Greater than
};
var contentInitial = {
  91: definition // Left square bracket
};
var flowInitial = {
  '-2': codeIndented,
  // Horizontal tab
  '-1': codeIndented,
  // Virtual space
  32: codeIndented // Space
};
var flow$3 = {
  35: headingAtx,
  // Number sign
  42: thematicBreak$2,
  // Asterisk
  45: [setextUnderline, thematicBreak$2],
  // Dash
  60: htmlFlow,
  // Less than
  61: setextUnderline,
  // Equals to
  95: thematicBreak$2,
  // Underscore
  96: codeFenced,
  // Grave accent
  126: codeFenced // Tilde
};
var string$1 = {
  38: characterReference,
  // Ampersand
  92: characterEscape // Backslash
};
var text$3 = {
  '-5': lineEnding,
  // Carriage return
  '-4': lineEnding,
  // Line feed
  '-3': lineEnding,
  // Carriage return + line feed
  33: labelStartImage,
  // Exclamation mark
  38: characterReference,
  // Ampersand
  42: attention,
  // Asterisk
  60: [autolink$1, htmlText],
  // Less than
  91: labelStartLink,
  // Left square bracket
  92: [hardBreakEscape, characterEscape],
  // Backslash
  93: labelEnd,
  // Right square bracket
  95: attention,
  // Underscore
  96: codeText // Grave accent
};
var insideSpan = {
  null: [attention, text$1$1.resolver]
};
var disable = {
  null: []
};
constructs$1.contentInitial = contentInitial;
constructs$1.disable = disable;
constructs$1.document = document$2;
constructs$1.flow = flow$3;
constructs$1.flowInitial = flowInitial;
constructs$1.insideSpan = insideSpan;
constructs$1.string = string$1;
constructs$1.text = text$3;
var content = content$3;
var document$1 = document$3;
var flow$2 = flow$4;
var text$2 = text$5;
var combineExtensions = combineExtensions_1;
var createTokenizer = createTokenizer_1;
var miniflat = miniflat_1;
var constructs = constructs$1;
function parse$5(options) {
  var settings = options || {};
  var parser = {
    defined: [],
    constructs: combineExtensions([constructs].concat(miniflat(settings.extensions))),
    content: create(content),
    document: create(document$1),
    flow: create(flow$2),
    string: create(text$2.string),
    text: create(text$2.text)
  };
  return parser;
  function create(initializer) {
    return creator;
    function creator(from) {
      return createTokenizer(parser, initializer, from);
    }
  }
}
var parse_1 = parse$5;
var search$1 = /[\0\t\n\r]/g;
function preprocess() {
  var start = true;
  var column = 1;
  var buffer = '';
  var atCarriageReturn;
  return preprocessor;
  function preprocessor(value, encoding, end) {
    var chunks = [];
    var match;
    var next;
    var startPosition;
    var endPosition;
    var code;
    value = buffer + value.toString(encoding);
    startPosition = 0;
    buffer = '';
    if (start) {
      if (value.charCodeAt(0) === 65279) {
        startPosition++;
      }
      start = undefined;
    }
    while (startPosition < value.length) {
      search$1.lastIndex = startPosition;
      match = search$1.exec(value);
      endPosition = match ? match.index : value.length;
      code = value.charCodeAt(endPosition);
      if (!match) {
        buffer = value.slice(startPosition);
        break;
      }
      if (code === 10 && startPosition === endPosition && atCarriageReturn) {
        chunks.push(-3);
        atCarriageReturn = undefined;
      } else {
        if (atCarriageReturn) {
          chunks.push(-5);
          atCarriageReturn = undefined;
        }
        if (startPosition < endPosition) {
          chunks.push(value.slice(startPosition, endPosition));
          column += endPosition - startPosition;
        }
        if (code === 0) {
          chunks.push(65533);
          column++;
        } else if (code === 9) {
          next = Math.ceil(column / 4) * 4;
          chunks.push(-2);
          while (column++ < next) chunks.push(-1);
        } else if (code === 10) {
          chunks.push(-4);
          column = 1;
        } // Must be carriage return.
        else {
          atCarriageReturn = true;
          column = 1;
        }
      }
      startPosition = endPosition + 1;
    }
    if (end) {
      if (atCarriageReturn) chunks.push(-5);
      if (buffer) chunks.push(buffer);
      chunks.push(null);
    }
    return chunks;
  }
}
var preprocess_1 = preprocess;
var subtokenize = subtokenize_1;
function postprocess$1(events) {
  while (!subtokenize(events)) {
    // Empty
  }
  return events;
}
var postprocess_1 = postprocess$1;
var dist = fromMarkdown$7;

// These three are compiled away in the `dist/`

var toString$8 = mdastUtilToString;
var assign = assign_1;
var own$5 = hasOwnProperty$n;
var normalizeIdentifier = normalizeIdentifier_1;
var safeFromInt = safeFromInt_1;
var parser = parse_1;
var preprocessor = preprocess_1;
var postprocess = postprocess_1;
var decode = decodeEntity_1;
var stringifyPosition = unistUtilStringifyPosition;
function fromMarkdown$7(value, encoding, options) {
  if (typeof encoding !== 'string') {
    options = encoding;
    encoding = undefined;
  }
  return compiler(options)(postprocess(parser(options).document().write(preprocessor()(value, encoding, true))));
}

// Note this compiler only understand complete buffering, not streaming.
function compiler(options) {
  var settings = options || {};
  var config = configure$3({
    transforms: [],
    canContainEols: ['emphasis', 'fragment', 'heading', 'paragraph', 'strong'],
    enter: {
      autolink: opener(link),
      autolinkProtocol: onenterdata,
      autolinkEmail: onenterdata,
      atxHeading: opener(heading),
      blockQuote: opener(blockQuote),
      characterEscape: onenterdata,
      characterReference: onenterdata,
      codeFenced: opener(codeFlow),
      codeFencedFenceInfo: buffer,
      codeFencedFenceMeta: buffer,
      codeIndented: opener(codeFlow, buffer),
      codeText: opener(codeText, buffer),
      codeTextData: onenterdata,
      data: onenterdata,
      codeFlowValue: onenterdata,
      definition: opener(definition),
      definitionDestinationString: buffer,
      definitionLabelString: buffer,
      definitionTitleString: buffer,
      emphasis: opener(emphasis),
      hardBreakEscape: opener(hardBreak),
      hardBreakTrailing: opener(hardBreak),
      htmlFlow: opener(html, buffer),
      htmlFlowData: onenterdata,
      htmlText: opener(html, buffer),
      htmlTextData: onenterdata,
      image: opener(image),
      label: buffer,
      link: opener(link),
      listItem: opener(listItem),
      listItemValue: onenterlistitemvalue,
      listOrdered: opener(list, onenterlistordered),
      listUnordered: opener(list),
      paragraph: opener(paragraph),
      reference: onenterreference,
      referenceString: buffer,
      resourceDestinationString: buffer,
      resourceTitleString: buffer,
      setextHeading: opener(heading),
      strong: opener(strong),
      thematicBreak: opener(thematicBreak)
    },
    exit: {
      atxHeading: closer(),
      atxHeadingSequence: onexitatxheadingsequence,
      autolink: closer(),
      autolinkEmail: onexitautolinkemail,
      autolinkProtocol: onexitautolinkprotocol,
      blockQuote: closer(),
      characterEscapeValue: onexitdata,
      characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
      characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
      characterReferenceValue: onexitcharacterreferencevalue,
      codeFenced: closer(onexitcodefenced),
      codeFencedFence: onexitcodefencedfence,
      codeFencedFenceInfo: onexitcodefencedfenceinfo,
      codeFencedFenceMeta: onexitcodefencedfencemeta,
      codeFlowValue: onexitdata,
      codeIndented: closer(onexitcodeindented),
      codeText: closer(onexitcodetext),
      codeTextData: onexitdata,
      data: onexitdata,
      definition: closer(),
      definitionDestinationString: onexitdefinitiondestinationstring,
      definitionLabelString: onexitdefinitionlabelstring,
      definitionTitleString: onexitdefinitiontitlestring,
      emphasis: closer(),
      hardBreakEscape: closer(onexithardbreak),
      hardBreakTrailing: closer(onexithardbreak),
      htmlFlow: closer(onexithtmlflow),
      htmlFlowData: onexitdata,
      htmlText: closer(onexithtmltext),
      htmlTextData: onexitdata,
      image: closer(onexitimage),
      label: onexitlabel,
      labelText: onexitlabeltext,
      lineEnding: onexitlineending,
      link: closer(onexitlink),
      listItem: closer(),
      listOrdered: closer(),
      listUnordered: closer(),
      paragraph: closer(),
      referenceString: onexitreferencestring,
      resourceDestinationString: onexitresourcedestinationstring,
      resourceTitleString: onexitresourcetitlestring,
      resource: onexitresource,
      setextHeading: closer(onexitsetextheading),
      setextHeadingLineSequence: onexitsetextheadinglinesequence,
      setextHeadingText: onexitsetextheadingtext,
      strong: closer(),
      thematicBreak: closer()
    }
  }, settings.mdastExtensions || []);
  var data = {};
  return compile;
  function compile(events) {
    var tree = {
      type: 'root',
      children: []
    };
    var stack = [tree];
    var tokenStack = [];
    var listStack = [];
    var index = -1;
    var handler;
    var listStart;
    var context = {
      stack: stack,
      tokenStack: tokenStack,
      config: config,
      enter: enter,
      exit: exit,
      buffer: buffer,
      resume: resume,
      setData: setData,
      getData: getData
    };
    while (++index < events.length) {
      // We preprocess lists to add `listItem` tokens, and to infer whether
      // items the list itself are spread out.
      if (events[index][1].type === 'listOrdered' || events[index][1].type === 'listUnordered') {
        if (events[index][0] === 'enter') {
          listStack.push(index);
        } else {
          listStart = listStack.pop(index);
          index = prepareList(events, listStart, index);
        }
      }
    }
    index = -1;
    while (++index < events.length) {
      handler = config[events[index][0]];
      if (own$5.call(handler, events[index][1].type)) {
        handler[events[index][1].type].call(assign({
          sliceSerialize: events[index][2].sliceSerialize
        }, context), events[index][1]);
      }
    }
    if (tokenStack.length) {
      throw new Error('Cannot close document, a token (`' + tokenStack[tokenStack.length - 1].type + '`, ' + stringifyPosition({
        start: tokenStack[tokenStack.length - 1].start,
        end: tokenStack[tokenStack.length - 1].end
      }) + ') is still open');
    }

    // Figure out `root` position.
    tree.position = {
      start: point(events.length ? events[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: point(events.length ? events[events.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    };
    index = -1;
    while (++index < config.transforms.length) {
      tree = config.transforms[index](tree) || tree;
    }
    return tree;
  }
  function prepareList(events, start, length) {
    var index = start - 1;
    var containerBalance = -1;
    var listSpread = false;
    var listItem;
    var tailIndex;
    var lineIndex;
    var tailEvent;
    var event;
    var firstBlankLineIndex;
    var atMarker;
    while (++index <= length) {
      event = events[index];
      if (event[1].type === 'listUnordered' || event[1].type === 'listOrdered' || event[1].type === 'blockQuote') {
        if (event[0] === 'enter') {
          containerBalance++;
        } else {
          containerBalance--;
        }
        atMarker = undefined;
      } else if (event[1].type === 'lineEndingBlank') {
        if (event[0] === 'enter') {
          if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) {
            firstBlankLineIndex = index;
          }
          atMarker = undefined;
        }
      } else if (event[1].type === 'linePrefix' || event[1].type === 'listItemValue' || event[1].type === 'listItemMarker' || event[1].type === 'listItemPrefix' || event[1].type === 'listItemPrefixWhitespace') ;else {
        atMarker = undefined;
      }
      if (!containerBalance && event[0] === 'enter' && event[1].type === 'listItemPrefix' || containerBalance === -1 && event[0] === 'exit' && (event[1].type === 'listUnordered' || event[1].type === 'listOrdered')) {
        if (listItem) {
          tailIndex = index;
          lineIndex = undefined;
          while (tailIndex--) {
            tailEvent = events[tailIndex];
            if (tailEvent[1].type === 'lineEnding' || tailEvent[1].type === 'lineEndingBlank') {
              if (tailEvent[0] === 'exit') continue;
              if (lineIndex) {
                events[lineIndex][1].type = 'lineEndingBlank';
                listSpread = true;
              }
              tailEvent[1].type = 'lineEnding';
              lineIndex = tailIndex;
            } else if (tailEvent[1].type === 'linePrefix' || tailEvent[1].type === 'blockQuotePrefix' || tailEvent[1].type === 'blockQuotePrefixWhitespace' || tailEvent[1].type === 'blockQuoteMarker' || tailEvent[1].type === 'listItemIndent') ;else {
              break;
            }
          }
          if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) {
            listItem._spread = true;
          }

          // Fix position.
          listItem.end = point(lineIndex ? events[lineIndex][1].start : event[1].end);
          events.splice(lineIndex || index, 0, ['exit', listItem, event[2]]);
          index++;
          length++;
        }

        // Create a new list item.
        if (event[1].type === 'listItemPrefix') {
          listItem = {
            type: 'listItem',
            _spread: false,
            start: point(event[1].start)
          };
          events.splice(index, 0, ['enter', listItem, event[2]]);
          index++;
          length++;
          firstBlankLineIndex = undefined;
          atMarker = true;
        }
      }
    }
    events[start][1]._spread = listSpread;
    return length;
  }
  function setData(key, value) {
    data[key] = value;
  }
  function getData(key) {
    return data[key];
  }
  function point(d) {
    return {
      line: d.line,
      column: d.column,
      offset: d.offset
    };
  }
  function opener(create, and) {
    return open;
    function open(token) {
      enter.call(this, create(token), token);
      if (and) and.call(this, token);
    }
  }
  function buffer() {
    this.stack.push({
      type: 'fragment',
      children: []
    });
  }
  function enter(node, token) {
    this.stack[this.stack.length - 1].children.push(node);
    this.stack.push(node);
    this.tokenStack.push(token);
    node.position = {
      start: point(token.start)
    };
    return node;
  }
  function closer(and) {
    return close;
    function close(token) {
      if (and) and.call(this, token);
      exit.call(this, token);
    }
  }
  function exit(token) {
    var node = this.stack.pop();
    var open = this.tokenStack.pop();
    if (!open) {
      throw new Error('Cannot close `' + token.type + '` (' + stringifyPosition({
        start: token.start,
        end: token.end
      }) + '): it’s not open');
    } else if (open.type !== token.type) {
      throw new Error('Cannot close `' + token.type + '` (' + stringifyPosition({
        start: token.start,
        end: token.end
      }) + '): a different token (`' + open.type + '`, ' + stringifyPosition({
        start: open.start,
        end: open.end
      }) + ') is open');
    }
    node.position.end = point(token.end);
    return node;
  }
  function resume() {
    return toString$8(this.stack.pop());
  }

  //
  // Handlers.
  //

  function onenterlistordered() {
    setData('expectingFirstListItemValue', true);
  }
  function onenterlistitemvalue(token) {
    if (getData('expectingFirstListItemValue')) {
      this.stack[this.stack.length - 2].start = parseInt(this.sliceSerialize(token), 10);
      setData('expectingFirstListItemValue');
    }
  }
  function onexitcodefencedfenceinfo() {
    var data = this.resume();
    this.stack[this.stack.length - 1].lang = data;
  }
  function onexitcodefencedfencemeta() {
    var data = this.resume();
    this.stack[this.stack.length - 1].meta = data;
  }
  function onexitcodefencedfence() {
    // Exit if this is the closing fence.
    if (getData('flowCodeInside')) return;
    this.buffer();
    setData('flowCodeInside', true);
  }
  function onexitcodefenced() {
    var data = this.resume();
    this.stack[this.stack.length - 1].value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
    setData('flowCodeInside');
  }
  function onexitcodeindented() {
    var data = this.resume();
    this.stack[this.stack.length - 1].value = data;
  }
  function onexitdefinitionlabelstring(token) {
    // Discard label, use the source content instead.
    var label = this.resume();
    this.stack[this.stack.length - 1].label = label;
    this.stack[this.stack.length - 1].identifier = normalizeIdentifier(this.sliceSerialize(token)).toLowerCase();
  }
  function onexitdefinitiontitlestring() {
    var data = this.resume();
    this.stack[this.stack.length - 1].title = data;
  }
  function onexitdefinitiondestinationstring() {
    var data = this.resume();
    this.stack[this.stack.length - 1].url = data;
  }
  function onexitatxheadingsequence(token) {
    if (!this.stack[this.stack.length - 1].depth) {
      this.stack[this.stack.length - 1].depth = this.sliceSerialize(token).length;
    }
  }
  function onexitsetextheadingtext() {
    setData('setextHeadingSlurpLineEnding', true);
  }
  function onexitsetextheadinglinesequence(token) {
    this.stack[this.stack.length - 1].depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
  }
  function onexitsetextheading() {
    setData('setextHeadingSlurpLineEnding');
  }
  function onenterdata(token) {
    var siblings = this.stack[this.stack.length - 1].children;
    var tail = siblings[siblings.length - 1];
    if (!tail || tail.type !== 'text') {
      // Add a new text node.
      tail = text();
      tail.position = {
        start: point(token.start)
      };
      this.stack[this.stack.length - 1].children.push(tail);
    }
    this.stack.push(tail);
  }
  function onexitdata(token) {
    var tail = this.stack.pop();
    tail.value += this.sliceSerialize(token);
    tail.position.end = point(token.end);
  }
  function onexitlineending(token) {
    var context = this.stack[this.stack.length - 1];

    // If we’re at a hard break, include the line ending in there.
    if (getData('atHardBreak')) {
      context.children[context.children.length - 1].position.end = point(token.end);
      setData('atHardBreak');
      return;
    }
    if (!getData('setextHeadingSlurpLineEnding') && config.canContainEols.indexOf(context.type) > -1) {
      onenterdata.call(this, token);
      onexitdata.call(this, token);
    }
  }
  function onexithardbreak() {
    setData('atHardBreak', true);
  }
  function onexithtmlflow() {
    var data = this.resume();
    this.stack[this.stack.length - 1].value = data;
  }
  function onexithtmltext() {
    var data = this.resume();
    this.stack[this.stack.length - 1].value = data;
  }
  function onexitcodetext() {
    var data = this.resume();
    this.stack[this.stack.length - 1].value = data;
  }
  function onexitlink() {
    var context = this.stack[this.stack.length - 1];

    // To do: clean.
    if (getData('inReference')) {
      context.type += 'Reference';
      context.referenceType = getData('referenceType') || 'shortcut';
      delete context.url;
      delete context.title;
    } else {
      delete context.identifier;
      delete context.label;
      delete context.referenceType;
    }
    setData('referenceType');
  }
  function onexitimage() {
    var context = this.stack[this.stack.length - 1];

    // To do: clean.
    if (getData('inReference')) {
      context.type += 'Reference';
      context.referenceType = getData('referenceType') || 'shortcut';
      delete context.url;
      delete context.title;
    } else {
      delete context.identifier;
      delete context.label;
      delete context.referenceType;
    }
    setData('referenceType');
  }
  function onexitlabeltext(token) {
    this.stack[this.stack.length - 2].identifier = normalizeIdentifier(this.sliceSerialize(token)).toLowerCase();
  }
  function onexitlabel() {
    var fragment = this.stack[this.stack.length - 1];
    var value = this.resume();
    this.stack[this.stack.length - 1].label = value;

    // Assume a reference.
    setData('inReference', true);
    if (this.stack[this.stack.length - 1].type === 'link') {
      this.stack[this.stack.length - 1].children = fragment.children;
    } else {
      this.stack[this.stack.length - 1].alt = value;
    }
  }
  function onexitresourcedestinationstring() {
    var data = this.resume();
    this.stack[this.stack.length - 1].url = data;
  }
  function onexitresourcetitlestring() {
    var data = this.resume();
    this.stack[this.stack.length - 1].title = data;
  }
  function onexitresource() {
    setData('inReference');
  }
  function onenterreference() {
    setData('referenceType', 'collapsed');
  }
  function onexitreferencestring(token) {
    var label = this.resume();
    this.stack[this.stack.length - 1].label = label;
    this.stack[this.stack.length - 1].identifier = normalizeIdentifier(this.sliceSerialize(token)).toLowerCase();
    setData('referenceType', 'full');
  }
  function onexitcharacterreferencemarker(token) {
    setData('characterReferenceType', token.type);
  }
  function onexitcharacterreferencevalue(token) {
    var data = this.sliceSerialize(token);
    var type = getData('characterReferenceType');
    var value;
    var tail;
    if (type) {
      value = safeFromInt(data, type === 'characterReferenceMarkerNumeric' ? 10 : 16);
      setData('characterReferenceType');
    } else {
      value = decode(data);
    }
    tail = this.stack.pop();
    tail.value += value;
    tail.position.end = point(token.end);
  }
  function onexitautolinkprotocol(token) {
    onexitdata.call(this, token);
    this.stack[this.stack.length - 1].url = this.sliceSerialize(token);
  }
  function onexitautolinkemail(token) {
    onexitdata.call(this, token);
    this.stack[this.stack.length - 1].url = 'mailto:' + this.sliceSerialize(token);
  }

  //
  // Creaters.
  //

  function blockQuote() {
    return {
      type: 'blockquote',
      children: []
    };
  }
  function codeFlow() {
    return {
      type: 'code',
      lang: null,
      meta: null,
      value: ''
    };
  }
  function codeText() {
    return {
      type: 'inlineCode',
      value: ''
    };
  }
  function definition() {
    return {
      type: 'definition',
      identifier: '',
      label: null,
      title: null,
      url: ''
    };
  }
  function emphasis() {
    return {
      type: 'emphasis',
      children: []
    };
  }
  function heading() {
    return {
      type: 'heading',
      depth: undefined,
      children: []
    };
  }
  function hardBreak() {
    return {
      type: 'break'
    };
  }
  function html() {
    return {
      type: 'html',
      value: ''
    };
  }
  function image() {
    return {
      type: 'image',
      title: null,
      url: '',
      alt: null
    };
  }
  function link() {
    return {
      type: 'link',
      title: null,
      url: '',
      children: []
    };
  }
  function list(token) {
    return {
      type: 'list',
      ordered: token.type === 'listOrdered',
      start: null,
      spread: token._spread,
      children: []
    };
  }
  function listItem(token) {
    return {
      type: 'listItem',
      spread: token._spread,
      checked: null,
      children: []
    };
  }
  function paragraph() {
    return {
      type: 'paragraph',
      children: []
    };
  }
  function strong() {
    return {
      type: 'strong',
      children: []
    };
  }
  function text() {
    return {
      type: 'text',
      value: ''
    };
  }
  function thematicBreak() {
    return {
      type: 'thematicBreak'
    };
  }
}
function configure$3(config, extensions) {
  var index = -1;
  while (++index < extensions.length) {
    extension$1(config, extensions[index]);
  }
  return config;
}
function extension$1(config, extension) {
  var key;
  var left;
  for (key in extension) {
    left = own$5.call(config, key) ? config[key] : config[key] = {};
    if (key === 'canContainEols' || key === 'transforms') {
      config[key] = [].concat(left, extension[key]);
    } else {
      Object.assign(left, extension[key]);
    }
  }
}
(function (module) {
  module.exports = dist;
})(mdastUtilFromMarkdown);
var remarkParse = parse$4;
var fromMarkdown$6 = mdastUtilFromMarkdown.exports;
function parse$4(options) {
  var self = this;
  this.Parser = parse;
  function parse(doc) {
    return fromMarkdown$6(doc, Object.assign({}, self.data('settings'), options, {
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: self.data('micromarkExtensions') || [],
      mdastExtensions: self.data('fromMarkdownExtensions') || []
    }));
  }
}
var mdastUtilToHast = {
  exports: {}
};
var unistBuilder = u$b;
function u$b(type, props, value) {
  var node;
  if ((value === null || value === undefined) && (typeof props !== 'object' || Array.isArray(props))) {
    value = props;
    props = {};
  }
  node = Object.assign({
    type: String(type)
  }, props);
  if (Array.isArray(value)) {
    node.children = value;
  } else if (value !== null && value !== undefined) {
    node.value = String(value);
  }
  return node;
}
var convert_1 = convert$2;
function convert$2(test) {
  if (test == null) {
    return ok;
  }
  if (typeof test === 'string') {
    return typeFactory(test);
  }
  if (typeof test === 'object') {
    return 'length' in test ? anyFactory(test) : allFactory(test);
  }
  if (typeof test === 'function') {
    return test;
  }
  throw new Error('Expected function, string, or object as test');
}

// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function allFactory(test) {
  return all;
  function all(node) {
    var key;
    for (key in test) {
      if (node[key] !== test[key]) return false;
    }
    return true;
  }
}
function anyFactory(tests) {
  var checks = [];
  var index = -1;
  while (++index < tests.length) {
    checks[index] = convert$2(tests[index]);
  }
  return any;
  function any() {
    var index = -1;
    while (++index < checks.length) {
      if (checks[index].apply(this, arguments)) {
        return true;
      }
    }
    return false;
  }
}

// Utility to convert a string into a function which checks a given node’s type
// for said string.
function typeFactory(test) {
  return type;
  function type(node) {
    return Boolean(node && node.type === test);
  }
}

// Utility to return true.
function ok() {
  return true;
}
var color_1 = color$1;
function color$1(d) {
  return "\x1B[33m" + d + "\x1B[39m";
}
var unistUtilVisitParents = visitParents$1;
var convert$1 = convert_1;
var color = color_1;
var CONTINUE$1 = true;
var SKIP$1 = 'skip';
var EXIT$1 = false;
visitParents$1.CONTINUE = CONTINUE$1;
visitParents$1.SKIP = SKIP$1;
visitParents$1.EXIT = EXIT$1;
function visitParents$1(tree, test, visitor, reverse) {
  var step;
  var is;
  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor;
    visitor = test;
    test = null;
  }
  is = convert$1(test);
  step = reverse ? -1 : 1;
  factory(tree, null, [])();
  function factory(node, index, parents) {
    var value = typeof node === 'object' && node !== null ? node : {};
    var name;
    if (typeof value.type === 'string') {
      name = typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
      visit.displayName = 'node (' + color(value.type + (name ? '<' + name + '>' : '')) + ')';
    }
    return visit;
    function visit() {
      var grandparents = parents.concat(node);
      var result = [];
      var subresult;
      var offset;
      if (!test || is(node, index, parents[parents.length - 1] || null)) {
        result = toResult(visitor(node, parents));
        if (result[0] === EXIT$1) {
          return result;
        }
      }
      if (node.children && result[0] !== SKIP$1) {
        offset = (reverse ? node.children.length : -1) + step;
        while (offset > -1 && offset < node.children.length) {
          subresult = factory(node.children[offset], offset, grandparents)();
          if (subresult[0] === EXIT$1) {
            return subresult;
          }
          offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
        }
      }
      return result;
    }
  }
}
function toResult(value) {
  if (value !== null && typeof value === 'object' && 'length' in value) {
    return value;
  }
  if (typeof value === 'number') {
    return [CONTINUE$1, value];
  }
  return [value];
}
var unistUtilVisit = visit$4;
var visitParents = unistUtilVisitParents;
var CONTINUE = visitParents.CONTINUE;
var SKIP = visitParents.SKIP;
var EXIT = visitParents.EXIT;
visit$4.CONTINUE = CONTINUE;
visit$4.SKIP = SKIP;
visit$4.EXIT = EXIT;
function visit$4(tree, test, visitor, reverse) {
  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor;
    visitor = test;
    test = null;
  }
  visitParents(tree, test, overload, reverse);
  function overload(node, parents) {
    var parent = parents[parents.length - 1];
    var index = parent ? parent.children.indexOf(node) : null;
    return visitor(node, index, parent);
  }
}
var start = factory$1('start');
var end = factory$1('end');
var unistUtilPosition = position$2;
position$2.start = start;
position$2.end = end;
function position$2(node) {
  return {
    start: start(node),
    end: end(node)
  };
}
function factory$1(type) {
  point.displayName = type;
  return point;
  function point(node) {
    var point = node && node.position && node.position[type] || {};
    return {
      line: point.line || null,
      column: point.column || null,
      offset: isNaN(point.offset) ? null : point.offset
    };
  }
}
var unistUtilGenerated = generated$1;
function generated$1(node) {
  return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}
var visit$3 = unistUtilVisit;
var mdastUtilDefinitions = getDefinitionFactory;
var own$4 = {}.hasOwnProperty;

// Get a definition in `node` by `identifier`.
function getDefinitionFactory(node, options) {
  return getterFactory(gather(node));
}

// Gather all definitions in `node`
function gather(node) {
  var cache = {};
  if (!node || !node.type) {
    throw new Error('mdast-util-definitions expected node');
  }
  visit$3(node, 'definition', ondefinition);
  return cache;
  function ondefinition(definition) {
    var id = normalise(definition.identifier);
    if (!own$4.call(cache, id)) {
      cache[id] = definition;
    }
  }
}

// Factory to get a node from the given definition-cache.
function getterFactory(cache) {
  return getter;

  // Get a node from the bound definition-cache.
  function getter(identifier) {
    var id = identifier && normalise(identifier);
    return id && own$4.call(cache, id) ? cache[id] : null;
  }
}
function normalise(identifier) {
  return identifier.toUpperCase();
}
var all_1;
var hasRequiredAll;
function requireAll() {
  if (hasRequiredAll) return all_1;
  hasRequiredAll = 1;
  all_1 = all;
  var one = requireOne();
  function all(h, parent) {
    var nodes = parent.children || [];
    var length = nodes.length;
    var values = [];
    var index = -1;
    var result;
    var head;
    while (++index < length) {
      result = one(h, nodes[index], parent);
      if (result) {
        if (index && nodes[index - 1].type === 'break') {
          if (result.value) {
            result.value = result.value.replace(/^\s+/, '');
          }
          head = result.children && result.children[0];
          if (head && head.value) {
            head.value = head.value.replace(/^\s+/, '');
          }
        }
        values = values.concat(result);
      }
    }
    return values;
  }
  return all_1;
}
var one_1;
var hasRequiredOne;
function requireOne() {
  if (hasRequiredOne) return one_1;
  hasRequiredOne = 1;
  one_1 = one;
  var u = unistBuilder;
  var all = requireAll();
  var own = {}.hasOwnProperty;

  // Transform an unknown node.
  function unknown(h, node) {
    if (text(node)) {
      return h.augment(node, u('text', node.value));
    }
    return h(node, 'div', all(h, node));
  }

  // Visit a node.
  function one(h, node, parent) {
    var type = node && node.type;
    var fn;

    // Fail on non-nodes.
    if (!type) {
      throw new Error('Expected node, got `' + node + '`');
    }
    if (own.call(h.handlers, type)) {
      fn = h.handlers[type];
    } else if (h.passThrough && h.passThrough.indexOf(type) > -1) {
      fn = returnNode;
    } else {
      fn = h.unknownHandler;
    }
    return (typeof fn === 'function' ? fn : unknown)(h, node, parent);
  }

  // Check if the node should be renderered as a text node.
  function text(node) {
    var data = node.data || {};
    if (own.call(data, 'hName') || own.call(data, 'hProperties') || own.call(data, 'hChildren')) {
      return false;
    }
    return 'value' in node;
  }
  function returnNode(h, node) {
    var clone;
    if (node.children) {
      clone = Object.assign({}, node);
      clone.children = all(h, node);
      return clone;
    }
    return node;
  }
  return one_1;
}
var thematicBreak_1 = thematicBreak$1;
function thematicBreak$1(h, node) {
  return h(node, 'hr');
}
var wrap_1 = wrap$5;
var u$a = unistBuilder;

// Wrap `nodes` with line feeds between each entry.
// Optionally adds line feeds at the start and end.
function wrap$5(nodes, loose) {
  var result = [];
  var index = -1;
  var length = nodes.length;
  if (loose) {
    result.push(u$a('text', '\n'));
  }
  while (++index < length) {
    if (index) {
      result.push(u$a('text', '\n'));
    }
    result.push(nodes[index]);
  }
  if (loose && nodes.length > 0) {
    result.push(u$a('text', '\n'));
  }
  return result;
}
var list_1 = list$1;
var wrap$4 = wrap_1;
var all$c = requireAll();
function list$1(h, node) {
  var props = {};
  var name = node.ordered ? 'ol' : 'ul';
  var items;
  var index = -1;
  var length;
  if (typeof node.start === 'number' && node.start !== 1) {
    props.start = node.start;
  }
  items = all$c(h, node);
  length = items.length;

  // Like GitHub, add a class for custom styling.
  while (++index < length) {
    if (items[index].properties.className && items[index].properties.className.indexOf('task-list-item') !== -1) {
      props.className = ['contains-task-list'];
      break;
    }
  }
  return h(node, name, props, wrap$4(items, true));
}
var footer$1 = generateFootnotes;
var thematicBreak = thematicBreak_1;
var list = list_1;
var wrap$3 = wrap_1;
function generateFootnotes(h) {
  var footnoteById = h.footnoteById;
  var footnoteOrder = h.footnoteOrder;
  var length = footnoteOrder.length;
  var index = -1;
  var listItems = [];
  var def;
  var backReference;
  var content;
  var tail;
  while (++index < length) {
    def = footnoteById[footnoteOrder[index].toUpperCase()];
    if (!def) {
      continue;
    }
    content = def.children.concat();
    tail = content[content.length - 1];
    backReference = {
      type: 'link',
      url: '#fnref-' + def.identifier,
      data: {
        hProperties: {
          className: ['footnote-backref']
        }
      },
      children: [{
        type: 'text',
        value: '↩'
      }]
    };
    if (!tail || tail.type !== 'paragraph') {
      tail = {
        type: 'paragraph',
        children: []
      };
      content.push(tail);
    }
    tail.children.push(backReference);
    listItems.push({
      type: 'listItem',
      data: {
        hProperties: {
          id: 'fn-' + def.identifier
        }
      },
      children: content,
      position: def.position
    });
  }
  if (listItems.length === 0) {
    return null;
  }
  return h(null, 'div', {
    className: ['footnotes']
  }, wrap$3([thematicBreak(h), list(h, {
    type: 'list',
    ordered: true,
    children: listItems
  })], true));
}
var blockquote_1 = blockquote;
var wrap$2 = wrap_1;
var all$b = requireAll();
function blockquote(h, node) {
  return h(node, 'blockquote', wrap$2(all$b(h, node), true));
}
var _break = hardBreak;
var u$9 = unistBuilder;
function hardBreak(h, node) {
  return [h(node, 'br'), u$9('text', '\n')];
}
var code_1 = code$1;
var u$8 = unistBuilder;
function code$1(h, node) {
  var value = node.value ? node.value + '\n' : '';
  // To do: next major, use `node.lang` w/o regex, the splitting’s been going
  // on for years in remark now.
  var lang = node.lang && node.lang.match(/^[^ \t]+(?=[ \t]|$)/);
  var props = {};
  var code;
  if (lang) {
    props.className = ['language-' + lang];
  }
  code = h(node, 'code', props, [u$8('text', value)]);
  if (node.meta) {
    code.data = {
      meta: node.meta
    };
  }
  return h(node.position, 'pre', [code]);
}
var _delete = strikethrough$3;
var all$a = requireAll();
function strikethrough$3(h, node) {
  return h(node, 'del', all$a(h, node));
}
var emphasis_1 = emphasis;
var all$9 = requireAll();
function emphasis(h, node) {
  return h(node, 'em', all$9(h, node));
}
var footnoteReference_1 = footnoteReference$1;
var u$7 = unistBuilder;
function footnoteReference$1(h, node) {
  var footnoteOrder = h.footnoteOrder;
  var identifier = String(node.identifier);
  if (footnoteOrder.indexOf(identifier) === -1) {
    footnoteOrder.push(identifier);
  }
  return h(node.position, 'sup', {
    id: 'fnref-' + identifier
  }, [h(node, 'a', {
    href: '#fn-' + identifier,
    className: ['footnote-ref']
  }, [u$7('text', node.label || identifier)])]);
}
var footnote_1 = footnote;
var footnoteReference = footnoteReference_1;
function footnote(h, node) {
  var footnoteById = h.footnoteById;
  var footnoteOrder = h.footnoteOrder;
  var identifier = 1;
  while (identifier in footnoteById) {
    identifier++;
  }
  identifier = String(identifier);

  // No need to check if `identifier` exists in `footnoteOrder`, it’s guaranteed
  // to not exist because we just generated it.
  footnoteOrder.push(identifier);
  footnoteById[identifier] = {
    type: 'footnoteDefinition',
    identifier: identifier,
    children: [{
      type: 'paragraph',
      children: node.children
    }],
    position: node.position
  };
  return footnoteReference(h, {
    type: 'footnoteReference',
    identifier: identifier,
    position: node.position
  });
}
var heading_1 = heading;
var all$8 = requireAll();
function heading(h, node) {
  return h(node, 'h' + node.depth, all$8(h, node));
}
var html_1$1 = html$3;
var u$6 = unistBuilder;

// Return either a `raw` node in dangerous mode, otherwise nothing.
function html$3(h, node) {
  return h.dangerous ? h.augment(node, u$6('raw', node.value)) : null;
}
var encodeCache = {};

// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function getEncodeCache(exclude) {
  var i,
    ch,
    cache = encodeCache[exclude];
  if (cache) {
    return cache;
  }
  cache = encodeCache[exclude] = [];
  for (i = 0; i < 128; i++) {
    ch = String.fromCharCode(i);
    if (/^[0-9a-z]$/i.test(ch)) {
      // always allow unencoded alphanumeric characters
      cache.push(ch);
    } else {
      cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
  }
  for (i = 0; i < exclude.length; i++) {
    cache[exclude.charCodeAt(i)] = exclude[i];
  }
  return cache;
}

// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function encode(string, exclude, keepEscaped) {
  var i,
    l,
    code,
    nextCode,
    cache,
    result = '';
  if (typeof exclude !== 'string') {
    // encode(string, keepEscaped)
    keepEscaped = exclude;
    exclude = encode.defaultChars;
  }
  if (typeof keepEscaped === 'undefined') {
    keepEscaped = true;
  }
  cache = getEncodeCache(exclude);
  for (i = 0, l = string.length; i < l; i++) {
    code = string.charCodeAt(i);
    if (keepEscaped && code === 0x25 /* % */ && i + 2 < l) {
      if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
        result += string.slice(i, i + 3);
        i += 2;
        continue;
      }
    }
    if (code < 128) {
      result += cache[code];
      continue;
    }
    if (code >= 0xD800 && code <= 0xDFFF) {
      if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
        nextCode = string.charCodeAt(i + 1);
        if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
          result += encodeURIComponent(string[i] + string[i + 1]);
          i++;
          continue;
        }
      }
      result += '%EF%BF%BD';
      continue;
    }
    result += encodeURIComponent(string[i]);
  }
  return result;
}
encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
encode.componentChars = "-_.!~*'()";
var encode_1 = encode;
var revert_1 = revert$2;
var u$5 = unistBuilder;
var all$7 = requireAll();

// Return the content of a reference without definition as Markdown.
function revert$2(h, node) {
  var subtype = node.referenceType;
  var suffix = ']';
  var contents;
  var head;
  var tail;
  if (subtype === 'collapsed') {
    suffix += '[]';
  } else if (subtype === 'full') {
    suffix += '[' + (node.label || node.identifier) + ']';
  }
  if (node.type === 'imageReference') {
    return u$5('text', '![' + node.alt + suffix);
  }
  contents = all$7(h, node);
  head = contents[0];
  if (head && head.type === 'text') {
    head.value = '[' + head.value;
  } else {
    contents.unshift(u$5('text', '['));
  }
  tail = contents[contents.length - 1];
  if (tail && tail.type === 'text') {
    tail.value += suffix;
  } else {
    contents.push(u$5('text', suffix));
  }
  return contents;
}
var imageReference_1 = imageReference;
var normalize$6 = encode_1;
var revert$1 = revert_1;
function imageReference(h, node) {
  var def = h.definition(node.identifier);
  var props;
  if (!def) {
    return revert$1(h, node);
  }
  props = {
    src: normalize$6(def.url || ''),
    alt: node.alt
  };
  if (def.title !== null && def.title !== undefined) {
    props.title = def.title;
  }
  return h(node, 'img', props);
}
var normalize$5 = encode_1;
var image_1 = image;
function image(h, node) {
  var props = {
    src: normalize$5(node.url),
    alt: node.alt
  };
  if (node.title !== null && node.title !== undefined) {
    props.title = node.title;
  }
  return h(node, 'img', props);
}
var inlineCode_1$1 = inlineCode$1;
var u$4 = unistBuilder;
function inlineCode$1(h, node) {
  var value = node.value.replace(/\r?\n|\r/g, ' ');
  return h(node, 'code', [u$4('text', value)]);
}
var linkReference_1 = linkReference;
var normalize$4 = encode_1;
var revert = revert_1;
var all$6 = requireAll();
function linkReference(h, node) {
  var def = h.definition(node.identifier);
  var props;
  if (!def) {
    return revert(h, node);
  }
  props = {
    href: normalize$4(def.url || '')
  };
  if (def.title !== null && def.title !== undefined) {
    props.title = def.title;
  }
  return h(node, 'a', props, all$6(h, node));
}
var normalize$3 = encode_1;
var all$5 = requireAll();
var link_1 = link;
function link(h, node) {
  var props = {
    href: normalize$3(node.url)
  };
  if (node.title !== null && node.title !== undefined) {
    props.title = node.title;
  }
  return h(node, 'a', props, all$5(h, node));
}
var listItem_1$1 = listItem$1;
var u$3 = unistBuilder;
var all$4 = requireAll();
function listItem$1(h, node, parent) {
  var result = all$4(h, node);
  var head = result[0];
  var loose = parent ? listLoose(parent) : listItemLoose(node);
  var props = {};
  var wrapped = [];
  var length;
  var index;
  var child;
  if (typeof node.checked === 'boolean') {
    if (!head || head.tagName !== 'p') {
      head = h(null, 'p', []);
      result.unshift(head);
    }
    if (head.children.length > 0) {
      head.children.unshift(u$3('text', ' '));
    }
    head.children.unshift(h(null, 'input', {
      type: 'checkbox',
      checked: node.checked,
      disabled: true
    }));

    // According to github-markdown-css, this class hides bullet.
    // See: <https://github.com/sindresorhus/github-markdown-css>.
    props.className = ['task-list-item'];
  }
  length = result.length;
  index = -1;
  while (++index < length) {
    child = result[index];

    // Add eols before nodes, except if this is a loose, first paragraph.
    if (loose || index !== 0 || child.tagName !== 'p') {
      wrapped.push(u$3('text', '\n'));
    }
    if (child.tagName === 'p' && !loose) {
      wrapped = wrapped.concat(child.children);
    } else {
      wrapped.push(child);
    }
  }

  // Add a final eol.
  if (length && (loose || child.tagName !== 'p')) {
    wrapped.push(u$3('text', '\n'));
  }
  return h(node, 'li', props, wrapped);
}
function listLoose(node) {
  var loose = node.spread;
  var children = node.children;
  var length = children.length;
  var index = -1;
  while (!loose && ++index < length) {
    loose = listItemLoose(children[index]);
  }
  return loose;
}
function listItemLoose(node) {
  var spread = node.spread;
  return spread === undefined || spread === null ? node.children.length > 1 : spread;
}
var paragraph_1 = paragraph;
var all$3 = requireAll();
function paragraph(h, node) {
  return h(node, 'p', all$3(h, node));
}
var root_1 = root$a;
var u$2 = unistBuilder;
var wrap$1 = wrap_1;
var all$2 = requireAll();
function root$a(h, node) {
  return h.augment(node, u$2('root', wrap$1(all$2(h, node))));
}
var strong_1 = strong;
var all$1 = requireAll();
function strong(h, node) {
  return h(node, 'strong', all$1(h, node));
}
var table_1 = table$3;
var position$1 = unistUtilPosition;
var wrap = wrap_1;
var all = requireAll();
function table$3(h, node) {
  var rows = node.children;
  var index = rows.length;
  var align = node.align || [];
  var alignLength = align.length;
  var result = [];
  var pos;
  var row;
  var out;
  var name;
  var cell;
  while (index--) {
    row = rows[index].children;
    name = index === 0 ? 'th' : 'td';
    pos = alignLength || row.length;
    out = [];
    while (pos--) {
      cell = row[pos];
      out[pos] = h(cell, name, {
        align: align[pos]
      }, cell ? all(h, cell) : []);
    }
    result[index] = h(rows[index], 'tr', wrap(out, true));
  }
  return h(node, 'table', wrap([h(result[0].position, 'thead', wrap([result[0]], true))].concat(result[1] ? h({
    start: position$1.start(result[1]),
    end: position$1.end(result[result.length - 1])
  }, 'tbody', wrap(result.slice(1), true)) : []), true));
}
var text_1 = text$1;
var u$1 = unistBuilder;
function text$1(h, node) {
  return h.augment(node, u$1('text', String(node.value).replace(/[ \t]*(\r?\n|\r)[ \t]*/g, '$1')));
}
var handlers$1 = {
  blockquote: blockquote_1,
  break: _break,
  code: code_1,
  delete: _delete,
  emphasis: emphasis_1,
  footnoteReference: footnoteReference_1,
  footnote: footnote_1,
  heading: heading_1,
  html: html_1$1,
  imageReference: imageReference_1,
  image: image_1,
  inlineCode: inlineCode_1$1,
  linkReference: linkReference_1,
  link: link_1,
  listItem: listItem_1$1,
  list: list_1,
  paragraph: paragraph_1,
  root: root_1,
  strong: strong_1,
  table: table_1,
  text: text_1,
  thematicBreak: thematicBreak_1,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
};

// Return nothing for nodes that are ignored.
function ignore() {
  return null;
}
var lib = toHast;
var u = unistBuilder;
var visit$2 = unistUtilVisit;
var position = unistUtilPosition;
var generated = unistUtilGenerated;
var definitions = mdastUtilDefinitions;
var one = requireOne();
var footer = footer$1;
var handlers = handlers$1;
var own$3 = {}.hasOwnProperty;
var deprecationWarningIssued = false;

// Factory to transform.
function factory(tree, options) {
  var settings = options || {};

  // Issue a warning if the deprecated tag 'allowDangerousHTML' is used
  if (settings.allowDangerousHTML !== undefined && !deprecationWarningIssued) {
    deprecationWarningIssued = true;
    console.warn('mdast-util-to-hast: deprecation: `allowDangerousHTML` is nonstandard, use `allowDangerousHtml` instead');
  }
  var dangerous = settings.allowDangerousHtml || settings.allowDangerousHTML;
  var footnoteById = {};
  h.dangerous = dangerous;
  h.definition = definitions(tree);
  h.footnoteById = footnoteById;
  h.footnoteOrder = [];
  h.augment = augment;
  h.handlers = Object.assign({}, handlers, settings.handlers);
  h.unknownHandler = settings.unknownHandler;
  h.passThrough = settings.passThrough;
  visit$2(tree, 'footnoteDefinition', onfootnotedefinition);
  return h;

  // Finalise the created `right`, a hast node, from `left`, an mdast node.
  function augment(left, right) {
    var data;
    var ctx;

    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (left && left.data) {
      data = left.data;
      if (data.hName) {
        if (right.type !== 'element') {
          right = {
            type: 'element',
            tagName: '',
            properties: {},
            children: []
          };
        }
        right.tagName = data.hName;
      }
      if (right.type === 'element' && data.hProperties) {
        right.properties = Object.assign({}, right.properties, data.hProperties);
      }
      if (right.children && data.hChildren) {
        right.children = data.hChildren;
      }
    }
    ctx = left && left.position ? left : {
      position: left
    };
    if (!generated(ctx)) {
      right.position = {
        start: position.start(ctx),
        end: position.end(ctx)
      };
    }
    return right;
  }

  // Create an element for `node`.
  function h(node, tagName, props, children) {
    if ((children === undefined || children === null) && typeof props === 'object' && 'length' in props) {
      children = props;
      props = {};
    }
    return augment(node, {
      type: 'element',
      tagName: tagName,
      properties: props || {},
      children: children || []
    });
  }
  function onfootnotedefinition(definition) {
    var id = String(definition.identifier).toUpperCase();

    // Mimick CM behavior of link definitions.
    // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
    if (!own$3.call(footnoteById, id)) {
      footnoteById[id] = definition;
    }
  }
}

// Transform `tree`, which is an mdast node, to a hast node.
function toHast(tree, options) {
  var h = factory(tree, options);
  var node = one(h, tree);
  var foot = footer(h);
  if (foot) {
    node.children = node.children.concat(u('text', '\n'), foot);
  }
  return node;
}
(function (module) {
  module.exports = lib;
})(mdastUtilToHast);
var mdast2hast = mdastUtilToHast.exports;
var remarkRehype$1 = remark2rehype;

// Attacher.
// If a destination is given, runs the destination with the new hast tree
// (bridge mode).
// Without destination, returns the tree: further plugins run on that tree
// (mutate mode).
function remark2rehype(destination, options) {
  if (destination && !destination.process) {
    options = destination;
    destination = null;
  }
  return destination ? bridge(destination, options) : mutate(options);
}

// Bridge mode.
// Runs the destination with the new hast tree.
function bridge(destination, options) {
  return transformer;
  function transformer(node, file, next) {
    destination.run(mdast2hast(node, options), file, done);
    function done(error) {
      next(error);
    }
  }
}

// Mutate-mode.
// Further transformers run on the hast tree.
function mutate(options) {
  return transformer;
  function transformer(node) {
    return mdast2hast(node, options);
  }
}
var propTypes = {
  exports: {}
};
var reactIs$2 = {
  exports: {}
};
var reactIs_production_min$1 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min$1.AsyncMode = l;
  reactIs_production_min$1.ConcurrentMode = m;
  reactIs_production_min$1.ContextConsumer = k;
  reactIs_production_min$1.ContextProvider = h;
  reactIs_production_min$1.Element = c;
  reactIs_production_min$1.ForwardRef = n;
  reactIs_production_min$1.Fragment = e;
  reactIs_production_min$1.Lazy = t;
  reactIs_production_min$1.Memo = r;
  reactIs_production_min$1.Portal = d;
  reactIs_production_min$1.Profiler = g;
  reactIs_production_min$1.StrictMode = f;
  reactIs_production_min$1.Suspense = p;
  reactIs_production_min$1.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min$1.isConcurrentMode = A;
  reactIs_production_min$1.isContextConsumer = function (a) {
    return z(a) === k;
  };
  reactIs_production_min$1.isContextProvider = function (a) {
    return z(a) === h;
  };
  reactIs_production_min$1.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min$1.isForwardRef = function (a) {
    return z(a) === n;
  };
  reactIs_production_min$1.isFragment = function (a) {
    return z(a) === e;
  };
  reactIs_production_min$1.isLazy = function (a) {
    return z(a) === t;
  };
  reactIs_production_min$1.isMemo = function (a) {
    return z(a) === r;
  };
  reactIs_production_min$1.isPortal = function (a) {
    return z(a) === d;
  };
  reactIs_production_min$1.isProfiler = function (a) {
    return z(a) === g;
  };
  reactIs_production_min$1.isStrictMode = function (a) {
    return z(a) === f;
  };
  reactIs_production_min$1.isSuspense = function (a) {
    return z(a) === p;
  };
  reactIs_production_min$1.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min$1.typeOf = z;
  return reactIs_production_min$1;
}
var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1) return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$1.AsyncMode = AsyncMode;
      reactIs_development$1.ConcurrentMode = ConcurrentMode;
      reactIs_development$1.ContextConsumer = ContextConsumer;
      reactIs_development$1.ContextProvider = ContextProvider;
      reactIs_development$1.Element = Element;
      reactIs_development$1.ForwardRef = ForwardRef;
      reactIs_development$1.Fragment = Fragment;
      reactIs_development$1.Lazy = Lazy;
      reactIs_development$1.Memo = Memo;
      reactIs_development$1.Portal = Portal;
      reactIs_development$1.Profiler = Profiler;
      reactIs_development$1.StrictMode = StrictMode;
      reactIs_development$1.Suspense = Suspense;
      reactIs_development$1.isAsyncMode = isAsyncMode;
      reactIs_development$1.isConcurrentMode = isConcurrentMode;
      reactIs_development$1.isContextConsumer = isContextConsumer;
      reactIs_development$1.isContextProvider = isContextProvider;
      reactIs_development$1.isElement = isElement;
      reactIs_development$1.isForwardRef = isForwardRef;
      reactIs_development$1.isFragment = isFragment;
      reactIs_development$1.isLazy = isLazy;
      reactIs_development$1.isMemo = isMemo;
      reactIs_development$1.isPortal = isPortal;
      reactIs_development$1.isProfiler = isProfiler;
      reactIs_development$1.isStrictMode = isStrictMode;
      reactIs_development$1.isSuspense = isSuspense;
      reactIs_development$1.isValidElementType = isValidElementType;
      reactIs_development$1.typeOf = typeOf;
    })();
  }
  return reactIs_development$1;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs$2.exports;
  hasRequiredReactIs = 1;
  (function (module) {
    if (process.env.NODE_ENV === 'production') {
      module.exports = requireReactIs_production_min$1();
    } else {
      module.exports = requireReactIs_development$1();
    }
  })(reactIs$2);
  return reactIs$2.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }

      // Detect buggy property enumeration order in older V8 versions.

      // https://bugs.chromium.org/p/v8/issues/detail?id=4118
      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
      test1[5] = 'de';
      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if (order2.join('') !== '0123456789') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }
      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has$1;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has$1;
  hasRequiredHas = 1;
  has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
  return has$1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function printWarning() {};
  if (process.env.NODE_ENV !== 'production') {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has = requireHas();
    printWarning = function printWarning(text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {/**/}
    };
  }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== 'production') {
      for (var typeSpecName in typeSpecs) {
        if (has(typeSpecs, typeSpecName)) {
          var error;
          // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.
          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
              var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
              err.name = 'Invariant Violation';
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
          }
        }
      }
    }
  }

  /**
   * Resets warning cache when testing.
   *
   * @private
   */
  checkPropTypes.resetWarningCache = function () {
    if (process.env.NODE_ENV !== 'production') {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function printWarning() {};
  if (process.env.NODE_ENV !== 'production') {
    printWarning = function printWarning(text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bigint: createPrimitiveTypeChecker('bigint'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === 'object' ? data : {};
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== 'production') {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            err.name = 'Invariant Violation';
            throw err;
          } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;
            if (!manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
            expectedType: expectedType
          });
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== 'production') {
          if (arguments.length > 1) {
            printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
          } else {
            printWarning('Invalid argument supplied to oneOf, expected an array.');
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === 'symbol') {
            return String(value);
          }
          return value;
        });
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (has(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from props.
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has(shapeTypes, key) && typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // falsy value can't be a Symbol
      if (!propValue) {
        return false;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {}
  function emptyFunctionWithReset() {}
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function factoryWithThrowingShims() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }
      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    } // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs$1 = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs$1.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}
var immutable = extend;
var hasOwnProperty$l = Object.prototype.hasOwnProperty;
function extend() {
  var target = {};
  for (var i = 0; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (hasOwnProperty$l.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
}
var schema = Schema$2;
var proto$1 = Schema$2.prototype;
proto$1.space = null;
proto$1.normal = {};
proto$1.property = {};
function Schema$2(property, normal, space) {
  this.property = property;
  this.normal = normal;
  if (space) {
    this.space = space;
  }
}
var xtend = immutable;
var Schema$1 = schema;
var merge_1 = merge$2;
function merge$2(definitions) {
  var length = definitions.length;
  var property = [];
  var normal = [];
  var index = -1;
  var info;
  var space;
  while (++index < length) {
    info = definitions[index];
    property.push(info.property);
    normal.push(info.normal);
    space = info.space;
  }
  return new Schema$1(xtend.apply(null, property), xtend.apply(null, normal), space);
}
var normalize_1 = normalize$2;
function normalize$2(value) {
  return value.toLowerCase();
}
var info = Info$2;
var proto = Info$2.prototype;
proto.space = null;
proto.attribute = null;
proto.property = null;
proto.boolean = false;
proto.booleanish = false;
proto.overloadedBoolean = false;
proto.number = false;
proto.commaSeparated = false;
proto.spaceSeparated = false;
proto.commaOrSpaceSeparated = false;
proto.mustUseProperty = false;
proto.defined = false;
function Info$2(property, attribute) {
  this.property = property;
  this.attribute = attribute;
}
var types$4 = {};
var powers = 0;
types$4.boolean = increment();
types$4.booleanish = increment();
types$4.overloadedBoolean = increment();
types$4.number = increment();
types$4.spaceSeparated = increment();
types$4.commaSeparated = increment();
types$4.commaOrSpaceSeparated = increment();
function increment() {
  return Math.pow(2, ++powers);
}
var Info$1 = info;
var types$3 = types$4;
var definedInfo = DefinedInfo$2;
DefinedInfo$2.prototype = new Info$1();
DefinedInfo$2.prototype.defined = true;
var checks = ['boolean', 'booleanish', 'overloadedBoolean', 'number', 'commaSeparated', 'spaceSeparated', 'commaOrSpaceSeparated'];
var checksLength = checks.length;
function DefinedInfo$2(property, attribute, mask, space) {
  var index = -1;
  var check;
  mark(this, 'space', space);
  Info$1.call(this, property, attribute);
  while (++index < checksLength) {
    check = checks[index];
    mark(this, check, (mask & types$3[check]) === types$3[check]);
  }
}
function mark(values, key, value) {
  if (value) {
    values[key] = value;
  }
}
var normalize$1 = normalize_1;
var Schema = schema;
var DefinedInfo$1 = definedInfo;
var create_1 = create$c;
function create$c(definition) {
  var space = definition.space;
  var mustUseProperty = definition.mustUseProperty || [];
  var attributes = definition.attributes || {};
  var props = definition.properties;
  var transform = definition.transform;
  var property = {};
  var normal = {};
  var prop;
  var info;
  for (prop in props) {
    info = new DefinedInfo$1(prop, transform(attributes, prop), props[prop], space);
    if (mustUseProperty.indexOf(prop) !== -1) {
      info.mustUseProperty = true;
    }
    property[prop] = info;
    normal[normalize$1(prop)] = prop;
    normal[normalize$1(info.attribute)] = prop;
  }
  return new Schema(property, normal, space);
}
var create$b = create_1;
var xlink$2 = create$b({
  space: 'xlink',
  transform: xlinkTransform,
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
});
function xlinkTransform(_, prop) {
  return 'xlink:' + prop.slice(5).toLowerCase();
}
var create$a = create_1;
var xml$2 = create$a({
  space: 'xml',
  transform: xmlTransform,
  properties: {
    xmlLang: null,
    xmlBase: null,
    xmlSpace: null
  }
});
function xmlTransform(_, prop) {
  return 'xml:' + prop.slice(3).toLowerCase();
}
var caseSensitiveTransform_1 = caseSensitiveTransform$2;
function caseSensitiveTransform$2(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute;
}
var caseSensitiveTransform$1 = caseSensitiveTransform_1;
var caseInsensitiveTransform_1 = caseInsensitiveTransform$2;
function caseInsensitiveTransform$2(attributes, property) {
  return caseSensitiveTransform$1(attributes, property.toLowerCase());
}
var create$9 = create_1;
var caseInsensitiveTransform$1 = caseInsensitiveTransform_1;
var xmlns$2 = create$9({
  space: 'xmlns',
  attributes: {
    xmlnsxlink: 'xmlns:xlink'
  },
  transform: caseInsensitiveTransform$1,
  properties: {
    xmlns: null,
    xmlnsXLink: null
  }
});
var types$2 = types$4;
var create$8 = create_1;
var booleanish$1 = types$2.booleanish;
var number$3 = types$2.number;
var spaceSeparated$2 = types$2.spaceSeparated;
var aria$2 = create$8({
  transform: ariaTransform,
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish$1,
    ariaAutoComplete: null,
    ariaBusy: booleanish$1,
    ariaChecked: booleanish$1,
    ariaColCount: number$3,
    ariaColIndex: number$3,
    ariaColSpan: number$3,
    ariaControls: spaceSeparated$2,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated$2,
    ariaDetails: null,
    ariaDisabled: booleanish$1,
    ariaDropEffect: spaceSeparated$2,
    ariaErrorMessage: null,
    ariaExpanded: booleanish$1,
    ariaFlowTo: spaceSeparated$2,
    ariaGrabbed: booleanish$1,
    ariaHasPopup: null,
    ariaHidden: booleanish$1,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated$2,
    ariaLevel: number$3,
    ariaLive: null,
    ariaModal: booleanish$1,
    ariaMultiLine: booleanish$1,
    ariaMultiSelectable: booleanish$1,
    ariaOrientation: null,
    ariaOwns: spaceSeparated$2,
    ariaPlaceholder: null,
    ariaPosInSet: number$3,
    ariaPressed: booleanish$1,
    ariaReadOnly: booleanish$1,
    ariaRelevant: null,
    ariaRequired: booleanish$1,
    ariaRoleDescription: spaceSeparated$2,
    ariaRowCount: number$3,
    ariaRowIndex: number$3,
    ariaRowSpan: number$3,
    ariaSelected: booleanish$1,
    ariaSetSize: number$3,
    ariaSort: null,
    ariaValueMax: number$3,
    ariaValueMin: number$3,
    ariaValueNow: number$3,
    ariaValueText: null,
    role: null
  }
});
function ariaTransform(_, prop) {
  return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase();
}
var types$1 = types$4;
var create$7 = create_1;
var caseInsensitiveTransform = caseInsensitiveTransform_1;
var boolean$2 = types$1.boolean;
var overloadedBoolean = types$1.overloadedBoolean;
var booleanish = types$1.booleanish;
var number$2 = types$1.number;
var spaceSeparated$1 = types$1.spaceSeparated;
var commaSeparated$1 = types$1.commaSeparated;
var html$2 = create$7({
  space: 'html',
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  transform: caseInsensitiveTransform,
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated$1,
    acceptCharset: spaceSeparated$1,
    accessKey: spaceSeparated$1,
    action: null,
    allow: null,
    allowFullScreen: boolean$2,
    allowPaymentRequest: boolean$2,
    allowUserMedia: boolean$2,
    alt: null,
    as: null,
    async: boolean$2,
    autoCapitalize: null,
    autoComplete: spaceSeparated$1,
    autoFocus: boolean$2,
    autoPlay: boolean$2,
    capture: boolean$2,
    charSet: null,
    checked: boolean$2,
    cite: null,
    className: spaceSeparated$1,
    cols: number$2,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean$2,
    controlsList: spaceSeparated$1,
    coords: number$2 | commaSeparated$1,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean$2,
    defer: boolean$2,
    dir: null,
    dirName: null,
    disabled: boolean$2,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean$2,
    formTarget: null,
    headers: spaceSeparated$1,
    height: number$2,
    hidden: boolean$2,
    high: number$2,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated$1,
    httpEquiv: spaceSeparated$1,
    id: null,
    imageSizes: null,
    imageSrcSet: commaSeparated$1,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean$2,
    itemId: null,
    itemProp: spaceSeparated$1,
    itemRef: spaceSeparated$1,
    itemScope: boolean$2,
    itemType: spaceSeparated$1,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean$2,
    low: number$2,
    manifest: null,
    max: null,
    maxLength: number$2,
    media: null,
    method: null,
    min: null,
    minLength: number$2,
    multiple: boolean$2,
    muted: boolean$2,
    name: null,
    nonce: null,
    noModule: boolean$2,
    noValidate: boolean$2,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextMenu: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean$2,
    optimum: number$2,
    pattern: null,
    ping: spaceSeparated$1,
    placeholder: null,
    playsInline: boolean$2,
    poster: null,
    preload: null,
    readOnly: boolean$2,
    referrerPolicy: null,
    rel: spaceSeparated$1,
    required: boolean$2,
    reversed: boolean$2,
    rows: number$2,
    rowSpan: number$2,
    sandbox: spaceSeparated$1,
    scope: null,
    scoped: boolean$2,
    seamless: boolean$2,
    selected: boolean$2,
    shape: null,
    size: number$2,
    sizes: null,
    slot: null,
    span: number$2,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: commaSeparated$1,
    start: number$2,
    step: null,
    style: null,
    tabIndex: number$2,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean$2,
    useMap: null,
    value: booleanish,
    width: number$2,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated$1,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: number$2,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number$2,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: boolean$2,
    // Lists. Use CSS to reduce space between items instead
    declare: boolean$2,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: number$2,
    // `<img>` and `<object>`
    leftMargin: number$2,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: number$2,
    // `<body>`
    marginWidth: number$2,
    // `<body>`
    noResize: boolean$2,
    // `<frame>`
    noHref: boolean$2,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean$2,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean$2,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: number$2,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: booleanish,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: number$2,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number$2,
    // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean$2,
    disableRemotePlayback: boolean$2,
    prefix: null,
    property: null,
    results: number$2,
    security: null,
    unselectable: null
  }
});
var merge$1 = merge_1;
var xlink$1 = xlink$2;
var xml$1 = xml$2;
var xmlns$1 = xmlns$2;
var aria$1 = aria$2;
var html$1 = html$2;
var html_1 = merge$1([xml$1, xlink$1, xmlns$1, aria$1, html$1]);
var visit$1 = unistUtilVisit;
var rehypeFilter_1 = rehypeFilter;

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Element} Element
 *
 * @callback AllowElement
 * @param {Element} element
 * @param {number} index
 * @param {Element|Root} parent
 * @returns {boolean|undefined}
 *
 * @typedef RehypeFilterOptions
 * @property {Array.<string>} [allowedElements]
 * @property {Array.<string>} [disallowedElements=[]]
 * @property {AllowElement} [allowElement]
 * @property {boolean} [unwrapDisallowed=false]
 */

/**
 * @type {import('unified').Plugin<[RehypeFilterOptions]>}
 */
function rehypeFilter(options) {
  if (options.allowedElements && options.disallowedElements) {
    throw new TypeError('Only one of `allowedElements` and `disallowedElements` should be defined');
  }
  if (options.allowedElements || options.disallowedElements || options.allowElement) {
    return function (tree) {
      var node = /** @type {Root} */tree;
      visit$1(node, 'element', onelement);
    };
  }

  /**
   * @param {Node} node_
   * @param {number|null|undefined} index
   * @param {Node|null|undefined} parent_
   * @returns {number|void}
   */
  function onelement(node_, index, parent_) {
    var node = /** @type {Element} */node_;
    var parent = /** @type {Element|Root} */parent_;
    /** @type {boolean|undefined} */
    var remove;
    if (options.allowedElements) {
      remove = !options.allowedElements.includes(node.tagName);
    } else if (options.disallowedElements) {
      remove = options.disallowedElements.includes(node.tagName);
    }
    if (!remove && options.allowElement && typeof index === 'number') {
      remove = !options.allowElement(node, index, parent);
    }
    if (remove && typeof index === 'number') {
      if (options.unwrapDisallowed && node.children) {
        var _parent$children;
        (_parent$children = parent.children).splice.apply(_parent$children, [index, 1].concat(_toConsumableArray2(node.children)));
      } else {
        parent.children.splice(index, 1);
      }
      return index;
    }
    return undefined;
  }
}
var protocols = ['http', 'https', 'mailto', 'tel'];
var uriTransformer_1 = uriTransformer$1;

/**
 * @param {string} uri
 * @returns {string}
 */
function uriTransformer$1(uri) {
  var url = (uri || '').trim();
  var first = url.charAt(0);
  if (first === '#' || first === '/') {
    return url;
  }
  var colon = url.indexOf(':');
  if (colon === -1) {
    return url;
  }
  var index = -1;
  while (++index < protocols.length) {
    var protocol = protocols[index];
    if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) {
      return url;
    }
  }
  index = url.indexOf('?');
  if (index !== -1 && colon > index) {
    return url;
  }
  index = url.indexOf('#');
  if (index !== -1 && colon > index) {
    return url;
  }

  // eslint-disable-next-line no-script-url
  return 'javascript:void(0)';
}
var astToReact = {};
var reactIs$1 = {
  exports: {}
};
var reactIs_production_min = {};

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = 60103,
    c = 60106,
    d = 60107,
    e = 60108,
    f = 60114,
    g = 60109,
    h = 60110,
    k = 60112,
    l = 60113,
    m = 60120,
    n = 60115,
    p = 60116,
    q = 60121,
    r = 60122,
    u = 60117,
    v = 60129,
    w = 60131;
  if ("function" === typeof Symbol && Symbol.for) {
    var x = Symbol.for;
    b = x("react.element");
    c = x("react.portal");
    d = x("react.fragment");
    e = x("react.strict_mode");
    f = x("react.profiler");
    g = x("react.provider");
    h = x("react.context");
    k = x("react.forward_ref");
    l = x("react.suspense");
    m = x("react.suspense_list");
    n = x("react.memo");
    p = x("react.lazy");
    q = x("react.block");
    r = x("react.server.block");
    u = x("react.fundamental");
    v = x("react.debug_trace_mode");
    w = x("react.legacy_hidden");
  }
  function y(a) {
    if ("object" === typeof a && null !== a) {
      var t = a.$$typeof;
      switch (t) {
        case b:
          switch (a = a.type, a) {
            case d:
            case f:
            case e:
            case l:
            case m:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case h:
                case k:
                case p:
                case n:
                case g:
                  return a;
                default:
                  return t;
              }
          }
        case c:
          return t;
      }
    }
  }
  var z = g,
    A = b,
    B = k,
    C = d,
    D = p,
    E = n,
    F = c,
    G = f,
    H = e,
    I = l;
  reactIs_production_min.ContextConsumer = h;
  reactIs_production_min.ContextProvider = z;
  reactIs_production_min.Element = A;
  reactIs_production_min.ForwardRef = B;
  reactIs_production_min.Fragment = C;
  reactIs_production_min.Lazy = D;
  reactIs_production_min.Memo = E;
  reactIs_production_min.Portal = F;
  reactIs_production_min.Profiler = G;
  reactIs_production_min.StrictMode = H;
  reactIs_production_min.Suspense = I;
  reactIs_production_min.isAsyncMode = function () {
    return !1;
  };
  reactIs_production_min.isConcurrentMode = function () {
    return !1;
  };
  reactIs_production_min.isContextConsumer = function (a) {
    return y(a) === h;
  };
  reactIs_production_min.isContextProvider = function (a) {
    return y(a) === g;
  };
  reactIs_production_min.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
  };
  reactIs_production_min.isForwardRef = function (a) {
    return y(a) === k;
  };
  reactIs_production_min.isFragment = function (a) {
    return y(a) === d;
  };
  reactIs_production_min.isLazy = function (a) {
    return y(a) === p;
  };
  reactIs_production_min.isMemo = function (a) {
    return y(a) === n;
  };
  reactIs_production_min.isPortal = function (a) {
    return y(a) === c;
  };
  reactIs_production_min.isProfiler = function (a) {
    return y(a) === f;
  };
  reactIs_production_min.isStrictMode = function (a) {
    return y(a) === e;
  };
  reactIs_production_min.isSuspense = function (a) {
    return y(a) === l;
  };
  reactIs_production_min.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === v || a === e || a === l || a === m || a === w || "object" === typeof a && null !== a && (a.$$typeof === p || a.$$typeof === n || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r) ? !0 : !1;
  };
  reactIs_production_min.typeOf = y;
  return reactIs_production_min;
}
var reactIs_development = {};

/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // ATTENTION
      // When adding new symbols to this file,
      // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var REACT_ELEMENT_TYPE = 0xeac7;
      var REACT_PORTAL_TYPE = 0xeaca;
      var REACT_FRAGMENT_TYPE = 0xeacb;
      var REACT_STRICT_MODE_TYPE = 0xeacc;
      var REACT_PROFILER_TYPE = 0xead2;
      var REACT_PROVIDER_TYPE = 0xeacd;
      var REACT_CONTEXT_TYPE = 0xeace;
      var REACT_FORWARD_REF_TYPE = 0xead0;
      var REACT_SUSPENSE_TYPE = 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = 0xead8;
      var REACT_MEMO_TYPE = 0xead3;
      var REACT_LAZY_TYPE = 0xead4;
      var REACT_BLOCK_TYPE = 0xead9;
      var REACT_SERVER_BLOCK_TYPE = 0xeada;
      var REACT_FUNDAMENTAL_TYPE = 0xead5;
      var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
      var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
      if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor('react.element');
        REACT_PORTAL_TYPE = symbolFor('react.portal');
        REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
        REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
        REACT_PROFILER_TYPE = symbolFor('react.profiler');
        REACT_PROVIDER_TYPE = symbolFor('react.provider');
        REACT_CONTEXT_TYPE = symbolFor('react.context');
        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
        REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
        REACT_MEMO_TYPE = symbolFor('react.memo');
        REACT_LAZY_TYPE = symbolFor('react.lazy');
        REACT_BLOCK_TYPE = symbolFor('react.block');
        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
        symbolFor('react.scope');
        symbolFor('react.opaque.id');
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
        symbolFor('react.offscreen');
        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
      }

      // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

      var enableScopeAPI = false; // Experimental Create Event Handle API.

      function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') {
          return true;
        } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).

        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
          return true;
        }
        if (typeof type === 'object' && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
            return true;
          }
        }
        return false;
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                case REACT_SUSPENSE_LIST_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      }
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
          }
        }
        return false;
      }
      function isConcurrentMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
          }
        }
        return false;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = requireReactIs_production_min();
  } else {
    module.exports = requireReactIs_development();
  }
})(reactIs$1);
var types = types$4;
var create$6 = create_1;
var caseSensitiveTransform = caseSensitiveTransform_1;
var boolean$1 = types.boolean;
var number$1 = types.number;
var spaceSeparated = types.spaceSeparated;
var commaSeparated = types.commaSeparated;
var commaOrSpaceSeparated = types.commaOrSpaceSeparated;
var svg$2 = create$6({
  space: 'svg',
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  transform: caseSensitiveTransform,
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number$1,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number$1,
    amplitude: number$1,
    arabicForm: null,
    ascent: number$1,
    attributeName: null,
    attributeType: null,
    azimuth: number$1,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number$1,
    by: null,
    calcMode: null,
    capHeight: number$1,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number$1,
    diffuseConstant: number$1,
    direction: null,
    display: null,
    dur: null,
    divisor: number$1,
    dominantBaseline: null,
    download: boolean$1,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number$1,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number$1,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number$1,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number$1,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number$1,
    horizOriginX: number$1,
    horizOriginY: number$1,
    id: null,
    ideographic: number$1,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number$1,
    k: number$1,
    k1: number$1,
    k2: number$1,
    k3: number$1,
    k4: number$1,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number$1,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number$1,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number$1,
    overlineThickness: number$1,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number$1,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number$1,
    pointsAtY: number$1,
    pointsAtZ: number$1,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number$1,
    specularExponent: number$1,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number$1,
    strikethroughThickness: number$1,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number$1,
    strokeOpacity: number$1,
    strokeWidth: null,
    style: null,
    surfaceScale: number$1,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number$1,
    tableValues: null,
    target: null,
    targetX: number$1,
    targetY: number$1,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: number$1,
    underlineThickness: number$1,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number$1,
    values: null,
    vAlphabetic: number$1,
    vMathematical: number$1,
    vectorEffect: null,
    vHanging: number$1,
    vIdeographic: number$1,
    version: null,
    vertAdvY: number$1,
    vertOriginX: number$1,
    vertOriginY: number$1,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number$1,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
});
var merge = merge_1;
var xlink = xlink$2;
var xml = xml$2;
var xmlns = xmlns$2;
var aria = aria$2;
var svg$1 = svg$2;
var svg_1 = merge([xml, xlink, xmlns, aria, svg$1]);
var normalize = normalize_1;
var DefinedInfo = definedInfo;
var Info = info;
var data = 'data';
var find_1 = find$1;
var valid = /^data[-\w.:]+$/i;
var dash$1 = /-[a-z]/g;
var cap = /[A-Z]/g;
function find$1(schema, value) {
  var normal = normalize(value);
  var prop = value;
  var Type = Info;
  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]];
  }
  if (normal.length > 4 && normal.slice(0, 4) === data && valid.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      prop = datasetToProperty(value);
    } else {
      value = datasetToAttribute(value);
    }
    Type = DefinedInfo;
  }
  return new Type(prop, value);
}
function datasetToProperty(attribute) {
  var value = attribute.slice(5).replace(dash$1, camelcase);
  return data + value.charAt(0).toUpperCase() + value.slice(1);
}
function datasetToAttribute(property) {
  var value = property.slice(4);
  if (dash$1.test(value)) {
    return property;
  }
  value = value.replace(cap, kebab);
  if (value.charAt(0) !== '-') {
    value = '-' + value;
  }
  return data + value;
}
function kebab($0) {
  return '-' + $0.toLowerCase();
}
function camelcase($0) {
  return $0.charAt(1).toUpperCase();
}
var classId = "classID";
var dataType = "datatype";
var itemId = "itemID";
var strokeDashArray = "strokeDasharray";
var strokeDashOffset = "strokeDashoffset";
var strokeLineCap = "strokeLinecap";
var strokeLineJoin = "strokeLinejoin";
var strokeMiterLimit = "strokeMiterlimit";
var typeOf = "typeof";
var xLinkActuate = "xlinkActuate";
var xLinkArcRole = "xlinkArcrole";
var xLinkHref = "xlinkHref";
var xLinkRole = "xlinkRole";
var xLinkShow = "xlinkShow";
var xLinkTitle = "xlinkTitle";
var xLinkType = "xlinkType";
var xmlnsXLink = "xmlnsXlink";
var require$$4 = {
  classId: classId,
  dataType: dataType,
  itemId: itemId,
  strokeDashArray: strokeDashArray,
  strokeDashOffset: strokeDashOffset,
  strokeLineCap: strokeLineCap,
  strokeLineJoin: strokeLineJoin,
  strokeMiterLimit: strokeMiterLimit,
  typeOf: typeOf,
  xLinkActuate: xLinkActuate,
  xLinkArcRole: xLinkArcRole,
  xLinkHref: xLinkHref,
  xLinkRole: xLinkRole,
  xLinkShow: xLinkShow,
  xLinkTitle: xLinkTitle,
  xLinkType: xLinkType,
  xmlnsXLink: xmlnsXLink
};
var spaceSeparatedTokens = {};
spaceSeparatedTokens.parse = parse$3;
spaceSeparatedTokens.stringify = stringify$1;
var empty$1 = '';
var space$2 = ' ';
var whiteSpace = /[ \t\n\r\f]+/g;
function parse$3(value) {
  var input = String(value || empty$1).trim();
  return input === empty$1 ? [] : input.split(whiteSpace);
}
function stringify$1(values) {
  return values.join(space$2).trim();
}
var commaSeparatedTokens = {};
commaSeparatedTokens.parse = parse$2;
commaSeparatedTokens.stringify = stringify;
var comma = ',';
var space$1 = ' ';
var empty = '';

// Parse comma-separated tokens to an array.
function parse$2(value) {
  var values = [];
  var input = String(value || empty);
  var index = input.indexOf(comma);
  var lastIndex = 0;
  var end = false;
  var val;
  while (!end) {
    if (index === -1) {
      index = input.length;
      end = true;
    }
    val = input.slice(lastIndex, index).trim();
    if (val || !end) {
      values.push(val);
    }
    lastIndex = index + 1;
    index = input.indexOf(comma, lastIndex);
  }
  return values;
}

// Compile an array to comma-separated tokens.
// `options.padLeft` (default: `true`) pads a space left of each token, and
// `options.padRight` (default: `false`) pads a space to the right of each token.
function stringify(values, options) {
  var settings = options || {};
  var left = settings.padLeft === false ? empty : space$1;
  var right = settings.padRight ? space$1 : empty;

  // Ensure the last empty entry is seen.
  if (values[values.length - 1] === empty) {
    values = values.concat(empty);
  }
  return values.join(right + comma + left).trim();
}

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
var inlineStyleParser = function inlineStyleParser(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }
  if (!style) return [];
  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = {
      line: lineno,
      column: column
    };
    return function (node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = {
      line: lineno,
      column: column
    };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;
    if (options.silent) ;else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while (c = comment()) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;
    var i = 2;
    while (EMPTY_STRING != style.charAt(i) && (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))) {
      ++i;
    }
    i += 2;
    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }
    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;
    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);
    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim$2(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val ? trim$2(val[0].replace(COMMENT_REGEX, EMPTY_STRING)) : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);
    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];
    comments(decls);

    // declarations
    var decl;
    while (decl = declaration()) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }
    return decls;
  }
  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim$2(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}
var parse$1 = inlineStyleParser;

/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */
function StyleToObject(style, iterator) {
  var output = null;
  if (!style || typeof style !== 'string') {
    return output;
  }
  var declaration;
  var declarations = parse$1(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;
  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;
    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }
  return output;
}
var styleToObject = StyleToObject;
var React$1 = React$2;
var ReactIs = reactIs$1.exports;
var svg = svg_1;
var find = find_1;
var hastToReact = require$$4;
var spaces = spaceSeparatedTokens;
var commas = commaSeparatedTokens;
var style = styleToObject;
astToReact.hastToReact = toReact;
astToReact.hastChildrenToReact = childrenToReact$1;

/**
 * @typedef {JSX.IntrinsicElements} IntrinsicElements
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 */

/**
 * @typedef Info
 * @property {string?} space
 * @property {string?} attribute
 * @property {string?} property
 * @property {boolean} boolean
 * @property {boolean} booleanish
 * @property {boolean} overloadedBoolean
 * @property {boolean} number
 * @property {boolean} commaSeparated
 * @property {boolean} spaceSeparated
 * @property {boolean} commaOrSpaceSeparated
 * @property {boolean} mustUseProperty
 * @property {boolean} defined
 *
 * @typedef Schema
 * @property {Object.<string, Info>} property
 * @property {Object.<string, string>} normal
 * @property {string?} space
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {TransformOptions} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array.<Comment|Element|Text>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array.<Comment|Element|Text>} children
 * @param {string?} title
 * @returns {string|undefined}
 *
 * @typedef {keyof IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef ReactMarkdownProps
 * @property {Element} node
 * @property {string} key
 * @property {ReactNode[]} children
 * @property {Position?} [sourcePosition] Passed when `options.rawSourcePos` is given
 * @property {number} [index] Passed when `options.includeElementIndex` is given
 * @property {number} [siblingCount] Passed when `options.includeElementIndex` is given
 *
 * @callback CodeComponent
 * @param {JSX.IntrinsicElements['code'] & ReactMarkdownProps & {inline?: boolean}} props
 * @returns {ReactNode}
 *
 * @callback HeadingComponent
 * @param {JSX.IntrinsicElements['h1'] & ReactMarkdownProps & {level: number}} props
 * @returns {ReactNode}
 *
 * @callback LiComponent
 * @param {JSX.IntrinsicElements['li'] & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} props
 * @returns {ReactNode}
 *
 * @callback OrderedListComponent
 * @param {JSX.IntrinsicElements['ol'] & ReactMarkdownProps & {depth: number, ordered: true}} props
 * @returns {ReactNode}
 *
 * @callback TableCellComponent
 * @param {JSX.IntrinsicElements['table'] & ReactMarkdownProps & {style?: Object.<string, unknown>, isHeader: boolean}} props
 * @returns {ReactNode}
 *
 * @callback TableRowComponent
 * @param {JSX.IntrinsicElements['tr'] & ReactMarkdownProps & {isHeader: boolean}} props
 * @returns {ReactNode}
 *
 * @callback UnorderedListComponent
 * @param {JSX.IntrinsicElements['ul'] & ReactMarkdownProps & {depth: number, ordered: false}} props
 * @returns {ReactNode}
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableCellComponent|ReactMarkdownNames} td
 * @property {TableCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {{[TagName in keyof IntrinsicElements]: TagName | ((props: IntrinsicElements[TagName] & ReactMarkdownProps) => ReactNode)}} NormalComponents
 * @typedef {Partial<Omit<NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 */

/**
 * @typedef TransformOptions
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {string|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */

var own$2 = {}.hasOwnProperty;

// The table-related elements that must not contain whitespace text according
// to React.
var tableElements = new Set(['table', 'thead', 'tbody', 'tfoot', 'tr']);

/**
 * @param {Context} context
 * @param {Element|Root} node
 */
function childrenToReact$1(context, node) {
  /** @type {Array.<ReactNode>} */
  var children = [];
  var childIndex = -1;
  /** @type {Comment|Doctype|Element|Raw|Text} */
  var child;
  while (++childIndex < node.children.length) {
    child = node.children[childIndex];
    if (child.type === 'element') {
      children.push(toReact(context, child, childIndex, node));
    } else if (child.type === 'text') {
      // React does not permit whitespace text elements as children of table:
      // cf. https://github.com/remarkjs/react-markdown/issues/576
      if (node.type !== 'element' || !tableElements.has(node.tagName) || child.value !== '\n') {
        children.push(child.value);
      }
    }
    // @ts-expect-error `raw` nodes are non-standard
    else if (child.type === 'raw' && !context.options.skipHtml) {
      // Default behavior is to show (encoded) HTML.
      // @ts-expect-error `raw` nodes are non-standard
      children.push(child.value);
    }
  }
  return children;
}

/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */
function toReact(context, node, index, parent) {
  var options = context.options;
  var parentSchema = context.schema;
  /** @type {ReactMarkdownNames} */
  // @ts-expect-error assume a known HTML/SVG element.
  var name = node.tagName;
  /** @type {Object.<string, unknown>} */
  var properties = {};
  var schema = parentSchema;
  /** @type {string} */
  var property;
  if (parentSchema.space === 'html' && name === 'svg') {
    schema = svg;
    context.schema = schema;
  }

  /* istanbul ignore else - types say they’re optional. */
  if (node.properties) {
    for (property in node.properties) {
      /* istanbul ignore else - prototype polution. */
      if (own$2.call(node.properties, property)) {
        addProperty(properties, property, node.properties[property], context);
      }
    }
  }
  if (name === 'ol' || name === 'ul') {
    context.listDepth++;
  }
  var children = childrenToReact$1(context, node);
  if (name === 'ol' || name === 'ul') {
    context.listDepth--;
  }

  // Restore parent schema.
  context.schema = parentSchema;

  // Nodes created by plugins do not have positional info, in which case we use
  // an object that matches the positon interface.
  var position = node.position || {
    start: {
      line: null,
      column: null,
      offset: null
    },
    end: {
      line: null,
      column: null,
      offset: null
    }
  };
  var component = options.components && own$2.call(options.components, name) ? options.components[name] : name;
  var basic = typeof component === 'string' || component === React$1.Fragment;
  if (!ReactIs.isValidElementType(component)) {
    throw new TypeError("Component for name `".concat(name, "` not defined or is not renderable"));
  }
  properties.key = [name, position.start.line, position.start.column, index].join('-');
  if (name === 'a' && options.linkTarget) {
    properties.target = typeof options.linkTarget === 'function' ?
    // @ts-expect-error assume `href` is a string
    options.linkTarget(properties.href, node.children, properties.title) : options.linkTarget;
  }
  if (name === 'a' && options.transformLinkUri) {
    properties.href = options.transformLinkUri(
    // @ts-expect-error assume `href` is a string
    properties.href, node.children, properties.title);
  }
  if (!basic && name === 'code' && parent.type === 'element' && parent.tagName !== 'pre') {
    properties.inline = true;
  }
  if (!basic && (name === 'h1' || name === 'h2' || name === 'h3' || name === 'h4' || name === 'h5' || name === 'h6')) {
    properties.level = parseInt(name.charAt(1), 10);
  }
  if (name === 'img' && options.transformImageUri) {
    properties.src = options.transformImageUri(
    // @ts-expect-error assume `src` is a string
    properties.src, properties.alt, properties.title);
  }
  if (!basic && name === 'li' && parent.type === 'element') {
    var input = getInputElement(node);
    properties.checked = input && input.properties ? Boolean(input.properties.checked) : null;
    properties.index = getElementsBeforeCount(parent, node);
    properties.ordered = parent.tagName === 'ol';
  }
  if (!basic && (name === 'ol' || name === 'ul')) {
    properties.ordered = name === 'ol';
    properties.depth = context.listDepth;
  }
  if (name === 'td' || name === 'th') {
    if (properties.align) {
      if (!properties.style) properties.style = {};
      // @ts-expect-error assume `style` is an object
      properties.style.textAlign = properties.align;
      delete properties.align;
    }
    if (!basic) {
      properties.isHeader = name === 'th';
    }
  }
  if (!basic && name === 'tr' && parent.type === 'element') {
    properties.isHeader = Boolean(parent.tagName === 'thead');
  }

  // If `sourcePos` is given, pass source information (line/column info from markdown source).
  if (options.sourcePos) {
    properties['data-sourcepos'] = flattenPosition(position);
  }
  if (!basic && options.rawSourcePos) {
    properties.sourcePosition = node.position;
  }

  // If `includeElementIndex` is given, pass node index info to components.
  if (!basic && options.includeElementIndex) {
    properties.index = getElementsBeforeCount(parent, node);
    properties.siblingCount = getElementsBeforeCount(parent);
  }
  if (!basic) {
    properties.node = node;
  }

  // Ensure no React warnings are emitted for void elements w/ children.
  return children.length > 0 ? React$1.createElement(component, properties, children) : React$1.createElement(component, properties);
}

/**
 * @param {Element|Root} node
 * @returns {Element?}
 */
function getInputElement(node) {
  var index = -1;
  while (++index < node.children.length) {
    var child = node.children[index];
    if (child.type === 'element' && child.tagName === 'input') {
      return child;
    }
  }
  return null;
}

/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */
function getElementsBeforeCount(parent, node) {
  var index = -1;
  var count = 0;
  while (++index < parent.children.length) {
    if (parent.children[index] === node) break;
    if (parent.children[index].type === 'element') count++;
  }
  return count;
}

/**
 * @param {Object.<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */
function addProperty(props, prop, value, ctx) {
  /** @type {Info} */
  var info = find(ctx.schema, prop);
  var result = value;

  // Ignore nullish and `NaN` values.
  // eslint-disable-next-line no-self-compare
  if (result === null || result === undefined || result !== result) {
    return;
  }

  // Accept `array`.
  // Most props are space-separated.
  if (result && typeof result === 'object' && 'length' in result) {
    // type-coverage:ignore-next-line remove when typed.
    result = (info.commaSeparated ? commas : spaces).stringify(result);
  }
  if (info.property === 'style' && typeof result === 'string') {
    result = parseStyle(result);
  }

  /* istanbul ignore else - types say they’re optional. */
  if (info.space && info.property) {
    props[own$2.call(hastToReact, info.property) ? hastToReact[info.property] : info.property] = result;
  } else if (info.attribute) {
    props[info.attribute] = result;
  }
}

/**
 * @param {string} value
 * @returns {Object.<string, string>}
 */
function parseStyle(value) {
  /** @type {Object.<string, string>} */
  var result = {};
  try {
    style(value, iterator);
  } catch (/** @type {unknown} */_) {
    // Silent.
  }
  return result;

  /**
   * @param {string} name
   * @param {string} v
   */
  function iterator(name, v) {
    var k = name.slice(0, 4) === '-ms-' ? "ms-".concat(name.slice(4)) : name;
    result[k.replace(/-([a-z])/g, styleReplacer)] = v;
  }
}

/**
 * @param {unknown} _
 * @param {string} $1
 */
function styleReplacer(_, $1) {
  return $1.toUpperCase();
}

/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */
function flattenPosition(pos) {
  return [pos.start.line, ':', pos.start.column, '-', pos.end.line, ':', pos.end.column].map(function (d) {
    return String(d);
  }).join('');
}
var React = React$2;
var vfile = vfile$2.exports;
var unified = unified_1;
var parse = remarkParse;
var remarkRehype = remarkRehype$1;
var PropTypes = propTypes.exports;
var html = html_1;
var filter = rehypeFilter_1;
var uriTransformer = uriTransformer_1;
var childrenToReact = astToReact.hastChildrenToReact;

/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').RehypeFilterOptions} FilterOptions
 * @typedef {import('./ast-to-react.js').TransformOptions} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [plugins=[]] **deprecated**: use `remarkPlugins` instead
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 */

var reactMarkdown = ReactMarkdown;
var own$1 = {}.hasOwnProperty;
var changelog = 'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';

/**
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */

/**
 * @type {Object.<string, Deprecation>}
 */
var deprecated = {
  renderers: {
    to: 'components',
    id: 'change-renderers-to-components'
  },
  astPlugins: {
    id: 'remove-buggy-html-in-markdown-parser'
  },
  allowDangerousHtml: {
    id: 'remove-buggy-html-in-markdown-parser'
  },
  escapeHtml: {
    id: 'remove-buggy-html-in-markdown-parser'
  },
  source: {
    to: 'children',
    id: 'change-source-to-children'
  },
  allowNode: {
    to: 'allowElement',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  allowedTypes: {
    to: 'allowedElements',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  disallowedTypes: {
    to: 'disallowedElements',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  includeNodeIndex: {
    to: 'includeElementIndex',
    id: 'change-includenodeindex-to-includeelementindex'
  }
};

/**
 * @param {ReactMarkdownOptions} options
 * @returns {ReactElement}
 */
function ReactMarkdown(options) {
  for (var key in deprecated) {
    if (own$1.call(deprecated, key) && own$1.call(options, key)) {
      /** @type {Deprecation} */
      var deprecation = deprecated[key];
      console.warn("[react-markdown] Warning: please ".concat(deprecation.to ? "use `".concat(deprecation.to, "` instead of") : 'remove', " `").concat(key, "` (see <").concat(changelog, "#").concat(deprecation.id, "> for more info)"));
      delete deprecated[key];
    }
  }
  var processor = unified().use(parse)
  // TODO: deprecate `plugins` in v7.0.0.
  .use(options.remarkPlugins || options.plugins || []).use(remarkRehype, {
    allowDangerousHtml: true
  }).use(options.rehypePlugins || []).use(filter, options);

  /** @type {vfile} */
  var file;
  if (typeof options.children === 'string') {
    file = vfile(options.children);
  } else {
    if (options.children !== undefined && options.children !== null) {
      console.warn("[react-markdown] Warning: please pass a string as `children` (not: `".concat(options.children, "`)"));
    }
    file = vfile();
  }

  /** @type {Root} */
  // @ts-expect-error we’ll throw if it isn’t a root next.
  var hastNode = processor.runSync(processor.parse(file), file);
  if (hastNode.type !== 'root') {
    throw new TypeError('Expected a `root` node');
  }

  /** @type {ReactElement} */
  var result = React.createElement(React.Fragment, {}, childrenToReact({
    options: options,
    schema: html,
    listDepth: 0
  }, hastNode));
  if (options.className) {
    result = React.createElement('div', {
      className: options.className
    }, result);
  }
  return result;
}
ReactMarkdown.defaultProps = {
  transformLinkUri: uriTransformer
};
ReactMarkdown.propTypes = {
  // Core options:
  children: PropTypes.string,
  // Layout options:
  className: PropTypes.string,
  // Filter options:
  allowElement: PropTypes.func,
  allowedElements: PropTypes.arrayOf(PropTypes.string),
  disallowedElements: PropTypes.arrayOf(PropTypes.string),
  unwrapDisallowed: PropTypes.bool,
  // Plugin options:
  // type-coverage:ignore-next-line
  remarkPlugins: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.func]))])),
  // type-coverage:ignore-next-line
  rehypePlugins: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.func]))])),
  // Transform options:
  sourcePos: PropTypes.bool,
  rawSourcePos: PropTypes.bool,
  skipHtml: PropTypes.bool,
  includeElementIndex: PropTypes.bool,
  transformLinkUri: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  linkTarget: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  transformImageUri: PropTypes.func,
  components: PropTypes.object
};
ReactMarkdown.uriTransformer = uriTransformer;
var micromarkExtensionGfm = {
  exports: {}
};
var micromarkExtensionGfmAutolinkLiteral = {
  exports: {}
};
var syntax$4 = {};
var asciiAlpha = asciiAlpha_1;
var asciiAlphanumeric = asciiAlphanumeric_1;
var asciiControl = asciiControl_1;
var markdownLineEnding = markdownLineEnding_1;
var unicodePunctuation$1 = unicodePunctuation_1;
var unicodeWhitespace$1 = unicodeWhitespace_1;
var www = {
  tokenize: tokenizeWww,
  partial: true
};
var domain = {
  tokenize: tokenizeDomain,
  partial: true
};
var path = {
  tokenize: tokenizePath,
  partial: true
};
var punctuation = {
  tokenize: tokenizePunctuation,
  partial: true
};
var namedCharacterReference = {
  tokenize: tokenizeNamedCharacterReference,
  partial: true
};
var wwwAutolink = {
  tokenize: tokenizeWwwAutolink,
  previous: previousWww
};
var httpAutolink = {
  tokenize: tokenizeHttpAutolink,
  previous: previousHttp
};
var emailAutolink = {
  tokenize: tokenizeEmailAutolink,
  previous: previousEmail
};
var text = {};

// Export hooked constructs.
syntax$4.text = text;

// `0`
var code = 48;

// While the code is smaller than `{`.
while (code < 123) {
  text[code] = emailAutolink;
  code++;
  // Jump from `:` -> `A`
  if (code === 58) code = 65;
  // Jump from `[` -> `a`
  else if (code === 91) code = 97;
}

// `+`
text[43] = emailAutolink;
// `-`
text[45] = emailAutolink;
// `.`
text[46] = emailAutolink;
// `_`
text[95] = emailAutolink;
// `h`.
text[72] = [emailAutolink, httpAutolink];
text[104] = [emailAutolink, httpAutolink];
// `w`.
text[87] = [emailAutolink, wwwAutolink];
text[119] = [emailAutolink, wwwAutolink];
function tokenizeEmailAutolink(effects, ok, nok) {
  var self = this;
  var hasDot;
  return start;
  function start(code) {
    /* istanbul ignore next - hooks. */
    if (!gfmAtext(code) || !previousEmail(self.previous) || previous$1(self.events)) {
      return nok(code);
    }
    effects.enter('literalAutolink');
    effects.enter('literalAutolinkEmail');
    return atext(code);
  }
  function atext(code) {
    if (gfmAtext(code)) {
      effects.consume(code);
      return atext;
    }

    // `@`
    if (code === 64) {
      effects.consume(code);
      return label;
    }
    return nok(code);
  }
  function label(code) {
    // `.`
    if (code === 46) {
      return effects.check(punctuation, done, dotContinuation)(code);
    }
    if (
    // `-`
    code === 45 ||
    // `_`
    code === 95) {
      return effects.check(punctuation, nok, dashOrUnderscoreContinuation)(code);
    }
    if (asciiAlphanumeric(code)) {
      effects.consume(code);
      return label;
    }
    return done(code);
  }
  function dotContinuation(code) {
    effects.consume(code);
    hasDot = true;
    return label;
  }
  function dashOrUnderscoreContinuation(code) {
    effects.consume(code);
    return afterDashOrUnderscore;
  }
  function afterDashOrUnderscore(code) {
    // `.`
    if (code === 46) {
      return effects.check(punctuation, nok, dotContinuation)(code);
    }
    return label(code);
  }
  function done(code) {
    if (hasDot) {
      effects.exit('literalAutolinkEmail');
      effects.exit('literalAutolink');
      return ok(code);
    }
    return nok(code);
  }
}
function tokenizeWwwAutolink(effects, ok, nok) {
  var self = this;
  return start;
  function start(code) {
    /* istanbul ignore next - hooks. */
    if (code !== 87 && code - 32 !== 87 || !previousWww(self.previous) || previous$1(self.events)) {
      return nok(code);
    }
    effects.enter('literalAutolink');
    effects.enter('literalAutolinkWww');
    // For `www.` we check instead of attempt, because when it matches, GH
    // treats it as part of a domain (yes, it says a valid domain must come
    // after `www.`, but that’s not how it’s implemented by them).
    return effects.check(www, effects.attempt(domain, effects.attempt(path, done), nok), nok)(code);
  }
  function done(code) {
    effects.exit('literalAutolinkWww');
    effects.exit('literalAutolink');
    return ok(code);
  }
}
function tokenizeHttpAutolink(effects, ok, nok) {
  var self = this;
  return start;
  function start(code) {
    /* istanbul ignore next - hooks. */
    if (code !== 72 && code - 32 !== 72 || !previousHttp(self.previous) || previous$1(self.events)) {
      return nok(code);
    }
    effects.enter('literalAutolink');
    effects.enter('literalAutolinkHttp');
    effects.consume(code);
    return t1;
  }
  function t1(code) {
    // `t`
    if (code === 84 || code - 32 === 84) {
      effects.consume(code);
      return t2;
    }
    return nok(code);
  }
  function t2(code) {
    // `t`
    if (code === 84 || code - 32 === 84) {
      effects.consume(code);
      return p;
    }
    return nok(code);
  }
  function p(code) {
    // `p`
    if (code === 80 || code - 32 === 80) {
      effects.consume(code);
      return s;
    }
    return nok(code);
  }
  function s(code) {
    // `s`
    if (code === 83 || code - 32 === 83) {
      effects.consume(code);
      return colon;
    }
    return colon(code);
  }
  function colon(code) {
    // `:`
    if (code === 58) {
      effects.consume(code);
      return slash1;
    }
    return nok(code);
  }
  function slash1(code) {
    // `/`
    if (code === 47) {
      effects.consume(code);
      return slash2;
    }
    return nok(code);
  }
  function slash2(code) {
    // `/`
    if (code === 47) {
      effects.consume(code);
      return after;
    }
    return nok(code);
  }
  function after(code) {
    return asciiControl(code) || unicodeWhitespace$1(code) || unicodePunctuation$1(code) ? nok(code) : effects.attempt(domain, effects.attempt(path, done), nok)(code);
  }
  function done(code) {
    effects.exit('literalAutolinkHttp');
    effects.exit('literalAutolink');
    return ok(code);
  }
}
function tokenizeWww(effects, ok, nok) {
  return start;
  function start(code) {
    // Assume a `w`.
    effects.consume(code);
    return w2;
  }
  function w2(code) {
    // `w`
    if (code === 87 || code - 32 === 87) {
      effects.consume(code);
      return w3;
    }
    return nok(code);
  }
  function w3(code) {
    // `w`
    if (code === 87 || code - 32 === 87) {
      effects.consume(code);
      return dot;
    }
    return nok(code);
  }
  function dot(code) {
    // `.`
    if (code === 46) {
      effects.consume(code);
      return after;
    }
    return nok(code);
  }
  function after(code) {
    return code === null || markdownLineEnding(code) ? nok(code) : ok(code);
  }
}
function tokenizeDomain(effects, ok, nok) {
  var hasUnderscoreInLastSegment;
  var hasUnderscoreInLastLastSegment;
  return domain;
  function domain(code) {
    // `&`
    if (code === 38) {
      return effects.check(namedCharacterReference, done, punctuationContinuation)(code);
    }
    if (code === 46 /* `.` */ || code === 95 /* `_` */) {
      return effects.check(punctuation, done, punctuationContinuation)(code);
    }

    // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
    // occur, which sounds like ASCII only, but they also support `www.點看.com`,
    // so that’s Unicode.
    // Instead of some new production for Unicode alphanumerics, markdown
    // already has that for Unicode punctuation and whitespace, so use those.
    if (asciiControl(code) || unicodeWhitespace$1(code) || code !== 45 /* `-` */ && unicodePunctuation$1(code)) {
      return done(code);
    }
    effects.consume(code);
    return domain;
  }
  function punctuationContinuation(code) {
    // `.`
    if (code === 46) {
      hasUnderscoreInLastLastSegment = hasUnderscoreInLastSegment;
      hasUnderscoreInLastSegment = undefined;
      effects.consume(code);
      return domain;
    }

    // `_`
    if (code === 95) hasUnderscoreInLastSegment = true;
    effects.consume(code);
    return domain;
  }
  function done(code) {
    if (!hasUnderscoreInLastLastSegment && !hasUnderscoreInLastSegment) {
      return ok(code);
    }
    return nok(code);
  }
}
function tokenizePath(effects, ok) {
  var balance = 0;
  return inPath;
  function inPath(code) {
    // `&`
    if (code === 38) {
      return effects.check(namedCharacterReference, ok, continuedPunctuation)(code);
    }

    // `(`
    if (code === 40) {
      balance++;
    }

    // `)`
    if (code === 41) {
      return effects.check(punctuation, parenAtPathEnd, continuedPunctuation)(code);
    }
    if (pathEnd(code)) {
      return ok(code);
    }
    if (trailingPunctuation(code)) {
      return effects.check(punctuation, ok, continuedPunctuation)(code);
    }
    effects.consume(code);
    return inPath;
  }
  function continuedPunctuation(code) {
    effects.consume(code);
    return inPath;
  }
  function parenAtPathEnd(code) {
    balance--;
    return balance < 0 ? ok(code) : continuedPunctuation(code);
  }
}
function tokenizeNamedCharacterReference(effects, ok, nok) {
  return start;
  function start(code) {
    // Assume an ampersand.
    effects.consume(code);
    return inside;
  }
  function inside(code) {
    if (asciiAlpha(code)) {
      effects.consume(code);
      return inside;
    }

    // `;`
    if (code === 59) {
      effects.consume(code);
      return after;
    }
    return nok(code);
  }
  function after(code) {
    // If the named character reference is followed by the end of the path, it’s
    // not continued punctuation.
    return pathEnd(code) ? ok(code) : nok(code);
  }
}
function tokenizePunctuation(effects, ok, nok) {
  return start;
  function start(code) {
    // Always a valid trailing punctuation marker.
    effects.consume(code);
    return after;
  }
  function after(code) {
    // Check the next.
    if (trailingPunctuation(code)) {
      effects.consume(code);
      return after;
    }

    // If the punctuation marker is followed by the end of the path, it’s not
    // continued punctuation.
    return pathEnd(code) ? ok(code) : nok(code);
  }
}
function trailingPunctuation(code) {
  return (
    // `!`
    code === 33 ||
    // `"`
    code === 34 ||
    // `'`
    code === 39 ||
    // `)`
    code === 41 ||
    // `*`
    code === 42 ||
    // `,`
    code === 44 ||
    // `.`
    code === 46 ||
    // `:`
    code === 58 ||
    // `;`
    code === 59 ||
    // `<`
    code === 60 ||
    // `?`
    code === 63 ||
    // `_`.
    code === 95 ||
    // `~`
    code === 126
  );
}
function pathEnd(code) {
  return (
    // EOF.
    code === null ||
    // CR, LF, CRLF, HT, VS.
    code < 0 ||
    // Space.
    code === 32 ||
    // `<`
    code === 60
  );
}
function gfmAtext(code) {
  return code === 43 /* `+` */ || code === 45 /* `-` */ || code === 46 /* `.` */ || code === 95 /* `_` */ || asciiAlphanumeric(code);
}
function previousWww(code) {
  return code === null || code < 0 || code === 32 /* ` ` */ || code === 40 /* `(` */ || code === 42 /* `*` */ || code === 95 /* `_` */ || code === 126 /* `~` */;
}
function previousHttp(code) {
  return code === null || !asciiAlpha(code);
}
function previousEmail(code) {
  return code !== 47 /* `/` */ && previousHttp(code);
}
function previous$1(events) {
  var index = events.length;
  while (index--) {
    if ((events[index][1].type === 'labelLink' || events[index][1].type === 'labelImage') && !events[index][1]._balanced) {
      return true;
    }
  }
}
(function (module) {
  module.exports = syntax$4;
})(micromarkExtensionGfmAutolinkLiteral);
var micromarkExtensionGfmStrikethrough = create$5;
var classifyCharacter = classifyCharacter_1;
var chunkedSplice = chunkedSplice_1;
var resolveAll = resolveAll_1;
var shallow = shallow_1;
function create$5(options) {
  var settings = options || {};
  var single = settings.singleTilde;
  var tokenizer = {
    tokenize: tokenizeStrikethrough,
    resolveAll: resolveAllStrikethrough
  };
  if (single === null || single === undefined) {
    single = true;
  }
  return {
    text: {
      126: tokenizer
    },
    insideSpan: {
      null: tokenizer
    }
  };

  // Take events and resolve strikethrough.
  function resolveAllStrikethrough(events, context) {
    var index = -1;
    var strikethrough;
    var text;
    var open;
    var nextEvents;

    // Walk through all events.
    while (++index < events.length) {
      // Find a token that can close.
      if (events[index][0] === 'enter' && events[index][1].type === 'strikethroughSequenceTemporary' && events[index][1]._close) {
        open = index;

        // Now walk back to find an opener.
        while (open--) {
          // Find a token that can open the closer.
          if (events[open][0] === 'exit' && events[open][1].type === 'strikethroughSequenceTemporary' && events[open][1]._open &&
          // If the sizes are the same:
          events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
            events[index][1].type = 'strikethroughSequence';
            events[open][1].type = 'strikethroughSequence';
            strikethrough = {
              type: 'strikethrough',
              start: shallow(events[open][1].start),
              end: shallow(events[index][1].end)
            };
            text = {
              type: 'strikethroughText',
              start: shallow(events[open][1].end),
              end: shallow(events[index][1].start)
            };

            // Opening.
            nextEvents = [['enter', strikethrough, context], ['enter', events[open][1], context], ['exit', events[open][1], context], ['enter', text, context]];

            // Between.
            chunkedSplice(nextEvents, nextEvents.length, 0, resolveAll(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));

            // Closing.
            chunkedSplice(nextEvents, nextEvents.length, 0, [['exit', text, context], ['enter', events[index][1], context], ['exit', events[index][1], context], ['exit', strikethrough, context]]);
            chunkedSplice(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - 2;
            break;
          }
        }
      }
    }
    return removeRemainingSequences(events);
  }
  function removeRemainingSequences(events) {
    var index = -1;
    var length = events.length;
    while (++index < length) {
      if (events[index][1].type === 'strikethroughSequenceTemporary') {
        events[index][1].type = 'data';
      }
    }
    return events;
  }
  function tokenizeStrikethrough(effects, ok, nok) {
    var previous = this.previous;
    var events = this.events;
    var size = 0;
    return start;
    function start(code) {
      if (code !== 126 || previous === 126 && events[events.length - 1][1].type !== 'characterEscape') {
        return nok(code);
      }
      effects.enter('strikethroughSequenceTemporary');
      return more(code);
    }
    function more(code) {
      var before = classifyCharacter(previous);
      var token;
      var after;
      if (code === 126) {
        // If this is the third marker, exit.
        if (size > 1) return nok(code);
        effects.consume(code);
        size++;
        return more;
      }
      if (size < 2 && !single) return nok(code);
      token = effects.exit('strikethroughSequenceTemporary');
      after = classifyCharacter(code);
      token._open = !after || after === 2 && before;
      token._close = !before || before === 2 && after;
      return ok(code);
    }
  }
}
var micromarkExtensionGfmTable = {
  exports: {}
};
var syntax$3 = {};
syntax$3.flow = {
  null: {
    tokenize: tokenizeTable,
    resolve: resolveTable,
    interruptible: true
  }
};
var createSpace = factorySpace$h;
var setextUnderlineMini = {
  tokenize: tokenizeSetextUnderlineMini,
  partial: true
};
var nextPrefixedOrBlank = {
  tokenize: tokenizeNextPrefixedOrBlank,
  partial: true
};
function resolveTable(events, context) {
  var length = events.length;
  var index = -1;
  var token;
  var inHead;
  var inDelimiterRow;
  var inRow;
  var cell;
  var content;
  var text;
  var contentStart;
  var contentEnd;
  var cellStart;
  while (++index < length) {
    token = events[index][1];
    if (inRow) {
      if (token.type === 'temporaryTableCellContent') {
        contentStart = contentStart || index;
        contentEnd = index;
      }
      if (
      // Combine separate content parts into one.
      (token.type === 'tableCellDivider' || token.type === 'tableRow') && contentEnd) {
        content = {
          type: 'tableContent',
          start: events[contentStart][1].start,
          end: events[contentEnd][1].end
        };
        text = {
          type: 'chunkText',
          start: content.start,
          end: content.end,
          contentType: 'text'
        };
        events.splice(contentStart, contentEnd - contentStart + 1, ['enter', content, context], ['enter', text, context], ['exit', text, context], ['exit', content, context]);
        index -= contentEnd - contentStart - 3;
        length = events.length;
        contentStart = undefined;
        contentEnd = undefined;
      }
    }
    if (events[index][0] === 'exit' && cellStart && cellStart + 1 < index && (token.type === 'tableCellDivider' || token.type === 'tableRow' && (cellStart + 3 < index || events[cellStart][1].type !== 'whitespace'))) {
      cell = {
        type: inDelimiterRow ? 'tableDelimiter' : inHead ? 'tableHeader' : 'tableData',
        start: events[cellStart][1].start,
        end: events[index][1].end
      };
      events.splice(index + (token.type === 'tableCellDivider' ? 1 : 0), 0, ['exit', cell, context]);
      events.splice(cellStart, 0, ['enter', cell, context]);
      index += 2;
      length = events.length;
      cellStart = index + 1;
    }
    if (token.type === 'tableRow') {
      inRow = events[index][0] === 'enter';
      if (inRow) {
        cellStart = index + 1;
      }
    }
    if (token.type === 'tableDelimiterRow') {
      inDelimiterRow = events[index][0] === 'enter';
      if (inDelimiterRow) {
        cellStart = index + 1;
      }
    }
    if (token.type === 'tableHead') {
      inHead = events[index][0] === 'enter';
    }
  }
  return events;
}
function tokenizeTable(effects, ok, nok) {
  var align = [];
  var tableHeaderCount = 0;
  var seenDelimiter;
  var hasDash;
  return start;
  function start(code) {
    /* istanbul ignore if - used to be passed in beta micromark versions. */
    if (code === null || code === -5 || code === -4 || code === -3) {
      return nok(code);
    }
    effects.enter('table')._align = align;
    effects.enter('tableHead');
    effects.enter('tableRow');

    // If we start with a pipe, we open a cell marker.
    if (code === 124) {
      return cellDividerHead(code);
    }
    tableHeaderCount++;
    effects.enter('temporaryTableCellContent');
    // Can’t be space or eols at the start of a construct, so we’re in a cell.
    return inCellContentHead(code);
  }
  function cellDividerHead(code) {
    // Always a pipe.
    effects.enter('tableCellDivider');
    effects.consume(code);
    effects.exit('tableCellDivider');
    seenDelimiter = true;
    return cellBreakHead;
  }
  function cellBreakHead(code) {
    // EOF, CR, LF, CRLF.
    if (code === null || code === -5 || code === -4 || code === -3) {
      return atRowEndHead(code);
    }

    // HT, VS, SP.
    if (code === -2 || code === -1 || code === 32) {
      effects.enter('whitespace');
      effects.consume(code);
      return inWhitespaceHead;
    }
    if (seenDelimiter) {
      seenDelimiter = undefined;
      tableHeaderCount++;
    }

    // `|`
    if (code === 124) {
      return cellDividerHead(code);
    }

    // Anything else is cell content.
    effects.enter('temporaryTableCellContent');
    return inCellContentHead(code);
  }
  function inWhitespaceHead(code) {
    // HT, VS, SP.
    if (code === -2 || code === -1 || code === 32) {
      effects.consume(code);
      return inWhitespaceHead;
    }
    effects.exit('whitespace');
    return cellBreakHead(code);
  }
  function inCellContentHead(code) {
    // EOF, whitespace, pipe
    if (code === null || code < 0 || code === 32 || code === 124) {
      effects.exit('temporaryTableCellContent');
      return cellBreakHead(code);
    }
    effects.consume(code);
    // `\`
    return code === 92 ? inCellContentEscapeHead : inCellContentHead;
  }
  function inCellContentEscapeHead(code) {
    // `\` or `|`
    if (code === 92 || code === 124) {
      effects.consume(code);
      return inCellContentHead;
    }

    // Anything else.
    return inCellContentHead(code);
  }
  function atRowEndHead(code) {
    if (code === null) {
      return nok(code);
    }
    effects.exit('tableRow');
    effects.exit('tableHead');

    // Always a line ending.
    effects.enter('lineEnding');
    effects.consume(code);
    effects.exit('lineEnding');

    // If a setext heading, exit.
    return effects.check(setextUnderlineMini, nok,
    // Support an indent before the delimiter row.
    createSpace(effects, rowStartDelimiter, 'linePrefix', 4));
  }
  function rowStartDelimiter(code) {
    // If there’s another space, or we’re at the EOL/EOF, exit.
    if (code === null || code < 0 || code === 32) {
      return nok(code);
    }
    effects.enter('tableDelimiterRow');
    return atDelimiterRowBreak(code);
  }
  function atDelimiterRowBreak(code) {
    // EOF, CR, LF, CRLF.
    if (code === null || code === -5 || code === -4 || code === -3) {
      return rowEndDelimiter(code);
    }

    // HT, VS, SP.
    if (code === -2 || code === -1 || code === 32) {
      effects.enter('whitespace');
      effects.consume(code);
      return inWhitespaceDelimiter;
    }

    // `-`
    if (code === 45) {
      effects.enter('tableDelimiterFiller');
      effects.consume(code);
      hasDash = true;
      align.push(null);
      return inFillerDelimiter;
    }

    // `:`
    if (code === 58) {
      effects.enter('tableDelimiterAlignment');
      effects.consume(code);
      effects.exit('tableDelimiterAlignment');
      align.push('left');
      return afterLeftAlignment;
    }

    // If we start with a pipe, we open a cell marker.
    if (code === 124) {
      effects.enter('tableCellDivider');
      effects.consume(code);
      effects.exit('tableCellDivider');
      return atDelimiterRowBreak;
    }
    return nok(code);
  }
  function inWhitespaceDelimiter(code) {
    // HT, VS, SP.
    if (code === -2 || code === -1 || code === 32) {
      effects.consume(code);
      return inWhitespaceDelimiter;
    }
    effects.exit('whitespace');
    return atDelimiterRowBreak(code);
  }
  function inFillerDelimiter(code) {
    // `-`
    if (code === 45) {
      effects.consume(code);
      return inFillerDelimiter;
    }
    effects.exit('tableDelimiterFiller');

    // `:`
    if (code === 58) {
      effects.enter('tableDelimiterAlignment');
      effects.consume(code);
      effects.exit('tableDelimiterAlignment');
      align[align.length - 1] = align[align.length - 1] === 'left' ? 'center' : 'right';
      return afterRightAlignment;
    }
    return atDelimiterRowBreak(code);
  }
  function afterLeftAlignment(code) {
    // `-`
    if (code === 45) {
      effects.enter('tableDelimiterFiller');
      effects.consume(code);
      hasDash = true;
      return inFillerDelimiter;
    }

    // Anything else is not ok.
    return nok(code);
  }
  function afterRightAlignment(code) {
    // EOF, CR, LF, CRLF.
    if (code === null || code === -5 || code === -4 || code === -3) {
      return rowEndDelimiter(code);
    }

    // HT, VS, SP.
    if (code === -2 || code === -1 || code === 32) {
      effects.enter('whitespace');
      effects.consume(code);
      return inWhitespaceDelimiter;
    }

    // `|`
    if (code === 124) {
      effects.enter('tableCellDivider');
      effects.consume(code);
      effects.exit('tableCellDivider');
      return atDelimiterRowBreak;
    }
    return nok(code);
  }
  function rowEndDelimiter(code) {
    effects.exit('tableDelimiterRow');

    // Exit if there was no dash at all, or if the header cell count is not the
    // delimiter cell count.
    if (!hasDash || tableHeaderCount !== align.length) {
      return nok(code);
    }
    if (code === null) {
      return tableClose(code);
    }
    return effects.check(nextPrefixedOrBlank, tableClose, tableContinue)(code);
  }
  function tableClose(code) {
    effects.exit('table');
    return ok(code);
  }
  function tableContinue(code) {
    // Always a line ending.
    effects.enter('lineEnding');
    effects.consume(code);
    effects.exit('lineEnding');
    // We checked that it’s not a prefixed or blank line, so we’re certain a
    // body is coming, though it may be indented.
    return createSpace(effects, bodyStart, 'linePrefix', 4);
  }
  function bodyStart(code) {
    effects.enter('tableBody');
    return rowStartBody(code);
  }
  function rowStartBody(code) {
    effects.enter('tableRow');

    // If we start with a pipe, we open a cell marker.
    if (code === 124) {
      return cellDividerBody(code);
    }
    effects.enter('temporaryTableCellContent');
    // Can’t be space or eols at the start of a construct, so we’re in a cell.
    return inCellContentBody(code);
  }
  function cellDividerBody(code) {
    // Always a pipe.
    effects.enter('tableCellDivider');
    effects.consume(code);
    effects.exit('tableCellDivider');
    return cellBreakBody;
  }
  function cellBreakBody(code) {
    // EOF, CR, LF, CRLF.
    if (code === null || code === -5 || code === -4 || code === -3) {
      return atRowEndBody(code);
    }

    // HT, VS, SP.
    if (code === -2 || code === -1 || code === 32) {
      effects.enter('whitespace');
      effects.consume(code);
      return inWhitespaceBody;
    }

    // `|`
    if (code === 124) {
      return cellDividerBody(code);
    }

    // Anything else is cell content.
    effects.enter('temporaryTableCellContent');
    return inCellContentBody(code);
  }
  function inWhitespaceBody(code) {
    // HT, VS, SP.
    if (code === -2 || code === -1 || code === 32) {
      effects.consume(code);
      return inWhitespaceBody;
    }
    effects.exit('whitespace');
    return cellBreakBody(code);
  }
  function inCellContentBody(code) {
    // EOF, whitespace, pipe
    if (code === null || code < 0 || code === 32 || code === 124) {
      effects.exit('temporaryTableCellContent');
      return cellBreakBody(code);
    }
    effects.consume(code);
    // `\`
    return code === 92 ? inCellContentEscapeBody : inCellContentBody;
  }
  function inCellContentEscapeBody(code) {
    // `\` or `|`
    if (code === 92 || code === 124) {
      effects.consume(code);
      return inCellContentBody;
    }

    // Anything else.
    return inCellContentBody(code);
  }
  function atRowEndBody(code) {
    effects.exit('tableRow');
    if (code === null) {
      return tableBodyClose(code);
    }
    return effects.check(nextPrefixedOrBlank, tableBodyClose, tableBodyContinue)(code);
  }
  function tableBodyClose(code) {
    effects.exit('tableBody');
    return tableClose(code);
  }
  function tableBodyContinue(code) {
    // Always a line ending.
    effects.enter('lineEnding');
    effects.consume(code);
    effects.exit('lineEnding');
    // Support an optional prefix, then start a body row.
    return createSpace(effects, rowStartBody, 'linePrefix', 4);
  }
}

// Based on micromark, but that won’t work as we’re in a table, and that expects
// content.
// <https://github.com/micromark/micromark/blob/main/lib/tokenize/setext-underline.js>
function tokenizeSetextUnderlineMini(effects, ok, nok) {
  return start;
  function start(code) {
    // `-`
    if (code !== 45) {
      return nok(code);
    }
    effects.enter('setextUnderline');
    return sequence(code);
  }
  function sequence(code) {
    if (code === 45) {
      effects.consume(code);
      return sequence;
    }
    return whitespace(code);
  }
  function whitespace(code) {
    if (code === -2 || code === -1 || code === 32) {
      effects.consume(code);
      return whitespace;
    }
    if (code === null || code === -5 || code === -4 || code === -3) {
      return ok(code);
    }
    return nok(code);
  }
}
function tokenizeNextPrefixedOrBlank(effects, ok, nok) {
  var size = 0;
  return start;
  function start(code) {
    // This is a check, so we don’t care about tokens, but we open a bogus one
    // so we’re valid.
    effects.enter('check');
    // EOL.
    effects.consume(code);
    return whitespace;
  }
  function whitespace(code) {
    // VS or SP.
    if (code === -1 || code === 32) {
      effects.consume(code);
      size++;
      return size === 4 ? ok : whitespace;
    }

    // EOF or whitespace
    if (code === null || code < 0) {
      return ok(code);
    }

    // Anything else.
    return nok(code);
  }
}
(function (module) {
  module.exports = syntax$3;
})(micromarkExtensionGfmTable);
var micromarkExtensionGfmTaskListItem = {
  exports: {}
};
var syntax$2 = {};
var markdownLineEndingOrSpace = markdownLineEndingOrSpace_1;
var spaceFactory = factorySpace$h;
var prefixSize = prefixSize_1;
var tasklistCheck = {
  tokenize: tokenizeTasklistCheck
};
syntax$2.text = {
  91: tasklistCheck
};
function tokenizeTasklistCheck(effects, ok, nok) {
  var self = this;
  return open;
  function open(code) {
    if (
    // Exit if not `[`.
    code !== 91 ||
    // Exit if there’s stuff before.
    self.previous !== null ||
    // Exit if not in the first content that is the first child of a list
    // item.
    !self._gfmTasklistFirstContentOfListItem) {
      return nok(code);
    }
    effects.enter('taskListCheck');
    effects.enter('taskListCheckMarker');
    effects.consume(code);
    effects.exit('taskListCheckMarker');
    return inside;
  }
  function inside(code) {
    // Tab or space.
    if (code === -2 || code === 32) {
      effects.enter('taskListCheckValueUnchecked');
      effects.consume(code);
      effects.exit('taskListCheckValueUnchecked');
      return close;
    }

    // Upper- and lower `x`.
    if (code === 88 || code === 120) {
      effects.enter('taskListCheckValueChecked');
      effects.consume(code);
      effects.exit('taskListCheckValueChecked');
      return close;
    }
    return nok(code);
  }
  function close(code) {
    // `]`
    if (code === 93) {
      effects.enter('taskListCheckMarker');
      effects.consume(code);
      effects.exit('taskListCheckMarker');
      effects.exit('taskListCheck');
      return effects.check({
        tokenize: spaceThenNonSpace
      }, ok, nok);
    }
    return nok(code);
  }
}
function spaceThenNonSpace(effects, ok, nok) {
  var self = this;
  return spaceFactory(effects, after, 'whitespace');
  function after(code) {
    return prefixSize(self.events, 'whitespace') && code !== null && !markdownLineEndingOrSpace(code) ? ok(code) : nok(code);
  }
}
(function (module) {
  module.exports = syntax$2;
})(micromarkExtensionGfmTaskListItem);
var combine = combineExtensions_1;
var autolink = micromarkExtensionGfmAutolinkLiteral.exports;
var strikethrough$2 = micromarkExtensionGfmStrikethrough;
var table$2 = micromarkExtensionGfmTable.exports;
var tasklist = micromarkExtensionGfmTaskListItem.exports;
var syntax$1 = create$4;
function create$4(options) {
  return combine([autolink, strikethrough$2(options), table$2, tasklist]);
}
(function (module) {
  module.exports = syntax$1;
})(micromarkExtensionGfm);
var fromMarkdown$5 = {};
var ccount_1 = ccount$1;
function ccount$1(source, character) {
  var value = String(source);
  var count = 0;
  var index;
  if (typeof character !== 'string') {
    throw new Error('Expected character');
  }
  index = value.indexOf(character);
  while (index !== -1) {
    count++;
    index = value.indexOf(character, index + character.length);
  }
  return count;
}
var escapeStringRegexp = function escapeStringRegexp(string) {
  if (typeof string !== 'string') {
    throw new TypeError('Expected a string');
  }

  // Escape characters with special meaning either inside or outside character sets.
  // Use a simple backslash escape when it’s always valid, and a \unnnn escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
  return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
};
var mdastUtilFindAndReplace = findAndReplace$1;
var visit = unistUtilVisitParents;
var convert = convert_1;
var escape = escapeStringRegexp;
var splice$2 = [].splice;
function findAndReplace$1(tree, find, replace, options) {
  var settings;
  var schema;
  if (typeof find === 'string' || find && typeof find.exec === 'function') {
    schema = [[find, replace]];
  } else {
    schema = find;
    options = replace;
  }
  settings = options || {};
  search(tree, settings, handlerFactory(toPairs(schema)));
  return tree;
  function handlerFactory(pairs) {
    var pair = pairs[0];
    return handler;
    function handler(node, parent) {
      var find = pair[0];
      var replace = pair[1];
      var nodes = [];
      var start = 0;
      var index = parent.children.indexOf(node);
      var position;
      var match;
      var subhandler;
      var value;
      find.lastIndex = 0;
      match = find.exec(node.value);
      while (match) {
        position = match.index;
        value = replace.apply(null, [].concat(match, {
          index: match.index,
          input: match.input
        }));
        if (value !== false) {
          if (start !== position) {
            nodes.push({
              type: 'text',
              value: node.value.slice(start, position)
            });
          }
          if (typeof value === 'string' && value.length > 0) {
            value = {
              type: 'text',
              value: value
            };
          }
          if (value) {
            nodes = [].concat(nodes, value);
          }
          start = position + match[0].length;
        }
        if (!find.global) {
          break;
        }
        match = find.exec(node.value);
      }
      if (position === undefined) {
        nodes = [node];
        index--;
      } else {
        if (start < node.value.length) {
          nodes.push({
            type: 'text',
            value: node.value.slice(start)
          });
        }
        nodes.unshift(index, 1);
        splice$2.apply(parent.children, nodes);
      }
      if (pairs.length > 1) {
        subhandler = handlerFactory(pairs.slice(1));
        position = -1;
        while (++position < nodes.length) {
          node = nodes[position];
          if (node.type === 'text') {
            subhandler(node, parent);
          } else {
            search(node, settings, subhandler);
          }
        }
      }
      return index + nodes.length + 1;
    }
  }
}
function search(tree, settings, handler) {
  var ignored = convert(settings.ignore || []);
  var result = [];
  visit(tree, 'text', visitor);
  return result;
  function visitor(node, parents) {
    var index = -1;
    var parent;
    var grandparent;
    while (++index < parents.length) {
      parent = parents[index];
      if (ignored(parent, grandparent ? grandparent.children.indexOf(parent) : undefined, grandparent)) {
        return;
      }
      grandparent = parent;
    }
    return handler(node, grandparent);
  }
}
function toPairs(schema) {
  var result = [];
  var key;
  var index;
  if (typeof schema !== 'object') {
    throw new Error('Expected array or object as schema');
  }
  if ('length' in schema) {
    index = -1;
    while (++index < schema.length) {
      result.push([toExpression(schema[index][0]), toFunction(schema[index][1])]);
    }
  } else {
    for (key in schema) {
      result.push([toExpression(key), toFunction(schema[key])]);
    }
  }
  return result;
}
function toExpression(find) {
  return typeof find === 'string' ? new RegExp(escape(find), 'g') : find;
}
function toFunction(replace) {
  return typeof replace === 'function' ? replace : returner;
  function returner() {
    return replace;
  }
}
var ccount = ccount_1;
var findAndReplace = mdastUtilFindAndReplace;
var unicodePunctuation = unicodePunctuation_1;
var unicodeWhitespace = unicodeWhitespace_1;
fromMarkdown$5.transforms = [transformGfmAutolinkLiterals];
fromMarkdown$5.enter = {
  literalAutolink: enterLiteralAutolink,
  literalAutolinkEmail: enterLiteralAutolinkValue,
  literalAutolinkHttp: enterLiteralAutolinkValue,
  literalAutolinkWww: enterLiteralAutolinkValue
};
fromMarkdown$5.exit = {
  literalAutolink: exitLiteralAutolink,
  literalAutolinkEmail: exitLiteralAutolinkEmail,
  literalAutolinkHttp: exitLiteralAutolinkHttp,
  literalAutolinkWww: exitLiteralAutolinkWww
};
function enterLiteralAutolink(token) {
  this.enter({
    type: 'link',
    title: null,
    url: '',
    children: []
  }, token);
}
function enterLiteralAutolinkValue(token) {
  this.config.enter.autolinkProtocol.call(this, token);
}
function exitLiteralAutolinkHttp(token) {
  this.config.exit.autolinkProtocol.call(this, token);
}
function exitLiteralAutolinkWww(token) {
  this.config.exit.data.call(this, token);
  this.stack[this.stack.length - 1].url = 'http://' + this.sliceSerialize(token);
}
function exitLiteralAutolinkEmail(token) {
  this.config.exit.autolinkEmail.call(this, token);
}
function exitLiteralAutolink(token) {
  this.exit(token);
}
function transformGfmAutolinkLiterals(tree) {
  findAndReplace(tree, [[/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/i, findUrl], [/([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/, findEmail]], {
    ignore: ['link', 'linkReference']
  });
}
function findUrl($0, protocol, domain, path, match) {
  var prefix = '';
  var parts;
  var result;

  // Not an expected previous character.
  if (!previous(match)) {
    return false;
  }

  // Treat `www` as part of the domain.
  if (/^w/i.test(protocol)) {
    domain = protocol + domain;
    protocol = '';
    prefix = 'http://';
  }
  if (!isCorrectDomain(domain)) {
    return false;
  }
  parts = splitUrl(domain + path);
  if (!parts[0]) return false;
  result = {
    type: 'link',
    title: null,
    url: prefix + protocol + parts[0],
    children: [{
      type: 'text',
      value: protocol + parts[0]
    }]
  };
  if (parts[1]) {
    result = [result, {
      type: 'text',
      value: parts[1]
    }];
  }
  return result;
}
function findEmail($0, atext, label, match) {
  // Not an expected previous character.
  if (!previous(match, true) || /[_-]$/.test(label)) {
    return false;
  }
  return {
    type: 'link',
    title: null,
    url: 'mailto:' + atext + '@' + label,
    children: [{
      type: 'text',
      value: atext + '@' + label
    }]
  };
}
function isCorrectDomain(domain) {
  var parts = domain.split('.');
  if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) {
    return false;
  }
  return true;
}
function splitUrl(url) {
  var trail = /[!"&'),.:;<>?\]}]+$/.exec(url);
  var closingParenIndex;
  var openingParens;
  var closingParens;
  if (trail) {
    url = url.slice(0, trail.index);
    trail = trail[0];
    closingParenIndex = trail.indexOf(')');
    openingParens = ccount(url, '(');
    closingParens = ccount(url, ')');
    while (closingParenIndex !== -1 && openingParens > closingParens) {
      url += trail.slice(0, closingParenIndex + 1);
      trail = trail.slice(closingParenIndex + 1);
      closingParenIndex = trail.indexOf(')');
      closingParens++;
    }
  }
  return [url, trail];
}
function previous(match, email) {
  var code = match.input.charCodeAt(match.index - 1);
  return (code !== code || unicodeWhitespace(code) || unicodePunctuation(code)) && (!email || code !== 47);
}
var fromMarkdown$4 = {};
fromMarkdown$4.canContainEols = ['delete'];
fromMarkdown$4.enter = {
  strikethrough: enterStrikethrough
};
fromMarkdown$4.exit = {
  strikethrough: exitStrikethrough
};
function enterStrikethrough(token) {
  this.enter({
    type: 'delete',
    children: []
  }, token);
}
function exitStrikethrough(token) {
  this.exit(token);
}
var fromMarkdown$3 = {};
fromMarkdown$3.enter = {
  table: enterTable,
  tableData: enterCell,
  tableHeader: enterCell,
  tableRow: enterRow
};
fromMarkdown$3.exit = {
  codeText: exitCodeText,
  table: exitTable,
  tableData: exit,
  tableHeader: exit,
  tableRow: exit
};
function enterTable(token) {
  this.enter({
    type: 'table',
    align: token._align,
    children: []
  }, token);
  this.setData('inTable', true);
}
function exitTable(token) {
  this.exit(token);
  this.setData('inTable');
}
function enterRow(token) {
  this.enter({
    type: 'tableRow',
    children: []
  }, token);
}
function exit(token) {
  this.exit(token);
}
function enterCell(token) {
  this.enter({
    type: 'tableCell',
    children: []
  }, token);
}

// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
function exitCodeText(token) {
  var value = this.resume();
  if (this.getData('inTable')) {
    value = value.replace(/\\([\\|])/g, replace$1);
  }
  this.stack[this.stack.length - 1].value = value;
  this.exit(token);
}
function replace$1($0, $1) {
  // Pipes work, backslashes don’t (but can’t escape pipes).
  return $1 === '|' ? $1 : $0;
}
var fromMarkdown$2 = {};
fromMarkdown$2.exit = {
  taskListCheckValueChecked: exitCheck,
  taskListCheckValueUnchecked: exitCheck,
  paragraph: exitParagraphWithTaskListItem
};
function exitCheck(token) {
  // We’re always in a paragraph, in a list item.
  this.stack[this.stack.length - 2].checked = token.type === 'taskListCheckValueChecked';
}
function exitParagraphWithTaskListItem(token) {
  var parent = this.stack[this.stack.length - 2];
  var node = this.stack[this.stack.length - 1];
  var siblings = parent.children;
  var head = node.children[0];
  var index = -1;
  var firstParaghraph;
  if (parent && parent.type === 'listItem' && typeof parent.checked === 'boolean' && head && head.type === 'text') {
    while (++index < siblings.length) {
      if (siblings[index].type === 'paragraph') {
        firstParaghraph = siblings[index];
        break;
      }
    }
    if (firstParaghraph === node) {
      // Must start with a space or a tab.
      head.value = head.value.slice(1);
      if (head.value.length === 0) {
        node.children.shift();
      } else {
        head.position.start.column++;
        head.position.start.offset++;
        node.position.start = Object.assign({}, head.position.start);
      }
    }
  }
  this.exit(token);
}
var autolinkLiteral$1 = fromMarkdown$5;
var strikethrough$1 = fromMarkdown$4;
var table$1 = fromMarkdown$3;
var taskListItem$1 = fromMarkdown$2;
var own = {}.hasOwnProperty;
var fromMarkdown$1 = configure$2([autolinkLiteral$1, strikethrough$1, table$1, taskListItem$1]);
function configure$2(extensions) {
  var config = {
    transforms: [],
    canContainEols: []
  };
  var length = extensions.length;
  var index = -1;
  while (++index < length) {
    extension(config, extensions[index]);
  }
  return config;
}
function extension(config, extension) {
  var key;
  var left;
  var right;
  for (key in extension) {
    left = own.call(config, key) ? config[key] : config[key] = {};
    right = extension[key];
    if (key === 'canContainEols' || key === 'transforms') {
      config[key] = [].concat(left, right);
    } else {
      Object.assign(left, right);
    }
  }
}
var toMarkdown$5 = {};
var inConstruct = 'phrasing';
var notInConstruct = ['autolink', 'link', 'image', 'label'];
toMarkdown$5.unsafe = [{
  character: '@',
  before: '[+\\-.\\w]',
  after: '[\\-.\\w]',
  inConstruct: inConstruct,
  notInConstruct: notInConstruct
}, {
  character: '.',
  before: '[Ww]',
  after: '[\\-.\\w]',
  inConstruct: inConstruct,
  notInConstruct: notInConstruct
}, {
  character: ':',
  before: '[ps]',
  after: '\\/',
  inConstruct: inConstruct,
  notInConstruct: notInConstruct
}];
var toMarkdown$4 = {};
var containerPhrasing = phrasing$2;
function phrasing$2(parent, context, safeOptions) {
  var children = parent.children || [];
  var results = [];
  var index = -1;
  var before = safeOptions.before;
  var after;
  var handle;
  var child;
  while (++index < children.length) {
    child = children[index];
    if (index + 1 < children.length) {
      handle = context.handle.handlers[children[index + 1].type];
      if (handle && handle.peek) handle = handle.peek;
      after = handle ? handle(children[index + 1], parent, context, {
        before: '',
        after: ''
      }).charAt(0) : '';
    } else {
      after = safeOptions.after;
    }

    // In some cases, html (text) can be found in phrasing right after an eol.
    // When we’d serialize that, in most cases that would be seen as html
    // (flow).
    // As we can’t escape or so to prevent it from happening, we take a somewhat
    // reasonable approach: replace that eol with a space.
    // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
    if (results.length > 0 && (before === '\r' || before === '\n') && child.type === 'html') {
      results[results.length - 1] = results[results.length - 1].replace(/(\r?\n|\r)$/, ' ');
      before = ' ';
    }
    results.push(context.handle(child, parent, context, {
      before: before,
      after: after
    }));
    before = results[results.length - 1].slice(-1);
  }
  return results.join('');
}
var phrasing$1 = containerPhrasing;
toMarkdown$4.unsafe = [{
  character: '~',
  inConstruct: 'phrasing'
}];
toMarkdown$4.handlers = {
  delete: handleDelete
};
handleDelete.peek = peekDelete;
function handleDelete(node, _, context) {
  var exit = context.enter('emphasis');
  var value = phrasing$1(node, context, {
    before: '~',
    after: '~'
  });
  exit();
  return '~~' + value + '~~';
}
function peekDelete() {
  return '~';
}
var patternCompile_1 = patternCompile$1;
function patternCompile$1(pattern) {
  var before;
  var after;
  if (!pattern._compiled) {
    before = pattern.before ? '(?:' + pattern.before + ')' : '';
    after = pattern.after ? '(?:' + pattern.after + ')' : '';
    if (pattern.atBreak) {
      before = '[\\r\\n][\\t ]*' + before;
    }
    pattern._compiled = new RegExp((before ? '(' + before + ')' : '') + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? '\\' : '') + pattern.character + (after || ''), 'g');
  }
  return pattern._compiled;
}
var inlineCode_1 = inlineCode;
inlineCode.peek = inlineCodePeek;
var patternCompile = patternCompile_1;
function inlineCode(node, parent, context) {
  var value = node.value || '';
  var sequence = '`';
  var index = -1;
  var pattern;
  var expression;
  var match;
  var position;

  // If there is a single grave accent on its own in the code, use a fence of
  // two.
  // If there are two in a row, use one.
  while (new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value)) {
    sequence += '`';
  }

  // If this is not just spaces or eols (tabs don’t count), and either the
  // first or last character are a space, eol, or tick, then pad with spaces.
  if (/[^ \r\n]/.test(value) && (/[ \r\n`]/.test(value.charAt(0)) || /[ \r\n`]/.test(value.charAt(value.length - 1)))) {
    value = ' ' + value + ' ';
  }

  // We have a potential problem: certain characters after eols could result in
  // blocks being seen.
  // For example, if someone injected the string `'\n# b'`, then that would
  // result in an ATX heading.
  // We can’t escape characters in `inlineCode`, but because eols are
  // transformed to spaces when going from markdown to HTML anyway, we can swap
  // them out.
  while (++index < context.unsafe.length) {
    pattern = context.unsafe[index];

    // Only look for `atBreak`s.
    // Btw: note that `atBreak` patterns will always start the regex at LF or
    // CR.
    if (!pattern.atBreak) continue;
    expression = patternCompile(pattern);
    while (match = expression.exec(value)) {
      position = match.index;

      // Support CRLF (patterns only look for one of the characters).
      if (value.charCodeAt(position) === 10 /* `\n` */ && value.charCodeAt(position - 1) === 13 /* `\r` */) {
        position--;
      }
      value = value.slice(0, position) + ' ' + value.slice(match.index + 1);
    }
  }
  return sequence + value + sequence;
}
function inlineCodePeek() {
  return '`';
}

/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */

/**
 * Results cache
 */

var res = '';
var cache;

/**
 * Expose `repeat`
 */

var repeatString = repeat$3;

/**
 * Repeat the given `string` the specified `number`
 * of times.
 *
 * **Example:**
 *
 * ```js
 * var repeat = require('repeat-string');
 * repeat('A', 5);
 * //=> AAAAA
 * ```
 *
 * @param {String} `string` The string to repeat
 * @param {Number} `number` The number of times to repeat the string
 * @return {String} Repeated string
 * @api public
 */

function repeat$3(str, num) {
  if (typeof str !== 'string') {
    throw new TypeError('expected a string');
  }

  // cover common, quick use cases
  if (num === 1) return str;
  if (num === 2) return str + str;
  var max = str.length * num;
  if (cache !== str || typeof cache === 'undefined') {
    cache = str;
    res = '';
  } else if (res.length >= max) {
    return res.substr(0, max);
  }
  while (max > res.length && num > 1) {
    if (num & 1) {
      res += str;
    }
    num >>= 1;
    str += str;
  }
  res += str;
  res = res.substr(0, max);
  return res;
}
var repeat$2 = repeatString;
var markdownTable_1 = markdownTable$1;
var trailingWhitespace = / +$/;

// Characters.
var space = ' ';
var lineFeed = '\n';
var dash = '-';
var colon = ':';
var verticalBar = '|';
var x = 0;
var C = 67;
var L = 76;
var R = 82;
var c = 99;
var l = 108;
var r$1 = 114;

// Create a table from a matrix of strings.
function markdownTable$1(table, options) {
  var settings = options || {};
  var padding = settings.padding !== false;
  var start = settings.delimiterStart !== false;
  var end = settings.delimiterEnd !== false;
  var align = (settings.align || []).concat();
  var alignDelimiters = settings.alignDelimiters !== false;
  var alignments = [];
  var stringLength = settings.stringLength || defaultStringLength;
  var rowIndex = -1;
  var rowLength = table.length;
  var cellMatrix = [];
  var sizeMatrix = [];
  var row = [];
  var sizes = [];
  var longestCellByColumn = [];
  var mostCellsPerRow = 0;
  var cells;
  var columnIndex;
  var columnLength;
  var largest;
  var size;
  var cell;
  var lines;
  var line;
  var before;
  var after;
  var code;

  // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
  // do superfluous work when aligning, so optimize for aligning.
  while (++rowIndex < rowLength) {
    cells = table[rowIndex];
    columnIndex = -1;
    columnLength = cells.length;
    row = [];
    sizes = [];
    if (columnLength > mostCellsPerRow) {
      mostCellsPerRow = columnLength;
    }
    while (++columnIndex < columnLength) {
      cell = serialize(cells[columnIndex]);
      if (alignDelimiters === true) {
        size = stringLength(cell);
        sizes[columnIndex] = size;
        largest = longestCellByColumn[columnIndex];
        if (largest === undefined || size > largest) {
          longestCellByColumn[columnIndex] = size;
        }
      }
      row.push(cell);
    }
    cellMatrix[rowIndex] = row;
    sizeMatrix[rowIndex] = sizes;
  }

  // Figure out which alignments to use.
  columnIndex = -1;
  columnLength = mostCellsPerRow;
  if (typeof align === 'object' && 'length' in align) {
    while (++columnIndex < columnLength) {
      alignments[columnIndex] = toAlignment(align[columnIndex]);
    }
  } else {
    code = toAlignment(align);
    while (++columnIndex < columnLength) {
      alignments[columnIndex] = code;
    }
  }

  // Inject the alignment row.
  columnIndex = -1;
  columnLength = mostCellsPerRow;
  row = [];
  sizes = [];
  while (++columnIndex < columnLength) {
    code = alignments[columnIndex];
    before = '';
    after = '';
    if (code === l) {
      before = colon;
    } else if (code === r$1) {
      after = colon;
    } else if (code === c) {
      before = colon;
      after = colon;
    }

    // There *must* be at least one hyphen-minus in each alignment cell.
    size = alignDelimiters ? Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length) : 1;
    cell = before + repeat$2(dash, size) + after;
    if (alignDelimiters === true) {
      size = before.length + size + after.length;
      if (size > longestCellByColumn[columnIndex]) {
        longestCellByColumn[columnIndex] = size;
      }
      sizes[columnIndex] = size;
    }
    row[columnIndex] = cell;
  }

  // Inject the alignment row.
  cellMatrix.splice(1, 0, row);
  sizeMatrix.splice(1, 0, sizes);
  rowIndex = -1;
  rowLength = cellMatrix.length;
  lines = [];
  while (++rowIndex < rowLength) {
    row = cellMatrix[rowIndex];
    sizes = sizeMatrix[rowIndex];
    columnIndex = -1;
    columnLength = mostCellsPerRow;
    line = [];
    while (++columnIndex < columnLength) {
      cell = row[columnIndex] || '';
      before = '';
      after = '';
      if (alignDelimiters === true) {
        size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
        code = alignments[columnIndex];
        if (code === r$1) {
          before = repeat$2(space, size);
        } else if (code === c) {
          if (size % 2 === 0) {
            before = repeat$2(space, size / 2);
            after = before;
          } else {
            before = repeat$2(space, size / 2 + 0.5);
            after = repeat$2(space, size / 2 - 0.5);
          }
        } else {
          after = repeat$2(space, size);
        }
      }
      if (start === true && columnIndex === 0) {
        line.push(verticalBar);
      }
      if (padding === true &&
      // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(alignDelimiters === false && cell === '') && (start === true || columnIndex !== 0)) {
        line.push(space);
      }
      if (alignDelimiters === true) {
        line.push(before);
      }
      line.push(cell);
      if (alignDelimiters === true) {
        line.push(after);
      }
      if (padding === true) {
        line.push(space);
      }
      if (end === true || columnIndex !== columnLength - 1) {
        line.push(verticalBar);
      }
    }
    line = line.join('');
    if (end === false) {
      line = line.replace(trailingWhitespace, '');
    }
    lines.push(line);
  }
  return lines.join(lineFeed);
}
function serialize(value) {
  return value === null || value === undefined ? '' : String(value);
}
function defaultStringLength(value) {
  return value.length;
}
function toAlignment(value) {
  var code = typeof value === 'string' ? value.charCodeAt(0) : x;
  return code === L || code === l ? l : code === R || code === r$1 ? r$1 : code === C || code === c ? c : x;
}
var phrasing = containerPhrasing;
var defaultInlineCode = inlineCode_1;
var markdownTable = markdownTable_1;
var toMarkdown_1$1 = toMarkdown$3;
function toMarkdown$3(options) {
  var settings = options || {};
  var padding = settings.tableCellPadding;
  var alignDelimiters = settings.tablePipeAlign;
  var stringLength = settings.stringLength;
  var around = padding ? ' ' : '|';
  return {
    unsafe: [{
      character: '\r',
      inConstruct: 'tableCell'
    }, {
      character: '\n',
      inConstruct: 'tableCell'
    },
    // A pipe, when followed by a tab or space (padding), or a dash or colon
    // (unpadded delimiter row), could result in a table.
    {
      atBreak: true,
      character: '|',
      after: '[\t :-]'
    },
    // A pipe in a cell must be encoded.
    {
      character: '|',
      inConstruct: 'tableCell'
    },
    // A colon must be followed by a dash, in which case it could start a
    // delimiter row.
    {
      atBreak: true,
      character: ':',
      after: '-'
    },
    // A delimiter row can also start with a dash, when followed by more
    // dashes, a colon, or a pipe.
    // This is a stricter version than the built in check for lists, thematic
    // breaks, and setex heading underlines though:
    // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
    {
      atBreak: true,
      character: '-',
      after: '[:|-]'
    }],
    handlers: {
      table: handleTable,
      tableRow: handleTableRow,
      tableCell: handleTableCell,
      inlineCode: inlineCodeWithTable
    }
  };
  function handleTable(node, _, context) {
    return serializeData(handleTableAsData(node, context), node.align);
  }

  // This function isn’t really used normally, because we handle rows at the
  // table level.
  // But, if someone passes in a table row, this ensures we make somewhat sense.
  function handleTableRow(node, _, context) {
    var row = handleTableRowAsData(node, context);
    // `markdown-table` will always add an align row
    var value = serializeData([row]);
    return value.slice(0, value.indexOf('\n'));
  }
  function handleTableCell(node, _, context) {
    var exit = context.enter('tableCell');
    var value = phrasing(node, context, {
      before: around,
      after: around
    });
    exit();
    return value;
  }
  function serializeData(matrix, align) {
    return markdownTable(matrix, {
      align: align,
      alignDelimiters: alignDelimiters,
      padding: padding,
      stringLength: stringLength
    });
  }
  function handleTableAsData(node, context) {
    var children = node.children;
    var index = -1;
    var length = children.length;
    var result = [];
    var subexit = context.enter('table');
    while (++index < length) {
      result[index] = handleTableRowAsData(children[index], context);
    }
    subexit();
    return result;
  }
  function handleTableRowAsData(node, context) {
    var children = node.children;
    var index = -1;
    var length = children.length;
    var result = [];
    var subexit = context.enter('tableRow');
    while (++index < length) {
      result[index] = handleTableCell(children[index], node, context);
    }
    subexit();
    return result;
  }
  function inlineCodeWithTable(node, parent, context) {
    var value = defaultInlineCode(node, parent, context);
    if (context.stack.indexOf('tableCell') !== -1) {
      value = value.replace(/\|/g, '\\$&');
    }
    return value;
  }
}
var toMarkdown$2 = {};
var checkBullet_1 = checkBullet$1;
function checkBullet$1(context) {
  var marker = context.options.bullet || '*';
  if (marker !== '*' && marker !== '+' && marker !== '-') {
    throw new Error('Cannot serialize items with `' + marker + '` for `options.bullet`, expected `*`, `+`, or `-`');
  }
  return marker;
}
var checkListItemIndent_1 = checkListItemIndent$1;
function checkListItemIndent$1(context) {
  var style = context.options.listItemIndent || 'tab';
  if (style === 1 || style === '1') {
    return 'one';
  }
  if (style !== 'tab' && style !== 'one' && style !== 'mixed') {
    throw new Error('Cannot serialize items with `' + style + '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`');
  }
  return style;
}
var containerFlow = flow$1;
var repeat$1 = repeatString;
function flow$1(parent, context) {
  var children = parent.children || [];
  var results = [];
  var index = -1;
  var child;
  while (++index < children.length) {
    child = children[index];
    results.push(context.handle(child, parent, context, {
      before: '\n',
      after: '\n'
    }));
    if (index + 1 < children.length) {
      results.push(between(child, children[index + 1]));
    }
  }
  return results.join('');
  function between(left, right) {
    var index = -1;
    var result;
    while (++index < context.join.length) {
      result = context.join[index](left, right, parent, context);
      if (result === true || result === 1) {
        break;
      }
      if (typeof result === 'number') {
        return repeat$1('\n', 1 + Number(result));
      }
      if (result === false) {
        return '\n\n<!---->\n\n';
      }
    }
    return '\n\n';
  }
}
var indentLines_1 = indentLines$1;
var eol = /\r?\n|\r/g;
function indentLines$1(value, map) {
  var result = [];
  var start = 0;
  var line = 0;
  var match;
  while (match = eol.exec(value)) {
    one(value.slice(start, match.index));
    result.push(match[0]);
    start = match.index + match[0].length;
    line++;
  }
  one(value.slice(start));
  return result.join('');
  function one(value) {
    result.push(map(value, line, !value));
  }
}
var listItem_1 = listItem;
var repeat = repeatString;
var checkBullet = checkBullet_1;
var checkListItemIndent = checkListItemIndent_1;
var flow = containerFlow;
var indentLines = indentLines_1;
function listItem(node, parent, context) {
  var bullet = checkBullet(context);
  var listItemIndent = checkListItemIndent(context);
  var size;
  var value;
  var exit;
  if (parent && parent.ordered) {
    bullet = (parent.start > -1 ? parent.start : 1) + (context.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + '.';
  }
  size = bullet.length + 1;
  if (listItemIndent === 'tab' || listItemIndent === 'mixed' && (parent && parent.spread || node.spread)) {
    size = Math.ceil(size / 4) * 4;
  }
  exit = context.enter('listItem');
  value = indentLines(flow(node, context), map);
  exit();
  return value;
  function map(line, index, blank) {
    if (index) {
      return (blank ? '' : repeat(' ', size)) + line;
    }
    return (blank ? bullet : bullet + repeat(' ', size - bullet.length)) + line;
  }
}
var defaultListItem = listItem_1;
toMarkdown$2.unsafe = [{
  atBreak: true,
  character: '-',
  after: '[:|-]'
}];
toMarkdown$2.handlers = {
  listItem: listItemWithTaskListItem
};
function listItemWithTaskListItem(node, parent, context) {
  var value = defaultListItem(node, parent, context);
  var head = node.children[0];
  if (typeof node.checked === 'boolean' && head && head.type === 'paragraph') {
    value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
  }
  return value;
  function check($0) {
    return $0 + '[' + (node.checked ? 'x' : ' ') + '] ';
  }
}
var configure_1 = configure$1;
function configure$1(base, extension) {
  var index = -1;
  var key;

  // First do subextensions.
  if (extension.extensions) {
    while (++index < extension.extensions.length) {
      configure$1(base, extension.extensions[index]);
    }
  }
  for (key in extension) {
    if (key === 'extensions') ;else if (key === 'unsafe' || key === 'join') {
      base[key] = base[key].concat(extension[key] || []);
    } else if (key === 'handlers') {
      base[key] = Object.assign(base[key], extension[key] || {});
    } else {
      base.options[key] = extension[key];
    }
  }
  return base;
}
var autolinkLiteral = toMarkdown$5;
var strikethrough = toMarkdown$4;
var table = toMarkdown_1$1;
var taskListItem = toMarkdown$2;
var configure = configure_1;
var toMarkdown_1 = toMarkdown$1;
function toMarkdown$1(options) {
  var config = configure({
    handlers: {},
    join: [],
    unsafe: [],
    options: {}
  }, {
    extensions: [autolinkLiteral, strikethrough, table(options), taskListItem]
  });
  return Object.assign(config.options, {
    handlers: config.handlers,
    join: config.join,
    unsafe: config.unsafe
  });
}
var syntax = micromarkExtensionGfm.exports;
var fromMarkdown = fromMarkdown$1;
var toMarkdown = toMarkdown_1;
var warningIssued;
var remarkGfm = gfm;
function gfm(options) {
  var data = this.data();

  /* istanbul ignore next - old remark. */
  if (!warningIssued && (this.Parser && this.Parser.prototype && this.Parser.prototype.blockTokenizers || this.Compiler && this.Compiler.prototype && this.Compiler.prototype.visitors)) {
    warningIssued = true;
    console.warn('[remark-gfm] Warning: please upgrade to remark 13 to use this plugin');
  }
  add('micromarkExtensions', syntax(options));
  add('fromMarkdownExtensions', fromMarkdown);
  add('toMarkdownExtensions', toMarkdown(options));
  function add(field, value) {
    /* istanbul ignore if - other extensions. */
    if (data[field]) data[field].push(value);else data[field] = [value];
  }
}
var styles$D = {
  "centered": "markdown-module_centered__C5-VS",
  "p": "markdown-module_p__MLso-",
  "strong": "markdown-module_strong__URTfW",
  "heading": "markdown-module_heading__FzDxc",
  "list": "markdown-module_list__g4-EF",
  "nestedList": "markdown-module_nestedList__w8IdF",
  "listItem": "markdown-module_listItem__a9VID",
  "listIndex": "markdown-module_listIndex__JLuV4",
  "listBullet": "markdown-module_listBullet__T1oTy",
  "tableScroll": "markdown-module_tableScroll__O-tuX",
  "table": "markdown-module_table__ENXvD",
  "tableHeader": "markdown-module_tableHeader__bxtpb",
  "tableCell": "markdown-module_tableCell__PyZNq",
  "blockquote": "markdown-module_blockquote__cFTWd"
};
var Markdown = function Markdown(_ref20) {
  var _ref20$value = _ref20.value,
    value = _ref20$value === void 0 ? '' : _ref20$value,
    _ref20$centerText = _ref20.centerText,
    centerText = _ref20$centerText === void 0 ? false : _ref20$centerText;
  var _useThemeContext5 = useThemeContext(),
    _useThemeContext5$mar = _useThemeContext5.markdown,
    bulletAsset = _useThemeContext5$mar.bulletAsset,
    _blockquote = _useThemeContext5$mar.blockquote,
    color = _useThemeContext5.loader.color;
  return React$2.createElement("div", {
    className: centerText ? styles$D.centered : undefined
  }, React$2.createElement(reactMarkdown, {
    linkTarget: "_blank",
    remarkPlugins: [remarkGfm],
    components: {
      // Tables are wider than a phone. Scroll the table, never the page.
      table: function table(_ref21) {
        var children = _ref21.children;
        return React$2.createElement("div", {
          className: styles$D.tableScroll
        }, React$2.createElement("table", {
          className: styles$D.table
        }, children));
      },
      th: function th(_ref22) {
        var children = _ref22.children,
          style = _ref22.style;
        return React$2.createElement("th", {
          className: styles$D.tableHeader,
          style: style
        }, React$2.createElement(Body_4, null, children));
      },
      td: function td(_ref23) {
        var children = _ref23.children,
          style = _ref23.style;
        return React$2.createElement("td", {
          className: styles$D.tableCell,
          style: style
        }, React$2.createElement(Body_2, null, children));
      },
      p: function p(_ref24) {
        var children = _ref24.children;
        return React$2.createElement(Body_2, {
          className: styles$D.p
        }, children);
      },
      strong: function strong(_ref25) {
        var children = _ref25.children;
        return React$2.createElement(Body_4, {
          className: styles$D.strong
        }, children);
      },
      h1: function h1(_ref26) {
        var children = _ref26.children;
        return React$2.createElement(Heading_1, {
          className: styles$D.heading
        }, children);
      },
      h2: function h2(_ref27) {
        var children = _ref27.children;
        return React$2.createElement(Heading_2, {
          className: styles$D.heading
        }, children);
      },
      h3: function h3(_ref28) {
        var children = _ref28.children;
        return React$2.createElement(Heading_3, {
          className: styles$D.heading
        }, children);
      },
      h4: function h4(_ref29) {
        var children = _ref29.children;
        return React$2.createElement(Heading_4, {
          className: styles$D.heading
        }, children);
      },
      h5: function h5(_ref30) {
        var children = _ref30.children;
        return React$2.createElement(Body_1, {
          className: styles$D.heading
        }, children);
      },
      h6: function h6(_ref31) {
        var children = _ref31.children;
        return React$2.createElement(Body_3, {
          className: styles$D.heading
        }, children);
      },
      li: function li(props) {
        return React$2.createElement("div", null, props.ordered ? React$2.createElement("li", {
          className: styles$D.listItem
        }, React$2.createElement(Body_2, {
          className: styles$D.listIndex
        }, props.index + 1), React$2.createElement(Body_2, null, props.children)) : React$2.createElement("div", {
          className: styles$D.listItem
        }, React$2.createElement("div", {
          className: styles$D.listBullet
        }, React$2.createElement("img", {
          src: bulletAsset,
          alt: ""
        })), React$2.createElement(Body_2, null, props.children)));
      },
      ol: function ol(_ref32) {
        var children = _ref32.children,
          depth = _ref32.depth;
        return React$2.createElement("ol", {
          className: depth === 0 ? styles$D.list : styles$D.nestedList,
          children: children
        });
      },
      ul: function ul(_ref33) {
        var children = _ref33.children,
          depth = _ref33.depth;
        return React$2.createElement("ul", {
          className: depth === 0 ? styles$D.list : styles$D.nestedList,
          children: children
        });
      },
      /* eslint-disable @typescript-eslint/no-unused-vars */
      blockquote: function blockquote(_a) {
        var props = __rest(_a, ["node"]);
        return React$2.createElement("blockquote", Object.assign({
          style: _blockquote,
          className: styles$D.blockquote
        }, props));
      },
      /* eslint-enable @typescript-eslint/no-unused-vars */
      hr: function hr() {
        return React$2.createElement("hr", {
          style: {
            borderTop: "1px solid ".concat(String(color))
          }
        });
      }
    }
  }, value));
};
var styles$C = {
  "container": "confirmation-gate-module_container__MkKn8",
  "title": "confirmation-gate-module_title__xd5kj",
  "confirmations": "confirmation-gate-module_confirmations__lYmM-",
  "acknowledgement": "confirmation-gate-module_acknowledgement__qOVUP",
  "acknowledgementLabel": "confirmation-gate-module_acknowledgementLabel__iY2GV",
  "checkmarkContainer": "confirmation-gate-module_checkmarkContainer__SHFsB",
  "checkbox": "confirmation-gate-module_checkbox__2Qkzs"
};

/**
 * Shown in place of the redemption form when a segment carries one or more
 * confirmation fields, so the claimant has to read and acknowledge them before
 * they can order.
 *
 * The acknowledgement is a gate only: nothing is submitted for it, which is why
 * `confirmation` must stay in voucher-form-redemption's `DONT_VALIDATE_TYPES`.
 */
var ConfirmationGate = function ConfirmationGate(_ref34) {
  var confirmations = _ref34.confirmations,
    title = _ref34.title,
    acknowledgementLabel = _ref34.acknowledgementLabel,
    buttonCopy = _ref34.buttonCopy,
    onConfirm = _ref34.onConfirm,
    className = _ref34.className;
  var _useState10 = useState(false),
    _useState11 = _slicedToArray(_useState10, 2),
    acknowledged = _useState11[0],
    setAcknowledged = _useState11[1];
  var _useThemeContext6 = useThemeContext(),
    _useThemeContext6$for = _useThemeContext6.form.body,
    _useThemeContext6$for2 = _useThemeContext6$for === void 0 ? DefaultFormBodyModel : _useThemeContext6$for,
    borderColor = _useThemeContext6$for2.borderColor,
    checkbox = _useThemeContext6$for2.checkbox;
  return React$2.createElement("div", {
    className: classnames(className, styles$C.container)
  }, React$2.createElement(Heading_3, {
    className: styles$C.title
  }, title), React$2.createElement("div", {
    className: styles$C.confirmations,
    "data-test-id": "confirmation-content"
  }, confirmations.map(function (_ref35) {
    var name = _ref35.name,
      placeholder = _ref35.placeholder;
    return React$2.createElement(Markdown, {
      key: name,
      value: placeholder
    });
  })), React$2.createElement("label", {
    htmlFor: "confirmation-acknowledgement",
    className: styles$C.acknowledgement
  }, React$2.createElement(Body_2, {
    className: styles$C.acknowledgementLabel
  }, acknowledgementLabel), React$2.createElement("div", {
    className: styles$C.checkmarkContainer
  }, React$2.createElement("input", {
    type: "checkbox",
    id: "confirmation-acknowledgement",
    "data-test-id": "confirmation-acknowledgement",
    className: styles$C.checkbox,
    style: {
      borderColor: borderColor
    },
    checked: acknowledged,
    onChange: function onChange() {
      setAcknowledged(!acknowledged);
    }
  }), React$2.createElement(Checkmark, {
    checked: acknowledged,
    color: checkbox === null || checkbox === void 0 ? void 0 : checkbox.color
  }))), React$2.createElement(PrimaryButton, {
    label: buttonCopy,
    onClick: onConfirm,
    disabled: !acknowledged,
    "data-test-id": "confirmation-continue"
  }));
};
var styles$B = {
  "divider": "divider-module_divider__HWoj3"
};
var Divider = function Divider(_ref36) {
  var className = _ref36.className,
    _ref36$style = _ref36.style,
    style = _ref36$style === void 0 ? {} : _ref36$style;
  var _useThemeContext7 = useThemeContext(),
    src = _useThemeContext7.divider.src;
  return React$2.createElement("img", {
    className: classnames(className, styles$B.divider),
    style: style,
    src: src,
    alt: ""
  });
};
var isMergeableObject = function isMergeableObject(value) {
  return isNonNullObject(value) && !isSpecial(value);
};
function isNonNullObject(value) {
  return !!value && typeof value === 'object';
}
function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}
function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function (element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}
function mergeObject(target, source, options) {
  var destination = {};
  if (options.isMergeableObject(target)) {
    Object.keys(target).forEach(function (key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }
  Object.keys(source).forEach(function (key) {
    if (!options.isMergeableObject(source[key]) || !target[key]) {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    } else {
      destination[key] = deepmerge(target[key], source[key], options);
    }
  });
  return destination;
}
function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}
deepmerge.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error('first argument should be an array');
  }
  return array.reduce(function (prev, next) {
    return deepmerge(prev, next, options);
  }, {});
};
var deepmerge_1 = deepmerge;

/** Detect free variable `global` from Node.js. */
var freeGlobal$2 = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$9 = freeGlobal$2 || freeSelf$1 || Function('return this')();

/** Built-in value references. */
var Symbol$6 = root$9.Symbol;

/** Used for built-in method references. */
var objectProto$q = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$k = objectProto$q.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$3 = objectProto$q.toString;

/** Built-in value references. */
var symToStringTag$3 = Symbol$6 ? Symbol$6.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$2(value) {
  var isOwn = hasOwnProperty$k.call(value, symToStringTag$3),
    tag = value[symToStringTag$3];
  try {
    value[symToStringTag$3] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$3.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$3] = tag;
    } else {
      delete value[symToStringTag$3];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$p = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$2 = objectProto$p.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$3(value) {
  return nativeObjectToString$2.call(value);
}

/** `Object#toString` result references. */
var nullTag$1 = '[object Null]',
  undefinedTag$1 = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$2 = Symbol$6 ? Symbol$6.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$6(value) {
  if (value == null) {
    return value === undefined ? undefinedTag$1 : nullTag$1;
  }
  return symToStringTag$2 && symToStringTag$2 in Object(value) ? getRawTag$2(value) : objectToString$3(value);
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg$2(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/** Built-in value references. */
var getPrototype = overArg$2(Object.getPrototypeOf, Object);

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$6(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var objectTag$6 = '[object Object]';

/** Used for built-in method references. */
var funcProto$4 = Function.prototype,
  objectProto$o = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$4 = funcProto$4.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$j = objectProto$o.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$4.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject$1(value) {
  if (!isObjectLike$6(value) || baseGetTag$6(value) != objectTag$6) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$j.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$4.call(Ctor) == objectCtorString;
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear$2() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq$3(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$5(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$3(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto$1 = Array.prototype;

/** Built-in value references. */
var splice$1 = arrayProto$1.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$2(key) {
  var data = this.__data__,
    index = assocIndexOf$5(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$2(key) {
  var data = this.__data__,
    index = assocIndexOf$5(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$2(key) {
  return assocIndexOf$5(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$2(key, value) {
  var data = this.__data__,
    index = assocIndexOf$5(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$5(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$5.prototype.clear = listCacheClear$2;
ListCache$5.prototype['delete'] = listCacheDelete$2;
ListCache$5.prototype.get = listCacheGet$2;
ListCache$5.prototype.has = listCacheHas$2;
ListCache$5.prototype.set = listCacheSet$2;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$2() {
  this.__data__ = new ListCache$5();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete$2(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet$2(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas$2(key) {
  return this.__data__.has(key);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$6(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var asyncTag$1 = '[object AsyncFunction]',
  funcTag$4 = '[object Function]',
  genTag$2 = '[object GeneratorFunction]',
  proxyTag$1 = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$5(value) {
  if (!isObject$6(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$6(value);
  return tag == funcTag$4 || tag == genTag$2 || tag == asyncTag$1 || tag == proxyTag$1;
}

/** Used to detect overreaching core-js shims. */
var coreJsData$2 = root$9['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey$1 = function () {
  var uid = /[^.]+$/.exec(coreJsData$2 && coreJsData$2.keys && coreJsData$2.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$2(func) {
  return !!maskSrcKey$1 && maskSrcKey$1 in func;
}

/** Used for built-in method references. */
var funcProto$3 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$3 = funcProto$3.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$3(func) {
  if (func != null) {
    try {
      return funcToString$3.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
  objectProto$n = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$i = objectProto$n.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative$1 = RegExp('^' + funcToString$2.call(hasOwnProperty$i).replace(reRegExpChar$1, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$2(value) {
  if (!isObject$6(value) || isMasked$2(value)) {
    return false;
  }
  var pattern = isFunction$5(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$3(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue$2(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$8(object, key) {
  var value = getValue$2(object, key);
  return baseIsNative$2(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var Map$5 = getNative$8(root$9, 'Map');

/* Built-in method references that are verified to be native. */
var nativeCreate$5 = getNative$8(Object, 'create');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$2() {
  this.__data__ = nativeCreate$5 ? nativeCreate$5(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete$2(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$4 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$m = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$h = objectProto$m.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$2(key) {
  var data = this.__data__;
  if (nativeCreate$5) {
    var result = data[key];
    return result === HASH_UNDEFINED$4 ? undefined : result;
  }
  return hasOwnProperty$h.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$l = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$g = objectProto$l.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$2(key) {
  var data = this.__data__;
  return nativeCreate$5 ? data[key] !== undefined : hasOwnProperty$g.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$3 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$2(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$5 && value === undefined ? HASH_UNDEFINED$3 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$2(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$2.prototype.clear = hashClear$2;
Hash$2.prototype['delete'] = hashDelete$2;
Hash$2.prototype.get = hashGet$2;
Hash$2.prototype.has = hashHas$2;
Hash$2.prototype.set = hashSet$2;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$2() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash$2(),
    'map': new (Map$5 || ListCache$5)(),
    'string': new Hash$2()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable$2(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$5(map, key) {
  var data = map.__data__;
  return isKeyable$2(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$2(key) {
  var result = getMapData$5(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$2(key) {
  return getMapData$5(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$2(key) {
  return getMapData$5(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$2(key, value) {
  var data = getMapData$5(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$4(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$4.prototype.clear = mapCacheClear$2;
MapCache$4.prototype['delete'] = mapCacheDelete$2;
MapCache$4.prototype.get = mapCacheGet$2;
MapCache$4.prototype.has = mapCacheHas$2;
MapCache$4.prototype.set = mapCacheSet$2;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$2(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$5) {
    var pairs = data.__data__;
    if (!Map$5 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$4(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$3(entries) {
  var data = this.__data__ = new ListCache$5(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$3.prototype.clear = stackClear$2;
Stack$3.prototype['delete'] = stackDelete$2;
Stack$3.prototype.get = stackGet$2;
Stack$3.prototype.has = stackHas$2;
Stack$3.prototype.set = stackSet$2;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}
var defineProperty$2 = function () {
  try {
    var func = getNative$8(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$3(object, key, value) {
  if (key == '__proto__' && defineProperty$2) {
    defineProperty$2(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/** Used for built-in method references. */
var objectProto$k = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$f = objectProto$k.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$f.call(object, key) && eq$3(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue$3(object, key, value);
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
    length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue$3(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes$2(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** `Object#toString` result references. */
var argsTag$5 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$2(value) {
  return isObjectLike$6(value) && baseGetTag$6(value) == argsTag$5;
}

/** Used for built-in method references. */
var objectProto$j = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$j.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$3 = objectProto$j.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$3 = baseIsArguments$2(function () {
  return arguments;
}()) ? baseIsArguments$2 : function (value) {
  return isObjectLike$6(value) && hasOwnProperty$e.call(value, 'callee') && !propertyIsEnumerable$3.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$b = Array.isArray;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse$1() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$2 = freeExports$2 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

/** Built-in value references. */
var Buffer$1 = moduleExports$2 ? root$9.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer$3 = nativeIsBuffer || stubFalse$1;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$3 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint$1 = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$3(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$3 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint$1.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$2 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$4(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$2;
}

/** `Object#toString` result references. */
var argsTag$4 = '[object Arguments]',
  arrayTag$3 = '[object Array]',
  boolTag$4 = '[object Boolean]',
  dateTag$4 = '[object Date]',
  errorTag$3 = '[object Error]',
  funcTag$3 = '[object Function]',
  mapTag$7 = '[object Map]',
  numberTag$4 = '[object Number]',
  objectTag$5 = '[object Object]',
  regexpTag$4 = '[object RegExp]',
  setTag$7 = '[object Set]',
  stringTag$4 = '[object String]',
  weakMapTag$4 = '[object WeakMap]';
var arrayBufferTag$4 = '[object ArrayBuffer]',
  dataViewTag$6 = '[object DataView]',
  float32Tag$3 = '[object Float32Array]',
  float64Tag$3 = '[object Float64Array]',
  int8Tag$3 = '[object Int8Array]',
  int16Tag$3 = '[object Int16Array]',
  int32Tag$3 = '[object Int32Array]',
  uint8Tag$3 = '[object Uint8Array]',
  uint8ClampedTag$3 = '[object Uint8ClampedArray]',
  uint16Tag$3 = '[object Uint16Array]',
  uint32Tag$3 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags$1 = {};
typedArrayTags$1[float32Tag$3] = typedArrayTags$1[float64Tag$3] = typedArrayTags$1[int8Tag$3] = typedArrayTags$1[int16Tag$3] = typedArrayTags$1[int32Tag$3] = typedArrayTags$1[uint8Tag$3] = typedArrayTags$1[uint8ClampedTag$3] = typedArrayTags$1[uint16Tag$3] = typedArrayTags$1[uint32Tag$3] = true;
typedArrayTags$1[argsTag$4] = typedArrayTags$1[arrayTag$3] = typedArrayTags$1[arrayBufferTag$4] = typedArrayTags$1[boolTag$4] = typedArrayTags$1[dataViewTag$6] = typedArrayTags$1[dateTag$4] = typedArrayTags$1[errorTag$3] = typedArrayTags$1[funcTag$3] = typedArrayTags$1[mapTag$7] = typedArrayTags$1[numberTag$4] = typedArrayTags$1[objectTag$5] = typedArrayTags$1[regexpTag$4] = typedArrayTags$1[setTag$7] = typedArrayTags$1[stringTag$4] = typedArrayTags$1[weakMapTag$4] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$2(value) {
  return isObjectLike$6(value) && isLength$4(value.length) && !!typedArrayTags$1[baseGetTag$6(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary$2(func) {
  return function (value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports$1 && freeGlobal$2.process;

/** Used to access faster Node.js helpers. */
var nodeUtil$1 = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;
    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

/* Node.js helper references. */
var nodeIsTypedArray$1 = nodeUtil$1 && nodeUtil$1.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$3 = nodeIsTypedArray$1 ? baseUnary$2(nodeIsTypedArray$1) : baseIsTypedArray$2;

/** Used for built-in method references. */
var objectProto$i = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$i.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$b(value),
    isArg = !isArr && isArguments$3(value),
    isBuff = !isArr && !isArg && isBuffer$3(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray$3(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes$2(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$d.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex$3(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$2(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$h;
  return value === proto;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$2 = overArg$2(Object.keys, Object);

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$g.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$2(object) {
  if (!isPrototype$2(object)) {
    return nativeKeys$2(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$c.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$2(value) {
  return value != null && isLength$4(value.length) && !isFunction$5(value);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$4(object) {
  return isArrayLike$2(object) ? arrayLikeKeys$2(object) : baseKeys$2(object);
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys$4(source), object);
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$f.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject$6(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$2(object),
    result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$b.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike$2(object) ? arrayLikeKeys$2(object, true) : baseKeysIn(object);
}

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root$9.Buffer : undefined,
  allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
    result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
    length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter$2(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray$2() {
  return [];
}

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$2 = objectProto$e.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$2 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$2 = !nativeGetSymbols$2 ? stubArray$2 : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter$2(nativeGetSymbols$2(object), function (symbol) {
    return propertyIsEnumerable$2.call(object, symbol);
  });
};

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols$2(source), object);
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush$2(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray$2 : function (object) {
  var result = [];
  while (object) {
    arrayPush$2(result, getSymbols$2(object));
    object = getPrototype(object);
  }
  return result;
};

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$b(object) ? result : arrayPush$2(result, symbolsFunc(object));
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$2(object) {
  return baseGetAllKeys$2(object, keys$4, getSymbols$2);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys$2(object, keysIn, getSymbolsIn);
}

/* Built-in method references that are verified to be native. */
var DataView$2 = getNative$8(root$9, 'DataView');

/* Built-in method references that are verified to be native. */
var Promise$3 = getNative$8(root$9, 'Promise');

/* Built-in method references that are verified to be native. */
var Set$3 = getNative$8(root$9, 'Set');

/* Built-in method references that are verified to be native. */
var WeakMap$3 = getNative$8(root$9, 'WeakMap');

/** `Object#toString` result references. */
var mapTag$6 = '[object Map]',
  objectTag$4 = '[object Object]',
  promiseTag$1 = '[object Promise]',
  setTag$6 = '[object Set]',
  weakMapTag$3 = '[object WeakMap]';
var dataViewTag$5 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString$1 = toSource$3(DataView$2),
  mapCtorString$1 = toSource$3(Map$5),
  promiseCtorString$1 = toSource$3(Promise$3),
  setCtorString$1 = toSource$3(Set$3),
  weakMapCtorString$1 = toSource$3(WeakMap$3);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$2 = baseGetTag$6;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView$2 && getTag$2(new DataView$2(new ArrayBuffer(1))) != dataViewTag$5 || Map$5 && getTag$2(new Map$5()) != mapTag$6 || Promise$3 && getTag$2(Promise$3.resolve()) != promiseTag$1 || Set$3 && getTag$2(new Set$3()) != setTag$6 || WeakMap$3 && getTag$2(new WeakMap$3()) != weakMapTag$3) {
  getTag$2 = function getTag$2(value) {
    var result = baseGetTag$6(value),
      Ctor = result == objectTag$4 ? value.constructor : undefined,
      ctorString = Ctor ? toSource$3(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString$1:
          return dataViewTag$5;
        case mapCtorString$1:
          return mapTag$6;
        case promiseCtorString$1:
          return promiseTag$1;
        case setCtorString$1:
          return setTag$6;
        case weakMapCtorString$1:
          return weakMapTag$3;
      }
    }
    return result;
  };
}
var getTag$3 = getTag$2;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$d.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
    result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$a.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/** Built-in value references. */
var Uint8Array$2 = root$9.Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/** Used to convert symbols to primitives and strings. */
var symbolProto$3 = Symbol$6 ? Symbol$6.prototype : undefined,
  symbolValueOf$1 = symbolProto$3 ? symbolProto$3.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/** `Object#toString` result references. */
var boolTag$3 = '[object Boolean]',
  dateTag$3 = '[object Date]',
  mapTag$5 = '[object Map]',
  numberTag$3 = '[object Number]',
  regexpTag$3 = '[object RegExp]',
  setTag$5 = '[object Set]',
  stringTag$3 = '[object String]',
  symbolTag$4 = '[object Symbol]';
var arrayBufferTag$3 = '[object ArrayBuffer]',
  dataViewTag$4 = '[object DataView]',
  float32Tag$2 = '[object Float32Array]',
  float64Tag$2 = '[object Float64Array]',
  int8Tag$2 = '[object Int8Array]',
  int16Tag$2 = '[object Int16Array]',
  int32Tag$2 = '[object Int32Array]',
  uint8Tag$2 = '[object Uint8Array]',
  uint8ClampedTag$2 = '[object Uint8ClampedArray]',
  uint16Tag$2 = '[object Uint16Array]',
  uint32Tag$2 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$3:
      return cloneArrayBuffer(object);
    case boolTag$3:
    case dateTag$3:
      return new Ctor(+object);
    case dataViewTag$4:
      return cloneDataView(object, isDeep);
    case float32Tag$2:
    case float64Tag$2:
    case int8Tag$2:
    case int16Tag$2:
    case int32Tag$2:
    case uint8Tag$2:
    case uint8ClampedTag$2:
    case uint16Tag$2:
    case uint32Tag$2:
      return cloneTypedArray(object, isDeep);
    case mapTag$5:
      return new Ctor();
    case numberTag$3:
    case stringTag$3:
      return new Ctor(object);
    case regexpTag$3:
      return cloneRegExp(object);
    case setTag$5:
      return new Ctor();
    case symbolTag$4:
      return cloneSymbol(object);
  }
}

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject$6(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype$2(object) ? baseCreate(getPrototype(object)) : {};
}

/** `Object#toString` result references. */
var mapTag$4 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike$6(value) && getTag$3(value) == mapTag$4;
}

/* Node.js helper references. */
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary$2(nodeIsMap) : baseIsMap;

/** `Object#toString` result references. */
var setTag$4 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike$6(value) && getTag$3(value) == setTag$4;
}

/* Node.js helper references. */
var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary$2(nodeIsSet) : baseIsSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
  CLONE_FLAT_FLAG = 2,
  CLONE_SYMBOLS_FLAG$2 = 4;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]',
  arrayTag$2 = '[object Array]',
  boolTag$2 = '[object Boolean]',
  dateTag$2 = '[object Date]',
  errorTag$2 = '[object Error]',
  funcTag$2 = '[object Function]',
  genTag$1 = '[object GeneratorFunction]',
  mapTag$3 = '[object Map]',
  numberTag$2 = '[object Number]',
  objectTag$3 = '[object Object]',
  regexpTag$2 = '[object RegExp]',
  setTag$3 = '[object Set]',
  stringTag$2 = '[object String]',
  symbolTag$3 = '[object Symbol]',
  weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
  dataViewTag$3 = '[object DataView]',
  float32Tag$1 = '[object Float32Array]',
  float64Tag$1 = '[object Float64Array]',
  int8Tag$1 = '[object Int8Array]',
  int16Tag$1 = '[object Int16Array]',
  int32Tag$1 = '[object Int32Array]',
  uint8Tag$1 = '[object Uint8Array]',
  uint8ClampedTag$1 = '[object Uint8ClampedArray]',
  uint16Tag$1 = '[object Uint16Array]',
  uint32Tag$1 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$3] = cloneableTags[arrayTag$2] = cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] = cloneableTags[boolTag$2] = cloneableTags[dateTag$2] = cloneableTags[float32Tag$1] = cloneableTags[float64Tag$1] = cloneableTags[int8Tag$1] = cloneableTags[int16Tag$1] = cloneableTags[int32Tag$1] = cloneableTags[mapTag$3] = cloneableTags[numberTag$2] = cloneableTags[objectTag$3] = cloneableTags[regexpTag$2] = cloneableTags[setTag$3] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$3] = cloneableTags[uint8Tag$1] = cloneableTags[uint8ClampedTag$1] = cloneableTags[uint16Tag$1] = cloneableTags[uint32Tag$1] = true;
cloneableTags[errorTag$2] = cloneableTags[funcTag$2] = cloneableTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone$1(value, bitmask, customizer, key, object, stack) {
  var result,
    isDeep = bitmask & CLONE_DEEP_FLAG$1,
    isFlat = bitmask & CLONE_FLAT_FLAG,
    isFull = bitmask & CLONE_SYMBOLS_FLAG$2;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$6(value)) {
    return value;
  }
  var isArr = isArray$b(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$3(value),
      isFunc = tag == funcTag$2 || tag == genTag$1;
    if (isBuffer$3(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$3 || tag == argsTag$3 || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack$3());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone$1(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys$2 : isFlat ? keysIn : keys$4;
  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
  CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone$1(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG$1);
}
var isArray$a = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';
function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;
  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray$a(a),
      arrB = isArray$a(b),
      i,
      length,
      key;
    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (!equal(a[i], b[i])) return false;
      return true;
    }
    if (arrA != arrB) return false;
    var dateA = a instanceof Date,
      dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp,
      regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;
    if (length !== keyList(b).length) return false;
    for (i = length; i-- !== 0;) if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element) return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }
  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};
var isProduction = process.env.NODE_ENV === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }
    var text = "Warning: " + message;
    if (typeof console !== 'undefined') {
      console.warn(text);
    }
    try {
      throw Error(text);
    } catch (x) {}
  }
}

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone$1(value) {
  return baseClone$1(value, CLONE_SYMBOLS_FLAG);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap$2(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length,
    result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/** `Object#toString` result references. */
var symbolTag$2 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$4(value) {
  return typeof value == 'symbol' || isObjectLike$6(value) && baseGetTag$6(value) == symbolTag$2;
}

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$2(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var _memoized = function memoized() {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = _memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    _memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  _memoized.cache = new (memoize$2.Cache || MapCache$4)();
  return _memoized;
}

// Expose `MapCache`.
memoize$2.Cache = MapCache$4;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE$1 = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$2(func) {
  var result = memoize$2(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE$1) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar$1 = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$2 = memoizeCapped$2(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName$1, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, '$1') : number || match);
  });
  return result;
});

/** Used as references for various `Number` constants. */
var INFINITY$3 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$5(value) {
  if (typeof value == 'string' || isSymbol$4(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$3 ? '-0' : result;
}

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = Symbol$6 ? Symbol$6.prototype : undefined,
  symbolToString$2 = symbolProto$2 ? symbolProto$2.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$2(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$b(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$2(value, baseToString$2) + '';
  }
  if (isSymbol$4(value)) {
    return symbolToString$2 ? symbolToString$2.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$2 ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$7(value) {
  return value == null ? '' : baseToString$2(value);
}

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray$b(value)) {
    return arrayMap$2(value, toKey$5);
  }
  return isSymbol$4(value) ? [value] : copyArray(stringToPath$2(toString$7(value)));
}
var reactIs = requireReactIs();
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$5.apply(this, arguments);
}
function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
var FormikContext = /*#__PURE__*/createContext(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
FormikContext.Consumer;
function useFormikContext() {
  var formik = useContext(FormikContext);
  !!!formik ? process.env.NODE_ENV !== "production" ? warning(false, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : warning(false) : void 0;
  return formik;
}

/** @private is the value an empty array? */

var isEmptyArray = function isEmptyArray(value) {
  return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */

var isFunction$4 = function isFunction(obj) {
  return typeof obj === 'function';
};
/** @private is the given object an Object? */

var isObject$5 = function isObject(obj) {
  return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */

var isInteger = function isInteger(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */

var isString$1 = function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private Does a React component have exactly 0 children? */

var isEmptyChildren = function isEmptyChildren(children) {
  return Children.count(children) === 0;
};
/** @private is the given object/value a promise? */

var isPromise = function isPromise(value) {
  return isObject$5(value) && isFunction$4(value.then);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */

function getActiveElement$1(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
/**
 * Deeply get a value from an object via its path.
 */

function getIn$1(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }
  var path = toPath(key);
  while (obj && p < path.length) {
    obj = obj[path[p++]];
  } // check if path is not in the end

  if (p !== path.length && !obj) {
    return def;
  }
  return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */

function setIn(obj, path, value) {
  var res = clone$1(obj); // this keeps inheritance when obj is a class

  var resVal = res;
  var i = 0;
  var pathArray = toPath(path);
  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn$1(obj, pathArray.slice(0, i + 1));
    if (currentObj && (isObject$5(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = clone$1(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  } // Return original object if new value is the same as current

  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }
  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  } // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.

  if (i === 0 && value === undefined) {
    delete res[pathArray[i]];
  }
  return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */

function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = new WeakMap();
  }
  if (response === void 0) {
    response = {};
  }
  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var val = object[k];
    if (isObject$5(val)) {
      if (!visited.get(val)) {
        visited.set(val, true); // In order to keep array values consistent for both dot path  and
        // bracket syntax, we need to check if this is an array so that
        // this will output  { friends: [true] } and not { friends: { "0": true } }

        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }
  return response;
}
function formikReducer(state, msg) {
  switch (msg.type) {
    case 'SET_VALUES':
      return _extends$5({}, state, {
        values: msg.payload
      });
    case 'SET_TOUCHED':
      return _extends$5({}, state, {
        touched: msg.payload
      });
    case 'SET_ERRORS':
      if (reactFastCompare(state.errors, msg.payload)) {
        return state;
      }
      return _extends$5({}, state, {
        errors: msg.payload
      });
    case 'SET_STATUS':
      return _extends$5({}, state, {
        status: msg.payload
      });
    case 'SET_ISSUBMITTING':
      return _extends$5({}, state, {
        isSubmitting: msg.payload
      });
    case 'SET_ISVALIDATING':
      return _extends$5({}, state, {
        isValidating: msg.payload
      });
    case 'SET_FIELD_VALUE':
      return _extends$5({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });
    case 'SET_FIELD_TOUCHED':
      return _extends$5({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });
    case 'SET_FIELD_ERROR':
      return _extends$5({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });
    case 'RESET_FORM':
      return _extends$5({}, state, msg.payload);
    case 'SET_FORMIK_STATE':
      return msg.payload(state);
    case 'SUBMIT_ATTEMPT':
      return _extends$5({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });
    case 'SUBMIT_FAILURE':
      return _extends$5({}, state, {
        isSubmitting: false
      });
    case 'SUBMIT_SUCCESS':
      return _extends$5({}, state, {
        isSubmitting: false
      });
    default:
      return state;
  }
} // Initial empty states // objects

var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
  var _ref$validateOnChange = _ref.validateOnChange,
    validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange,
    _ref$validateOnBlur = _ref.validateOnBlur,
    validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur,
    _ref$validateOnMount = _ref.validateOnMount,
    validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount,
    isInitialValid = _ref.isInitialValid,
    _ref$enableReinitiali = _ref.enableReinitialize,
    enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali,
    onSubmit = _ref.onSubmit,
    rest = _objectWithoutPropertiesLoose$2(_ref, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);
  var props = _extends$5({
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onSubmit: onSubmit
  }, rest);
  var initialValues = useRef(props.initialValues);
  var initialErrors = useRef(props.initialErrors || emptyErrors);
  var initialTouched = useRef(props.initialTouched || emptyTouched);
  var initialStatus = useRef(props.initialStatus);
  var isMounted = useRef(false);
  var fieldRegistry = useRef({});
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      !(typeof isInitialValid === 'undefined') ? process.env.NODE_ENV !== "production" ? warning(false, 'isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.') : warning(false) : void 0; // eslint-disable-next-line
    }, []);
  }
  useEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  var _React$useState = useState(0),
    setIteration = _React$useState[1];
  var stateRef = useRef({
    values: cloneDeep(props.initialValues),
    errors: cloneDeep(props.initialErrors) || emptyErrors,
    touched: cloneDeep(props.initialTouched) || emptyTouched,
    status: cloneDeep(props.initialStatus),
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  });
  var state = stateRef.current;
  var dispatch = useCallback(function (action) {
    var prev = stateRef.current;
    stateRef.current = formikReducer(prev, action); // force rerender

    if (prev !== stateRef.current) setIteration(function (x) {
      return x + 1;
    });
  }, []);
  var runValidateHandler = useCallback(function (values, field) {
    return new Promise(function (resolve, reject) {
      var maybePromisedErrors = props.validate(values, field);
      if (maybePromisedErrors == null) {
        // use loose null check here on purpose
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function (errors) {
          resolve(errors || emptyErrors);
        }, function (actualException) {
          if (process.env.NODE_ENV !== 'production') {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", actualException);
          }
          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props.validate]);
  /**
   * Run validation against a Yup schema and optionally run a function if successful
   */

  var runValidationSchema = useCallback(function (values, field) {
    var validationSchema = props.validationSchema;
    var schema = isFunction$4(validationSchema) ? validationSchema(field) : validationSchema;
    var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
    return new Promise(function (resolve, reject) {
      promise.then(function () {
        resolve(emptyErrors);
      }, function (err) {
        // Yup will throw a validation error if validation fails. We catch those and
        // resolve them into Formik errors. We can sniff if something is a Yup error
        // by checking error.name.
        // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
        if (err.name === 'ValidationError') {
          resolve(yupToFormErrors(err));
        } else {
          // We throw any other errors
          if (process.env.NODE_ENV !== 'production') {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", err);
          }
          reject(err);
        }
      });
    });
  }, [props.validationSchema]);
  var runSingleFieldLevelValidation = useCallback(function (field, value) {
    return new Promise(function (resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = useCallback(function (values) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function (f) {
      return isFunction$4(fieldRegistry.current[f].validate);
    }); // Construct an array with all of the field validation functions

    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f) {
      return runSingleFieldLevelValidation(f, getIn$1(values, f));
    }) : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')]; // use special case ;)

    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
          return prev;
        }
        if (curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }
        return prev;
      }, {});
    });
  }, [runSingleFieldLevelValidation]); // Run all validations and return the result

  var runAllValidations = useCallback(function (values) {
    return Promise.all([runFieldLevelValidations(values), props.validationSchema ? runValidationSchema(values) : {}, props.validate ? runValidateHandler(values) : {}]).then(function (_ref2) {
      var fieldErrors = _ref2[0],
        schemaErrors = _ref2[1],
        validateErrors = _ref2[2];
      var combinedErrors = deepmerge_1.all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge: arrayMerge
      });
      return combinedErrors;
    });
  }, [props.validate, props.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]); // Run all validations methods and update state accordingly

  var validateFormWithHighPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }
    dispatch({
      type: 'SET_ISVALIDATING',
      payload: true
    });
    return runAllValidations(values).then(function (combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
        dispatch({
          type: 'SET_ERRORS',
          payload: combinedErrors
        });
      }
      return combinedErrors;
    });
  });
  useEffect(function () {
    if (validateOnMount && isMounted.current === true && reactFastCompare(initialValues.current, props.initialValues)) {
      validateFormWithHighPriority(initialValues.current);
    }
  }, [validateOnMount, validateFormWithHighPriority]);
  var resetForm = useCallback(function (nextState) {
    var values = nextState && nextState.values ? nextState.values : initialValues.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
    initialValues.current = values;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;
    var dispatchFn = function dispatchFn() {
      dispatch({
        type: 'RESET_FORM',
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors: errors,
          touched: touched,
          status: status,
          values: values,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
        }
      });
    };
    if (props.onReset) {
      var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props.initialErrors, props.initialStatus, props.initialTouched, props.onReset]);
  useEffect(function () {
    if (isMounted.current === true && !reactFastCompare(initialValues.current, props.initialValues)) {
      if (enableReinitialize) {
        initialValues.current = props.initialValues;
        resetForm();
        if (validateOnMount) {
          validateFormWithHighPriority(initialValues.current);
        }
      }
    }
  }, [enableReinitialize, props.initialValues, resetForm, validateOnMount, validateFormWithHighPriority]);
  useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare(initialErrors.current, props.initialErrors)) {
      initialErrors.current = props.initialErrors || emptyErrors;
      dispatch({
        type: 'SET_ERRORS',
        payload: props.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props.initialErrors]);
  useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare(initialTouched.current, props.initialTouched)) {
      initialTouched.current = props.initialTouched || emptyTouched;
      dispatch({
        type: 'SET_TOUCHED',
        payload: props.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props.initialTouched]);
  useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare(initialStatus.current, props.initialStatus)) {
      initialStatus.current = props.initialStatus;
      dispatch({
        type: 'SET_STATUS',
        payload: props.initialStatus
      });
    }
  }, [enableReinitialize, props.initialStatus, props.initialTouched]);
  var validateField = useEventCallback(function (name) {
    // This will efficiently validate a single field by avoiding state
    // changes if the validation function is synchronous. It's different from
    // what is called when using validateForm.
    if (fieldRegistry.current[name] && isFunction$4(fieldRegistry.current[name].validate)) {
      var value = getIn$1(state.values, name);
      var maybePromise = fieldRegistry.current[name].validate(value);
      if (isPromise(maybePromise)) {
        // Only flip isValidating if the function is async.
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: true
        });
        return maybePromise.then(function (x) {
          return x;
        }).then(function (error) {
          dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
              field: name,
              value: error
            }
          });
          dispatch({
            type: 'SET_ISVALIDATING',
            payload: false
          });
        });
      } else {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props.validationSchema) {
      dispatch({
        type: 'SET_ISVALIDATING',
        payload: true
      });
      return runValidationSchema(state.values, name).then(function (x) {
        return x;
      }).then(function (error) {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: getIn$1(error, name)
          }
        });
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
      });
    }
    return Promise.resolve();
  });
  var registerField = useCallback(function (name, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name] = {
      validate: validate
    };
  }, []);
  var unregisterField = useCallback(function (name) {
    delete fieldRegistry.current[name];
  }, []);
  var setTouched = useEventCallback(function (touched, shouldValidate) {
    dispatch({
      type: 'SET_TOUCHED',
      payload: touched
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var setErrors = useCallback(function (errors) {
    dispatch({
      type: 'SET_ERRORS',
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function (values, shouldValidate) {
    var resolvedValues = isFunction$4(values) ? values(state.values) : values;
    dispatch({
      type: 'SET_VALUES',
      payload: resolvedValues
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
  });
  var setFieldError = useCallback(function (field, value) {
    dispatch({
      type: 'SET_FIELD_ERROR',
      payload: {
        field: field,
        value: value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function (field, value, shouldValidate) {
    var resolvedValue = isFunction$4(value) ? value(getIn$1(state.values, field)) : value;
    dispatch({
      type: 'SET_FIELD_VALUE',
      payload: {
        field: field,
        value: resolvedValue
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(setIn(state.values, field, resolvedValue)) : Promise.resolve();
  });
  var executeChange = useCallback(function (eventOrTextValue, maybePath) {
    // By default, assume that the first argument is a string. This allows us to use
    // handleChange with React Native and React Native Web's onChangeText prop which
    // provides just the value of the input.
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
    // so we handle like we would a normal HTML change event.

    if (!isString$1(eventOrTextValue)) {
      // If we can, persist the event
      // @see https://reactjs.org/docs/events.html#event-pooling
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }
      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type = target.type,
        name = target.name,
        id = target.id,
        value = target.value,
        checked = target.checked,
        outerHTML = target.outerHTML,
        options = target.options,
        multiple = target.multiple;
      field = maybePath ? maybePath : name ? name : id;
      if (!field && process.env.NODE_ENV !== "production") {
        warnAboutMissingIdentifier({
          htmlContent: outerHTML,
          documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
          handlerName: 'handleChange'
        });
      }
      val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
      ? getValueForCheckbox(getIn$1(state.values, field), checked, value) : options && multiple // <select multiple>
      ? getSelectedValues(options) : value;
    }
    if (field) {
      // Set form fields by name
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function (eventOrPath) {
    if (isString$1(eventOrPath)) {
      return function (event) {
        return executeChange(event, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function (field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }
    dispatch({
      type: 'SET_FIELD_TOUCHED',
      payload: {
        field: field,
        value: touched
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var executeBlur = useCallback(function (e, path) {
    if (e.persist) {
      e.persist();
    }
    var _e$target = e.target,
      name = _e$target.name,
      id = _e$target.id,
      outerHTML = _e$target.outerHTML;
    var field = path ? path : name ? name : id;
    if (!field && process.env.NODE_ENV !== "production") {
      warnAboutMissingIdentifier({
        htmlContent: outerHTML,
        documentationAnchorLink: 'handleblur-e-any--void',
        handlerName: 'handleBlur'
      });
    }
    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function (eventOrString) {
    if (isString$1(eventOrString)) {
      return function (event) {
        return executeBlur(event, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = useCallback(function (stateOrCb) {
    if (isFunction$4(stateOrCb)) {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = useCallback(function (status) {
    dispatch({
      type: 'SET_STATUS',
      payload: status
    });
  }, []);
  var setSubmitting = useCallback(function (isSubmitting) {
    dispatch({
      type: 'SET_ISSUBMITTING',
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function () {
    dispatch({
      type: 'SUBMIT_ATTEMPT'
    });
    return validateFormWithHighPriority().then(function (combinedErrors) {
      // In case an error was thrown and passed to the resolved Promise,
      // `combinedErrors` can be an instance of an Error. We need to check
      // that and abort the submit.
      // If we don't do that, calling `Object.keys(new Error())` yields an
      // empty array, which causes the validation to pass and the form
      // to be submitted.
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
      if (isActuallyValid) {
        // Proceed with submit...
        //
        // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
        // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
        // This would be fine in simple cases, but make it impossible to disable submit
        // buttons where people use callbacks or promises as side effects (which is basically
        // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
        //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
        // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
        // cleanup of isSubmitting on behalf of the consumer.
        var promiseOrUndefined;
        try {
          promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
          // via setSubmitting(false)

          if (promiseOrUndefined === undefined) {
            return;
          }
        } catch (error) {
          throw error;
        }
        return Promise.resolve(promiseOrUndefined).then(function (result) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_SUCCESS'
            });
          }
          return result;
        })["catch"](function (_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_FAILURE'
            }); // This is a legit error rejected by the onSubmit fn
            // so we don't want to break the promise chain

            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        // ^^^ Make sure Formik is still mounted before updating state
        dispatch({
          type: 'SUBMIT_FAILURE'
        }); // throw combinedErrors;

        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }
      return;
    });
  });
  var handleSubmit = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction$4(e.preventDefault)) {
      e.preventDefault();
    }
    if (e && e.stopPropagation && isFunction$4(e.stopPropagation)) {
      e.stopPropagation();
    } // Warn if form submission is triggered by a <button> without a
    // specified `type` attribute during development. This mitigates
    // a common gotcha in forms with both reset and submit buttons,
    // where the dev forgets to add type="button" to the reset button.

    if (process.env.NODE_ENV !== "production" && typeof document !== 'undefined') {
      // Safely get the active element (works with IE)
      var activeElement = getActiveElement$1();
      if (activeElement !== null && activeElement instanceof HTMLButtonElement) {
        !(activeElement.attributes && activeElement.attributes.getNamedItem('type')) ? process.env.NODE_ENV !== "production" ? warning(false, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : warning(false) : void 0;
      }
    }
    submitForm()["catch"](function (reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm: resetForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    setErrors: setErrors,
    setFieldError: setFieldError,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    setFormikState: setFormikState,
    submitForm: submitForm
  };
  var executeSubmit = useEventCallback(function () {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction$4(e.preventDefault)) {
      e.preventDefault();
    }
    if (e && e.stopPropagation && isFunction$4(e.stopPropagation)) {
      e.stopPropagation();
    }
    resetForm();
  });
  var getFieldMeta = useCallback(function (name) {
    return {
      value: getIn$1(state.values, name),
      error: getIn$1(state.errors, name),
      touched: !!getIn$1(state.touched, name),
      initialValue: getIn$1(initialValues.current, name),
      initialTouched: !!getIn$1(initialTouched.current, name),
      initialError: getIn$1(initialErrors.current, name)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = useCallback(function (name) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name, value, shouldValidate);
      },
      setTouched: function setTouched(value, shouldValidate) {
        return setFieldTouched(name, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = useCallback(function (nameOrOptions) {
    var isAnObject = isObject$5(nameOrOptions);
    var name = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn$1(state.values, name);
    var field = {
      name: name,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };
    if (isAnObject) {
      var type = nameOrOptions.type,
        valueProp = nameOrOptions.value,
        is = nameOrOptions.as,
        multiple = nameOrOptions.multiple;
      if (type === 'checkbox') {
        if (valueProp === undefined) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type === 'radio') {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is === 'select' && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }
    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = useMemo(function () {
    return !reactFastCompare(initialValues.current, state.values);
  }, [initialValues.current, state.values]);
  var isValid = useMemo(function () {
    return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction$4(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props]);
  var ctx = _extends$5({}, state, {
    initialValues: initialValues.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur: handleBlur,
    handleChange: handleChange,
    handleReset: handleReset,
    handleSubmit: handleSubmit,
    resetForm: resetForm,
    setErrors: setErrors,
    setFormikState: setFormikState,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setFieldError: setFieldError,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    submitForm: submitForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    isValid: isValid,
    dirty: dirty,
    unregisterField: unregisterField,
    registerField: registerField,
    getFieldProps: getFieldProps,
    getFieldMeta: getFieldMeta,
    getFieldHelpers: getFieldHelpers,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount
  });
  return ctx;
}
function Formik(props) {
  var formikbag = useFormik(props);
  var component = props.component,
    children = props.children,
    render = props.render,
    innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />

  useImperativeHandle(innerRef, function () {
    return formikbag;
  });
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      !!props.render ? process.env.NODE_ENV !== "production" ? warning(false, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : warning(false) : void 0; // eslint-disable-next-line
    }, []);
  }
  return createElement(FormikProvider, {
    value: formikbag
  }, component ? createElement(component, formikbag) : render ? render(formikbag) : children // children come last, always called
  ? isFunction$4(children) ? children(formikbag) : !isEmptyChildren(children) ? Children.only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent,
    documentationAnchorLink = _ref4.documentationAnchorLink,
    handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */

function yupToFormErrors(yupError) {
  var errors = {};
  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }
    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;
      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }
      var err = _ref5;
      if (!getIn$1(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }
  return errors;
}
/**
 * Validate a yup schema.
 */

function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }
  var normalizedValues = prepareDataForValidation(values);
  return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
    abortEarly: false,
    context: context || normalizedValues
  });
}
/**
 * Recursively prepare values.
 */

function prepareDataForValidation(values) {
  var data = Array.isArray(values) ? [] : {};
  for (var k in values) {
    if (Object.prototype.hasOwnProperty.call(values, k)) {
      var key = String(k);
      if (Array.isArray(values[key]) === true) {
        data[key] = values[key].map(function (value) {
          if (Array.isArray(value) === true || isPlainObject$1(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== '' ? value : undefined;
          }
        });
      } else if (isPlainObject$1(values[key])) {
        data[key] = prepareDataForValidation(values[key]);
      } else {
        data[key] = values[key] !== '' ? values[key] : undefined;
      }
    }
  }
  return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */

function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function merge(e, i) {
    if (typeof destination[i] === 'undefined') {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? deepmerge_1(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = deepmerge_1(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}
/** Return multi select values based on an array of options */

function getSelectedValues(options) {
  return Array.from(options).filter(function (el) {
    return el.selected;
  }).map(function (el) {
    return el.value;
  });
}
/** Return the next value for a checkbox */

function getValueForCheckbox(currentValue, checked, valueProp) {
  // If the current value was a boolean, return a boolean
  if (typeof currentValue === 'boolean') {
    return Boolean(checked);
  } // If the currentValue was not a boolean we want to return an array

  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index = -1;
  if (!Array.isArray(currentValue)) {
    // eslint-disable-next-line eqeqeq
    if (!valueProp || valueProp == 'true' || valueProp == 'false') {
      return Boolean(checked);
    }
  } else {
    // If the current value is already an array, use it
    currentArrayOfValues = currentValue;
    index = currentValue.indexOf(valueProp);
    isValueInArray = index >= 0;
  } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values

  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  } // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values

  if (!isValueInArray) {
    return currentArrayOfValues;
  } // If the checkbox was unchecked and the value is in the array, remove the value and return the array

  return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85

var useIsomorphicLayoutEffect$1 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;
function useEventCallback(fn) {
  var ref = useRef(fn); // we copy a ref to the callback scoped to the current state/props on each render

  useIsomorphicLayoutEffect$1(function () {
    ref.current = fn;
  });
  return useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current.apply(void 0, args);
  }, []);
}
function Field(_ref) {
  var validate = _ref.validate,
    name = _ref.name,
    render = _ref.render,
    children = _ref.children,
    is = _ref.as,
    component = _ref.component,
    className = _ref.className,
    props = _objectWithoutPropertiesLoose$2(_ref, ["validate", "name", "render", "children", "as", "component", "className"]);
  var _useFormikContext = useFormikContext(),
    formik = _objectWithoutPropertiesLoose$2(_useFormikContext, ["validate", "validationSchema"]);
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      !!render ? process.env.NODE_ENV !== "production" ? warning(false, "<Field render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Field name=\"" + name + "\" render={({field, form}) => ...} /> with <Field name=\"" + name + "\">{({field, form, meta}) => ...}</Field>") : warning(false) : void 0;
      !!(is && children && isFunction$4(children)) ? process.env.NODE_ENV !== "production" ? warning(false, 'You should not use <Field as> and <Field children> as a function in the same <Field> component; <Field as> will be ignored.') : warning(false) : void 0;
      !!(component && children && isFunction$4(children)) ? process.env.NODE_ENV !== "production" ? warning(false, 'You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.') : warning(false) : void 0;
      !!(render && children && !isEmptyChildren(children)) ? process.env.NODE_ENV !== "production" ? warning(false, 'You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored') : warning(false) : void 0; // eslint-disable-next-line
    }, []);
  } // Register field and field-level validation with parent <Formik>

  var registerField = formik.registerField,
    unregisterField = formik.unregisterField;
  useEffect(function () {
    registerField(name, {
      validate: validate
    });
    return function () {
      unregisterField(name);
    };
  }, [registerField, unregisterField, name, validate]);
  var field = formik.getFieldProps(_extends$5({
    name: name
  }, props));
  var meta = formik.getFieldMeta(name);
  var legacyBag = {
    field: field,
    form: formik
  };
  if (render) {
    return render(_extends$5({}, legacyBag, {
      meta: meta
    }));
  }
  if (isFunction$4(children)) {
    return children(_extends$5({}, legacyBag, {
      meta: meta
    }));
  }
  if (component) {
    // This behavior is backwards compat with earlier Formik 0.9 to 1.x
    if (typeof component === 'string') {
      var innerRef = props.innerRef,
        rest = _objectWithoutPropertiesLoose$2(props, ["innerRef"]);
      return createElement(component, _extends$5({
        ref: innerRef
      }, field, rest, {
        className: className
      }), children);
    } // We don't pass `meta` for backwards compat

    return createElement(component, _extends$5({
      field: field,
      form: formik
    }, props, {
      className: className
    }), children);
  } // default to input here so we can check for both `as` and `children` above

  var asElement = is || 'input';
  if (typeof asElement === 'string') {
    var _innerRef = props.innerRef,
      _rest = _objectWithoutPropertiesLoose$2(props, ["innerRef"]);
    return createElement(asElement, _extends$5({
      ref: _innerRef
    }, field, _rest, {
      className: className
    }), children);
  }
  return createElement(asElement, _extends$5({}, field, props, {
    className: className
  }), children);
}
var Form$1 = /*#__PURE__*/forwardRef(function (props, ref) {
  // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
  // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
  var action = props.action,
    rest = _objectWithoutPropertiesLoose$2(props, ["action"]);
  var _action = action != null ? action : '#';
  var _useFormikContext = useFormikContext(),
    handleReset = _useFormikContext.handleReset,
    handleSubmit = _useFormikContext.handleSubmit;
  return createElement("form", _extends$5({
    onSubmit: handleSubmit,
    ref: ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form$1.displayName = 'Form';

/**
 * Some array helpers!
 */

var move = function move(array, from, to) {
  var copy = copyArrayLike(array);
  var value = copy[from];
  copy.splice(from, 1);
  copy.splice(to, 0, value);
  return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
  var copy = copyArrayLike(arrayLike);
  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};
var insert = function insert(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy.splice(index, 0, value);
  return copy;
};
var replace = function replace(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy[index] = value;
  return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
  if (!arrayLike) {
    return [];
  } else if (Array.isArray(arrayLike)) {
    return [].concat(arrayLike);
  } else {
    var maxIndex = Object.keys(arrayLike).map(function (key) {
      return parseInt(key);
    }).reduce(function (max, el) {
      return el > max ? el : max;
    }, 0);
    return Array.from(_extends$5({}, arrayLike, {
      length: maxIndex + 1
    }));
  }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
  var fn = typeof alteration === 'function' ? alteration : defaultFunction;
  return function (data) {
    if (Array.isArray(data) || isObject$5(data)) {
      var clone = copyArrayLike(data);
      return fn(clone);
    } // This can be assumed to be a primitive, which
    // is a case for top level validation errors

    return data;
  };
};
var FieldArrayInner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(FieldArrayInner, _React$Component);
  function FieldArrayInner(props) {
    var _this;
    _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
    // @todo Fix TS 3.2.1

    _this.updateArrayField = function (fn, alterTouched, alterErrors) {
      var _this$props = _this.props,
        name = _this$props.name,
        setFormikState = _this$props.formik.setFormikState;
      setFormikState(function (prevState) {
        var updateErrors = createAlterationHandler(alterErrors, fn);
        var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
        // otherwise it causes an error with unshift.

        var values = setIn(prevState.values, name, fn(getIn$1(prevState.values, name)));
        var fieldError = alterErrors ? updateErrors(getIn$1(prevState.errors, name)) : undefined;
        var fieldTouched = alterTouched ? updateTouched(getIn$1(prevState.touched, name)) : undefined;
        if (isEmptyArray(fieldError)) {
          fieldError = undefined;
        }
        if (isEmptyArray(fieldTouched)) {
          fieldTouched = undefined;
        }
        return _extends$5({}, prevState, {
          values: values,
          errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
          touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
        });
      });
    };
    _this.push = function (value) {
      return _this.updateArrayField(function (arrayLike) {
        return [].concat(copyArrayLike(arrayLike), [cloneDeep(value)]);
      }, false, false);
    };
    _this.handlePush = function (value) {
      return function () {
        return _this.push(value);
      };
    };
    _this.swap = function (indexA, indexB) {
      return _this.updateArrayField(function (array) {
        return swap(array, indexA, indexB);
      }, true, true);
    };
    _this.handleSwap = function (indexA, indexB) {
      return function () {
        return _this.swap(indexA, indexB);
      };
    };
    _this.move = function (from, to) {
      return _this.updateArrayField(function (array) {
        return move(array, from, to);
      }, true, true);
    };
    _this.handleMove = function (from, to) {
      return function () {
        return _this.move(from, to);
      };
    };
    _this.insert = function (index, value) {
      return _this.updateArrayField(function (array) {
        return insert(array, index, value);
      }, function (array) {
        return insert(array, index, null);
      }, function (array) {
        return insert(array, index, null);
      });
    };
    _this.handleInsert = function (index, value) {
      return function () {
        return _this.insert(index, value);
      };
    };
    _this.replace = function (index, value) {
      return _this.updateArrayField(function (array) {
        return replace(array, index, value);
      }, false, false);
    };
    _this.handleReplace = function (index, value) {
      return function () {
        return _this.replace(index, value);
      };
    };
    _this.unshift = function (value) {
      var length = -1;
      _this.updateArrayField(function (array) {
        var arr = array ? [value].concat(array) : [value];
        length = arr.length;
        return arr;
      }, function (array) {
        return array ? [null].concat(array) : [null];
      }, function (array) {
        return array ? [null].concat(array) : [null];
      });
      return length;
    };
    _this.handleUnshift = function (value) {
      return function () {
        return _this.unshift(value);
      };
    };
    _this.handleRemove = function (index) {
      return function () {
        return _this.remove(index);
      };
    };
    _this.handlePop = function () {
      return function () {
        return _this.pop();
      };
    };
    _this.remove = _this.remove.bind(_assertThisInitialized(_this));
    _this.pop = _this.pop.bind(_assertThisInitialized(_this));
    return _this;
  }
  var _proto = FieldArrayInner.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.validateOnChange && this.props.formik.validateOnChange && !reactFastCompare(getIn$1(prevProps.formik.values, prevProps.name), getIn$1(this.props.formik.values, this.props.name))) {
      this.props.formik.validateForm(this.props.formik.values);
    }
  };
  _proto.remove = function remove(index) {
    // We need to make sure we also remove relevant pieces of `touched` and `errors`
    var result;
    this.updateArrayField(
    // so this gets call 3 times
    function (array) {
      var copy = array ? copyArrayLike(array) : [];
      if (!result) {
        result = copy[index];
      }
      if (isFunction$4(copy.splice)) {
        copy.splice(index, 1);
      } // if the array only includes undefined values we have to return an empty array

      return isFunction$4(copy.every) ? copy.every(function (v) {
        return v === undefined;
      }) ? [] : copy : copy;
    }, true, true);
    return result;
  };
  _proto.pop = function pop() {
    // Remove relevant pieces of `touched` and `errors` too!
    var result;
    this.updateArrayField(
    // so this gets call 3 times
    function (array) {
      var tmp = array.slice();
      if (!result) {
        result = tmp && tmp.pop && tmp.pop();
      }
      return tmp;
    }, true, true);
    return result;
  };
  _proto.render = function render() {
    var arrayHelpers = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    };
    var _this$props2 = this.props,
      component = _this$props2.component,
      render = _this$props2.render,
      children = _this$props2.children,
      name = _this$props2.name,
      _this$props2$formik = _this$props2.formik,
      restOfFormik = _objectWithoutPropertiesLoose$2(_this$props2$formik, ["validate", "validationSchema"]);
    var props = _extends$5({}, arrayHelpers, {
      form: restOfFormik,
      name: name
    });
    return component ? createElement(component, props) : render ? render(props) : children // children come last, always called
    ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? Children.only(children) : null : null;
  };
  return FieldArrayInner;
}(Component);
FieldArrayInner.defaultProps = {
  validateOnChange: true
};
var styles$A = {
  "input": "controls-module_input__LYDlY",
  "error": "controls-module_error__6D3k3",
  "container": "controls-module_container__docsH",
  "label": "controls-module_label__41UVA",
  "labelText": "controls-module_labelText__g6apB",
  "optional": "controls-module_optional__q-epj"
};
var WarningControl = function WarningControl(_ref37) {
  var placeholder = _ref37.placeholder;
  return React$2.createElement(WarningAlert, {
    className: styles$A.container,
    title: placeholder
  });
};
var TextControl = function TextControl(_ref38) {
  var placeholder = _ref38.placeholder;
  var _useThemeContext8 = useThemeContext(),
    _useThemeContext8$for = _useThemeContext8.form.body,
    _useThemeContext8$for2 = _useThemeContext8$for === void 0 ? DefaultFormBodyModel : _useThemeContext8$for,
    text = _useThemeContext8$for2.text;
  return React$2.createElement("div", {
    className: styles$A.container
  }, React$2.createElement(Notice, {
    style: text
  }, placeholder));
};

// Display-only sentence, like TextControl (Plain text), but rendered with the
// Body_2 variant in black so it matches the font, size & colour of the
// Checkbox control's label rather than the themed Notice styling.
var AdditionalInformationControl = function AdditionalInformationControl(_ref39) {
  var placeholder = _ref39.placeholder;
  return React$2.createElement("div", {
    className: styles$A.container
  }, React$2.createElement(Body_2, {
    style: {
      color: '#000000'
    }
  }, placeholder));
};
var styles$z = {
  "error": "control-error-module_error__MNWjC",
  "visible": "control-error-module_visible__x9v7B",
  "hidden": "control-error-module_hidden__l73En"
};
var ControlError = function ControlError(_ref40) {
  var message = _ref40.message,
    style = _ref40.style;
  var _useThemeContext9 = useThemeContext(),
    _useThemeContext9$for = _useThemeContext9.form.body,
    _useThemeContext9$for2 = _useThemeContext9$for === void 0 ? DefaultFormBodyModel : _useThemeContext9$for,
    error = _useThemeContext9$for2.error;
  return React$2.createElement(FormError, {
    style: Object.assign({
      color: error === null || error === void 0 ? void 0 : error.color
    }, style),
    className: classnames(styles$z.error, message === '' ? styles$z.hidden : styles$z.visible)
  }, message);
};
var styles$y = {
  "container": "info-tooltip-module_container__YyV23",
  "button": "info-tooltip-module_button__-VQnC",
  "icon": "info-tooltip-module_icon__ca3k4",
  "bubble": "info-tooltip-module_bubble__JNloT"
};
var idCounter$1 = 0;
var InfoTooltip = function InfoTooltip(_ref41) {
  var text = _ref41.text,
    _ref41$label = _ref41.label,
    label = _ref41$label === void 0 ? 'More information' : _ref41$label;
  var _useState12 = useState(false),
    _useState13 = _slicedToArray(_useState12, 2),
    open = _useState13[0],
    setOpen = _useState13[1];
  var containerRef = useRef(null);
  var idRef = useRef("info-tooltip-".concat(idCounter$1 += 1));
  var id = idRef.current;
  useEffect(function () {
    if (!open) return undefined;
    var handlePointer = function handlePointer(event) {
      var _a;
      if (!((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
        setOpen(false);
      }
    };
    var handleKey = function handleKey(event) {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', handlePointer);
    document.addEventListener('touchstart', handlePointer);
    document.addEventListener('keydown', handleKey);
    return function () {
      document.removeEventListener('mousedown', handlePointer);
      document.removeEventListener('touchstart', handlePointer);
      document.removeEventListener('keydown', handleKey);
    };
  }, [open]);
  return React$2.createElement("span", {
    className: styles$y.container,
    ref: containerRef,
    onMouseEnter: function onMouseEnter() {
      setOpen(true);
    },
    onMouseLeave: function onMouseLeave() {
      setOpen(false);
    }
  }, React$2.createElement("button", {
    type: "button",
    className: styles$y.button,
    "aria-label": label,
    "aria-expanded": open,
    "aria-describedby": open ? id : undefined,
    onClick: function onClick() {
      setOpen(function (prev) {
        return !prev;
      });
    },
    onFocus: function onFocus() {
      setOpen(true);
    },
    onBlur: function onBlur() {
      setOpen(false);
    }
  }, React$2.createElement("svg", {
    className: styles$y.icon,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    focusable: "false"
  }, React$2.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "7.25",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }), React$2.createElement("circle", {
    cx: "8",
    cy: "4.75",
    r: "0.95",
    fill: "currentColor"
  }), React$2.createElement("path", {
    d: "M8 7.25v4.25",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }))), open && React$2.createElement("span", {
    role: "tooltip",
    id: id,
    className: styles$y.bubble
  }, text));
};
var StringControl = function StringControl(_ref42) {
  var name = _ref42.name,
    placeholder = _ref42.placeholder,
    _ref42$error = _ref42.error,
    errorMessage = _ref42$error === void 0 ? '' : _ref42$error,
    _ref42$displayOptiona = _ref42.displayOptional,
    displayOptional = _ref42$displayOptiona === void 0 ? false : _ref42$displayOptiona,
    optional = _ref42.optional,
    placeholderAttribute = _ref42.placeholderAttribute,
    info = _ref42.info,
    _onChange2 = _ref42.onChange;
  var _useThemeContext0 = useThemeContext(),
    _useThemeContext0$for = _useThemeContext0.form.body,
    _useThemeContext0$for2 = _useThemeContext0$for === void 0 ? DefaultFormBodyModel : _useThemeContext0$for,
    error = _useThemeContext0$for2.error,
    borderColor = _useThemeContext0$for2.borderColor;
  var _useFormikContext2 = useFormikContext(),
    handleChange = _useFormikContext2.handleChange;
  var style = {
    borderColor: errorMessage ? error === null || error === void 0 ? void 0 : error.color : borderColor,
    fontFamily: 'inherit'
  };
  return React$2.createElement(Body_2, null, React$2.createElement("label", {
    htmlFor: name
  }, React$2.createElement("div", {
    className: styles$A.label
  }, React$2.createElement("span", {
    className: styles$A.labelText
  }, placeholder, info && React$2.createElement(InfoTooltip, {
    text: info
  })), optional && displayOptional && React$2.createElement("span", {
    className: styles$A.optional
  }, "Optional"))), React$2.createElement(Field, Object.assign({
    type: "string",
    id: name,
    name: name,
    style: style,
    className: styles$A.input,
    "data-testid": name,
    placeholder: placeholderAttribute
  }, _onChange2 ? {
    onChange: function onChange(e) {
      handleChange(e);
      _onChange2();
    }
  } : {})), React$2.createElement(ControlError, {
    message: errorMessage
  }));
};
var ElementType;
(function (ElementType) {
  ElementType["String"] = "string";
  ElementType["Dropdown"] = "dropdown";
  ElementType["Checkbox"] = "checkbox";
  ElementType["Hidden"] = "hidden";
  ElementType["Text"] = "text";
  ElementType["AdditionalInformation"] = "additionalInformation";
  ElementType["Warning"] = "warning";
  ElementType["Markdown"] = "markdown";
  ElementType["Address"] = "address";
  ElementType["TextArea"] = "textarea";
  ElementType["Date"] = "date";
})(ElementType || (ElementType = {}));
var styles$x = {
  "dropdown": "dropdown-control-module_dropdown__KnlXn"
};
var DropdownControl = function DropdownControl(_ref43) {
  var name = _ref43.name,
    placeholder = _ref43.placeholder,
    choices = _ref43.choices,
    outOfStock = _ref43.outOfStock,
    _ref43$error = _ref43.error,
    errorMessage = _ref43$error === void 0 ? '' : _ref43$error,
    _ref43$showLabel = _ref43.showLabel,
    showLabel = _ref43$showLabel === void 0 ? true : _ref43$showLabel;
  var _useThemeContext1 = useThemeContext(),
    _useThemeContext1$for = _useThemeContext1.form.body,
    _useThemeContext1$for2 = _useThemeContext1$for === void 0 ? DefaultFormBodyModel : _useThemeContext1$for,
    error = _useThemeContext1$for2.error,
    borderColor = _useThemeContext1$for2.borderColor;
  var style = {
    borderColor: errorMessage ? error === null || error === void 0 ? void 0 : error.color : borderColor,
    fontFamily: 'inherit',
    zIndex: 9999999
  };
  return React$2.createElement(Body_2, null, showLabel && React$2.createElement("label", {
    htmlFor: name
  }, placeholder), React$2.createElement(Field, {
    as: "select",
    id: name,
    name: name,
    style: style,
    className: classnames(styles$x.dropdown, styles$A.input),
    placeholder: placeholder
  }, React$2.createElement("option", {
    value: placeholder
  }, placeholder), choices && choices.map(function (choice) {
    var _a;
    // Legacy JavaScript consumers may omit choicesOOS.
    // oxlint-disable-next-line typescript/no-unnecessary-condition
    var isOutOfStock = (_a = outOfStock === null || outOfStock === void 0 ? void 0 : outOfStock.choicesOOS) === null || _a === void 0 ? void 0 : _a.some(function (entry) {
      return entry.name === choice;
    });
    return React$2.createElement("option", {
      key: choice,
      value: choice,
      disabled: isOutOfStock
    }, isOutOfStock ? "".concat(choice, " - Out Of Stock").concat((outOfStock === null || outOfStock === void 0 ? void 0 : outOfStock.message) ? " [".concat(outOfStock.message, "]") : '') : choice);
  })), React$2.createElement(ControlError, {
    message: errorMessage
  }));
};
var styles$w = {
  "container": "link-module_container__mEG1w",
  "link": "link-module_link__p-Mf-"
};
var Link = function Link(_ref44) {
  var _ref44$typography = _ref44.typography,
    typography = _ref44$typography === void 0 ? TypographyVariant.Body_1 : _ref44$typography,
    _onClick3 = _ref44.onClick,
    className = _ref44.className,
    style = _ref44.style,
    label = _ref44.label;
  return React$2.createElement("div", {
    style: style,
    className: styles$w.container,
    onClick: function onClick() {
      if (_onClick3) {
        _onClick3();
      }
    }
  }, React$2.createElement(Typography, {
    className: classnames(styles$w.link, className),
    variant: typography
  }, label));
};
var styles$v = {
  "container": "cookie-banner-module_container__HqC0d",
  "content": "cookie-banner-module_content__DvkcF",
  "copy": "cookie-banner-module_copy__wluJj",
  "button": "cookie-banner-module_button__jw1J7",
  "buttons": "cookie-banner-module_buttons__lbXQ5"
};
var CookieBanner = function CookieBanner(_ref45) {
  var onAcceptAll = _ref45.onAcceptAll,
    onDenyAll = _ref45.onDenyAll,
    onMoreInfo = _ref45.onMoreInfo;
  var _useThemeContext10 = useThemeContext(),
    secondary = _useThemeContext10.button.secondary,
    cookieBanner = _useThemeContext10.cookieBanner;
  var privacyPolicyUrl = 'https://www.huggg.me/privacy';
  var infoSecurityPolicyUrl = 'https://www.huggg.me/information-security-policy';
  var getExternalLinkHandler = function getExternalLinkHandler(url) {
    return function () {
      window.open(url);
    };
  };
  return React$2.createElement("div", {
    className: styles$v.container
  }, React$2.createElement("div", {
    className: styles$v.content
  }, React$2.createElement(Heading_1, null, cookieBanner.heading), React$2.createElement(Body_1, {
    className: styles$v.copy
  }, cookieBanner.body, " For more information see our", ' ', React$2.createElement(Link, {
    onClick: getExternalLinkHandler(privacyPolicyUrl),
    label: "privacy policy"
  }), ' ', "or", ' ', React$2.createElement(Link, {
    onClick: getExternalLinkHandler(infoSecurityPolicyUrl),
    label: "information security policy"
  }), ' ', "or see ", React$2.createElement(Link, {
    onClick: onMoreInfo,
    label: "here"
  }), " for more detailed information about the cookies we use."), React$2.createElement("div", {
    className: styles$v.buttons
  }, React$2.createElement(SecondaryButton, {
    arrow: ButtonArrowState.None,
    className: styles$v.button,
    style: {
      border: "1px solid ".concat(String(secondary === null || secondary === void 0 ? void 0 : secondary.foreground))
    },
    label: cookieBanner.deny,
    onClick: onDenyAll
  }), React$2.createElement(PrimaryButton, {
    arrow: ButtonArrowState.None,
    className: styles$v.button,
    label: cookieBanner.accept,
    onClick: onAcceptAll
  }))));
};
var styles$u = {
  "container": "modal-module_container__2LT2s",
  "background": "modal-module_background__GjkbX",
  "content": "modal-module_content__CbyPM",
  "title": "modal-module_title__fVrJu",
  "closeCross": "modal-module_closeCross__QplNT",
  "children": "modal-module_children__9a8Ip"
};
var Modal = function Modal(_ref46) {
  var title = _ref46.title,
    children = _ref46.children,
    onClose = _ref46.onClose,
    className = _ref46.className;
  return React$2.createElement(React$2.Fragment, null, createPortal(React$2.createElement(Body_2, {
    className: classnames(className, styles$u.container)
  }, React$2.createElement("div", {
    "data-testid": "modal-background",
    className: styles$u.background,
    onClick: onClose
  }), React$2.createElement("div", {
    className: styles$u.content
  }, React$2.createElement(Heading_3, {
    className: styles$u.title
  }, React$2.createElement("div", null, title, ' ', React$2.createElement(CloseCross, {
    onClick: onClose,
    className: styles$u.closeCross
  }))), React$2.createElement("div", {
    className: styles$u.children
  }, children))), document.body));
};
var Panel = function Panel(_ref47) {
  var className = _ref47.className,
    style = _ref47.style,
    children = _ref47.children;
  var _useThemeContext11 = useThemeContext(),
    panel = _useThemeContext11.panel;
  return React$2.createElement("pre", {
    style: Object.assign({
      backgroundColor: panel.background,
      padding: '16px',
      overflow: 'scroll'
    }, style),
    className: className
  }, React$2.createElement(Body_2, null, children));
};
var styles$t = {
  "container": "toggle-module_container__iNaL6",
  "background": "toggle-module_background__VGa7S",
  "active": "toggle-module_active__bPy9u",
  "disabled": "toggle-module_disabled__Vaivg",
  "handle": "toggle-module_handle__P7d-v",
  "checked": "toggle-module_checked__LEthZ"
};
var Toggle = function Toggle(_ref48) {
  var onChange = _ref48.onChange,
    _ref48$value = _ref48.value,
    value = _ref48$value === void 0 ? false : _ref48$value,
    _ref48$disabled = _ref48.disabled,
    disabled = _ref48$disabled === void 0 ? false : _ref48$disabled;
  var _useThemeContext12 = useThemeContext(),
    name = _useThemeContext12.name;
  var b2gColor = '#A9B9DF';
  var b2bColor = '#facbd7';
  // TODO should be a primary color or smtng in the theme
  var primaryColor = name === 'default' ? b2bColor : b2gColor;
  var onToggleChange = function onToggleChange() {
    if (disabled) {
      return;
    }
    if (onChange) {
      onChange(!value);
    }
  };
  return React$2.createElement("div", {
    className: styles$t.container
  }, React$2.createElement("input", {
    type: "checkbox",
    checked: value,
    onChange: onToggleChange
  }), React$2.createElement("button", {
    "data-testid": "toggle",
    className: classnames(styles$t.background, disabled ? styles$t.disabled : styles$t.active),
    style: value ? {
      backgroundColor: primaryColor
    } : {},
    onClick: onToggleChange
  }, React$2.createElement("div", {
    className: classnames(styles$t.handle, _defineProperty2(_defineProperty2({}, styles$t.checked, value), styles$t.disabled, disabled))
  })));
};
var styles$s = {
  "container": "cookie-details-modal-module_container__Iu-p4",
  "categoryHeading": "cookie-details-modal-module_categoryHeading__qJsbU",
  "detailsContainer": "cookie-details-modal-module_detailsContainer__T8TTQ",
  "cookieDetails": "cookie-details-modal-module_cookieDetails__8VVSM",
  "bold": "cookie-details-modal-module_bold__MUThK"
};
var CookieCategoryDetails = function CookieCategoryDetails(_ref49) {
  var cookies = _ref49.cookies;
  return React$2.createElement(Body_3, {
    className: styles$s.detailsContainer
  }, cookies.map(function (_ref50) {
    var name = _ref50.name,
      provider = _ref50.provider,
      description = _ref50.description,
      expiry = _ref50.expiry;
    return React$2.createElement("div", {
      className: styles$s.cookieDetails,
      key: name
    }, React$2.createElement(Body_4, {
      className: styles$s.bold
    }, name), "\xA0from\xA0", React$2.createElement(Body_4, {
      className: styles$s.bold
    }, provider, "."), description && " ".concat(description), ".", expiry && React$2.createElement(React$2.Fragment, null, "\xA0Expiry:\xA0", React$2.createElement(Body_4, {
      className: styles$s.bold
    }, " ", expiry, ".")));
  }));
};
var CookieDetailsModal = function CookieDetailsModal(_ref51) {
  var model = _ref51.model,
    enabled = _ref51.enabled,
    onClose = _ref51.onClose,
    _onChange3 = _ref51.onChange;
  return React$2.createElement(Modal, {
    onClose: onClose,
    title: "COOKIE DETAILS"
  }, React$2.createElement("div", {
    className: styles$s.container
  }, Object.entries(model).map(function (_ref52) {
    var _ref53 = _slicedToArray(_ref52, 2),
      key = _ref53[0],
      value = _ref53[1];
    return React$2.createElement(Panel, {
      key: key,
      style: {
        backgroundColor: '#E6E6E6',
        margin: '1em 0'
      }
    }, React$2.createElement(Heading_1, {
      className: styles$s.categoryHeading,
      key: key
    }, React$2.createElement("span", null, key), React$2.createElement(Toggle, {
      value: enabled[key],
      disabled: key === 'essential',
      onChange: function onChange(value) {
        _onChange3(key, value);
      }
    })), React$2.createElement("span", null, value.description), React$2.createElement("div", {
      style: {
        paddingTop: '1rem'
      }
    }, React$2.createElement(Accordion, {
      rows: [{
        heading: 'cookies',
        children: React$2.createElement(CookieCategoryDetails, {
          cookies: value.cookies
        })
      }]
    })));
  })));
};
var eventemitter3 = {
  exports: {}
};
(function (module) {
  var has = Object.prototype.hasOwnProperty,
    prefix = '~';

  /**
   * Constructor to create a storage for our `EE` objects.
   * An `Events` instance is a plain object whose properties are event names.
   *
   * @constructor
   * @private
   */
  function Events() {}

  //
  // We try to not inherit from `Object.prototype`. In some engines creating an
  // instance in this way is faster than calling `Object.create(null)` directly.
  // If `Object.create(null)` is not supported we prefix the event names with a
  // character to make sure that the built-in object properties are not
  // overridden or used as an attack vector.
  //
  if (Object.create) {
    Events.prototype = Object.create(null);

    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
  }

  /**
   * Representation of a single event listener.
   *
   * @param {Function} fn The listener function.
   * @param {*} context The context to invoke the listener with.
   * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
   * @constructor
   * @private
   */
  function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
  }

  /**
   * Add a listener for a given event.
   *
   * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn The listener function.
   * @param {*} context The context to invoke the listener with.
   * @param {Boolean} once Specify if the listener is a one-time listener.
   * @returns {EventEmitter}
   * @private
   */
  function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') {
      throw new TypeError('The listener must be a function');
    }
    var listener = new EE(fn, context || emitter, once),
      evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);else emitter._events[evt] = [emitter._events[evt], listener];
    return emitter;
  }

  /**
   * Clear event by name.
   *
   * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
   * @param {(String|Symbol)} evt The Event name.
   * @private
   */
  function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();else delete emitter._events[evt];
  }

  /**
   * Minimal `EventEmitter` interface that is molded against the Node.js
   * `EventEmitter` interface.
   *
   * @constructor
   * @public
   */
  function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
  }

  /**
   * Return an array listing the events for which the emitter has registered
   * listeners.
   *
   * @returns {Array}
   * @public
   */
  EventEmitter.prototype.eventNames = function eventNames() {
    var names = [],
      events,
      name;
    if (this._eventsCount === 0) return names;
    for (name in events = this._events) {
      if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    }
    if (Object.getOwnPropertySymbols) {
      return names.concat(Object.getOwnPropertySymbols(events));
    }
    return names;
  };

  /**
   * Return the listeners registered for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @returns {Array} The registered listeners.
   * @public
   */
  EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event,
      handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [handlers.fn];
    for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
      ee[i] = handlers[i].fn;
    }
    return ee;
  };

  /**
   * Return the number of listeners listening to a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @returns {Number} The number of listeners.
   * @public
   */
  EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event,
      listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
  };

  /**
   * Calls each of the listeners registered for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @returns {Boolean} `true` if the event had listeners, else `false`.
   * @public
   */
  EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt],
      len = arguments.length,
      args,
      i;
    if (listeners.fn) {
      if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
      switch (len) {
        case 1:
          return listeners.fn.call(listeners.context), true;
        case 2:
          return listeners.fn.call(listeners.context, a1), true;
        case 3:
          return listeners.fn.call(listeners.context, a1, a2), true;
        case 4:
          return listeners.fn.call(listeners.context, a1, a2, a3), true;
        case 5:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
        case 6:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
      }
      for (i = 1, args = new Array(len - 1); i < len; i++) {
        args[i - 1] = arguments[i];
      }
      listeners.fn.apply(listeners.context, args);
    } else {
      var length = listeners.length,
        j;
      for (i = 0; i < length; i++) {
        if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
        switch (len) {
          case 1:
            listeners[i].fn.call(listeners[i].context);
            break;
          case 2:
            listeners[i].fn.call(listeners[i].context, a1);
            break;
          case 3:
            listeners[i].fn.call(listeners[i].context, a1, a2);
            break;
          case 4:
            listeners[i].fn.call(listeners[i].context, a1, a2, a3);
            break;
          default:
            if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
              args[j - 1] = arguments[j];
            }
            listeners[i].fn.apply(listeners[i].context, args);
        }
      }
    }
    return true;
  };

  /**
   * Add a listener for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn The listener function.
   * @param {*} [context=this] The context to invoke the listener with.
   * @returns {EventEmitter} `this`.
   * @public
   */
  EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
  };

  /**
   * Add a one-time listener for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn The listener function.
   * @param {*} [context=this] The context to invoke the listener with.
   * @returns {EventEmitter} `this`.
   * @public
   */
  EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
  };

  /**
   * Remove the listeners of a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn Only remove the listeners that match this function.
   * @param {*} context Only remove the listeners that have this context.
   * @param {Boolean} once Only remove one-time listeners.
   * @returns {EventEmitter} `this`.
   * @public
   */
  EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
      clearEvent(this, evt);
      return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
      if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
        clearEvent(this, evt);
      }
    } else {
      for (var i = 0, events = [], length = listeners.length; i < length; i++) {
        if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
          events.push(listeners[i]);
        }
      }

      //
      // Reset the array, or remove it completely if we have no more listeners.
      //
      if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;else clearEvent(this, evt);
    }
    return this;
  };

  /**
   * Remove all listeners, or those of the specified event.
   *
   * @param {(String|Symbol)} [event] The event name.
   * @returns {EventEmitter} `this`.
   * @public
   */
  EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
      evt = prefix ? prefix + event : event;
      if (this._events[evt]) clearEvent(this, evt);
    } else {
      this._events = new Events();
      this._eventsCount = 0;
    }
    return this;
  };

  //
  // Alias methods names because people roll like that.
  //
  EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
  EventEmitter.prototype.addListener = EventEmitter.prototype.on;

  //
  // Expose the prefix.
  //
  EventEmitter.prefixed = prefix;

  //
  // Allow `EventEmitter` to be imported as module namespace.
  //
  EventEmitter.EventEmitter = EventEmitter;

  //
  // Expose the module.
  //
  {
    module.exports = EventEmitter;
  }
})(eventemitter3);
var EventEmitter = eventemitter3.exports;
var DocumentCookieService = /*#__PURE__*/function (_EventEmitter) {
  function DocumentCookieService() {
    var _this2;
    _classCallCheck2(this, DocumentCookieService);
    _this2 = _callSuper(this, DocumentCookieService);
    _this2.cookies = {};
    _this2.initialiseCookies(false);
    setInterval(_this2.initialiseCookies.bind(_this2), DocumentCookieService.REFRESH_INTERVAL);
    return _this2;
  }
  _inherits2(DocumentCookieService, _EventEmitter);
  return _createClass2(DocumentCookieService, [{
    key: "emitChangeEvents",
    value: function emitChangeEvents(oldCookies, newCookies) {
      // eslint-disable-next-line no-console
      console.dir({
        oldCookies: oldCookies,
        newCookies: newCookies
      });
    }
  }, {
    key: "initialiseCookies",
    value: function initialiseCookies() {
      var _this3 = this;
      var withEvents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var oldCookies = Object.assign({}, this.cookies);
      var newCookies = DocumentCookieService.parseDocumentCookie();
      if (withEvents) {
        this.emitChangeEvents(oldCookies, newCookies);
      }
      var entries = Object.entries(newCookies);
      entries.forEach(function (_ref54) {
        var _ref55 = _slicedToArray(_ref54, 2),
          key = _ref55[0],
          value = _ref55[1];
        Object.defineProperty(_this3.cookies, key, {
          value: value,
          writable: false,
          enumerable: true,
          configurable: true
        });
      });
    }
  }, {
    key: "setCookie",
    value: function setCookie(key, value) {
      // NOTE 400 days, see https://developer.chrome.com/blog/cookie-max-age-expires/#example
      document.cookie = "".concat(key, "=").concat(value, ";Max-Age=1707109200;SameSite=Lax;Path=/");
      this.initialiseCookies();
    }
  }], [{
    key: "parseDocumentCookie",
    value: function parseDocumentCookie() {
      var src = document.cookie;
      var lineItems = src.split(';');
      var entries = lineItems.map(function (item) {
        var _item$trim$split$map$ = item.trim().split('=').map(function (item) {
            return item.trim();
          }).filter(Boolean),
          _item$trim$split$map$2 = _toArray(_item$trim$split$map$),
          key = _item$trim$split$map$2[0],
          value = _arrayLikeToArray2(_item$trim$split$map$2).slice(1);
        return [key, value.join(' ')];
      });
      return Object.fromEntries(entries);
    }
  }]);
}(EventEmitter);
DocumentCookieService.REFRESH_INTERVAL = 30000;
var CookieConsentService = /*#__PURE__*/function (_DocumentCookieServic) {
  function CookieConsentService(name, model) {
    var _this4;
    _classCallCheck2(this, CookieConsentService);
    _this4 = _callSuper(this, CookieConsentService);
    _this4.name = name;
    _this4.getCategoryCookieKey = function (category) {
      return "".concat(CookieConsentService.COOKIE_PREFIX, "_").concat(_this4.name, "_").concat(category, "Enabled");
    };
    _this4.hasSeenCookieKey = "".concat(CookieConsentService.COOKIE_PREFIX, "_").concat(name, "_hasSeenCookieMessage");
    _this4.initiialiseModel(model);
    _this4.initialiseCategoryAccessors(model);
    return _this4;
  }
  _inherits2(CookieConsentService, _DocumentCookieServic);
  return _createClass2(CookieConsentService, [{
    key: "hasSeenCookieMessage",
    get: function get() {
      return this.cookies[this.hasSeenCookieKey] === 'true';
    },
    set: function set(value) {
      this.setCookie(this.hasSeenCookieKey, "".concat(value));
    }
  }, {
    key: "acceptAll",
    value: function acceptAll() {
      var _this5 = this;
      this.forEachCategory(function (category) {
        _this5.enabled[category] = true;
      });
    }
  }, {
    key: "denyAll",
    value: function denyAll() {
      var _this6 = this;
      this.forEachCategory(function (category) {
        _this6.enabled[category] = false;
      });
    }
  }, {
    key: "emitChangeEvents",
    value: function emitChangeEvents(oldCookies, newCookies) {
      var _this7 = this;
      var changes = new Map();
      this.forEachCategory(function (category) {
        var cookie = _this7.getCategoryCookieKey(category);
        if (oldCookies[cookie] !== newCookies[cookie]) {
          var value = newCookies[cookie] !== 'false';
          changes.set(category, value);
          _this7.emit("".concat(category, "-consent-change"), value);
        }
      });
      if (changes.size > 0) {
        this.emit("consent-change", changes);
      }
      if (oldCookies[this.hasSeenCookieKey] !== newCookies[this.hasSeenCookieKey]) {
        var value = newCookies[this.hasSeenCookieKey] === 'true';
        this.emit('has-seen-cookie-message-change', value);
      }
    }
  }, {
    key: "initiialiseModel",
    value: function initiialiseModel(passedModel) {
      var _this8 = this;
      this.model = cjs(passedModel, {
        essential: {
          cookies: [{
            name: this.hasSeenCookieKey,
            provider: 'huggg',
            description: 'This helps us to decide if we should ask you for cookie consent.',
            expiry: '400 days'
          }].concat(_toConsumableArray2(Object.keys(passedModel).filter(function (item) {
            return item !== 'essential';
          }).map(function (category) {
            return {
              name: _this8.getCategoryCookieKey(category),
              provider: 'huggg',
              description: "This stores your consent to for cookies from the ".concat(category, " category"),
              expiry: '400 days'
            };
          })))
        }
      });
    }
  }, {
    key: "initialiseCategoryAccessors",
    value: function initialiseCategoryAccessors(model) {
      var _this9 = this;
      this.enabled = {
        essential: true
      };
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      var self = this;
      var keys = Object.keys(model);
      keys.forEach(function (key) {
        Object.defineProperty(_this9.enabled, key, {
          get: function get() {
            if (key === 'essential') {
              return true;
            }
            return self.cookies[self.getCategoryCookieKey(key)] === 'true';
          },
          set: function set(value) {
            if (key === 'essential') {
              if (!value) {
                throw new Error('can not disable essential cookies.');
              }
              return value;
            }
            self.setCookie(self.getCategoryCookieKey(key), "".concat(value));
          },
          enumerable: true
        });
      });
    }
  }, {
    key: "forEachCategory",
    value: function forEachCategory(fn) {
      Object.keys(this.model).filter(function (category) {
        return category !== 'essential';
      }).forEach(fn);
    }
  }]);
}(DocumentCookieService);
CookieConsentService.COOKIE_PREFIX = 'hugggCookies';
var CookieConsentContext = createContext(null);
function CookieConsentContextProvider(_ref56) {
  var children = _ref56.children,
    model = _ref56.model,
    name = _ref56.name,
    _ref56$disabled = _ref56.disabled,
    disabled = _ref56$disabled === void 0 ? false : _ref56$disabled;
  var service = useMemo(function () {
    return new CookieConsentService(name, model);
  }, [name, model]);
  var _useState14 = useState(service.hasSeenCookieMessage),
    _useState15 = _slicedToArray(_useState14, 2),
    hasSeenCookieMessage = _useState15[0],
    setHasSeenCookieMessage = _useState15[1];
  var _useState16 = useState(false),
    _useState17 = _slicedToArray(_useState16, 2),
    renderDetailsModal = _useState17[0],
    setRenderDetailsModal = _useState17[1];
  var _useState18 = useState(service.enabled),
    _useState19 = _slicedToArray(_useState18, 2),
    enabled = _useState19[0],
    setEnabled = _useState19[1];
  var onConsentChange = function onConsentChange(changes) {
    setEnabled(Object.assign(Object.assign({}, enabled), Object.fromEntries(changes.entries())));
  };
  useEffect(function () {
    service.on('has-seen-cookie-message-change', setHasSeenCookieMessage);
    service.on('consent-change', onConsentChange);
    return function () {
      service.removeListener('has-seen-cookie-message-change', setHasSeenCookieMessage);
      service.removeListener('consent-change', onConsentChange);
    };
  }, []);
  return React$2.createElement(CookieConsentContext.Provider, {
    key: name,
    value: service
  }, children, !disabled && !hasSeenCookieMessage && createPortal(React$2.createElement(CookieBanner, {
    onAcceptAll: function onAcceptAll() {
      service.acceptAll();
      service.hasSeenCookieMessage = true;
    },
    onDenyAll: function onDenyAll() {
      service.denyAll();
      service.hasSeenCookieMessage = true;
    },
    onMoreInfo: function onMoreInfo() {
      setRenderDetailsModal(true);
    }
  }), document.body), renderDetailsModal && React$2.createElement(CookieDetailsModal, {
    model: service.model,
    enabled: enabled,
    onClose: function onClose() {
      service.hasSeenCookieMessage = true;
      setRenderDetailsModal(false);
    },
    onChange: function onChange(category, value) {
      service.enabled[category] = value;
    }
  }));
}
var useCookieConsentContext = function useCookieConsentContext() {
  return useContext(CookieConsentContext);
};
var DateControl = function DateControl(_ref57) {
  var name = _ref57.name,
    _ref57$placeholder = _ref57.placeholder,
    placeholder = _ref57$placeholder === void 0 ? '' : _ref57$placeholder,
    _ref57$error = _ref57.error,
    stringifiedErrorStruct = _ref57$error === void 0 ? '' : _ref57$error,
    optional = _ref57.optional,
    _ref57$displayOptiona = _ref57.displayOptional,
    displayOptional = _ref57$displayOptiona === void 0 ? false : _ref57$displayOptiona,
    _ref57$validateOnBlur = _ref57.validateOnBlur,
    validateOnBlur = _ref57$validateOnBlur === void 0 ? false : _ref57$validateOnBlur;
  var _useFormikContext3 = useFormikContext(),
    handleBlur = _useFormikContext3.handleBlur,
    validateField = _useFormikContext3.validateField,
    touched = _useFormikContext3.touched;
  var onBlur = function onBlur(event) {
    handleBlur(event);
    if (!validateOnBlur) return;
    var fieldName = event.target.name;
    void validateField(fieldName);
    // The age rule is attached to the year, but depends on all three parts.
    if (fieldName !== "".concat(name, ".year") && getIn$1(touched, "".concat(name, ".year"))) {
      void validateField("".concat(name, ".year"));
    }
  };
  var _useState20 = useState(''),
    _useState21 = _slicedToArray(_useState20, 2),
    errorMessage = _useState21[0],
    setErrorMessage = _useState21[1];
  var _useState22 = useState({}),
    _useState23 = _slicedToArray(_useState22, 2),
    errorStruct = _useState23[0],
    setErrorStruct = _useState23[1];
  var _useThemeContext13 = useThemeContext(),
    _useThemeContext13$fo = _useThemeContext13.form.body,
    _useThemeContext13$fo2 = _useThemeContext13$fo === void 0 ? DefaultFormBodyModel : _useThemeContext13$fo,
    error = _useThemeContext13$fo2.error,
    borderColor = _useThemeContext13$fo2.borderColor;
  useEffect(function () {
    var parsed = JSON.parse(stringifiedErrorStruct || '{}');
    setErrorStruct(parsed);
    setErrorMessage(Object.keys(parsed).length > 0 ? Object.values(parsed).sort(function (a, b) {
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    }).join('. ') : '');
  }, [stringifiedErrorStruct]);
  return React$2.createElement(Body_2, null, React$2.createElement("label", {
    htmlFor: name
  }, React$2.createElement("div", {
    className: styles$A.label
  }, placeholder, optional && displayOptional && React$2.createElement("span", {
    className: styles$A.optional
  }, "Optional"))), React$2.createElement("div", {
    style: {
      display: 'flex',
      gap: '8px'
    }
  }, React$2.createElement(Field, {
    onBlur: onBlur,
    type: "string",
    name: "".concat(name, ".date"),
    placeholder: "DD",
    style: {
      borderColor: errorStruct.date ? error === null || error === void 0 ? void 0 : error.color : borderColor,
      width: '64px'
    },
    className: styles$A.input,
    "data-testid": name
  }), React$2.createElement(Field, {
    onBlur: onBlur,
    type: "string",
    name: "".concat(name, ".month"),
    placeholder: "MM",
    style: {
      borderColor: errorStruct.month ? error === null || error === void 0 ? void 0 : error.color : borderColor,
      width: '64px'
    },
    className: styles$A.input,
    "data-testid": name
  }), React$2.createElement(Field, {
    onBlur: onBlur,
    type: "string",
    name: "".concat(name, ".year"),
    placeholder: "YYYY",
    style: {
      borderColor: errorStruct.year ? error === null || error === void 0 ? void 0 : error.color : borderColor,
      width: '96px'
    },
    className: styles$A.input,
    "data-testid": name
  })), React$2.createElement(ControlError, {
    message: errorMessage
  }));
};
var styles$r = {
  "container": "checkbox-control-module_container__AGXWU",
  "checkmarkContainer": "checkbox-control-module_checkmarkContainer__C6X-1",
  "checkbox": "checkbox-control-module_checkbox__D7kvA",
  "label": "checkbox-control-module_label__42mvu"
};
var CheckboxControl = function CheckboxControl(_ref58) {
  var name = _ref58.name,
    placeholder = _ref58.placeholder,
    _ref58$error = _ref58.error,
    errorMessage = _ref58$error === void 0 ? '' : _ref58$error,
    handleChange = _ref58.handleChange;
  var _useThemeContext14 = useThemeContext(),
    _useThemeContext14$fo = _useThemeContext14.form.body,
    _useThemeContext14$fo2 = _useThemeContext14$fo === void 0 ? DefaultFormBodyModel : _useThemeContext14$fo,
    error = _useThemeContext14$fo2.error,
    borderColor = _useThemeContext14$fo2.borderColor,
    checkbox = _useThemeContext14$fo2.checkbox;
  var _useState24 = useState(false),
    _useState25 = _slicedToArray(_useState24, 2),
    checked = _useState25[0],
    setChecked = _useState25[1];
  var style = {
    borderColor: errorMessage ? error === null || error === void 0 ? void 0 : error.color : borderColor
  };
  return React$2.createElement(React$2.Fragment, null, React$2.createElement("label", {
    htmlFor: name,
    className: styles$r.container
  }, React$2.createElement(Body_2, {
    className: styles$r.label
  }, placeholder), React$2.createElement("div", {
    className: styles$r.checkmarkContainer
  }, React$2.createElement(Field, {
    type: "checkbox",
    name: name,
    id: name,
    style: style,
    className: classnames(styles$r.checkbox),
    onChange: function onChange(e) {
      if (handleChange) {
        handleChange(e);
      }
      setChecked(checked ? false : true);
    },
    checked: checked
  }), React$2.createElement(Checkmark, {
    checked: checked,
    color: checkbox === null || checkbox === void 0 ? void 0 : checkbox.color
  }))), React$2.createElement(ControlError, {
    message: errorMessage
  }));
};
var MarkdownControl = function MarkdownControl(_ref59) {
  var placeholder = _ref59.placeholder;
  return React$2.createElement("div", {
    className: styles$A.container
  }, React$2.createElement(Markdown, {
    value: placeholder
  }));
};

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */

function debounce$1(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;
  function later() {
    var last = Date.now() - timestamp;
    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  }
  var debounced = function debounced() {
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }
    return result;
  };
  debounced.clear = function () {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  debounced.flush = function () {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      clearTimeout(timeout);
      timeout = null;
    }
  };
  return debounced;
}
// Adds compatibility for ES modules
debounce$1.debounce = debounce$1;
var debounce_1 = debounce$1;
var AddressFinderService = function AddressFinderService(basepath) {
  var makeRequest = function makeRequest(url) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee3() {
      var response, results;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return fetch(url);
          case 1:
            response = _context3.v;
            if (response.ok) {
              _context3.n = 2;
              break;
            }
            throw new Error("there was an error making an address finder request: [".concat(response.status, "] \"").concat(response.statusText, "\""));
          case 2:
            _context3.n = 3;
            return response.json();
          case 3:
            results = _context3.v;
            return _context3.a(2, results);
        }
      }, _callee3);
    }));
  };
  var getSearchUrl = function getSearchUrl(country, searchTerm) {
    return "".concat(basepath, "/address-search/country/").concat(country, "/search/").concat(searchTerm);
  };
  return {
    search: function search(country, searchTerm, containerId) {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee4() {
        var url;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              url = getSearchUrl(country, searchTerm);
              return _context4.a(2, makeRequest(containerId ? "".concat(url, "?containerId=").concat(containerId) : url));
          }
        }, _callee4);
      }));
    },
    retrieve: function retrieve(country, searchTerm, addressId) {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              return _context5.a(2, makeRequest("".concat(getSearchUrl(country, searchTerm), "/retrieve/").concat(addressId)));
          }
        }, _callee5);
      }));
    }
  };
};
function t(t) {
  return "object" == typeof t && null != t && 1 === t.nodeType;
}
function e(t, e) {
  return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
}
function n(t, n) {
  if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
    var r = getComputedStyle(t, null);
    return e(r.overflowY, n) || e(r.overflowX, n) || function (t) {
      var e = function (t) {
        if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
        try {
          return t.ownerDocument.defaultView.frameElement;
        } catch (t) {
          return null;
        }
      }(t);
      return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
    }(t);
  }
  return !1;
}
function r(t, e, n, r, i, o, l, d) {
  return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
}
var i = function i(e, _i2) {
  var o = window,
    l = _i2.scrollMode,
    d = _i2.block,
    f = _i2.inline,
    h = _i2.boundary,
    u = _i2.skipOverflowHiddenElements,
    s = "function" == typeof h ? h : function (t) {
      return t !== h;
    };
  if (!t(e)) throw new TypeError("Invalid target");
  for (var a, c, g = document.scrollingElement || document.documentElement, p = [], m = e; t(m) && s(m);) {
    if ((m = null == (c = (a = m).parentElement) ? a.getRootNode().host || null : c) === g) {
      p.push(m);
      break;
    }
    null != m && m === document.body && n(m) && !n(document.documentElement) || null != m && n(m, u) && p.push(m);
  }
  for (var w = o.visualViewport ? o.visualViewport.width : innerWidth, v = o.visualViewport ? o.visualViewport.height : innerHeight, W = window.scrollX || pageXOffset, H = window.scrollY || pageYOffset, b = e.getBoundingClientRect(), y = b.height, E = b.width, M = b.top, V = b.right, x = b.bottom, I = b.left, C = "start" === d || "nearest" === d ? M : "end" === d ? x : M + y / 2, R = "center" === f ? I + E / 2 : "end" === f ? V : I, T = [], k = 0; k < p.length; k++) {
    var B = p[k],
      D = B.getBoundingClientRect(),
      O = D.height,
      X = D.width,
      Y = D.top,
      L = D.right,
      S = D.bottom,
      j = D.left;
    if ("if-needed" === l && M >= 0 && I >= 0 && x <= v && V <= w && M >= Y && x <= S && I >= j && V <= L) return T;
    var N = getComputedStyle(B),
      q = parseInt(N.borderLeftWidth, 10),
      z = parseInt(N.borderTopWidth, 10),
      A = parseInt(N.borderRightWidth, 10),
      F = parseInt(N.borderBottomWidth, 10),
      G = 0,
      J = 0,
      K = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - q - A : 0,
      P = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - z - F : 0,
      Q = "offsetWidth" in B ? 0 === B.offsetWidth ? 0 : X / B.offsetWidth : 0,
      U = "offsetHeight" in B ? 0 === B.offsetHeight ? 0 : O / B.offsetHeight : 0;
    if (g === B) G = "start" === d ? C : "end" === d ? C - v : "nearest" === d ? r(H, H + v, v, z, F, H + C, H + C + y, y) : C - v / 2, J = "start" === f ? R : "center" === f ? R - w / 2 : "end" === f ? R - w : r(W, W + w, w, q, A, W + R, W + R + E, E), G = Math.max(0, G + H), J = Math.max(0, J + W);else {
      G = "start" === d ? C - Y - z : "end" === d ? C - S + F + P : "nearest" === d ? r(Y, S, O, z, F + P, C, C + y, y) : C - (Y + O / 2) + P / 2, J = "start" === f ? R - j - q : "center" === f ? R - (j + X / 2) + K / 2 : "end" === f ? R - L + A + K : r(j, L, X, q, A + K, R, R + E, E);
      var Z = B.scrollLeft,
        $ = B.scrollTop;
      C += $ - (G = Math.max(0, Math.min($ + G / U, B.scrollHeight - O / U + P))), R += Z - (J = Math.max(0, Math.min(Z + J / Q, B.scrollWidth - X / Q + K)));
    }
    T.push({
      el: B,
      top: G,
      left: J
    });
  }
  return T;
};
var idCounter = 0;
/**
 * Accepts a parameter and returns it if it's a function
 * or a noop function if it's not. This allows us to
 * accept a callback, but not worry about it if it's not
 * passed.
 * @param {Function} cb the callback
 * @return {Function} a function
 */

function cbToCb(cb) {
  return typeof cb === 'function' ? cb : noop;
}
function noop() {}
/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node the element that should scroll into view
 * @param {HTMLElement} menuNode the menu element of the component
 */

function scrollIntoView(node, menuNode) {
  if (!node) {
    return;
  }
  var actions = i(node, {
    boundary: menuNode,
    block: 'nearest',
    scrollMode: 'if-needed'
  });
  actions.forEach(function (_ref) {
    var el = _ref.el,
      top = _ref.top,
      left = _ref.left;
    el.scrollTop = top;
    el.scrollLeft = left;
  });
}
/**
 * @param {HTMLElement} parent the parent node
 * @param {HTMLElement} child the child node
 * @param {Window} environment The window context where downshift renders.
 * @return {Boolean} whether the parent is the child or the child is in the parent
 */

function isOrContainsNode(parent, child, environment) {
  var result = parent === child || child instanceof environment.Node && parent.contains && parent.contains(child);
  return result;
}
/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */

function debounce(fn, time) {
  var timeoutId;
  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }
  function wrapper() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    cancel();
    timeoutId = setTimeout(function () {
      timeoutId = null;
      fn.apply(void 0, args);
    }, time);
  }
  wrapper.cancel = cancel;
  return wrapper;
}
/**
 * This is intended to be used to compose event handlers.
 * They are executed in order until one of them sets
 * `event.preventDownshiftDefault = true`.
 * @param {...Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */

function callAllEventHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }
  return function (event) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }
    return fns.some(function (fn) {
      if (fn) {
        fn.apply(void 0, [event].concat(args));
      }
      return event.preventDownshiftDefault || event.hasOwnProperty('nativeEvent') && event.nativeEvent.preventDownshiftDefault;
    });
  };
}
function handleRefs() {
  for (var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    refs[_key4] = arguments[_key4];
  }
  return function (node) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    });
  };
}
/**
 * This generates a unique ID for an instance of Downshift
 * @return {String} the unique ID
 */

function generateId() {
  return String(idCounter++);
}
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specify if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */

function getA11yStatusMessage$1(_ref2) {
  var isOpen = _ref2.isOpen,
    resultCount = _ref2.resultCount,
    previousResultCount = _ref2.previousResultCount;
  if (!isOpen) {
    return '';
  }
  if (!resultCount) {
    return 'No results are available.';
  }
  if (resultCount !== previousResultCount) {
    return "".concat(resultCount, " result").concat(resultCount === 1 ? ' is' : 's are', " available, use up and down arrow keys to navigate. Press Enter key to select.");
  }
  return '';
}
/**
 * Takes an argument and if it's an array, returns the first item in the array
 * otherwise returns the argument
 * @param {*} arg the maybe-array
 * @param {*} defaultValue the value if arg is falsey not defined
 * @return {*} the arg or it's first item
 */

function unwrapArray(arg, defaultValue) {
  arg = Array.isArray(arg) ? /* istanbul ignore next (preact) */
  arg[0] : arg;
  if (!arg && defaultValue) {
    return defaultValue;
  } else {
    return arg;
  }
}
/**
 * @param {Object} element (P)react element
 * @return {Boolean} whether it's a DOM element
 */

function isDOMElement(element) {
  return typeof element.type === 'string';
}
/**
 * @param {Object} element (P)react element
 * @return {Object} the props
 */

function getElementProps(element) {
  return element.props;
}
/**
 * Throws a helpful error message for required properties. Useful
 * to be used as a default in destructuring or object params.
 * @param {String} fnName the function name
 * @param {String} propName the prop name
 */

function requiredProp(fnName, propName) {
  // eslint-disable-next-line no-console
  console.error("The property \"".concat(propName, "\" is required in \"").concat(fnName, "\""));
}
var stateKeys = ['highlightedIndex', 'inputValue', 'isOpen', 'selectedItem', 'type'];
/**
 * @param {Object} state the state object
 * @return {Object} state that is relevant to downshift
 */

function pickState(state) {
  if (state === void 0) {
    state = {};
  }
  var result = {};
  stateKeys.forEach(function (k) {
    if (state.hasOwnProperty(k)) {
      result[k] = state[k];
    }
  });
  return result;
}
/**
 * This will perform a shallow merge of the given state object
 * with the state coming from props
 * (for the controlled component scenario)
 * This is used in state updater functions so they're referencing
 * the right state regardless of where it comes from.
 *
 * @param {Object} state The state of the component/hook.
 * @param {Object} props The props that may contain controlled values.
 * @returns {Object} The merged controlled state.
 */

function _getState(state, props) {
  return Object.keys(state).reduce(function (prevState, key) {
    prevState[key] = isControlledProp(props, key) ? props[key] : state[key];
    return prevState;
  }, {});
}
/**
 * This determines whether a prop is a "controlled prop" meaning it is
 * state which is controlled by the outside of this component rather
 * than within this component.
 *
 * @param {Object} props The props that may contain controlled values.
 * @param {String} key the key to check
 * @return {Boolean} whether it is a controlled controlled prop
 */

function isControlledProp(props, key) {
  return props[key] !== undefined;
}
/**
 * Normalizes the 'key' property of a KeyboardEvent in IE/Edge
 * @param {Object} event a keyboardEvent object
 * @return {String} keyboard key
 */

function normalizeArrowKey(event) {
  var key = event.key,
    keyCode = event.keyCode;
  /* istanbul ignore next (ie) */

  if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) {
    return "Arrow".concat(key);
  }
  return key;
}
/**
 * Simple check if the value passed is object literal
 * @param {*} obj any things
 * @return {Boolean} whether it's object literal
 */

function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}
/**
 * Returns the new index in the list, in a circular way. If next value is out of bonds from the total,
 * it will wrap to either 0 or itemCount - 1.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index after the move.
 */

function getNextWrappingIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  if (circular === void 0) {
    circular = true;
  }
  if (itemCount === 0) {
    return -1;
  }
  var itemsLastIndex = itemCount - 1;
  if (typeof baseIndex !== 'number' || baseIndex < 0 || baseIndex >= itemCount) {
    baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
  }
  var newIndex = baseIndex + moveAmount;
  if (newIndex < 0) {
    newIndex = circular ? itemsLastIndex : 0;
  } else if (newIndex > itemsLastIndex) {
    newIndex = circular ? 0 : itemsLastIndex;
  }
  var nonDisabledNewIndex = getNextNonDisabledIndex(moveAmount, newIndex, itemCount, getItemNodeFromIndex, circular);
  if (nonDisabledNewIndex === -1) {
    return baseIndex >= itemCount ? -1 : baseIndex;
  }
  return nonDisabledNewIndex;
}
/**
 * Returns the next index in the list of an item that is not disabled.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index. Returns baseIndex if item is not disabled. Returns next non-disabled item otherwise. If no non-disabled found it will return -1.
 */

function getNextNonDisabledIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  var currentElementNode = getItemNodeFromIndex(baseIndex);
  if (!currentElementNode || !currentElementNode.hasAttribute('disabled')) {
    return baseIndex;
  }
  if (moveAmount > 0) {
    for (var _index = baseIndex + 1; _index < itemCount; _index++) {
      if (!getItemNodeFromIndex(_index).hasAttribute('disabled')) {
        return _index;
      }
    }
  } else {
    for (var _index2 = baseIndex - 1; _index2 >= 0; _index2--) {
      if (!getItemNodeFromIndex(_index2).hasAttribute('disabled')) {
        return _index2;
      }
    }
  }
  if (circular) {
    return moveAmount > 0 ? getNextNonDisabledIndex(1, 0, itemCount, getItemNodeFromIndex, false) : getNextNonDisabledIndex(-1, itemCount - 1, itemCount, getItemNodeFromIndex, false);
  }
  return -1;
}
/**
 * Checks if event target is within the downshift elements.
 *
 * @param {EventTarget} target Target to check.
 * @param {HTMLElement[]} downshiftElements The elements that form downshift (list, toggle button etc).
 * @param {Window} environment The window context where downshift renders.
 * @param {boolean} checkActiveElement Whether to also check activeElement.
 *
 * @returns {boolean} Whether or not the target is within downshift elements.
 */

function targetWithinDownshift(target, downshiftElements, environment, checkActiveElement) {
  if (checkActiveElement === void 0) {
    checkActiveElement = true;
  }
  return downshiftElements.some(function (contextNode) {
    return contextNode && (isOrContainsNode(contextNode, target, environment) || checkActiveElement && isOrContainsNode(contextNode, environment.document.activeElement, environment));
  });
} // eslint-disable-next-line import/no-mutable-exports

var validateControlledUnchanged = noop;
/* istanbul ignore next */

if (process.env.NODE_ENV !== 'production') {
  validateControlledUnchanged = function validateControlledUnchanged(state, prevProps, nextProps) {
    var warningDescription = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
    Object.keys(state).forEach(function (propKey) {
      if (prevProps[propKey] !== undefined && nextProps[propKey] === undefined) {
        // eslint-disable-next-line no-console
        console.error("downshift: A component has changed the controlled prop \"".concat(propKey, "\" to be uncontrolled. ").concat(warningDescription));
      } else if (prevProps[propKey] === undefined && nextProps[propKey] !== undefined) {
        // eslint-disable-next-line no-console
        console.error("downshift: A component has changed the uncontrolled prop \"".concat(propKey, "\" to be controlled. ").concat(warningDescription));
      }
    });
  };
}
var cleanupStatus = debounce(function (documentProp) {
  getStatusDiv(documentProp).textContent = '';
}, 500);
/**
 * @param {String} status the status message
 * @param {Object} documentProp document passed by the user.
 */

function setStatus(status, documentProp) {
  var div = getStatusDiv(documentProp);
  if (!status) {
    return;
  }
  div.textContent = status;
  cleanupStatus(documentProp);
}
/**
 * Get the status node or create it if it does not already exist.
 * @param {Object} documentProp document passed by the user.
 * @return {HTMLElement} the status node.
 */

function getStatusDiv(documentProp) {
  if (documentProp === void 0) {
    documentProp = document;
  }
  var statusDiv = documentProp.getElementById('a11y-status-message');
  if (statusDiv) {
    return statusDiv;
  }
  statusDiv = documentProp.createElement('div');
  statusDiv.setAttribute('id', 'a11y-status-message');
  statusDiv.setAttribute('role', 'status');
  statusDiv.setAttribute('aria-live', 'polite');
  statusDiv.setAttribute('aria-relevant', 'additions text');
  Object.assign(statusDiv.style, {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    width: '1px'
  });
  documentProp.body.appendChild(statusDiv);
  return statusDiv;
}
var unknown$1 = process.env.NODE_ENV !== "production" ? '__autocomplete_unknown__' : 0;
var mouseUp = process.env.NODE_ENV !== "production" ? '__autocomplete_mouseup__' : 1;
var itemMouseEnter = process.env.NODE_ENV !== "production" ? '__autocomplete_item_mouseenter__' : 2;
var keyDownArrowUp = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_arrow_up__' : 3;
var keyDownArrowDown = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_arrow_down__' : 4;
var keyDownEscape = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_escape__' : 5;
var keyDownEnter = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_enter__' : 6;
var keyDownHome = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_home__' : 7;
var keyDownEnd = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_end__' : 8;
var clickItem = process.env.NODE_ENV !== "production" ? '__autocomplete_click_item__' : 9;
var blurInput = process.env.NODE_ENV !== "production" ? '__autocomplete_blur_input__' : 10;
var changeInput = process.env.NODE_ENV !== "production" ? '__autocomplete_change_input__' : 11;
var keyDownSpaceButton = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_space_button__' : 12;
var clickButton = process.env.NODE_ENV !== "production" ? '__autocomplete_click_button__' : 13;
var blurButton = process.env.NODE_ENV !== "production" ? '__autocomplete_blur_button__' : 14;
var controlledPropUpdatedSelectedItem = process.env.NODE_ENV !== "production" ? '__autocomplete_controlled_prop_updated_selected_item__' : 15;
var touchEnd = process.env.NODE_ENV !== "production" ? '__autocomplete_touchend__' : 16;
var stateChangeTypes$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  unknown: unknown$1,
  mouseUp: mouseUp,
  itemMouseEnter: itemMouseEnter,
  keyDownArrowUp: keyDownArrowUp,
  keyDownArrowDown: keyDownArrowDown,
  keyDownEscape: keyDownEscape,
  keyDownEnter: keyDownEnter,
  keyDownHome: keyDownHome,
  keyDownEnd: keyDownEnd,
  clickItem: clickItem,
  blurInput: blurInput,
  changeInput: changeInput,
  keyDownSpaceButton: keyDownSpaceButton,
  clickButton: clickButton,
  blurButton: blurButton,
  controlledPropUpdatedSelectedItem: controlledPropUpdatedSelectedItem,
  touchEnd: touchEnd
});

/* eslint camelcase:0 */

var Downshift = /*#__PURE__*/function () {
  var Downshift = /*#__PURE__*/function (_Component) {
    function Downshift(_props) {
      var _this0;
      _classCallCheck2(this, Downshift);
      var _this;
      _this0 = _callSuper(this, Downshift, [_props]);
      _this = _this0;
      _this0.id = _this0.props.id || "downshift-".concat(generateId());
      _this0.menuId = _this0.props.menuId || "".concat(_this0.id, "-menu");
      _this0.labelId = _this0.props.labelId || "".concat(_this0.id, "-label");
      _this0.inputId = _this0.props.inputId || "".concat(_this0.id, "-input");
      _this0.getItemId = _this0.props.getItemId || function (index) {
        return "".concat(_this0.id, "-item-").concat(index);
      };
      _this0.input = null;
      _this0.items = [];
      _this0.itemCount = null;
      _this0.previousResultCount = 0;
      _this0.timeoutIds = [];
      _this0.internalSetTimeout = function (fn, time) {
        var id = setTimeout(function () {
          _this0.timeoutIds = _this0.timeoutIds.filter(function (i) {
            return i !== id;
          });
          fn();
        }, time);
        _this0.timeoutIds.push(id);
      };
      _this0.setItemCount = function (count) {
        _this0.itemCount = count;
      };
      _this0.unsetItemCount = function () {
        _this0.itemCount = null;
      };
      _this0.setHighlightedIndex = function (highlightedIndex, otherStateToSet) {
        if (highlightedIndex === void 0) {
          highlightedIndex = _this.props.defaultHighlightedIndex;
        }
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(_objectSpread({
          highlightedIndex: highlightedIndex
        }, otherStateToSet));
      };
      _this0.clearSelection = function (cb) {
        _this0.internalSetState({
          selectedItem: null,
          inputValue: '',
          highlightedIndex: _this0.props.defaultHighlightedIndex,
          isOpen: _this0.props.defaultIsOpen
        }, cb);
      };
      _this0.selectItem = function (item, otherStateToSet, cb) {
        otherStateToSet = pickState(otherStateToSet);
        _this0.internalSetState(_objectSpread({
          isOpen: _this0.props.defaultIsOpen,
          highlightedIndex: _this0.props.defaultHighlightedIndex,
          selectedItem: item,
          inputValue: _this0.props.itemToString(item)
        }, otherStateToSet), cb);
      };
      _this0.selectItemAtIndex = function (itemIndex, otherStateToSet, cb) {
        var item = _this0.items[itemIndex];
        if (item == null) {
          return;
        }
        _this0.selectItem(item, otherStateToSet, cb);
      };
      _this0.selectHighlightedItem = function (otherStateToSet, cb) {
        return _this0.selectItemAtIndex(_this0.getState().highlightedIndex, otherStateToSet, cb);
      };
      _this0.internalSetState = function (stateToSet, cb) {
        var isItemSelected, onChangeArg;
        var onStateChangeArg = {};
        var isStateToSetFunction = typeof stateToSet === 'function'; // we want to call `onInputValueChange` before the `setState` call
        // so someone controlling the `inputValue` state gets notified of
        // the input change as soon as possible. This avoids issues with
        // preserving the cursor position.
        // See https://github.com/downshift-js/downshift/issues/217 for more info.

        if (!isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) {
          _this0.props.onInputValueChange(stateToSet.inputValue, _objectSpread(_objectSpread({}, _this0.getStateAndHelpers()), stateToSet));
        }
        return _this0.setState(function (state) {
          state = _this0.getState(state);
          var newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet; // Your own function that could modify the state that will be set.

          newStateToSet = _this0.props.stateReducer(state, newStateToSet); // checks if an item is selected, regardless of if it's different from
          // what was selected before
          // used to determine if onSelect and onChange callbacks should be called

          isItemSelected = newStateToSet.hasOwnProperty('selectedItem'); // this keeps track of the object we want to call with setState

          var nextState = {}; // this is just used to tell whether the state changed
          // and we're trying to update that state. OR if the selection has changed and we're
          // trying to update the selection

          if (isItemSelected && newStateToSet.selectedItem !== state.selectedItem) {
            onChangeArg = newStateToSet.selectedItem;
          }
          newStateToSet.type = newStateToSet.type || unknown$1;
          Object.keys(newStateToSet).forEach(function (key) {
            // onStateChangeArg should only have the state that is
            // actually changing
            if (state[key] !== newStateToSet[key]) {
              onStateChangeArg[key] = newStateToSet[key];
            } // the type is useful for the onStateChangeArg
            // but we don't actually want to set it in internal state.
            // this is an undocumented feature for now... Not all internalSetState
            // calls support it and I'm not certain we want them to yet.
            // But it enables users controlling the isOpen state to know when
            // the isOpen state changes due to mouseup events which is quite handy.

            if (key === 'type') {
              return;
            }
            newStateToSet[key]; // if it's coming from props, then we don't care to set it internally

            if (!isControlledProp(_this0.props, key)) {
              nextState[key] = newStateToSet[key];
            }
          }); // if stateToSet is a function, then we weren't able to call onInputValueChange
          // earlier, so we'll call it now that we know what the inputValue state will be.

          if (isStateToSetFunction && newStateToSet.hasOwnProperty('inputValue')) {
            _this0.props.onInputValueChange(newStateToSet.inputValue, _objectSpread(_objectSpread({}, _this0.getStateAndHelpers()), newStateToSet));
          }
          return nextState;
        }, function () {
          // call the provided callback if it's a function
          cbToCb(cb)(); // only call the onStateChange and onChange callbacks if
          // we have relevant information to pass them.

          var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;
          if (hasMoreStateThanType) {
            _this0.props.onStateChange(onStateChangeArg, _this0.getStateAndHelpers());
          }
          if (isItemSelected) {
            _this0.props.onSelect(stateToSet.selectedItem, _this0.getStateAndHelpers());
          }
          if (onChangeArg !== undefined) {
            _this0.props.onChange(onChangeArg, _this0.getStateAndHelpers());
          } // this is currently undocumented and therefore subject to change
          // We'll try to not break it, but just be warned.

          _this0.props.onUserAction(onStateChangeArg, _this0.getStateAndHelpers());
        });
      };
      _this0.rootRef = function (node) {
        return _this0._rootNode = node;
      };
      _this0.getRootProps = function (_temp, _temp2) {
        var _ref60 = _temp === void 0 ? {} : _temp,
          _ref60$refKey = _ref60.refKey,
          refKey = _ref60$refKey === void 0 ? 'ref' : _ref60$refKey,
          ref = _ref60.ref,
          rest = _objectWithoutProperties2(_ref60, _excluded4);
        var _ref61 = _temp2 === void 0 ? {} : _temp2,
          _ref61$suppressRefErr = _ref61.suppressRefError,
          suppressRefError = _ref61$suppressRefErr === void 0 ? false : _ref61$suppressRefErr;
        // this is used in the render to know whether the user has called getRootProps.
        // It uses that to know whether to apply the props automatically
        _this.getRootProps.called = true;
        _this.getRootProps.refKey = refKey;
        _this.getRootProps.suppressRefError = suppressRefError;
        var _this$getState = _this.getState(),
          isOpen = _this$getState.isOpen;
        return _objectSpread(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({}, refKey, handleRefs(ref, _this.rootRef)), "role", 'combobox'), 'aria-expanded', isOpen), 'aria-haspopup', 'listbox'), 'aria-owns', isOpen ? _this.menuId : null), 'aria-labelledby', _this.labelId), rest);
      };
      _this0.keyDownHandlers = {
        ArrowDown: function ArrowDown(event) {
          var _this1 = this;
          event.preventDefault();
          if (this.getState().isOpen) {
            var amount = event.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowDown
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowDown
            }, function () {
              var itemCount = _this1.getItemCount();
              if (itemCount > 0) {
                var _this1$getState = _this1.getState(),
                  highlightedIndex = _this1$getState.highlightedIndex;
                var nextHighlightedIndex = getNextWrappingIndex(1, highlightedIndex, itemCount, function (index) {
                  return _this1.getItemNodeFromIndex(index);
                });
                _this1.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowDown
                });
              }
            });
          }
        },
        ArrowUp: function ArrowUp(event) {
          var _this10 = this;
          event.preventDefault();
          if (this.getState().isOpen) {
            var amount = event.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowUp
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowUp
            }, function () {
              var itemCount = _this10.getItemCount();
              if (itemCount > 0) {
                var _this10$getState = _this10.getState(),
                  highlightedIndex = _this10$getState.highlightedIndex;
                var nextHighlightedIndex = getNextWrappingIndex(-1, highlightedIndex, itemCount, function (index) {
                  return _this10.getItemNodeFromIndex(index);
                });
                _this10.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowUp
                });
              }
            });
          }
        },
        Enter: function Enter(event) {
          if (event.which === 229) {
            return;
          }
          var _this$getState2 = this.getState(),
            isOpen = _this$getState2.isOpen,
            highlightedIndex = _this$getState2.highlightedIndex;
          if (isOpen && highlightedIndex != null) {
            event.preventDefault();
            var item = this.items[highlightedIndex];
            var itemNode = this.getItemNodeFromIndex(highlightedIndex);
            if (item == null || itemNode && itemNode.hasAttribute('disabled')) {
              return;
            }
            this.selectHighlightedItem({
              type: keyDownEnter
            });
          }
        },
        Escape: function Escape(event) {
          event.preventDefault();
          this.reset(_objectSpread({
            type: keyDownEscape
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ''
          }));
        }
      };
      _this0.buttonKeyDownHandlers = _objectSpread(_objectSpread({}, _this0.keyDownHandlers), {}, {
        ' ': function _(event) {
          event.preventDefault();
          this.toggleMenu({
            type: keyDownSpaceButton
          });
        }
      });
      _this0.inputKeyDownHandlers = _objectSpread(_objectSpread({}, _this0.keyDownHandlers), {}, {
        Home: function Home(event) {
          var _this11 = this;
          var _this$getState3 = this.getState(),
            isOpen = _this$getState3.isOpen;
          if (!isOpen) {
            return;
          }
          event.preventDefault();
          var itemCount = this.getItemCount();
          if (itemCount <= 0 || !isOpen) {
            return;
          } // get next non-disabled starting downwards from 0 if that's disabled.

          var newHighlightedIndex = getNextNonDisabledIndex(1, 0, itemCount, function (index) {
            return _this11.getItemNodeFromIndex(index);
          }, false);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownHome
          });
        },
        End: function End(event) {
          var _this12 = this;
          var _this$getState4 = this.getState(),
            isOpen = _this$getState4.isOpen;
          if (!isOpen) {
            return;
          }
          event.preventDefault();
          var itemCount = this.getItemCount();
          if (itemCount <= 0 || !isOpen) {
            return;
          } // get next non-disabled starting upwards from last index if that's disabled.

          var newHighlightedIndex = getNextNonDisabledIndex(-1, itemCount - 1, itemCount, function (index) {
            return _this12.getItemNodeFromIndex(index);
          }, false);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownEnd
          });
        }
      });
      _this0.getToggleButtonProps = function (_temp3) {
        var _ref62 = _temp3 === void 0 ? {} : _temp3,
          onClick = _ref62.onClick,
          onPress = _ref62.onPress,
          onKeyDown = _ref62.onKeyDown,
          onKeyUp = _ref62.onKeyUp,
          onBlur = _ref62.onBlur,
          rest = _objectWithoutProperties2(_ref62, _excluded5);
        var _this$getState5 = _this.getState(),
          isOpen = _this$getState5.isOpen;
        var enabledEventHandlers = {
          onClick: callAllEventHandlers(onClick, _this.buttonHandleClick),
          onKeyDown: callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
          onKeyUp: callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
          onBlur: callAllEventHandlers(onBlur, _this.buttonHandleBlur)
        };
        var eventHandlers = rest.disabled ? {} : enabledEventHandlers;
        return _objectSpread(_objectSpread({
          type: 'button',
          role: 'button',
          'aria-label': isOpen ? 'close menu' : 'open menu',
          'aria-haspopup': true,
          'data-toggle': true
        }, eventHandlers), rest);
      };
      _this0.buttonHandleKeyUp = function (event) {
        // Prevent click event from emitting in Firefox
        event.preventDefault();
      };
      _this0.buttonHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);
        if (_this0.buttonKeyDownHandlers[key]) {
          _this0.buttonKeyDownHandlers[key].call(_this0, event);
        }
      };
      _this0.buttonHandleClick = function (event) {
        event.preventDefault(); // handle odd case for Safari and Firefox which
        // don't give the button the focus properly.

        /* istanbul ignore if (can't reasonably test this) */

        if (_this0.props.environment.document.activeElement === _this0.props.environment.document.body) {
          event.target.focus();
        } // to simplify testing components that use downshift, we'll not wrap this in a setTimeout
        // if the NODE_ENV is test. With the proper build system, this should be dead code eliminated
        // when building for production and should therefore have no impact on production code.

        if (process.env.NODE_ENV === 'test') {
          _this0.toggleMenu({
            type: clickButton
          });
        } else {
          // Ensure that toggle of menu occurs after the potential blur event in iOS
          _this0.internalSetTimeout(function () {
            return _this0.toggleMenu({
              type: clickButton
            });
          });
        }
      };
      _this0.buttonHandleBlur = function (event) {
        var blurTarget = event.target; // Save blur target for comparison with activeElement later
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not body element

        _this0.internalSetTimeout(function () {
          if (!_this0.isMouseDown && (_this0.props.environment.document.activeElement == null || _this0.props.environment.document.activeElement.id !== _this0.inputId) && _this0.props.environment.document.activeElement !== blurTarget // Do nothing if we refocus the same element again (to solve issue in Safari on iOS)
          ) {
            _this0.reset({
              type: blurButton
            });
          }
        });
      };
      _this0.getLabelProps = function (props) {
        return _objectSpread({
          htmlFor: _this0.inputId,
          id: _this0.labelId
        }, props);
      };
      _this0.getInputProps = function (_temp4) {
        var _ref63 = _temp4 === void 0 ? {} : _temp4,
          onKeyDown = _ref63.onKeyDown,
          onBlur = _ref63.onBlur,
          onChange = _ref63.onChange,
          onInput = _ref63.onInput,
          onChangeText = _ref63.onChangeText,
          rest = _objectWithoutProperties2(_ref63, _excluded6);
        var onChangeKey;
        var eventHandlers = {};
        /* istanbul ignore next (preact) */

        {
          onChangeKey = 'onChange';
        }
        var _this$getState6 = _this.getState(),
          inputValue = _this$getState6.inputValue,
          isOpen = _this$getState6.isOpen,
          highlightedIndex = _this$getState6.highlightedIndex;
        if (!rest.disabled) {
          eventHandlers = _defineProperty2(_defineProperty2(_defineProperty2({}, onChangeKey, callAllEventHandlers(onChange, onInput, _this.inputHandleChange)), "onKeyDown", callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown)), "onBlur", callAllEventHandlers(onBlur, _this.inputHandleBlur));
        }
        return _objectSpread(_objectSpread({
          'aria-autocomplete': 'list',
          'aria-activedescendant': isOpen && typeof highlightedIndex === 'number' && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : null,
          'aria-controls': isOpen ? _this.menuId : null,
          'aria-labelledby': _this.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: 'off',
          value: inputValue,
          id: _this.inputId
        }, eventHandlers), rest);
      };
      _this0.inputHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);
        if (key && _this0.inputKeyDownHandlers[key]) {
          _this0.inputKeyDownHandlers[key].call(_this0, event);
        }
      };
      _this0.inputHandleChange = function (event) {
        _this0.internalSetState({
          type: changeInput,
          isOpen: true,
          inputValue: event.target.value,
          highlightedIndex: _this0.props.defaultHighlightedIndex
        });
      };
      _this0.inputHandleBlur = function () {
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not the body element
        _this0.internalSetTimeout(function () {
          var downshiftButtonIsActive = _this0.props.environment.document && !!_this0.props.environment.document.activeElement && !!_this0.props.environment.document.activeElement.dataset && _this0.props.environment.document.activeElement.dataset.toggle && _this0._rootNode && _this0._rootNode.contains(_this0.props.environment.document.activeElement);
          if (!_this0.isMouseDown && !downshiftButtonIsActive) {
            _this0.reset({
              type: blurInput
            });
          }
        });
      };
      _this0.menuRef = function (node) {
        _this0._menuNode = node;
      };
      _this0.getMenuProps = function (_temp5, _temp6) {
        var _ref64 = _temp5 === void 0 ? {} : _temp5,
          _ref64$refKey = _ref64.refKey,
          refKey = _ref64$refKey === void 0 ? 'ref' : _ref64$refKey,
          ref = _ref64.ref,
          props = _objectWithoutProperties2(_ref64, _excluded7);
        var _ref65 = _temp6 === void 0 ? {} : _temp6,
          _ref65$suppressRefErr = _ref65.suppressRefError,
          suppressRefError = _ref65$suppressRefErr === void 0 ? false : _ref65$suppressRefErr;
        _this.getMenuProps.called = true;
        _this.getMenuProps.refKey = refKey;
        _this.getMenuProps.suppressRefError = suppressRefError;
        return _objectSpread(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({}, refKey, handleRefs(ref, _this.menuRef)), "role", 'listbox'), 'aria-labelledby', props && props['aria-label'] ? null : _this.labelId), "id", _this.menuId), props);
      };
      _this0.getItemProps = function (_temp7) {
        var _ref66 = _temp7 === void 0 ? {} : _temp7,
          onMouseMove = _ref66.onMouseMove,
          onMouseDown = _ref66.onMouseDown,
          onClick = _ref66.onClick,
          onPress = _ref66.onPress,
          index = _ref66.index,
          _ref66$item = _ref66.item,
          item = _ref66$item === void 0 ? process.env.NODE_ENV === 'production' ? /* istanbul ignore next */
          undefined : requiredProp('getItemProps', 'item') : _ref66$item,
          rest = _objectWithoutProperties2(_ref66, _excluded8);
        if (index === undefined) {
          _this.items.push(item);
          index = _this.items.indexOf(item);
        } else {
          _this.items[index] = item;
        }
        var onSelectKey = 'onClick';
        var customClickHandler = onClick;
        var enabledEventHandlers = _defineProperty2({
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: callAllEventHandlers(onMouseMove, function () {
            if (index === _this.getState().highlightedIndex) {
              return;
            }
            _this.setHighlightedIndex(index, {
              type: itemMouseEnter
            }); // We never want to manually scroll when changing state based
            // on `onMouseMove` because we will be moving the element out
            // from under the user which is currently scrolling/moving the
            // cursor

            _this.avoidScrolling = true;
            _this.internalSetTimeout(function () {
              return _this.avoidScrolling = false;
            }, 250);
          }),
          onMouseDown: callAllEventHandlers(onMouseDown, function (event) {
            // This prevents the activeElement from being changed
            // to the item so it can remain with the current activeElement
            // which is a more common use case.
            event.preventDefault();
          })
        }, onSelectKey, callAllEventHandlers(customClickHandler, function () {
          _this.selectItemAtIndex(index, {
            type: clickItem
          });
        })); // Passing down the onMouseDown handler to prevent redirect
        // of the activeElement if clicking on disabled items

        var eventHandlers = rest.disabled ? {
          onMouseDown: enabledEventHandlers.onMouseDown
        } : enabledEventHandlers;
        return _objectSpread(_objectSpread({
          id: _this.getItemId(index),
          role: 'option',
          'aria-selected': _this.getState().highlightedIndex === index
        }, eventHandlers), rest);
      };
      _this0.clearItems = function () {
        _this0.items = [];
      };
      _this0.reset = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(function (_ref) {
          var selectedItem = _ref.selectedItem;
          return _objectSpread({
            isOpen: _this.props.defaultIsOpen,
            highlightedIndex: _this.props.defaultHighlightedIndex,
            inputValue: _this.props.itemToString(selectedItem)
          }, otherStateToSet);
        }, cb);
      };
      _this0.toggleMenu = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(function (_ref2) {
          var isOpen = _ref2.isOpen;
          return _objectSpread(_objectSpread({
            isOpen: !isOpen
          }, isOpen && {
            highlightedIndex: _this.props.defaultHighlightedIndex
          }), otherStateToSet);
        }, function () {
          var _this$getState7 = _this.getState(),
            isOpen = _this$getState7.isOpen,
            highlightedIndex = _this$getState7.highlightedIndex;
          if (isOpen) {
            if (_this.getItemCount() > 0 && typeof highlightedIndex === 'number') {
              _this.setHighlightedIndex(highlightedIndex, otherStateToSet);
            }
          }
          cbToCb(cb)();
        });
      };
      _this0.openMenu = function (cb) {
        _this0.internalSetState({
          isOpen: true
        }, cb);
      };
      _this0.closeMenu = function (cb) {
        _this0.internalSetState({
          isOpen: false
        }, cb);
      };
      _this0.updateStatus = debounce(function () {
        var state = _this0.getState();
        var item = _this0.items[state.highlightedIndex];
        var resultCount = _this0.getItemCount();
        var status = _this0.props.getA11yStatusMessage(_objectSpread({
          itemToString: _this0.props.itemToString,
          previousResultCount: _this0.previousResultCount,
          resultCount: resultCount,
          highlightedItem: item
        }, state));
        _this0.previousResultCount = resultCount;
        setStatus(status, _this0.props.environment.document);
      }, 200);
      // fancy destructuring + defaults + aliases
      // this basically says each value of state should either be set to
      // the initial value or the default value if the initial value is not provided
      var _this0$props = _this0.props,
        defaultHighlightedIndex = _this0$props.defaultHighlightedIndex,
        _this0$props$initialH = _this0$props.initialHighlightedIndex,
        _highlightedIndex = _this0$props$initialH === void 0 ? defaultHighlightedIndex : _this0$props$initialH,
        defaultIsOpen = _this0$props.defaultIsOpen,
        _this0$props$initialI = _this0$props.initialIsOpen,
        _isOpen = _this0$props$initialI === void 0 ? defaultIsOpen : _this0$props$initialI,
        _this0$props$initialI2 = _this0$props.initialInputValue,
        _inputValue = _this0$props$initialI2 === void 0 ? '' : _this0$props$initialI2,
        _this0$props$initialS = _this0$props.initialSelectedItem,
        _selectedItem = _this0$props$initialS === void 0 ? null : _this0$props$initialS;
      var _state = _this0.getState({
        highlightedIndex: _highlightedIndex,
        isOpen: _isOpen,
        inputValue: _inputValue,
        selectedItem: _selectedItem
      });
      if (_state.selectedItem != null && _this0.props.initialInputValue === undefined) {
        _state.inputValue = _this0.props.itemToString(_state.selectedItem);
      }
      _this0.state = _state;
      return _this0;
    }

    /**
     * Clear all running timeouts
     */
    _inherits2(Downshift, _Component);
    return _createClass2(Downshift, [{
      key: "internalClearTimeouts",
      value: function internalClearTimeouts() {
        this.timeoutIds.forEach(function (id) {
          clearTimeout(id);
        });
        this.timeoutIds = [];
      }
      /**
       * Gets the state based on internal state or props
       * If a state value is passed via props, then that
       * is the value given, otherwise it's retrieved from
       * stateToMerge
       *
       * @param {Object} stateToMerge defaults to this.state
       * @return {Object} the state
       */
    }, {
      key: "getState",
      value: function getState(stateToMerge) {
        if (stateToMerge === void 0) {
          stateToMerge = this.state;
        }
        return _getState(stateToMerge, this.props);
      }
    }, {
      key: "getItemCount",
      value: function getItemCount() {
        // things read better this way. They're in priority order:
        // 1. `this.itemCount`
        // 2. `this.props.itemCount`
        // 3. `this.items.length`
        var itemCount = this.items.length;
        if (this.itemCount != null) {
          itemCount = this.itemCount;
        } else if (this.props.itemCount !== undefined) {
          itemCount = this.props.itemCount;
        }
        return itemCount;
      }
    }, {
      key: "getItemNodeFromIndex",
      value: function getItemNodeFromIndex(index) {
        return this.props.environment.document.getElementById(this.getItemId(index));
      }
    }, {
      key: "scrollHighlightedItemIntoView",
      value: function scrollHighlightedItemIntoView() {
        /* istanbul ignore else (react-native) */
        {
          var node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
          this.props.scrollIntoView(node, this._menuNode);
        }
      }
    }, {
      key: "moveHighlightedIndex",
      value: function moveHighlightedIndex(amount, otherStateToSet) {
        var _this13 = this;
        var itemCount = this.getItemCount();
        var _this$getState8 = this.getState(),
          highlightedIndex = _this$getState8.highlightedIndex;
        if (itemCount > 0) {
          var nextHighlightedIndex = getNextWrappingIndex(amount, highlightedIndex, itemCount, function (index) {
            return _this13.getItemNodeFromIndex(index);
          });
          this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
        }
      }
    }, {
      key: "getStateAndHelpers",
      value: function getStateAndHelpers() {
        var _this$getState9 = this.getState(),
          highlightedIndex = _this$getState9.highlightedIndex,
          inputValue = _this$getState9.inputValue,
          selectedItem = _this$getState9.selectedItem,
          isOpen = _this$getState9.isOpen;
        var itemToString = this.props.itemToString;
        var id = this.id;
        var getRootProps = this.getRootProps,
          getToggleButtonProps = this.getToggleButtonProps,
          getLabelProps = this.getLabelProps,
          getMenuProps = this.getMenuProps,
          getInputProps = this.getInputProps,
          getItemProps = this.getItemProps,
          openMenu = this.openMenu,
          closeMenu = this.closeMenu,
          toggleMenu = this.toggleMenu,
          selectItem = this.selectItem,
          selectItemAtIndex = this.selectItemAtIndex,
          selectHighlightedItem = this.selectHighlightedItem,
          setHighlightedIndex = this.setHighlightedIndex,
          clearSelection = this.clearSelection,
          clearItems = this.clearItems,
          reset = this.reset,
          setItemCount = this.setItemCount,
          unsetItemCount = this.unsetItemCount,
          setState = this.internalSetState;
        return {
          // prop getters
          getRootProps: getRootProps,
          getToggleButtonProps: getToggleButtonProps,
          getLabelProps: getLabelProps,
          getMenuProps: getMenuProps,
          getInputProps: getInputProps,
          getItemProps: getItemProps,
          // actions
          reset: reset,
          openMenu: openMenu,
          closeMenu: closeMenu,
          toggleMenu: toggleMenu,
          selectItem: selectItem,
          selectItemAtIndex: selectItemAtIndex,
          selectHighlightedItem: selectHighlightedItem,
          setHighlightedIndex: setHighlightedIndex,
          clearSelection: clearSelection,
          clearItems: clearItems,
          setItemCount: setItemCount,
          unsetItemCount: unsetItemCount,
          setState: setState,
          // props
          itemToString: itemToString,
          // derived
          id: id,
          // state
          highlightedIndex: highlightedIndex,
          inputValue: inputValue,
          isOpen: isOpen,
          selectedItem: selectedItem
        };
      } //////////////////////////// ROOT
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this14 = this;
        /* istanbul ignore if (react-native) */
        if (process.env.NODE_ENV !== 'production' && !false && this.getMenuProps.called && !this.getMenuProps.suppressRefError) {
          validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps);
        }
        /* istanbul ignore if (react-native) */

        {
          // this.isMouseDown helps us track whether the mouse is currently held down.
          // This is useful when the user clicks on an item in the list, but holds the mouse
          // down long enough for the list to disappear (because the blur event fires on the input)
          // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
          // trigger hiding the menu.
          var onMouseDown = function onMouseDown() {
            _this14.isMouseDown = true;
          };
          var onMouseUp = function onMouseUp(event) {
            _this14.isMouseDown = false; // if the target element or the activeElement is within a downshift node
            // then we don't want to reset downshift

            var contextWithinDownshift = targetWithinDownshift(event.target, [_this14._rootNode, _this14._menuNode], _this14.props.environment);
            if (!contextWithinDownshift && _this14.getState().isOpen) {
              _this14.reset({
                type: mouseUp
              }, function () {
                return _this14.props.onOuterClick(_this14.getStateAndHelpers());
              });
            }
          }; // Touching an element in iOS gives focus and hover states, but touching out of
          // the element will remove hover, and persist the focus state, resulting in the
          // blur event not being triggered.
          // this.isTouchMove helps us track whether the user is tapping or swiping on a touch screen.
          // If the user taps outside of Downshift, the component should be reset,
          // but not if the user is swiping

          var onTouchStart = function onTouchStart() {
            _this14.isTouchMove = false;
          };
          var onTouchMove = function onTouchMove() {
            _this14.isTouchMove = true;
          };
          var onTouchEnd = function onTouchEnd(event) {
            var contextWithinDownshift = targetWithinDownshift(event.target, [_this14._rootNode, _this14._menuNode], _this14.props.environment, false);
            if (!_this14.isTouchMove && !contextWithinDownshift && _this14.getState().isOpen) {
              _this14.reset({
                type: touchEnd
              }, function () {
                return _this14.props.onOuterClick(_this14.getStateAndHelpers());
              });
            }
          };
          var environment = this.props.environment;
          environment.addEventListener('mousedown', onMouseDown);
          environment.addEventListener('mouseup', onMouseUp);
          environment.addEventListener('touchstart', onTouchStart);
          environment.addEventListener('touchmove', onTouchMove);
          environment.addEventListener('touchend', onTouchEnd);
          this.cleanup = function () {
            _this14.internalClearTimeouts();
            _this14.updateStatus.cancel();
            environment.removeEventListener('mousedown', onMouseDown);
            environment.removeEventListener('mouseup', onMouseUp);
            environment.removeEventListener('touchstart', onTouchStart);
            environment.removeEventListener('touchmove', onTouchMove);
            environment.removeEventListener('touchend', onTouchEnd);
          };
        }
      }
    }, {
      key: "shouldScroll",
      value: function shouldScroll(prevState, prevProps) {
        var _ref67 = this.props.highlightedIndex === undefined ? this.getState() : this.props,
          currentHighlightedIndex = _ref67.highlightedIndex;
        var _ref68 = prevProps.highlightedIndex === undefined ? prevState : prevProps,
          prevHighlightedIndex = _ref68.highlightedIndex;
        var scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen;
        var scrollWhenNavigating = currentHighlightedIndex !== prevHighlightedIndex;
        return scrollWhenOpen || scrollWhenNavigating;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        if (process.env.NODE_ENV !== 'production') {
          validateControlledUnchanged(this.state, prevProps, this.props);
          /* istanbul ignore if (react-native) */

          if (this.getMenuProps.called && !this.getMenuProps.suppressRefError) {
            validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps);
          }
        }
        if (isControlledProp(this.props, 'selectedItem') && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) {
          this.internalSetState({
            type: controlledPropUpdatedSelectedItem,
            inputValue: this.props.itemToString(this.props.selectedItem)
          });
        }
        if (!this.avoidScrolling && this.shouldScroll(prevState, prevProps)) {
          this.scrollHighlightedItemIntoView();
        }
        /* istanbul ignore else (react-native) */

        {
          this.updateStatus();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.cleanup(); // avoids memory leak
      }
    }, {
      key: "render",
      value: function render() {
        var children = unwrapArray(this.props.children, noop); // because the items are rerendered every time we call the children
        // we clear this out each render and it will be populated again as
        // getItemProps is called.

        this.clearItems(); // we reset this so we know whether the user calls getRootProps during
        // this render. If they do then we don't need to do anything,
        // if they don't then we need to clone the element they return and
        // apply the props for them.

        this.getRootProps.called = false;
        this.getRootProps.refKey = undefined;
        this.getRootProps.suppressRefError = undefined; // we do something similar for getMenuProps

        this.getMenuProps.called = false;
        this.getMenuProps.refKey = undefined;
        this.getMenuProps.suppressRefError = undefined; // we do something similar for getLabelProps

        this.getLabelProps.called = false; // and something similar for getInputProps

        this.getInputProps.called = false;
        var element = unwrapArray(children(this.getStateAndHelpers()));
        if (!element) {
          return null;
        }
        if (this.getRootProps.called || this.props.suppressRefError) {
          if (process.env.NODE_ENV !== 'production' && !this.getRootProps.suppressRefError && !this.props.suppressRefError) {
            validateGetRootPropsCalledCorrectly(element, this.getRootProps);
          }
          return element;
        } else if (isDOMElement(element)) {
          // they didn't apply the root props, but we can clone
          // this and apply the props ourselves
          return /*#__PURE__*/cloneElement(element, this.getRootProps(getElementProps(element)));
        }
        /* istanbul ignore else */

        if (process.env.NODE_ENV !== 'production') {
          // they didn't apply the root props, but they need to
          // otherwise we can't query around the autocomplete
          throw new Error('downshift: If you return a non-DOM element, you must apply the getRootProps function');
        }
        /* istanbul ignore next */

        return undefined;
      }
    }]);
  }(Component);
  Downshift.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: false,
    getA11yStatusMessage: getA11yStatusMessage$1,
    itemToString: function itemToString(i) {
      if (i == null) {
        return '';
      }
      if (process.env.NODE_ENV !== 'production' && isPlainObject(i) && !i.hasOwnProperty('toString')) {
        // eslint-disable-next-line no-console
        console.warn('downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.', 'The object that was passed:', i);
      }
      return String(i);
    },
    onStateChange: noop,
    onInputValueChange: noop,
    onUserAction: noop,
    onChange: noop,
    onSelect: noop,
    onOuterClick: noop,
    selectedItemChanged: function selectedItemChanged(prevItem, item) {
      return prevItem !== item;
    },
    environment: /* istanbul ignore next (ssr) */
    typeof window === 'undefined' ? {} : window,
    stateReducer: function stateReducer(state, stateToSet) {
      return stateToSet;
    },
    suppressRefError: false,
    scrollIntoView: scrollIntoView
  };
  Downshift.stateChangeTypes = stateChangeTypes$3;
  return Downshift;
}();
process.env.NODE_ENV !== "production" ? Downshift.propTypes = {
  children: propTypes.exports.func,
  defaultHighlightedIndex: propTypes.exports.number,
  defaultIsOpen: propTypes.exports.bool,
  initialHighlightedIndex: propTypes.exports.number,
  initialSelectedItem: propTypes.exports.any,
  initialInputValue: propTypes.exports.string,
  initialIsOpen: propTypes.exports.bool,
  getA11yStatusMessage: propTypes.exports.func,
  itemToString: propTypes.exports.func,
  onChange: propTypes.exports.func,
  onSelect: propTypes.exports.func,
  onStateChange: propTypes.exports.func,
  onInputValueChange: propTypes.exports.func,
  onUserAction: propTypes.exports.func,
  onOuterClick: propTypes.exports.func,
  selectedItemChanged: propTypes.exports.func,
  stateReducer: propTypes.exports.func,
  itemCount: propTypes.exports.number,
  id: propTypes.exports.string,
  environment: propTypes.exports.shape({
    addEventListener: propTypes.exports.func,
    removeEventListener: propTypes.exports.func,
    document: propTypes.exports.shape({
      getElementById: propTypes.exports.func,
      activeElement: propTypes.exports.any,
      body: propTypes.exports.any
    })
  }),
  suppressRefError: propTypes.exports.bool,
  scrollIntoView: propTypes.exports.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components

  /* eslint-disable react/no-unused-prop-types */
  selectedItem: propTypes.exports.any,
  isOpen: propTypes.exports.bool,
  inputValue: propTypes.exports.string,
  highlightedIndex: propTypes.exports.number,
  labelId: propTypes.exports.string,
  inputId: propTypes.exports.string,
  menuId: propTypes.exports.string,
  getItemId: propTypes.exports.func
  /* eslint-enable react/no-unused-prop-types */
} : void 0;
function validateGetMenuPropsCalledCorrectly(node, _ref3) {
  var refKey = _ref3.refKey;
  if (!node) {
    // eslint-disable-next-line no-console
    console.error("downshift: The ref prop \"".concat(refKey, "\" from getMenuProps was not applied correctly on your menu element."));
  }
}
function validateGetRootPropsCalledCorrectly(element, _ref4) {
  var refKey = _ref4.refKey;
  var refKeySpecified = refKey !== 'ref';
  var isComposite = !isDOMElement(element);
  if (isComposite && !refKeySpecified && !reactIs$1.exports.isForwardRef(element)) {
    // eslint-disable-next-line no-console
    console.error('downshift: You returned a non-DOM element. You must specify a refKey in getRootProps');
  } else if (!isComposite && refKeySpecified) {
    // eslint-disable-next-line no-console
    console.error("downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified \"".concat(refKey, "\""));
  }
  if (!reactIs$1.exports.isForwardRef(element) && !getElementProps(element)[refKey]) {
    // eslint-disable-next-line no-console
    console.error("downshift: You must apply the ref prop \"".concat(refKey, "\" from getRootProps onto your root element."));
  }
}
var dropdownDefaultStateValues = {
  highlightedIndex: -1,
  isOpen: false,
  selectedItem: null,
  inputValue: ''
};
function callOnChangeProps(action, state, newState) {
  var props = action.props,
    type = action.type;
  var changes = {};
  Object.keys(state).forEach(function (key) {
    invokeOnChangeHandler(key, action, state, newState);
    if (newState[key] !== state[key]) {
      changes[key] = newState[key];
    }
  });
  if (props.onStateChange && Object.keys(changes).length) {
    props.onStateChange(_objectSpread({
      type: type
    }, changes));
  }
}
function invokeOnChangeHandler(key, action, state, newState) {
  var props = action.props,
    type = action.type;
  var handler = "on".concat(capitalizeString(key), "Change");
  if (props[handler] && newState[key] !== undefined && newState[key] !== state[key]) {
    props[handler](_objectSpread({
      type: type
    }, newState));
  }
}
/**
 * Default state reducer that returns the changes.
 *
 * @param {Object} s state.
 * @param {Object} a action with changes.
 * @returns {Object} changes.
 */

function stateReducer(s, a) {
  return a.changes;
}
/**
 * Returns a message to be added to aria-live region when item is selected.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */

function getA11ySelectionMessage(selectionParameters) {
  var selectedItem = selectionParameters.selectedItem,
    itemToStringLocal = selectionParameters.itemToString;
  return selectedItem ? "".concat(itemToStringLocal(selectedItem), " has been selected.") : '';
}
/**
 * Debounced call for updating the a11y message.
 */

var updateA11yStatus = debounce(function (getA11yMessage, document) {
  setStatus(getA11yMessage(), document);
}, 200); // istanbul ignore next

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;
function useElementIds(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? "downshift-".concat(generateId()) : _ref$id,
    labelId = _ref.labelId,
    menuId = _ref.menuId,
    getItemId = _ref.getItemId,
    toggleButtonId = _ref.toggleButtonId,
    inputId = _ref.inputId;
  var elementIdsRef = useRef({
    labelId: labelId || "".concat(id, "-label"),
    menuId: menuId || "".concat(id, "-menu"),
    getItemId: getItemId || function (index) {
      return "".concat(id, "-item-").concat(index);
    },
    toggleButtonId: toggleButtonId || "".concat(id, "-toggle-button"),
    inputId: inputId || "".concat(id, "-input")
  });
  return elementIdsRef.current;
}
function getItemIndex(index, item, items) {
  if (index !== undefined) {
    return index;
  }
  if (items.length === 0) {
    return -1;
  }
  return items.indexOf(item);
}
function itemToString(item) {
  return item ? String(item) : '';
}
function capitalizeString(string) {
  return "".concat(string.slice(0, 1).toUpperCase()).concat(string.slice(1));
}
function useLatestRef(val) {
  var ref = useRef(val); // technically this is not "concurrent mode safe" because we're manipulating
  // the value during render (so it's not idempotent). However, the places this
  // hook is used is to support memoizing callbacks which will be called
  // *during* render, so we need the latest values *during* render.
  // If not for this, then we'd probably want to use useLayoutEffect instead.

  ref.current = val;
  return ref;
}
/**
 * Computes the controlled state using a the previous state, props,
 * two reducers, one from downshift and an optional one from the user.
 * Also calls the onChange handlers for state values that have changed.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */

function useEnhancedReducer(reducer, initialState, props) {
  var prevStateRef = useRef();
  var actionRef = useRef();
  var enhancedReducer = useCallback(function (state, action) {
    actionRef.current = action;
    state = _getState(state, action.props);
    var changes = reducer(state, action);
    var newState = action.props.stateReducer(state, _objectSpread(_objectSpread({}, action), {}, {
      changes: changes
    }));
    return newState;
  }, [reducer]);
  var _useReducer = useReducer(enhancedReducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var propsRef = useLatestRef(props);
  var dispatchWithProps = useCallback(function (action) {
    return dispatch(_objectSpread({
      props: propsRef.current
    }, action));
  }, [propsRef]);
  var action = actionRef.current;
  useEffect(function () {
    if (action && prevStateRef.current && prevStateRef.current !== state) {
      callOnChangeProps(action, _getState(prevStateRef.current, action.props), state);
    }
    prevStateRef.current = state;
  }, [state, props, action]);
  return [state, dispatchWithProps];
}
var defaultProps$3 = {
  itemToString: itemToString,
  stateReducer: stateReducer,
  getA11ySelectionMessage: getA11ySelectionMessage,
  scrollIntoView: scrollIntoView,
  circularNavigation: false,
  environment: /* istanbul ignore next (ssr) */
  typeof window === 'undefined' ? {} : window
};
function getDefaultValue$1(props, propKey, defaultStateValues) {
  if (defaultStateValues === void 0) {
    defaultStateValues = dropdownDefaultStateValues;
  }
  var defaultValue = props["default".concat(capitalizeString(propKey))];
  if (defaultValue !== undefined) {
    return defaultValue;
  }
  return defaultStateValues[propKey];
}
function getInitialValue$1(props, propKey, defaultStateValues) {
  if (defaultStateValues === void 0) {
    defaultStateValues = dropdownDefaultStateValues;
  }
  var value = props[propKey];
  if (value !== undefined) {
    return value;
  }
  var initialValue = props["initial".concat(capitalizeString(propKey))];
  if (initialValue !== undefined) {
    return initialValue;
  }
  return getDefaultValue$1(props, propKey, defaultStateValues);
}
function getInitialState$2(props) {
  var selectedItem = getInitialValue$1(props, 'selectedItem');
  var isOpen = getInitialValue$1(props, 'isOpen');
  var highlightedIndex = getInitialValue$1(props, 'highlightedIndex');
  var inputValue = getInitialValue$1(props, 'inputValue');
  return {
    highlightedIndex: highlightedIndex < 0 && selectedItem && isOpen ? props.items.indexOf(selectedItem) : highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}
function getHighlightedIndexOnOpen(props, state, offset, getItemNodeFromIndex) {
  var items = props.items,
    initialHighlightedIndex = props.initialHighlightedIndex,
    defaultHighlightedIndex = props.defaultHighlightedIndex;
  var selectedItem = state.selectedItem,
    highlightedIndex = state.highlightedIndex;
  if (items.length === 0) {
    return -1;
  } // initialHighlightedIndex will give value to highlightedIndex on initial state only.

  if (initialHighlightedIndex !== undefined && highlightedIndex === initialHighlightedIndex) {
    return initialHighlightedIndex;
  }
  if (defaultHighlightedIndex !== undefined) {
    return defaultHighlightedIndex;
  }
  if (selectedItem) {
    if (offset === 0) {
      return items.indexOf(selectedItem);
    }
    return getNextWrappingIndex(offset, items.indexOf(selectedItem), items.length, getItemNodeFromIndex, false);
  }
  if (offset === 0) {
    return -1;
  }
  return offset < 0 ? items.length - 1 : 0;
}
/**
 * Reuse the movement tracking of mouse and touch events.
 *
 * @param {boolean} isOpen Whether the dropdown is open or not.
 * @param {Array<Object>} downshiftElementRefs Downshift element refs to track movement (toggleButton, menu etc.)
 * @param {Object} environment Environment where component/hook exists.
 * @param {Function} handleBlur Handler on blur from mouse or touch.
 * @returns {Object} Ref containing whether mouseDown or touchMove event is happening
 */

function useMouseAndTouchTracker(isOpen, downshiftElementRefs, environment, handleBlur) {
  var mouseAndTouchTrackersRef = useRef({
    isMouseDown: false,
    isTouchMove: false
  });
  useEffect(function () {
    // The same strategy for checking if a click occurred inside or outside downsift
    // as in downshift.js.
    var onMouseDown = function onMouseDown() {
      mouseAndTouchTrackersRef.current.isMouseDown = true;
    };
    var onMouseUp = function onMouseUp(event) {
      mouseAndTouchTrackersRef.current.isMouseDown = false;
      if (isOpen && !targetWithinDownshift(event.target, downshiftElementRefs.map(function (ref) {
        return ref.current;
      }), environment)) {
        handleBlur();
      }
    };
    var onTouchStart = function onTouchStart() {
      mouseAndTouchTrackersRef.current.isTouchMove = false;
    };
    var onTouchMove = function onTouchMove() {
      mouseAndTouchTrackersRef.current.isTouchMove = true;
    };
    var onTouchEnd = function onTouchEnd(event) {
      if (isOpen && !mouseAndTouchTrackersRef.current.isTouchMove && !targetWithinDownshift(event.target, downshiftElementRefs.map(function (ref) {
        return ref.current;
      }), environment, false)) {
        handleBlur();
      }
    };
    environment.addEventListener('mousedown', onMouseDown);
    environment.addEventListener('mouseup', onMouseUp);
    environment.addEventListener('touchstart', onTouchStart);
    environment.addEventListener('touchmove', onTouchMove);
    environment.addEventListener('touchend', onTouchEnd);
    return function cleanup() {
      environment.removeEventListener('mousedown', onMouseDown);
      environment.removeEventListener('mouseup', onMouseUp);
      environment.removeEventListener('touchstart', onTouchStart);
      environment.removeEventListener('touchmove', onTouchMove);
      environment.removeEventListener('touchend', onTouchEnd);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, environment]);
  return mouseAndTouchTrackersRef;
}
/* istanbul ignore next */
// eslint-disable-next-line import/no-mutable-exports

var useGetterPropsCalledChecker = function useGetterPropsCalledChecker() {
  return noop;
};
/**
 * Custom hook that checks if getter props are called correctly.
 *
 * @param  {...any} propKeys Getter prop names to be handled.
 * @returns {Function} Setter function called inside getter props to set call information.
 */

/* istanbul ignore next */

if (process.env.NODE_ENV !== 'production') {
  useGetterPropsCalledChecker = function useGetterPropsCalledChecker() {
    var isInitialMountRef = useRef(true);
    for (var _len = arguments.length, propKeys = new Array(_len), _key = 0; _key < _len; _key++) {
      propKeys[_key] = arguments[_key];
    }
    var getterPropsCalledRef = useRef(propKeys.reduce(function (acc, propKey) {
      acc[propKey] = {};
      return acc;
    }, {}));
    useEffect(function () {
      Object.keys(getterPropsCalledRef.current).forEach(function (propKey) {
        var propCallInfo = getterPropsCalledRef.current[propKey];
        if (isInitialMountRef.current) {
          if (!Object.keys(propCallInfo).length) {
            // eslint-disable-next-line no-console
            console.error("downshift: You forgot to call the ".concat(propKey, " getter function on your component / element."));
            return;
          }
        }
        var suppressRefError = propCallInfo.suppressRefError,
          refKey = propCallInfo.refKey,
          elementRef = propCallInfo.elementRef;
        if ((!elementRef || !elementRef.current) && !suppressRefError) {
          // eslint-disable-next-line no-console
          console.error("downshift: The ref prop \"".concat(refKey, "\" from ").concat(propKey, " was not applied correctly on your element."));
        }
      });
      isInitialMountRef.current = false;
    });
    var setGetterPropCallInfo = useCallback(function (propKey, suppressRefError, refKey, elementRef) {
      getterPropsCalledRef.current[propKey] = {
        suppressRefError: suppressRefError,
        refKey: refKey,
        elementRef: elementRef
      };
    }, []);
    return setGetterPropCallInfo;
  };
}
function useA11yMessageSetter(getA11yMessage, dependencyArray, _ref2) {
  var isInitialMount = _ref2.isInitialMount,
    highlightedIndex = _ref2.highlightedIndex,
    items = _ref2.items,
    environment = _ref2.environment,
    rest = _objectWithoutProperties2(_ref2, _excluded9);
  // Sets a11y status message on changes in state.
  useEffect(function () {
    if (isInitialMount || false) {
      return;
    }
    updateA11yStatus(function () {
      return getA11yMessage(_objectSpread({
        highlightedIndex: highlightedIndex,
        highlightedItem: items[highlightedIndex],
        resultCount: items.length
      }, rest));
    }, environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencyArray);
}
function useScrollIntoView(_ref3) {
  var highlightedIndex = _ref3.highlightedIndex,
    isOpen = _ref3.isOpen,
    itemRefs = _ref3.itemRefs,
    getItemNodeFromIndex = _ref3.getItemNodeFromIndex,
    menuElement = _ref3.menuElement,
    scrollIntoViewProp = _ref3.scrollIntoView;
  // used not to scroll on highlight by mouse.
  var shouldScrollRef = useRef(true); // Scroll on highlighted item if change comes from keyboard.

  useIsomorphicLayoutEffect(function () {
    if (highlightedIndex < 0 || !isOpen || !Object.keys(itemRefs.current).length) {
      return;
    }
    if (shouldScrollRef.current === false) {
      shouldScrollRef.current = true;
    } else {
      scrollIntoViewProp(getItemNodeFromIndex(highlightedIndex), menuElement);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [highlightedIndex]);
  return shouldScrollRef;
} // eslint-disable-next-line import/no-mutable-exports

var useControlPropsValidator = noop;
/* istanbul ignore next */

if (process.env.NODE_ENV !== 'production') {
  useControlPropsValidator = function useControlPropsValidator(_ref4) {
    var isInitialMount = _ref4.isInitialMount,
      props = _ref4.props,
      state = _ref4.state;
    // used for checking when props are moving from controlled to uncontrolled.
    var prevPropsRef = useRef(props);
    useEffect(function () {
      if (isInitialMount) {
        return;
      }
      validateControlledUnchanged(state, prevPropsRef.current, props);
      prevPropsRef.current = props;
    }, [state, props, isInitialMount]);
  };
}

/* eslint-disable complexity */

function downshiftCommonReducer(state, action, stateChangeTypes) {
  var type = action.type,
    props = action.props;
  var changes;
  switch (type) {
    case stateChangeTypes.ItemMouseMove:
      changes = {
        highlightedIndex: action.disabled ? -1 : action.index
      };
      break;
    case stateChangeTypes.MenuMouseLeave:
      changes = {
        highlightedIndex: -1
      };
      break;
    case stateChangeTypes.ToggleButtonClick:
    case stateChangeTypes.FunctionToggleMenu:
      changes = {
        isOpen: !state.isOpen,
        highlightedIndex: state.isOpen ? -1 : getHighlightedIndexOnOpen(props, state, 0)
      };
      break;
    case stateChangeTypes.FunctionOpenMenu:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
      };
      break;
    case stateChangeTypes.FunctionCloseMenu:
      changes = {
        isOpen: false
      };
      break;
    case stateChangeTypes.FunctionSetHighlightedIndex:
      changes = {
        highlightedIndex: action.highlightedIndex
      };
      break;
    case stateChangeTypes.FunctionSetInputValue:
      changes = {
        inputValue: action.inputValue
      };
      break;
    case stateChangeTypes.FunctionReset:
      changes = {
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        isOpen: getDefaultValue$1(props, 'isOpen'),
        selectedItem: getDefaultValue$1(props, 'selectedItem'),
        inputValue: getDefaultValue$1(props, 'inputValue')
      };
      break;
    default:
      throw new Error('Reducer called without proper action type.');
  }
  return _objectSpread(_objectSpread({}, state), changes);
}
({
  items: propTypes.exports.array.isRequired,
  itemToString: propTypes.exports.func,
  getA11yStatusMessage: propTypes.exports.func,
  getA11ySelectionMessage: propTypes.exports.func,
  circularNavigation: propTypes.exports.bool,
  highlightedIndex: propTypes.exports.number,
  defaultHighlightedIndex: propTypes.exports.number,
  initialHighlightedIndex: propTypes.exports.number,
  isOpen: propTypes.exports.bool,
  defaultIsOpen: propTypes.exports.bool,
  initialIsOpen: propTypes.exports.bool,
  selectedItem: propTypes.exports.any,
  initialSelectedItem: propTypes.exports.any,
  defaultSelectedItem: propTypes.exports.any,
  id: propTypes.exports.string,
  labelId: propTypes.exports.string,
  menuId: propTypes.exports.string,
  getItemId: propTypes.exports.func,
  toggleButtonId: propTypes.exports.string,
  stateReducer: propTypes.exports.func,
  onSelectedItemChange: propTypes.exports.func,
  onHighlightedIndexChange: propTypes.exports.func,
  onStateChange: propTypes.exports.func,
  onIsOpenChange: propTypes.exports.func,
  environment: propTypes.exports.shape({
    addEventListener: propTypes.exports.func,
    removeEventListener: propTypes.exports.func,
    document: propTypes.exports.shape({
      getElementById: propTypes.exports.func,
      activeElement: propTypes.exports.any,
      body: propTypes.exports.any
    })
  })
});
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specift if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */
function getA11yStatusMessage(_a) {
  var isOpen = _a.isOpen,
    resultCount = _a.resultCount,
    previousResultCount = _a.previousResultCount;
  if (!isOpen) {
    return '';
  }
  if (!resultCount) {
    return 'No results are available.';
  }
  if (resultCount !== previousResultCount) {
    return "".concat(resultCount, " result").concat(resultCount === 1 ? ' is' : 's are', " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.");
  }
  return '';
}
_assign(_assign({}, defaultProps$3), {
  getA11yStatusMessage: getA11yStatusMessage
});
/* istanbul ignore next */
if (process.env.NODE_ENV !== 'production') ;
process.env.NODE_ENV !== "production" ? '__menu_keydown_arrow_down__' : 0;
process.env.NODE_ENV !== "production" ? '__menu_keydown_arrow_up__' : 1;
process.env.NODE_ENV !== "production" ? '__menu_keydown_escape__' : 2;
process.env.NODE_ENV !== "production" ? '__menu_keydown_home__' : 3;
process.env.NODE_ENV !== "production" ? '__menu_keydown_end__' : 4;
process.env.NODE_ENV !== "production" ? '__menu_keydown_enter__' : 5;
process.env.NODE_ENV !== "production" ? '__menu_keydown_space_button__' : 6;
process.env.NODE_ENV !== "production" ? '__menu_keydown_character__' : 7;
process.env.NODE_ENV !== "production" ? '__menu_blur__' : 8;
process.env.NODE_ENV !== "production" ? '__menu_mouse_leave__' : 9;
process.env.NODE_ENV !== "production" ? '__item_mouse_move__' : 10;
process.env.NODE_ENV !== "production" ? '__item_click__' : 11;
process.env.NODE_ENV !== "production" ? '__togglebutton_click__' : 12;
process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_arrow_down__' : 13;
process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_arrow_up__' : 14;
process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_character__' : 15;
process.env.NODE_ENV !== "production" ? '__function_toggle_menu__' : 16;
process.env.NODE_ENV !== "production" ? '__function_open_menu__' : 17;
process.env.NODE_ENV !== "production" ? '__function_close_menu__' : 18;
process.env.NODE_ENV !== "production" ? '__function_set_highlighted_index__' : 19;
process.env.NODE_ENV !== "production" ? '__function_select_item__' : 20;
process.env.NODE_ENV !== "production" ? '__function_set_input_value__' : 21;
process.env.NODE_ENV !== "production" ? '__function_reset__' : 22;
var InputKeyDownArrowDown = process.env.NODE_ENV !== "production" ? '__input_keydown_arrow_down__' : 0;
var InputKeyDownArrowUp = process.env.NODE_ENV !== "production" ? '__input_keydown_arrow_up__' : 1;
var InputKeyDownEscape = process.env.NODE_ENV !== "production" ? '__input_keydown_escape__' : 2;
var InputKeyDownHome = process.env.NODE_ENV !== "production" ? '__input_keydown_home__' : 3;
var InputKeyDownEnd = process.env.NODE_ENV !== "production" ? '__input_keydown_end__' : 4;
var InputKeyDownEnter = process.env.NODE_ENV !== "production" ? '__input_keydown_enter__' : 5;
var InputChange = process.env.NODE_ENV !== "production" ? '__input_change__' : 6;
var InputBlur = process.env.NODE_ENV !== "production" ? '__input_blur__' : 7;
var MenuMouseLeave = process.env.NODE_ENV !== "production" ? '__menu_mouse_leave__' : 8;
var ItemMouseMove = process.env.NODE_ENV !== "production" ? '__item_mouse_move__' : 9;
var ItemClick = process.env.NODE_ENV !== "production" ? '__item_click__' : 10;
var ToggleButtonClick = process.env.NODE_ENV !== "production" ? '__togglebutton_click__' : 11;
var FunctionToggleMenu = process.env.NODE_ENV !== "production" ? '__function_toggle_menu__' : 12;
var FunctionOpenMenu = process.env.NODE_ENV !== "production" ? '__function_open_menu__' : 13;
var FunctionCloseMenu = process.env.NODE_ENV !== "production" ? '__function_close_menu__' : 14;
var FunctionSetHighlightedIndex = process.env.NODE_ENV !== "production" ? '__function_set_highlighted_index__' : 15;
var FunctionSelectItem = process.env.NODE_ENV !== "production" ? '__function_select_item__' : 16;
var FunctionSetInputValue = process.env.NODE_ENV !== "production" ? '__function_set_input_value__' : 17;
var FunctionReset$1 = process.env.NODE_ENV !== "production" ? '__function_reset__' : 18;
var ControlledPropUpdatedSelectedItem = process.env.NODE_ENV !== "production" ? '__controlled_prop_updated_selected_item__' : 19;
var stateChangeTypes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: InputKeyDownArrowDown,
  InputKeyDownArrowUp: InputKeyDownArrowUp,
  InputKeyDownEscape: InputKeyDownEscape,
  InputKeyDownHome: InputKeyDownHome,
  InputKeyDownEnd: InputKeyDownEnd,
  InputKeyDownEnter: InputKeyDownEnter,
  InputChange: InputChange,
  InputBlur: InputBlur,
  MenuMouseLeave: MenuMouseLeave,
  ItemMouseMove: ItemMouseMove,
  ItemClick: ItemClick,
  ToggleButtonClick: ToggleButtonClick,
  FunctionToggleMenu: FunctionToggleMenu,
  FunctionOpenMenu: FunctionOpenMenu,
  FunctionCloseMenu: FunctionCloseMenu,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex,
  FunctionSelectItem: FunctionSelectItem,
  FunctionSetInputValue: FunctionSetInputValue,
  FunctionReset: FunctionReset$1,
  ControlledPropUpdatedSelectedItem: ControlledPropUpdatedSelectedItem
});
function getInitialState$1(props) {
  var initialState = getInitialState$2(props);
  var selectedItem = initialState.selectedItem;
  var inputValue = initialState.inputValue;
  if (inputValue === '' && selectedItem && props.defaultInputValue === undefined && props.initialInputValue === undefined && props.inputValue === undefined) {
    inputValue = props.itemToString(selectedItem);
  }
  return _objectSpread(_objectSpread({}, initialState), {}, {
    inputValue: inputValue
  });
}
var propTypes$1 = {
  items: propTypes.exports.array.isRequired,
  itemToString: propTypes.exports.func,
  getA11yStatusMessage: propTypes.exports.func,
  getA11ySelectionMessage: propTypes.exports.func,
  circularNavigation: propTypes.exports.bool,
  highlightedIndex: propTypes.exports.number,
  defaultHighlightedIndex: propTypes.exports.number,
  initialHighlightedIndex: propTypes.exports.number,
  isOpen: propTypes.exports.bool,
  defaultIsOpen: propTypes.exports.bool,
  initialIsOpen: propTypes.exports.bool,
  selectedItem: propTypes.exports.any,
  initialSelectedItem: propTypes.exports.any,
  defaultSelectedItem: propTypes.exports.any,
  inputValue: propTypes.exports.string,
  defaultInputValue: propTypes.exports.string,
  initialInputValue: propTypes.exports.string,
  id: propTypes.exports.string,
  labelId: propTypes.exports.string,
  menuId: propTypes.exports.string,
  getItemId: propTypes.exports.func,
  inputId: propTypes.exports.string,
  toggleButtonId: propTypes.exports.string,
  stateReducer: propTypes.exports.func,
  onSelectedItemChange: propTypes.exports.func,
  onHighlightedIndexChange: propTypes.exports.func,
  onStateChange: propTypes.exports.func,
  onIsOpenChange: propTypes.exports.func,
  onInputValueChange: propTypes.exports.func,
  environment: propTypes.exports.shape({
    addEventListener: propTypes.exports.func,
    removeEventListener: propTypes.exports.func,
    document: propTypes.exports.shape({
      getElementById: propTypes.exports.func,
      activeElement: propTypes.exports.any,
      body: propTypes.exports.any
    })
  })
};
/**
 * The useCombobox version of useControlledReducer, which also
 * checks if the controlled prop selectedItem changed between
 * renders. If so, it will also update inputValue with its
 * string equivalent. It uses the common useEnhancedReducer to
 * compute the rest of the state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */

function useControlledReducer(reducer, initialState, props) {
  var previousSelectedItemRef = useRef();
  var _useEnhancedReducer = useEnhancedReducer(reducer, initialState, props),
    _useEnhancedReducer2 = _slicedToArray(_useEnhancedReducer, 2),
    state = _useEnhancedReducer2[0],
    dispatch = _useEnhancedReducer2[1]; // ToDo: if needed, make same approach as selectedItemChanged from Downshift.

  useEffect(function () {
    if (isControlledProp(props, 'selectedItem')) {
      if (previousSelectedItemRef.current !== props.selectedItem) {
        dispatch({
          type: ControlledPropUpdatedSelectedItem,
          inputValue: props.itemToString(props.selectedItem)
        });
      }
      previousSelectedItemRef.current = state.selectedItem === previousSelectedItemRef.current ? props.selectedItem : state.selectedItem;
    }
  });
  return [_getState(state, props), dispatch];
} // eslint-disable-next-line import/no-mutable-exports

var validatePropTypes$1 = noop;
/* istanbul ignore next */

if (process.env.NODE_ENV !== 'production') {
  validatePropTypes$1 = function validatePropTypes$1(options, caller) {
    propTypes.exports.checkPropTypes(propTypes$1, options, 'prop', caller.name);
  };
}
var defaultProps$1 = _objectSpread(_objectSpread({}, defaultProps$3), {}, {
  getA11yStatusMessage: getA11yStatusMessage$1,
  circularNavigation: true
});

/* eslint-disable complexity */

function downshiftUseComboboxReducer(state, action) {
  var type = action.type,
    props = action.props,
    shiftKey = action.shiftKey;
  var changes;
  switch (type) {
    case ItemClick:
      changes = {
        isOpen: getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        selectedItem: props.items[action.index],
        inputValue: props.itemToString(props.items[action.index])
      };
      break;
    case InputKeyDownArrowDown:
      if (state.isOpen) {
        changes = {
          highlightedIndex: getNextWrappingIndex(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
        };
      } else {
        changes = {
          highlightedIndex: getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
          isOpen: props.items.length >= 0
        };
      }
      break;
    case InputKeyDownArrowUp:
      if (state.isOpen) {
        changes = {
          highlightedIndex: getNextWrappingIndex(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
        };
      } else {
        changes = {
          highlightedIndex: getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
          isOpen: props.items.length >= 0
        };
      }
      break;
    case InputKeyDownEnter:
      changes = _objectSpread({}, state.isOpen && state.highlightedIndex >= 0 && {
        selectedItem: props.items[state.highlightedIndex],
        isOpen: getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        inputValue: props.itemToString(props.items[state.highlightedIndex])
      });
      break;
    case InputKeyDownEscape:
      changes = _objectSpread({
        isOpen: false,
        highlightedIndex: -1
      }, !state.isOpen && {
        selectedItem: null,
        inputValue: ''
      });
      break;
    case InputKeyDownHome:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case InputKeyDownEnd:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case InputBlur:
      changes = _objectSpread({
        isOpen: false,
        highlightedIndex: -1
      }, state.highlightedIndex >= 0 && action.selectItem && {
        selectedItem: props.items[state.highlightedIndex],
        inputValue: props.itemToString(props.items[state.highlightedIndex])
      });
      break;
    case InputChange:
      changes = {
        isOpen: true,
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        inputValue: action.inputValue
      };
      break;
    case FunctionSelectItem:
      changes = {
        selectedItem: action.selectedItem,
        inputValue: props.itemToString(action.selectedItem)
      };
      break;
    case ControlledPropUpdatedSelectedItem:
      changes = {
        inputValue: action.inputValue
      };
      break;
    default:
      return downshiftCommonReducer(state, action, stateChangeTypes$1);
  }
  return _objectSpread(_objectSpread({}, state), changes);
}
/* eslint-enable complexity */

/* eslint-disable max-statements */
useCombobox.stateChangeTypes = stateChangeTypes$1;
function useCombobox(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }
  validatePropTypes$1(userProps, useCombobox); // Props defaults and destructuring.

  var props = _objectSpread(_objectSpread({}, defaultProps$1), userProps);
  var initialIsOpen = props.initialIsOpen,
    defaultIsOpen = props.defaultIsOpen,
    items = props.items,
    scrollIntoView = props.scrollIntoView,
    environment = props.environment,
    getA11yStatusMessage = props.getA11yStatusMessage,
    getA11ySelectionMessage = props.getA11ySelectionMessage,
    itemToString = props.itemToString; // Initial state depending on controlled props.

  var initialState = getInitialState$1(props);
  var _useControlledReducer = useControlledReducer(downshiftUseComboboxReducer, initialState, props),
    _useControlledReducer2 = _slicedToArray(_useControlledReducer, 2),
    state = _useControlledReducer2[0],
    dispatch = _useControlledReducer2[1];
  var isOpen = state.isOpen,
    highlightedIndex = state.highlightedIndex,
    selectedItem = state.selectedItem,
    inputValue = state.inputValue; // Element refs.

  var menuRef = useRef(null);
  var itemRefs = useRef({});
  var inputRef = useRef(null);
  var toggleButtonRef = useRef(null);
  var comboboxRef = useRef(null);
  var isInitialMountRef = useRef(true); // prevent id re-generation between renders.

  var elementIds = useElementIds(props); // used to keep track of how many items we had on previous cycle.

  var previousResultCountRef = useRef(); // utility callback to get item element.

  var latest = useLatestRef({
    state: state,
    props: props
  });
  var getItemNodeFromIndex = useCallback(function (index) {
    return itemRefs.current[elementIds.getItemId(index)];
  }, [elementIds]); // Effects.
  // Sets a11y status message on changes in state.

  useA11yMessageSetter(getA11yStatusMessage, [isOpen, highlightedIndex, inputValue, items], _objectSpread({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items: items,
    environment: environment,
    itemToString: itemToString
  }, state)); // Sets a11y status message on changes in selectedItem.

  useA11yMessageSetter(getA11ySelectionMessage, [selectedItem], _objectSpread({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items: items,
    environment: environment,
    itemToString: itemToString
  }, state)); // Scroll on highlighted item if change comes from keyboard.

  var shouldScrollRef = useScrollIntoView({
    menuElement: menuRef.current,
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    itemRefs: itemRefs,
    scrollIntoView: scrollIntoView,
    getItemNodeFromIndex: getItemNodeFromIndex
  });
  useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props: props,
    state: state
  }); // Focus the input on first render if required.

  useEffect(function () {
    var focusOnOpen = initialIsOpen || defaultIsOpen || isOpen;
    if (focusOnOpen && inputRef.current) {
      inputRef.current.focus();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (isInitialMountRef.current) {
      return;
    }
    previousResultCountRef.current = items.length;
  }); // Add mouse/touch events to document.

  var mouseAndTouchTrackersRef = useMouseAndTouchTracker(isOpen, [comboboxRef, menuRef, toggleButtonRef], environment, function () {
    dispatch({
      type: InputBlur,
      selectItem: false
    });
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker('getInputProps', 'getComboboxProps', 'getMenuProps'); // Make initial ref false.

  useEffect(function () {
    isInitialMountRef.current = false;
  }, []); // Reset itemRefs on close.

  useEffect(function () {
    if (!isOpen) {
      itemRefs.current = {};
    }
  }, [isOpen]);
  /* Event handler functions */

  var inputKeyDownHandlers = useMemo(function () {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch({
          type: InputKeyDownArrowDown,
          shiftKey: event.shiftKey,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch({
          type: InputKeyDownArrowUp,
          shiftKey: event.shiftKey,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      Home: function Home(event) {
        if (!latest.current.state.isOpen) {
          return;
        }
        event.preventDefault();
        dispatch({
          type: InputKeyDownHome,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      End: function End(event) {
        if (!latest.current.state.isOpen) {
          return;
        }
        event.preventDefault();
        dispatch({
          type: InputKeyDownEnd,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      Escape: function Escape(event) {
        var latestState = latest.current.state;
        if (latestState.isOpen || latestState.inputValue || latestState.selectedItem || latestState.highlightedIndex > -1) {
          event.preventDefault();
          dispatch({
            type: InputKeyDownEscape
          });
        }
      },
      Enter: function Enter(event) {
        var latestState = latest.current.state; // if closed or no highlighted index, do nothing.

        if (!latestState.isOpen || latestState.highlightedIndex < 0 || event.which === 229 // if IME composing, wait for next Enter keydown event.
        ) {
          return;
        }
        event.preventDefault();
        dispatch({
          type: InputKeyDownEnter,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      }
    };
  }, [dispatch, latest, getItemNodeFromIndex]); // Getter props.

  var getLabelProps = useCallback(function (labelProps) {
    return _objectSpread({
      id: elementIds.labelId,
      htmlFor: elementIds.inputId
    }, labelProps);
  }, [elementIds]);
  var getMenuProps = useCallback(function (_temp, _temp2) {
    var _ref69 = _temp === void 0 ? {} : _temp,
      onMouseLeave = _ref69.onMouseLeave,
      _ref69$refKey = _ref69.refKey,
      refKey = _ref69$refKey === void 0 ? 'ref' : _ref69$refKey,
      ref = _ref69.ref,
      rest = _objectWithoutProperties2(_ref69, _excluded0);
    var _ref70 = _temp2 === void 0 ? {} : _temp2,
      _ref70$suppressRefErr = _ref70.suppressRefError,
      suppressRefError = _ref70$suppressRefErr === void 0 ? false : _ref70$suppressRefErr;
    setGetterPropCallInfo('getMenuProps', suppressRefError, refKey, menuRef);
    return _objectSpread(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({}, refKey, handleRefs(ref, function (menuNode) {
      menuRef.current = menuNode;
    })), "id", elementIds.menuId), "role", 'listbox'), 'aria-labelledby', elementIds.labelId), "onMouseLeave", callAllEventHandlers(onMouseLeave, function () {
      dispatch({
        type: MenuMouseLeave
      });
    })), rest);
  }, [dispatch, setGetterPropCallInfo, elementIds]);
  var getItemProps = useCallback(function (_temp3) {
    var _ref71 = _temp3 === void 0 ? {} : _temp3,
      item = _ref71.item,
      index = _ref71.index,
      _ref71$refKey = _ref71.refKey,
      refKey = _ref71$refKey === void 0 ? 'ref' : _ref71$refKey,
      ref = _ref71.ref,
      onMouseMove = _ref71.onMouseMove,
      onMouseDown = _ref71.onMouseDown,
      onClick = _ref71.onClick,
      onPress = _ref71.onPress,
      disabled = _ref71.disabled,
      rest = _objectWithoutProperties2(_ref71, _excluded1);
    var _latest$current = latest.current,
      latestProps = _latest$current.props,
      latestState = _latest$current.state;
    var itemIndex = getItemIndex(index, item, latestProps.items);
    if (itemIndex < 0) {
      throw new Error('Pass either item or item index in getItemProps!');
    }
    var onSelectKey = 'onClick';
    var customClickHandler = onClick;
    var itemHandleMouseMove = function itemHandleMouseMove() {
      if (index === latestState.highlightedIndex) {
        return;
      }
      shouldScrollRef.current = false;
      dispatch({
        type: ItemMouseMove,
        index: index,
        disabled: disabled
      });
    };
    var itemHandleClick = function itemHandleClick() {
      dispatch({
        type: ItemClick,
        index: index
      });
    };
    var itemHandleMouseDown = function itemHandleMouseDown(e) {
      return e.preventDefault();
    };
    return _objectSpread(_objectSpread(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({}, refKey, handleRefs(ref, function (itemNode) {
      if (itemNode) {
        itemRefs.current[elementIds.getItemId(itemIndex)] = itemNode;
      }
    })), "disabled", disabled), "role", 'option'), 'aria-selected', "".concat(itemIndex === latestState.highlightedIndex)), "id", elementIds.getItemId(itemIndex)), !disabled && _defineProperty2({}, onSelectKey, callAllEventHandlers(customClickHandler, itemHandleClick))), {}, {
      onMouseMove: callAllEventHandlers(onMouseMove, itemHandleMouseMove),
      onMouseDown: callAllEventHandlers(onMouseDown, itemHandleMouseDown)
    }, rest);
  }, [dispatch, latest, shouldScrollRef, elementIds]);
  var getToggleButtonProps = useCallback(function (_temp4) {
    var _ref73 = _temp4 === void 0 ? {} : _temp4,
      onClick = _ref73.onClick,
      onPress = _ref73.onPress,
      _ref73$refKey = _ref73.refKey,
      refKey = _ref73$refKey === void 0 ? 'ref' : _ref73$refKey,
      ref = _ref73.ref,
      rest = _objectWithoutProperties2(_ref73, _excluded10);
    var toggleButtonHandleClick = function toggleButtonHandleClick() {
      dispatch({
        type: ToggleButtonClick
      });
      if (!latest.current.state.isOpen && inputRef.current) {
        inputRef.current.focus();
      }
    };
    return _objectSpread(_objectSpread(_defineProperty2(_defineProperty2(_defineProperty2({}, refKey, handleRefs(ref, function (toggleButtonNode) {
      toggleButtonRef.current = toggleButtonNode;
    })), "id", elementIds.toggleButtonId), "tabIndex", -1), !rest.disabled && _objectSpread({}, {
      onClick: callAllEventHandlers(onClick, toggleButtonHandleClick)
    })), rest);
  }, [dispatch, latest, elementIds]);
  var getInputProps = useCallback(function (_temp5, _temp6) {
    var _ref74 = _temp5 === void 0 ? {} : _temp5,
      onKeyDown = _ref74.onKeyDown,
      onChange = _ref74.onChange,
      onInput = _ref74.onInput,
      onBlur = _ref74.onBlur,
      onChangeText = _ref74.onChangeText,
      _ref74$refKey = _ref74.refKey,
      refKey = _ref74$refKey === void 0 ? 'ref' : _ref74$refKey,
      ref = _ref74.ref,
      rest = _objectWithoutProperties2(_ref74, _excluded11);
    var _ref75 = _temp6 === void 0 ? {} : _temp6,
      _ref75$suppressRefErr = _ref75.suppressRefError,
      suppressRefError = _ref75$suppressRefErr === void 0 ? false : _ref75$suppressRefErr;
    setGetterPropCallInfo('getInputProps', suppressRefError, refKey, inputRef);
    var latestState = latest.current.state;
    var inputHandleKeyDown = function inputHandleKeyDown(event) {
      var key = normalizeArrowKey(event);
      if (key && inputKeyDownHandlers[key]) {
        inputKeyDownHandlers[key](event);
      }
    };
    var inputHandleChange = function inputHandleChange(event) {
      dispatch({
        type: InputChange,
        inputValue: event.target.value
      });
    };
    var inputHandleBlur = function inputHandleBlur() {
      /* istanbul ignore else */
      if (latestState.isOpen && !mouseAndTouchTrackersRef.current.isMouseDown) {
        dispatch({
          type: InputBlur,
          selectItem: true
        });
      }
    };
    /* istanbul ignore next (preact) */

    var onChangeKey = 'onChange';
    var eventHandlers = {};
    if (!rest.disabled) {
      eventHandlers = _defineProperty2(_defineProperty2(_defineProperty2({}, onChangeKey, callAllEventHandlers(onChange, onInput, inputHandleChange)), "onKeyDown", callAllEventHandlers(onKeyDown, inputHandleKeyDown)), "onBlur", callAllEventHandlers(onBlur, inputHandleBlur));
    }
    return _objectSpread(_objectSpread(_objectSpread(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({}, refKey, handleRefs(ref, function (inputNode) {
      inputRef.current = inputNode;
    })), "id", elementIds.inputId), 'aria-autocomplete', 'list'), 'aria-controls', elementIds.menuId), latestState.isOpen && latestState.highlightedIndex > -1 && {
      'aria-activedescendant': elementIds.getItemId(latestState.highlightedIndex)
    }), {}, {
      'aria-labelledby': elementIds.labelId,
      // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
      // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
      autoComplete: 'off',
      value: latestState.inputValue
    }, eventHandlers), rest);
  }, [dispatch, inputKeyDownHandlers, latest, mouseAndTouchTrackersRef, setGetterPropCallInfo, elementIds]);
  var getComboboxProps = useCallback(function (_temp7, _temp8) {
    var _ref76 = _temp7 === void 0 ? {} : _temp7,
      _ref76$refKey = _ref76.refKey,
      refKey = _ref76$refKey === void 0 ? 'ref' : _ref76$refKey,
      ref = _ref76.ref,
      rest = _objectWithoutProperties2(_ref76, _excluded12);
    var _ref77 = _temp8 === void 0 ? {} : _temp8,
      _ref77$suppressRefErr = _ref77.suppressRefError,
      suppressRefError = _ref77$suppressRefErr === void 0 ? false : _ref77$suppressRefErr;
    setGetterPropCallInfo('getComboboxProps', suppressRefError, refKey, comboboxRef);
    return _objectSpread(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({}, refKey, handleRefs(ref, function (comboboxNode) {
      comboboxRef.current = comboboxNode;
    })), "role", 'combobox'), 'aria-haspopup', 'listbox'), 'aria-owns', elementIds.menuId), 'aria-expanded', latest.current.state.isOpen), rest);
  }, [latest, setGetterPropCallInfo, elementIds]); // returns

  var toggleMenu = useCallback(function () {
    dispatch({
      type: FunctionToggleMenu
    });
  }, [dispatch]);
  var closeMenu = useCallback(function () {
    dispatch({
      type: FunctionCloseMenu
    });
  }, [dispatch]);
  var openMenu = useCallback(function () {
    dispatch({
      type: FunctionOpenMenu
    });
  }, [dispatch]);
  var setHighlightedIndex = useCallback(function (newHighlightedIndex) {
    dispatch({
      type: FunctionSetHighlightedIndex,
      highlightedIndex: newHighlightedIndex
    });
  }, [dispatch]);
  var selectItem = useCallback(function (newSelectedItem) {
    dispatch({
      type: FunctionSelectItem,
      selectedItem: newSelectedItem
    });
  }, [dispatch]);
  var setInputValue = useCallback(function (newInputValue) {
    dispatch({
      type: FunctionSetInputValue,
      inputValue: newInputValue
    });
  }, [dispatch]);
  var reset = useCallback(function () {
    dispatch({
      type: FunctionReset$1
    });
  }, [dispatch]);
  return {
    // prop getters.
    getItemProps: getItemProps,
    getLabelProps: getLabelProps,
    getMenuProps: getMenuProps,
    getInputProps: getInputProps,
    getComboboxProps: getComboboxProps,
    getToggleButtonProps: getToggleButtonProps,
    // actions.
    toggleMenu: toggleMenu,
    openMenu: openMenu,
    closeMenu: closeMenu,
    setHighlightedIndex: setHighlightedIndex,
    setInputValue: setInputValue,
    selectItem: selectItem,
    reset: reset,
    // state.
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}
/**
 * Returns a message to be added to aria-live region when item is removed.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */

function getA11yRemovalMessage(selectionParameters) {
  var removedSelectedItem = selectionParameters.removedSelectedItem,
    itemToStringLocal = selectionParameters.itemToString;
  return "".concat(itemToStringLocal(removedSelectedItem), " has been removed.");
}
({
  selectedItems: propTypes.exports.array,
  initialSelectedItems: propTypes.exports.array,
  defaultSelectedItems: propTypes.exports.array,
  itemToString: propTypes.exports.func,
  getA11yRemovalMessage: propTypes.exports.func,
  stateReducer: propTypes.exports.func,
  activeIndex: propTypes.exports.number,
  initialActiveIndex: propTypes.exports.number,
  defaultActiveIndex: propTypes.exports.number,
  onActiveIndexChange: propTypes.exports.func,
  onSelectedItemsChange: propTypes.exports.func,
  keyNavigationNext: propTypes.exports.string,
  keyNavigationPrevious: propTypes.exports.string,
  environment: propTypes.exports.shape({
    addEventListener: propTypes.exports.func,
    removeEventListener: propTypes.exports.func,
    document: propTypes.exports.shape({
      getElementById: propTypes.exports.func,
      activeElement: propTypes.exports.any,
      body: propTypes.exports.any
    })
  })
});
({
  itemToString: defaultProps$3.itemToString,
  stateReducer: defaultProps$3.stateReducer,
  environment: defaultProps$3.environment,
  getA11yRemovalMessage: getA11yRemovalMessage,
  keyNavigationNext: 'ArrowRight',
  keyNavigationPrevious: 'ArrowLeft'
}); // eslint-disable-next-line import/no-mutable-exports
/* istanbul ignore next */

if (process.env.NODE_ENV !== 'production') ;
process.env.NODE_ENV !== "production" ? '__selected_item_click__' : 0;
process.env.NODE_ENV !== "production" ? '__selected_item_keydown_delete__' : 1;
process.env.NODE_ENV !== "production" ? '__selected_item_keydown_backspace__' : 2;
process.env.NODE_ENV !== "production" ? '__selected_item_keydown_navigation_next__' : 3;
process.env.NODE_ENV !== "production" ? '__selected_item_keydown_navigation_previous__' : 4;
process.env.NODE_ENV !== "production" ? '__dropdown_keydown_navigation_previous__' : 5;
process.env.NODE_ENV !== "production" ? '__dropdown_keydown_backspace__' : 6;
process.env.NODE_ENV !== "production" ? '__dropdown_click__' : 7;
process.env.NODE_ENV !== "production" ? '__function_add_selected_item__' : 8;
process.env.NODE_ENV !== "production" ? '__function_remove_selected_item__' : 9;
process.env.NODE_ENV !== "production" ? '__function_set_selected_items__' : 10;
process.env.NODE_ENV !== "production" ? '__function_set_active_index__' : 11;
process.env.NODE_ENV !== "production" ? '__function_reset__' : 12;
var searchIcon = "data:image/svg+xml,%3Csvg%20width%3D%223.7498mm%22%20height%3D%223.6655mm%22%20version%3D%221.1%22%20viewBox%3D%220%200%203.7498%203.6655%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%3Cg%20transform%3D%22translate%28-77.851%20-85.402%29%22%20fill%3D%22none%22%3E%20%20%3Cg%20transform%3D%22matrix%28.26458%200%200%20.26458%2077.785%2085.335%29%22%3E%20%20%20%3Cpath%20d%3D%22m5.6667%2010.333c2.5773%200%204.6666-2.0893%204.6666-4.6666s-2.0893-4.6667-4.6666-4.6667-4.6667%202.0893-4.6667%204.6667%202.0893%204.6666%204.6667%204.6666z%22%20stroke%3D%22%23000%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%20%20%3C%2Fg%3E%20%20%3Cg%20transform%3D%22matrix%28.26458%200%200%20.26458%2080.079%2087.546%29%22%3E%20%20%20%3Cpath%20d%3D%22m5%205-4-4%22%20stroke%3D%22%23000%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%20%20%3C%2Fg%3E%20%3C%2Fg%3E%3C%2Fsvg%3E";
var styles$q = {
  "container": "query-result-module_container__gn2S7",
  "text": "query-result-module_text__knO4Z",
  "value": "query-result-module_value__BZpHh",
  "selected": "query-result-module_selected__Brc9J",
  "containerDescription": "query-result-module_containerDescription__msFkj"
};
var QueryResult = function QueryResult(_ref78) {
  var _ref78$item = _ref78.item,
    description = _ref78$item.description,
    text = _ref78$item.text,
    isContainer = _ref78$item.isContainer,
    _ref78$selected = _ref78.selected,
    selected = _ref78$selected === void 0 ? false : _ref78$selected;
  return React$2.createElement("div", {
    className: classnames(styles$q.container, _defineProperty2({}, styles$q.selected, selected))
  }, React$2.createElement("div", {
    className: classnames(styles$q.text)
  }, text.map(function (copy, index) {
    var Component = index % 2 === 0 ? Small_1 : Small_2;
    return React$2.createElement(Component, {
      key: "".concat(copy, "_").concat(index),
      className: styles$q.value
    }, copy);
  })), isContainer && React$2.createElement("div", {
    className: styles$q.containerDescription
  }, React$2.createElement(Small_1, {
    className: styles$q.containerDescriptionCopy
  }, description)));
};
var styles$p = {
  "searchContainer": "query-input-module_searchContainer__Y7AZS",
  "searchInput": "query-input-module_searchInput__rEhh2",
  "icon": "query-input-module_icon__ls3Cb",
  "loader": "query-input-module_loader__SWbHs",
  "searchResultList": "query-input-module_searchResultList__zMffQ",
  "searchResultContainer": "query-input-module_searchResultContainer__ZzB75",
  "searchResultNotListed": "query-input-module_searchResultNotListed__EOi9f",
  "searchResultNotListedLabel": "query-input-module_searchResultNotListedLabel__JQlEU",
  "searchResultsNotListedLink": "query-input-module_searchResultsNotListedLink__WV-SP"
};
function QueryInput(_ref79) {
  var _ref79$loading = _ref79.loading,
    loading = _ref79$loading === void 0 ? false : _ref79$loading,
    _ref79$results = _ref79.results,
    results = _ref79$results === void 0 ? [] : _ref79$results,
    placeholder = _ref79.placeholder,
    manualLinkCopy = _ref79.manualLinkCopy,
    onChange = _ref79.onChange,
    onSelect = _ref79.onSelect,
    onManualEntryClick = _ref79.onManualEntryClick,
    resultToString = _ref79.resultToString,
    style = _ref79.style;
  var _useCombobox = useCombobox({
      onInputValueChange: function onInputValueChange(_ref80) {
        var inputValue = _ref80.inputValue;
        onChange(inputValue !== null && inputValue !== void 0 ? inputValue : '');
      },
      items: results,
      itemToString: function itemToString(item) {
        return item ? resultToString(item) : '';
      },
      onSelectedItemChange: function onSelectedItemChange(_ref81) {
        var selectedItem = _ref81.selectedItem;
        if (onSelect && selectedItem) {
          onSelect(selectedItem);
        }
      }
    }),
    isOpen = _useCombobox.isOpen,
    getMenuProps = _useCombobox.getMenuProps,
    getInputProps = _useCombobox.getInputProps,
    getComboboxProps = _useCombobox.getComboboxProps,
    highlightedIndex = _useCombobox.highlightedIndex,
    getItemProps = _useCombobox.getItemProps,
    openMenu = _useCombobox.openMenu;
  useEffect(function () {
    if (results.length > 0) {
      openMenu();
    }
  }, [results]);
  return React$2.createElement("div", {
    className: styles$p.searchContainer
  }, React$2.createElement("div", Object.assign({}, getComboboxProps()), React$2.createElement(Body_2, null, React$2.createElement("input", Object.assign({
    className: classnames(styles$A.input, styles$p.searchInput),
    placeholder: placeholder,
    style: style
  }, getInputProps(), {
    autoComplete: "new-address"
  }))), loading ? React$2.createElement(Loader, {
    className: classnames(styles$p.icon, styles$p.loader)
  }) : React$2.createElement("img", {
    className: styles$p.icon,
    src: searchIcon
  })), React$2.createElement("div", Object.assign({
    className: styles$p.searchResultList
  }, getMenuProps()), isOpen && React$2.createElement(React$2.Fragment, null, React$2.createElement("div", {
    className: styles$p.searchResultContainer
  }, results.map(function (item, index) {
    return React$2.createElement("div", Object.assign({
      key: "".concat(JSON.stringify(item)).concat(index)
    }, getItemProps({
      item: item,
      index: index
    })), React$2.createElement(QueryResult, {
      item: item,
      selected: index === highlightedIndex
    }));
  })), results.length > 0 && React$2.createElement("div", {
    className: styles$p.searchResultNotListed
  }, React$2.createElement(Small_1, {
    className: styles$p.searchResultNotListedLabel
  }, "Address not listed?"), React$2.createElement(Link, {
    className: styles$p.searchResultsNotListedLink,
    label: manualLinkCopy,
    onClick: onManualEntryClick
  })))));
}
var map$2 = [['Andorra', 'AND', 'AD'], ['Austria', 'AUT', 'AT'], ['Belarus', 'BLR', 'BY'], ['Belgium', 'BEL', 'BE'], ['Bulgaria', 'BGR', 'BG'], ['Croatia', 'HRV', 'HR'], ['Czechia', 'CZE', 'CZ'], ['Denmark', 'DNK', 'DK'], ['Estonia', 'EST', 'EE'], ['Finland', 'FIN', 'FI'], ['France', 'FRA', 'FR'], ['Georgia', 'GEO', 'GE'], ['Germany', 'DEU', 'DE'], ['Gibraltar', 'GIB', 'GI'], ['Greece', 'GRC', 'GR'], ['Guernsey', 'GGY', 'GG'], ['Hungary', 'HUN', 'HU'], ['Ireland', 'IRL', 'IE'], ['Isle of Man', 'IMN', 'IM'], ['Italy', 'ITA', 'IT'], ['Jersey', 'JEY', 'JE'], ['Latvia', 'LVA', 'LV'], ['Liechtenstein', 'LIE', 'LI'], ['Lithuania', 'LTU', 'LT'], ['Luxembourg', 'LUX', 'LU'], ['Malta', 'MLT', 'MT'], ['Moldova, Republic of', 'MDA', 'MD'], ['Monaco', 'MCO', 'MC'], ['Montenegro', 'MNE', 'ME'], ['Netherlands', 'NLD', 'NL'], ['Norway', 'NOR', 'NO'], ['Poland', 'POL', 'PL'], ['Portugal', 'PRT', 'PT'], ['Réunion', 'REU', 'RE'], ['Romania', 'ROU', 'RO'], ['Slovakia', 'SVK', 'SK'], ['Slovenia', 'SVN', 'SI'], ['Spain', 'ESP', 'ES'], ['Sweden', 'SWE', 'SE'], ['Switzerland', 'CHE', 'CH'], ['Turkey', 'TUR', 'TR'], ['Ukraine', 'UKR', 'UA'], ['United Kingdom', 'GBR', 'GB'], ['United States of America', 'USA', 'US']];
var labelMap = new Map(map$2.map(function (_ref82) {
  var _ref83 = _slicedToArray(_ref82, 2),
    label = _ref83[0],
    alpha3 = _ref83[1];
  return [label, alpha3];
}));
var valueMap = new Map(map$2.map(function (_ref84) {
  var _ref85 = _slicedToArray(_ref84, 2),
    label = _ref85[0],
    alpha3 = _ref85[1];
  return [alpha3, label];
}));
var alpha2Map = new Map(map$2.map(function (_ref86) {
  var _ref87 = _slicedToArray(_ref86, 3),
    alpha3 = _ref87[1],
    alpha2 = _ref87[2];
  return [alpha3, alpha2];
}));
var getConverter = function getConverter(map) {
  return function () {
    for (var _len5 = arguments.length, keys = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      keys[_key5] = arguments[_key5];
    }
    return keys.reduce(function (list, key) {
      var value = map.get(key);
      if (value) {
        list.push(value);
      }
      return list;
    }, []);
  };
};
var getCountryLabelByValue = getConverter(valueMap);
var getCountryValueByLabel = getConverter(labelMap);
// Maps an alpha-3 ISO-3166 code to its alpha-2 form (e.g. 'GBR' -> 'GB'). Added so
// the address picker can emit a `countryIso2` alongside the existing alpha-3
// `countryIso`, for consumers that require the two-letter form (the Procurement
// order API's deliveryCountry). Existing exports are unchanged.
var getCountryAlpha2ByValue = getConverter(alpha2Map);
var countries = map$2.map(function (_ref88) {
  var _ref89 = _slicedToArray(_ref88, 1),
    key = _ref89[0];
  return key;
});
var formatAddress = function formatAddress(address) {
  var _a, _b, _c, _d;
  return "".concat((_a = address === null || address === void 0 ? void 0 : address.addressLine1) !== null && _a !== void 0 ? _a : '', "\n").concat((_b = address === null || address === void 0 ? void 0 : address.addressLine2) !== null && _b !== void 0 ? _b : '', "\n").concat((_c = address === null || address === void 0 ? void 0 : address.city) !== null && _c !== void 0 ? _c : '', "\n").concat((_d = address === null || address === void 0 ? void 0 : address.postcode) !== null && _d !== void 0 ? _d : '', "\n").concat((address === null || address === void 0 ? void 0 : address.country) ? getCountryLabelByValue(address.country).join(',') : '', "\n");
};
var AddressFinderControl = function AddressFinderControl(_ref90) {
  var name = _ref90.name,
    _ref90$placeholder = _ref90.placeholder,
    countries = _ref90$placeholder === void 0 ? 'GBR' : _ref90$placeholder,
    _ref90$error = _ref90.error,
    stringifiedErrorStruct = _ref90$error === void 0 ? '' : _ref90$error,
    _ref90$value = _ref90.value,
    value = _ref90$value === void 0 ? {} : _ref90$value,
    _ref90$label = _ref90.label,
    label = _ref90$label === void 0 ? 'Postal Address' : _ref90$label;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var _useState26 = useState([]),
    _useState27 = _slicedToArray(_useState26, 2),
    results = _useState27[0],
    setResults = _useState27[1];
  var _useState28 = useState(false),
    _useState29 = _slicedToArray(_useState28, 2),
    loading = _useState29[0],
    setLoading = _useState29[1];
  var _useState30 = useState(null),
    _useState31 = _slicedToArray(_useState30, 2),
    selectedAddress = _useState31[0],
    setSelectedAddress = _useState31[1];
  var _useState32 = useState(''),
    _useState33 = _slicedToArray(_useState32, 2),
    error = _useState33[0],
    setError = _useState33[1];
  var _useState34 = useState({}),
    _useState35 = _slicedToArray(_useState34, 2),
    errorStruct = _useState35[0],
    setErrorStruct = _useState35[1];
  var _useState36 = useState(false),
    _useState37 = _slicedToArray(_useState36, 2),
    isManualEntry = _useState37[0],
    setIsManualEntry = _useState37[1];
  var _useState38 = useState(null),
    _useState39 = _slicedToArray(_useState38, 2),
    currentSearchTerm = _useState39[0],
    setCurrentSearchTerm = _useState39[1];
  var _useThemeContext15 = useThemeContext(),
    _useThemeContext15$fo = _useThemeContext15.form.body,
    _useThemeContext15$fo2 = _useThemeContext15$fo === void 0 ? DefaultFormBodyModel : _useThemeContext15$fo,
    errorModel = _useThemeContext15$fo2.error,
    borderColor = _useThemeContext15$fo2.borderColor,
    address = _useThemeContext15$fo2.address;
  var debounceTime = 500;
  var findAddresses = AddressFinderService('/api/v1');
  var manualLinkCopy = (_b = (_a = address === null || address === void 0 ? void 0 : address.copy) === null || _a === void 0 ? void 0 : _a.manualLink) !== null && _b !== void 0 ? _b : 'Enter address manually';
  var lookupErrorCopy = (_d = (_c = address === null || address === void 0 ? void 0 : address.copy) === null || _c === void 0 ? void 0 : _c.lookupError) !== null && _d !== void 0 ? _d : 'Postcode lookup error. Please enter address manually.';
  var _useFormikContext4 = useFormikContext(),
    setFieldValue = _useFormikContext4.setFieldValue;
  var countryLabel = value.country;
  // Empty stored country labels retain the GBR fallback.
  var country =
  // oxlint-disable-next-line typescript/prefer-nullish-coalescing
  countryLabel && getCountryValueByLabel(countryLabel).shift() || 'GBR';
  // The alpha-2 form of the same country, emitted additively as `countryIso2`
  // alongside the alpha-3 `countryIso` (below). Downstream consumers that need the
  // two-letter code (the Procurement order API) read this; nothing reading the
  // existing `country`/`countryIso` fields is affected.
  var countryIso2 = (_e = getCountryAlpha2ByValue(country).shift()) !== null && _e !== void 0 ? _e : 'GB';
  useEffect(function () {
    var _a, _b;
    var parsed = JSON.parse(stringifiedErrorStruct || '{}');
    var withoutCountry = __rest(parsed, ["country"]);
    setError(Object.keys(withoutCountry).length > 0 ? (_b = (_a = address === null || address === void 0 ? void 0 : address.copy) === null || _a === void 0 ? void 0 : _a.invalid) !== null && _b !== void 0 ? _b : "Address should be valid" : '');
    setErrorStruct(parsed);
  }, [stringifiedErrorStruct]);
  useEffect(function () {
    setSelectedAddress(null);
    void setFieldValue("".concat(name, ".countryIso"), country, false);
    void setFieldValue("".concat(name, ".countryIso2"), countryIso2, false);
  }, [country]);
  var style = {
    borderColor: error && !isManualEntry ? errorModel === null || errorModel === void 0 ? void 0 : errorModel.color : borderColor
  };
  // Every lookup failure (daily limit, out of credit, proxy or network error)
  // gets the same plain message; the manual entry link below it is the way out.
  // The proxy logs the underlying cause server-side.
  var handleError = function handleError() {
    setResults([]);
    setLoading(false);
    setError(lookupErrorCopy);
  };
  var search = function search(searchTerm) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee6() {
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            if (error) {
              setError('');
            }
            setCurrentSearchTerm(searchTerm);
            setLoading(true);
            return _context6.a(2, findAddresses.search(country, searchTerm).then(function (results) {
              setResults(results);
              setLoading(false);
            }).catch(handleError));
        }
      }, _callee6);
    }));
  };
  var onQueryChange = function onQueryChange(searchTerm) {
    if (searchTerm.length < 2) {
      return;
    }
    setError('');
    void search(searchTerm);
  };
  var onResultSelected = function onResultSelected(addressResult) {
    setIsManualEntry(false);
    if (!currentSearchTerm) {
      return;
    }
    var method = addressResult.isContainer ? findAddresses.search : findAddresses.retrieve;
    setLoading(true);
    void method(country, currentSearchTerm, addressResult.id).then(function (result) {
      var _a, _b, _c, _d;
      setLoading(false);
      if (Array.isArray(result)) {
        setResults(result);
      } else {
        // Older address providers may omit individual fields.
        var _address = result;
        void setFieldValue("".concat(name, ".addressLine1"), (_a = _address === null || _address === void 0 ? void 0 : _address.addressLine1) !== null && _a !== void 0 ? _a : '', false);
        void setFieldValue("".concat(name, ".addressLine2"), (_b = _address === null || _address === void 0 ? void 0 : _address.addressLine2) !== null && _b !== void 0 ? _b : '', false);
        void setFieldValue("".concat(name, ".city"), (_c = _address === null || _address === void 0 ? void 0 : _address.city) !== null && _c !== void 0 ? _c : '', false);
        void setFieldValue("".concat(name, ".postcode"), (_d = _address === null || _address === void 0 ? void 0 : _address.postcode) !== null && _d !== void 0 ? _d : '', false);
        // The decoupled structured address (Loqate's preformatted lines +
        // granular components). Carried on the form value untouched so a
        // downstream supplier can build its own length-capped lines; absent
        // for manual entry, where consumers fall back to addressLine1/2.
        void setFieldValue("".concat(name, ".structured"), _address === null || _address === void 0 ? void 0 : _address.structured, false);
        // A fresh lookup supersedes any prior manual edits, so clear the edited
        // flags — the newly-populated flat fields are the looked-up values again.
        void setFieldValue("".concat(name, ".edited"), {}, false);
        setSelectedAddress(result);
      }
    }).catch(handleError);
  };
  var onManualEntryClick = function onManualEntryClick() {
    setResults([]);
    setIsManualEntry(true);
  };
  // Flag a flat field as hand-edited (the user typed into it), so a downstream supplier
  // prefers the typed value over the now-stale looked-up/structured one. Reset on a
  // fresh lookup (above).
  var markEdited = function markEdited(field) {
    void setFieldValue("".concat(name, ".edited.").concat(field), true, false);
  };
  var renderBottomSection = function renderBottomSection() {
    return selectedAddress ? React$2.createElement(Panel, {
      style: {
        marginBottom: '32px',
        minHeight: '140px'
      }
    }, formatAddress(selectedAddress), React$2.createElement(Link, {
      style: {
        marginTop: '15px'
      },
      label: "Edit address",
      onClick: onManualEntryClick
    })) : React$2.createElement(Link, {
      style: {
        marginBottom: '32px'
      },
      label: manualLinkCopy,
      onClick: onManualEntryClick
    });
  };
  var countryChoices = getCountryLabelByValue.apply(void 0, _toConsumableArray2(countries.split(',')));
  var renderFormikInputs = function renderFormikInputs(shouldShow) {
    var _a, _b, _c, _d;
    return React$2.createElement("div", {
      style: {
        marginTop: '32px',
        display: shouldShow ? 'block' : 'none'
      }
    }, React$2.createElement(StringControl, {
      name: "".concat(name, ".addressLine1"),
      placeholder: "Address Line 1",
      onChange: function onChange() {
        markEdited('addressLine1');
      },
      error: (_a = errorStruct.addressLine1) === null || _a === void 0 ? void 0 : _a.replace("".concat(name, ".addressLine1"), 'Address Line 1')
    }), React$2.createElement(StringControl, {
      name: "".concat(name, ".addressLine2"),
      placeholder: "Address Line 2",
      onChange: function onChange() {
        markEdited('addressLine2');
      },
      error: (_b = errorStruct.addressLine2) === null || _b === void 0 ? void 0 : _b.replace("".concat(name, ".addressLine2"), 'Address Line 2')
    }), React$2.createElement(StringControl, {
      name: "".concat(name, ".city"),
      placeholder: "City",
      onChange: function onChange() {
        markEdited('city');
      },
      error: (_c = errorStruct.city) === null || _c === void 0 ? void 0 : _c.replace("".concat(name, ".city"), 'City')
    }), React$2.createElement(StringControl, {
      name: "".concat(name, ".postcode"),
      placeholder: "Post Code",
      onChange: function onChange() {
        markEdited('postcode');
      },
      error: (_d = errorStruct.postcode) === null || _d === void 0 ? void 0 : _d.replace("".concat(name, ".postcode"), 'Post Code')
    }));
  };
  var LabelElement = countryChoices.length > 1 ? Body_4 : Body_2;
  return React$2.createElement(Body_2, null, React$2.createElement("label", {
    htmlFor: name
  }, React$2.createElement(LabelElement, {
    className: styles$A.label
  }, label)), countryChoices.length > 1 && React$2.createElement(DropdownControl, {
    name: "".concat(name, ".country"),
    placeholder: (_g = (_f = address === null || address === void 0 ? void 0 : address.copy) === null || _f === void 0 ? void 0 : _f.select) !== null && _g !== void 0 ? _g : 'Select a country',
    choices: getCountryLabelByValue.apply(void 0, _toConsumableArray2(countries.split(','))),
    error: (_h = errorStruct.country) === null || _h === void 0 ? void 0 : _h.replace("".concat(name, ".country"), 'Country')
  }), React$2.createElement(QueryInput, {
    loading: loading,
    style: style,
    placeholder: (_k = (_j = address === null || address === void 0 ? void 0 : address.copy) === null || _j === void 0 ? void 0 : _j.prompt) !== null && _k !== void 0 ? _k : 'Start typing your address or postcode',
    manualLinkCopy: manualLinkCopy,
    results: results,
    onChange: debounce_1(onQueryChange, debounceTime),
    onSelect: onResultSelected,
    onManualEntryClick: onManualEntryClick,
    resultToString: function resultToString() {
      return currentSearchTerm !== null && currentSearchTerm !== void 0 ? currentSearchTerm : '';
    }
  }), !isManualEntry && React$2.createElement(React$2.Fragment, null, React$2.createElement(ControlError, {
    style: {
      marginTop: '0',
      minHeight: '16px'
    },
    message: error
  }), renderBottomSection()), renderFormikInputs(isManualEntry));
};
var localStyles$6 = {
  "lengthCount": "text-area-control-module_lengthCount__BDqdL"
};
var TextAreaControl = function TextAreaControl(_ref91) {
  var name = _ref91.name,
    placeholder = _ref91.placeholder,
    _ref91$error = _ref91.error,
    errorMessage = _ref91$error === void 0 ? '' : _ref91$error,
    _ref91$displayOptiona = _ref91.displayOptional,
    displayOptional = _ref91$displayOptiona === void 0 ? false : _ref91$displayOptiona,
    optional = _ref91.optional,
    _ref91$maxLength = _ref91.maxLength,
    maxLength = _ref91$maxLength === void 0 ? 200 : _ref91$maxLength,
    value = _ref91.value,
    placeholderAttribute = _ref91.placeholderAttribute;
  var _a;
  var _useThemeContext16 = useThemeContext(),
    _useThemeContext16$fo = _useThemeContext16.form.body,
    _useThemeContext16$fo2 = _useThemeContext16$fo === void 0 ? DefaultFormBodyModel : _useThemeContext16$fo,
    error = _useThemeContext16$fo2.error,
    borderColor = _useThemeContext16$fo2.borderColor;
  var style = {
    borderColor: errorMessage ? error === null || error === void 0 ? void 0 : error.color : borderColor,
    resize: 'none',
    fontFamily: 'inherit',
    height: '8.2rem',
    paddingTop: '8px'
  };
  var validateLength = function validateLength(value) {
    if (value.length > maxLength) {
      return "length should be ".concat(maxLength, " characters or less");
    }
  };
  var valueLength = (_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0;
  return React$2.createElement(Body_2, null, React$2.createElement("label", {
    htmlFor: name
  }, React$2.createElement("div", {
    className: styles$A.label
  }, placeholder, optional && displayOptional && React$2.createElement("span", {
    className: styles$A.optional
  }, "Optional"))), React$2.createElement(Field, {
    validate: validateLength,
    as: "textarea",
    type: "string",
    id: name,
    name: name,
    style: style,
    className: styles$A.input,
    "data-testid": name,
    placeholder: placeholderAttribute
  }), React$2.createElement(ControlError, {
    message: errorMessage
  }), React$2.createElement("div", {
    style: {
      position: 'relative'
    }
  }, React$2.createElement(Footer_1, {
    className: localStyles$6.lengthCount,
    style: {
      color: valueLength > maxLength ? '#f15e40' : 'rgb(153,153,153)'
    }
  }, valueLength, " / ", maxLength)));
};
var controls = new Map([[ElementType.String, StringControl], [ElementType.Dropdown, DropdownControl], [ElementType.Date, DateControl], [ElementType.Checkbox, CheckboxControl], [ElementType.Text, TextControl], [ElementType.AdditionalInformation, AdditionalInformationControl], [ElementType.Warning, WarningControl], [ElementType.Markdown, MarkdownControl], [ElementType.Address, AddressFinderControl], [ElementType.TextArea, TextAreaControl]]);
var styles$o = {
  "container": "form-body-module_container__-OM2U"
};
var getInitialValues = function getInitialValues(model) {
  return model.reduce(function (values, _ref92) {
    var elementType = _ref92.elementType,
      placeholder = _ref92.placeholder,
      name = _ref92.name;
    // Stored form types are strings; unknown/custom values keep the default path.
    switch (elementType) {
      case ElementType.String:
      case ElementType.Dropdown:
      case ElementType.TextArea:
        return Object.assign(Object.assign({}, values), _defineProperty2({}, name, ''));
      case ElementType.Checkbox:
        return Object.assign(Object.assign({}, values), _defineProperty2({}, name, false));
      case ElementType.Hidden:
        return Object.assign(Object.assign({}, values), _defineProperty2({}, name, placeholder));
      case ElementType.Address:
        // eslint-disable-next-line no-case-declarations
        // An empty first country code must retain the GBR default.
        // oxlint-disable-next-line typescript/prefer-nullish-coalescing
        var countryIso = placeholder.split(',').shift() || 'GBR';
        return Object.assign(Object.assign({}, values), _defineProperty2({}, name, {
          addressLine1: '',
          addressLine2: '',
          city: '',
          postcode: '',
          country: getCountryLabelByValue(countryIso).shift(),
          countryIso: countryIso,
          countryIso2: getCountryAlpha2ByValue(countryIso).shift(),
          // Tracks which flat fields the user hand-edits; the picker flips a key
          // true on edit and resets this on a fresh lookup.
          edited: {}
        }));
      case ElementType.Date:
        // eslint-disable-next-line no-case-declarations
        return Object.assign(Object.assign({}, values), _defineProperty2({}, name, {
          date: '',
          month: '',
          year: ''
        }));
      default:
        return values;
    }
  }, {});
};

// ES6 Map
var map$1;
try {
  map$1 = Map;
} catch (_) {}
var set;

// ES6 Set
try {
  set = Set;
} catch (_) {}
function baseClone(src, circulars, clones) {
  // Null/undefined/functions/etc
  if (!src || typeof src !== 'object' || typeof src === 'function') {
    return src;
  }

  // DOM Node
  if (src.nodeType && 'cloneNode' in src) {
    return src.cloneNode(true);
  }

  // Date
  if (src instanceof Date) {
    return new Date(src.getTime());
  }

  // RegExp
  if (src instanceof RegExp) {
    return new RegExp(src);
  }

  // Arrays
  if (Array.isArray(src)) {
    return src.map(_clone);
  }

  // ES6 Maps
  if (map$1 && src instanceof map$1) {
    return new Map(Array.from(src.entries()));
  }

  // ES6 Sets
  if (set && src instanceof set) {
    return new Set(Array.from(src.values()));
  }

  // Object
  if (src instanceof Object) {
    circulars.push(src);
    var obj = Object.create(src);
    clones.push(obj);
    for (var key in src) {
      var idx = circulars.findIndex(function (i) {
        return i === src[key];
      });
      obj[key] = idx > -1 ? clones[idx] : baseClone(src[key], circulars, clones);
    }
    return obj;
  }

  // ???
  return src;
}
function _clone(src) {
  return baseClone(src, [], []);
}
var toString$6 = Object.prototype.toString;
var errorToString = Error.prototype.toString;
var regExpToString = RegExp.prototype.toString;
var symbolToString$1 = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : function () {
  return '';
};
var SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(val) {
  if (val != +val) return 'NaN';
  var isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}
function printSimpleValue(val) {
  var quoteStrings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (val == null || val === true || val === false) return '' + val;
  var typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? "\"".concat(val, "\"") : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString$1.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  var tag = toString$6.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}
function printValue(value, quoteStrings) {
  var result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    var result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}
var mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: function notType(_ref93) {
    var path = _ref93.path,
      type = _ref93.type,
      value = _ref93.value,
      originalValue = _ref93.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = "".concat(path, " must be a `").concat(type, "` type, ") + "but the final value was: `".concat(printValue(value, true), "`") + (isCast ? " (cast from the value `".concat(printValue(originalValue, true), "`).") : '.');
    if (value === null) {
      msg += "\n If \"null\" is intended as an empty value be sure to mark the schema as `.nullable()`";
    }
    return msg;
  },
  defined: '${path} must be defined'
};
var string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
var number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
var date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
var boolean = {
  isValue: '${path} field must be ${value}'
};
var object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}'
};
var array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
Object.assign(Object.create(null), {
  mixed: mixed,
  string: string,
  number: number,
  date: date,
  object: object,
  array: array,
  boolean: boolean
});

/** Used for built-in method references. */

var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas$1(object, key) {
  return object != null && hasOwnProperty$9.call(object, key);
}
var _baseHas = baseHas$1;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$9 = Array.isArray;
var isArray_1 = isArray$9;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$8 = freeGlobal || freeSelf || Function('return this')();
var _root = root$8;
var root$7 = _root;

/** Built-in value references. */
var Symbol$5 = root$7.Symbol;
var _Symbol = Symbol$5;
var Symbol$4 = _Symbol;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$b.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$b.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$8.call(value, symToStringTag$1),
    tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$a = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$a.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$2(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$2;
var Symbol$3 = _Symbol,
  getRawTag = _getRawTag,
  objectToString$1 = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$3 ? Symbol$3.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$5(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString$1(value);
}
var _baseGetTag = baseGetTag$5;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$5(value) {
  return value != null && typeof value == 'object';
}
var isObjectLike_1 = isObjectLike$5;
var baseGetTag$4 = _baseGetTag,
  isObjectLike$4 = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$3(value) {
  return typeof value == 'symbol' || isObjectLike$4(value) && baseGetTag$4(value) == symbolTag$1;
}
var isSymbol_1 = isSymbol$3;
var isArray$8 = isArray_1,
  isSymbol$2 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$3(value, object) {
  if (isArray$8(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol$2(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
var _isKey = isKey$3;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$4(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}
var isObject_1 = isObject$4;
var baseGetTag$3 = _baseGetTag,
  isObject$3 = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
  funcTag$1 = '[object Function]',
  genTag = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$3(value) {
  if (!isObject$3(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$3(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$3;
var root$6 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$6['__core-js_shared__'];
var _coreJsData = coreJsData$1;
var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}
var _toSource = toSource$2;
var isFunction$2 = isFunction_1,
  isMasked = _isMasked,
  isObject$2 = isObject_1,
  toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
  objectProto$9 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$7).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$2(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$2(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}
var _getValue = getValue$1;
var baseIsNative = _baseIsNative,
  getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}
var _getNative = getNative$7;
var getNative$6 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$6(Object, 'create');
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$6.call(data, key) ? data[key] : undefined;
}
var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$5.call(data, key);
}
var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet$1;
var hashClear = _hashClear,
  hashDelete = _hashDelete,
  hashGet = _hashGet,
  hashHas = _hashHas,
  hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$2(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$2;
var eq$1 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
    index = assocIndexOf$3(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
    index = assocIndexOf$2(data, key);
  return index < 0 ? undefined : data[index][1];
}
var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear,
  listCacheDelete = _listCacheDelete,
  listCacheGet = _listCacheGet,
  listCacheHas = _listCacheHas,
  listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;
var getNative$5 = _getNative,
  root$5 = _root;

/* Built-in method references that are verified to be native. */
var Map$4 = getNative$5(root$5, 'Map');
var _Map = Map$4;
var Hash = _Hash,
  ListCache$3 = _ListCache,
  Map$3 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$3 || ListCache$3)(),
    'string': new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear,
  mapCacheDelete = _mapCacheDelete,
  mapCacheGet = _mapCacheGet,
  mapCacheHas = _mapCacheHas,
  mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$3(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3;
var MapCache$2 = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var _memoized2 = function memoized() {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = _memoized2.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    _memoized2.cache = cache.set(key, result) || cache;
    return result;
  };
  _memoized2.cache = new (memoize$1.Cache || MapCache$2)();
  return _memoized2;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache$2;
var memoize_1 = memoize$1;
var memoize = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}
var _memoizeCapped = memoizeCapped$1;
var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
var _stringToPath = stringToPath$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$1(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length,
    result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}
var _arrayMap = arrayMap$1;
var Symbol$2 = _Symbol,
  arrayMap = _arrayMap,
  isArray$7 = isArray_1,
  isSymbol$1 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
  symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$7(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString$1) + '';
  }
  if (isSymbol$1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}
var _baseToString = baseToString$1;
var baseToString = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$5(value) {
  return value == null ? '' : baseToString(value);
}
var toString_1 = toString$5;
var isArray$6 = isArray_1,
  isKey$2 = _isKey,
  stringToPath = _stringToPath,
  toString$4 = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$2(value, object) {
  if (isArray$6(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath(toString$4(value));
}
var _castPath = castPath$2;
var baseGetTag$2 = _baseGetTag,
  isObjectLike$3 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$3(value) && baseGetTag$2(value) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1;
var baseIsArguments = _baseIsArguments,
  isObjectLike$2 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$2 = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike$2(value) && hasOwnProperty$4.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};
var isArguments_1 = isArguments$2;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$2(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var _isIndex = isIndex$2;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$3(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength$3;
var isSymbol = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$4(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
var _toKey = toKey$4;
var castPath$1 = _castPath,
  isArguments$1 = isArguments_1,
  isArray$5 = isArray_1,
  isIndex$1 = _isIndex,
  isLength$2 = isLength_1,
  toKey$3 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$2(object, path, hasFunc) {
  path = castPath$1(path, object);
  var index = -1,
    length = path.length,
    result = false;
  while (++index < length) {
    var key = toKey$3(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength$2(length) && isIndex$1(key, length) && (isArray$5(object) || isArguments$1(object));
}
var _hasPath = hasPath$2;
var baseHas = _baseHas,
  hasPath$1 = _hasPath;

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath$1(object, path, baseHas);
}
var has_1 = has;
var isSchema = function isSchema(obj) {
  return obj && obj.__isYupSchema__;
};
var Condition = /*#__PURE__*/function () {
  function Condition(refs, options) {
    _classCallCheck2(this, Condition);
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;
    if (typeof options === 'function') {
      this.fn = options;
      return;
    }
    if (!has_1(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    var is = options.is,
      then = options.then,
      otherwise = options.otherwise;
    var check = typeof is === 'function' ? is : function () {
      for (var _len6 = arguments.length, values = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        values[_key6] = arguments[_key6];
      }
      return values.every(function (value) {
        return value === is;
      });
    };
    this.fn = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }
      var options = args.pop();
      var schema = args.pop();
      var branch = check.apply(void 0, args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }
  return _createClass2(Condition, [{
    key: "resolve",
    value: function resolve(base, options) {
      var values = this.refs.map(function (ref) {
        return ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
      });
      var schema = this.fn.apply(base, values.concat(base, options));
      if (schema === undefined || schema === base) return base;
      if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
      return schema.resolve(options);
    }
  }]);
}();
function toArray(value) {
  return value == null ? [] : [].concat(value);
}
function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$4.apply(this, arguments);
}
var strReg = /\$\{\s*(\w+)\s*\}/g;
var ValidationError = /*#__PURE__*/function (_Error) {
  function ValidationError(errorOrErrors, value, field, type) {
    var _this15;
    _classCallCheck2(this, ValidationError);
    _this15 = _callSuper(this, ValidationError);
    _this15.value = void 0;
    _this15.path = void 0;
    _this15.type = void 0;
    _this15.errors = void 0;
    _this15.params = void 0;
    _this15.inner = void 0;
    _this15.name = 'ValidationError';
    _this15.value = value;
    _this15.path = field;
    _this15.type = type;
    _this15.errors = [];
    _this15.inner = [];
    toArray(errorOrErrors).forEach(function (err) {
      if (ValidationError.isError(err)) {
        var _this15$errors;
        (_this15$errors = _this15.errors).push.apply(_this15$errors, _toConsumableArray2(err.errors));
        _this15.inner = _this15.inner.concat(err.inner.length ? err.inner : err);
      } else {
        _this15.errors.push(err);
      }
    });
    _this15.message = _this15.errors.length > 1 ? "".concat(_this15.errors.length, " errors occurred") : _this15.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(_this15, ValidationError);
    return _this15;
  }
  _inherits2(ValidationError, _Error);
  return _createClass2(ValidationError, null, [{
    key: "formatError",
    value: function formatError(message, params) {
      var path = params.label || params.path || 'this';
      if (path !== params.path) params = _extends$4({}, params, {
        path: path
      });
      if (typeof message === 'string') return message.replace(strReg, function (_, key) {
        return printValue(params[key]);
      });
      if (typeof message === 'function') return message(params);
      return message;
    }
  }, {
    key: "isError",
    value: function isError(err) {
      return err && err.name === 'ValidationError';
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var once = function once(cb) {
  var fired = false;
  return function () {
    if (fired) return;
    fired = true;
    cb.apply(void 0, arguments);
  };
};
function runTests(options, cb) {
  var endEarly = options.endEarly,
    tests = options.tests,
    args = options.args,
    value = options.value,
    errors = options.errors,
    sort = options.sort,
    path = options.path;
  var callback = once(cb);
  var count = tests.length;
  var nestedErrors = [];
  errors = errors ? errors : [];
  if (!count) return errors.length ? callback(new ValidationError(errors, value, path)) : callback(null, value);
  for (var _i3 = 0; _i3 < tests.length; _i3++) {
    var test = tests[_i3];
    test(args, function finishTestRun(err) {
      if (err) {
        // always return early for non validation errors
        if (!ValidationError.isError(err)) {
          return callback(err, value);
        }
        if (endEarly) {
          err.value = value;
          return callback(err, value);
        }
        nestedErrors.push(err);
      }
      if (--count <= 0) {
        if (nestedErrors.length) {
          if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

          if (errors.length) nestedErrors.push.apply(nestedErrors, _toConsumableArray2(errors));
          errors = nestedErrors;
        }
        if (errors.length) {
          callback(new ValidationError(errors, value, path), value);
          return;
        }
        callback(null, value);
      }
    });
  }
}
var getNative$4 = _getNative;
var defineProperty$1 = function () {
  try {
    var func = getNative$4(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();
var _defineProperty = defineProperty$1;
var defineProperty = _defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$2(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}
var _baseAssignValue = baseAssignValue$2;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$1(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
      iterable = Object(object),
      props = keysFunc(object),
      length = props.length;
    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}
var _createBaseFor = createBaseFor$1;
var createBaseFor = _createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$1 = createBaseFor();
var _baseFor = baseFor$1;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}
var _baseTimes = baseTimes$1;
var isBuffer$2 = {
  exports: {}
};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;
(function (module, exports) {
  var root = _root,
    stubFalse = stubFalse_1;

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Built-in value references. */
  var Buffer = moduleExports ? root.Buffer : undefined;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */
  var isBuffer = nativeIsBuffer || stubFalse;
  module.exports = isBuffer;
})(isBuffer$2, isBuffer$2.exports);
var baseGetTag$1 = _baseGetTag,
  isLength$1 = isLength_1,
  isObjectLike$1 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
  arrayTag$1 = '[object Array]',
  boolTag$1 = '[object Boolean]',
  dateTag$1 = '[object Date]',
  errorTag$1 = '[object Error]',
  funcTag = '[object Function]',
  mapTag$2 = '[object Map]',
  numberTag$1 = '[object Number]',
  objectTag$2 = '[object Object]',
  regexpTag$1 = '[object RegExp]',
  setTag$2 = '[object Set]',
  stringTag$1 = '[object String]',
  weakMapTag$1 = '[object WeakMap]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
  dataViewTag$2 = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$1(value) && isLength$1(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$1(func) {
  return function (value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$1;
var _nodeUtil = {
  exports: {}
};
(function (module, exports) {
  var freeGlobal = _freeGlobal;

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;
      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();
  module.exports = nodeUtil;
})(_nodeUtil, _nodeUtil.exports);
var baseIsTypedArray = _baseIsTypedArray,
  baseUnary = _baseUnary,
  nodeUtil = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$2;
var baseTimes = _baseTimes,
  isArguments = isArguments_1,
  isArray$4 = isArray_1,
  isBuffer$1 = isBuffer$2.exports,
  isIndex = _isIndex,
  isTypedArray$1 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$5.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$4(value),
    isArg = !isArr && isArguments(value),
    isBuff = !isArr && !isArg && isBuffer$1(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys$1;

/** Used for built-in method references. */

var objectProto$4 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$1(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$4;
  return value === proto;
}
var _isPrototype = isPrototype$1;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$1(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}
var _overArg = overArg$1;
var overArg = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg(Object.keys, Object);
var _nativeKeys = nativeKeys$1;
var isPrototype = _isPrototype,
  nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys$1;
var isFunction$1 = isFunction_1,
  isLength = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$1(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}
var isArrayLike_1 = isArrayLike$1;
var arrayLikeKeys = _arrayLikeKeys,
  baseKeys = _baseKeys,
  isArrayLike = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$3(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
var keys_1 = keys$3;
var baseFor = _baseFor,
  keys$2 = keys_1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$2(object, iteratee) {
  return object && baseFor(object, iteratee, keys$2);
}
var _baseForOwn = baseForOwn$2;
var ListCache$2 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$2();
  this.size = 0;
}
var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}
var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas$1;
var ListCache$1 = _ListCache,
  Map$2 = _Map,
  MapCache$1 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet$1;
var ListCache = _ListCache,
  stackClear = _stackClear,
  stackDelete = _stackDelete,
  stackGet = _stackGet,
  stackHas = _stackHas,
  stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$2(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$2.prototype.clear = stackClear;
Stack$2.prototype['delete'] = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;
var _Stack = Stack$2;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;
var MapCache = _MapCache,
  setCacheAdd = _setCacheAdd,
  setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$1(values) {
  var index = -1,
    length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;
var _SetCache = SetCache$1;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$1(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$1;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$1(cache, key) {
  return cache.has(key);
}
var _cacheHas = cacheHas$1;
var SetCache = _SetCache,
  arraySome = _arraySome,
  cacheHas = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
  COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
    arrLength = array.length,
    othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
    result = true,
    seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : undefined;
  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
      othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}
var _equalArrays = equalArrays$2;
var root$4 = _root;

/** Built-in value references. */
var Uint8Array$1 = root$4.Uint8Array;
var _Uint8Array = Uint8Array$1;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
    result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}
var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$1(set) {
  var index = -1,
    result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}
var _setToArray = setToArray$1;
var Symbol$1 = _Symbol,
  Uint8Array = _Uint8Array,
  eq = eq_1,
  equalArrays$1 = _equalArrays,
  mapToArray = _mapToArray,
  setToArray = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
  COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
  dateTag = '[object Date]',
  errorTag = '[object Error]',
  mapTag$1 = '[object Map]',
  numberTag = '[object Number]',
  regexpTag = '[object RegExp]',
  setTag$1 = '[object Set]',
  stringTag = '[object String]',
  symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]',
  dataViewTag$1 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
  symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$1:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);
    case errorTag:
      return object.name == other.name && object.message == other.message;
    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';
    case mapTag$1:
      var convert = mapToArray;
    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$1(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}
var _arrayPush = arrayPush$1;
var arrayPush = _arrayPush,
  isArray$3 = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$3(object) ? result : arrayPush(result, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys$1;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$1(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$1() {
  return [];
}
var stubArray_1 = stubArray$1;
var arrayFilter = _arrayFilter,
  stubArray = stubArray_1;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$2.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$1 = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var _getSymbols = getSymbols$1;
var baseGetAllKeys = _baseGetAllKeys,
  getSymbols = _getSymbols,
  keys$1 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$1(object) {
  return baseGetAllKeys(object, keys$1, getSymbols);
}
var _getAllKeys = getAllKeys$1;
var getAllKeys = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
    objProps = getAllKeys(object),
    objLength = objProps.length,
    othProps = getAllKeys(other),
    othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
      othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
      othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}
var _equalObjects = equalObjects$1;
var getNative$3 = _getNative,
  root$3 = _root;

/* Built-in method references that are verified to be native. */
var DataView$1 = getNative$3(root$3, 'DataView');
var _DataView = DataView$1;
var getNative$2 = _getNative,
  root$2 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$2(root$2, 'Promise');
var _Promise = Promise$2;
var getNative$1 = _getNative,
  root$1 = _root;

/* Built-in method references that are verified to be native. */
var Set$2 = getNative$1(root$1, 'Set');
var _Set = Set$2;
var getNative = _getNative,
  root = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$2 = getNative(root, 'WeakMap');
var _WeakMap = WeakMap$2;
var DataView = _DataView,
  Map$1 = _Map,
  Promise$1 = _Promise,
  Set$1 = _Set,
  WeakMap$1 = _WeakMap,
  baseGetTag = _baseGetTag,
  toSource = _toSource;

/** `Object#toString` result references. */
var mapTag = '[object Map]',
  objectTag$1 = '[object Object]',
  promiseTag = '[object Promise]',
  setTag = '[object Set]',
  weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
  mapCtorString = toSource(Map$1),
  promiseCtorString = toSource(Promise$1),
  setCtorString = toSource(Set$1),
  weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$1 = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$1(new Map$1()) != mapTag || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$1 && getTag$1(new Set$1()) != setTag || WeakMap$1 && getTag$1(new WeakMap$1()) != weakMapTag) {
  getTag$1 = function getTag$1(value) {
    var result = baseGetTag(value),
      Ctor = result == objectTag$1 ? value.constructor : undefined,
      ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
var _getTag = getTag$1;
var Stack$1 = _Stack,
  equalArrays = _equalArrays,
  equalByTag = _equalByTag,
  equalObjects = _equalObjects,
  getTag = _getTag,
  isArray$2 = isArray_1,
  isBuffer = isBuffer$2.exports,
  isTypedArray = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
  arrayTag = '[object Array]',
  objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$2(object),
    othIsArr = isArray$2(other),
    objTag = objIsArr ? arrayTag : getTag(object),
    othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag,
    othIsObj = othTag == objectTag,
    isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
      othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
        othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack$1());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;
var baseIsEqualDeep = _baseIsEqualDeep,
  isObjectLike = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$2(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
}
var _baseIsEqual = baseIsEqual$2;
var Stack = _Stack,
  baseIsEqual$1 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
  COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
    length = index,
    noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
      objValue = object[key],
      srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}
var _baseIsMatch = baseIsMatch$1;
var isObject$1 = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject$1(value);
}
var _isStrictComparable = isStrictComparable$2;
var isStrictComparable$1 = _isStrictComparable,
  keys = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys(object),
    length = result.length;
  while (length--) {
    var key = result[length],
      value = object[key];
    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}
var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$2(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2;
var baseIsMatch = _baseIsMatch,
  getMatchData = _getMatchData,
  matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}
var _baseMatches = baseMatches$1;
var castPath = _castPath,
  toKey$2 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$2(object, path) {
  path = castPath(path, object);
  var index = 0,
    length = path.length;
  while (object != null && index < length) {
    object = object[toKey$2(path[index++])];
  }
  return index && index == length ? object : undefined;
}
var _baseGet = baseGet$2;
var baseGet$1 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$1(object, path);
  return result === undefined ? defaultValue : result;
}
var get_1 = get$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}
var _baseHasIn = baseHasIn$1;
var baseHasIn = _baseHasIn,
  hasPath = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$1(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}
var hasIn_1 = hasIn$1;
var baseIsEqual = _baseIsEqual,
  get = get_1,
  hasIn = hasIn_1,
  isKey$1 = _isKey,
  isStrictComparable = _isStrictComparable,
  matchesStrictComparable = _matchesStrictComparable,
  toKey$1 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
  COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$1(path), srcValue);
  }
  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$1(value) {
  return value;
}
var identity_1 = identity$1;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$1(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}
var _baseProperty = baseProperty$1;
var baseGet = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function (object) {
    return baseGet(object, path);
  };
}
var _basePropertyDeep = basePropertyDeep$1;
var baseProperty = _baseProperty,
  basePropertyDeep = _basePropertyDeep,
  isKey = _isKey,
  toKey = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
var property_1 = property$1;
var baseMatches = _baseMatches,
  baseMatchesProperty = _baseMatchesProperty,
  identity = identity_1,
  isArray$1 = isArray_1,
  property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$2(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray$1(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
var _baseIteratee = baseIteratee$2;
var baseAssignValue$1 = _baseAssignValue,
  baseForOwn$1 = _baseForOwn,
  baseIteratee$1 = _baseIteratee;

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee$1(iteratee);
  baseForOwn$1(object, function (value, key, object) {
    baseAssignValue$1(result, key, iteratee(value, key, object));
  });
  return result;
}
var mapValues_1 = mapValues;

/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */

function Cache(maxSize) {
  this._maxSize = maxSize;
  this.clear();
}
Cache.prototype.clear = function () {
  this._size = 0;
  this._values = Object.create(null);
};
Cache.prototype.get = function (key) {
  return this._values[key];
};
Cache.prototype.set = function (key, value) {
  this._size >= this._maxSize && this.clear();
  if (!(key in this._values)) this._size++;
  return this._values[key] = value;
};
var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512;
var pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE);
var propertyExpr = {
  Cache: Cache,
  split: split,
  normalizePath: normalizePath,
  setter: function setter(path) {
    var parts = normalizePath(path);
    return setCache.get(path) || setCache.set(path, function setter(obj, value) {
      var index = 0;
      var len = parts.length;
      var data = obj;
      while (index < len - 1) {
        var part = parts[index];
        if (part === '__proto__' || part === 'constructor' || part === 'prototype') {
          return obj;
        }
        data = data[parts[index++]];
      }
      data[parts[index]] = value;
    });
  },
  getter: function getter(path, safe) {
    var parts = normalizePath(path);
    return getCache.get(path) || getCache.set(path, function getter(data) {
      var index = 0,
        len = parts.length;
      while (index < len) {
        if (data != null || !safe) data = data[parts[index++]];else return;
      }
      return data;
    });
  },
  join: function join(segments) {
    return segments.reduce(function (path, part) {
      return path + (isQuoted(part) || DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
    }, '');
  },
  forEach: function forEach(path, cb, thisArg) {
    _forEach(Array.isArray(path) ? path : split(path), cb, thisArg);
  }
};
function normalizePath(path) {
  return pathCache.get(path) || pathCache.set(path, split(path).map(function (part) {
    return part.replace(CLEAN_QUOTES_REGEX, '$2');
  }));
}
function split(path) {
  return path.match(SPLIT_REGEX) || [''];
}
function _forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket;
  for (idx = 0; idx < len; idx++) {
    part = parts[idx];
    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"';
      }
      isBracket = isQuoted(part);
      isArray = !isBracket && /^\d+$/.test(part);
      iter.call(thisArg, part, isBracket, isArray, idx, parts);
    }
  }
}
function isQuoted(str) {
  return typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1;
}
function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX);
}
function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part);
}
function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part));
}
var prefixes = {
  context: '$',
  value: '.'
};
var Reference = /*#__PURE__*/function () {
  function Reference(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck2(this, Reference);
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    var prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && propertyExpr.getter(this.path, true);
    this.map = options.map;
  }
  return _createClass2(Reference, [{
    key: "getValue",
    value: function getValue(value, parent, context) {
      var result = this.isContext ? context : this.isValue ? value : parent;
      if (this.getter) result = this.getter(result || {});
      if (this.map) result = this.map(result);
      return result;
    }
    /**
     *
     * @param {*} value
     * @param {Object} options
     * @param {Object=} options.context
     * @param {Object=} options.parent
     */
  }, {
    key: "cast",
    value: function cast(value, options) {
      return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
  }, {
    key: "resolve",
    value: function resolve() {
      return this;
    }
  }, {
    key: "describe",
    value: function describe() {
      return {
        type: 'ref',
        key: this.key
      };
    }
  }, {
    key: "toString",
    value: function toString() {
      return "Ref(".concat(this.key, ")");
    }
  }], [{
    key: "isRef",
    value: function isRef(value) {
      return value && value.__isYupRef;
    }
  }]);
}(); // @ts-ignore
Reference.prototype.__isYupRef = true;
function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function createValidation(config) {
  function validate(_ref, cb) {
    var value = _ref.value,
      _ref$path = _ref.path,
      path = _ref$path === void 0 ? '' : _ref$path,
      label = _ref.label,
      options = _ref.options,
      originalValue = _ref.originalValue,
      sync = _ref.sync,
      rest = _objectWithoutPropertiesLoose$1(_ref, ["value", "path", "label", "options", "originalValue", "sync"]);
    var name = config.name,
      test = config.test,
      params = config.params,
      message = config.message;
    var parent = options.parent,
      context = options.context;
    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }
    function createError() {
      var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var nextParams = mapValues_1(_extends$3({
        value: value,
        originalValue: originalValue,
        label: label,
        path: overrides.path || path
      }, params, overrides.params), resolve);
      var error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
      error.params = nextParams;
      return error;
    }
    var ctx = _extends$3({
      path: path,
      parent: parent,
      type: name,
      createError: createError,
      resolve: resolve,
      options: options,
      originalValue: originalValue
    }, rest);
    if (!sync) {
      try {
        Promise.resolve(test.call(ctx, value, ctx)).then(function (validOrError) {
          if (ValidationError.isError(validOrError)) cb(validOrError);else if (!validOrError) cb(createError());else cb(null, validOrError);
        }).catch(cb);
      } catch (err) {
        cb(err);
      }
      return;
    }
    var result;
    try {
      var _ref2;
      result = test.call(ctx, value, ctx);
      if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') {
        throw new Error("Validation test of type: \"".concat(ctx.type, "\" returned a Promise during a synchronous validate. ") + "This test will finish after the validate call has returned");
      }
    } catch (err) {
      cb(err);
      return;
    }
    if (ValidationError.isError(result)) cb(result);else if (!result) cb(createError());else cb(null, result);
  }
  validate.OPTIONS = config;
  return validate;
}
var trim$1 = function trim$1(part) {
  return part.substr(0, part.length - 1).substr(1);
};
function getIn(schema, path, value) {
  var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : value;
  var parent, lastPart, lastPartDebug; // root path: ''

  if (!path) return {
    parent: parent,
    parentPath: path,
    schema: schema
  };
  propertyExpr.forEach(path, function (_part, isBracket, isArray) {
    var part = isBracket ? trim$1(_part) : _part;
    schema = schema.resolve({
      context: context,
      parent: parent,
      value: value
    });
    if (schema.innerType) {
      var idx = isArray ? parseInt(part, 10) : 0;
      if (value && idx >= value.length) {
        throw new Error("Yup.reach cannot resolve an array item at index: ".concat(_part, ", in the path: ").concat(path, ". ") + "because there is no value at that index. ");
      }
      parent = value;
      value = value && value[idx];
      schema = schema.innerType;
    } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal

    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error("The schema does not contain the path: ".concat(path, ". ") + "(failed at: ".concat(lastPartDebug, " which is a type: \"").concat(schema._type, "\")"));
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }
    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema: schema,
    parent: parent,
    parentPath: lastPart
  };
}
var ReferenceSet = /*#__PURE__*/function () {
  function ReferenceSet() {
    _classCallCheck2(this, ReferenceSet);
    this.list = void 0;
    this.refs = void 0;
    this.list = new Set();
    this.refs = new Map();
  }
  return _createClass2(ReferenceSet, [{
    key: "size",
    get: function get() {
      return this.list.size + this.refs.size;
    }
  }, {
    key: "describe",
    value: function describe() {
      var description = [];
      var _iterator2 = _createForOfIteratorHelper(this.list),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          description.push(item);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = _createForOfIteratorHelper(this.refs),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
            ref = _step3$value[1];
          description.push(ref.describe());
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return description;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
  }, {
    key: "resolveAll",
    value: function resolveAll(resolve) {
      return this.toArray().reduce(function (acc, e) {
        return acc.concat(Reference.isRef(e) ? resolve(e) : e);
      }, []);
    }
  }, {
    key: "add",
    value: function add(value) {
      Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
  }, {
    key: "delete",
    value: function _delete(value) {
      Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    }
  }, {
    key: "clone",
    value: function clone() {
      var next = new ReferenceSet();
      next.list = new Set(this.list);
      next.refs = new Map(this.refs);
      return next;
    }
  }, {
    key: "merge",
    value: function merge(newItems, removeItems) {
      var next = this.clone();
      newItems.list.forEach(function (value) {
        return next.add(value);
      });
      newItems.refs.forEach(function (value) {
        return next.add(value);
      });
      removeItems.list.forEach(function (value) {
        return next.delete(value);
      });
      removeItems.refs.forEach(function (value) {
        return next.delete(value);
      });
      return next;
    }
  }]);
}();
function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
var BaseSchema = /*#__PURE__*/function () {
  function BaseSchema(options) {
    var _this16 = this;
    _classCallCheck2(this, BaseSchema);
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this._typeError = void 0;
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(function () {
      _this16.typeError(mixed.notType);
    });
    this.type = (options == null ? void 0 : options.type) || 'mixed';
    this.spec = _extends$2({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      nullable: false,
      presence: 'optional'
    }, options == null ? void 0 : options.spec);
  } // TODO: remove
  return _createClass2(BaseSchema, [{
    key: "_type",
    get: function get() {
      return this.type;
    }
  }, {
    key: "_typeCheck",
    value: function _typeCheck(_value) {
      return true;
    }
  }, {
    key: "clone",
    value: function clone(spec) {
      if (this._mutate) {
        if (spec) Object.assign(this.spec, spec);
        return this;
      } // if the nested value is a schema we can skip cloning, since
      // they are already immutable

      var next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly

      next.type = this.type;
      next._typeError = this._typeError;
      next._whitelistError = this._whitelistError;
      next._blacklistError = this._blacklistError;
      next._whitelist = this._whitelist.clone();
      next._blacklist = this._blacklist.clone();
      next.exclusiveTests = _extends$2({}, this.exclusiveTests); // @ts-expect-error this is readonly

      next.deps = _toConsumableArray2(this.deps);
      next.conditions = _toConsumableArray2(this.conditions);
      next.tests = _toConsumableArray2(this.tests);
      next.transforms = _toConsumableArray2(this.transforms);
      next.spec = _clone(_extends$2({}, this.spec, spec));
      return next;
    }
  }, {
    key: "label",
    value: function label(_label) {
      var next = this.clone();
      next.spec.label = _label;
      return next;
    }
  }, {
    key: "meta",
    value: function meta() {
      if (arguments.length === 0) return this.spec.meta;
      var next = this.clone();
      next.spec.meta = Object.assign(next.spec.meta || {}, arguments.length <= 0 ? undefined : arguments[0]);
      return next;
    } // withContext<TContext extends AnyObject>(): BaseSchema<
    //   TCast,
    //   TContext,
    //   TOutput
    // > {
    //   return this as any;
    // }
  }, {
    key: "withMutation",
    value: function withMutation(fn) {
      var before = this._mutate;
      this._mutate = true;
      var result = fn(this);
      this._mutate = before;
      return result;
    }
  }, {
    key: "concat",
    value: function concat(schema) {
      if (!schema || schema === this) return this;
      if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError("You cannot `concat()` schema's of different types: ".concat(this.type, " and ").concat(schema.type));
      var base = this;
      var combined = schema.clone();
      var mergedSpec = _extends$2({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
      //   mergedSpec.nullable = base.spec.nullable;
      // if (combined.spec.presence === UNSET)
      //   mergedSpec.presence = base.spec.presence;

      combined.spec = mergedSpec;
      combined._typeError || (combined._typeError = base._typeError);
      combined._whitelistError || (combined._whitelistError = base._whitelistError);
      combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
      // precedence in case of conflicts)

      combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
      combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests

      combined.tests = base.tests;
      combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
      // the deduping logic is consistent

      combined.withMutation(function (next) {
        schema.tests.forEach(function (fn) {
          next.test(fn.OPTIONS);
        });
      });
      combined.transforms = [].concat(_toConsumableArray2(base.transforms), _toConsumableArray2(combined.transforms));
      return combined;
    }
  }, {
    key: "isType",
    value: function isType(v) {
      if (this.spec.nullable && v === null) return true;
      return this._typeCheck(v);
    }
  }, {
    key: "resolve",
    value: function resolve(options) {
      var schema = this;
      if (schema.conditions.length) {
        var conditions = schema.conditions;
        schema = schema.clone();
        schema.conditions = [];
        schema = conditions.reduce(function (schema, condition) {
          return condition.resolve(schema, options);
        }, schema);
        schema = schema.resolve(options);
      }
      return schema;
    }
    /**
     *
     * @param {*} value
     * @param {Object} options
     * @param {*=} options.parent
     * @param {*=} options.context
     */
  }, {
    key: "cast",
    value: function cast(value) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var resolvedSchema = this.resolve(_extends$2({
        value: value
      }, options));
      var result = resolvedSchema._cast(value, options);
      if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
        var formattedValue = printValue(value);
        var formattedResult = printValue(result);
        throw new TypeError("The value of ".concat(options.path || 'field', " could not be cast to a value ") + "that satisfies the schema type: \"".concat(resolvedSchema._type, "\". \n\n") + "attempted value: ".concat(formattedValue, " \n") + (formattedResult !== formattedValue ? "result of cast: ".concat(formattedResult) : ''));
      }
      return result;
    }
  }, {
    key: "_cast",
    value: function _cast(rawValue, _options) {
      var _this17 = this;
      var value = rawValue === undefined ? rawValue : this.transforms.reduce(function (value, fn) {
        return fn.call(_this17, value, rawValue, _this17);
      }, rawValue);
      if (value === undefined) {
        value = this.getDefault();
      }
      return value;
    }
  }, {
    key: "_validate",
    value: function _validate(_value) {
      var _this18 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;
      var sync = options.sync,
        path = options.path,
        _options$from = options.from,
        from = _options$from === void 0 ? [] : _options$from,
        _options$originalValu = options.originalValue,
        originalValue = _options$originalValu === void 0 ? _value : _options$originalValu,
        _options$strict = options.strict,
        strict = _options$strict === void 0 ? this.spec.strict : _options$strict,
        _options$abortEarly = options.abortEarly,
        abortEarly = _options$abortEarly === void 0 ? this.spec.abortEarly : _options$abortEarly;
      var value = _value;
      if (!strict) {
        // this._validating = true;
        value = this._cast(value, _extends$2({
          assert: false
        }, options)); // this._validating = false;
      } // value is cast, we can check if it meets type requirements

      var args = {
        value: value,
        path: path,
        options: options,
        originalValue: originalValue,
        schema: this,
        label: this.spec.label,
        sync: sync,
        from: from
      };
      var initialTests = [];
      if (this._typeError) initialTests.push(this._typeError);
      var finalTests = [];
      if (this._whitelistError) finalTests.push(this._whitelistError);
      if (this._blacklistError) finalTests.push(this._blacklistError);
      runTests({
        args: args,
        value: value,
        path: path,
        sync: sync,
        tests: initialTests,
        endEarly: abortEarly
      }, function (err) {
        if (err) return void cb(err, value);
        runTests({
          tests: _this18.tests.concat(finalTests),
          args: args,
          path: path,
          sync: sync,
          value: value,
          endEarly: abortEarly
        }, cb);
      });
    }
  }, {
    key: "validate",
    value: function validate(value, options, maybeCb) {
      var schema = this.resolve(_extends$2({}, options, {
        value: value
      })); // callback case is for nested validations

      return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise(function (resolve, reject) {
        return schema._validate(value, options, function (err, value) {
          if (err) reject(err);else resolve(value);
        });
      });
    }
  }, {
    key: "validateSync",
    value: function validateSync(value, options) {
      var schema = this.resolve(_extends$2({}, options, {
        value: value
      }));
      var result;
      schema._validate(value, _extends$2({}, options, {
        sync: true
      }), function (err, value) {
        if (err) throw err;
        result = value;
      });
      return result;
    }
  }, {
    key: "isValid",
    value: function isValid(value, options) {
      return this.validate(value, options).then(function () {
        return true;
      }, function (err) {
        if (ValidationError.isError(err)) return false;
        throw err;
      });
    }
  }, {
    key: "isValidSync",
    value: function isValidSync(value, options) {
      try {
        this.validateSync(value, options);
        return true;
      } catch (err) {
        if (ValidationError.isError(err)) return false;
        throw err;
      }
    }
  }, {
    key: "_getDefault",
    value: function _getDefault() {
      var defaultValue = this.spec.default;
      if (defaultValue == null) {
        return defaultValue;
      }
      return typeof defaultValue === 'function' ? defaultValue.call(this) : _clone(defaultValue);
    }
  }, {
    key: "getDefault",
    value: function getDefault(options) {
      var schema = this.resolve(options || {});
      return schema._getDefault();
    }
  }, {
    key: "default",
    value: function _default(def) {
      if (arguments.length === 0) {
        return this._getDefault();
      }
      var next = this.clone({
        default: def
      });
      return next;
    }
  }, {
    key: "strict",
    value: function strict() {
      var isStrict = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var next = this.clone();
      next.spec.strict = isStrict;
      return next;
    }
  }, {
    key: "_isPresent",
    value: function _isPresent(value) {
      return value != null;
    }
  }, {
    key: "defined",
    value: function defined() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mixed.defined;
      return this.test({
        message: message,
        name: 'defined',
        exclusive: true,
        test: function test(value) {
          return value !== undefined;
        }
      });
    }
  }, {
    key: "required",
    value: function required() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mixed.required;
      return this.clone({
        presence: 'required'
      }).withMutation(function (s) {
        return s.test({
          message: message,
          name: 'required',
          exclusive: true,
          test: function test(value) {
            return this.schema._isPresent(value);
          }
        });
      });
    }
  }, {
    key: "notRequired",
    value: function notRequired() {
      var next = this.clone({
        presence: 'optional'
      });
      next.tests = next.tests.filter(function (test) {
        return test.OPTIONS.name !== 'required';
      });
      return next;
    }
  }, {
    key: "nullable",
    value: function nullable() {
      var isNullable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var next = this.clone({
        nullable: isNullable !== false
      });
      return next;
    }
  }, {
    key: "transform",
    value: function transform(fn) {
      var next = this.clone();
      next.transforms.push(fn);
      return next;
    }
    /**
     * Adds a test function to the schema's queue of tests.
     * tests can be exclusive or non-exclusive.
     *
     * - exclusive tests, will replace any existing tests of the same name.
     * - non-exclusive: can be stacked
     *
     * If a non-exclusive test is added to a schema with an exclusive test of the same name
     * the exclusive test is removed and further tests of the same name will be stacked.
     *
     * If an exclusive test is added to a schema with non-exclusive tests of the same name
     * the previous tests are removed and further tests of the same name will replace each other.
     */
  }, {
    key: "test",
    value: function test() {
      var opts;
      if (arguments.length === 1) {
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'function') {
          opts = {
            test: arguments.length <= 0 ? undefined : arguments[0]
          };
        } else {
          opts = arguments.length <= 0 ? undefined : arguments[0];
        }
      } else if (arguments.length === 2) {
        opts = {
          name: arguments.length <= 0 ? undefined : arguments[0],
          test: arguments.length <= 1 ? undefined : arguments[1]
        };
      } else {
        opts = {
          name: arguments.length <= 0 ? undefined : arguments[0],
          message: arguments.length <= 1 ? undefined : arguments[1],
          test: arguments.length <= 2 ? undefined : arguments[2]
        };
      }
      if (opts.message === undefined) opts.message = mixed.default;
      if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
      var next = this.clone();
      var validate = createValidation(opts);
      var isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
      if (opts.exclusive) {
        if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
      }
      if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
      next.tests = next.tests.filter(function (fn) {
        if (fn.OPTIONS.name === opts.name) {
          if (isExclusive) return false;
          if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
        }
        return true;
      });
      next.tests.push(validate);
      return next;
    }
  }, {
    key: "when",
    value: function when(keys, options) {
      if (!Array.isArray(keys) && typeof keys !== 'string') {
        options = keys;
        keys = '.';
      }
      var next = this.clone();
      var deps = toArray(keys).map(function (key) {
        return new Reference(key);
      });
      deps.forEach(function (dep) {
        // @ts-ignore
        if (dep.isSibling) next.deps.push(dep.key);
      });
      next.conditions.push(new Condition(deps, options));
      return next;
    }
  }, {
    key: "typeError",
    value: function typeError(message) {
      var next = this.clone();
      next._typeError = createValidation({
        message: message,
        name: 'typeError',
        test: function test(value) {
          if (value !== undefined && !this.schema.isType(value)) return this.createError({
            params: {
              type: this.schema._type
            }
          });
          return true;
        }
      });
      return next;
    }
  }, {
    key: "oneOf",
    value: function oneOf(enums) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : mixed.oneOf;
      var next = this.clone();
      enums.forEach(function (val) {
        next._whitelist.add(val);
        next._blacklist.delete(val);
      });
      next._whitelistError = createValidation({
        message: message,
        name: 'oneOf',
        test: function test(value) {
          if (value === undefined) return true;
          var valids = this.schema._whitelist;
          var resolved = valids.resolveAll(this.resolve);
          return resolved.includes(value) ? true : this.createError({
            params: {
              values: valids.toArray().join(', '),
              resolved: resolved
            }
          });
        }
      });
      return next;
    }
  }, {
    key: "notOneOf",
    value: function notOneOf(enums) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : mixed.notOneOf;
      var next = this.clone();
      enums.forEach(function (val) {
        next._blacklist.add(val);
        next._whitelist.delete(val);
      });
      next._blacklistError = createValidation({
        message: message,
        name: 'notOneOf',
        test: function test(value) {
          var invalids = this.schema._blacklist;
          var resolved = invalids.resolveAll(this.resolve);
          if (resolved.includes(value)) return this.createError({
            params: {
              values: invalids.toArray().join(', '),
              resolved: resolved
            }
          });
          return true;
        }
      });
      return next;
    }
  }, {
    key: "strip",
    value: function strip() {
      var _strip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var next = this.clone();
      next.spec.strip = _strip;
      return next;
    }
  }, {
    key: "describe",
    value: function describe() {
      var next = this.clone();
      var _next$spec = next.spec,
        label = _next$spec.label,
        meta = _next$spec.meta;
      var description = {
        meta: meta,
        label: label,
        type: next.type,
        oneOf: next._whitelist.describe(),
        notOneOf: next._blacklist.describe(),
        tests: next.tests.map(function (fn) {
          return {
            name: fn.OPTIONS.name,
            params: fn.OPTIONS.params
          };
        }).filter(function (n, idx, list) {
          return list.findIndex(function (c) {
            return c.name === n.name;
          }) === idx;
        })
      };
      return description;
    }
  }]);
}(); // eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-expect-error
BaseSchema.prototype.__isYupSchema__ = true;
var _loop = function _loop() {
  var method = _arr[_i4];
  BaseSchema.prototype["".concat(method, "At")] = function (path, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _getIn = getIn(this, path, value, options.context),
      parent = _getIn.parent,
      parentPath = _getIn.parentPath,
      schema = _getIn.schema;
    return schema[method](parent && parent[parentPath], _extends$2({}, options, {
      parent: parent,
      path: path
    }));
  };
};
for (var _i4 = 0, _arr = ['validate', 'validateSync']; _i4 < _arr.length; _i4++) {
  _loop();
}
for (var _i5 = 0, _arr2 = ['equals', 'is']; _i5 < _arr2.length; _i5++) {
  var alias = _arr2[_i5];
  BaseSchema.prototype[alias] = BaseSchema.prototype.oneOf;
}
for (var _i6 = 0, _arr3 = ['not', 'nope']; _i6 < _arr3.length; _i6++) {
  var _alias = _arr3[_i6];
  BaseSchema.prototype[_alias] = BaseSchema.prototype.notOneOf;
}
BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;
var Mixed = BaseSchema;
function create$3() {
  return new Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class

create$3.prototype = Mixed.prototype;
var isAbsent = function isAbsent(value) {
  return value == null;
};
function create$2() {
  return new BooleanSchema();
}
var BooleanSchema = /*#__PURE__*/function (_BaseSchema) {
  function BooleanSchema() {
    var _this19;
    _classCallCheck2(this, BooleanSchema);
    _this19 = _callSuper(this, BooleanSchema, [{
      type: 'boolean'
    }]);
    _this19.withMutation(function () {
      _this19.transform(function (value) {
        if (!this.isType(value)) {
          if (/^(true|1)$/i.test(String(value))) return true;
          if (/^(false|0)$/i.test(String(value))) return false;
        }
        return value;
      });
    });
    return _this19;
  }
  _inherits2(BooleanSchema, _BaseSchema);
  return _createClass2(BooleanSchema, [{
    key: "_typeCheck",
    value: function _typeCheck(v) {
      if (v instanceof Boolean) v = v.valueOf();
      return typeof v === 'boolean';
    }
  }, {
    key: "isTrue",
    value: function isTrue() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : boolean.isValue;
      return this.test({
        message: message,
        name: 'is-value',
        exclusive: true,
        params: {
          value: 'true'
        },
        test: function test(value) {
          return isAbsent(value) || value === true;
        }
      });
    }
  }, {
    key: "isFalse",
    value: function isFalse() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : boolean.isValue;
      return this.test({
        message: message,
        name: 'is-value',
        exclusive: true,
        params: {
          value: 'false'
        },
        test: function test(value) {
          return isAbsent(value) || value === false;
        }
      });
    }
  }]);
}(BaseSchema);
create$2.prototype = BooleanSchema.prototype;
var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

var rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line

var rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
var isTrimmed = function isTrimmed(value) {
  return isAbsent(value) || value === value.trim();
};
var objStringTag = {}.toString();
function create$1() {
  return new StringSchema();
}
var StringSchema = /*#__PURE__*/function (_BaseSchema2) {
  function StringSchema() {
    var _this20;
    _classCallCheck2(this, StringSchema);
    _this20 = _callSuper(this, StringSchema, [{
      type: 'string'
    }]);
    _this20.withMutation(function () {
      _this20.transform(function (value) {
        if (this.isType(value)) return value;
        if (Array.isArray(value)) return value;
        var strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
    return _this20;
  }
  _inherits2(StringSchema, _BaseSchema2);
  return _createClass2(StringSchema, [{
    key: "_typeCheck",
    value: function _typeCheck(value) {
      if (value instanceof String) value = value.valueOf();
      return typeof value === 'string';
    }
  }, {
    key: "_isPresent",
    value: function _isPresent(value) {
      return _superPropGet(StringSchema, "_isPresent", this, 3)([value]) && !!value.length;
    }
  }, {
    key: "length",
    value: function length(_length) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : string.length;
      return this.test({
        message: message,
        name: 'length',
        exclusive: true,
        params: {
          length: _length
        },
        test: function test(value) {
          return isAbsent(value) || value.length === this.resolve(_length);
        }
      });
    }
  }, {
    key: "min",
    value: function min(_min) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : string.min;
      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          min: _min
        },
        test: function test(value) {
          return isAbsent(value) || value.length >= this.resolve(_min);
        }
      });
    }
  }, {
    key: "max",
    value: function max(_max) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : string.max;
      return this.test({
        name: 'max',
        exclusive: true,
        message: message,
        params: {
          max: _max
        },
        test: function test(value) {
          return isAbsent(value) || value.length <= this.resolve(_max);
        }
      });
    }
  }, {
    key: "matches",
    value: function matches(regex, options) {
      var excludeEmptyString = false;
      var message;
      var name;
      if (options) {
        if (typeof options === 'object') {
          var _options$excludeEmpty = options.excludeEmptyString;
          excludeEmptyString = _options$excludeEmpty === void 0 ? false : _options$excludeEmpty;
          message = options.message;
          name = options.name;
        } else {
          message = options;
        }
      }
      return this.test({
        name: name || 'matches',
        message: message || string.matches,
        params: {
          regex: regex
        },
        test: function test(value) {
          return isAbsent(value) || value === '' && excludeEmptyString || value.search(regex) !== -1;
        }
      });
    }
  }, {
    key: "email",
    value: function email() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.email;
      return this.matches(rEmail, {
        name: 'email',
        message: message,
        excludeEmptyString: true
      });
    }
  }, {
    key: "url",
    value: function url() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.url;
      return this.matches(rUrl, {
        name: 'url',
        message: message,
        excludeEmptyString: true
      });
    }
  }, {
    key: "uuid",
    value: function uuid() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.uuid;
      return this.matches(rUUID, {
        name: 'uuid',
        message: message,
        excludeEmptyString: false
      });
    } //-- transforms --
  }, {
    key: "ensure",
    value: function ensure() {
      return this.default('').transform(function (val) {
        return val === null ? '' : val;
      });
    }
  }, {
    key: "trim",
    value: function trim() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.trim;
      return this.transform(function (val) {
        return val != null ? val.trim() : val;
      }).test({
        message: message,
        name: 'trim',
        test: isTrimmed
      });
    }
  }, {
    key: "lowercase",
    value: function lowercase() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.lowercase;
      return this.transform(function (value) {
        return !isAbsent(value) ? value.toLowerCase() : value;
      }).test({
        message: message,
        name: 'string_case',
        exclusive: true,
        test: function test(value) {
          return isAbsent(value) || value === value.toLowerCase();
        }
      });
    }
  }, {
    key: "uppercase",
    value: function uppercase() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.uppercase;
      return this.transform(function (value) {
        return !isAbsent(value) ? value.toUpperCase() : value;
      }).test({
        message: message,
        name: 'string_case',
        exclusive: true,
        test: function test(value) {
          return isAbsent(value) || value === value.toUpperCase();
        }
      });
    }
  }]);
}(BaseSchema);
create$1.prototype = StringSchema.prototype; //
// String Interfaces
//

/* eslint-disable */

/**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */
//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
    minutesOffset = 0,
    timestamp,
    struct;
  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) struct[k] = +struct[k] || 0; // allow undefined days and months

    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds

    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time

    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }
      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;
  return timestamp;
}

// @ts-ignore
var invalidDate = new Date('');
var isDate = function isDate(obj) {
  return Object.prototype.toString.call(obj) === '[object Date]';
};
var DateSchema = /*#__PURE__*/function (_BaseSchema3) {
  function DateSchema() {
    var _this21;
    _classCallCheck2(this, DateSchema);
    _this21 = _callSuper(this, DateSchema, [{
      type: 'date'
    }]);
    _this21.withMutation(function () {
      _this21.transform(function (value) {
        if (this.isType(value)) return value;
        value = parseIsoDate(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.

        return !isNaN(value) ? new Date(value) : invalidDate;
      });
    });
    return _this21;
  }
  _inherits2(DateSchema, _BaseSchema3);
  return _createClass2(DateSchema, [{
    key: "_typeCheck",
    value: function _typeCheck(v) {
      return isDate(v) && !isNaN(v.getTime());
    }
  }, {
    key: "prepareParam",
    value: function prepareParam(ref, name) {
      var param;
      if (!Reference.isRef(ref)) {
        var cast = this.cast(ref);
        if (!this._typeCheck(cast)) throw new TypeError("`".concat(name, "` must be a Date or a value that can be `cast()` to a Date"));
        param = cast;
      } else {
        param = ref;
      }
      return param;
    }
  }, {
    key: "min",
    value: function min(_min2) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : date.min;
      var limit = this.prepareParam(_min2, 'min');
      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          min: _min2
        },
        test: function test(value) {
          return isAbsent(value) || value >= this.resolve(limit);
        }
      });
    }
  }, {
    key: "max",
    value: function max(_max2) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : date.max;
      var limit = this.prepareParam(_max2, 'max');
      return this.test({
        message: message,
        name: 'max',
        exclusive: true,
        params: {
          max: _max2
        },
        test: function test(value) {
          return isAbsent(value) || value <= this.resolve(limit);
        }
      });
    }
  }]);
}(BaseSchema);
DateSchema.INVALID_DATE = invalidDate;
DateSchema.prototype;

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */

function arrayReduce$1(array, iteratee, accumulator, initAccum) {
  var index = -1,
    length = array == null ? 0 : array.length;
  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}
var _arrayReduce = arrayReduce$1;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */

function basePropertyOf$1(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}
var _basePropertyOf = basePropertyOf$1;
var basePropertyOf = _basePropertyOf;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',
  '\xc1': 'A',
  '\xc2': 'A',
  '\xc3': 'A',
  '\xc4': 'A',
  '\xc5': 'A',
  '\xe0': 'a',
  '\xe1': 'a',
  '\xe2': 'a',
  '\xe3': 'a',
  '\xe4': 'a',
  '\xe5': 'a',
  '\xc7': 'C',
  '\xe7': 'c',
  '\xd0': 'D',
  '\xf0': 'd',
  '\xc8': 'E',
  '\xc9': 'E',
  '\xca': 'E',
  '\xcb': 'E',
  '\xe8': 'e',
  '\xe9': 'e',
  '\xea': 'e',
  '\xeb': 'e',
  '\xcc': 'I',
  '\xcd': 'I',
  '\xce': 'I',
  '\xcf': 'I',
  '\xec': 'i',
  '\xed': 'i',
  '\xee': 'i',
  '\xef': 'i',
  '\xd1': 'N',
  '\xf1': 'n',
  '\xd2': 'O',
  '\xd3': 'O',
  '\xd4': 'O',
  '\xd5': 'O',
  '\xd6': 'O',
  '\xd8': 'O',
  '\xf2': 'o',
  '\xf3': 'o',
  '\xf4': 'o',
  '\xf5': 'o',
  '\xf6': 'o',
  '\xf8': 'o',
  '\xd9': 'U',
  '\xda': 'U',
  '\xdb': 'U',
  '\xdc': 'U',
  '\xf9': 'u',
  '\xfa': 'u',
  '\xfb': 'u',
  '\xfc': 'u',
  '\xdd': 'Y',
  '\xfd': 'y',
  '\xff': 'y',
  '\xc6': 'Ae',
  '\xe6': 'ae',
  '\xde': 'Th',
  '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  "\u0100": 'A',
  "\u0102": 'A',
  "\u0104": 'A',
  "\u0101": 'a',
  "\u0103": 'a',
  "\u0105": 'a',
  "\u0106": 'C',
  "\u0108": 'C',
  "\u010A": 'C',
  "\u010C": 'C',
  "\u0107": 'c',
  "\u0109": 'c',
  "\u010B": 'c',
  "\u010D": 'c',
  "\u010E": 'D',
  "\u0110": 'D',
  "\u010F": 'd',
  "\u0111": 'd',
  "\u0112": 'E',
  "\u0114": 'E',
  "\u0116": 'E',
  "\u0118": 'E',
  "\u011A": 'E',
  "\u0113": 'e',
  "\u0115": 'e',
  "\u0117": 'e',
  "\u0119": 'e',
  "\u011B": 'e',
  "\u011C": 'G',
  "\u011E": 'G',
  "\u0120": 'G',
  "\u0122": 'G',
  "\u011D": 'g',
  "\u011F": 'g',
  "\u0121": 'g',
  "\u0123": 'g',
  "\u0124": 'H',
  "\u0126": 'H',
  "\u0125": 'h',
  "\u0127": 'h',
  "\u0128": 'I',
  "\u012A": 'I',
  "\u012C": 'I',
  "\u012E": 'I',
  "\u0130": 'I',
  "\u0129": 'i',
  "\u012B": 'i',
  "\u012D": 'i',
  "\u012F": 'i',
  "\u0131": 'i',
  "\u0134": 'J',
  "\u0135": 'j',
  "\u0136": 'K',
  "\u0137": 'k',
  "\u0138": 'k',
  "\u0139": 'L',
  "\u013B": 'L',
  "\u013D": 'L',
  "\u013F": 'L',
  "\u0141": 'L',
  "\u013A": 'l',
  "\u013C": 'l',
  "\u013E": 'l',
  "\u0140": 'l',
  "\u0142": 'l',
  "\u0143": 'N',
  "\u0145": 'N',
  "\u0147": 'N',
  "\u014A": 'N',
  "\u0144": 'n',
  "\u0146": 'n',
  "\u0148": 'n',
  "\u014B": 'n',
  "\u014C": 'O',
  "\u014E": 'O',
  "\u0150": 'O',
  "\u014D": 'o',
  "\u014F": 'o',
  "\u0151": 'o',
  "\u0154": 'R',
  "\u0156": 'R',
  "\u0158": 'R',
  "\u0155": 'r',
  "\u0157": 'r',
  "\u0159": 'r',
  "\u015A": 'S',
  "\u015C": 'S',
  "\u015E": 'S',
  "\u0160": 'S',
  "\u015B": 's',
  "\u015D": 's',
  "\u015F": 's',
  "\u0161": 's',
  "\u0162": 'T',
  "\u0164": 'T',
  "\u0166": 'T',
  "\u0163": 't',
  "\u0165": 't',
  "\u0167": 't',
  "\u0168": 'U',
  "\u016A": 'U',
  "\u016C": 'U',
  "\u016E": 'U',
  "\u0170": 'U',
  "\u0172": 'U',
  "\u0169": 'u',
  "\u016B": 'u',
  "\u016D": 'u',
  "\u016F": 'u',
  "\u0171": 'u',
  "\u0173": 'u',
  "\u0174": 'W',
  "\u0175": 'w',
  "\u0176": 'Y',
  "\u0177": 'y',
  "\u0178": 'Y',
  "\u0179": 'Z',
  "\u017B": 'Z',
  "\u017D": 'Z',
  "\u017A": 'z',
  "\u017C": 'z',
  "\u017E": 'z',
  "\u0132": 'IJ',
  "\u0133": 'ij',
  "\u0152": 'Oe',
  "\u0153": 'oe',
  "\u0149": "'n",
  "\u017F": 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter$1 = basePropertyOf(deburredLetters);
var _deburrLetter = deburrLetter$1;
var deburrLetter = _deburrLetter,
  toString$3 = toString_1;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange$3 = "\\u0300-\\u036f",
  reComboHalfMarksRange$3 = "\\ufe20-\\ufe2f",
  rsComboSymbolsRange$3 = "\\u20d0-\\u20ff",
  rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3;

/** Used to compose unicode capture groups. */
var rsCombo$2 = '[' + rsComboRange$3 + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo$2, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr$1(string) {
  string = toString$3(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}
var deburr_1 = deburr$1;

/** Used to match words composed of alphanumeric characters. */

var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords$1(string) {
  return string.match(reAsciiWord) || [];
}
var _asciiWords = asciiWords$1;

/** Used to detect strings that need a more robust regexp to match words. */

var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord$1(string) {
  return reHasUnicodeWord.test(string);
}
var _hasUnicodeWord = hasUnicodeWord$1;

/** Used to compose unicode character classes. */

var rsAstralRange$2 = "\\ud800-\\udfff",
  rsComboMarksRange$2 = "\\u0300-\\u036f",
  reComboHalfMarksRange$2 = "\\ufe20-\\ufe2f",
  rsComboSymbolsRange$2 = "\\u20d0-\\u20ff",
  rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2,
  rsDingbatRange = "\\u2700-\\u27bf",
  rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
  rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
  rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
  rsPunctuationRange = "\\u2000-\\u206f",
  rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
  rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
  rsVarRange$2 = "\\ufe0e\\ufe0f",
  rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos$1 = "['\u2019]",
  rsBreak = '[' + rsBreakRange + ']',
  rsCombo$1 = '[' + rsComboRange$2 + ']',
  rsDigits = '\\d+',
  rsDingbat = '[' + rsDingbatRange + ']',
  rsLower = '[' + rsLowerRange + ']',
  rsMisc = '[^' + rsAstralRange$2 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
  rsFitz$1 = "\\ud83c[\\udffb-\\udfff]",
  rsModifier$1 = '(?:' + rsCombo$1 + '|' + rsFitz$1 + ')',
  rsNonAstral$1 = '[^' + rsAstralRange$2 + ']',
  rsRegional$1 = "(?:\\ud83c[\\udde6-\\uddff]){2}",
  rsSurrPair$1 = "[\\ud800-\\udbff][\\udc00-\\udfff]",
  rsUpper = '[' + rsUpperRange + ']',
  rsZWJ$2 = "\\u200d";

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
  rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
  rsOptContrLower = '(?:' + rsApos$1 + '(?:d|ll|m|re|s|t|ve))?',
  rsOptContrUpper = '(?:' + rsApos$1 + '(?:D|LL|M|RE|S|T|VE))?',
  reOptMod$1 = rsModifier$1 + '?',
  rsOptVar$1 = '[' + rsVarRange$2 + ']?',
  rsOptJoin$1 = '(?:' + rsZWJ$2 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
  rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
  rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
  rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
  rsEmoji = '(?:' + [rsDingbat, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsSeq$1;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords$1(string) {
  return string.match(reUnicodeWord) || [];
}
var _unicodeWords = unicodeWords$1;
var asciiWords = _asciiWords,
  hasUnicodeWord = _hasUnicodeWord,
  toString$2 = toString_1,
  unicodeWords = _unicodeWords;

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words$1(string, pattern, guard) {
  string = toString$2(string);
  pattern = guard ? undefined : pattern;
  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}
var words_1 = words$1;
var arrayReduce = _arrayReduce,
  deburr = deburr_1,
  words = words_1;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder$2(callback) {
  return function (string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}
var _createCompounder = createCompounder$2;
var createCompounder$1 = _createCompounder;

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder$1(function (result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});
var snakeCase_1 = snakeCase;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice$1(array, start, end) {
  var index = -1,
    length = array.length;
  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}
var _baseSlice = baseSlice$1;
var baseSlice = _baseSlice;

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice$1(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return !start && end >= length ? array : baseSlice(array, start, end);
}
var _castSlice = castSlice$1;

/** Used to compose unicode character classes. */

var rsAstralRange$1 = "\\ud800-\\udfff",
  rsComboMarksRange$1 = "\\u0300-\\u036f",
  reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f",
  rsComboSymbolsRange$1 = "\\u20d0-\\u20ff",
  rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
  rsVarRange$1 = "\\ufe0e\\ufe0f";

/** Used to compose unicode capture groups. */
var rsZWJ$1 = "\\u200d";

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ$1 + rsAstralRange$1 + rsComboRange$1 + rsVarRange$1 + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode$2(string) {
  return reHasUnicode.test(string);
}
var _hasUnicode = hasUnicode$2;

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */

function asciiToArray$1(string) {
  return string.split('');
}
var _asciiToArray = asciiToArray$1;

/** Used to compose unicode character classes. */

var rsAstralRange = "\\ud800-\\udfff",
  rsComboMarksRange = "\\u0300-\\u036f",
  reComboHalfMarksRange = "\\ufe20-\\ufe2f",
  rsComboSymbolsRange = "\\u20d0-\\u20ff",
  rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
  rsVarRange = "\\ufe0e\\ufe0f";

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
  rsCombo = '[' + rsComboRange + ']',
  rsFitz = "\\ud83c[\\udffb-\\udfff]",
  rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
  rsNonAstral = '[^' + rsAstralRange + ']',
  rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
  rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
  rsZWJ = "\\u200d";

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
  rsOptVar = '[' + rsVarRange + ']?',
  rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
  rsSeq = rsOptVar + reOptMod + rsOptJoin,
  rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray$1(string) {
  return string.match(reUnicode) || [];
}
var _unicodeToArray = unicodeToArray$1;
var asciiToArray = _asciiToArray,
  hasUnicode$1 = _hasUnicode,
  unicodeToArray = _unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray$1(string) {
  return hasUnicode$1(string) ? unicodeToArray(string) : asciiToArray(string);
}
var _stringToArray = stringToArray$1;
var castSlice = _castSlice,
  hasUnicode = _hasUnicode,
  stringToArray = _stringToArray,
  toString$1 = toString_1;

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst$1(methodName) {
  return function (string) {
    string = toString$1(string);
    var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
    var chr = strSymbols ? strSymbols[0] : string.charAt(0);
    var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
    return chr[methodName]() + trailing;
  };
}
var _createCaseFirst = createCaseFirst$1;
var createCaseFirst = _createCaseFirst;

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst$1 = createCaseFirst('toUpperCase');
var upperFirst_1 = upperFirst$1;
var toString = toString_1,
  upperFirst = upperFirst_1;

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize$1(string) {
  return upperFirst(toString(string).toLowerCase());
}
var capitalize_1 = capitalize$1;
var capitalize = capitalize_1,
  createCompounder = _createCompounder;

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function (result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});
var camelCase_1 = camelCase;
var baseAssignValue = _baseAssignValue,
  baseForOwn = _baseForOwn,
  baseIteratee = _baseIteratee;

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee);
  baseForOwn(object, function (value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}
var mapKeys_1 = mapKeys;
var toposort$1 = {
  exports: {}
};

/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

toposort$1.exports = function (edges) {
  return toposort(uniqueNodes(edges), edges);
};
toposort$1.exports.array = toposort;
function toposort(nodes, edges) {
  var cursor = nodes.length,
    sorted = new Array(cursor),
    visited = {},
    i = cursor
    // Better data structures make algorithm much faster.
    ,
    outgoingEdges = makeOutgoingEdges(edges),
    nodesHash = makeNodesHash(nodes);

  // check for unknown nodes
  edges.forEach(function (edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    }
  });
  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set());
  }
  return sorted;
  function visit(node, i, predecessors) {
    if (predecessors.has(node)) {
      var nodeRep;
      try {
        nodeRep = ", node was:" + JSON.stringify(node);
      } catch (e) {
        nodeRep = "";
      }
      throw new Error('Cyclic dependency' + nodeRep);
    }
    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
    }
    if (visited[i]) return;
    visited[i] = true;
    var outgoing = outgoingEdges.get(node) || new Set();
    outgoing = Array.from(outgoing);
    if (i = outgoing.length) {
      predecessors.add(node);
      do {
        var child = outgoing[--i];
        visit(child, nodesHash.get(child), predecessors);
      } while (i);
      predecessors.delete(node);
    }
    sorted[--cursor] = node;
  }
}
function uniqueNodes(arr) {
  var res = new Set();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    res.add(edge[0]);
    res.add(edge[1]);
  }
  return Array.from(res);
}
function makeOutgoingEdges(arr) {
  var edges = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    if (!edges.has(edge[0])) edges.set(edge[0], new Set());
    if (!edges.has(edge[1])) edges.set(edge[1], new Set());
    edges.get(edge[0]).add(edge[1]);
  }
  return edges;
}
function makeNodesHash(arr) {
  var res = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i);
  }
  return res;
}
function sortFields(fields) {
  var excludedEdges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var edges = [];
  var nodes = new Set();
  var excludes = new Set(excludedEdges.map(function (_ref94) {
    var _ref95 = _slicedToArray(_ref94, 2),
      a = _ref95[0],
      b = _ref95[1];
    return "".concat(a, "-").concat(b);
  }));
  function addNode(depPath, key) {
    var node = propertyExpr.split(depPath)[0];
    nodes.add(node);
    if (!excludes.has("".concat(key, "-").concat(node))) edges.push([key, node]);
  }
  var _loop2 = function _loop2(key) {
    if (has_1(fields, key)) {
      var value = fields[key];
      nodes.add(key);
      if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && 'deps' in value) value.deps.forEach(function (path) {
        return addNode(path, key);
      });
    }
  };
  for (var key in fields) {
    _loop2(key);
  }
  return toposort$1.exports.array(Array.from(nodes), edges).reverse();
}
function findIndex(arr, err) {
  var idx = Infinity;
  arr.some(function (key, ii) {
    var _err$path;
    if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}
function sortByKeyOrder(keys) {
  return function (a, b) {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}
function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};
function unknown(ctx, value) {
  var known = Object.keys(ctx.fields);
  return Object.keys(value).filter(function (key) {
    return known.indexOf(key) === -1;
  });
}
var defaultSort = sortByKeyOrder([]);
var ObjectSchema = /*#__PURE__*/function (_BaseSchema4) {
  function ObjectSchema(spec) {
    var _this22;
    _classCallCheck2(this, ObjectSchema);
    _this22 = _callSuper(this, ObjectSchema, [{
      type: 'object'
    }]);
    _this22.fields = Object.create(null);
    _this22._sortErrors = defaultSort;
    _this22._nodes = [];
    _this22._excludedEdges = [];
    _this22.withMutation(function () {
      _this22.transform(function coerce(value) {
        if (typeof value === 'string') {
          try {
            value = JSON.parse(value);
          } catch (err) {
            value = null;
          }
        }
        if (this.isType(value)) return value;
        return null;
      });
      if (spec) {
        _this22.shape(spec);
      }
    });
    return _this22;
  }
  _inherits2(ObjectSchema, _BaseSchema4);
  return _createClass2(ObjectSchema, [{
    key: "_typeCheck",
    value: function _typeCheck(value) {
      return isObject(value) || typeof value === 'function';
    }
  }, {
    key: "_cast",
    value: function _cast(_value) {
      var _this23 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$stripUnknown;
      var value = _superPropGet(ObjectSchema, "_cast", this, 3)([_value, options]); //should ignore nulls here

      if (value === undefined) return this.getDefault();
      if (!this._typeCheck(value)) return value;
      var fields = this.fields;
      var strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
      var props = this._nodes.concat(Object.keys(value).filter(function (v) {
        return _this23._nodes.indexOf(v) === -1;
      }));
      var intermediateValue = {}; // is filled during the transform below

      var innerOptions = _extends$1({}, options, {
        parent: intermediateValue,
        __validating: options.__validating || false
      });
      var isChanged = false;
      var _iterator4 = _createForOfIteratorHelper(props),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _prop = _step4.value;
          var field = fields[_prop];
          var exists = has_1(value, _prop);
          if (field) {
            var fieldValue = void 0;
            var inputValue = value[_prop]; // safe to mutate since this is fired in sequence

            innerOptions.path = (options.path ? "".concat(options.path, ".") : '') + _prop; // innerOptions.value = value[prop];

            field = field.resolve({
              value: inputValue,
              context: options.context,
              parent: intermediateValue
            });
            var fieldSpec = 'spec' in field ? field.spec : undefined;
            var strict = fieldSpec == null ? void 0 : fieldSpec.strict;
            if (fieldSpec == null ? void 0 : fieldSpec.strip) {
              isChanged = isChanged || _prop in value;
              continue;
            }
            fieldValue = !options.__validating || !strict ?
            // TODO: use _cast, this is double resolving
            field.cast(value[_prop], innerOptions) : value[_prop];
            if (fieldValue !== undefined) {
              intermediateValue[_prop] = fieldValue;
            }
          } else if (exists && !strip) {
            intermediateValue[_prop] = value[_prop];
          }
          if (intermediateValue[_prop] !== value[_prop]) {
            isChanged = true;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return isChanged ? intermediateValue : value;
    }
  }, {
    key: "_validate",
    value: function _validate(_value) {
      var _this24 = this;
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      var errors = [];
      var sync = opts.sync,
        _opts$from = opts.from,
        from = _opts$from === void 0 ? [] : _opts$from,
        _opts$originalValue = opts.originalValue,
        originalValue = _opts$originalValue === void 0 ? _value : _opts$originalValue,
        _opts$abortEarly = opts.abortEarly,
        abortEarly = _opts$abortEarly === void 0 ? this.spec.abortEarly : _opts$abortEarly,
        _opts$recursive = opts.recursive,
        recursive = _opts$recursive === void 0 ? this.spec.recursive : _opts$recursive;
      from = [{
        schema: this,
        value: originalValue
      }].concat(_toConsumableArray2(from)); // this flag is needed for handling `strict` correctly in the context of
      // validation vs just casting. e.g strict() on a field is only used when validating

      opts.__validating = true;
      opts.originalValue = originalValue;
      opts.from = from;
      _superPropGet(ObjectSchema, "_validate", this, 3)([_value, opts, function (err, value) {
        if (err) {
          if (!ValidationError.isError(err) || abortEarly) {
            return void callback(err, value);
          }
          errors.push(err);
        }
        if (!recursive || !isObject(value)) {
          callback(errors[0] || null, value);
          return;
        }
        originalValue = originalValue || value;
        var tests = _this24._nodes.map(function (key) {
          return function (_, cb) {
            var path = key.indexOf('.') === -1 ? (opts.path ? "".concat(opts.path, ".") : '') + key : "".concat(opts.path || '', "[\"").concat(key, "\"]");
            var field = _this24.fields[key];
            if (field && 'validate' in field) {
              field.validate(value[key], _extends$1({}, opts, {
                // @ts-ignore
                path: path,
                from: from,
                // inner fields are always strict:
                // 1. this isn't strict so the casting will also have cast inner values
                // 2. this is strict in which case the nested values weren't cast either
                strict: true,
                parent: value,
                originalValue: originalValue[key]
              }), cb);
              return;
            }
            cb(null);
          };
        });
        runTests({
          sync: sync,
          tests: tests,
          value: value,
          errors: errors,
          endEarly: abortEarly,
          sort: _this24._sortErrors,
          path: opts.path
        }, callback);
      }]);
    }
  }, {
    key: "clone",
    value: function clone(spec) {
      var next = _superPropGet(ObjectSchema, "clone", this, 3)([spec]);
      next.fields = _extends$1({}, this.fields);
      next._nodes = this._nodes;
      next._excludedEdges = this._excludedEdges;
      next._sortErrors = this._sortErrors;
      return next;
    }
  }, {
    key: "concat",
    value: function concat(schema) {
      var _this25 = this;
      var next = _superPropGet(ObjectSchema, "concat", this, 3)([schema]);
      var nextFields = next.fields;
      for (var _i7 = 0, _Object$entries2 = Object.entries(this.fields); _i7 < _Object$entries2.length; _i7++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i7], 2),
          field = _Object$entries2$_i[0],
          schemaOrRef = _Object$entries2$_i[1];
        var _target = nextFields[field];
        if (_target === undefined) {
          nextFields[field] = schemaOrRef;
        } else if (_target instanceof BaseSchema && schemaOrRef instanceof BaseSchema) {
          nextFields[field] = schemaOrRef.concat(_target);
        }
      }
      return next.withMutation(function () {
        return next.shape(nextFields, _this25._excludedEdges);
      });
    }
  }, {
    key: "getDefaultFromShape",
    value: function getDefaultFromShape() {
      var _this26 = this;
      var dft = {};
      this._nodes.forEach(function (key) {
        var field = _this26.fields[key];
        dft[key] = 'default' in field ? field.getDefault() : undefined;
      });
      return dft;
    }
  }, {
    key: "_getDefault",
    value: function _getDefault() {
      if ('default' in this.spec) {
        return _superPropGet(ObjectSchema, "_getDefault", this, 3)([]);
      } // if there is no default set invent one

      if (!this._nodes.length) {
        return undefined;
      }
      return this.getDefaultFromShape();
    }
  }, {
    key: "shape",
    value: function shape(additions) {
      var excludes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var next = this.clone();
      var fields = Object.assign(next.fields, additions);
      next.fields = fields;
      next._sortErrors = sortByKeyOrder(Object.keys(fields));
      if (excludes.length) {
        // this is a convenience for when users only supply a single pair
        if (!Array.isArray(excludes[0])) excludes = [excludes];
        next._excludedEdges = [].concat(_toConsumableArray2(next._excludedEdges), _toConsumableArray2(excludes));
      }
      next._nodes = sortFields(fields, next._excludedEdges);
      return next;
    }
  }, {
    key: "pick",
    value: function pick(keys) {
      var picked = {};
      var _iterator5 = _createForOfIteratorHelper(keys),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var key = _step5.value;
          if (this.fields[key]) picked[key] = this.fields[key];
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return this.clone().withMutation(function (next) {
        next.fields = {};
        return next.shape(picked);
      });
    }
  }, {
    key: "omit",
    value: function omit(keys) {
      var next = this.clone();
      var fields = next.fields;
      next.fields = {};
      var _iterator6 = _createForOfIteratorHelper(keys),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var key = _step6.value;
          delete fields[key];
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return next.withMutation(function () {
        return next.shape(fields);
      });
    }
  }, {
    key: "from",
    value: function from(_from, to, alias) {
      var fromGetter = propertyExpr.getter(_from, true);
      return this.transform(function (obj) {
        if (obj == null) return obj;
        var newObj = obj;
        if (has_1(obj, _from)) {
          newObj = _extends$1({}, obj);
          if (!alias) delete newObj[_from];
          newObj[to] = fromGetter(obj);
        }
        return newObj;
      });
    }
  }, {
    key: "noUnknown",
    value: function noUnknown() {
      var noAllow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : object.noUnknown;
      if (typeof noAllow === 'string') {
        message = noAllow;
        noAllow = true;
      }
      var next = this.test({
        name: 'noUnknown',
        exclusive: true,
        message: message,
        test: function test(value) {
          if (value == null) return true;
          var unknownKeys = unknown(this.schema, value);
          return !noAllow || unknownKeys.length === 0 || this.createError({
            params: {
              unknown: unknownKeys.join(', ')
            }
          });
        }
      });
      next.spec.noUnknown = noAllow;
      return next;
    }
  }, {
    key: "unknown",
    value: function unknown() {
      var allow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : object.noUnknown;
      return this.noUnknown(!allow, message);
    }
  }, {
    key: "transformKeys",
    value: function transformKeys(fn) {
      return this.transform(function (obj) {
        return obj && mapKeys_1(obj, function (_, key) {
          return fn(key);
        });
      });
    }
  }, {
    key: "camelCase",
    value: function camelCase() {
      return this.transformKeys(camelCase_1);
    }
  }, {
    key: "snakeCase",
    value: function snakeCase() {
      return this.transformKeys(snakeCase_1);
    }
  }, {
    key: "constantCase",
    value: function constantCase() {
      return this.transformKeys(function (key) {
        return snakeCase_1(key).toUpperCase();
      });
    }
  }, {
    key: "describe",
    value: function describe() {
      var base = _superPropGet(ObjectSchema, "describe", this, 3)([]);
      base.fields = mapValues_1(this.fields, function (value) {
        return value.describe();
      });
      return base;
    }
  }]);
}(BaseSchema);
function create(spec) {
  return new ObjectSchema(spec);
}
create.prototype = ObjectSchema.prototype;
var dateRegex = /^(0[1-9]|[12][0-9]|3[01])$/;
var monthRegex = /^(0[1-9]|1[012])$/;
var yearRegex = /^(19|20)\d\d$/;
var messageOr = function messageOr(message, fallback) {
  return message === '' ? fallback : message !== null && message !== void 0 ? message : fallback;
};
var ANCHORED_REGEX_FIELD_NAMES = ['emailAddress'];
var isCalendarDateValid = function isCalendarDateValid(_ref96) {
  var date = _ref96.date,
    month = _ref96.month,
    year = _ref96.year;
  // Incomplete or malformed parts have their own validation messages.
  if (!date || !month || !year || !dateRegex.test(date) || !monthRegex.test(month) || !yearRegex.test(year)) return true;
  var parsed = new Date(Date.UTC(Number(year), Number(month) - 1, Number(date)));
  return parsed.getUTCFullYear() === Number(year) && parsed.getUTCMonth() === Number(month) - 1 && parsed.getUTCDate() === Number(date);
};
// Whether the date is at least `minimumAge` years before today. Only a
// complete, well-formed date is judged: anything else is left to the part
// rules, so a wrong year reads "Year is invalid" rather than an age message.
// The cutoff is the birthday `minimumAge` years on, so someone is old enough
// from that day; a 29 February birthday rolls to 1 March in a common year.
var isAtLeastYearsAgo = function isAtLeastYearsAgo(_ref97, minimumAge) {
  var date = _ref97.date,
    month = _ref97.month,
    year = _ref97.year;
  if (!date || !month || !year || !dateRegex.test(date) || !monthRegex.test(month) || !yearRegex.test(year) || !isCalendarDateValid({
    date: date,
    month: month,
    year: year
  })) {
    return true;
  }
  var cutoff = new Date(Number(year) + minimumAge, Number(month) - 1, Number(date));
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  return cutoff <= today;
};
var anchoredRegex = function anchoredRegex(regex) {
  // Check if regex already has start and end anchors
  var hasStartAnchor = regex.startsWith('^');
  var hasEndAnchor = regex.endsWith('$');
  // Only add anchors if they're missing
  if (hasStartAnchor && hasEndAnchor) {
    return regex; // Already anchored
  } else if (hasStartAnchor) {
    return "".concat(regex, "$"); // Add only end anchor
  } else if (hasEndAnchor) {
    return "^".concat(regex); // Add only start anchor
  } else {
    return "^".concat(regex, "$"); // Add both anchors
  }
};
// TODO move the validation into the control components
// maybe use AJV - can construct a schema here, or return one in the data
var buildValidationSchema = function buildValidationSchema(model) {
  var trimmedString = function trimmedString(label) {
    var schema = create$1().transform(function (_value, originalValue) {
      return typeof originalValue === 'string' ? originalValue.trim() : originalValue;
    });
    if (label) {
      schema = schema.label(label);
    }
    return schema;
  };
  var schemaObject = model.reduce(/* eslint-disable @typescript-eslint/no-explicit-any */
  function (obj, field) {
    /* eslint-enable @typescript-eslint/no-explicit-any */
    var choices = field.choices,
      storedElementType = field.elementType,
      name = field.name,
      placeholder = field.placeholder,
      optional = field.optional,
      validationRegex = field.validationRegex,
      validationRegexFlags = field.validationRegexFlags,
      validationErrorMessage = field.validationErrorMessage,
      minimumAge = field.minimumAge;
    // Form definitions are stored as strings and may contain legacy/custom values.
    var elementType = storedElementType;
    // Legacy regex patterns default to case-insensitive matching.
    var flags = validationRegexFlags !== null && validationRegexFlags !== void 0 ? validationRegexFlags : 'i';
    if (validationRegexFlags === false) {
      flags = '';
    } else if (validationRegexFlags === '') {
      flags = 'i';
    }
    if (elementType === ElementType.String || elementType === ElementType.TextArea) {
      var fieldSchema = trimmedString(placeholder || name);
      if (!optional) {
        fieldSchema = fieldSchema.required(placeholder && "".concat(placeholder, " is a required field") || "".concat(name, " is a required field")).min(1);
      }
      if (validationRegex) {
        var regex = ANCHORED_REGEX_FIELD_NAMES.includes(name) ? anchoredRegex(validationRegex) : validationRegex;
        if (optional) {
          // For optional fields: only apply regex if there's a value
          // Since trimmedString already handles trimming, we can use a simpler approach
          fieldSchema = fieldSchema.test('regex-if-value', messageOr(validationErrorMessage, "".concat(placeholder || name, " is invalid")), function (value) {
            // For optional fields, empty/whitespace should pass
            if (!value) return true;
            // If there's a value, validate it against regex
            return new RegExp(regex, String(flags)).test(value);
          });
        } else {
          // For required fields, always validate regex
          fieldSchema = fieldSchema.matches(new RegExp(regex, String(flags)), messageOr(validationErrorMessage, "".concat(placeholder || name, " is invalid")));
        }
      }
      obj[name] = fieldSchema;
    } else if (elementType === ElementType.Dropdown) {
      var _fieldSchema = trimmedString(placeholder || name);
      if (!optional) {
        _fieldSchema = _fieldSchema.required(placeholder && "".concat(placeholder, " is a required field") || "".concat(name, " is a required field")).oneOf(choices, messageOr(validationErrorMessage, "".concat(placeholder || name, " is invalid")));
      }
      obj[name] = _fieldSchema;
    } else if (elementType === ElementType.Checkbox) {
      if (!optional) {
        obj[name] = create$2().required("".concat(name, " is a required field")).oneOf([true], "This is a required field");
      }
    } else if (elementType === ElementType.Address) {
      obj[name] = create().shape({
        addressLine1: trimmedString(),
        addressLine2: trimmedString(),
        city: trimmedString(),
        postcode: trimmedString(),
        country: trimmedString().oneOf(countries, "".concat(name, ".country is invalid")),
        // The machine-generated structured address: permitted, not validated,
        // so it survives to submission alongside the flat lines.
        structured: create$3(),
        // The picker's hand-edited-field flags: likewise permitted, not validated.
        edited: create$3()
      });
      if (!optional) {
        obj[name] = create().shape({
          addressLine1: trimmedString().min(1).required(),
          addressLine2: trimmedString().min(1),
          city: trimmedString().min(1).required(),
          postcode: trimmedString().min(1).required(),
          country: trimmedString().oneOf(countries, "".concat(name, ".country is invalid")).required(),
          structured: create$3(),
          edited: create$3()
        }).required("".concat(name, " is a required field"));
      }
    } else if (elementType === ElementType.Date) {
      // The age rule sits on the year part: the date control renders its
      // error from the per-part struct, so an error on the object itself
      // would not display.
      var withMinimumAge = function withMinimumAge(year) {
        return minimumAge ? year.test('calendar-date', 'Enter a valid date of birth', function isValidCalendarDate() {
          return isCalendarDateValid(this.parent);
        }).test('minimum-age', messageOr(validationErrorMessage, "You must be at least ".concat(minimumAge, " years old")), function isOldEnough() {
          return isAtLeastYearsAgo(this.parent, minimumAge);
        }) : year;
      };
      obj[name] = create().shape({
        date: trimmedString(),
        month: trimmedString(),
        year: withMinimumAge(trimmedString())
      });
      if (!optional) {
        obj[name] = create().shape({
          date: trimmedString().length(2, 'Date must be 2 digits').required('Date is required').matches(dateRegex, 'Date is invalid'),
          month: trimmedString().length(2, 'Month must be 2 digits').required('Month is required').matches(monthRegex, 'Month is invalid'),
          year: withMinimumAge(trimmedString().length(4, 'Year must be 4 digits').required('Year is required').matches(yearRegex, 'Year is invalid'))
        }).required("".concat(name, " is a required field"));
      }
    } else if (elementType === ElementType.Hidden) {
      obj[name] = trimmedString(placeholder);
    }
    return obj;
  }, {});
  return create().shape(schemaObject);
};

/* eslint-disable @typescript-eslint/no-explicit-any */
var getErrorForControl = function getErrorForControl(touched, errors, name) {
  // Untouched fields and all falsy errors have no displayed message.
  // oxlint-disable-next-line typescript/prefer-nullish-coalescing
  var errorValue = touched[name] && errors[name] || '';
  if (typeof errorValue === 'string') {
    return errorValue;
  }
  var touchedChildren = Object.keys(touched[name]);
  var trimmed = Object.entries(errorValue).reduce(function (obj, _ref98) {
    var _ref99 = _slicedToArray(_ref98, 2),
      key = _ref99[0],
      value = _ref99[1];
    return Object.assign(Object.assign({}, obj), touchedChildren.includes(key) ? _defineProperty2({}, key, value) : {});
  }, {});
  return JSON.stringify(trimmed);
};
/* eslint-enable @typescript-eslint/no-explicit-any */

var _trim = function trim(value) {
  switch (true) {
    case typeof value === 'string':
      return value.trim();
    case typeof value === 'object':
      return Array.isArray(value) ? value.map(function (item) {
        return _trim(item);
      }) : Object.entries(value).reduce(function (acc, _ref101) {
        var _ref102 = _slicedToArray(_ref101, 2),
          key = _ref102[0],
          value = _ref102[1];
        return Object.assign(Object.assign({}, acc), _defineProperty2({}, key, _trim(value)));
      }, {});
    default:
      return value;
  }
};
var FormBody = function FormBody(_ref103) {
  var initialValues = _ref103.initialValues,
    model = _ref103.model,
    buttonCopy = _ref103.buttonCopy,
    onConfirm = _ref103.onConfirm,
    className = _ref103.className,
    outOfStock = _ref103.outOfStock;
  return React$2.createElement("div", {
    className: classnames(className, styles$o.container)
  }, React$2.createElement(Formik, {
    initialValues: initialValues !== null && initialValues !== void 0 ? initialValues : getInitialValues(model),
    onSubmit: function onSubmit(values) {
      onConfirm(_trim(values));
    },
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: buildValidationSchema(model)
  }, function (_ref104) {
    var touched = _ref104.touched,
      errors = _ref104.errors,
      isSubmitting = _ref104.isSubmitting,
      handleSubmit = _ref104.handleSubmit,
      handleChange = _ref104.handleChange,
      values = _ref104.values;
    var getError = getErrorForControl.bind(null, touched, errors);
    var renderControl = function renderControl(controlModel) {
      var Control = controls.get(controlModel.elementType);
      if (!Control) return null;
      return React$2.createElement(Control, Object.assign({
        key: controlModel.name
      }, controlModel, {
        handleChange: handleChange,
        error: getError(controlModel.name),
        value: values[controlModel.name],
        outOfStock: outOfStock
      }));
    };
    return React$2.createElement(Form$1, {
      onSubmit: handleSubmit
    }, model.map(renderControl), React$2.createElement(PrimaryButton, {
      label: buttonCopy,
      type: ButtonType.Submit,
      disabled: isSubmitting
    }));
  }));
};
var styles$n = {
  "container": "form-header-module_container__QyvK3",
  "title": "form-header-module_title__x33f2",
  "close": "form-header-module_close__b7NdZ",
  "subtitle": "form-header-module_subtitle__99l-H"
};
var FormHeader = function FormHeader(_ref105) {
  var title = _ref105.title,
    subtitle = _ref105.subtitle,
    onCancel = _ref105.onCancel;
  var _useThemeContext17 = useThemeContext(),
    header = _useThemeContext17.form.header;
  return React$2.createElement(React$2.Fragment, null, React$2.createElement("div", {
    style: {
      backgroundColor: header === null || header === void 0 ? void 0 : header.background
    },
    className: styles$n.container
  }, React$2.createElement(Heading_3, {
    className: styles$n.title
  }, title), onCancel && React$2.createElement(CloseCross, {
    className: styles$n.close,
    onClick: onCancel
  })), React$2.createElement(Heading_4, {
    className: styles$n.subtitle
  }, subtitle));
};
var Form = function Form(_ref106) {
  var model = _ref106.model,
    onConfirm = _ref106.onConfirm,
    onCancel = _ref106.onCancel,
    initialValues = _ref106.initialValues,
    outOfStock = _ref106.outOfStock;
  var _useThemeContext18 = useThemeContext(),
    form = _useThemeContext18.form;
  var values = Object.assign(Object.assign({
    title: '',
    subtitle: '',
    confirmButtonText: ''
  }, form), model.formLayout);
  return React$2.createElement(React$2.Fragment, null, React$2.createElement(FormHeader, {
    title: values.title,
    subtitle: values.subtitle,
    onCancel: onCancel
  }), React$2.createElement(FormBody, {
    initialValues: initialValues,
    model: model.formDataTypes,
    buttonCopy: values.confirmButtonText,
    onConfirm: onConfirm,
    outOfStock: outOfStock
  }));
};
var GiftWrapPhase;
(function (GiftWrapPhase) {
  GiftWrapPhase["Intro"] = "intro";
  GiftWrapPhase["Idle"] = "idle";
  GiftWrapPhase["Outro"] = "outro";
})(GiftWrapPhase || (GiftWrapPhase = {}));
var styles$m = {
  "introContainer": "default-animation-module_introContainer__xsbKM",
  "introContainerActive": "default-animation-module_introContainerActive__pq0v2",
  "idleContainer": "default-animation-module_idleContainer__MNOT2",
  "idleContainerActive": "default-animation-module_idleContainerActive__r8686",
  "idleGiftLoop": "default-animation-module_idleGiftLoop__3-K8j",
  "label": "default-animation-module_label__UycGZ",
  "labelRotate": "default-animation-module_labelRotate__oYkLP",
  "ends": "default-animation-module_ends__8vgis",
  "endsRotate": "default-animation-module_endsRotate__Xe3Lw",
  "leftBow": "default-animation-module_leftBow__wV4eg",
  "leftBowRotate": "default-animation-module_leftBowRotate__GgWSl",
  "rightBow": "default-animation-module_rightBow__8IY2l",
  "rightBowRotate": "default-animation-module_rightBowRotate__GVs9i",
  "shadow": "default-animation-module_shadow__EL-sB",
  "shadowLoop": "default-animation-module_shadowLoop__FQ3dC",
  "sparckles": "default-animation-module_sparckles__ntJWv",
  "outroContainer": "default-animation-module_outroContainer__4fMe6",
  "outroContainerActive": "default-animation-module_outroContainerActive__xVmwO",
  "string": "default-animation-module_string__aptX8",
  "pink-circle": "default-animation-module_pink-circle__TNSrN",
  "pinkCircleTranslate": "default-animation-module_pinkCircleTranslate__wB4zt",
  "sparckleScale": "default-animation-module_sparckleScale__SDrQG",
  "blue-star": "default-animation-module_blue-star__ebdqs",
  "blueStarTranslate": "default-animation-module_blueStarTranslate__uDTxM",
  "blue-circle": "default-animation-module_blue-circle__WF64d",
  "blueCircleTranslate": "default-animation-module_blueCircleTranslate__wQK-b",
  "pink-star": "default-animation-module_pink-star__jhN8s",
  "pinkStarTranslate": "default-animation-module_pinkStarTranslate__ZcHTh",
  "yellow-star": "default-animation-module_yellow-star__qAkfP",
  "yellowStarTranslate": "default-animation-module_yellowStarTranslate__YPr1f"
};
var localStyles$5 = {
  "tagIcon": "blue-stars-wrapping-module_tagIcon__sOvNX",
  "tag": "blue-stars-wrapping-module_tag__ZzQ8r",
  "visible": "blue-stars-wrapping-module_visible__gVaTk",
  "st0": "blue-stars-wrapping-module_st0__ozhC-",
  "clip": "blue-stars-wrapping-module_clip__zdCjU",
  "st2": "blue-stars-wrapping-module_st2__rHPc-"
};
var BlueStars = function BlueStars() {
  return React$2.createElement("svg", {
    "data-testid": "gift",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -14 476.81 435.64"
  }, React$2.createElement("g", null, React$2.createElement("g", {
    transform: "translate(0 -27) scale(1.49)"
  }, React$2.createElement("path", {
    className: localStyles$5.st0,
    d: "M319.9,289.7L286.7,85.9c-0.7-4.5-4.6-7.8-9.2-7.8h-235c-4.5,0-8.4,3.3-9.2,7.8L0.1,289.7\n          c-0.9,5.6,3.4,10.8,9.2,10.8h301.4C316.4,300.5,320.8,295.4,319.9,289.7z"
  }), React$2.createElement("g", null, React$2.createElement("defs", null, React$2.createElement("path", {
    id: "SVGID_1_",
    d: "M319.9,289.3L286.7,85.4c-0.7-4.5-4.6-7.8-9.2-7.8h-235c-4.5,0-8.4,3.3-9.2,7.8L0.1,289.3\n              c-0.9,5.6,3.4,10.8,9.2,10.8h301.4C316.4,300,320.8,294.9,319.9,289.3z"
  })), React$2.createElement("clipPath", {
    id: "SVGID_00000099641912345770055490000007849415254370733970_"
  }, React$2.createElement("use", {
    href: "#SVGID_1_",
    className: localStyles$5.visible
  })), React$2.createElement("path", {
    className: localStyles$5.clip,
    d: "M48.4,98.9l1.2,16.6\n            c0.1,1.6,1.5,2.9,3.2,2.9l16.7-0.2c3.1,0,4.4,4,1.8,5.7l-13.8,9.4c-1.4,0.9-1.8,2.8-0.9,4.2l8.5,14.3c1.6,2.7-1.3,5.8-4,4.4\n            l-15-7.2c-1.5-0.7-3.3-0.2-4.1,1.3l-8.1,14.5c-1.5,2.7-5.6,1.8-5.8-1.3l-1.2-16.6c-0.1-1.6-1.5-2.9-3.2-2.9l-16.7,0.2\n            c-3.1,0-4.4-4-1.8-5.7l13.8-9.4c1.4-0.9,1.8-2.8,0.9-4.2l-8.5-14.3c-1.6-2.7,1.3-5.8,4-4.4l15,7.2c1.5,0.7,3.3,0.2,4.1-1.3\n            l8.1-14.5C44.1,94.9,48.2,95.8,48.4,98.9z"
  }), React$2.createElement("path", {
    className: localStyles$5.clip,
    d: "M140,50l1.2,16.6\n            c0.1,1.6,1.5,2.9,3.2,2.9l16.7-0.2c3.1,0,4.4,4,1.8,5.7l-13.8,9.4c-1.4,0.9-1.8,2.8-0.9,4.2l8.5,14.3c1.6,2.7-1.3,5.8-4,4.4\n            l-15-7.2c-1.5-0.7-3.3-0.2-4.1,1.3l-8.1,14.5c-1.5,2.7-5.6,1.8-5.8-1.3l-1.2-16.6c-0.1-1.6-1.5-2.9-3.2-2.9l-16.7,0.2\n            c-3.1,0-4.4-4-1.8-5.7l13.8-9.4c1.4-0.9,1.8-2.8,0.9-4.2l-8.5-14.3c-1.6-2.7,1.3-5.8,4-4.4l15,7.2c1.5,0.7,3.3,0.2,4.1-1.3\n            l8.1-14.5C135.7,46,139.8,46.9,140,50z"
  }), React$2.createElement("path", {
    className: localStyles$5.clip,
    d: "M4.2,205.5l12.6,10.9\n            c1.2,1.1,3.1,1,4.3-0.2l11.6-11.9c2.2-2.2,5.9-0.3,5.3,2.8l-3.1,16.4c-0.3,1.6,0.7,3.2,2.3,3.6l16.1,4.1c3,0.8,3.2,5,0.2,6\n            l-15.7,5.5c-1.6,0.5-2.4,2.2-2,3.8l4.5,16c0.8,3-2.7,5.2-5.1,3.2l-12.6-10.9c-1.2-1.1-3.1-1-4.3,0.2L6.7,266.9\n            c-2.2,2.2-5.9,0.3-5.3-2.8l3.1-16.4c0.3-1.6-0.7-3.2-2.3-3.6l-16.1-4.1c-3-0.8-3.2-5-0.2-6l15.7-5.5c1.6-0.5,2.4-2.2,2-3.8\n            l-4.5-16C-1.7,205.8,1.8,203.5,4.2,205.5z"
  }), React$2.createElement("path", {
    className: localStyles$5.clip,
    d: "M85.7,254.3l12.6,10.9\n            c1.2,1.1,3.1,1,4.3-0.2l11.6-11.9c2.2-2.2,5.9-0.3,5.3,2.8l-3.1,16.4c-0.3,1.6,0.7,3.2,2.3,3.6l16.1,4.1c3,0.8,3.2,5,0.2,6\n            l-15.7,5.5c-1.6,0.5-2.4,2.2-2,3.8l4.5,16c0.8,3-2.7,5.2-5.1,3.2l-12.6-10.9c-1.2-1.1-3.1-1-4.3,0.2l-11.6,11.9\n            c-2.2,2.2-5.9,0.3-5.3-2.8l3.1-16.4c0.3-1.6-0.7-3.2-2.3-3.6l-16.1-4.1c-3-0.8-3.2-5-0.2-6l15.7-5.5c1.6-0.5,2.4-2.2,2-3.8\n            l-4.5-16C79.8,254.5,83.3,252.3,85.7,254.3z"
  }), React$2.createElement("path", {
    className: localStyles$5.clip,
    d: "M265.4,272.5l7.6,14.8\n            c0.8,1.5,2.5,2.1,4,1.4l15.2-6.7c2.8-1.2,5.6,1.9,3.9,4.6l-9,14c-0.9,1.4-0.6,3.2,0.8,4.2l13.4,9.9c2.5,1.8,1.1,5.8-2,5.6\n            l-16.6-0.8c-1.7-0.1-3.1,1.1-3.3,2.8l-1.8,16.6c-0.3,3.1-4.5,3.8-5.9,1.1l-7.6-14.8c-0.8-1.5-2.5-2.1-4-1.4l-15.2,6.7\n            c-2.8,1.2-5.6-1.9-3.9-4.6l9-14c0.9-1.4,0.6-3.2-0.8-4.2l-13.4-9.9c-2.5-1.8-1.1-5.8,2-5.6l16.6,0.8c1.7,0.1,3.1-1.1,3.3-2.8\n            l1.8-16.6C259.8,270.5,264,269.7,265.4,272.5z"
  }), React$2.createElement("path", {
    className: localStyles$5.clip,
    d: "M294.2,180.4l7.6,14.8\n            c0.8,1.5,2.5,2.1,4,1.4l15.2-6.7c2.8-1.2,5.6,1.9,3.9,4.6l-9,14c-0.9,1.4-0.6,3.2,0.8,4.2l13.4,9.9c2.5,1.8,1.1,5.8-2,5.6\n            l-16.6-0.8c-1.7-0.1-3.1,1.1-3.3,2.8l-1.8,16.6c-0.3,3.1-4.5,3.8-5.9,1.1L293,233c-0.8-1.5-2.5-2.1-4-1.4l-15.2,6.7\n            c-2.8,1.2-5.6-1.9-3.9-4.6l9-14c0.9-1.4,0.6-3.2-0.8-4.2l-13.4-9.9c-2.5-1.8-1.1-5.8,2-5.6l16.6,0.8c1.7,0.1,3.1-1.1,3.3-2.8\n            l1.8-16.6C288.7,178.4,292.8,177.6,294.2,180.4z"
  }), React$2.createElement("path", {
    className: localStyles$5.clip,
    d: "M236.1,74l7.6,14.8\n            c0.8,1.5,2.5,2.1,4,1.4l15.2-6.7c2.8-1.2,5.6,1.9,3.9,4.6l-9,14c-0.9,1.4-0.6,3.2,0.8,4.2l13.4,9.9c2.5,1.8,1.1,5.8-2,5.6\n            l-16.6-0.8c-1.7-0.1-3.1,1.1-3.3,2.8l-1.8,16.6c-0.3,3.1-4.5,3.8-5.9,1.1l-7.6-14.8c-0.8-1.5-2.5-2.1-4-1.4l-15.2,6.7\n            c-2.8,1.2-5.6-1.9-3.9-4.6l9-14c0.9-1.4,0.6-3.2-0.8-4.2l-13.4-9.9c-2.5-1.8-1.1-5.8,2-5.6l16.6,0.8c1.7,0.1,3.1-1.1,3.3-2.8\n            l1.8-16.6C230.6,72,234.7,71.2,236.1,74z"
  })), React$2.createElement("path", {
    className: localStyles$5.st2,
    d: "M100.1,152.3l12.6,10.9c1.2,1.1,3.1,1,4.3-0.2l11.6-11.9c2.2-2.2,5.9-0.3,5.3,2.8l-3.1,16.4\n          c-0.3,1.6,0.7,3.2,2.3,3.6l16.1,4.1c3,0.8,3.2,5,0.2,6l-15.7,5.5c-1.6,0.5-2.4,2.2-2,3.8l4.5,16c0.8,3-2.7,5.2-5.1,3.2l-12.6-10.9\n          c-1.2-1.1-3.1-1-4.3,0.2l-11.6,11.9c-2.2,2.2-5.9,0.3-5.3-2.8l3.1-16.4c0.3-1.6-0.7-3.2-2.3-3.6L82,186.7c-3-0.8-3.2-5-0.2-6\n          l15.7-5.5c1.6-0.5,2.4-2.2,2-3.8l-4.5-16C94.2,152.5,97.7,150.2,100.1,152.3z"
  }), React$2.createElement("path", {
    className: localStyles$5.st2,
    d: "M182.2,219.9l14.6,8c1.4,0.8,3.3,0.3,4.1-1.1l8.9-14.1c1.7-2.6,5.7-1.5,5.8,1.6l0.3,16.7c0,1.7,1.3,3,3,3.1\n          l16.6,0.7c3.1,0.1,4.1,4.2,1.5,5.8l-14.3,8.6c-1.4,0.9-1.9,2.7-1.2,4.1l7.7,14.8c1.4,2.7-1.6,5.7-4.3,4.2l-14.6-8\n          c-1.4-0.8-3.3-0.3-4.1,1.1l-8.9,14.1c-1.7,2.6-5.7,1.5-5.8-1.6l-0.3-16.7c0-1.7-1.3-3-3-3.1l-16.6-0.7c-3.1-0.1-4.1-4.2-1.5-5.8\n          l14.3-8.6c1.4-0.9,1.9-2.7,1.2-4.1l-7.7-14.8C176.4,221.4,179.4,218.4,182.2,219.9z"
  }), React$2.createElement("path", {
    className: localStyles$5.st2,
    d: "M182.2,126.3l14.6,8c1.4,0.8,3.3,0.3,4.1-1.1l8.9-14.1c1.7-2.6,5.7-1.5,5.8,1.6l0.3,16.7c0,1.7,1.3,3,3,3.1\n          l16.6,0.7c3.1,0.1,4.1,4.2,1.5,5.8l-14.3,8.6c-1.4,0.9-1.9,2.7-1.2,4.1l7.7,14.8c1.4,2.7-1.6,5.7-4.3,4.2l-14.6-8\n          c-1.4-0.8-3.3-0.3-4.1,1.1l-8.9,14.1c-1.7,2.6-5.7,1.5-5.8-1.6l-0.3-16.7c0-1.7-1.3-3-3-3.1l-16.6-0.7c-3.1-0.1-4.1-4.2-1.5-5.8\n          l14.3-8.6c1.4-0.9,1.9-2.7,1.2-4.1l-7.7-14.8C176.4,127.7,179.4,124.8,182.2,126.3z"
  })), React$2.createElement("line", {
    className: styles$m.string,
    x1: "236.34",
    y1: "88.37",
    x2: "236.34",
    y2: "421.64"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.leftBow),
    d: "M163.83,36.51c7.72,9.03,72.64,51.86,72.64,51.86,0,0-32.19-70.79-39.92-79.83-7.73-9.04-21.31-10.11-30.34-2.38-9.04,7.72-10.1,21.31-2.38,30.34Z"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.rightBow),
    d: "M308.6,68.86c-8.7,4.83-72.13,19.5-72.13,19.5,0,0,45.92-46.16,54.61-51,8.7-4.83,19.67-1.7,24.51,6.99,4.83,8.7,1.71,19.67-6.99,24.51Z"
  }), React$2.createElement("g", {
    className: styles$m.label
  }, React$2.createElement("path", {
    className: localStyles$5.tag,
    d: "M383.34,219l-53.87,38.04c-3.58,2.53-8.53,1.68-11.06-1.91l-66.64-94.4c-1.08-1.54-1.59-3.4-1.42-5.27l3.73-42.66c.8-9.18,9.67-15.43,18.58-13.12l41.45,10.76c1.82,.47,3.41,1.57,4.49,3.1l66.64,94.4c2.53,3.58,1.68,8.53-1.91,11.06m-107.68-108.42c-2.4-3.4-7.1-4.21-10.5-1.81-3.4,2.4-4.21,7.1-1.81,10.5,2.4,3.4,7.1,4.21,10.5,1.81,3.4-2.4,4.21-7.1,1.81-10.5"
  }), React$2.createElement("path", {
    className: localStyles$5.tagIcon,
    transform: "scale(1.49 1.34)",
    d: "M194.8,138.1l5.3-3.7c0.7-0.5,1.7-0.2,2.2,0.7l10.9,17.1c0.5,0.9,1.7,0.5,1.5-0.5c-1-4.6-1.3-11.1,3.6-14.5\n        \t\tc5.8-4,11.1-2.2,20.2,11l7.5,10.8c0.5,0.8,0.5,1.8-0.2,2.2l-4.8,3.3c-0.7,0.5-1.6,0.2-2.2-0.6l-5.1-7.4c-5.5-8-8.8-9.5-12.6-6.9\n        \t\tc-3.9,2.7-2.8,9.9,2.6,17.7l3.3,4.8c0.5,0.8,0.5,1.8-0.2,2.2l-4.8,3.3c-0.7,0.5-1.6,0.2-2.2-0.6l-25.4-36.7\n        \t\tC194.1,139.6,194.2,138.6,194.8,138.1"
  })), React$2.createElement("path", {
    className: styles$m.string,
    d: "M266.39,112.37s-10.45-24.21-30.05-24"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.ends),
    d: "M179.11,250.06c-3.62-10.66-10.05-27.22-2.8-43.73,10.47-23.86,25.88-16.69,36.35-40.54,10.47-23.85-1.93-29.92,5.53-54.87,3.88-12.97,11.92-17.51,18.03-22.76,0,0-28.44-2.12-42.93,24.22-14.49,26.34,.59,47.8-34.61,60.58"
  })));
};
var localStyles$4 = {
  "tagIcon": "christmas-trees-wrapping-module_tagIcon__3V-CI",
  "tag": "christmas-trees-wrapping-module_tag__jFlxU",
  "visible": "christmas-trees-wrapping-module_visible__2nwXx",
  "clip": "christmas-trees-wrapping-module_clip__V1EfG",
  "st2": "christmas-trees-wrapping-module_st2__D41-4",
  "st3": "christmas-trees-wrapping-module_st3__n-cxY"
};
var ChristmasTrees = function ChristmasTrees() {
  return React$2.createElement("svg", {
    "data-testid": "gift",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -14 476.81 435.64"
  }, React$2.createElement("g", null, React$2.createElement("g", {
    transform: "translate(0 -27) scale(1.49)"
  }, React$2.createElement("defs", null, React$2.createElement("path", {
    id: "SVGID_1_",
    d: "M319.9,289.7L286.7,85.9c-0.7-4.5-4.6-7.8-9.2-7.8h-235c-4.5,0-8.4,3.3-9.2,7.8L0.1,289.7\n              c-0.9,5.6,3.4,10.8,9.2,10.8h301.4C316.4,300.5,320.8,295.4,319.9,289.7z"
  })), React$2.createElement("clipPath", {
    id: "SVGID_00000008828880287695994300000009761507785385857453_"
  }, React$2.createElement("use", {
    href: "#SVGID_1_",
    className: localStyles$4.visible
  })), React$2.createElement("path", {
    className: localStyles$4.clip,
    d: "M319.9,289.7\n            L286.7,85.9c-0.7-4.5-4.6-7.8-9.2-7.8h-235c-4.5,0-8.4,3.3-9.2,7.8L0.1,289.7c-0.9,5.6,3.4,10.8,9.2,10.8h301.4\n            C316.4,300.5,320.8,295.4,319.9,289.7z"
  }), React$2.createElement("g", {
    className: localStyles$4.clip
  }, React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M29.9,282h-6.7v-9.9c0-0.7,0.6-1.4,1.4-1.4h4c0.7,0,1.4,0.6,1.4,1.4V282z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M6.7,284.3l8.7,11.5c1,1.3,0.1,3.1-1.6,3.1h-1.6c-1.6,0-2.5,1.8-1.6,3.1l6.5,8.6c1,1.3,0.1,3.1-1.6,3.1h0\n                  c-1.6,0-2.5,1.8-1.6,3.1l11,14.5c0.8,1,2.3,1,3.1,0l11-14.5c1-1.3,0.1-3.1-1.6-3.1h0c-1.6,0-2.5-1.8-1.6-3.1l6.5-8.6\n                  c1-1.3,0.1-3.1-1.6-3.1h-1.6c-1.6,0-2.5-1.8-1.6-3.1l8.7-11.5c1-1.3,0.1-3.1-1.6-3.1H8.3C6.7,281.1,5.8,283,6.7,284.3z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M287.1,320.8h6.7v9.9c0,0.7-0.6,1.4-1.4,1.4h-4c-0.7,0-1.4-0.6-1.4-1.4V320.8z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M310.3,318.5l-8.7-11.5c-1-1.3-0.1-3.1,1.6-3.1h1.6c1.6,0,2.5-1.8,1.6-3.1l-6.5-8.6\n                  c-1-1.3-0.1-3.1,1.6-3.1l0,0c1.6,0,2.5-1.8,1.6-3.1l-11-14.5c-0.8-1-2.3-1-3.1,0L278,286c-1,1.3-0.1,3.1,1.6,3.1l0,0\n                  c1.6,0,2.5,1.8,1.6,3.1l-6.5,8.6c-1,1.3-0.1,3.1,1.6,3.1h1.6c1.6,0,2.5,1.8,1.6,3.1l-8.7,11.5c-1,1.3-0.1,3.1,1.6,3.1h36.6\n                  C310.4,321.7,311.3,319.8,310.3,318.5z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M135.5,282h-6.7v-9.9c0-0.7,0.6-1.4,1.4-1.4h4c0.7,0,1.4,0.6,1.4,1.4V282z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M112.3,284.3l8.7,11.5c1,1.3,0.1,3.1-1.6,3.1h-1.6c-1.6,0-2.5,1.8-1.6,3.1l6.5,8.6c1,1.3,0.1,3.1-1.6,3.1\n                  h0c-1.6,0-2.5,1.8-1.6,3.1l11,14.5c0.8,1,2.3,1,3.1,0l11-14.5c1-1.3,0.1-3.1-1.6-3.1h0c-1.6,0-2.5-1.8-1.6-3.1l6.5-8.6\n                  c1-1.3,0.1-3.1-1.6-3.1h-1.6c-1.6,0-2.5-1.8-1.6-3.1l8.7-11.5c1-1.3,0.1-3.1-1.6-3.1h-36.6C112.2,281.1,111.3,283,112.3,284.3z\n                  "
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M181.6,320.8h6.7v9.9c0,0.7-0.6,1.4-1.4,1.4h-4c-0.7,0-1.4-0.6-1.4-1.4V320.8z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M204.8,318.5l-8.7-11.5c-1-1.3-0.1-3.1,1.6-3.1h1.6c1.6,0,2.5-1.8,1.6-3.1l-6.5-8.6\n                  c-1-1.3-0.1-3.1,1.6-3.1l0,0c1.6,0,2.5-1.8,1.6-3.1l-11-14.5c-0.8-1-2.3-1-3.1,0l-11,14.5c-1,1.3-0.1,3.1,1.6,3.1h0\n                  c1.6,0,2.5,1.8,1.6,3.1l-6.5,8.6c-1,1.3-0.1,3.1,1.6,3.1h1.6c1.6,0,2.5,1.8,1.6,3.1l-8.7,11.5c-1,1.3-0.1,3.1,1.6,3.1h36.6\n                  C204.8,321.7,205.7,319.8,204.8,318.5z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M241.1,282h-6.7v-9.9c0-0.7,0.6-1.4,1.4-1.4h4c0.7,0,1.4,0.6,1.4,1.4V282z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M217.9,284.3l8.7,11.5c1,1.3,0.1,3.1-1.6,3.1h-1.6c-1.6,0-2.5,1.8-1.6,3.1l6.5,8.6c1,1.3,0.1,3.1-1.6,3.1\n                  l0,0c-1.6,0-2.5,1.8-1.6,3.1l11,14.5c0.8,1,2.3,1,3.1,0l11-14.5c1-1.3,0.1-3.1-1.6-3.1h0c-1.6,0-2.5-1.8-1.6-3.1l6.5-8.6\n                  c1-1.3,0.1-3.1-1.6-3.1h-1.6c-1.6,0-2.5-1.8-1.6-3.1l8.7-11.5c1-1.3,0.1-3.1-1.6-3.1h-36.6C217.8,281.1,216.9,283,217.9,284.3z\n                  "
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M76,320.8h6.7v9.9c0,0.7-0.6,1.4-1.4,1.4h-4c-0.7,0-1.4-0.6-1.4-1.4V320.8z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M99.2,318.5l-8.7-11.5c-1-1.3-0.1-3.1,1.6-3.1h1.6c1.6,0,2.5-1.8,1.6-3.1l-6.5-8.6c-1-1.3-0.1-3.1,1.6-3.1\n                  h0c1.6,0,2.5-1.8,1.6-3.1l-11-14.5c-0.8-1-2.3-1-3.1,0l-11,14.5c-1,1.3-0.1,3.1,1.6,3.1h0c1.6,0,2.5,1.8,1.6,3.1l-6.5,8.6\n                  c-1,1.3-0.1,3.1,1.6,3.1h1.6c1.6,0,2.5,1.8,1.6,3.1l-8.7,11.5c-1,1.3-0.1,3.1,1.6,3.1h36.6C99.2,321.7,100.2,319.8,99.2,318.5z\n                  "
  })))), React$2.createElement("g", {
    className: localStyles$4.clip
  }, React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M29.9,208.6h-6.7v-9.9c0-0.7,0.6-1.4,1.4-1.4h4c0.7,0,1.4,0.6,1.4,1.4V208.6z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M6.7,210.8l8.7,11.5c1,1.3,0.1,3.1-1.6,3.1h-1.6c-1.6,0-2.5,1.8-1.6,3.1l6.5,8.6c1,1.3,0.1,3.1-1.6,3.1h0\n                  c-1.6,0-2.5,1.8-1.6,3.1l11,14.5c0.8,1,2.3,1,3.1,0l11-14.5c1-1.3,0.1-3.1-1.6-3.1h0c-1.6,0-2.5-1.8-1.6-3.1l6.5-8.6\n                  c1-1.3,0.1-3.1-1.6-3.1h-1.6c-1.6,0-2.5-1.8-1.6-3.1l8.7-11.5c1-1.3,0.1-3.1-1.6-3.1H8.3C6.7,207.7,5.8,209.5,6.7,210.8z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M287.1,247.3h6.7v9.9c0,0.7-0.6,1.4-1.4,1.4h-4c-0.7,0-1.4-0.6-1.4-1.4V247.3z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M310.3,245.1l-8.7-11.5c-1-1.3-0.1-3.1,1.6-3.1h1.6c1.6,0,2.5-1.8,1.6-3.1l-6.5-8.6\n                  c-1-1.3-0.1-3.1,1.6-3.1l0,0c1.6,0,2.5-1.8,1.6-3.1l-11-14.5c-0.8-1-2.3-1-3.1,0l-11,14.5c-1,1.3-0.1,3.1,1.6,3.1l0,0\n                  c1.6,0,2.5,1.8,1.6,3.1l-6.5,8.6c-1,1.3-0.1,3.1,1.6,3.1h1.6c1.6,0,2.5,1.8,1.6,3.1l-8.7,11.5c-1,1.3-0.1,3.1,1.6,3.1h36.6\n                  C310.4,248.2,311.3,246.4,310.3,245.1z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M135.5,208.6h-6.7v-9.9c0-0.7,0.6-1.4,1.4-1.4h4c0.7,0,1.4,0.6,1.4,1.4V208.6z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M112.3,210.8l8.7,11.5c1,1.3,0.1,3.1-1.6,3.1h-1.6c-1.6,0-2.5,1.8-1.6,3.1l6.5,8.6c1,1.3,0.1,3.1-1.6,3.1\n                  h0c-1.6,0-2.5,1.8-1.6,3.1l11,14.5c0.8,1,2.3,1,3.1,0l11-14.5c1-1.3,0.1-3.1-1.6-3.1h0c-1.6,0-2.5-1.8-1.6-3.1l6.5-8.6\n                  c1-1.3,0.1-3.1-1.6-3.1h-1.6c-1.6,0-2.5-1.8-1.6-3.1l8.7-11.5c1-1.3,0.1-3.1-1.6-3.1h-36.6\n                  C112.2,207.7,111.3,209.5,112.3,210.8z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M181.6,247.3h6.7v9.9c0,0.7-0.6,1.4-1.4,1.4h-4c-0.7,0-1.4-0.6-1.4-1.4V247.3z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M204.8,245.1l-8.7-11.5c-1-1.3-0.1-3.1,1.6-3.1h1.6c1.6,0,2.5-1.8,1.6-3.1l-6.5-8.6\n                  c-1-1.3-0.1-3.1,1.6-3.1l0,0c1.6,0,2.5-1.8,1.6-3.1l-11-14.5c-0.8-1-2.3-1-3.1,0l-11,14.5c-1,1.3-0.1,3.1,1.6,3.1h0\n                  c1.6,0,2.5,1.8,1.6,3.1l-6.5,8.6c-1,1.3-0.1,3.1,1.6,3.1h1.6c1.6,0,2.5,1.8,1.6,3.1l-8.7,11.5c-1,1.3-0.1,3.1,1.6,3.1h36.6\n                  C204.8,248.2,205.7,246.4,204.8,245.1z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M241.1,208.6h-6.7v-9.9c0-0.7,0.6-1.4,1.4-1.4h4c0.7,0,1.4,0.6,1.4,1.4V208.6z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M217.9,210.8l8.7,11.5c1,1.3,0.1,3.1-1.6,3.1h-1.6c-1.6,0-2.5,1.8-1.6,3.1l6.5,8.6c1,1.3,0.1,3.1-1.6,3.1\n                  l0,0c-1.6,0-2.5,1.8-1.6,3.1l11,14.5c0.8,1,2.3,1,3.1,0l11-14.5c1-1.3,0.1-3.1-1.6-3.1h0c-1.6,0-2.5-1.8-1.6-3.1l6.5-8.6\n                  c1-1.3,0.1-3.1-1.6-3.1h-1.6c-1.6,0-2.5-1.8-1.6-3.1l8.7-11.5c1-1.3,0.1-3.1-1.6-3.1h-36.6\n                  C217.8,207.7,216.9,209.5,217.9,210.8z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M76,247.3h6.7v9.9c0,0.7-0.6,1.4-1.4,1.4h-4c-0.7,0-1.4-0.6-1.4-1.4V247.3z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M99.2,245.1l-8.7-11.5c-1-1.3-0.1-3.1,1.6-3.1h1.6c1.6,0,2.5-1.8,1.6-3.1l-6.5-8.6c-1-1.3-0.1-3.1,1.6-3.1\n                  h0c1.6,0,2.5-1.8,1.6-3.1l-11-14.5c-0.8-1-2.3-1-3.1,0l-11,14.5c-1,1.3-0.1,3.1,1.6,3.1h0c1.6,0,2.5,1.8,1.6,3.1l-6.5,8.6\n                  c-1,1.3-0.1,3.1,1.6,3.1h1.6c1.6,0,2.5,1.8,1.6,3.1l-8.7,11.5c-1,1.3-0.1,3.1,1.6,3.1h36.6C99.2,248.2,100.2,246.4,99.2,245.1z\n                  "
  })))), React$2.createElement("g", {
    className: localStyles$4.clip
  }, React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M29.9,135.1h-6.7v-9.9c0-0.7,0.6-1.4,1.4-1.4h4c0.7,0,1.4,0.6,1.4,1.4V135.1z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M6.7,137.4l8.7,11.5c1,1.3,0.1,3.1-1.6,3.1h-1.6c-1.6,0-2.5,1.8-1.6,3.1l6.5,8.6c1,1.3,0.1,3.1-1.6,3.1h0\n                  c-1.6,0-2.5,1.8-1.6,3.1l11,14.5c0.8,1,2.3,1,3.1,0l11-14.5c1-1.3,0.1-3.1-1.6-3.1h0c-1.6,0-2.5-1.8-1.6-3.1l6.5-8.6\n                  c1-1.3,0.1-3.1-1.6-3.1h-1.6c-1.6,0-2.5-1.8-1.6-3.1l8.7-11.5c1-1.3,0.1-3.1-1.6-3.1H8.3C6.7,134.2,5.8,136.1,6.7,137.4z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M287.1,173.9h6.7v9.9c0,0.7-0.6,1.4-1.4,1.4h-4c-0.7,0-1.4-0.6-1.4-1.4V173.9z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M310.3,171.7l-8.7-11.5c-1-1.3-0.1-3.1,1.6-3.1h1.6c1.6,0,2.5-1.8,1.6-3.1l-6.5-8.6\n                  c-1-1.3-0.1-3.1,1.6-3.1l0,0c1.6,0,2.5-1.8,1.6-3.1l-11-14.5c-0.8-1-2.3-1-3.1,0l-11,14.5c-1,1.3-0.1,3.1,1.6,3.1l0,0\n                  c1.6,0,2.5,1.8,1.6,3.1l-6.5,8.6c-1,1.3-0.1,3.1,1.6,3.1h1.6c1.6,0,2.5,1.8,1.6,3.1l-8.7,11.5c-1,1.3-0.1,3.1,1.6,3.1h36.6\n                  C310.4,174.8,311.3,172.9,310.3,171.7z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M135.5,135.1h-6.7v-9.9c0-0.7,0.6-1.4,1.4-1.4h4c0.7,0,1.4,0.6,1.4,1.4V135.1z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M112.3,137.4l8.7,11.5c1,1.3,0.1,3.1-1.6,3.1h-1.6c-1.6,0-2.5,1.8-1.6,3.1l6.5,8.6c1,1.3,0.1,3.1-1.6,3.1\n                  h0c-1.6,0-2.5,1.8-1.6,3.1l11,14.5c0.8,1,2.3,1,3.1,0l11-14.5c1-1.3,0.1-3.1-1.6-3.1h0c-1.6,0-2.5-1.8-1.6-3.1l6.5-8.6\n                  c1-1.3,0.1-3.1-1.6-3.1h-1.6c-1.6,0-2.5-1.8-1.6-3.1l8.7-11.5c1-1.3,0.1-3.1-1.6-3.1h-36.6\n                  C112.2,134.2,111.3,136.1,112.3,137.4z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M181.6,173.9h6.7v9.9c0,0.7-0.6,1.4-1.4,1.4h-4c-0.7,0-1.4-0.6-1.4-1.4V173.9z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M204.8,171.7l-8.7-11.5c-1-1.3-0.1-3.1,1.6-3.1h1.6c1.6,0,2.5-1.8,1.6-3.1l-6.5-8.6\n                  c-1-1.3-0.1-3.1,1.6-3.1l0,0c1.6,0,2.5-1.8,1.6-3.1l-11-14.5c-0.8-1-2.3-1-3.1,0l-11,14.5c-1,1.3-0.1,3.1,1.6,3.1h0\n                  c1.6,0,2.5,1.8,1.6,3.1l-6.5,8.6c-1,1.3-0.1,3.1,1.6,3.1h1.6c1.6,0,2.5,1.8,1.6,3.1l-8.7,11.5c-1,1.3-0.1,3.1,1.6,3.1h36.6\n                  C204.8,174.8,205.7,172.9,204.8,171.7z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M241.1,135.1h-6.7v-9.9c0-0.7,0.6-1.4,1.4-1.4h4c0.7,0,1.4,0.6,1.4,1.4V135.1z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M217.9,137.4l8.7,11.5c1,1.3,0.1,3.1-1.6,3.1h-1.6c-1.6,0-2.5,1.8-1.6,3.1l6.5,8.6c1,1.3,0.1,3.1-1.6,3.1\n                  l0,0c-1.6,0-2.5,1.8-1.6,3.1l11,14.5c0.8,1,2.3,1,3.1,0l11-14.5c1-1.3,0.1-3.1-1.6-3.1h0c-1.6,0-2.5-1.8-1.6-3.1l6.5-8.6\n                  c1-1.3,0.1-3.1-1.6-3.1h-1.6c-1.6,0-2.5-1.8-1.6-3.1l8.7-11.5c1-1.3,0.1-3.1-1.6-3.1h-36.6\n                  C217.8,134.2,216.9,136.1,217.9,137.4z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M76,173.9h6.7v9.9c0,0.7-0.6,1.4-1.4,1.4h-4c-0.7,0-1.4-0.6-1.4-1.4V173.9z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M99.2,171.7l-8.7-11.5c-1-1.3-0.1-3.1,1.6-3.1h1.6c1.6,0,2.5-1.8,1.6-3.1l-6.5-8.6c-1-1.3-0.1-3.1,1.6-3.1\n                  h0c1.6,0,2.5-1.8,1.6-3.1l-11-14.5c-0.8-1-2.3-1-3.1,0l-11,14.5c-1,1.3-0.1,3.1,1.6,3.1h0c1.6,0,2.5,1.8,1.6,3.1l-6.5,8.6\n                  c-1,1.3-0.1,3.1,1.6,3.1h1.6c1.6,0,2.5,1.8,1.6,3.1l-8.7,11.5c-1,1.3-0.1,3.1,1.6,3.1h36.6C99.2,174.8,100.2,172.9,99.2,171.7z\n                  "
  })))), React$2.createElement("g", {
    className: localStyles$4.clip
  }, React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M29.9,62.5h-6.7v-9.9c0-0.7,0.6-1.4,1.4-1.4h4c0.7,0,1.4,0.6,1.4,1.4V62.5z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M6.7,64.8l8.7,11.5c1,1.3,0.1,3.1-1.6,3.1h-1.6c-1.6,0-2.5,1.8-1.6,3.1l6.5,8.6c1,1.3,0.1,3.1-1.6,3.1h0\n                  c-1.6,0-2.5,1.8-1.6,3.1l11,14.5c0.8,1,2.3,1,3.1,0l11-14.5c1-1.3,0.1-3.1-1.6-3.1h0c-1.6,0-2.5-1.8-1.6-3.1l6.5-8.6\n                  c1-1.3,0.1-3.1-1.6-3.1h-1.6c-1.6,0-2.5-1.8-1.6-3.1l8.7-11.5c1-1.3,0.1-3.1-1.6-3.1H8.3C6.7,61.7,5.8,63.5,6.7,64.8z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M287.1,101.3h6.7v9.9c0,0.7-0.6,1.4-1.4,1.4h-4c-0.7,0-1.4-0.6-1.4-1.4V101.3z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M310.3,99.1l-8.7-11.5c-1-1.3-0.1-3.1,1.6-3.1h1.6c1.6,0,2.5-1.8,1.6-3.1l-6.5-8.6c-1-1.3-0.1-3.1,1.6-3.1\n                  l0,0c1.6,0,2.5-1.8,1.6-3.1L292,52c-0.8-1-2.3-1-3.1,0l-11,14.5c-1,1.3-0.1,3.1,1.6,3.1l0,0c1.6,0,2.5,1.8,1.6,3.1l-6.5,8.6\n                  c-1,1.3-0.1,3.1,1.6,3.1h1.6c1.6,0,2.5,1.8,1.6,3.1l-8.7,11.5c-1,1.3-0.1,3.1,1.6,3.1h36.6C310.4,102.2,311.3,100.3,310.3,99.1\n                  z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M135.5,62.5h-6.7v-9.9c0-0.7,0.6-1.4,1.4-1.4h4c0.7,0,1.4,0.6,1.4,1.4V62.5z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M112.3,64.8l8.7,11.5c1,1.3,0.1,3.1-1.6,3.1h-1.6c-1.6,0-2.5,1.8-1.6,3.1l6.5,8.6c1,1.3,0.1,3.1-1.6,3.1h0\n                  c-1.6,0-2.5,1.8-1.6,3.1l11,14.5c0.8,1,2.3,1,3.1,0l11-14.5c1-1.3,0.1-3.1-1.6-3.1h0c-1.6,0-2.5-1.8-1.6-3.1l6.5-8.6\n                  c1-1.3,0.1-3.1-1.6-3.1h-1.6c-1.6,0-2.5-1.8-1.6-3.1l8.7-11.5c1-1.3,0.1-3.1-1.6-3.1h-36.6C112.2,61.7,111.3,63.5,112.3,64.8z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M181.6,101.3h6.7v9.9c0,0.7-0.6,1.4-1.4,1.4h-4c-0.7,0-1.4-0.6-1.4-1.4V101.3z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M204.8,99.1l-8.7-11.5c-1-1.3-0.1-3.1,1.6-3.1h1.6c1.6,0,2.5-1.8,1.6-3.1l-6.5-8.6c-1-1.3-0.1-3.1,1.6-3.1\n                  l0,0c1.6,0,2.5-1.8,1.6-3.1l-11-14.5c-0.8-1-2.3-1-3.1,0l-11,14.5c-1,1.3-0.1,3.1,1.6,3.1h0c1.6,0,2.5,1.8,1.6,3.1l-6.5,8.6\n                  c-1,1.3-0.1,3.1,1.6,3.1h1.6c1.6,0,2.5,1.8,1.6,3.1l-8.7,11.5c-1,1.3-0.1,3.1,1.6,3.1h36.6C204.8,102.2,205.7,100.3,204.8,99.1\n                  z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M241.1,62.5h-6.7v-9.9c0-0.7,0.6-1.4,1.4-1.4h4c0.7,0,1.4,0.6,1.4,1.4V62.5z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M217.9,64.8l8.7,11.5c1,1.3,0.1,3.1-1.6,3.1h-1.6c-1.6,0-2.5,1.8-1.6,3.1l6.5,8.6c1,1.3,0.1,3.1-1.6,3.1\n                  l0,0c-1.6,0-2.5,1.8-1.6,3.1l11,14.5c0.8,1,2.3,1,3.1,0l11-14.5c1-1.3,0.1-3.1-1.6-3.1h0c-1.6,0-2.5-1.8-1.6-3.1l6.5-8.6\n                  c1-1.3,0.1-3.1-1.6-3.1h-1.6c-1.6,0-2.5-1.8-1.6-3.1l8.7-11.5c1-1.3,0.1-3.1-1.6-3.1h-36.6C217.8,61.7,216.9,63.5,217.9,64.8z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st2,
    d: "M76,101.3h6.7v9.9c0,0.7-0.6,1.4-1.4,1.4h-4c-0.7,0-1.4-0.6-1.4-1.4V101.3z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$4.st3,
    d: "M99.2,99.1l-8.7-11.5c-1-1.3-0.1-3.1,1.6-3.1h1.6c1.6,0,2.5-1.8,1.6-3.1l-6.5-8.6c-1-1.3-0.1-3.1,1.6-3.1\n                  h0c1.6,0,2.5-1.8,1.6-3.1L80.9,52c-0.8-1-2.3-1-3.1,0l-11,14.5c-1,1.3-0.1,3.1,1.6,3.1h0c1.6,0,2.5,1.8,1.6,3.1l-6.5,8.6\n                  c-1,1.3-0.1,3.1,1.6,3.1h1.6c1.6,0,2.5,1.8,1.6,3.1l-8.7,11.5c-1,1.3-0.1,3.1,1.6,3.1h36.6C99.2,102.2,100.2,100.3,99.2,99.1z"
  }))))), React$2.createElement("line", {
    className: styles$m.string,
    x1: "236.34",
    y1: "88.37",
    x2: "236.34",
    y2: "421.64"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.leftBow),
    d: "M163.83,36.51c7.72,9.03,72.64,51.86,72.64,51.86,0,0-32.19-70.79-39.92-79.83-7.73-9.04-21.31-10.11-30.34-2.38-9.04,7.72-10.1,21.31-2.38,30.34Z"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.rightBow),
    d: "M308.6,68.86c-8.7,4.83-72.13,19.5-72.13,19.5,0,0,45.92-46.16,54.61-51,8.7-4.83,19.67-1.7,24.51,6.99,4.83,8.7,1.71,19.67-6.99,24.51Z"
  }), React$2.createElement("g", {
    className: styles$m.label
  }, React$2.createElement("path", {
    className: localStyles$4.tag,
    d: "M383.34,219l-53.87,38.04c-3.58,2.53-8.53,1.68-11.06-1.91l-66.64-94.4c-1.08-1.54-1.59-3.4-1.42-5.27l3.73-42.66c.8-9.18,9.67-15.43,18.58-13.12l41.45,10.76c1.82,.47,3.41,1.57,4.49,3.1l66.64,94.4c2.53,3.58,1.68,8.53-1.91,11.06m-107.68-108.42c-2.4-3.4-7.1-4.21-10.5-1.81-3.4,2.4-4.21,7.1-1.81,10.5,2.4,3.4,7.1,4.21,10.5,1.81,3.4-2.4,4.21-7.1,1.81-10.5"
  }), React$2.createElement("path", {
    className: localStyles$4.tagIcon,
    transform: "scale(1.49 1.34)",
    d: "M194.8,138.1l5.3-3.7c0.7-0.5,1.7-0.2,2.2,0.7l10.9,17.1c0.5,0.9,1.7,0.5,1.5-0.5c-1-4.6-1.3-11.1,3.6-14.5\n        \t\tc5.8-4,11.1-2.2,20.2,11l7.5,10.8c0.5,0.8,0.5,1.8-0.2,2.2l-4.8,3.3c-0.7,0.5-1.6,0.2-2.2-0.6l-5.1-7.4c-5.5-8-8.8-9.5-12.6-6.9\n        \t\tc-3.9,2.7-2.8,9.9,2.6,17.7l3.3,4.8c0.5,0.8,0.5,1.8-0.2,2.2l-4.8,3.3c-0.7,0.5-1.6,0.2-2.2-0.6l-25.4-36.7\n        \t\tC194.1,139.6,194.2,138.6,194.8,138.1"
  })), React$2.createElement("path", {
    className: styles$m.string,
    d: "M266.39,112.37s-10.45-24.21-30.05-24"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.ends),
    d: "M179.11,250.06c-3.62-10.66-10.05-27.22-2.8-43.73,10.47-23.86,25.88-16.69,36.35-40.54,10.47-23.85-1.93-29.92,5.53-54.87,3.88-12.97,11.92-17.51,18.03-22.76,0,0-28.44-2.12-42.93,24.22-14.49,26.34,.59,47.8-34.61,60.58"
  })));
};
var localStyles$3 = {
  "tag": "christmas-wreath-wrapping-module_tag__P-zjP",
  "tagIcon": "christmas-wreath-wrapping-module_tagIcon__LWb8y",
  "visible": "christmas-wreath-wrapping-module_visible__h3Kpy",
  "clipFill": "christmas-wreath-wrapping-module_clipFill__WKzr0",
  "clip": "christmas-wreath-wrapping-module_clip__rFk4x",
  "clipLine": "christmas-wreath-wrapping-module_clipLine__lr5Mq",
  "st2": "christmas-wreath-wrapping-module_st2__zbQnv",
  "st3": "christmas-wreath-wrapping-module_st3__xWRcP"
};
var ChristmasWreath = function ChristmasWreath() {
  return React$2.createElement("svg", {
    "data-testid": "gift",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -14 476.81 435.64"
  }, React$2.createElement("g", null, React$2.createElement("g", {
    transform: "translate(0 -27) scale(1.49)"
  }, React$2.createElement("g", null, React$2.createElement("defs", null, React$2.createElement("path", {
    id: "SVGID_1_",
    d: "M319.9,290.1L286.7,86.2c-0.7-4.5-4.6-7.8-9.2-7.8h-235c-4.5,0-8.4,3.3-9.2,7.8L0.1,290.1\n              c-0.9,5.6,3.4,10.8,9.2,10.8h301.4C316.4,300.8,320.8,295.7,319.9,290.1z"
  })), React$2.createElement("clipPath", {
    id: "SVGID_00000107566198442959937060000009904383562077088701_"
  }, React$2.createElement("use", {
    href: "#SVGID_1_",
    className: localStyles$3.visible
  })), React$2.createElement("path", {
    className: localStyles$3.clipFill,
    d: "M319.9,290.1\n            L286.7,86.2c-0.7-4.5-4.6-7.8-9.2-7.8h-235c-4.5,0-8.4,3.3-9.2,7.8L0.1,290.1c-0.9,5.6,3.4,10.8,9.2,10.8h301.4\n            C316.4,300.8,320.8,295.7,319.9,290.1z"
  }), React$2.createElement("g", {
    className: localStyles$3.clip
  }, React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M89,298C74.1,265.7,43.1,242.3,6,238.1c-6.3-0.7-12.7-0.9-19-0.4c-2,0.1-3.5,1.8-3.3,3.8\n                c0.1,2,1.8,3.5,3.8,3.3c5.9-0.4,11.8-0.3,17.7,0.4c46.2,5.2,82.3,42.6,85.8,88.9c0.1,2,1.9,3.4,3.8,3.3c2-0.1,3.4-1.9,3.3-3.8\n                C97.2,320.9,94,308.9,89,298z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M12.7,240.6c0,0,0-0.1-0.1-0.1L7.9,231c-0.9-1.8-3-2.5-4.8-1.6c-1.8,0.9-2.5,3-1.6,4.8l4.7,9.4\n                  c0.9,1.8,3,2.5,4.8,1.6C12.7,244.4,13.5,242.3,12.7,240.6z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M12.7,240.6c-0.2-0.5-0.5-0.9-1-1.3c-1.5-1.3-3.8-1-5,0.5l-6.7,8.1c-1.3,1.5-1,3.8,0.5,5\n                  c1.5,1.3,3.8,1,5-0.5l6.7-8.1C13.1,243.2,13.2,241.8,12.7,240.6z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M25.7,231.4c-0.7-1.6-2.5-2.4-4.3-1.9c-1.9,0.6-3,2.6-2.4,4.5l4,13.3c0.6,1.9,2.6,3,4.5,2.4\n                  c1.9-0.6,3-2.6,2.4-4.5l-4-13.3C25.8,231.7,25.8,231.6,25.7,231.4z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M29.7,244.7c-0.1-0.3-0.3-0.6-0.5-0.8c-1.3-1.5-3.5-1.7-5-0.4l-10.6,9c-1.5,1.3-1.7,3.5-0.4,5\n                  c1.3,1.5,3.5,1.7,5,0.4l10.6-9C30,247.8,30.4,246.1,29.7,244.7z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M44.1,237.9c-0.6-1.4-2.1-2.2-3.7-2.1c-2,0.2-3.4,2-3.1,4l1.6,13.8c0.2,2,2,3.4,4,3.1c2-0.2,3.4-2,3.1-4\n                  L44.5,239C44.4,238.6,44.3,238.3,44.1,237.9z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M45.8,251.7c0-0.1-0.1-0.2-0.2-0.3c-1-1.7-3.2-2.3-4.9-1.3l-12,7c-1.7,1-2.3,3.2-1.3,4.9\n                  c1,1.7,3.2,2.3,4.9,1.3l12-7C45.9,255.3,46.5,253.3,45.8,251.7z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M61.2,247.6c-0.5-1.2-1.7-2-3-2.1c-2-0.1-3.7,1.4-3.8,3.4l-0.8,13.8c-0.1,2,1.4,3.7,3.4,3.8\n                  c2,0.1,3.7-1.4,3.8-3.4l0.8-13.8C61.5,248.7,61.4,248.1,61.2,247.6z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M60.4,261.4c-0.8-1.7-2.7-2.5-4.5-1.8l-13,4.8c-1.9,0.7-2.8,2.7-2.1,4.6c0.7,1.8,2.7,2.8,4.6,2.1l13-4.8\n                  c1.9-0.7,2.8-2.7,2.1-4.6C60.4,261.6,60.4,261.5,60.4,261.4z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M76.3,260c-0.4-1-1.3-1.7-2.4-2c-1.9-0.5-3.8,0.7-4.3,2.7l-3.2,13.5c-0.5,1.9,0.7,3.8,2.7,4.3\n                  c1.9,0.5,3.8-0.7,4.3-2.7l3.2-13.5C76.7,261.5,76.6,260.7,76.3,260z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M73.1,273.5c-0.7-1.4-2.3-2.3-3.9-2L55.6,274c-1.9,0.4-3.2,2.2-2.9,4.2c0.4,1.9,2.2,3.2,4.2,2.9l13.6-2.5\n                  c1.9-0.4,3.2-2.2,2.9-4.2C73.3,274,73.2,273.7,73.1,273.5z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M89,274.9c-0.4-0.8-1-1.4-1.8-1.8c-1.8-0.8-3.9,0.1-4.7,1.9l-5.5,12.7c-0.8,1.8,0.1,3.9,1.9,4.7\n                  c1.8,0.8,3.9-0.1,4.7-1.9l5.5-12.7C89.4,276.8,89.4,275.8,89,274.9z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M83.5,287.6c-0.6-1.2-1.8-2.1-3.3-2.1l-13.9,0.1c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6l13.9-0.1\n                  c2,0,3.6-1.6,3.6-3.6C83.8,288.5,83.7,288,83.5,287.6z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M98.9,291.7c-0.3-0.6-0.7-1.1-1.3-1.5c-1.7-1.1-3.9-0.6-5,1L85,302.8c-1.1,1.7-0.6,3.9,1,5\n                  c1.7,1.1,3.9,0.6,5-1l7.6-11.6C99.3,294.1,99.4,292.8,98.9,291.7z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M91.3,303.3c-0.5-1-1.4-1.8-2.7-2L75,299c-1.9-0.3-3.8,1-4.1,2.9c-0.3,1.9,1,3.8,2.9,4.1l13.7,2.3\n                  c1.9,0.3,3.8-1,4.1-2.9C91.7,304.7,91.6,303.9,91.3,303.3z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M240,305.5c-0.4,0.1-0.7,0.1-1.1,0.1c-2-0.2-3.4-1.9-3.2-3.9c0.5-5.9,0.6-11.8,0-17.7\n                c-4.1-46.3-40.6-83.3-86.8-87.9c-2-0.2-3.4-1.9-3.2-3.9c0.2-2,1.9-3.4,3.9-3.2c49.6,4.9,88.8,44.6,93.2,94.4\n                c0.6,6.3,0.5,12.7,0,19C242.6,303.9,241.5,305.2,240,305.5z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M249,288.4c-0.8,0.2-1.7,0.1-2.5-0.3l-9.3-5c-1.7-0.9-2.4-3.1-1.5-4.8c0.9-1.7,3.1-2.4,4.8-1.5l9.3,5\n                  c1.7,0.9,2.4,3.1,1.5,4.8C250.9,287.5,250,288.1,249,288.4z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M231.4,289.9c-1.3,0.3-2.7-0.2-3.6-1.3c-1.2-1.6-1-3.8,0.6-5l8.3-6.5c1.6-1.2,3.8-1,5,0.6\n                  c1.2,1.6,1,3.8-0.6,5l-8.3,6.5C232.4,289.6,231.9,289.8,231.4,289.9z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M249.2,270.6c-0.6,0.1-1.3,0.1-1.9-0.1l-13.2-4.3c-1.9-0.6-2.9-2.6-2.3-4.5c0.6-1.9,2.6-2.9,4.5-2.3\n                  l13.2,4.3c1.9,0.6,2.9,2.6,2.3,4.5C251.4,269.4,250.3,270.3,249.2,270.6z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M226.8,276.6c-1.1,0.2-2.3,0-3.2-0.8c-1.5-1.3-1.6-3.6-0.3-5l9.2-10.3c1.3-1.5,3.6-1.6,5-0.3\n                  c1.5,1.3,1.6,3.6,0.3,5l-9.2,10.3C228.1,276.1,227.5,276.4,226.8,276.6z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M243.1,252c-0.4,0.1-0.8,0.1-1.3,0l-13.7-2c-2-0.3-3.3-2.1-3-4c0.3-2,2.1-3.3,4-3l13.7,2\n                  c2,0.3,3.3,2.1,3,4C245.6,250.5,244.5,251.7,243.1,252z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M222.1,261.8c-0.9,0.2-1.8,0.1-2.7-0.5c-1.7-1-2.2-3.2-1.2-4.9l7.3-11.8c1-1.7,3.2-2.2,4.9-1.2\n                  c1.7,1,2.2,3.2,1.2,4.9l-7.3,11.8C223.8,261,223,261.6,222.1,261.8z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M233.9,234.7c-0.2,0-0.4,0.1-0.7,0.1l-13.8,0.5c-2,0.1-3.6-1.5-3.7-3.5c-0.1-2,1.5-3.6,3.5-3.7l13.8-0.5\n                  c2-0.1,3.6,1.5,3.7,3.5C236.7,232.9,235.5,234.4,233.9,234.7z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M214.9,248.1c-0.7,0.2-1.4,0.1-2.1-0.2c-1.8-0.7-2.7-2.8-2-4.6l5.1-12.9c0.7-1.8,2.8-2.7,4.6-2\n                  c1.8,0.7,2.7,2.8,2,4.6l-5.1,12.9C217,247,216,247.8,214.9,248.1z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M221.8,219.4C221.8,219.4,221.8,219.4,221.8,219.4l-13.6,2.9c-1.9,0.4-3.8-0.8-4.2-2.8\n                  c-0.4-1.9,0.8-3.8,2.7-4.2c0,0,0,0,0,0l13.6-2.9c1.9-0.4,3.8,0.8,4.2,2.8C224.9,217,223.7,218.9,221.8,219.4z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M205.4,235.8c-0.5,0.1-1,0.1-1.5,0c-1.9-0.4-3.2-2.3-2.8-4.2l2.8-13.6c0.4-1.9,2.3-3.2,4.2-2.8\n                  c1.9,0.4,3.2,2.3,2.8,4.2l-2.8,13.6C207.8,234.4,206.7,235.5,205.4,235.8z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M194.4,211.5c-1.7,0.4-3.4-0.5-4.1-2.2c-0.7-1.8,0.1-3.9,2-4.7l12.9-5.2c1.9-0.7,3.9,0.2,4.7,2\n                  c0.7,1.8-0.1,3.9-2,4.7l-12.9,5.2C194.7,211.4,194.5,211.4,194.4,211.5z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M193.9,225.3c-0.3,0.1-0.6,0.1-0.9,0.1c-2-0.1-3.5-1.7-3.5-3.7l0.4-13.8c0.1-2,1.7-3.5,3.7-3.5\n                  c2,0.1,3.5,1.7,3.5,3.7l-0.4,13.8C196.7,223.6,195.5,225,193.9,225.3z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M178.8,203.3c-1.4,0.3-3-0.3-3.8-1.6c-1-1.7-0.5-3.9,1.1-4.9l11.8-7.3c1.7-1,3.9-0.5,4.9,1.1\n                  c1,1.7,0.5,3.9-1.1,4.9l-11.8,7.3C179.6,203.1,179.2,203.2,178.8,203.3z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M180.8,217c-0.1,0-0.2,0-0.3,0c-2,0.3-3.8-1.1-4.1-3l-2-13.7c-0.3-2,1.1-3.8,3-4.1c2-0.3,3.8,1.1,4.1,3\n                  l2,13.7C183.9,214.9,182.6,216.6,180.8,217z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M331.8,137.6c0.2,0.3,0.4,0.6,0.6,0.9c0.8,1.8-0.1,3.9-1.9,4.7c-5.4,2.3-10.7,5.1-15.6,8.3\n                c-38.9,25.4-54.4,75.1-36.7,118c0.8,1.8-0.1,3.9-1.9,4.7c-1.8,0.8-3.9-0.1-4.7-1.9c-19-46.1-2.4-99.4,39.4-126.7\n                c5.3-3.5,11-6.5,16.8-8.9C329.2,136,330.8,136.4,331.8,137.6z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M312.5,137.7c0.5,0.6,0.9,1.4,0.9,2.3l0,10.5c0,2-1.6,3.6-3.6,3.6c-2,0-3.6-1.6-3.6-3.6l0-10.5\n                  c0-2,1.6-3.6,3.6-3.6C310.8,136.5,311.8,137,312.5,137.7z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M322.1,152.5c0.9,1,1.1,2.5,0.6,3.8c-0.8,1.8-2.9,2.6-4.7,1.8l-9.7-4.2c-1.8-0.8-2.6-2.9-1.8-4.7\n                  c0.8-1.8,2.9-2.6,4.7-1.8l9.7,4.2C321.3,151.8,321.8,152.1,322.1,152.5z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M296.7,146c0.4,0.5,0.7,1.1,0.8,1.7l2.4,13.6c0.3,1.9-1,3.8-2.9,4.1c-1.9,0.3-3.8-1-4.1-2.9l-2.4-13.6\n                  c-0.3-1.9,1-3.8,2.9-4.1C294.6,144.5,295.9,145,296.7,146z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M312.5,162.9c0.7,0.8,1,2,0.8,3.2c-0.5,1.9-2.4,3.1-4.3,2.6l-13.5-3.3c-1.9-0.5-3.1-2.4-2.6-4.3\n                  c0.5-1.9,2.4-3.1,4.3-2.6l13.5,3.3C311.4,161.9,312.1,162.3,312.5,162.9z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M283.2,160.1c0.3,0.3,0.5,0.7,0.6,1.1l4.7,13c0.7,1.9-0.3,3.9-2.1,4.6c-1.9,0.7-3.9-0.3-4.6-2.1l-4.7-13\n                  c-0.7-1.9,0.3-3.9,2.1-4.6C280.7,158.5,282.2,159,283.2,160.1z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M301.7,174c0.6,0.7,0.9,1.6,0.9,2.6c-0.1,2-1.8,3.5-3.8,3.3l-13.8-0.9c-2-0.1-3.5-1.8-3.3-3.8\n                  c0.1-2,1.8-3.5,3.8-3.3l13.8,0.9C300.2,172.8,301.1,173.3,301.7,174z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M272.3,176.3c0.1,0.2,0.3,0.3,0.4,0.5l6.9,12c1,1.7,0.4,3.9-1.3,4.9c-1.7,1-3.9,0.4-4.9-1.3l-6.9-12\n                  c-1-1.7-0.4-3.9,1.3-4.9C269.3,174.7,271.2,175.1,272.3,176.3z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M293,186.8c0.5,0.5,0.8,1.2,0.8,1.9c0.2,2-1.2,3.7-3.2,3.9l-13.8,1.5c-2,0.2-3.7-1.2-3.9-3.2\n                  c-0.2-2,1.2-3.7,3.2-3.9l13.8-1.5C291.1,185.5,292.2,185.9,293,186.8z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M264.4,194.2C264.4,194.2,264.4,194.3,264.4,194.2l8.9,10.6c1.3,1.5,1.1,3.8-0.4,5c-1.5,1.3-3.7,1.1-5-0.4\n                  c0,0,0,0,0,0l-8.9-10.6c-1.3-1.5-1.1-3.8,0.4-5C260.9,192.6,263.1,192.7,264.4,194.2z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M286.6,201c0.3,0.4,0.6,0.8,0.7,1.3c0.6,1.9-0.5,3.9-2.4,4.4l-13.3,3.9c-1.9,0.6-3.9-0.5-4.4-2.4\n                  c-0.6-1.9,0.5-3.9,2.4-4.4l13.3-3.9C284.3,199.4,285.7,199.9,286.6,201z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M270.4,222.1c1.1,1.3,1.2,3.3,0,4.6c-1.3,1.5-3.5,1.7-5,0.4l-10.6-8.9c-1.5-1.3-1.7-3.5-0.4-5\n                  c1.3-1.5,3.5-1.7,5-0.4l10.6,8.9C270.1,221.8,270.2,222,270.4,222.1z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M282.8,216c0.2,0.2,0.4,0.5,0.5,0.7c0.9,1.8,0.1,3.9-1.6,4.8l-12.4,6.1c-1.8,0.9-3.9,0.2-4.8-1.6\n                  c-0.9-1.8-0.1-3.9,1.6-4.8l12.4-6.1C280,214.4,281.7,214.8,282.8,216z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M270.4,239.7c1,1.1,1.2,2.8,0.4,4.1c-1,1.7-3.2,2.3-4.9,1.3l-12-6.9c-1.7-1-2.3-3.2-1.3-4.9\n                  c1-1.7,3.2-2.3,4.9-1.3l12,6.9C269.9,239.1,270.2,239.4,270.4,239.7z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M281.6,231.5c0.1,0.1,0.1,0.1,0.2,0.2c1.2,1.6,0.8,3.8-0.8,5l-11.2,8.2c-1.6,1.2-3.9,0.8-5-0.8\n                  c-1.2-1.6-0.8-3.8,0.8-5l11.2-8.2C278.3,229.8,280.4,230,281.6,231.5z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M99.1,193c-0.3-1.8-1.8-3.1-3.6-3c-5.9,0.1-11.8-0.3-17.7-1.2c-32.8-5.3-60.3-26.6-73.5-57.1\n                c-0.8-1.8-2.9-2.6-4.7-1.9c-1.8,0.8-2.6,2.9-1.9,4.7c14.2,32.7,43.8,55.7,79,61.3c6.3,1,12.6,1.4,18.9,1.3c2,0,3.5-1.7,3.5-3.7\n                C99.1,193.3,99.1,193.1,99.1,193z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M81.4,200.7c0-0.3-0.1-0.6-0.3-0.9l-4.3-9.6c-0.8-1.8-2.9-2.6-4.7-1.8c-1.8,0.8-2.6,2.9-1.8,4.7l4.3,9.6\n                  c0.8,1.8,2.9,2.6,4.7,1.8C80.8,203.9,81.6,202.3,81.4,200.7z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M84.2,183.3c-0.1-0.8-0.5-1.5-1.1-2.1c-1.5-1.3-3.7-1.2-5.1,0.2l-7.1,7.8c-1.3,1.5-1.2,3.7,0.2,5.1\n                  c1.5,1.3,3.7,1.2,5.1-0.2l7.1-7.8C84,185.4,84.3,184.3,84.2,183.3z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M63.6,199.6c0-0.1,0-0.2-0.1-0.3l-3.4-13.4c-0.5-1.9-2.4-3.1-4.3-2.6c-1.9,0.5-3.1,2.4-2.6,4.3l3.4,13.4\n                  c0.5,1.9,2.4,3.1,4.3,2.6C62.7,203.2,63.9,201.4,63.6,199.6z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M71.2,177.7c-0.1-0.6-0.3-1.2-0.7-1.7c-1.2-1.6-3.5-1.9-5-0.6l-11,8.5c-1.6,1.2-1.9,3.5-0.6,5\n                  c1.2,1.6,3.5,1.9,5,0.6l11-8.5C70.9,180.2,71.4,178.9,71.2,177.7z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M44.5,178.4c-0.3-1.8-1.9-3.2-3.8-3c-2,0.1-3.5,1.8-3.3,3.8l1,13.8c0.1,2,1.8,3.5,3.8,3.3\n                  c2-0.1,3.5-1.8,3.3-3.8l-1-13.8C44.5,178.6,44.5,178.5,44.5,178.4z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M56.8,172c-0.1-0.4-0.2-0.8-0.4-1.1c-0.9-1.7-3.1-2.4-4.8-1.5l-12.3,6.4c-1.7,0.9-2.4,3.1-1.5,4.8\n                  c0.9,1.7,3.1,2.4,4.8,1.5l12.3-6.4C56.3,174.9,57,173.4,56.8,172z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M30.8,170c-0.2-1.6-1.5-2.9-3.2-3c-2-0.2-3.7,1.2-3.9,3.2l-1.4,13.8c-0.2,2,1.2,3.7,3.2,3.9\n                  c2,0.2,3.7-1.2,3.9-3.2l1.4-13.8C30.8,170.6,30.8,170.3,30.8,170z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M43.6,163.8c0-0.2-0.1-0.4-0.1-0.6c-0.6-1.9-2.6-2.9-4.5-2.3l-13.2,4.2c-1.9,0.6-2.9,2.6-2.3,4.5\n                  c0.6,1.9,2.6,2.9,4.5,2.3l13.2-4.2C42.8,167.2,43.8,165.5,43.6,163.8z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M19.6,158.5c-0.2-1.3-1.2-2.5-2.6-2.9c-1.9-0.5-3.9,0.6-4.4,2.5l-3.8,13.3c-0.5,1.9,0.6,3.9,2.5,4.4\n                  c1.9,0.5,3.9-0.6,4.4-2.5l3.8-13.3C19.6,159.5,19.7,159,19.6,158.5z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M32,151c-0.3-1.9-2.1-3.3-4-3l-13.7,1.9c-2,0.3-3.3,2.1-3.1,4c0,0,0,0,0,0c0.3,1.9,2.1,3.3,4,3l13.7-1.9\n                  C30.9,154.8,32.3,153,32,151C32,151.1,32,151,32,151z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M135.1,195c1.5,1,2,3,1.1,4.6c-2.7,5.2-5,10.7-6.7,16.4c-9.7,31.7-2.7,65.8,18.8,91.2\n                c1.3,1.5,1.1,3.8-0.4,5s-3.8,1.1-5-0.4c-23.1-27.2-30.6-63.8-20.1-97.9c1.9-6.1,4.3-12,7.2-17.6c0.9-1.8,3.1-2.4,4.8-1.5\n                C134.9,194.9,135,195,135.1,195z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M120.3,207.5c0.3,0.2,0.5,0.4,0.7,0.7l6.7,8.1c1.3,1.5,1.1,3.8-0.5,5c-1.5,1.3-3.8,1.1-5-0.5l-6.7-8.1\n                  c-1.3-1.5-1.1-3.8,0.5-5C117.3,206.7,119,206.7,120.3,207.5z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M137.2,212.7c0.7,0.5,1.2,1.1,1.4,2c0.5,1.9-0.5,3.9-2.4,4.4L126,222c-1.9,0.5-3.9-0.5-4.4-2.4\n                  c-0.5-1.9,0.5-3.9,2.4-4.4l10.1-2.9C135.2,211.9,136.3,212.1,137.2,212.7z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M113.5,224c0.1,0.1,0.2,0.1,0.3,0.2l10.6,8.9c1.5,1.3,1.7,3.5,0.4,5c-1.3,1.5-3.6,1.7-5,0.4l-10.6-8.9\n                  c-1.5-1.3-1.7-3.5-0.4-5C109.9,223.2,112,222.9,113.5,224z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M136.5,226.8c0.5,0.3,0.9,0.8,1.2,1.4c0.9,1.8,0.1,3.9-1.6,4.8l-12.4,6.1c-1.8,0.9-3.9,0.1-4.8-1.6\n                  c-0.9-1.8-0.1-3.9,1.6-4.8l12.4-6.1C134.1,226,135.5,226.1,136.5,226.8z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M124.1,250.5c1.5,1.1,2,3.1,1.1,4.7c-1,1.7-3.2,2.3-4.9,1.3l-12-7c-1.7-1-2.3-3.2-1.3-4.9\n                  c1-1.7,3.2-2.3,4.9-1.3l12,7C123.9,250.3,124,250.4,124.1,250.5z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M135.3,242.3c0.3,0.2,0.6,0.5,0.9,0.8c1.2,1.6,0.8,3.8-0.8,5l-11.2,8.2c-1.6,1.2-3.8,0.8-5-0.8\n                  c-1.2-1.6-0.8-3.8,0.8-5l11.2-8.2C132.4,241.4,134,241.4,135.3,242.3z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M127.1,267.7c1.3,0.9,1.9,2.6,1.3,4.2c-0.7,1.9-2.7,2.8-4.6,2.1l-13-4.8c-1.9-0.7-2.8-2.7-2.1-4.6\n                  c0.7-1.9,2.7-2.8,4.6-2.1l13,4.8C126.6,267.4,126.9,267.5,127.1,267.7z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M136.7,257.7c0.2,0.1,0.3,0.2,0.5,0.4c1.4,1.4,1.5,3.6,0.1,5.1l-9.6,10c-1.4,1.4-3.6,1.5-5.1,0.1\n                  c-1.4-1.4-1.5-3.6-0.1-5.1l9.6-10C133.4,256.9,135.3,256.7,136.7,257.7z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M133.2,284.2c1.1,0.8,1.7,2.2,1.5,3.6c-0.3,1.9-2.2,3.2-4.2,2.9l-13.6-2.5c-1.9-0.3-3.2-2.2-2.9-4.2\n                  c0.3-1.9,2.2-3.2,4.2-2.9l13.6,2.5C132.3,283.7,132.7,283.9,133.2,284.2z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M140.9,272.7c1.6,1.1,2,3.3,0.9,4.9l-7.7,11.5c-1.1,1.6-3.3,2.1-5,1c0,0,0,0,0,0c-1.6-1.1-2-3.3-0.9-4.9\n                  l7.7-11.5C137,272,139.2,271.6,140.9,272.7C140.9,272.7,140.9,272.7,140.9,272.7z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M345.5,268.7c0.3,1.7-0.7,3.5-2.4,4.1c-5.6,1.9-11,4.2-16.2,7.1c-29.1,16-47.8,45.3-50.1,78.5\n                c-0.1,2-1.8,3.5-3.8,3.3c-2-0.1-3.5-1.8-3.3-3.8c2.4-35.6,22.5-67.1,53.8-84.3c5.6-3.1,11.4-5.6,17.4-7.6\n                c1.9-0.6,3.9,0.4,4.5,2.3C345.4,268.4,345.4,268.6,345.5,268.7z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M326.1,267.4c0.1,0.3,0.1,0.6,0.1,1l-0.8,10.5c-0.2,2-1.9,3.4-3.8,3.3c-2-0.2-3.4-1.9-3.3-3.8l0.8-10.5\n                  c0.2-2,1.9-3.4,3.8-3.3C324.5,264.6,325.8,265.8,326.1,267.4z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M334.6,282.8c0.2,0.8,0.1,1.6-0.4,2.4c-0.9,1.7-3.1,2.4-4.8,1.5l-9.3-5c-1.7-0.9-2.4-3.1-1.5-4.8\n                  c0.9-1.7,3.1-2.4,4.8-1.5l9.3,5C333.8,280.9,334.4,281.8,334.6,282.8z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M309.8,274.4c0,0.1,0,0.2,0.1,0.3l1.4,13.8c0.2,2-1.2,3.7-3.2,3.9c-2,0.2-3.7-1.2-3.9-3.2l-1.4-13.8\n                  c-0.2-2,1.2-3.7,3.2-3.9C307.8,271.3,309.4,272.6,309.8,274.4z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M324.3,292.5c0.1,0.6,0.1,1.2-0.1,1.8c-0.6,1.9-2.6,2.9-4.5,2.3l-13.2-4.3c-1.9-0.6-2.9-2.6-2.3-4.5\n                  c0.6-1.9,2.6-2.9,4.5-2.3l13.2,4.3C323.2,290.2,324.1,291.2,324.3,292.5z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M298.9,300.8c0.4,1.8-0.7,3.6-2.5,4.1c-1.9,0.5-3.9-0.6-4.4-2.5l-3.7-13.3c-0.5-1.9,0.6-3.9,2.5-4.4\n                  c1.9-0.5,3.9,0.6,4.4,2.5l3.7,13.3C298.9,300.6,298.9,300.7,298.9,300.8z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M312.6,302.7c0.1,0.4,0.1,0.8,0,1.2c-0.3,2-2.1,3.3-4,3l-13.7-1.9c-2-0.3-3.3-2.1-3-4c0.3-2,2.1-3.3,4-3\n                  l13.7,1.9C311.2,300.1,312.4,301.3,312.6,302.7z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M303,314.8c0,0.2,0.1,0.4,0.1,0.6c0.1,2-1.5,3.6-3.5,3.7l-13.8,0.5c-2,0.1-3.6-1.5-3.7-3.5\n                  c-0.1-2,1.5-3.6,3.5-3.7l13.8-0.5C301.1,311.9,302.6,313.1,303,314.8z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M282,331.3c0.3,1.3-0.2,2.8-1.4,3.6c-1.6,1.2-3.8,0.8-5-0.8l-8.1-11.3c-1.1-1.6-0.8-3.8,0.8-5\n                  c1.6-1.2,3.8-0.8,5,0.8l8.1,11.3C281.7,330.3,281.9,330.8,282,331.3z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M295.5,328.4c0.4,1.9-0.9,3.8-2.8,4.2l-13.6,2.9c-1.9,0.4-3.8-0.8-4.2-2.8c0,0,0,0,0,0\n                  c-0.4-1.9,0.9-3.8,2.8-4.2l13.6-2.9C293.2,325.2,295.1,326.5,295.5,328.4C295.5,328.4,295.5,328.4,295.5,328.4z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M194.2,260.8c1.6,0.7,2.6,2.5,2.1,4.2c-1.5,5.7-2.5,11.5-3,17.4c-2.6,33.1,11.7,64.8,38.2,84.9\n                c1.6,1.2,1.9,3.4,0.7,5c-1.2,1.6-3.4,1.9-5,0.7c-28.5-21.5-43.8-55.6-41-91.2c0.5-6.3,1.6-12.6,3.2-18.7c0.5-1.9,2.5-3,4.4-2.5\n                C194,260.7,194.1,260.7,194.2,260.8z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M182.5,276.2c0.3,0.1,0.6,0.3,0.8,0.5l8.4,6.4c1.6,1.2,1.9,3.5,0.6,5c-1.2,1.6-3.4,1.9-5,0.6l-8.4-6.4\n                  c-1.6-1.2-1.9-3.5-0.6-5C179.3,276,181.1,275.6,182.5,276.2z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M200.1,277.6c0.7,0.3,1.4,0.8,1.8,1.6c0.9,1.7,0.3,3.9-1.4,4.9l-9.2,5.1c-1.7,0.9-3.9,0.3-4.9-1.4\n                  c-0.9-1.7-0.3-3.9,1.4-4.9l9.2-5.1C198,277.2,199.2,277.2,200.1,277.6z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M179.4,293.7c0.1,0,0.2,0.1,0.3,0.1l12.3,6.4c1.8,0.9,2.4,3.1,1.5,4.8c-0.9,1.7-3.1,2.5-4.8,1.5l-12.3-6.4\n                  c-1.8-0.9-2.4-3.1-1.5-4.8C175.8,293.7,177.7,293.1,179.4,293.7z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M202.5,291.5c0.5,0.2,1.1,0.6,1.4,1.1c1.2,1.5,1,3.8-0.6,5l-10.8,8.7c-1.5,1.2-3.8,1-5-0.6\n                  c-1.2-1.5-1-3.8,0.6-5l10.8-8.7C200,291.2,201.3,291,202.5,291.5z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M195.5,317.3c1.7,0.7,2.6,2.6,2.1,4.4c-0.6,1.9-2.6,2.9-4.5,2.3l-13.2-4.2c-1.9-0.6-2.9-2.6-2.3-4.5\n                  c0.6-1.9,2.6-2.9,4.5-2.3l13.2,4.2C195.4,317.2,195.5,317.2,195.5,317.3z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M204.7,306.9c0.4,0.1,0.7,0.4,1,0.6c1.5,1.3,1.6,3.6,0.3,5l-9.1,10.4c-1.3,1.5-3.6,1.6-5,0.3\n                  c-1.5-1.3-1.6-3.6-0.3-5l9.1-10.4C201.7,306.6,203.3,306.3,204.7,306.9z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M202.3,333.4c1.5,0.6,2.4,2.1,2.2,3.8c-0.3,2-2.1,3.3-4,3.1l-13.7-1.8c-2-0.3-3.3-2.1-3.1-4\n                  c0.3-2,2.1-3.3,4-3.1l13.7,1.8C201.8,333.3,202,333.3,202.3,333.4z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M209.5,321.6c0.2,0.1,0.4,0.2,0.5,0.3c1.7,1,2.2,3.2,1.2,4.9l-7.2,11.8c-1,1.7-3.2,2.2-4.9,1.2\n                  c-1.7-1-2.2-3.2-1.2-4.9l7.2-11.8C206,321.5,207.9,321,209.5,321.6z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M211.8,348.2c1.3,0.5,2.2,1.7,2.2,3.2c0.1,2-1.5,3.6-3.4,3.7l-13.8,0.6c-2,0.1-3.6-1.5-3.7-3.4\n                  c-0.1-2,1.5-3.6,3.4-3.7l13.8-0.6C210.8,347.9,211.3,348,211.8,348.2z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M216.8,335.3c1.8,0.7,2.7,2.8,2,4.6l-5,12.9c-0.7,1.8-2.8,2.7-4.6,2c0,0,0,0,0,0c-1.8-0.7-2.7-2.8-2-4.6\n                  l5-12.9C212.9,335.5,214.9,334.5,216.8,335.3C216.8,335.3,216.8,335.3,216.8,335.3z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M64.7,112.4c-7.2,0-14.5-0.8-21.8-2.3c-6.2-1.3-12.3-3.2-18.1-5.6c-1.8-0.8-2.7-2.8-1.9-4.7\n                c0.8-1.8,2.8-2.7,4.7-1.9c5.4,2.2,11.1,4,16.9,5.2c32.5,6.9,65.8-3.1,89.2-26.8c1.4-1.4,3.7-1.4,5.1,0c1.4,1.4,1.4,3.7,0,5.1\n                C118.8,101.5,92.2,112.4,64.7,112.4z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M39.9,118.4c-0.9,0-1.8-0.4-2.5-1.1c-1.4-1.4-1.4-3.7,0-5.1l7.5-7.4c1.4-1.4,3.7-1.4,5.1,0\n                  c1.4,1.4,1.4,3.7,0,5.1l-7.5,7.4C41.7,118,40.8,118.4,39.9,118.4z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M47.3,111c-1.4,0-2.8-0.9-3.3-2.3l-3.8-9.8c-0.7-1.8,0.2-3.9,2-4.6c1.8-0.7,3.9,0.2,4.6,2l3.8,9.8\n                  c0.7,1.8-0.2,3.9-2,4.6C48.2,110.9,47.8,111,47.3,111z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M56.8,123.8c-0.7,0-1.4-0.2-2.1-0.7c-1.6-1.1-2-3.4-0.9-5l8-11.3c1.1-1.6,3.4-2,5-0.9c1.6,1.1,2,3.4,0.9,5\n                  l-8,11.3C59.1,123.2,57.9,123.8,56.8,123.8z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M64.8,112.4c-1.2,0-2.4-0.6-3.1-1.7l-7.2-11.9c-1-1.7-0.5-3.9,1.2-4.9c1.7-1,3.9-0.5,4.9,1.2l7.2,11.9\n                  c1,1.7,0.5,3.9-1.2,4.9C66.1,112.3,65.4,112.4,64.8,112.4z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M76.4,123.4c-0.5,0-1-0.1-1.5-0.3c-1.8-0.8-2.6-3-1.7-4.8l5.9-12.5c0.8-1.8,3-2.6,4.8-1.7\n                  c1.8,0.8,2.6,3,1.7,4.8l-5.9,12.5C79,122.6,77.7,123.4,76.4,123.4z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M82.3,110.9c-1,0-2-0.4-2.7-1.2l-9.1-10.4c-1.3-1.5-1.1-3.7,0.3-5c1.5-1.3,3.7-1.1,5,0.3l9.1,10.4\n                  c1.3,1.5,1.1,3.7-0.3,5C83.9,110.6,83.1,110.9,82.3,110.9z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M95.6,119.6c-0.3,0-0.6,0-0.9-0.1c-1.9-0.5-3-2.5-2.5-4.4l3.6-13.4c0.5-1.9,2.5-3,4.4-2.5\n                  c1.9,0.5,3,2.5,2.5,4.4L99,117C98.6,118.6,97.1,119.6,95.6,119.6z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M99.2,106.3c-0.8,0-1.6-0.3-2.2-0.8l-10.8-8.7c-1.5-1.2-1.8-3.5-0.5-5c1.2-1.5,3.5-1.8,5-0.5l10.8,8.7\n                  c1.5,1.2,1.8,3.5,0.5,5C101.3,105.8,100.2,106.3,99.2,106.3z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M113.8,112.6c-0.1,0-0.2,0-0.3,0c-2-0.2-3.4-1.9-3.2-3.9l1.2-13.8c0.2-2,1.9-3.4,3.9-3.2\n                  c2,0.2,3.4,1.9,3.2,3.9l-1.2,13.8C117.2,111.2,115.6,112.6,113.8,112.6z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M115.1,98.8c-0.6,0-1.2-0.1-1.7-0.4l-12.1-6.7c-1.7-1-2.4-3.1-1.4-4.9c1-1.7,3.1-2.4,4.9-1.4l12.1,6.7\n                  c1.7,1,2.4,3.1,1.4,4.9C117.5,98.1,116.3,98.8,115.1,98.8z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M244.1,102.7c-5.5-4.8-10.5-10.1-14.9-16.1c-3.8-5.1-7.2-10.5-10-16.2c-0.9-1.8-0.2-3.9,1.6-4.8\n                c1.8-0.9,3.9-0.2,4.8,1.6c2.6,5.3,5.7,10.3,9.3,15.1c19.9,26.6,51.6,41,84.8,38.5c2-0.1,3.7,1.3,3.8,3.3c0.1,2-1.3,3.7-3.3,3.8\n                C292.1,130.1,264.9,120.8,244.1,102.7z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M221.5,90.9c-0.7-0.6-1.2-1.5-1.2-2.5c-0.1-2,1.4-3.7,3.3-3.8l10.5-0.7c2-0.1,3.7,1.4,3.8,3.3\n                  c0.1,2-1.4,3.7-3.3,3.8l-10.5,0.7C223.1,91.8,222.2,91.5,221.5,90.9z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M232,90.2c-1.1-0.9-1.5-2.5-1-3.9l3.6-9.9c0.7-1.9,2.7-2.8,4.6-2.1c1.9,0.7,2.8,2.7,2.1,4.6l-3.6,9.9\n                  c-0.7,1.9-2.7,2.8-4.6,2.1C232.7,90.7,232.3,90.5,232,90.2z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M230.7,106.1c-0.5-0.5-0.9-1.1-1.1-1.8c-0.5-1.9,0.7-3.9,2.6-4.3l13.5-3.3c1.9-0.5,3.9,0.7,4.3,2.6\n                  c0.5,1.9-0.7,3.9-2.6,4.3l-13.5,3.3C232.8,107.2,231.6,106.8,230.7,106.1z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M244.2,102.8c-0.9-0.8-1.4-2-1.2-3.3l2.4-13.6c0.3-1.9,2.2-3.2,4.1-2.9c1.9,0.3,3.2,2.2,2.9,4.1l-2.4,13.6\n                  c-0.3,1.9-2.2,3.2-4.1,2.9C245.3,103.5,244.7,103.2,244.2,102.8z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M245.7,118.7c-0.4-0.3-0.7-0.8-0.9-1.3c-0.8-1.8,0-3.9,1.8-4.7l12.7-5.6c1.8-0.8,3.9,0,4.7,1.8\n                  c0.8,1.8,0,3.9-1.8,4.7l-12.7,5.6C248.2,119.8,246.7,119.6,245.7,118.7z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M258.4,113.1c-0.8-0.7-1.2-1.6-1.2-2.7l0-13.9c0-2,1.6-3.6,3.6-3.6c2,0,3.6,1.6,3.6,3.6l0,13.9\n                  c0,2-1.6,3.6-3.6,3.6C259.8,114,259,113.7,258.4,113.1z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M262.6,128.5c-0.2-0.2-0.4-0.4-0.6-0.7c-1.1-1.6-0.7-3.9,1-5l11.5-7.7c1.6-1.1,3.9-0.7,5,1\n                  c1.1,1.6,0.7,3.9-1,5l-11.5,7.7C265.6,129.7,263.8,129.5,262.6,128.5z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M274.1,120.8c-0.6-0.5-1-1.2-1.2-2.1l-2.4-13.6c-0.3-1.9,1-3.8,2.9-4.1c1.9-0.3,3.8,1,4.1,2.9l2.4,13.6\n                  c0.3,1.9-1,3.8-2.9,4.1C276,121.8,274.9,121.5,274.1,120.8z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M281,135.2c-0.1-0.1-0.2-0.1-0.2-0.2c-1.4-1.4-1.3-3.7,0.1-5.1l10-9.6c1.4-1.4,3.7-1.3,5.1,0.1\n                  c1.4,1.4,1.3,3.7-0.1,5.1l-10,9.6C284.5,136.4,282.4,136.4,281,135.2z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M291,125.6c-0.4-0.4-0.8-0.9-1-1.5l-4.7-13c-0.7-1.9,0.3-3.9,2.1-4.6c1.9-0.7,3.9,0.3,4.6,2.1l4.7,13\n                  c0.7,1.9-0.3,3.9-2.1,4.6C293.3,126.7,292,126.4,291,125.6z"
  }))), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M119.4,171.5c-0.4,0-0.8,0-1.2,0c-2,0-3.6-1.6-3.5-3.6c0-2,1.6-3.5,3.6-3.5c0,0,0,0,0,0\n                c5.8,0.1,11.8-0.4,17.6-1.4c32.7-5.6,60-27.3,72.9-57.9c0.8-1.8,2.9-2.7,4.7-1.9c1.8,0.8,2.7,2.9,1.9,4.7\n                c-13.9,32.9-43.2,56.1-78.3,62.2C131.3,171,125.3,171.5,119.4,171.5z"
  }), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M136.1,179.1c-0.5,0-1-0.1-1.4-0.3c-1.8-0.8-2.6-2.9-1.9-4.7l4.2-9.7c0.8-1.8,2.9-2.6,4.7-1.9\n                  c1.8,0.8,2.6,2.9,1.9,4.7l-4.2,9.7C138.8,178.3,137.5,179.1,136.1,179.1z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M140.3,169.4c-1,0-1.9-0.4-2.6-1.1l-7.2-7.7c-1.3-1.4-1.3-3.7,0.2-5.1c1.4-1.3,3.7-1.3,5.1,0.2l7.2,7.7\n                  c1.3,1.4,1.3,3.7-0.2,5.1C142.1,169.1,141.2,169.4,140.3,169.4z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M153.9,177.8c-0.3,0-0.6,0-0.8-0.1c-1.9-0.5-3.1-2.4-2.6-4.3l3.2-13.5c0.5-1.9,2.4-3.1,4.3-2.6\n                  c1.9,0.5,3.1,2.4,2.6,4.3l-3.2,13.5C157,176.7,155.5,177.8,153.9,177.8z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M157.1,164.3c-0.8,0-1.5-0.2-2.2-0.7l-11.1-8.4c-1.6-1.2-1.9-3.4-0.7-5c1.2-1.6,3.4-1.9,5-0.7l11.1,8.4\n                  c1.6,1.2,1.9,3.4,0.7,5C159.2,163.8,158.2,164.3,157.1,164.3z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M171.9,170.2c-0.1,0-0.1,0-0.2,0c-2-0.1-3.5-1.8-3.4-3.8l0.8-13.8c0.1-2,1.8-3.5,3.8-3.4\n                  c2,0.1,3.5,1.8,3.4,3.8l-0.8,13.8C175.3,168.7,173.8,170.2,171.9,170.2z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M173.4,156.4c-0.5,0-1.1-0.1-1.6-0.4l-12.3-6.3c-1.8-0.9-2.5-3.1-1.6-4.8c0.9-1.8,3.1-2.5,4.8-1.6\n                  l12.3,6.3c1.8,0.9,2.5,3.1,1.6,4.8C176,155.6,174.7,156.4,173.4,156.4z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M188.3,159.6c-1.8,0-3.3-1.3-3.5-3.2l-1.6-13.8c-0.2-2,1.2-3.7,3.1-4c2-0.2,3.7,1.2,4,3.1l1.6,13.8\n                  c0.2,2-1.2,3.7-3.1,4C188.6,159.6,188.5,159.6,188.3,159.6z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M186.7,145.8c-0.3,0-0.7-0.1-1.1-0.2l-13.2-4.1c-1.9-0.6-2.9-2.6-2.4-4.5c0.6-1.9,2.6-2.9,4.5-2.4\n                  l13.2,4.1c1.9,0.6,2.9,2.6,2.4,4.5C189.7,144.8,188.3,145.8,186.7,145.8z"
  })), React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M202.7,146.3c-1.5,0-3-1-3.4-2.6l-4-13.3c-0.6-1.9,0.5-3.9,2.4-4.4c1.9-0.6,3.9,0.5,4.4,2.4l4,13.3\n                  c0.6,1.9-0.5,3.9-2.4,4.4C203.3,146.3,203,146.3,202.7,146.3z"
  }), React$2.createElement("path", {
    className: localStyles$3.st2,
    d: "M198.7,133c-0.1,0-0.3,0-0.4,0l-13.7-1.7c-2-0.2-3.4-2-3.1-4c0.2-2,2-3.3,4-3.1l13.7,1.7\n                  c2,0.2,3.4,2,3.1,4C202,131.7,200.5,133,198.7,133z"
  }))), React$2.createElement("circle", {
    className: localStyles$3.st3,
    cx: "20.7",
    cy: "206.6",
    r: "7.9"
  }), React$2.createElement("circle", {
    className: localStyles$3.st3,
    cx: "28",
    cy: "299.8",
    r: "7.9"
  }), React$2.createElement("circle", {
    className: localStyles$3.st3,
    cx: "4.4",
    cy: "278.6",
    r: "7.9"
  }), React$2.createElement("circle", {
    className: localStyles$3.st3,
    cx: "176.9",
    cy: "244.2",
    r: "7.9"
  }), React$2.createElement("circle", {
    className: localStyles$3.st3,
    cx: "311",
    cy: "247.6",
    r: "7.9"
  }), React$2.createElement("circle", {
    className: localStyles$3.st3,
    cx: "273.8",
    cy: "78.5",
    r: "7.9"
  }), React$2.createElement("circle", {
    className: localStyles$3.st3,
    cx: "73.7",
    cy: "228.4",
    r: "7.9"
  }), React$2.createElement("circle", {
    className: localStyles$3.st3,
    cx: "72.4",
    cy: "145.6",
    r: "7.9"
  }), React$2.createElement("circle", {
    className: localStyles$3.st3,
    cx: "90.9",
    cy: "161.9",
    r: "7.9"
  }), React$2.createElement("circle", {
    className: localStyles$3.st3,
    cx: "49.8",
    cy: "78.2",
    r: "7.9"
  }), React$2.createElement("circle", {
    className: localStyles$3.st3,
    cx: "-38.1",
    cy: "133",
    r: "7.9"
  })), React$2.createElement("line", {
    className: localStyles$3.clipLine,
    x1: "158.6",
    y1: "77.8",
    x2: "158.6",
    y2: "301.5"
  }))), React$2.createElement("line", {
    className: styles$m.string,
    x1: "236.34",
    y1: "88.37",
    x2: "236.34",
    y2: "421.64"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.leftBow),
    d: "M163.83,36.51c7.72,9.03,72.64,51.86,72.64,51.86,0,0-32.19-70.79-39.92-79.83-7.73-9.04-21.31-10.11-30.34-2.38-9.04,7.72-10.1,21.31-2.38,30.34Z"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.rightBow),
    d: "M308.6,68.86c-8.7,4.83-72.13,19.5-72.13,19.5,0,0,45.92-46.16,54.61-51,8.7-4.83,19.67-1.7,24.51,6.99,4.83,8.7,1.71,19.67-6.99,24.51Z"
  }), React$2.createElement("g", {
    className: styles$m.label
  }, React$2.createElement("path", {
    className: localStyles$3.tag,
    d: "M383.34,219l-53.87,38.04c-3.58,2.53-8.53,1.68-11.06-1.91l-66.64-94.4c-1.08-1.54-1.59-3.4-1.42-5.27l3.73-42.66c.8-9.18,9.67-15.43,18.58-13.12l41.45,10.76c1.82,.47,3.41,1.57,4.49,3.1l66.64,94.4c2.53,3.58,1.68,8.53-1.91,11.06m-107.68-108.42c-2.4-3.4-7.1-4.21-10.5-1.81-3.4,2.4-4.21,7.1-1.81,10.5,2.4,3.4,7.1,4.21,10.5,1.81,3.4-2.4,4.21-7.1,1.81-10.5"
  }), React$2.createElement("path", {
    className: localStyles$3.tagIcon,
    transform: "scale(1.49 1.34)",
    d: "M194.8,138.1l5.3-3.7c0.7-0.5,1.7-0.2,2.2,0.7l10.9,17.1c0.5,0.9,1.7,0.5,1.5-0.5c-1-4.6-1.3-11.1,3.6-14.5\n        \t\tc5.8-4,11.1-2.2,20.2,11l7.5,10.8c0.5,0.8,0.5,1.8-0.2,2.2l-4.8,3.3c-0.7,0.5-1.6,0.2-2.2-0.6l-5.1-7.4c-5.5-8-8.8-9.5-12.6-6.9\n        \t\tc-3.9,2.7-2.8,9.9,2.6,17.7l3.3,4.8c0.5,0.8,0.5,1.8-0.2,2.2l-4.8,3.3c-0.7,0.5-1.6,0.2-2.2-0.6l-25.4-36.7\n        \t\tC194.1,139.6,194.2,138.6,194.8,138.1"
  })), React$2.createElement("path", {
    className: styles$m.string,
    d: "M266.39,112.37s-10.45-24.21-30.05-24"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.ends),
    d: "M179.11,250.06c-3.62-10.66-10.05-27.22-2.8-43.73,10.47-23.86,25.88-16.69,36.35-40.54,10.47-23.85-1.93-29.92,5.53-54.87,3.88-12.97,11.92-17.51,18.03-22.76,0,0-28.44-2.12-42.93,24.22-14.49,26.34,.59,47.8-34.61,60.58"
  })));
};
var localStyles$2 = {
  "stripe1": "default-wrapping-module_stripe1__VxQzA",
  "stripe2": "default-wrapping-module_stripe2__-Hiix",
  "stripe3": "default-wrapping-module_stripe3__bN3mM",
  "tag": "default-wrapping-module_tag__lQs0g",
  "tagIcon": "default-wrapping-module_tagIcon__jHtDX"
};
var DefaultWrapping = function DefaultWrapping() {
  return React$2.createElement("svg", {
    "data-testid": "gift",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -14 476.81 435.64"
  }, React$2.createElement("g", null, React$2.createElement("g", null, React$2.createElement("path", {
    className: localStyles$2.stripe3,
    d: "M390.43,382.8c-25.35,0-25.35-21.52-50.71-21.52s-25.35,21.52-50.69,21.52-25.34-21.52-50.68-21.52-25.34,21.52-50.68,21.52-25.35-21.52-50.69-21.52-25.35,21.52-50.69,21.52-25.35-21.52-50.7-21.52c-16.17,0-22.07,8.73-30.8,15.05L.18,404.63c-1.37,8.41,5.12,16.05,13.64,16.05H462.98c8.52,0,15.01-7.64,13.64-16.05l-4.6-28.25c-8.78-6.33-14.67-15.1-30.9-15.1-25.35,0-25.35,21.52-50.69,21.52Z"
  }), React$2.createElement("path", {
    className: localStyles$2.stripe2,
    d: "M390.43,323.4c-25.35,0-25.35-21.52-50.71-21.52s-25.35,21.52-50.69,21.52-25.34-21.52-50.68-21.52-25.34,21.52-50.68,21.52-25.35-21.52-50.69-21.52-25.35,21.52-50.69,21.52-25.35-21.52-50.7-21.52c-8.99,0-14.79,2.71-19.68,6.19l-11.12,68.25c8.73-6.32,14.63-15.05,30.8-15.05,25.35,0,25.35,21.52,50.7,21.52s25.34-21.52,50.69-21.52,25.35,21.52,50.69,21.52,25.34-21.52,50.68-21.52,25.34,21.52,50.68,21.52,25.35-21.52,50.69-21.52,25.36,21.52,50.71,21.52,25.35-21.52,50.69-21.52c16.24,0,22.13,8.77,30.9,15.1l-11.12-68.25c-4.91-3.51-10.73-6.25-19.78-6.25-25.35,0-25.35,21.52-50.69,21.52Z"
  }), React$2.createElement("path", {
    className: localStyles$2.stripe1,
    d: "M136.98,123.71c25.35,0,25.35,21.52,50.69,21.52s25.34-21.52,50.68-21.52,25.34,21.52,50.68,21.52,25.35-21.52,50.69-21.52,25.36,21.52,50.71,21.52c21.44,0,24.8-15.35,40.65-20.1l-3.94-24.19c-1.09-6.69-6.87-11.6-13.64-11.6H63.32c-6.78,0-12.55,4.91-13.64,11.6l-3.95,24.22c15.78,4.77,19.16,20.07,40.56,20.07,25.34,0,25.34-21.52,50.69-21.52Z"
  }), React$2.createElement("path", {
    className: localStyles$2.stripe1,
    d: "M390.43,264.01c-25.35,0-25.35-21.52-50.71-21.52s-25.35,21.52-50.69,21.52-25.34-21.52-50.68-21.52-25.34,21.52-50.68,21.52-25.35-21.52-50.69-21.52-25.35,21.52-50.69,21.52-25.35-21.52-50.7-21.52c-3.51,0-6.5,.45-9.18,1.16l-10.5,64.43c4.89-3.48,10.69-6.19,19.68-6.19,25.35,0,25.35,21.52,50.7,21.52s25.34-21.52,50.69-21.52,25.35,21.52,50.69,21.52,25.34-21.52,50.68-21.52,25.34,21.52,50.68,21.52,25.35-21.52,50.69-21.52,25.36,21.52,50.71,21.52,25.35-21.52,50.69-21.52c9.05,0,14.87,2.74,19.78,6.25l-10.5-64.46c-2.7-.73-5.72-1.18-9.28-1.18-25.35,0-25.35,21.52-50.69,21.52Z"
  }), React$2.createElement("path", {
    className: localStyles$2.stripe3,
    d: "M339.72,183.1c-25.35,0-25.35,21.52-50.69,21.52s-25.34-21.52-50.68-21.52-25.34,21.52-50.68,21.52-25.35-21.52-50.69-21.52-25.35,21.52-50.69,21.52-25.38-21.07-50.01-21.48l-9.86,60.51c2.68-.71,5.66-1.16,9.18-1.16,25.35,0,25.35,21.52,50.7,21.52s25.34-21.52,50.69-21.52,25.35,21.52,50.69,21.52,25.34-21.52,50.68-21.52,25.34,21.52,50.68,21.52,25.35-21.52,50.69-21.52,25.36,21.52,50.71,21.52,25.35-21.52,50.69-21.52c3.56,0,6.57,.46,9.28,1.18l-9.87-60.55c-24.72,.35-24.96,21.48-50.1,21.48s-25.35-21.52-50.71-21.52Z"
  }), React$2.createElement("path", {
    className: localStyles$2.stripe2,
    d: "M390.43,145.22c-25.35,0-25.35-21.52-50.71-21.52s-25.35,21.52-50.69,21.52-25.34-21.52-50.68-21.52-25.34,21.52-50.68,21.52-25.35-21.52-50.69-21.52-25.35,21.52-50.69,21.52c-21.4,0-24.79-15.3-40.56-20.07l-9.45,57.99c24.63,.4,24.91,21.48,50.01,21.48s25.34-21.52,50.69-21.52,25.35,21.52,50.69,21.52,25.34-21.52,50.68-21.52,25.34,21.52,50.68,21.52,25.35-21.52,50.69-21.52,25.36,21.52,50.71,21.52,25.38-21.13,50.1-21.48l-9.45-58.01c-15.85,4.74-19.21,20.1-40.65,20.1Z"
  })), React$2.createElement("line", {
    className: styles$m.string,
    x1: "236.34",
    y1: "88.37",
    x2: "236.34",
    y2: "421.64"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.leftBow),
    d: "M163.83,36.51c7.72,9.03,72.64,51.86,72.64,51.86,0,0-32.19-70.79-39.92-79.83-7.73-9.04-21.31-10.11-30.34-2.38-9.04,7.72-10.1,21.31-2.38,30.34Z"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.rightBow),
    d: "M308.6,68.86c-8.7,4.83-72.13,19.5-72.13,19.5,0,0,45.92-46.16,54.61-51,8.7-4.83,19.67-1.7,24.51,6.99,4.83,8.7,1.71,19.67-6.99,24.51Z"
  }), React$2.createElement("g", {
    className: styles$m.label
  }, React$2.createElement("path", {
    className: localStyles$2.tag,
    d: "M383.34,219l-53.87,38.04c-3.58,2.53-8.53,1.68-11.06-1.91l-66.64-94.4c-1.08-1.54-1.59-3.4-1.42-5.27l3.73-42.66c.8-9.18,9.67-15.43,18.58-13.12l41.45,10.76c1.82,.47,3.41,1.57,4.49,3.1l66.64,94.4c2.53,3.58,1.68,8.53-1.91,11.06m-107.68-108.42c-2.4-3.4-7.1-4.21-10.5-1.81-3.4,2.4-4.21,7.1-1.81,10.5,2.4,3.4,7.1,4.21,10.5,1.81,3.4-2.4,4.21-7.1,1.81-10.5"
  }), React$2.createElement("path", {
    className: localStyles$2.tagIcon,
    transform: "scale(1.49 1.34)",
    d: "M194.8,138.1l5.3-3.7c0.7-0.5,1.7-0.2,2.2,0.7l10.9,17.1c0.5,0.9,1.7,0.5,1.5-0.5c-1-4.6-1.3-11.1,3.6-14.5\n            c5.8-4,11.1-2.2,20.2,11l7.5,10.8c0.5,0.8,0.5,1.8-0.2,2.2l-4.8,3.3c-0.7,0.5-1.6,0.2-2.2-0.6l-5.1-7.4c-5.5-8-8.8-9.5-12.6-6.9\n            c-3.9,2.7-2.8,9.9,2.6,17.7l3.3,4.8c0.5,0.8,0.5,1.8-0.2,2.2l-4.8,3.3c-0.7,0.5-1.6,0.2-2.2-0.6l-25.4-36.7\n            C194.1,139.6,194.2,138.6,194.8,138.1"
  })), React$2.createElement("path", {
    className: styles$m.string,
    d: "M266.39,112.37s-10.45-24.21-30.05-24"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.ends),
    d: "M179.11,250.06c-3.62-10.66-10.05-27.22-2.8-43.73,10.47-23.86,25.88-16.69,36.35-40.54,10.47-23.85-1.93-29.92,5.53-54.87,3.88-12.97,11.92-17.51,18.03-22.76,0,0-28.44-2.12-42.93,24.22-14.49,26.34,.59,47.8-34.61,60.58"
  })));
};
var localStyles$1 = {
  "darkStripe": "red-stripes-wrapping-module_darkStripe__tHeD4",
  "lightStripe": "red-stripes-wrapping-module_lightStripe__b3s1m",
  "tagIcon": "red-stripes-wrapping-module_tagIcon__C9KtJ",
  "tag": "red-stripes-wrapping-module_tag__cKldQ"
};
var RedStripes = function RedStripes() {
  return React$2.createElement("svg", {
    "data-testid": "gift",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -14 476.81 435.64"
  }, React$2.createElement("g", null, React$2.createElement("g", {
    transform: "translate(0 -27) scale(1.49)"
  }, React$2.createElement("path", {
    className: localStyles$1.darkStripe,
    d: "M262,275.1c-17,0-17-14.4-34-14.4c-17,0-17,14.4-34,14.4c-17,0-17-14.4-34-14.4c-17,0-17,14.4-34,14.4\n            c-17,0-17-14.4-34-14.4s-17,14.4-34,14.4c-17,0-17-14.4-34-14.4c-10.9,0-14.8,5.9-20.7,10.1l-3.1,19c-0.9,5.6,3.4,10.8,9.2,10.8\n            h301.4c5.7,0,10.1-5.1,9.2-10.8l-3.1-19c-5.9-4.2-9.8-10.1-20.7-10.1C279,260.6,279,275.1,262,275.1"
  }), React$2.createElement("path", {
    className: localStyles$1.lightStripe,
    d: "M262,235.2c-17,0-17-14.4-34-14.4c-17,0-17,14.4-34,14.4c-17,0-17-14.4-34-14.4c-17,0-17,14.4-34,14.4\n            c-17,0-17-14.4-34-14.4s-17,14.4-34,14.4c-17,0-17-14.4-34-14.4c-6,0-9.9,1.8-13.2,4.2l-7.5,45.8c5.9-4.2,9.8-10.1,20.7-10.1\n            c17,0,17,14.4,34,14.4c17,0,17-14.4,34-14.4s17,14.4,34,14.4c17,0,17-14.4,34-14.4c17,0,17,14.4,34,14.4c17,0,17-14.4,34-14.4\n            c17,0,17,14.4,34,14.4c17,0,17-14.4,34-14.4c10.9,0,14.9,5.9,20.7,10.1l-7.5-45.8c-3.3-2.4-7.2-4.2-13.3-4.2\n            C279,220.8,279,235.2,262,235.2"
  }), React$2.createElement("path", {
    className: localStyles$1.lightStripe,
    d: "M91.9,101.2c17,0,17,14.4,34,14.4s17-14.4,34-14.4c17,0,17,14.4,34,14.4c17,0,17-14.4,34-14.4\n            c17,0,17,14.4,34,14.4c14.4,0,16.6-10.3,27.3-13.5l-2.6-16.2c-0.7-4.5-4.6-7.8-9.2-7.8h-235c-4.5,0-8.4,3.3-9.2,7.8l-2.6,16.3\n            c10.6,3.2,12.9,13.5,27.2,13.5C74.9,115.6,74.9,101.2,91.9,101.2"
  }), React$2.createElement("path", {
    className: localStyles$1.darkStripe,
    d: "M262,195.4c-17,0-17-14.4-34-14.4c-17,0-17,14.4-34,14.4c-17,0-17-14.4-34-14.4c-17,0-17,14.4-34,14.4\n            c-17,0-17-14.4-34-14.4s-17,14.4-34,14.4c-17,0-17-14.4-34-14.4c-2.4,0-4.4,0.3-6.2,0.8l-7,43.2c3.3-2.3,7.2-4.2,13.2-4.2\n            c17,0,17,14.4,34,14.4c17,0,17-14.4,34-14.4s17,14.4,34,14.4c17,0,17-14.4,34-14.4c17,0,17,14.4,34,14.4c17,0,17-14.4,34-14.4\n            c17,0,17,14.4,34,14.4c17,0,17-14.4,34-14.4c6.1,0,10,1.8,13.3,4.2l-7-43.3c-1.8-0.5-3.8-0.8-6.2-0.8\n            C279,180.9,279,195.4,262,195.4"
  }), React$2.createElement("path", {
    className: localStyles$1.lightStripe,
    d: "M228,141.1c-17,0-17,14.4-34,14.4s-17-14.4-34-14.4c-17,0-17,14.4-34,14.4c-17,0-17-14.4-34-14.4\n            c-17,0-17,14.4-34,14.4c-16.9,0-17-14.1-33.6-14.4l-6.6,40.6c1.8-0.5,3.8-0.8,6.2-0.8c17,0,17,14.4,34,14.4c17,0,17-14.4,34-14.4\n            c17,0,17,14.4,34,14.4c17,0,17-14.4,34-14.4c17,0,17,14.4,34,14.4s17-14.4,34-14.4c17,0,17,14.4,34,14.4c17,0,17-14.4,34-14.4\n            c2.4,0,4.4,0.3,6.2,0.8l-6.6-40.6c-16.6,0.2-16.8,14.4-33.6,14.4C245,155.5,245,141.1,228,141.1"
  }), React$2.createElement("path", {
    className: localStyles$1.darkStripe,
    d: "M262,115.6c-17,0-17-14.4-34-14.4c-17,0-17,14.4-34,14.4c-17,0-17-14.4-34-14.4c-17,0-17,14.4-34,14.4\n            c-17,0-17-14.4-34-14.4s-17,14.4-34,14.4c-14.4,0-16.6-10.3-27.2-13.5l-6.3,38.9c16.5,0.3,16.7,14.4,33.6,14.4\n            c17,0,17-14.4,34-14.4s17,14.4,34,14.4c17,0,17-14.4,34-14.4c17,0,17,14.4,34,14.4c17,0,17-14.4,34-14.4c17,0,17,14.4,34,14.4\n            c16.9,0,17-14.2,33.6-14.4l-6.3-38.9C278.7,105.3,276.4,115.6,262,115.6"
  })), React$2.createElement("line", {
    className: styles$m.string,
    x1: "236.34",
    y1: "88.37",
    x2: "236.34",
    y2: "421.64"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.leftBow),
    d: "M163.83,36.51c7.72,9.03,72.64,51.86,72.64,51.86,0,0-32.19-70.79-39.92-79.83-7.73-9.04-21.31-10.11-30.34-2.38-9.04,7.72-10.1,21.31-2.38,30.34Z"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.rightBow),
    d: "M308.6,68.86c-8.7,4.83-72.13,19.5-72.13,19.5,0,0,45.92-46.16,54.61-51,8.7-4.83,19.67-1.7,24.51,6.99,4.83,8.7,1.71,19.67-6.99,24.51Z"
  }), React$2.createElement("g", {
    className: styles$m.label
  }, React$2.createElement("path", {
    className: localStyles$1.tag,
    d: "M383.34,219l-53.87,38.04c-3.58,2.53-8.53,1.68-11.06-1.91l-66.64-94.4c-1.08-1.54-1.59-3.4-1.42-5.27l3.73-42.66c.8-9.18,9.67-15.43,18.58-13.12l41.45,10.76c1.82,.47,3.41,1.57,4.49,3.1l66.64,94.4c2.53,3.58,1.68,8.53-1.91,11.06m-107.68-108.42c-2.4-3.4-7.1-4.21-10.5-1.81-3.4,2.4-4.21,7.1-1.81,10.5,2.4,3.4,7.1,4.21,10.5,1.81,3.4-2.4,4.21-7.1,1.81-10.5"
  }), React$2.createElement("path", {
    className: localStyles$1.tagIcon,
    transform: "scale(1.49 1.34)",
    d: "M194.8,138.1l5.3-3.7c0.7-0.5,1.7-0.2,2.2,0.7l10.9,17.1c0.5,0.9,1.7,0.5,1.5-0.5c-1-4.6-1.3-11.1,3.6-14.5\n        \t\tc5.8-4,11.1-2.2,20.2,11l7.5,10.8c0.5,0.8,0.5,1.8-0.2,2.2l-4.8,3.3c-0.7,0.5-1.6,0.2-2.2-0.6l-5.1-7.4c-5.5-8-8.8-9.5-12.6-6.9\n        \t\tc-3.9,2.7-2.8,9.9,2.6,17.7l3.3,4.8c0.5,0.8,0.5,1.8-0.2,2.2l-4.8,3.3c-0.7,0.5-1.6,0.2-2.2-0.6l-25.4-36.7\n        \t\tC194.1,139.6,194.2,138.6,194.8,138.1"
  })), React$2.createElement("path", {
    className: styles$m.string,
    d: "M266.39,112.37s-10.45-24.21-30.05-24"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.ends),
    d: "M179.11,250.06c-3.62-10.66-10.05-27.22-2.8-43.73,10.47-23.86,25.88-16.69,36.35-40.54,10.47-23.85-1.93-29.92,5.53-54.87,3.88-12.97,11.92-17.51,18.03-22.76,0,0-28.44-2.12-42.93,24.22-14.49,26.34,.59,47.8-34.61,60.58"
  })));
};
var localStyles = {
  "tagIcon": "snow-wrapping-module_tagIcon__S-zRu",
  "tag": "snow-wrapping-module_tag__5Sluw",
  "st0": "snow-wrapping-module_st0__DXsOj",
  "clip": "snow-wrapping-module_clip__CLYXU",
  "st1": "snow-wrapping-module_st1__-mF7J",
  "visible": "snow-wrapping-module_visible__aKtQP"
};
var Snow = function Snow() {
  return React$2.createElement("svg", {
    "data-testid": "gift",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -14 476.81 435.64"
  }, React$2.createElement("g", null, React$2.createElement("g", {
    transform: "translate(0 -27) scale(1.49)"
  }, React$2.createElement("path", {
    className: localStyles.st0,
    d: "M319.9,289.7L286.7,85.9c-0.7-4.5-4.6-7.8-9.2-7.8h-235c-4.5,0-8.4,3.3-9.2,7.8L0.1,289.7\n            c-0.9,5.6,3.4,10.8,9.2,10.8h301.4C316.4,300.5,320.8,295.4,319.9,289.7z"
  }), React$2.createElement("circle", {
    className: localStyles.st1,
    cx: "247.6",
    cy: "177.8",
    r: "8.8"
  }), React$2.createElement("path", {
    className: localStyles.st1,
    d: "M73.1,247.5c1.2,0.9,2.9,0.7,3.7-0.5l6.9-9.1c0.4-0.6,1.1-0.9,1.8-1l2.5-0.3c7.8-1.1,13.8,6.8,10.8,14l-1,2.4\n            c-0.3,0.7-0.8,1.2-1.4,1.5L86,258.8c-1.4,0.6-2,2.1-1.4,3.5l1.6,3.8c0.6,1.4,2.1,2,3.5,1.4l6.5-2.7c1.4-0.6,2.9,0.1,3.5,1.4\n            l2.7,6.5c0.6,1.4,2.1,2,3.5,1.4l3.8-1.6c1.4-0.6,2-2.1,1.4-3.5l-4.4-10.6c-0.3-0.7-0.3-1.4,0-2l1-2.4c3-7.3,12.8-8.6,17.6-2.4\n            l1.6,2c0.4,0.6,0.6,1.3,0.5,2l-1.5,11.3c-0.2,1.5,0.8,2.8,2.3,3l4.1,0.5c1.5,0.2,2.8-0.8,3-2.3l0.9-7c0.2-1.5,1.5-2.5,3-2.3l7,0.9\n            c1.5,0.2,2.8-0.8,3-2.3l0.5-4.1c0.2-1.5-0.8-2.8-2.3-3l-11.3-1.5c-0.7-0.1-1.3-0.5-1.8-1l-1.6-2c-4.8-6.2-1.1-15.4,6.7-16.4\n            l2.5-0.3c0.7-0.1,1.4,0.1,2,0.5l9.1,6.9c1.2,0.9,2.9,0.7,3.7-0.5l2.5-3.3c0.9-1.2,0.7-2.9-0.5-3.7l-5.6-4.3\n            c-1.2-0.9-1.4-2.6-0.5-3.7l4.3-5.6c0.9-1.2,0.7-2.9-0.5-3.7l-3.3-2.5c-1.2-0.9-2.9-0.7-3.7,0.5l-6.9,9.1c-0.4,0.6-1.1,0.9-1.8,1\n            l-2.5,0.3c-7.8,1.1-13.8-6.8-10.8-14l1-2.4c0.3-0.7,0.8-1.2,1.4-1.5l10.6-4.4c1.4-0.6,2-2.1,1.4-3.5l-1.6-3.8\n            c-0.6-1.4-2.1-2-3.5-1.4l-6.5,2.7c-1.4,0.6-2.9-0.1-3.5-1.4L124,184c-0.6-1.4-2.1-2-3.5-1.4l-3.8,1.6c-1.4,0.6-2,2.1-1.4,3.5\n            l4.4,10.6c0.3,0.7,0.3,1.4,0,2l-1,2.4c-3,7.3-12.8,8.6-17.6,2.4l-1.6-2c-0.4-0.6-0.6-1.3-0.5-2l1.5-11.3c0.2-1.5-0.8-2.8-2.3-3\n            l-4.1-0.5c-1.5-0.2-2.8,0.8-3,2.3l-0.9,7c-0.2,1.5-1.5,2.5-3,2.3l-7-0.9c-1.5-0.2-2.8,0.8-3,2.3l-0.5,4.1c-0.2,1.5,0.8,2.8,2.3,3\n            l11.3,1.5c0.7,0.1,1.3,0.5,1.8,1l1.6,2c4.8,6.2,1.1,15.4-6.7,16.4l-2.5,0.3c-0.7,0.1-1.4-0.1-2-0.5l-9.1-6.9\n            c-1.2-0.9-2.9-0.7-3.7,0.5l-2.5,3.3c-0.9,1.2-0.7,2.9,0.5,3.7l5.6,4.3c1.2,0.9,1.4,2.6,0.5,3.7l-4.3,5.6c-0.9,1.2-0.7,2.9,0.5,3.7\n            L73.1,247.5z"
  }), React$2.createElement("path", {
    className: localStyles.st1,
    d: "M146,169.5c1.2,0.9,2.9,0.7,3.7-0.5l6.9-9.1c0.4-0.6,1.1-0.9,1.8-1l2.5-0.3c7.8-1.1,13.8,6.8,10.8,14l-1,2.4\n            c-0.3,0.7-0.8,1.2-1.4,1.5l-10.6,4.4c-1.4,0.6-2,2.1-1.4,3.5l1.6,3.8c0.6,1.4,2.1,2,3.5,1.4l6.5-2.7c1.4-0.6,2.9,0.1,3.5,1.4\n            l2.7,6.5c0.6,1.4,2.1,2,3.5,1.4l3.8-1.6c1.4-0.6,2-2.1,1.4-3.5l-4.4-10.6c-0.3-0.7-0.3-1.4,0-2l1-2.4c3-7.3,12.8-8.6,17.6-2.4\n            l1.6,2c0.4,0.6,0.6,1.3,0.5,2l-1.5,11.3c-0.2,1.5,0.8,2.8,2.3,3l4.1,0.5c1.5,0.2,2.8-0.8,3-2.3l0.9-7c0.2-1.5,1.5-2.5,3-2.3l7,0.9\n            c1.5,0.2,2.8-0.8,3-2.3l0.5-4.1c0.2-1.5-0.8-2.8-2.3-3l-11.3-1.5c-0.7-0.1-1.3-0.5-1.8-1l-1.6-2c-4.8-6.2-1.1-15.4,6.7-16.4\n            l2.5-0.3c0.7-0.1,1.4,0.1,2,0.5l9.1,6.9c1.2,0.9,2.9,0.7,3.7-0.5l2.5-3.3c0.9-1.2,0.7-2.9-0.5-3.7l-5.6-4.3\n            c-1.2-0.9-1.4-2.6-0.5-3.7l4.3-5.6c0.9-1.2,0.7-2.9-0.5-3.7l-3.3-2.5c-1.2-0.9-2.9-0.7-3.7,0.5l-6.9,9.1c-0.4,0.6-1.1,0.9-1.8,1\n            l-2.5,0.3c-7.8,1.1-13.8-6.8-10.8-14l1-2.4c0.3-0.7,0.8-1.2,1.4-1.5l10.6-4.4c1.4-0.6,2-2.1,1.4-3.5l-1.6-3.8\n            c-0.6-1.4-2.1-2-3.5-1.4l-6.5,2.7c-1.4,0.6-2.9-0.1-3.5-1.4l-2.7-6.5c-0.6-1.4-2.1-2-3.5-1.4l-3.8,1.6c-1.4,0.6-2,2.1-1.4,3.5\n            l4.4,10.6c0.3,0.7,0.3,1.4,0,2l-1,2.4c-3,7.3-12.8,8.6-17.6,2.4l-1.6-2c-0.4-0.6-0.6-1.3-0.5-2l1.5-11.3c0.2-1.5-0.8-2.8-2.3-3\n            l-4.1-0.5c-1.5-0.2-2.8,0.8-3,2.3l-0.9,7c-0.2,1.5-1.5,2.5-3,2.3l-7-0.9c-1.5-0.2-2.8,0.8-3,2.3l-0.5,4.1c-0.2,1.5,0.8,2.8,2.3,3\n            l11.3,1.5c0.7,0.1,1.3,0.5,1.8,1l1.6,2c4.8,6.2,1.1,15.4-6.7,16.4l-2.5,0.3c-0.7,0.1-1.4-0.1-2-0.5l-9.1-6.9\n            c-1.2-0.9-2.9-0.7-3.7,0.5l-2.5,3.3c-0.9,1.2-0.7,2.9,0.5,3.7l5.6,4.3c1.2,0.9,1.4,2.6,0.5,3.7l-4.3,5.6c-0.9,1.2-0.7,2.9,0.5,3.7\n            L146,169.5z"
  }), React$2.createElement("circle", {
    className: localStyles.st1,
    cx: "189.7",
    cy: "229.6",
    r: "8.8"
  }), React$2.createElement("circle", {
    className: localStyles.st1,
    cx: "35.2",
    cy: "216.9",
    r: "8.8"
  }), React$2.createElement("g", null, React$2.createElement("defs", null, React$2.createElement("path", {
    id: "SVGID_1_",
    d: "M319.9,289.7L286.7,85.9c-0.7-4.5-4.6-7.8-9.2-7.8h-235c-4.5,0-8.4,3.3-9.2,7.8L0.1,289.7\n                c-0.9,5.6,3.4,10.8,9.2,10.8h301.4C316.4,300.5,320.8,295.4,319.9,289.7z"
  })), React$2.createElement("clipPath", {
    id: "SVGID_00000076574983390936171800000001075675846578099086_"
  }, React$2.createElement("use", {
    href: "#SVGID_1_",
    className: localStyles.visible
  })), React$2.createElement("path", {
    className: localStyles.clip,
    d: "M-9,137.4\n              c0.8,1.3,2.4,1.7,3.7,0.9l9.8-5.9c0.6-0.4,1.3-0.5,2-0.3l2.5,0.6c7.7,1.9,10.4,11.3,5,17l-1.8,1.8c-0.5,0.5-1.2,0.8-1.9,0.8\n              l-11.4,0.3c-1.5,0-2.6,1.3-2.6,2.7l0.1,4.1c0,1.5,1.3,2.6,2.7,2.6l7.1-0.2c1.5,0,2.7,1.1,2.7,2.6l0.2,7.1c0,1.5,1.3,2.6,2.7,2.6\n              l4.1-0.1c1.5,0,2.6-1.3,2.6-2.7L18.2,160c0-0.7,0.2-1.4,0.7-1.9l1.8-1.8c5.4-5.7,15-3.4,17.2,4.2l0.7,2.4c0.2,0.7,0.1,1.4-0.2,2\n              L33,175c-0.7,1.3-0.2,2.9,1.1,3.6l3.6,2c1.3,0.7,2.9,0.2,3.6-1.1l3.4-6.2c0.7-1.3,2.3-1.8,3.6-1.1l6.2,3.4\n              c1.3,0.7,2.9,0.2,3.6-1.1l2-3.6c0.7-1.3,0.2-2.9-1.1-3.6l-10-5.5c-0.6-0.3-1.1-0.9-1.3-1.6l-0.7-2.4c-2.2-7.6,4.6-14.7,12.3-12.8\n              l2.5,0.6c0.7,0.2,1.3,0.6,1.7,1.2l5.9,9.8c0.8,1.3,2.4,1.7,3.7,0.9l3.5-2.1c1.3-0.8,1.7-2.4,0.9-3.7l-3.7-6.1\n              c-0.8-1.3-0.4-2.9,0.9-3.7l6.1-3.7c1.3-0.8,1.7-2.4,0.9-3.7l-2.1-3.5c-0.8-1.3-2.4-1.7-3.7-0.9l-9.8,5.9c-0.6,0.4-1.3,0.5-2,0.3\n              l-2.5-0.6c-7.7-1.9-10.4-11.3-5-17l1.8-1.8c0.5-0.5,1.2-0.8,1.9-0.8l11.4-0.3c1.5,0,2.6-1.3,2.6-2.7l-0.1-4.1\n              c0-1.5-1.3-2.6-2.7-2.6l-7.1,0.2c-1.5,0-2.7-1.1-2.7-2.6l-0.2-7.1c0-1.5-1.3-2.6-2.7-2.6l-4.1,0.1c-1.5,0-2.6,1.3-2.6,2.7\n              l0.3,11.4c0,0.7-0.2,1.4-0.7,1.9l-1.8,1.8c-5.4,5.7-15,3.4-17.2-4.2l-0.7-2.4c-0.2-0.7-0.1-1.4,0.2-2l5.5-10\n              c0.7-1.3,0.2-2.9-1.1-3.6l-3.6-2c-1.3-0.7-2.9-0.2-3.6,1.1l-3.4,6.2c-0.7,1.3-2.3,1.8-3.6,1.1l-6.2-3.4c-1.3-0.7-2.9-0.2-3.6,1.1\n              l-2,3.6c-0.7,1.3-0.2,2.9,1.1,3.6l10,5.5c0.6,0.3,1.1,0.9,1.3,1.6l0.7,2.4c2.2,7.6-4.6,14.7-12.3,12.8l-2.5-0.6\n              c-0.7-0.2-1.3-0.6-1.7-1.2l-5.9-9.8c-0.8-1.3-2.4-1.7-3.7-0.9l-3.5,2.1c-1.3,0.8-1.7,2.4-0.9,3.7l3.7,6.1c0.8,1.3,0.4,2.9-0.9,3.7\n              l-6.1,3.7c-1.3,0.8-1.7,2.4-0.9,3.7L-9,137.4z"
  }), React$2.createElement("path", {
    className: localStyles.clip,
    d: "M180.3,320.3\n              c1.2,0.9,2.9,0.7,3.7-0.5l6.9-9.1c0.4-0.6,1.1-0.9,1.8-1l2.5-0.3c7.8-1.1,13.8,6.8,10.8,14l-1,2.4c-0.3,0.7-0.8,1.2-1.4,1.5\n              l-10.6,4.4c-1.4,0.6-2,2.1-1.4,3.5l1.6,3.8c0.6,1.4,2.1,2,3.5,1.4l6.5-2.7c1.4-0.6,2.9,0.1,3.5,1.4l2.7,6.5c0.6,1.4,2.1,2,3.5,1.4\n              l3.8-1.6c1.4-0.6,2-2.1,1.4-3.5l-4.4-10.6c-0.3-0.7-0.3-1.4,0-2l1-2.4c3-7.3,12.8-8.6,17.6-2.4l1.6,2c0.4,0.6,0.6,1.3,0.5,2\n              l-1.5,11.3c-0.2,1.5,0.8,2.8,2.3,3l4.1,0.5c1.5,0.2,2.8-0.8,3-2.3l0.9-7c0.2-1.5,1.5-2.5,3-2.3l7,0.9c1.5,0.2,2.8-0.8,3-2.3\n              l0.5-4.1c0.2-1.5-0.8-2.8-2.3-3l-11.3-1.5c-0.7-0.1-1.3-0.5-1.8-1l-1.6-2c-4.8-6.2-1.1-15.4,6.7-16.4l2.5-0.3\n              c0.7-0.1,1.4,0.1,2,0.5l9.1,6.9c1.2,0.9,2.9,0.7,3.7-0.5l2.5-3.3c0.9-1.2,0.7-2.9-0.5-3.7l-5.6-4.3c-1.2-0.9-1.4-2.6-0.5-3.7\n              l4.3-5.6c0.9-1.2,0.7-2.9-0.5-3.7l-3.3-2.5c-1.2-0.9-2.9-0.7-3.7,0.5l-6.9,9.1c-0.4,0.6-1.1,0.9-1.8,1l-2.5,0.3\n              c-7.8,1.1-13.8-6.8-10.8-14l1-2.4c0.3-0.7,0.8-1.2,1.4-1.5l10.6-4.4c1.4-0.6,2-2.1,1.4-3.5l-1.6-3.8c-0.6-1.4-2.1-2-3.5-1.4\n              l-6.5,2.7c-1.4,0.6-2.9-0.1-3.5-1.4l-2.7-6.5c-0.6-1.4-2.1-2-3.5-1.4l-3.8,1.6c-1.4,0.6-2,2.1-1.4,3.5l4.4,10.6\n              c0.3,0.7,0.3,1.4,0,2l-1,2.4c-3,7.3-12.8,8.6-17.6,2.4l-1.6-2c-0.4-0.6-0.6-1.3-0.5-2l1.5-11.3c0.2-1.5-0.8-2.8-2.3-3l-4.1-0.5\n              c-1.5-0.2-2.8,0.8-3,2.3l-0.9,7c-0.2,1.5-1.5,2.5-3,2.3l-7-0.9c-1.5-0.2-2.8,0.8-3,2.3l-0.5,4.1c-0.2,1.5,0.8,2.8,2.3,3l11.3,1.5\n              c0.7,0.1,1.3,0.5,1.8,1l1.6,2c4.8,6.2,1.1,15.4-6.7,16.4l-2.5,0.3c-0.7,0.1-1.4-0.1-2-0.5l-9.1-6.9c-1.2-0.9-2.9-0.7-3.7,0.5\n              l-2.5,3.3c-0.9,1.2-0.7,2.9,0.5,3.7l5.6,4.3c1.2,0.9,1.4,2.6,0.5,3.7l-4.3,5.6c-0.9,1.2-0.7,2.9,0.5,3.7L180.3,320.3z"
  }), React$2.createElement("path", {
    className: localStyles.clip,
    d: "M269.1,248.7\n              c1.2,0.9,2.9,0.7,3.7-0.5l6.9-9.1c0.4-0.6,1.1-0.9,1.8-1l2.5-0.3c7.8-1.1,13.8,6.8,10.8,14l-1,2.4c-0.3,0.7-0.8,1.2-1.4,1.5\n              l-10.6,4.4c-1.4,0.6-2,2.1-1.4,3.5l1.6,3.8c0.6,1.4,2.1,2,3.5,1.4l6.5-2.7c1.4-0.6,2.9,0.1,3.5,1.4l2.7,6.5c0.6,1.4,2.1,2,3.5,1.4\n              l3.8-1.6c1.4-0.6,2-2.1,1.4-3.5l-4.4-10.6c-0.3-0.7-0.3-1.4,0-2l1-2.4c3-7.3,12.8-8.6,17.6-2.4l1.6,2c0.4,0.6,0.6,1.3,0.5,2\n              l-1.5,11.3c-0.2,1.5,0.8,2.8,2.3,3l4.1,0.5c1.5,0.2,2.8-0.8,3-2.3l0.9-7c0.2-1.5,1.5-2.5,3-2.3l7,0.9c1.5,0.2,2.8-0.8,3-2.3\n              l0.5-4.1c0.2-1.5-0.8-2.8-2.3-3l-11.3-1.5c-0.7-0.1-1.3-0.5-1.8-1l-1.6-2c-4.8-6.2-1.1-15.4,6.7-16.4l2.5-0.3\n              c0.7-0.1,1.4,0.1,2,0.5l9.1,6.9c1.2,0.9,2.9,0.7,3.7-0.5l2.5-3.3c0.9-1.2,0.7-2.9-0.5-3.7l-5.6-4.3c-1.2-0.9-1.4-2.6-0.5-3.7\n              l4.3-5.6c0.9-1.2,0.7-2.9-0.5-3.7l-3.3-2.5c-1.2-0.9-2.9-0.7-3.7,0.5l-6.9,9.1c-0.4,0.6-1.1,0.9-1.8,1l-2.5,0.3\n              c-7.8,1.1-13.8-6.8-10.8-14l1-2.4c0.3-0.7,0.8-1.2,1.4-1.5l10.6-4.4c1.4-0.6,2-2.1,1.4-3.5l-1.6-3.8c-0.6-1.4-2.1-2-3.5-1.4\n              l-6.5,2.7c-1.4,0.6-2.9-0.1-3.5-1.4l-2.7-6.5c-0.6-1.4-2.1-2-3.5-1.4l-3.8,1.6c-1.4,0.6-2,2.1-1.4,3.5l4.4,10.6\n              c0.3,0.7,0.3,1.4,0,2l-1,2.4c-3,7.3-12.8,8.6-17.6,2.4l-1.6-2c-0.4-0.6-0.6-1.3-0.5-2l1.5-11.3c0.2-1.5-0.8-2.8-2.3-3l-4.1-0.5\n              c-1.5-0.2-2.8,0.8-3,2.3l-0.9,7c-0.2,1.5-1.5,2.5-3,2.3l-7-0.9c-1.5-0.2-2.8,0.8-3,2.3l-0.5,4.1c-0.2,1.5,0.8,2.8,2.3,3l11.3,1.5\n              c0.7,0.1,1.3,0.5,1.8,1l1.6,2c4.8,6.2,1.1,15.4-6.7,16.4l-2.5,0.3c-0.7,0.1-1.4-0.1-2-0.5l-9.1-6.9c-1.2-0.9-2.9-0.7-3.7,0.5\n              l-2.5,3.3c-0.9,1.2-0.7,2.9,0.5,3.7l5.6,4.3c1.2,0.9,1.4,2.6,0.5,3.7l-4.3,5.6c-0.9,1.2-0.7,2.9,0.5,3.7L269.1,248.7z"
  }), React$2.createElement("path", {
    className: localStyles.clip,
    d: "M245,112.7\n              c1.2,0.9,2.9,0.7,3.7-0.5l6.9-9.1c0.4-0.6,1.1-0.9,1.8-1l2.5-0.3c7.8-1.1,13.8,6.8,10.8,14l-1,2.4c-0.3,0.7-0.8,1.2-1.4,1.5\n              l-10.6,4.4c-1.4,0.6-2,2.1-1.4,3.5l1.6,3.8c0.6,1.4,2.1,2,3.5,1.4l6.5-2.7c1.4-0.6,2.9,0.1,3.5,1.4l2.7,6.5c0.6,1.4,2.1,2,3.5,1.4\n              l3.8-1.6c1.4-0.6,2-2.1,1.4-3.5l-4.4-10.6c-0.3-0.7-0.3-1.4,0-2l1-2.4c3-7.3,12.8-8.6,17.6-2.4l1.6,2c0.4,0.6,0.6,1.3,0.5,2\n              l-1.5,11.3c-0.2,1.5,0.8,2.8,2.3,3l4.1,0.5c1.5,0.2,2.8-0.8,3-2.3l0.9-7c0.2-1.5,1.5-2.5,3-2.3l7,0.9c1.5,0.2,2.8-0.8,3-2.3\n              l0.5-4.1c0.2-1.5-0.8-2.8-2.3-3l-11.3-1.5c-0.7-0.1-1.3-0.5-1.8-1l-1.6-2c-4.8-6.2-1.1-15.4,6.7-16.4l2.5-0.3\n              c0.7-0.1,1.4,0.1,2,0.5l9.1,6.9c1.2,0.9,2.9,0.7,3.7-0.5l2.5-3.3c0.9-1.2,0.7-2.9-0.5-3.7l-5.6-4.3c-1.2-0.9-1.4-2.6-0.5-3.7\n              l4.3-5.6c0.9-1.2,0.7-2.9-0.5-3.7l-3.3-2.5c-1.2-0.9-2.9-0.7-3.7,0.5l-6.9,9.1c-0.4,0.6-1.1,0.9-1.8,1l-2.5,0.3\n              c-7.8,1.1-13.8-6.8-10.8-14l1-2.4c0.3-0.7,0.8-1.2,1.4-1.5l10.6-4.4c1.4-0.6,2-2.1,1.4-3.5l-1.6-3.8c-0.6-1.4-2.1-2-3.5-1.4\n              l-6.5,2.7c-1.4,0.6-2.9-0.1-3.5-1.4l-2.7-6.5c-0.6-1.4-2.1-2-3.5-1.4l-3.8,1.6c-1.4,0.6-2,2.1-1.4,3.5l4.4,10.6\n              c0.3,0.7,0.3,1.4,0,2l-1,2.4c-3,7.3-12.8,8.6-17.6,2.4l-1.6-2c-0.4-0.6-0.6-1.3-0.5-2l1.5-11.3c0.2-1.5-0.8-2.8-2.3-3l-4.1-0.5\n              c-1.5-0.2-2.8,0.8-3,2.3l-0.9,7c-0.2,1.5-1.5,2.5-3,2.3l-7-0.9c-1.5-0.2-2.8,0.8-3,2.3l-0.5,4.1c-0.2,1.5,0.8,2.8,2.3,3l11.3,1.5\n              c0.7,0.1,1.3,0.5,1.8,1l1.6,2c4.8,6.2,1.1,15.4-6.7,16.4l-2.5,0.3c-0.7,0.1-1.4-0.1-2-0.5l-9.1-6.9c-1.2-0.9-2.9-0.7-3.7,0.5\n              l-2.5,3.3c-0.9,1.2-0.7,2.9,0.5,3.7l5.6,4.3c1.2,0.9,1.4,2.6,0.5,3.7l-4.3,5.6c-0.9,1.2-0.7,2.9,0.5,3.7L245,112.7z"
  }), React$2.createElement("path", {
    className: localStyles.clip,
    d: "M-25.5,305\n              c1.2,0.9,2.9,0.7,3.7-0.5l6.9-9.1c0.4-0.6,1.1-0.9,1.8-1l2.5-0.3c7.8-1.1,13.8,6.8,10.8,14l-1,2.4c-0.3,0.7-0.8,1.2-1.4,1.5\n              l-10.6,4.4c-1.4,0.6-2,2.1-1.4,3.5l1.6,3.8c0.6,1.4,2.1,2,3.5,1.4l6.5-2.7c1.4-0.6,2.9,0.1,3.5,1.4l2.7,6.5c0.6,1.4,2.1,2,3.5,1.4\n              l3.8-1.6c1.4-0.6,2-2.1,1.4-3.5l-4.4-10.6c-0.3-0.7-0.3-1.4,0-2l1-2.4c3-7.3,12.8-8.6,17.6-2.4l1.6,2c0.4,0.6,0.6,1.3,0.5,2\n              l-1.5,11.3c-0.2,1.5,0.8,2.8,2.3,3l4.1,0.5c1.5,0.2,2.8-0.8,3-2.3l0.9-7c0.2-1.5,1.5-2.5,3-2.3l7,0.9c1.5,0.2,2.8-0.8,3-2.3\n              l0.5-4.1c0.2-1.5-0.8-2.8-2.3-3l-11.3-1.5c-0.7-0.1-1.3-0.5-1.8-1l-1.6-2c-4.8-6.2-1.1-15.4,6.7-16.4l2.5-0.3\n              c0.7-0.1,1.4,0.1,2,0.5l9.1,6.9c1.2,0.9,2.9,0.7,3.7-0.5l2.5-3.3c0.9-1.2,0.7-2.9-0.5-3.7l-5.6-4.3c-1.2-0.9-1.4-2.6-0.5-3.7\n              l4.3-5.6c0.9-1.2,0.7-2.9-0.5-3.7l-3.3-2.5c-1.2-0.9-2.9-0.7-3.7,0.5l-6.9,9.1c-0.4,0.6-1.1,0.9-1.8,1l-2.5,0.3\n              c-7.8,1.1-13.8-6.8-10.8-14l1-2.4c0.3-0.7,0.8-1.2,1.4-1.5l10.6-4.4c1.4-0.6,2-2.1,1.4-3.5l-1.6-3.8c-0.6-1.4-2.1-2-3.5-1.4\n              l-6.5,2.7c-1.4,0.6-2.9-0.1-3.5-1.4l-2.7-6.5c-0.6-1.4-2.1-2-3.5-1.4l-3.8,1.6c-1.4,0.6-2,2.1-1.4,3.5l4.4,10.6\n              c0.3,0.7,0.3,1.4,0,2l-1,2.4c-3,7.3-12.8,8.6-17.6,2.4l-1.6-2c-0.4-0.6-0.6-1.3-0.5-2l1.5-11.3c0.2-1.5-0.8-2.8-2.3-3l-4.1-0.5\n              c-1.5-0.2-2.8,0.8-3,2.3l-0.9,7c-0.2,1.5-1.5,2.5-3,2.3l-7-0.9c-1.5-0.2-2.8,0.8-3,2.3l-0.5,4.1c-0.2,1.5,0.8,2.8,2.3,3l11.3,1.5\n              c0.7,0.1,1.3,0.5,1.8,1l1.6,2c4.8,6.2,1.1,15.4-6.7,16.4l-2.5,0.3c-0.7,0.1-1.4-0.1-2-0.5l-9.1-6.9c-1.2-0.9-2.9-0.7-3.7,0.5\n              l-2.5,3.3c-0.9,1.2-0.7,2.9,0.5,3.7l5.6,4.3c1.2,0.9,1.4,2.6,0.5,3.7l-4.3,5.6c-0.9,1.2-0.7,2.9,0.5,3.7L-25.5,305z"
  }), React$2.createElement("circle", {
    className: localStyles.clip,
    cx: "96",
    cy: "81.4",
    r: "8.8"
  }), React$2.createElement("circle", {
    className: localStyles.clip,
    cx: "138.4",
    cy: "300.5",
    r: "8.8"
  }))), React$2.createElement("line", {
    className: styles$m.string,
    x1: "236.34",
    y1: "88.37",
    x2: "236.34",
    y2: "421.64"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.leftBow),
    d: "M163.83,36.51c7.72,9.03,72.64,51.86,72.64,51.86,0,0-32.19-70.79-39.92-79.83-7.73-9.04-21.31-10.11-30.34-2.38-9.04,7.72-10.1,21.31-2.38,30.34Z"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.rightBow),
    d: "M308.6,68.86c-8.7,4.83-72.13,19.5-72.13,19.5,0,0,45.92-46.16,54.61-51,8.7-4.83,19.67-1.7,24.51,6.99,4.83,8.7,1.71,19.67-6.99,24.51Z"
  }), React$2.createElement("g", {
    className: styles$m.label
  }, React$2.createElement("path", {
    className: localStyles.tag,
    d: "M383.34,219l-53.87,38.04c-3.58,2.53-8.53,1.68-11.06-1.91l-66.64-94.4c-1.08-1.54-1.59-3.4-1.42-5.27l3.73-42.66c.8-9.18,9.67-15.43,18.58-13.12l41.45,10.76c1.82,.47,3.41,1.57,4.49,3.1l66.64,94.4c2.53,3.58,1.68,8.53-1.91,11.06m-107.68-108.42c-2.4-3.4-7.1-4.21-10.5-1.81-3.4,2.4-4.21,7.1-1.81,10.5,2.4,3.4,7.1,4.21,10.5,1.81,3.4-2.4,4.21-7.1,1.81-10.5"
  }), React$2.createElement("path", {
    className: localStyles.tagIcon,
    transform: "scale(1.49 1.34)",
    d: "M194.8,138.1l5.3-3.7c0.7-0.5,1.7-0.2,2.2,0.7l10.9,17.1c0.5,0.9,1.7,0.5,1.5-0.5c-1-4.6-1.3-11.1,3.6-14.5\n        \t\tc5.8-4,11.1-2.2,20.2,11l7.5,10.8c0.5,0.8,0.5,1.8-0.2,2.2l-4.8,3.3c-0.7,0.5-1.6,0.2-2.2-0.6l-5.1-7.4c-5.5-8-8.8-9.5-12.6-6.9\n        \t\tc-3.9,2.7-2.8,9.9,2.6,17.7l3.3,4.8c0.5,0.8,0.5,1.8-0.2,2.2l-4.8,3.3c-0.7,0.5-1.6,0.2-2.2-0.6l-25.4-36.7\n        \t\tC194.1,139.6,194.2,138.6,194.8,138.1"
  })), React$2.createElement("path", {
    className: styles$m.string,
    d: "M266.39,112.37s-10.45-24.21-30.05-24"
  }), React$2.createElement("path", {
    className: classnames(styles$m.string, styles$m.ends),
    d: "M179.11,250.06c-3.62-10.66-10.05-27.22-2.8-43.73,10.47-23.86,25.88-16.69,36.35-40.54,10.47-23.85-1.93-29.92,5.53-54.87,3.88-12.97,11.92-17.51,18.03-22.76,0,0-28.44-2.12-42.93,24.22-14.49,26.34,.59,47.8-34.61,60.58"
  })));
};
var RemoteImage = function RemoteImage() {
  var _useThemeContext19 = useThemeContext(),
    remoteUrl = _useThemeContext19.giftWrap.remoteUrl;
  return React$2.createElement("img", {
    src: remoteUrl,
    alt: "Gift wrap",
    "data-testid": "gift",
    width: "auto",
    height: "280"
  });
};
var Sparkle = function Sparkle(_ref107) {
  var _ref107$className = _ref107.className,
    className = _ref107$className === void 0 ? '' : _ref107$className,
    _ref107$isCircle = _ref107.isCircle,
    isCircle = _ref107$isCircle === void 0 ? false : _ref107$isCircle;
  return React$2.createElement("div", {
    className: classnames(className, styles$m.sparckle)
  }, React$2.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80.7"
  }, isCircle ? React$2.createElement("circle", {
    cx: "40",
    cy: "40",
    r: "40"
  }) : React$2.createElement("path", {
    d: "M44.4,3.17l7.4,22.29c0.46,1.37,1.53,2.45,2.9,2.92l22.17,7.59c4.18,1.43,4.18,7.34,0,8.77L54.7,52.31\n           \tc-1.37,0.47-2.44,1.55-2.9,2.92l-7.4,22.29c-1.4,4.23-7.39,4.23-8.79,0l-7.4-22.29c-0.46-1.37-1.52-2.45-2.9-2.92L3.13,44.73\n           \tc-4.18-1.43-4.18-7.34,0-8.77l22.17-7.59c1.37-0.47,2.44-1.55,2.9-2.92l7.4-22.29C37.01-1.06,42.99-1.06,44.4,3.17"
  })));
};
var Sparkles = function Sparkles() {
  return React$2.createElement("div", {
    className: styles$m.sparckles
  }, React$2.createElement(Sparkle, {
    className: styles$m['pink-circle'],
    isCircle: true
  }), React$2.createElement(Sparkle, {
    className: styles$m['blue-star']
  }), React$2.createElement(Sparkle, {
    className: styles$m['blue-circle'],
    isCircle: true
  }), React$2.createElement(Sparkle, {
    className: styles$m['pink-star']
  }), React$2.createElement(Sparkle, {
    className: styles$m['yellow-star']
  }));
};
var Shadow = function Shadow() {
  return React$2.createElement("div", {
    className: styles$m.shadow
  }, React$2.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 100"
  }, React$2.createElement("g", null, React$2.createElement("ellipse", {
    cx: "250",
    cy: "50",
    rx: "235",
    ry: "25"
  }))));
};
var map = new Map([[GiftWrapType.Default, DefaultWrapping], [GiftWrapType.RedStripes, RedStripes], [GiftWrapType.Snow, Snow], [GiftWrapType.BlueStars, BlueStars], [GiftWrapType.ChristmasTrees, ChristmasTrees], [GiftWrapType.ChristmasWreath, ChristmasWreath], [GiftWrapType.RemoteImage, RemoteImage]]);
var getWrapping = function getWrapping(type) {
  var _a;
  return (_a = map.get(type)) !== null && _a !== void 0 ? _a : DefaultWrapping;
};
var TRANSFORM_CSS_PROPERTY = 'transform';
var DefaultAnimation = function DefaultAnimation(_ref108) {
  var _ref108$phase = _ref108.phase,
    phase = _ref108$phase === void 0 ? GiftWrapPhase.Intro : _ref108$phase,
    onIntroComplete = _ref108.onIntroComplete,
    onOutroComplete = _ref108.onOutroComplete,
    wrapping = _ref108.wrapping;
  var _useState40 = useState(false),
    _useState41 = _slicedToArray(_useState40, 2),
    initilaised = _useState41[0],
    setInitialised = _useState41[1];
  useEffect(function () {
    var timeout = setTimeout(function () {
      setInitialised(true);
    }, 200);
    return function () {
      clearTimeout(timeout);
    };
  }, []);
  var Wrapping = useMemo(function () {
    return getWrapping(wrapping);
  }, [wrapping]);
  if (wrapping === GiftWrapType.None) {
    onIntroComplete();
    onOutroComplete();
    return null;
  }
  return React$2.createElement("div", {
    className: classnames(styles$m.outroContainer, _defineProperty2({}, styles$m.outroContainerActive, phase === GiftWrapPhase.Outro)),
    onTransitionEnd: function onTransitionEnd(_ref109) {
      var propertyName = _ref109.propertyName;
      if (phase === GiftWrapPhase.Outro && propertyName === TRANSFORM_CSS_PROPERTY) {
        onOutroComplete();
      }
    }
  }, React$2.createElement("div", {
    className: classnames(styles$m.introContainer, _defineProperty2({}, styles$m.introContainerActive, initilaised)),
    onTransitionEnd: function onTransitionEnd() {
      if (phase === GiftWrapPhase.Intro) {
        onIntroComplete();
      }
    }
  }, React$2.createElement("div", {
    className: classnames(styles$m.idleContainer, _defineProperty2({}, styles$m.idleContainerActive, phase !== GiftWrapPhase.Intro))
  }, React$2.createElement(Sparkles, null), React$2.createElement(Wrapping, null), React$2.createElement(Shadow, null))));
};
var styles$l = {
  "center": "gift-wrap-module_center__M2oMO",
  "fadeable": "gift-wrap-module_fadeable__I75EQ",
  "fadeIn": "gift-wrap-module_fadeIn__eX71B"
};
var GiftWrap = function GiftWrap(_ref110) {
  var onUnwrapComplete = _ref110.onUnwrapComplete,
    _ref110$senderMessage = _ref110.senderMessage,
    senderMessage = _ref110$senderMessage === void 0 ? '' : _ref110$senderMessage,
    _ref110$autoUnwrap = _ref110.autoUnwrap,
    autoUnwrap = _ref110$autoUnwrap === void 0 ? false : _ref110$autoUnwrap;
  var _useThemeContext20 = useThemeContext(),
    _useThemeContext20$gi = _useThemeContext20.giftWrap,
    wrapping = _useThemeContext20$gi.wrapping,
    remoteUrl = _useThemeContext20$gi.remoteUrl;
  var _useState42 = useState(GiftWrapPhase.Intro),
    _useState43 = _slicedToArray(_useState42, 2),
    phase = _useState43[0],
    setPhase = _useState43[1];
  var _useState44 = useState(false),
    _useState45 = _slicedToArray(_useState44, 2),
    isUnwrapComplete = _useState45[0],
    setIsUnwrapComplete = _useState45[1];
  useEffect(function () {
    var timeout;
    if (isUnwrapComplete) {
      timeout = setTimeout(onUnwrapComplete, 350);
    }
    return function () {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [isUnwrapComplete, onUnwrapComplete]);
  useEffect(function () {
    var autoUnwrapTimeout;
    if (autoUnwrap && phase === GiftWrapPhase.Idle) {
      autoUnwrapTimeout = setTimeout(function () {
        setPhase(GiftWrapPhase.Outro);
      }, 1500);
    }
    return function () {
      if (autoUnwrapTimeout) {
        clearTimeout(autoUnwrapTimeout);
      }
    };
  }, [phase, autoUnwrap]);
  if (wrapping === GiftWrapType.None || wrapping === GiftWrapType.RemoteImage && !remoteUrl) {
    onUnwrapComplete();
    return null;
  }
  return React$2.createElement("div", null, React$2.createElement(DefaultAnimation, {
    phase: phase,
    onIntroComplete: function onIntroComplete() {
      setPhase(GiftWrapPhase.Idle);
    },
    onOutroComplete: function onOutroComplete() {
      setIsUnwrapComplete(true);
    },
    wrapping: wrapping
  }), React$2.createElement("div", {
    className: classnames(styles$l.fadeable, _defineProperty2({}, styles$l.fadeIn, phase === GiftWrapPhase.Idle))
  }, React$2.createElement(Heading_3, {
    className: styles$l.center
  }, senderMessage), !autoUnwrap ? React$2.createElement(PrimaryButton, {
    onClick: function onClick() {
      setPhase(GiftWrapPhase.Outro);
    },
    className: styles$l.center,
    label: "TAP TO UNWRAP"
  }) : null));
};
var Logo = function Logo(_ref111) {
  var className = _ref111.className,
    _ref111$style = _ref111.style,
    style = _ref111$style === void 0 ? {} : _ref111$style;
  var _useThemeContext21 = useThemeContext(),
    _useThemeContext21$lo = _useThemeContext21.logo,
    src = _useThemeContext21$lo.src,
    height = _useThemeContext21$lo.height;
  return React$2.createElement("img", {
    className: className,
    style: Object.assign({
      maxHeight: height,
      width: 'fit-content',
      objectFit: 'contain'
    }, style),
    src: src,
    alt: ""
  });
};
var styles$k = {
  "container": "message-bubble-module_container__MM4O0",
  "bubbleArrow": "message-bubble-module_bubbleArrow__ffR0I",
  "bubble": "message-bubble-module_bubble__xYVCN",
  "dots": "message-bubble-module_dots__XLQeM",
  "dot": "message-bubble-module_dot__zUKg3",
  "bounceAnimation": "message-bubble-module_bounceAnimation__1ElOl",
  "message": "message-bubble-module_message__GgxOY",
  "hide": "message-bubble-module_hide__BeGtX",
  "show": "message-bubble-module_show__us80n",
  "extraHeight": "message-bubble-module_extraHeight__V5J-F"
};
var MessageBubble = function MessageBubble(_ref112) {
  var message = _ref112.message,
    onAnimationComplete = _ref112.onAnimationComplete,
    _ref112$animate = _ref112.animate,
    animate = _ref112$animate === void 0 ? true : _ref112$animate,
    _ref112$extraHeight = _ref112.extraHeight,
    extraHeight = _ref112$extraHeight === void 0 ? '0px' : _ref112$extraHeight,
    _ref112$fromSelf = _ref112.fromSelf,
    fromSelf = _ref112$fromSelf === void 0 ? false : _ref112$fromSelf;
  var _useState46 = useState(animate),
    _useState47 = _slicedToArray(_useState46, 2),
    isTypingAnimation = _useState47[0],
    setIsTypingAnimation = _useState47[1];
  var _useThemeContext22 = useThemeContext(),
    colors = _useThemeContext22.reaction.colors;
  var color = fromSelf ? colors.sent : colors.received;
  var renderTypingAnimation = function renderTypingAnimation() {
    return React$2.createElement("div", {
      className: styles$k.dots
    }, React$2.createElement("span", {
      className: styles$k.dot
    }, "\u25CF"), React$2.createElement("span", {
      className: styles$k.dot
    }, "\u25CF"), React$2.createElement("span", {
      className: styles$k.dot
    }, "\u25CF"));
  };
  useEffect(function () {
    var timer = setTimeout(function () {
      setIsTypingAnimation(false);
    }, 2000);
    return function () {
      clearTimeout(timer);
    };
  });
  var renderMessage = function renderMessage() {
    return React$2.createElement("div", {
      className: classnames(styles$k.message, isTypingAnimation ? styles$k.hide : styles$k.show),
      onTransitionEnd: debounce_1.debounce(function () {
        if (onAnimationComplete && animate && !isTypingAnimation) {
          onAnimationComplete();
        }
      }, 1000, true)
    }, !isTypingAnimation && React$2.createElement(Markdown, {
      value: message,
      centerText: true
    }), React$2.createElement("div", {
      className: styles$k.extraHeight,
      style: {
        height: extraHeight
      }
    }));
  };
  return React$2.createElement(Body_2, {
    className: styles$k.container
  }, React$2.createElement("svg", {
    viewBox: "0 0 10 10",
    className: styles$k.bubbleArrow,
    fill: color,
    style: {
      transform: "scaleX(".concat(fromSelf ? -1 : 1, ")"),
      left: fromSelf ? 'calc(100% - 25%)' : '25%'
    }
  }, React$2.createElement("polygon", {
    points: "0,0 10,10 0,10 0,0"
  })), React$2.createElement("div", {
    className: styles$k.bubble,
    style: {
      backgroundColor: color
    }
  }, isTypingAnimation && renderTypingAnimation(), renderMessage()));
};

// src/utils/asArray.ts
function asArray(v) {
  return [].concat(v);
}

// src/utils/is.ts
function isPsuedoSelector(selector) {
  return selector.startsWith(":");
}
function isStyleCondition(selector) {
  return isString(selector) && (selector === "*" || selector.length > 1 && ":>~.+*".includes(selector.slice(0, 1)) || isImmediatePostcondition(selector));
}
function isValidProperty(property, value) {
  return (isString(value) || typeof value === "number") && !isCssVariables(property) && !isPsuedoSelector(property) && !isMediaQuery(property);
}
function isMediaQuery(selector) {
  return selector.startsWith("@media");
}
function isDirectClass(selector) {
  return selector === ".";
}
function isCssVariables(selector) {
  return selector === "--";
}
function isString(value) {
  return value + "" === value;
}
function isImmediatePostcondition(value) {
  return isString(value) && (value.startsWith("&") || isPsuedoSelector(value));
}

// src/utils/joinTruthy.ts
function joinTruthy(arr) {
  var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return arr.filter(Boolean).join(delimiter);
}

// src/utils/stableHash.ts
function stableHash(prefix, seed) {
  var hash = 0;
  if (seed.length === 0) return hash.toString();
  for (var _i8 = 0; _i8 < seed.length; _i8++) {
    var char = seed.charCodeAt(_i8);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return "".concat(prefix !== null && prefix !== void 0 ? prefix : "cl", "_").concat(hash.toString(36));
}

// src/utils/stringManipulators.ts
function handlePropertyValue(property, value) {
  if (property === "content") {
    return "\"".concat(value, "\"");
  }
  return value;
}
function camelCaseToDash(str) {
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function joinedProperty(property, value) {
  return "".concat(property, ":").concat(value);
}
function toClass(str) {
  return str ? ".".concat(str) : "";
}
function appendString(base, line) {
  return base ? "".concat(base, "\n").concat(line) : line;
}

// src/Rule.ts
var Rule = /*#__PURE__*/function () {
  function _Rule(sheet, property, value, selector) {
    _classCallCheck2(this, _Rule);
    this.sheet = sheet;
    this.property = property;
    this.value = value;
    this.selector = selector;
    this.property = property;
    this.value = value;
    this.joined = joinedProperty(property, value);
    var joinedConditions = this.selector.preconditions.concat(this.selector.postconditions);
    this.hash = this.selector.hasConditions ? this.selector.scopeClassName : stableHash(this.sheet.name, this.joined);
    this.key = joinTruthy([this.joined, joinedConditions, this.hash]);
  }
  return _createClass2(_Rule, [{
    key: "toString",
    value: function toString() {
      var selectors = mergeSelectors(this.selector.preconditions, {
        right: this.hash
      });
      selectors = mergeSelectors(this.selector.postconditions, {
        left: selectors
      });
      return "".concat(selectors, " {").concat(_Rule.genRule(this.property, this.value), "}");
    }
  }], [{
    key: "genRule",
    value: function genRule(property, value) {
      var transformedProperty = camelCaseToDash(property);
      return joinedProperty(transformedProperty, handlePropertyValue(property, value)) + ";";
    }
  }]);
}();
function mergeSelectors(selectors) {
  var _ref113 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref113$left = _ref113.left,
    left = _ref113$left === void 0 ? "" : _ref113$left,
    _ref113$right = _ref113.right,
    right = _ref113$right === void 0 ? "" : _ref113$right;
  var output = selectors.reduce(function (selectors2, current) {
    if (isPsuedoSelector(current)) {
      return selectors2 + current;
    }
    if (isImmediatePostcondition(current)) {
      return selectors2 + current.slice(1);
    }
    return joinTruthy([selectors2, current], " ");
  }, left);
  return joinTruthy([output, toClass(right)], " ");
}
var Selector = /*#__PURE__*/function () {
  function _Selector(sheet) {
    var scopeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var _ref114 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      preconditions = _ref114.preconditions,
      postconditions = _ref114.postconditions;
    _classCallCheck2(this, _Selector);
    this.sheet = sheet;
    this.preconditions = [];
    this.scopeClassName = null;
    this.scopeName = null;
    this.postconditions = [];
    this.preconditions = preconditions ? asArray(preconditions) : [];
    this.postconditions = postconditions ? asArray(postconditions) : [];
    this.setScope(scopeName);
  }
  return _createClass2(_Selector, [{
    key: "setScope",
    value: function setScope(scopeName) {
      if (!scopeName) {
        return this;
      }
      if (!this.scopeClassName) {
        this.scopeName = scopeName;
        this.scopeClassName = stableHash(this.sheet.name,
        // adding the count guarantees uniqueness across style.create calls
        scopeName + this.sheet.count);
      }
      return this;
    }
  }, {
    key: "hasConditions",
    get: function get() {
      return this.preconditions.length > 0 || this.postconditions.length > 0;
    }
  }, {
    key: "addScope",
    value: function addScope(scopeName) {
      return new _Selector(this.sheet, scopeName, {
        preconditions: this.preconditions,
        postconditions: this.postconditions
      });
    }
  }, {
    key: "addPrecondition",
    value: function addPrecondition(precondition) {
      return new _Selector(this.sheet, this.scopeClassName, {
        postconditions: this.postconditions,
        preconditions: this.preconditions.concat(precondition)
      });
    }
  }, {
    key: "addPostcondition",
    value: function addPostcondition(postcondition) {
      return new _Selector(this.sheet, this.scopeClassName, {
        preconditions: this.preconditions,
        postconditions: this.postconditions.concat(postcondition)
      });
    }
  }, {
    key: "createRule",
    value: function createRule(property, value) {
      return new Rule(this.sheet, property, value, this);
    }
  }]);
}();

// src/Sheet.ts
var Sheet = /*#__PURE__*/function () {
  function Sheet(name, rootNode) {
    _classCallCheck2(this, Sheet);
    this.name = name;
    this.rootNode = rootNode;
    // Hash->css
    this.storedStyles = {};
    // styles->hash
    this.storedClasses = {};
    this.style = "";
    this.count = 0;
    this.id = "flairup-".concat(name);
    this.styleTag = this.createStyleTag();
  }
  return _createClass2(Sheet, [{
    key: "getStyle",
    value: function getStyle() {
      return this.style;
    }
  }, {
    key: "append",
    value: function append(css) {
      this.style = appendString(this.style, css);
    }
  }, {
    key: "apply",
    value: function apply() {
      this.count++;
      if (!this.styleTag) {
        return;
      }
      this.styleTag.innerHTML = this.style;
    }
  }, {
    key: "isApplied",
    value: function isApplied() {
      return !!this.styleTag;
    }
  }, {
    key: "createStyleTag",
    value: function createStyleTag() {
      var _this$rootNode;
      if (typeof document === "undefined" || this.isApplied() ||
      // Explicitly disallow mounting to the DOM
      this.rootNode === null) {
        return this.styleTag;
      }
      var styleTag = document.createElement("style");
      styleTag.type = "text/css";
      styleTag.id = this.id;
      ((_this$rootNode = this.rootNode) !== null && _this$rootNode !== void 0 ? _this$rootNode : document.head).appendChild(styleTag);
      return styleTag;
    }
  }, {
    key: "addRule",
    value: function addRule(rule) {
      var storedClass = this.storedClasses[rule.key];
      if (isString(storedClass)) {
        return storedClass;
      }
      this.storedClasses[rule.key] = rule.hash;
      this.storedStyles[rule.hash] = [rule.property, rule.value];
      this.append(rule.toString());
      return rule.hash;
    }
  }]);
}();

// src/utils/forIn.ts
function forIn(obj, fn) {
  for (var key in obj) {
    fn(key.trim(), obj[key]);
  }
}

// src/cx.ts
function cx() {
  for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    args[_key8] = arguments[_key8];
  }
  var classes = args.reduce(function (classes2, arg) {
    if (arg instanceof Set) {
      classes2.push.apply(classes2, _toConsumableArray2(arg));
    } else if (typeof arg === "string") {
      classes2.push(arg);
    } else if (Array.isArray(arg)) {
      classes2.push(cx.apply(void 0, _toConsumableArray2(arg)));
    } else if (typeof arg === "object") {
      Object.entries(arg).forEach(function (_ref115) {
        var _ref116 = _slicedToArray(_ref115, 2),
          key = _ref116[0],
          value = _ref116[1];
        if (value) {
          classes2.push(key);
        }
      });
    }
    return classes2;
  }, []);
  return joinTruthy(classes, " ").trim();
}

// src/index.ts
function createSheet(name, rootNode) {
  var sheet = new Sheet(name, rootNode);
  return {
    create: create,
    getStyle: sheet.getStyle.bind(sheet),
    isApplied: sheet.isApplied.bind(sheet)
  };
  function create(styles) {
    var scopedStyles = {};
    iteratePreconditions(sheet, styles, new Selector(sheet)).forEach(function (_ref117) {
      var _ref118 = _slicedToArray(_ref117, 3),
        scopeName = _ref118[0],
        styles2 = _ref118[1],
        selector = _ref118[2];
      iterateStyles(sheet, styles2, selector).forEach(function (className) {
        addScopedStyle(scopeName, className);
      });
    });
    sheet.apply();
    return scopedStyles;
    function addScopedStyle(name2, className) {
      var _scopedStyles$name;
      scopedStyles[name2] = (_scopedStyles$name = scopedStyles[name2]) !== null && _scopedStyles$name !== void 0 ? _scopedStyles$name : /* @__PURE__ */new Set();
      scopedStyles[name2].add(className);
    }
  }
}
function iteratePreconditions(sheet, styles, selector) {
  var output = [];
  forIn(styles, function (key, value) {
    if (isStyleCondition(key)) {
      return iteratePreconditions(sheet, value, selector.addPrecondition(key)).forEach(function (item) {
        return output.push(item);
      });
    }
    output.push([key, styles[key], selector.addScope(key)]);
  });
  return output;
}
function iterateStyles(sheet, styles, selector) {
  var output = /* @__PURE__ */new Set();
  forIn(styles, function (property, value) {
    var res = [];
    if (isStyleCondition(property)) {
      res = iterateStyles(sheet, value, selector.addPostcondition(property));
    } else if (isDirectClass(property)) {
      res = asArray(value);
    } else if (isMediaQuery(property)) {
      res = handleMediaQuery(sheet, value, property, selector);
    } else if (isCssVariables(property)) {
      res = cssVariablesBlock(sheet, value, selector);
    } else if (isValidProperty(property, value)) {
      var rule = selector.createRule(property, value);
      sheet.addRule(rule);
      output.add(rule.hash);
    }
    return addEachClass(res, output);
  });
  return output;
}
function addEachClass(list, to) {
  list.forEach(function (className) {
    return to.add(className);
  });
  return to;
}
function cssVariablesBlock(sheet, styles, selector) {
  var classes = /* @__PURE__ */new Set();
  var chunkRows = [];
  forIn(styles, function (property, value) {
    if (isValidProperty(property, value)) {
      chunkRows.push(Rule.genRule(property, value));
      return;
    }
    var res = iterateStyles(sheet, value !== null && value !== void 0 ? value : {}, selector);
    addEachClass(res, classes);
  });
  if (!selector.scopeClassName) {
    return classes;
  }
  if (chunkRows.length) {
    var output = chunkRows.join(" ");
    sheet.append("".concat(mergeSelectors(selector.preconditions, {
      right: selector.scopeClassName
    }), " {").concat(output, "}"));
  }
  classes.add(selector.scopeClassName);
  return classes;
}
function handleMediaQuery(sheet, styles, mediaQuery, selector) {
  sheet.append(mediaQuery + " {");
  var output = iterateStyles(sheet, styles, selector);
  sheet.append("}");
  return output;
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _createForOfIteratorHelperLoose(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
    t && (r = t);
    var o = 0;
    return function () {
      return o >= r.length ? {
        done: !0
      } : {
        done: !1,
        value: r[o++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
var ClassNames;
(function (ClassNames) {
  ClassNames["hiddenOnSearch"] = "epr-hidden-on-search";
  ClassNames["searchActive"] = "epr-search-active";
  ClassNames["hidden"] = "epr-hidden";
  ClassNames["visible"] = "epr-visible";
  ClassNames["active"] = "epr-active";
  ClassNames["emoji"] = "epr-emoji";
  ClassNames["category"] = "epr-emoji-category";
  ClassNames["label"] = "epr-emoji-category-label";
  ClassNames["categoryContent"] = "epr-emoji-category-content";
  ClassNames["emojiHasVariations"] = "epr-emoji-has-variations";
  ClassNames["scrollBody"] = "epr-body";
  ClassNames["emojiList"] = "epr-emoji-list";
  ClassNames["external"] = "__EmojiPicker__";
  ClassNames["emojiPicker"] = "EmojiPickerReact";
  ClassNames["open"] = "epr-open";
  ClassNames["vertical"] = "epr-vertical";
  ClassNames["horizontal"] = "epr-horizontal";
  ClassNames["variationPicker"] = "epr-emoji-variation-picker";
  ClassNames["darkTheme"] = "epr-dark-theme";
  ClassNames["autoTheme"] = "epr-auto-theme";
})(ClassNames || (ClassNames = {}));
function asSelectors() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.map(function (c) {
    return "." + c;
  }).join('');
}
var stylesheet = /*#__PURE__*/createSheet('epr', null);
var hidden = {
  display: 'none',
  opacity: '0',
  pointerEvents: 'none',
  visibility: 'hidden',
  overflow: 'hidden'
};
var commonStyles = /*#__PURE__*/stylesheet.create({
  hidden: /*#__PURE__*/_extends({
    '.': ClassNames.hidden
  }, hidden)
});
var PickerStyleTag = /*#__PURE__*/memo(function PickerStyleTag(_ref) {
  var nonce = _ref.nonce;
  return createElement("style", {
    nonce: nonce,
    suppressHydrationWarning: true,
    dangerouslySetInnerHTML: {
      __html: stylesheet.getStyle()
    }
  });
});
var commonInteractionStyles = /*#__PURE__*/stylesheet.create({
  '.epr-main': {
    ':has(input:not(:placeholder-shown))': {
      categoryBtn: {
        ':hover': {
          opacity: '1',
          backgroundPositionY: 'var(--epr-category-navigation-button-size)'
        }
      },
      hiddenOnSearch: /*#__PURE__*/_extends({
        '.': ClassNames.hiddenOnSearch
      }, hidden)
    },
    ':has(input:placeholder-shown)': {
      visibleOnSearchOnly: hidden
    }
  },
  hiddenOnReactions: {
    transition: 'all 0.5s ease-in-out'
  },
  '.epr-reactions': {
    hiddenOnReactions: {
      height: '0px',
      width: '0px',
      opacity: '0',
      pointerEvents: 'none',
      overflow: 'hidden'
    }
  },
  '.EmojiPickerReact:not(.epr-search-active)': {
    categoryBtn: {
      ':hover': {
        opacity: '1',
        backgroundPositionY: 'var(--epr-category-navigation-button-size)'
      },
      '&.epr-active': {
        opacity: '1',
        backgroundPositionY: 'var(--epr-category-navigation-button-size)'
      }
    },
    visibleOnSearchOnly: /*#__PURE__*/_extends({
      '.': 'epr-visible-on-search-only'
    }, hidden)
  }
});
function darkMode(key, value) {
  var _eprDarkTheme, _eprAutoTheme;
  return {
    '.epr-dark-theme': (_eprDarkTheme = {}, _eprDarkTheme[key] = value, _eprDarkTheme),
    '.epr-auto-theme': (_eprAutoTheme = {}, _eprAutoTheme[key] = {
      '@media (prefers-color-scheme: dark)': value
    }, _eprAutoTheme)
  };
}

// eslint-disable-next-line complexity
function compareConfig(prev, next) {
  var _prev$customEmojis, _next$customEmojis;
  var prevCustomEmojis = (_prev$customEmojis = prev.customEmojis) != null ? _prev$customEmojis : [];
  var nextCustomEmojis = (_next$customEmojis = next.customEmojis) != null ? _next$customEmojis : [];
  return prev.open === next.open && prev.emojiVersion === next.emojiVersion && prev.reactionsDefaultOpen === next.reactionsDefaultOpen && prev.searchPlaceHolder === next.searchPlaceHolder && prev.searchPlaceholder === next.searchPlaceholder && prev.searchClearButtonLabel === next.searchClearButtonLabel && prev.defaultSkinTone === next.defaultSkinTone && prev.skinTonesDisabled === next.skinTonesDisabled && prev.autoFocusSearch === next.autoFocusSearch && prev.emojiStyle === next.emojiStyle && prev.theme === next.theme && prev.suggestedEmojisMode === next.suggestedEmojisMode && prev.lazyLoadEmojis === next.lazyLoadEmojis && prev.className === next.className && prev.height === next.height && prev.width === next.width && prev.style === next.style && prev.searchDisabled === next.searchDisabled && prev.skinTonePickerLocation === next.skinTonePickerLocation && prevCustomEmojis.length === nextCustomEmojis.length && prev.emojiData === next.emojiData;
}
var DEFAULT_REACTIONS = ['1f44d', '2764-fe0f', '1f603', '1f622', '1f64f', '1f44e', '1f621'];
var SuggestionMode;
(function (SuggestionMode) {
  SuggestionMode["RECENT"] = "recent";
  SuggestionMode["FREQUENT"] = "frequent";
})(SuggestionMode || (SuggestionMode = {}));
var EmojiStyle;
(function (EmojiStyle) {
  EmojiStyle["NATIVE"] = "native";
  EmojiStyle["APPLE"] = "apple";
  EmojiStyle["TWITTER"] = "twitter";
  EmojiStyle["GOOGLE"] = "google";
  EmojiStyle["FACEBOOK"] = "facebook";
})(EmojiStyle || (EmojiStyle = {}));
var Theme;
(function (Theme) {
  Theme["DARK"] = "dark";
  Theme["LIGHT"] = "light";
  Theme["AUTO"] = "auto";
})(Theme || (Theme = {}));
var SkinTones;
(function (SkinTones) {
  SkinTones["NEUTRAL"] = "neutral";
  SkinTones["LIGHT"] = "1f3fb";
  SkinTones["MEDIUM_LIGHT"] = "1f3fc";
  SkinTones["MEDIUM"] = "1f3fd";
  SkinTones["MEDIUM_DARK"] = "1f3fe";
  SkinTones["DARK"] = "1f3ff";
})(SkinTones || (SkinTones = {}));
var Categories;
(function (Categories) {
  Categories["SUGGESTED"] = "suggested";
  Categories["CUSTOM"] = "custom";
  Categories["SMILEYS_PEOPLE"] = "smileys_people";
  Categories["ANIMALS_NATURE"] = "animals_nature";
  Categories["FOOD_DRINK"] = "food_drink";
  Categories["TRAVEL_PLACES"] = "travel_places";
  Categories["ACTIVITIES"] = "activities";
  Categories["OBJECTS"] = "objects";
  Categories["SYMBOLS"] = "symbols";
  Categories["FLAGS"] = "flags";
})(Categories || (Categories = {}));
var SkinTonePickerLocation;
(function (SkinTonePickerLocation) {
  SkinTonePickerLocation["SEARCH"] = "SEARCH";
  SkinTonePickerLocation["PREVIEW"] = "PREVIEW";
})(SkinTonePickerLocation || (SkinTonePickerLocation = {}));
var CDN_URL_APPLE = 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/';
var CDN_URL_FACEBOOK = 'https://cdn.jsdelivr.net/npm/emoji-datasource-facebook/img/facebook/64/';
var CDN_URL_TWITTER = 'https://cdn.jsdelivr.net/npm/emoji-datasource-twitter/img/twitter/64/';
var CDN_URL_GOOGLE = 'https://cdn.jsdelivr.net/npm/emoji-datasource-google/img/google/64/';
function cdnUrl(emojiStyle) {
  switch (emojiStyle) {
    case EmojiStyle.TWITTER:
      return CDN_URL_TWITTER;
    case EmojiStyle.GOOGLE:
      return CDN_URL_GOOGLE;
    case EmojiStyle.FACEBOOK:
      return CDN_URL_FACEBOOK;
    case EmojiStyle.APPLE:
    default:
      return CDN_URL_APPLE;
  }
}
var skinToneVariations = [SkinTones.NEUTRAL, SkinTones.LIGHT, SkinTones.MEDIUM_LIGHT, SkinTones.MEDIUM, SkinTones.MEDIUM_DARK, SkinTones.DARK];
var skinTonesNamed = /*#__PURE__*/Object.entries(SkinTones).reduce(function (acc, _ref) {
  var key = _ref[0],
    value = _ref[1];
  acc[value] = key;
  return acc;
}, {});
var skinTonesMapped = /*#__PURE__*/skinToneVariations.reduce(function (mapped, skinTone) {
  var _Object$assign;
  return Object.assign(mapped, (_Object$assign = {}, _Object$assign[skinTone] = skinTone, _Object$assign));
}, {});
var EmojiProperties;
(function (EmojiProperties) {
  EmojiProperties["name"] = "n";
  EmojiProperties["unified"] = "u";
  EmojiProperties["variations"] = "v";
  EmojiProperties["added_in"] = "a";
  EmojiProperties["imgUrl"] = "imgUrl";
})(EmojiProperties || (EmojiProperties = {}));
function emojiNames(emoji) {
  var _emoji$EmojiPropertie;
  return (_emoji$EmojiPropertie = emoji[EmojiProperties.name]) != null ? _emoji$EmojiPropertie : [];
}
function addedIn(emoji) {
  return parseFloat(emoji[EmojiProperties.added_in] || '0');
}
function emojiName(emoji) {
  if (!emoji) {
    return '';
  }
  var names = emojiNames(emoji);
  return names[names.length - 1];
}
function unifiedWithoutSkinTone(unified) {
  var splat = unified.split('-');
  var _splat$splice = splat.splice(1, 1),
    skinTone = _splat$splice[0];
  if (skinTonesMapped[skinTone]) {
    return splat.join('-');
  }
  return unified;
}
function emojiUnified(emoji, skinTone) {
  var _emojiVariationUnifie;
  var unified = emoji[EmojiProperties.unified];
  if (!skinTone || !emojiHasVariations(emoji)) {
    return unified;
  }
  return (_emojiVariationUnifie = emojiVariationUnified(emoji, skinTone)) != null ? _emojiVariationUnifie : unified;
}
function emojiUrlByUnified(unified, emojiStyle) {
  return "" + cdnUrl(emojiStyle) + unified + ".png";
}
function emojiVariations(emoji) {
  var _emoji$EmojiPropertie2;
  return (_emoji$EmojiPropertie2 = emoji[EmojiProperties.variations]) != null ? _emoji$EmojiPropertie2 : [];
}
function emojiHasVariations(emoji) {
  return emojiVariations(emoji).length > 0;
}
function emojiVariationUnified(emoji, skinTone) {
  return skinTone ? emojiVariations(emoji).find(function (variation) {
    return variation.includes(skinTone);
  }) : emojiUnified(emoji);
}
function activeVariationFromUnified(unified) {
  var _unified$split = unified.split('-'),
    suspectedSkinTone = _unified$split[1];
  return Object.keys(skinTonesMapped).includes(suspectedSkinTone) ? suspectedSkinTone : null;
}
var _configByCategory;
var categoriesOrdered = [Categories.SUGGESTED, Categories.CUSTOM, Categories.SMILEYS_PEOPLE, Categories.ANIMALS_NATURE, Categories.FOOD_DRINK, Categories.TRAVEL_PLACES, Categories.ACTIVITIES, Categories.OBJECTS, Categories.SYMBOLS, Categories.FLAGS];
var SuggestedRecent = {
  name: 'Recently Used',
  category: Categories.SUGGESTED
};
var configByCategory = (_configByCategory = {}, _configByCategory[Categories.SUGGESTED] = {
  category: Categories.SUGGESTED,
  name: 'Frequently Used'
}, _configByCategory[Categories.CUSTOM] = {
  category: Categories.CUSTOM,
  name: 'Custom Emojis'
}, _configByCategory[Categories.SMILEYS_PEOPLE] = {
  category: Categories.SMILEYS_PEOPLE,
  name: 'Smileys & People'
}, _configByCategory[Categories.ANIMALS_NATURE] = {
  category: Categories.ANIMALS_NATURE,
  name: 'Animals & Nature'
}, _configByCategory[Categories.FOOD_DRINK] = {
  category: Categories.FOOD_DRINK,
  name: 'Food & Drink'
}, _configByCategory[Categories.TRAVEL_PLACES] = {
  category: Categories.TRAVEL_PLACES,
  name: 'Travel & Places'
}, _configByCategory[Categories.ACTIVITIES] = {
  category: Categories.ACTIVITIES,
  name: 'Activities'
}, _configByCategory[Categories.OBJECTS] = {
  category: Categories.OBJECTS,
  name: 'Objects'
}, _configByCategory[Categories.SYMBOLS] = {
  category: Categories.SYMBOLS,
  name: 'Symbols'
}, _configByCategory[Categories.FLAGS] = {
  category: Categories.FLAGS,
  name: 'Flags'
}, _configByCategory);
function baseCategoriesConfig(modifiers) {
  return categoriesOrdered.map(function (category) {
    return _extends({}, configByCategory[category], modifiers && modifiers[category] && modifiers[category]);
  });
}
function categoryFromCategoryConfig(category) {
  return category.category;
}
function categoryNameFromCategoryConfig(category) {
  return category.name;
}
function mergeCategoriesConfig(userCategoriesConfig, modifiers, emojiData) {
  var _userCategoriesConfig;
  if (userCategoriesConfig === void 0) {
    userCategoriesConfig = [];
  }
  if (modifiers === void 0) {
    modifiers = {};
  }
  var extra = function () {
    // 1. Start with localized categories from emojiData
    var fromData = emojiData != null && emojiData.categories ? Object.fromEntries(Object.entries(emojiData.categories).filter(function (_ref) {
      var config = _ref[1];
      return !!config;
    })) : {};
    // 2. Handle "Recently Used" override for explicit 'recent' mode
    if (modifiers.suggestionMode === SuggestionMode.RECENT) {
      var _emojiData$categories;
      var recentConfig = emojiData == null ? void 0 : (_emojiData$categories = emojiData.categories) == null ? void 0 : _emojiData$categories['suggested_recent'];
      fromData[Categories.SUGGESTED] = recentConfig ? {
        category: Categories.SUGGESTED,
        name: recentConfig.name
      } : SuggestedRecent;
    }
    return fromData;
  }();
  var base = baseCategoriesConfig(extra);
  if (!((_userCategoriesConfig = userCategoriesConfig) != null && _userCategoriesConfig.length)) {
    return base;
  }
  return userCategoriesConfig.map(function (category) {
    if (typeof category === 'string') {
      return getBaseConfigByCategory(category, extra[category]);
    }
    return _extends({}, getBaseConfigByCategory(category.category, extra[category.category]), category);
  });
}
function getBaseConfigByCategory(category, modifier) {
  if (modifier === void 0) {
    modifier = {};
  }
  return Object.assign(configByCategory[category], modifier);
}
var KNOWN_FAILING_EMOJIS = ['2640-fe0f', '2642-fe0f', '2695-fe0f'];
var DEFAULT_SEARCH_PLACEHOLDER = 'Search';
var DEFAULT_SEARCH_CLEAR_BUTTON_LABEL = 'Clear';
var SEARCH_RESULTS_NO_RESULTS_FOUND = 'No results found';
var SEARCH_RESULTS_SUFFIX = ' found. Use up and down arrow keys to navigate.';
var SEARCH_RESULTS_ONE_RESULT_FOUND = '1 result' + SEARCH_RESULTS_SUFFIX;
var SEARCH_RESULTS_MULTIPLE_RESULTS_FOUND = '%n results' + SEARCH_RESULTS_SUFFIX;
function mergeConfig(userConfig) {
  var _userConfig$emojiData, _userConfig$emojiData2, _userConfig$emojiData3, _userConfig$previewCo, _userConfig$previewCo2;
  if (userConfig === void 0) {
    userConfig = {};
  }
  var base = basePickerConfig();
  // Get localized mood from emojiData, fallback to base default
  // Get localized mood from emojiData, fallback to base default
  var localizedMood = (_userConfig$emojiData = userConfig.emojiData) == null ? void 0 : (_userConfig$emojiData2 = _userConfig$emojiData.categories) == null ? void 0 : (_userConfig$emojiData3 = _userConfig$emojiData2.preview_mood) == null ? void 0 : _userConfig$emojiData3.name;
  var previewConfig = _extends({}, base.previewConfig, localizedMood && !((_userConfig$previewCo = userConfig.previewConfig) != null && _userConfig$previewCo.defaultCaption) ? {
    defaultCaption: localizedMood
  } : {}, (_userConfig$previewCo2 = userConfig.previewConfig) != null ? _userConfig$previewCo2 : {});
  var config = Object.assign(base, userConfig);
  var categories = mergeCategoriesConfig(userConfig.categories, {
    suggestionMode: config.suggestedEmojisMode
  }, userConfig.emojiData);
  config.hiddenEmojis.forEach(function (emoji) {
    config.unicodeToHide.add(emoji);
  });
  var skinTonePickerLocation = config.searchDisabled ? SkinTonePickerLocation.PREVIEW : config.skinTonePickerLocation;
  return _extends({}, config, {
    categories: categories,
    previewConfig: previewConfig,
    skinTonePickerLocation: skinTonePickerLocation
  });
}
function basePickerConfig() {
  return {
    autoFocusSearch: true,
    categories: baseCategoriesConfig(),
    className: '',
    customEmojis: [],
    defaultSkinTone: SkinTones.NEUTRAL,
    emojiStyle: EmojiStyle.APPLE,
    emojiVersion: null,
    getEmojiUrl: emojiUrlByUnified,
    height: 450,
    lazyLoadEmojis: false,
    previewConfig: _extends({}, basePreviewConfig),
    searchDisabled: false,
    searchPlaceHolder: DEFAULT_SEARCH_PLACEHOLDER,
    searchPlaceholder: DEFAULT_SEARCH_PLACEHOLDER,
    searchClearButtonLabel: DEFAULT_SEARCH_CLEAR_BUTTON_LABEL,
    skinTonePickerLocation: SkinTonePickerLocation.SEARCH,
    skinTonesDisabled: false,
    style: {},
    suggestedEmojisMode: SuggestionMode.FREQUENT,
    theme: Theme.LIGHT,
    unicodeToHide: new Set(KNOWN_FAILING_EMOJIS),
    width: 350,
    reactionsDefaultOpen: false,
    reactions: DEFAULT_REACTIONS,
    open: true,
    allowExpandReactions: true,
    hiddenEmojis: [],
    emojiData: undefined,
    categoryIcons: {},
    nonce: undefined
  };
}
var basePreviewConfig = {
  defaultEmoji: '1f60a',
  defaultCaption: "What's your mood?",
  showPreview: true
};
var _excluded = ["children"];
var ConfigContext = /*#__PURE__*/createContext(/*#__PURE__*/basePickerConfig());
function PickerConfigProvider(_ref) {
  var children = _ref.children,
    config = _objectWithoutPropertiesLoose(_ref, _excluded);
  var mergedConfig = useSetConfig(config);
  return createElement(ConfigContext.Provider, {
    value: mergedConfig
  }, children);
}
function useSetConfig(config) {
  var _config$customEmojis;
  var _React$useState = useState(function () {
      return mergeConfig(config);
    }),
    mergedConfig = _React$useState[0],
    setMergedConfig = _React$useState[1];
  useEffect(function () {
    if (compareConfig(mergedConfig, config)) {
      return;
    }
    setMergedConfig(mergeConfig(config));
    // not gonna...
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(_config$customEmojis = config.customEmojis) == null ? void 0 : _config$customEmojis.length, config.open, config.emojiVersion, config.reactionsDefaultOpen, config.searchPlaceHolder, config.searchPlaceholder, config.searchClearButtonLabel, config.defaultSkinTone, config.skinTonesDisabled, config.autoFocusSearch, config.emojiStyle, config.theme, config.suggestedEmojisMode, config.lazyLoadEmojis, config.className, config.height, config.width, config.searchDisabled, config.skinTonePickerLocation, config.allowExpandReactions, config.emojiData]);
  return mergedConfig;
}
function usePickerConfig() {
  return useContext(ConfigContext);
}
function useDebouncedState(initialValue, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  var _useState = useState(initialValue),
    state = _useState[0],
    setState = _useState[1];
  var timer = useRef(null);
  function debouncedSetState(value) {
    return new Promise(function (resolve) {
      var _window;
      if (timer.current) {
        clearTimeout(timer.current);
      }
      timer.current = (_window = window) == null ? void 0 : _window.setTimeout(function () {
        setState(value);
        resolve(value);
      }, delay);
    });
  }
  return [state, debouncedSetState];
}
var categories = {
  smileys_people: {
    category: "smileys_people",
    name: "people & body"
  },
  animals_nature: {
    category: "animals_nature",
    name: "animals & nature"
  },
  food_drink: {
    category: "food_drink",
    name: "food & drink"
  },
  travel_places: {
    category: "travel_places",
    name: "travel & places"
  },
  activities: {
    category: "activities",
    name: "activities"
  },
  objects: {
    category: "objects",
    name: "objects"
  },
  symbols: {
    category: "symbols",
    name: "symbols"
  },
  flags: {
    category: "flags",
    name: "flags"
  },
  suggested: {
    category: "suggested",
    name: "Frequently Used"
  },
  custom: {
    category: "custom",
    name: "Custom Emojis"
  },
  suggested_recent: {
    category: "suggested",
    name: "Recently Used"
  },
  preview_mood: {
    category: "preview_mood",
    name: "What's your mood?"
  }
};
var emojis = {
  custom: [],
  smileys_people: [{
    n: ["face", "grin", "grinning face"],
    u: "1f600",
    a: "1"
  }, {
    n: ["face", "open", "mouth", "smile", "grinning face with big eyes"],
    u: "1f603",
    a: "0.6"
  }, {
    n: ["eye", "face", "open", "mouth", "smile", "grinning face with smiling eyes"],
    u: "1f604",
    a: "0.6"
  }, {
    n: ["eye", "face", "grin", "smile", "beaming face with smiling eyes"],
    u: "1f601",
    a: "0.6"
  }, {
    n: ["face", "laugh", "mouth", "smile", "satisfied", "grinning squinting face"],
    u: "1f606",
    a: "0.6"
  }, {
    n: ["cold", "face", "open", "smile", "sweat", "grinning face with sweat"],
    u: "1f605",
    a: "0.6"
  }, {
    n: ["face", "rofl", "floor", "laugh", "rotfl", "rolling", "rolling on the floor laughing"],
    u: "1f923",
    a: "3"
  }, {
    n: ["joy", "face", "tear", "laugh", "face with tears of joy"],
    u: "1f602",
    a: "0.6"
  }, {
    n: ["face", "smile", "slightly smiling face"],
    u: "1f642",
    a: "1"
  }, {
    n: ["face", "upside down", "upside down face"],
    u: "1f643",
    a: "1"
  }, {
    n: ["melt", "liquid", "dissolve", "disappear", "melting face"],
    u: "1fae0",
    a: "14"
  }, {
    n: ["face", "wink", "winking face"],
    u: "1f609",
    a: "0.6"
  }, {
    n: ["eye", "face", "blush", "smile", "smiling face with smiling eyes"],
    u: "1f60a",
    a: "0.6"
  }, {
    n: ["face", "halo", "angel", "fantasy", "innocent", "smiling face with halo"],
    u: "1f607",
    a: "1"
  }, {
    n: ["adore", "crush", "hearts", "in love", "smiling face with hearts"],
    u: "1f970",
    a: "11"
  }, {
    n: ["eye", "face", "love", "smile", "smiling face with heart eyes"],
    u: "1f60d",
    a: "0.6"
  }, {
    n: ["eyes", "face", "star", "grinning", "star struck"],
    u: "1f929",
    a: "5"
  }, {
    n: ["face", "kiss", "face blowing a kiss"],
    u: "1f618",
    a: "0.6"
  }, {
    n: ["face", "kiss", "kissing face"],
    u: "1f617",
    a: "1"
  }, {
    n: ["face", "smile", "relaxed", "outlined", "smiling face"],
    u: "263a-fe0f",
    a: "0.6"
  }, {
    n: ["eye", "face", "kiss", "closed", "kissing face with closed eyes"],
    u: "1f61a",
    a: "0.6"
  }, {
    n: ["eye", "face", "kiss", "smile", "kissing face with smiling eyes"],
    u: "1f619",
    a: "1"
  }, {
    n: ["tear", "proud", "smiling", "touched", "grateful", "relieved", "smiling face with tear"],
    u: "1f972",
    a: "13"
  }, {
    n: ["yum", "face", "smile", "delicious", "savouring", "face savoring food"],
    u: "1f60b",
    a: "0.6"
  }, {
    n: ["face", "tongue", "face with tongue"],
    u: "1f61b",
    a: "1"
  }, {
    n: ["eye", "face", "joke", "wink", "tongue", "winking face with tongue"],
    u: "1f61c",
    a: "0.6"
  }, {
    n: ["eye", "goofy", "large", "small", "zany face"],
    u: "1f92a",
    a: "5"
  }, {
    n: ["eye", "face", "taste", "tongue", "horrible", "squinting face with tongue"],
    u: "1f61d",
    a: "0.6"
  }, {
    n: ["face", "money", "mouth", "money mouth face"],
    u: "1f911",
    a: "1"
  }, {
    n: ["hug", "face", "hugging", "open hands", "smiling face", "smiling face with open hands"],
    u: "1f917",
    a: "1"
  }, {
    n: ["whoops", "face with hand over mouth"],
    u: "1f92d",
    a: "5"
  }, {
    n: ["awe", "scared", "surprise", "amazement", "disbelief", "embarrass", "face with open eyes and hand over mouth"],
    u: "1fae2",
    a: "14"
  }, {
    n: ["peep", "stare", "captivated", "face with peeking eye"],
    u: "1fae3",
    a: "14"
  }, {
    n: ["quiet", "shush", "shushing face"],
    u: "1f92b",
    a: "5"
  }, {
    n: ["face", "thinking", "thinking face"],
    u: "1f914",
    a: "1"
  }, {
    n: ["ok", "yes", "sunny", "salute", "troops", "saluting face"],
    u: "1fae1",
    a: "14"
  }, {
    n: ["zip", "face", "mouth", "zipper", "zipper mouth face"],
    u: "1f910",
    a: "1"
  }, {
    n: ["skeptic", "distrust", "face with raised eyebrow"],
    u: "1f928",
    a: "5"
  }, {
    n: ["meh", "face", "deadpan", "neutral", "neutral face"],
    u: "1f610",
    a: "0.7"
  }, {
    n: ["meh", "face", "inexpressive", "unexpressive", "expressionless", "expressionless face"],
    u: "1f611",
    a: "1"
  }, {
    n: ["face", "mouth", "quiet", "silent", "face without mouth"],
    u: "1f636",
    a: "1"
  }, {
    n: ["hide", "depressed", "disappear", "introvert", "invisible", "dotted line face"],
    u: "1fae5",
    a: "14"
  }, {
    n: ["absentminded", "face in clouds", "head in clouds", "face in the fog"],
    u: "1f636-200d-1f32b-fe0f",
    a: "13.1"
  }, {
    n: ["face", "smirk", "smirking face"],
    u: "1f60f",
    a: "0.6"
  }, {
    n: ["face", "unhappy", "unamused", "unamused face"],
    u: "1f612",
    a: "0.6"
  }, {
    n: ["eyes", "face", "eyeroll", "rolling", "face with rolling eyes"],
    u: "1f644",
    a: "1"
  }, {
    n: ["face", "grimace", "grimacing face"],
    u: "1f62c",
    a: "1"
  }, {
    n: ["gasp", "groan", "exhale", "relief", "whisper", "whistle", "face exhaling"],
    u: "1f62e-200d-1f4a8",
    a: "13.1"
  }, {
    n: ["lie", "face", "pinocchio", "lying face"],
    u: "1f925",
    a: "3"
  }, {
    n: ["face", "shock", "shaking", "vibrate", "earthquake", "shaking face"],
    u: "1fae8",
    a: "15"
  }, {
    n: ["no", "shake", "head shaking horizontally"],
    u: "1f642-200d-2194-fe0f",
    a: "15.1"
  }, {
    n: ["nod", "yes", "head shaking vertically"],
    u: "1f642-200d-2195-fe0f",
    a: "15.1"
  }, {
    n: ["face", "relieved", "relieved face"],
    u: "1f60c",
    a: "0.6"
  }, {
    n: ["face", "pensive", "dejected", "pensive face"],
    u: "1f614",
    a: "0.6"
  }, {
    n: ["face", "sleep", "good night", "sleepy face"],
    u: "1f62a",
    a: "0.6"
  }, {
    n: ["face", "drooling", "drooling face"],
    u: "1f924",
    a: "3"
  }, {
    n: ["zzz", "face", "sleep", "good night", "sleeping face"],
    u: "1f634",
    a: "1"
  }, {
    n: ["cold", "face", "mask", "sick", "doctor", "face with medical mask"],
    u: "1f637",
    a: "0.6"
  }, {
    n: ["ill", "face", "sick", "thermometer", "face with thermometer"],
    u: "1f912",
    a: "1"
  }, {
    n: ["face", "hurt", "injury", "bandage", "face with head bandage"],
    u: "1f915",
    a: "1"
  }, {
    n: ["face", "vomit", "nauseated", "nauseated face"],
    u: "1f922",
    a: "3"
  }, {
    n: ["puke", "sick", "vomit", "face vomiting"],
    u: "1f92e",
    a: "5"
  }, {
    n: ["face", "sneeze", "gesundheit", "sneezing face"],
    u: "1f927",
    a: "3"
  }, {
    n: ["hot", "hot face", "feverish", "sweating", "red faced", "heat stroke"],
    u: "1f975",
    a: "11"
  }, {
    n: ["cold", "icicles", "freezing", "cold face", "frostbite", "blue faced"],
    u: "1f976",
    a: "11"
  }, {
    n: ["dizzy", "tipsy", "woozy face", "wavy mouth", "intoxicated", "uneven eyes"],
    u: "1f974",
    a: "11"
  }, {
    n: ["dead", "face", "knocked out", "crossed out eyes", "face with crossed out eyes"],
    u: "1f635",
    a: "0.6"
  }, {
    n: ["whoa", "dizzy", "spiral", "trouble", "hypnotized", "face with spiral eyes"],
    u: "1f635-200d-1f4ab",
    a: "13.1"
  }, {
    n: ["shocked", "mind blown", "exploding head"],
    u: "1f92f",
    a: "5"
  }, {
    n: ["hat", "face", "cowboy", "cowgirl", "cowboy hat face"],
    u: "1f920",
    a: "3"
  }, {
    n: ["hat", "horn", "party", "celebration", "partying face"],
    u: "1f973",
    a: "11"
  }, {
    n: ["face", "nose", "glasses", "disguise", "incognito", "disguised face"],
    u: "1f978",
    a: "13"
  }, {
    n: ["sun", "cool", "face", "bright", "sunglasses", "smiling face with sunglasses"],
    u: "1f60e",
    a: "1"
  }, {
    n: ["face", "geek", "nerd", "nerd face"],
    u: "1f913",
    a: "1"
  }, {
    n: ["face", "stuffy", "monocle", "face with monocle"],
    u: "1f9d0",
    a: "5"
  }, {
    n: ["meh", "face", "confused", "confused face"],
    u: "1f615",
    a: "1"
  }, {
    n: ["meh", "unsure", "skeptical", "disappointed", "face with diagonal mouth"],
    u: "1fae4",
    a: "14"
  }, {
    n: ["face", "worried", "worried face"],
    u: "1f61f",
    a: "1"
  }, {
    n: ["face", "frown", "slightly frowning face"],
    u: "1f641",
    a: "1"
  }, {
    n: ["face", "frown", "frowning face"],
    u: "2639-fe0f",
    a: "0.7"
  }, {
    n: ["face", "open", "mouth", "sympathy", "face with open mouth"],
    u: "1f62e",
    a: "1"
  }, {
    n: ["face", "hushed", "stunned", "surprised", "hushed face"],
    u: "1f62f",
    a: "1"
  }, {
    n: ["face", "shocked", "totally", "astonished", "astonished face"],
    u: "1f632",
    a: "0.6"
  }, {
    n: ["face", "dazed", "flushed", "flushed face"],
    u: "1f633",
    a: "0.6"
  }, {
    n: ["mercy", "begging", "puppy eyes", "pleading face"],
    u: "1f97a",
    a: "11"
  }, {
    n: ["cry", "sad", "angry", "proud", "resist", "face holding back tears"],
    u: "1f979",
    a: "14"
  }, {
    n: ["face", "open", "frown", "mouth", "frowning face with open mouth"],
    u: "1f626",
    a: "1"
  }, {
    n: ["face", "anguished", "anguished face"],
    u: "1f627",
    a: "1"
  }, {
    n: ["face", "fear", "scared", "fearful", "fearful face"],
    u: "1f628",
    a: "0.6"
  }, {
    n: ["blue", "cold", "face", "sweat", "rushed", "anxious face with sweat"],
    u: "1f630",
    a: "0.6"
  }, {
    n: ["face", "whew", "relieved", "disappointed", "sad but relieved face"],
    u: "1f625",
    a: "0.6"
  }, {
    n: ["cry", "sad", "face", "tear", "crying face"],
    u: "1f622",
    a: "0.6"
  }, {
    n: ["cry", "sad", "sob", "face", "tear", "loudly crying face"],
    u: "1f62d",
    a: "0.6"
  }, {
    n: ["face", "fear", "munch", "scared", "scream", "face screaming in fear"],
    u: "1f631",
    a: "0.6"
  }, {
    n: ["face", "confounded", "confounded face"],
    u: "1f616",
    a: "0.6"
  }, {
    n: ["face", "persevere", "persevering face"],
    u: "1f623",
    a: "0.6"
  }, {
    n: ["face", "disappointed", "disappointed face"],
    u: "1f61e",
    a: "0.6"
  }, {
    n: ["cold", "face", "sweat", "downcast face with sweat"],
    u: "1f613",
    a: "0.6"
  }, {
    n: ["face", "tired", "weary", "weary face"],
    u: "1f629",
    a: "0.6"
  }, {
    n: ["face", "tired", "tired face"],
    u: "1f62b",
    a: "0.6"
  }, {
    n: ["yawn", "bored", "tired", "yawning face"],
    u: "1f971",
    a: "12"
  }, {
    n: ["won", "face", "triumph", "face with steam from nose"],
    u: "1f624",
    a: "0.6"
  }, {
    n: ["mad", "red", "face", "rage", "angry", "enraged", "pouting", "enraged face"],
    u: "1f621",
    a: "0.6"
  }, {
    n: ["mad", "face", "anger", "angry", "angry face"],
    u: "1f620",
    a: "0.6"
  }, {
    n: ["swearing", "face with symbols on mouth"],
    u: "1f92c",
    a: "5"
  }, {
    n: ["face", "horns", "smile", "fantasy", "fairy tale", "smiling face with horns"],
    u: "1f608",
    a: "1"
  }, {
    n: ["imp", "face", "demon", "devil", "fantasy", "angry face with horns"],
    u: "1f47f",
    a: "0.6"
  }, {
    n: ["face", "skull", "death", "monster", "fairy tale"],
    u: "1f480",
    a: "0.6"
  }, {
    n: ["face", "death", "skull", "monster", "crossbones", "skull and crossbones"],
    u: "2620-fe0f",
    a: "1"
  }, {
    n: ["poo", "dung", "face", "poop", "monster", "pile of poo"],
    u: "1f4a9",
    a: "0.6"
  }, {
    n: ["face", "clown", "clown face"],
    u: "1f921",
    a: "3"
  }, {
    n: ["ogre", "face", "fantasy", "monster", "creature", "fairy tale"],
    u: "1f479",
    a: "0.6"
  }, {
    n: ["face", "goblin", "fantasy", "monster", "creature", "fairy tale"],
    u: "1f47a",
    a: "0.6"
  }, {
    n: ["face", "ghost", "fantasy", "monster", "creature", "fairy tale"],
    u: "1f47b",
    a: "0.6"
  }, {
    n: ["ufo", "face", "alien", "fantasy", "creature", "extraterrestrial"],
    u: "1f47d",
    a: "0.6"
  }, {
    n: ["ufo", "face", "alien", "monster", "creature", "alien monster", "extraterrestrial"],
    u: "1f47e",
    a: "0.6"
  }, {
    n: ["face", "robot", "monster"],
    u: "1f916",
    a: "1"
  }, {
    n: ["cat", "face", "open", "mouth", "smile", "grinning", "grinning cat"],
    u: "1f63a",
    a: "0.6"
  }, {
    n: ["cat", "eye", "face", "grin", "smile", "grinning cat with smiling eyes"],
    u: "1f638",
    a: "0.6"
  }, {
    n: ["cat", "joy", "face", "tear", "cat with tears of joy"],
    u: "1f639",
    a: "0.6"
  }, {
    n: ["cat", "eye", "face", "love", "heart", "smile", "smiling cat with heart eyes"],
    u: "1f63b",
    a: "0.6"
  }, {
    n: ["cat", "wry", "face", "smile", "ironic", "cat with wry smile"],
    u: "1f63c",
    a: "0.6"
  }, {
    n: ["cat", "eye", "face", "kiss", "kissing cat"],
    u: "1f63d",
    a: "0.6"
  }, {
    n: ["oh", "cat", "face", "weary", "weary cat", "surprised"],
    u: "1f640",
    a: "0.6"
  }, {
    n: ["cat", "cry", "sad", "face", "tear", "crying cat"],
    u: "1f63f",
    a: "0.6"
  }, {
    n: ["cat", "face", "pouting", "pouting cat"],
    u: "1f63e",
    a: "0.6"
  }, {
    n: ["see", "evil", "face", "monkey", "forbidden", "see no evil monkey"],
    u: "1f648",
    a: "0.6"
  }, {
    n: ["evil", "face", "hear", "monkey", "forbidden", "hear no evil monkey"],
    u: "1f649",
    a: "0.6"
  }, {
    n: ["evil", "face", "speak", "monkey", "forbidden", "speak no evil monkey"],
    u: "1f64a",
    a: "0.6"
  }, {
    n: ["love", "mail", "heart", "letter", "love letter"],
    u: "1f48c",
    a: "0.6"
  }, {
    n: ["arrow", "cupid", "heart with arrow"],
    u: "1f498",
    a: "0.6"
  }, {
    n: ["ribbon", "valentine", "heart with ribbon"],
    u: "1f49d",
    a: "0.6"
  }, {
    n: ["excited", "sparkle", "sparkling heart"],
    u: "1f496",
    a: "0.6"
  }, {
    n: ["pulse", "excited", "growing", "nervous", "growing heart"],
    u: "1f497",
    a: "0.6"
  }, {
    n: ["beating", "heartbeat", "pulsating", "beating heart"],
    u: "1f493",
    a: "0.6"
  }, {
    n: ["revolving", "revolving hearts"],
    u: "1f49e",
    a: "0.6"
  }, {
    n: ["love", "two hearts"],
    u: "1f495",
    a: "0.6"
  }, {
    n: ["heart", "heart decoration"],
    u: "1f49f",
    a: "0.6"
  }, {
    n: ["mark", "exclamation", "punctuation", "heart exclamation"],
    u: "2763-fe0f",
    a: "1"
  }, {
    n: ["break", "broken", "broken heart"],
    u: "1f494",
    a: "0.6"
  }, {
    n: ["burn", "love", "lust", "heart", "sacred heart", "heart on fire"],
    u: "2764-fe0f-200d-1f525",
    a: "13.1"
  }, {
    n: ["well", "mending", "healthier", "improving", "recovering", "recuperating", "mending heart"],
    u: "2764-fe0f-200d-1fa79",
    a: "13.1"
  }, {
    n: ["heart", "red heart"],
    u: "2764-fe0f",
    a: "0.6"
  }, {
    n: ["cute", "like", "love", "pink", "heart", "pink heart"],
    u: "1fa77",
    a: "15"
  }, {
    n: ["orange", "orange heart"],
    u: "1f9e1",
    a: "5"
  }, {
    n: ["yellow", "yellow heart"],
    u: "1f49b",
    a: "0.6"
  }, {
    n: ["green", "green heart"],
    u: "1f49a",
    a: "0.6"
  }, {
    n: ["blue", "blue heart"],
    u: "1f499",
    a: "0.6"
  }, {
    n: ["cyan", "teal", "heart", "light blue", "light blue heart"],
    u: "1fa75",
    a: "15"
  }, {
    n: ["purple", "purple heart"],
    u: "1f49c",
    a: "0.6"
  }, {
    n: ["brown", "heart", "brown heart"],
    u: "1f90e",
    a: "12"
  }, {
    n: ["evil", "black", "wicked", "black heart"],
    u: "1f5a4",
    a: "3"
  }, {
    n: ["gray", "heart", "slate", "silver", "grey heart"],
    u: "1fa76",
    a: "15"
  }, {
    n: ["heart", "white", "white heart"],
    u: "1f90d",
    a: "12"
  }, {
    n: ["kiss", "lips", "kiss mark"],
    u: "1f48b",
    a: "0.6"
  }, {
    n: ["100", "full", "score", "hundred", "hundred points"],
    u: "1f4af",
    a: "0.6"
  }, {
    n: ["mad", "angry", "comic", "anger symbol"],
    u: "1f4a2",
    a: "0.6"
  }, {
    n: ["boom", "comic", "collision"],
    u: "1f4a5",
    a: "0.6"
  }, {
    n: ["star", "dizzy", "comic"],
    u: "1f4ab",
    a: "0.6"
  }, {
    n: ["comic", "sweat", "splashing", "sweat droplets"],
    u: "1f4a6",
    a: "0.6"
  }, {
    n: ["dash", "comic", "running", "dashing away"],
    u: "1f4a8",
    a: "0.6"
  }, {
    n: ["hole"],
    u: "1f573-fe0f",
    a: "0.7"
  }, {
    n: ["comic", "bubble", "dialog", "speech", "balloon", "speech balloon"],
    u: "1f4ac",
    a: "0.6"
  }, {
    n: ["eye", "bubble", "speech", "balloon", "witness", "eye in speech bubble"],
    u: "1f441-fe0f-200d-1f5e8-fe0f",
    a: "2"
  }, {
    n: ["bubble", "dialog", "speech", "balloon", "left speech bubble"],
    u: "1f5e8-fe0f",
    a: "2"
  }, {
    n: ["mad", "angry", "bubble", "balloon", "right anger bubble"],
    u: "1f5ef-fe0f",
    a: "0.7"
  }, {
    n: ["comic", "bubble", "balloon", "thought", "thought balloon"],
    u: "1f4ad",
    a: "1"
  }, {
    n: ["ZZZ", "zzz", "comic", "sleep", "good night"],
    u: "1f4a4",
    a: "0.6"
  }, {
    n: ["hand", "wave", "waving", "waving hand"],
    u: "1f44b",
    v: ["1f44b-1f3fb", "1f44b-1f3fc", "1f44b-1f3fd", "1f44b-1f3fe", "1f44b-1f3ff"],
    a: "0.6"
  }, {
    n: ["raised", "backhand", "raised back of hand"],
    u: "1f91a",
    v: ["1f91a-1f3fb", "1f91a-1f3fc", "1f91a-1f3fd", "1f91a-1f3fe", "1f91a-1f3ff"],
    a: "3"
  }, {
    n: ["hand", "finger", "splayed", "hand with fingers splayed"],
    u: "1f590-fe0f",
    v: ["1f590-1f3fb", "1f590-1f3fc", "1f590-1f3fd", "1f590-1f3fe", "1f590-1f3ff"],
    a: "0.7"
  }, {
    n: ["hand", "high 5", "high five", "raised hand"],
    u: "270b",
    v: ["270b-1f3fb", "270b-1f3fc", "270b-1f3fd", "270b-1f3fe", "270b-1f3ff"],
    a: "0.6"
  }, {
    n: ["hand", "spock", "finger", "vulcan", "vulcan salute"],
    u: "1f596",
    v: ["1f596-1f3fb", "1f596-1f3fc", "1f596-1f3fd", "1f596-1f3fe", "1f596-1f3ff"],
    a: "1"
  }, {
    n: ["hand", "right", "rightward", "rightwards hand"],
    u: "1faf1",
    v: ["1faf1-1f3fb", "1faf1-1f3fc", "1faf1-1f3fd", "1faf1-1f3fe", "1faf1-1f3ff"],
    a: "14"
  }, {
    n: ["hand", "left", "leftward", "leftwards hand"],
    u: "1faf2",
    v: ["1faf2-1f3fb", "1faf2-1f3fc", "1faf2-1f3fd", "1faf2-1f3fe", "1faf2-1f3ff"],
    a: "14"
  }, {
    n: ["drop", "shoo", "dismiss", "palm down hand"],
    u: "1faf3",
    v: ["1faf3-1f3fb", "1faf3-1f3fc", "1faf3-1f3fd", "1faf3-1f3fe", "1faf3-1f3ff"],
    a: "14"
  }, {
    n: ["come", "catch", "offer", "beckon", "palm up hand"],
    u: "1faf4",
    v: ["1faf4-1f3fb", "1faf4-1f3fc", "1faf4-1f3fd", "1faf4-1f3fe", "1faf4-1f3ff"],
    a: "14"
  }, {
    n: ["push", "stop", "wait", "refuse", "leftward", "high five", "leftwards pushing hand"],
    u: "1faf7",
    v: ["1faf7-1f3fb", "1faf7-1f3fc", "1faf7-1f3fd", "1faf7-1f3fe", "1faf7-1f3ff"],
    a: "15"
  }, {
    n: ["push", "stop", "wait", "refuse", "high five", "rightward", "rightwards pushing hand"],
    u: "1faf8",
    v: ["1faf8-1f3fb", "1faf8-1f3fc", "1faf8-1f3fd", "1faf8-1f3fe", "1faf8-1f3ff"],
    a: "15"
  }, {
    n: ["ok", "hand", "OK hand"],
    u: "1f44c",
    v: ["1f44c-1f3fb", "1f44c-1f3fc", "1f44c-1f3fd", "1f44c-1f3fe", "1f44c-1f3ff"],
    a: "0.6"
  }, {
    n: ["fingers", "pinched", "sarcastic", "hand gesture", "interrogation", "pinched fingers"],
    u: "1f90c",
    v: ["1f90c-1f3fb", "1f90c-1f3fc", "1f90c-1f3fd", "1f90c-1f3fe", "1f90c-1f3ff"],
    a: "13"
  }, {
    n: ["small amount", "pinching hand"],
    u: "1f90f",
    v: ["1f90f-1f3fb", "1f90f-1f3fc", "1f90f-1f3fd", "1f90f-1f3fe", "1f90f-1f3ff"],
    a: "12"
  }, {
    n: ["v", "hand", "victory", "victory hand"],
    u: "270c-fe0f",
    v: ["270c-1f3fb", "270c-1f3fc", "270c-1f3fd", "270c-1f3fe", "270c-1f3ff"],
    a: "0.6"
  }, {
    n: ["hand", "luck", "cross", "finger", "crossed fingers"],
    u: "1f91e",
    v: ["1f91e-1f3fb", "1f91e-1f3fc", "1f91e-1f3fd", "1f91e-1f3fe", "1f91e-1f3ff"],
    a: "3"
  }, {
    n: ["love", "snap", "heart", "money", "expensive", "hand with index finger and thumb crossed"],
    u: "1faf0",
    v: ["1faf0-1f3fb", "1faf0-1f3fc", "1faf0-1f3fd", "1faf0-1f3fe", "1faf0-1f3ff"],
    a: "14"
  }, {
    n: ["ily", "hand", "love you gesture"],
    u: "1f91f",
    v: ["1f91f-1f3fb", "1f91f-1f3fc", "1f91f-1f3fd", "1f91f-1f3fe", "1f91f-1f3ff"],
    a: "5"
  }, {
    n: ["hand", "horns", "finger", "rock on", "sign of the horns"],
    u: "1f918",
    v: ["1f918-1f3fb", "1f918-1f3fc", "1f918-1f3fd", "1f918-1f3fe", "1f918-1f3ff"],
    a: "1"
  }, {
    n: ["call", "hand", "shaka", "hang loose", "call me hand"],
    u: "1f919",
    v: ["1f919-1f3fb", "1f919-1f3fc", "1f919-1f3fd", "1f919-1f3fe", "1f919-1f3ff"],
    a: "3"
  }, {
    n: ["hand", "index", "point", "finger", "backhand", "backhand index pointing left"],
    u: "1f448",
    v: ["1f448-1f3fb", "1f448-1f3fc", "1f448-1f3fd", "1f448-1f3fe", "1f448-1f3ff"],
    a: "0.6"
  }, {
    n: ["hand", "index", "point", "finger", "backhand", "backhand index pointing right"],
    u: "1f449",
    v: ["1f449-1f3fb", "1f449-1f3fc", "1f449-1f3fd", "1f449-1f3fe", "1f449-1f3ff"],
    a: "0.6"
  }, {
    n: ["up", "hand", "point", "finger", "backhand", "backhand index pointing up"],
    u: "1f446",
    v: ["1f446-1f3fb", "1f446-1f3fc", "1f446-1f3fd", "1f446-1f3fe", "1f446-1f3ff"],
    a: "0.6"
  }, {
    n: ["hand", "finger", "middle finger"],
    u: "1f595",
    v: ["1f595-1f3fb", "1f595-1f3fc", "1f595-1f3fd", "1f595-1f3fe", "1f595-1f3ff"],
    a: "1"
  }, {
    n: ["down", "hand", "point", "finger", "backhand", "backhand index pointing down"],
    u: "1f447",
    v: ["1f447-1f3fb", "1f447-1f3fc", "1f447-1f3fd", "1f447-1f3fe", "1f447-1f3ff"],
    a: "0.6"
  }, {
    n: ["up", "hand", "index", "point", "finger", "index pointing up"],
    u: "261d-fe0f",
    v: ["261d-1f3fb", "261d-1f3fc", "261d-1f3fd", "261d-1f3fe", "261d-1f3ff"],
    a: "0.6"
  }, {
    n: ["you", "point", "index pointing at the viewer"],
    u: "1faf5",
    v: ["1faf5-1f3fb", "1faf5-1f3fc", "1faf5-1f3fd", "1faf5-1f3fe", "1faf5-1f3ff"],
    a: "14"
  }, {
    n: ["+1", "up", "hand", "thumb", "thumbs up"],
    u: "1f44d",
    v: ["1f44d-1f3fb", "1f44d-1f3fc", "1f44d-1f3fd", "1f44d-1f3fe", "1f44d-1f3ff"],
    a: "0.6"
  }, {
    n: [" 1", "down", "hand", "thumb", "thumbs down"],
    u: "1f44e",
    v: ["1f44e-1f3fb", "1f44e-1f3fc", "1f44e-1f3fd", "1f44e-1f3fe", "1f44e-1f3ff"],
    a: "0.6"
  }, {
    n: ["fist", "hand", "punch", "clenched", "raised fist"],
    u: "270a",
    v: ["270a-1f3fb", "270a-1f3fc", "270a-1f3fd", "270a-1f3fe", "270a-1f3ff"],
    a: "0.6"
  }, {
    n: ["fist", "hand", "punch", "clenched", "oncoming fist"],
    u: "1f44a",
    v: ["1f44a-1f3fb", "1f44a-1f3fc", "1f44a-1f3fd", "1f44a-1f3fe", "1f44a-1f3ff"],
    a: "0.6"
  }, {
    n: ["fist", "leftwards", "left facing fist"],
    u: "1f91b",
    v: ["1f91b-1f3fb", "1f91b-1f3fc", "1f91b-1f3fd", "1f91b-1f3fe", "1f91b-1f3ff"],
    a: "3"
  }, {
    n: ["fist", "rightwards", "right facing fist"],
    u: "1f91c",
    v: ["1f91c-1f3fb", "1f91c-1f3fc", "1f91c-1f3fd", "1f91c-1f3fe", "1f91c-1f3ff"],
    a: "3"
  }, {
    n: ["clap", "hand", "clapping hands"],
    u: "1f44f",
    v: ["1f44f-1f3fb", "1f44f-1f3fc", "1f44f-1f3fd", "1f44f-1f3fe", "1f44f-1f3ff"],
    a: "0.6"
  }, {
    n: ["hand", "hooray", "raised", "gesture", "celebration", "raising hands"],
    u: "1f64c",
    v: ["1f64c-1f3fb", "1f64c-1f3fc", "1f64c-1f3fd", "1f64c-1f3fe", "1f64c-1f3ff"],
    a: "0.6"
  }, {
    n: ["love", "heart hands"],
    u: "1faf6",
    v: ["1faf6-1f3fb", "1faf6-1f3fc", "1faf6-1f3fd", "1faf6-1f3fe", "1faf6-1f3ff"],
    a: "14"
  }, {
    n: ["hand", "open", "open hands"],
    u: "1f450",
    v: ["1f450-1f3fb", "1f450-1f3fc", "1f450-1f3fd", "1f450-1f3fe", "1f450-1f3ff"],
    a: "0.6"
  }, {
    n: ["prayer", "palms up together"],
    u: "1f932",
    v: ["1f932-1f3fb", "1f932-1f3fc", "1f932-1f3fd", "1f932-1f3fe", "1f932-1f3ff"],
    a: "5"
  }, {
    n: ["hand", "shake", "meeting", "handshake", "agreement"],
    u: "1f91d",
    v: ["1f91d-1f3fb", "1f91d-1f3fc", "1f91d-1f3fd", "1f91d-1f3fe", "1f91d-1f3ff", "1faf1-1f3fb-200d-1faf2-1f3fc", "1faf1-1f3fb-200d-1faf2-1f3fd", "1faf1-1f3fb-200d-1faf2-1f3fe", "1faf1-1f3fb-200d-1faf2-1f3ff", "1faf1-1f3fc-200d-1faf2-1f3fb", "1faf1-1f3fc-200d-1faf2-1f3fd", "1faf1-1f3fc-200d-1faf2-1f3fe", "1faf1-1f3fc-200d-1faf2-1f3ff", "1faf1-1f3fd-200d-1faf2-1f3fb", "1faf1-1f3fd-200d-1faf2-1f3fc", "1faf1-1f3fd-200d-1faf2-1f3fe", "1faf1-1f3fd-200d-1faf2-1f3ff", "1faf1-1f3fe-200d-1faf2-1f3fb", "1faf1-1f3fe-200d-1faf2-1f3fc", "1faf1-1f3fe-200d-1faf2-1f3fd", "1faf1-1f3fe-200d-1faf2-1f3ff", "1faf1-1f3ff-200d-1faf2-1f3fb", "1faf1-1f3ff-200d-1faf2-1f3fc", "1faf1-1f3ff-200d-1faf2-1f3fd", "1faf1-1f3ff-200d-1faf2-1f3fe"],
    a: "3"
  }, {
    n: ["ask", "hand", "pray", "high 5", "please", "thanks", "high five", "folded hands"],
    u: "1f64f",
    v: ["1f64f-1f3fb", "1f64f-1f3fc", "1f64f-1f3fd", "1f64f-1f3fe", "1f64f-1f3ff"],
    a: "0.6"
  }, {
    n: ["hand", "write", "writing hand"],
    u: "270d-fe0f",
    v: ["270d-1f3fb", "270d-1f3fc", "270d-1f3fd", "270d-1f3fe", "270d-1f3ff"],
    a: "0.7"
  }, {
    n: ["care", "nail", "polish", "manicure", "cosmetics", "nail polish"],
    u: "1f485",
    v: ["1f485-1f3fb", "1f485-1f3fc", "1f485-1f3fd", "1f485-1f3fe", "1f485-1f3ff"],
    a: "0.6"
  }, {
    n: ["phone", "selfie", "camera"],
    u: "1f933",
    v: ["1f933-1f3fb", "1f933-1f3fc", "1f933-1f3fd", "1f933-1f3fe", "1f933-1f3ff"],
    a: "3"
  }, {
    n: ["flex", "comic", "biceps", "muscle", "flexed biceps"],
    u: "1f4aa",
    v: ["1f4aa-1f3fb", "1f4aa-1f3fc", "1f4aa-1f3fd", "1f4aa-1f3fe", "1f4aa-1f3ff"],
    a: "0.6"
  }, {
    n: ["prosthetic", "accessibility", "mechanical arm"],
    u: "1f9be",
    a: "12"
  }, {
    n: ["prosthetic", "accessibility", "mechanical leg"],
    u: "1f9bf",
    a: "12"
  }, {
    n: ["leg", "kick", "limb"],
    u: "1f9b5",
    v: ["1f9b5-1f3fb", "1f9b5-1f3fc", "1f9b5-1f3fd", "1f9b5-1f3fe", "1f9b5-1f3ff"],
    a: "11"
  }, {
    n: ["foot", "kick", "stomp"],
    u: "1f9b6",
    v: ["1f9b6-1f3fb", "1f9b6-1f3fc", "1f9b6-1f3fd", "1f9b6-1f3fe", "1f9b6-1f3ff"],
    a: "11"
  }, {
    n: ["ear", "body"],
    u: "1f442",
    v: ["1f442-1f3fb", "1f442-1f3fc", "1f442-1f3fd", "1f442-1f3fe", "1f442-1f3ff"],
    a: "0.6"
  }, {
    n: ["accessibility", "hard of hearing", "ear with hearing aid"],
    u: "1f9bb",
    v: ["1f9bb-1f3fb", "1f9bb-1f3fc", "1f9bb-1f3fd", "1f9bb-1f3fe", "1f9bb-1f3ff"],
    a: "12"
  }, {
    n: ["nose", "body"],
    u: "1f443",
    v: ["1f443-1f3fb", "1f443-1f3fc", "1f443-1f3fd", "1f443-1f3fe", "1f443-1f3ff"],
    a: "0.6"
  }, {
    n: ["brain", "intelligent"],
    u: "1f9e0",
    a: "5"
  }, {
    n: ["heart", "organ", "pulse", "anatomical", "cardiology", "anatomical heart"],
    u: "1fac0",
    a: "13"
  }, {
    n: ["lungs", "organ", "breath", "exhalation", "inhalation", "respiration"],
    u: "1fac1",
    a: "13"
  }, {
    n: ["tooth", "dentist"],
    u: "1f9b7",
    a: "11"
  }, {
    n: ["bone", "skeleton"],
    u: "1f9b4",
    a: "11"
  }, {
    n: ["eye", "eyes", "face"],
    u: "1f440",
    a: "0.6"
  }, {
    n: ["eye", "body"],
    u: "1f441-fe0f",
    a: "0.7"
  }, {
    n: ["body", "tongue"],
    u: "1f445",
    a: "0.6"
  }, {
    n: ["lips", "mouth"],
    u: "1f444",
    a: "0.6"
  }, {
    n: ["fear", "anxious", "nervous", "worried", "flirting", "biting lip", "uncomfortable"],
    u: "1fae6",
    a: "14"
  }, {
    n: ["baby", "young"],
    u: "1f476",
    v: ["1f476-1f3fb", "1f476-1f3fc", "1f476-1f3fd", "1f476-1f3fe", "1f476-1f3ff"],
    a: "0.6"
  }, {
    n: ["child", "young", "gender neutral", "unspecified gender"],
    u: "1f9d2",
    v: ["1f9d2-1f3fb", "1f9d2-1f3fc", "1f9d2-1f3fd", "1f9d2-1f3fe", "1f9d2-1f3ff"],
    a: "5"
  }, {
    n: ["boy", "young"],
    u: "1f466",
    v: ["1f466-1f3fb", "1f466-1f3fc", "1f466-1f3fd", "1f466-1f3fe", "1f466-1f3ff"],
    a: "0.6"
  }, {
    n: ["girl", "virgo", "young", "zodiac"],
    u: "1f467",
    v: ["1f467-1f3fb", "1f467-1f3fc", "1f467-1f3fd", "1f467-1f3fe", "1f467-1f3ff"],
    a: "0.6"
  }, {
    n: ["adult", "person", "gender neutral", "unspecified gender"],
    u: "1f9d1",
    v: ["1f9d1-1f3fb", "1f9d1-1f3fc", "1f9d1-1f3fd", "1f9d1-1f3fe", "1f9d1-1f3ff"],
    a: "5"
  }, {
    n: ["hair", "blond", "person: blond hair", "blond haired person"],
    u: "1f471",
    v: ["1f471-1f3fb", "1f471-1f3fc", "1f471-1f3fd", "1f471-1f3fe", "1f471-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "adult"],
    u: "1f468",
    v: ["1f468-1f3fb", "1f468-1f3fc", "1f468-1f3fd", "1f468-1f3fe", "1f468-1f3ff"],
    a: "0.6"
  }, {
    n: ["beard", "person", "person: beard"],
    u: "1f9d4",
    v: ["1f9d4-1f3fb", "1f9d4-1f3fc", "1f9d4-1f3fd", "1f9d4-1f3fe", "1f9d4-1f3ff"],
    a: "5"
  }, {
    n: ["man", "beard", "man: beard"],
    u: "1f9d4-200d-2642-fe0f",
    v: ["1f9d4-1f3fb-200d-2642-fe0f", "1f9d4-1f3fc-200d-2642-fe0f", "1f9d4-1f3fd-200d-2642-fe0f", "1f9d4-1f3fe-200d-2642-fe0f", "1f9d4-1f3ff-200d-2642-fe0f"],
    a: "13.1"
  }, {
    n: ["beard", "woman", "woman: beard"],
    u: "1f9d4-200d-2640-fe0f",
    v: ["1f9d4-1f3fb-200d-2640-fe0f", "1f9d4-1f3fc-200d-2640-fe0f", "1f9d4-1f3fd-200d-2640-fe0f", "1f9d4-1f3fe-200d-2640-fe0f", "1f9d4-1f3ff-200d-2640-fe0f"],
    a: "13.1"
  }, {
    n: ["man", "adult", "red hair", "man: red hair"],
    u: "1f468-200d-1f9b0",
    v: ["1f468-1f3fb-200d-1f9b0", "1f468-1f3fc-200d-1f9b0", "1f468-1f3fd-200d-1f9b0", "1f468-1f3fe-200d-1f9b0", "1f468-1f3ff-200d-1f9b0"],
    a: "11"
  }, {
    n: ["man", "adult", "curly hair", "man: curly hair"],
    u: "1f468-200d-1f9b1",
    v: ["1f468-1f3fb-200d-1f9b1", "1f468-1f3fc-200d-1f9b1", "1f468-1f3fd-200d-1f9b1", "1f468-1f3fe-200d-1f9b1", "1f468-1f3ff-200d-1f9b1"],
    a: "11"
  }, {
    n: ["man", "adult", "white hair", "man: white hair"],
    u: "1f468-200d-1f9b3",
    v: ["1f468-1f3fb-200d-1f9b3", "1f468-1f3fc-200d-1f9b3", "1f468-1f3fd-200d-1f9b3", "1f468-1f3fe-200d-1f9b3", "1f468-1f3ff-200d-1f9b3"],
    a: "11"
  }, {
    n: ["man", "bald", "adult", "man: bald"],
    u: "1f468-200d-1f9b2",
    v: ["1f468-1f3fb-200d-1f9b2", "1f468-1f3fc-200d-1f9b2", "1f468-1f3fd-200d-1f9b2", "1f468-1f3fe-200d-1f9b2", "1f468-1f3ff-200d-1f9b2"],
    a: "11"
  }, {
    n: ["woman", "adult"],
    u: "1f469",
    v: ["1f469-1f3fb", "1f469-1f3fc", "1f469-1f3fd", "1f469-1f3fe", "1f469-1f3ff"],
    a: "0.6"
  }, {
    n: ["adult", "woman", "red hair", "woman: red hair"],
    u: "1f469-200d-1f9b0",
    v: ["1f469-1f3fb-200d-1f9b0", "1f469-1f3fc-200d-1f9b0", "1f469-1f3fd-200d-1f9b0", "1f469-1f3fe-200d-1f9b0", "1f469-1f3ff-200d-1f9b0"],
    a: "11"
  }, {
    n: ["adult", "person", "red hair", "gender neutral", "person: red hair", "unspecified gender"],
    u: "1f9d1-200d-1f9b0",
    v: ["1f9d1-1f3fb-200d-1f9b0", "1f9d1-1f3fc-200d-1f9b0", "1f9d1-1f3fd-200d-1f9b0", "1f9d1-1f3fe-200d-1f9b0", "1f9d1-1f3ff-200d-1f9b0"],
    a: "12.1"
  }, {
    n: ["adult", "woman", "curly hair", "woman: curly hair"],
    u: "1f469-200d-1f9b1",
    v: ["1f469-1f3fb-200d-1f9b1", "1f469-1f3fc-200d-1f9b1", "1f469-1f3fd-200d-1f9b1", "1f469-1f3fe-200d-1f9b1", "1f469-1f3ff-200d-1f9b1"],
    a: "11"
  }, {
    n: ["adult", "person", "curly hair", "gender neutral", "person: curly hair", "unspecified gender"],
    u: "1f9d1-200d-1f9b1",
    v: ["1f9d1-1f3fb-200d-1f9b1", "1f9d1-1f3fc-200d-1f9b1", "1f9d1-1f3fd-200d-1f9b1", "1f9d1-1f3fe-200d-1f9b1", "1f9d1-1f3ff-200d-1f9b1"],
    a: "12.1"
  }, {
    n: ["adult", "woman", "white hair", "woman: white hair"],
    u: "1f469-200d-1f9b3",
    v: ["1f469-1f3fb-200d-1f9b3", "1f469-1f3fc-200d-1f9b3", "1f469-1f3fd-200d-1f9b3", "1f469-1f3fe-200d-1f9b3", "1f469-1f3ff-200d-1f9b3"],
    a: "11"
  }, {
    n: ["adult", "person", "white hair", "gender neutral", "person: white hair", "unspecified gender"],
    u: "1f9d1-200d-1f9b3",
    v: ["1f9d1-1f3fb-200d-1f9b3", "1f9d1-1f3fc-200d-1f9b3", "1f9d1-1f3fd-200d-1f9b3", "1f9d1-1f3fe-200d-1f9b3", "1f9d1-1f3ff-200d-1f9b3"],
    a: "12.1"
  }, {
    n: ["bald", "adult", "woman", "woman: bald"],
    u: "1f469-200d-1f9b2",
    v: ["1f469-1f3fb-200d-1f9b2", "1f469-1f3fc-200d-1f9b2", "1f469-1f3fd-200d-1f9b2", "1f469-1f3fe-200d-1f9b2", "1f469-1f3ff-200d-1f9b2"],
    a: "11"
  }, {
    n: ["bald", "adult", "person", "person: bald", "gender neutral", "unspecified gender"],
    u: "1f9d1-200d-1f9b2",
    v: ["1f9d1-1f3fb-200d-1f9b2", "1f9d1-1f3fc-200d-1f9b2", "1f9d1-1f3fd-200d-1f9b2", "1f9d1-1f3fe-200d-1f9b2", "1f9d1-1f3ff-200d-1f9b2"],
    a: "12.1"
  }, {
    n: ["hair", "woman", "blonde", "woman: blond hair", "blond haired woman"],
    u: "1f471-200d-2640-fe0f",
    v: ["1f471-1f3fb-200d-2640-fe0f", "1f471-1f3fc-200d-2640-fe0f", "1f471-1f3fd-200d-2640-fe0f", "1f471-1f3fe-200d-2640-fe0f", "1f471-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["man", "hair", "blond", "man: blond hair", "blond haired man"],
    u: "1f471-200d-2642-fe0f",
    v: ["1f471-1f3fb-200d-2642-fe0f", "1f471-1f3fc-200d-2642-fe0f", "1f471-1f3fd-200d-2642-fe0f", "1f471-1f3fe-200d-2642-fe0f", "1f471-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["old", "adult", "older person", "gender neutral", "unspecified gender"],
    u: "1f9d3",
    v: ["1f9d3-1f3fb", "1f9d3-1f3fc", "1f9d3-1f3fd", "1f9d3-1f3fe", "1f9d3-1f3ff"],
    a: "5"
  }, {
    n: ["man", "old", "adult", "old man"],
    u: "1f474",
    v: ["1f474-1f3fb", "1f474-1f3fc", "1f474-1f3fd", "1f474-1f3fe", "1f474-1f3ff"],
    a: "0.6"
  }, {
    n: ["old", "adult", "woman", "old woman"],
    u: "1f475",
    v: ["1f475-1f3fb", "1f475-1f3fc", "1f475-1f3fd", "1f475-1f3fe", "1f475-1f3ff"],
    a: "0.6"
  }, {
    n: ["frown", "gesture", "person frowning"],
    u: "1f64d",
    v: ["1f64d-1f3fb", "1f64d-1f3fc", "1f64d-1f3fd", "1f64d-1f3fe", "1f64d-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "gesture", "frowning", "man frowning"],
    u: "1f64d-200d-2642-fe0f",
    v: ["1f64d-1f3fb-200d-2642-fe0f", "1f64d-1f3fc-200d-2642-fe0f", "1f64d-1f3fd-200d-2642-fe0f", "1f64d-1f3fe-200d-2642-fe0f", "1f64d-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["woman", "gesture", "frowning", "woman frowning"],
    u: "1f64d-200d-2640-fe0f",
    v: ["1f64d-1f3fb-200d-2640-fe0f", "1f64d-1f3fc-200d-2640-fe0f", "1f64d-1f3fd-200d-2640-fe0f", "1f64d-1f3fe-200d-2640-fe0f", "1f64d-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["gesture", "pouting", "person pouting"],
    u: "1f64e",
    v: ["1f64e-1f3fb", "1f64e-1f3fc", "1f64e-1f3fd", "1f64e-1f3fe", "1f64e-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "gesture", "pouting", "man pouting"],
    u: "1f64e-200d-2642-fe0f",
    v: ["1f64e-1f3fb-200d-2642-fe0f", "1f64e-1f3fc-200d-2642-fe0f", "1f64e-1f3fd-200d-2642-fe0f", "1f64e-1f3fe-200d-2642-fe0f", "1f64e-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["woman", "gesture", "pouting", "woman pouting"],
    u: "1f64e-200d-2640-fe0f",
    v: ["1f64e-1f3fb-200d-2640-fe0f", "1f64e-1f3fc-200d-2640-fe0f", "1f64e-1f3fd-200d-2640-fe0f", "1f64e-1f3fe-200d-2640-fe0f", "1f64e-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["hand", "gesture", "forbidden", "prohibited", "person gesturing NO", "person gesturing no"],
    u: "1f645",
    v: ["1f645-1f3fb", "1f645-1f3fc", "1f645-1f3fd", "1f645-1f3fe", "1f645-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "hand", "gesture", "forbidden", "prohibited", "man gesturing NO", "man gesturing no"],
    u: "1f645-200d-2642-fe0f",
    v: ["1f645-1f3fb-200d-2642-fe0f", "1f645-1f3fc-200d-2642-fe0f", "1f645-1f3fd-200d-2642-fe0f", "1f645-1f3fe-200d-2642-fe0f", "1f645-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["hand", "woman", "gesture", "forbidden", "prohibited", "woman gesturing NO", "woman gesturing no"],
    u: "1f645-200d-2640-fe0f",
    v: ["1f645-1f3fb-200d-2640-fe0f", "1f645-1f3fc-200d-2640-fe0f", "1f645-1f3fd-200d-2640-fe0f", "1f645-1f3fe-200d-2640-fe0f", "1f645-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["ok", "hand", "gesture", "person gesturing OK", "person gesturing ok"],
    u: "1f646",
    v: ["1f646-1f3fb", "1f646-1f3fc", "1f646-1f3fd", "1f646-1f3fe", "1f646-1f3ff"],
    a: "0.6"
  }, {
    n: ["ok", "man", "hand", "gesture", "man gesturing OK", "man gesturing ok"],
    u: "1f646-200d-2642-fe0f",
    v: ["1f646-1f3fb-200d-2642-fe0f", "1f646-1f3fc-200d-2642-fe0f", "1f646-1f3fd-200d-2642-fe0f", "1f646-1f3fe-200d-2642-fe0f", "1f646-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["ok", "hand", "woman", "gesture", "woman gesturing OK", "woman gesturing ok"],
    u: "1f646-200d-2640-fe0f",
    v: ["1f646-1f3fb-200d-2640-fe0f", "1f646-1f3fc-200d-2640-fe0f", "1f646-1f3fd-200d-2640-fe0f", "1f646-1f3fe-200d-2640-fe0f", "1f646-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["hand", "help", "sassy", "tipping", "information", "person tipping hand"],
    u: "1f481",
    v: ["1f481-1f3fb", "1f481-1f3fc", "1f481-1f3fd", "1f481-1f3fe", "1f481-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "sassy", "tipping hand", "man tipping hand"],
    u: "1f481-200d-2642-fe0f",
    v: ["1f481-1f3fb-200d-2642-fe0f", "1f481-1f3fc-200d-2642-fe0f", "1f481-1f3fd-200d-2642-fe0f", "1f481-1f3fe-200d-2642-fe0f", "1f481-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["sassy", "woman", "tipping hand", "woman tipping hand"],
    u: "1f481-200d-2640-fe0f",
    v: ["1f481-1f3fb-200d-2640-fe0f", "1f481-1f3fc-200d-2640-fe0f", "1f481-1f3fd-200d-2640-fe0f", "1f481-1f3fe-200d-2640-fe0f", "1f481-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["hand", "happy", "raised", "gesture", "person raising hand"],
    u: "1f64b",
    v: ["1f64b-1f3fb", "1f64b-1f3fc", "1f64b-1f3fd", "1f64b-1f3fe", "1f64b-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "gesture", "raising hand", "man raising hand"],
    u: "1f64b-200d-2642-fe0f",
    v: ["1f64b-1f3fb-200d-2642-fe0f", "1f64b-1f3fc-200d-2642-fe0f", "1f64b-1f3fd-200d-2642-fe0f", "1f64b-1f3fe-200d-2642-fe0f", "1f64b-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["woman", "gesture", "raising hand", "woman raising hand"],
    u: "1f64b-200d-2640-fe0f",
    v: ["1f64b-1f3fb-200d-2640-fe0f", "1f64b-1f3fc-200d-2640-fe0f", "1f64b-1f3fd-200d-2640-fe0f", "1f64b-1f3fe-200d-2640-fe0f", "1f64b-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["ear", "deaf", "hear", "deaf person", "accessibility"],
    u: "1f9cf",
    v: ["1f9cf-1f3fb", "1f9cf-1f3fc", "1f9cf-1f3fd", "1f9cf-1f3fe", "1f9cf-1f3ff"],
    a: "12"
  }, {
    n: ["man", "deaf", "deaf man"],
    u: "1f9cf-200d-2642-fe0f",
    v: ["1f9cf-1f3fb-200d-2642-fe0f", "1f9cf-1f3fc-200d-2642-fe0f", "1f9cf-1f3fd-200d-2642-fe0f", "1f9cf-1f3fe-200d-2642-fe0f", "1f9cf-1f3ff-200d-2642-fe0f"],
    a: "12"
  }, {
    n: ["deaf", "woman", "deaf woman"],
    u: "1f9cf-200d-2640-fe0f",
    v: ["1f9cf-1f3fb-200d-2640-fe0f", "1f9cf-1f3fc-200d-2640-fe0f", "1f9cf-1f3fd-200d-2640-fe0f", "1f9cf-1f3fe-200d-2640-fe0f", "1f9cf-1f3ff-200d-2640-fe0f"],
    a: "12"
  }, {
    n: ["bow", "sorry", "apology", "gesture", "person bowing"],
    u: "1f647",
    v: ["1f647-1f3fb", "1f647-1f3fc", "1f647-1f3fd", "1f647-1f3fe", "1f647-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "favor", "sorry", "bowing", "apology", "gesture", "man bowing"],
    u: "1f647-200d-2642-fe0f",
    v: ["1f647-1f3fb-200d-2642-fe0f", "1f647-1f3fc-200d-2642-fe0f", "1f647-1f3fd-200d-2642-fe0f", "1f647-1f3fe-200d-2642-fe0f", "1f647-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["favor", "sorry", "woman", "bowing", "apology", "gesture", "woman bowing"],
    u: "1f647-200d-2640-fe0f",
    v: ["1f647-1f3fb-200d-2640-fe0f", "1f647-1f3fc-200d-2640-fe0f", "1f647-1f3fd-200d-2640-fe0f", "1f647-1f3fe-200d-2640-fe0f", "1f647-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["face", "palm", "disbelief", "exasperation", "person facepalming"],
    u: "1f926",
    v: ["1f926-1f3fb", "1f926-1f3fc", "1f926-1f3fd", "1f926-1f3fe", "1f926-1f3ff"],
    a: "3"
  }, {
    n: ["man", "facepalm", "disbelief", "exasperation", "man facepalming"],
    u: "1f926-200d-2642-fe0f",
    v: ["1f926-1f3fb-200d-2642-fe0f", "1f926-1f3fc-200d-2642-fe0f", "1f926-1f3fd-200d-2642-fe0f", "1f926-1f3fe-200d-2642-fe0f", "1f926-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["woman", "facepalm", "disbelief", "exasperation", "woman facepalming"],
    u: "1f926-200d-2640-fe0f",
    v: ["1f926-1f3fb-200d-2640-fe0f", "1f926-1f3fc-200d-2640-fe0f", "1f926-1f3fd-200d-2640-fe0f", "1f926-1f3fe-200d-2640-fe0f", "1f926-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["doubt", "shrug", "ignorance", "indifference", "person shrugging"],
    u: "1f937",
    v: ["1f937-1f3fb", "1f937-1f3fc", "1f937-1f3fd", "1f937-1f3fe", "1f937-1f3ff"],
    a: "3"
  }, {
    n: ["man", "doubt", "shrug", "ignorance", "indifference", "man shrugging"],
    u: "1f937-200d-2642-fe0f",
    v: ["1f937-1f3fb-200d-2642-fe0f", "1f937-1f3fc-200d-2642-fe0f", "1f937-1f3fd-200d-2642-fe0f", "1f937-1f3fe-200d-2642-fe0f", "1f937-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["doubt", "shrug", "woman", "ignorance", "indifference", "woman shrugging"],
    u: "1f937-200d-2640-fe0f",
    v: ["1f937-1f3fb-200d-2640-fe0f", "1f937-1f3fc-200d-2640-fe0f", "1f937-1f3fd-200d-2640-fe0f", "1f937-1f3fe-200d-2640-fe0f", "1f937-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["nurse", "doctor", "therapist", "healthcare", "health worker"],
    u: "1f9d1-200d-2695-fe0f",
    v: ["1f9d1-1f3fb-200d-2695-fe0f", "1f9d1-1f3fc-200d-2695-fe0f", "1f9d1-1f3fd-200d-2695-fe0f", "1f9d1-1f3fe-200d-2695-fe0f", "1f9d1-1f3ff-200d-2695-fe0f"],
    a: "12.1"
  }, {
    n: ["man", "nurse", "doctor", "therapist", "healthcare", "man health worker"],
    u: "1f468-200d-2695-fe0f",
    v: ["1f468-1f3fb-200d-2695-fe0f", "1f468-1f3fc-200d-2695-fe0f", "1f468-1f3fd-200d-2695-fe0f", "1f468-1f3fe-200d-2695-fe0f", "1f468-1f3ff-200d-2695-fe0f"],
    a: "4"
  }, {
    n: ["nurse", "woman", "doctor", "therapist", "healthcare", "woman health worker"],
    u: "1f469-200d-2695-fe0f",
    v: ["1f469-1f3fb-200d-2695-fe0f", "1f469-1f3fc-200d-2695-fe0f", "1f469-1f3fd-200d-2695-fe0f", "1f469-1f3fe-200d-2695-fe0f", "1f469-1f3ff-200d-2695-fe0f"],
    a: "4"
  }, {
    n: ["student", "graduate"],
    u: "1f9d1-200d-1f393",
    v: ["1f9d1-1f3fb-200d-1f393", "1f9d1-1f3fc-200d-1f393", "1f9d1-1f3fd-200d-1f393", "1f9d1-1f3fe-200d-1f393", "1f9d1-1f3ff-200d-1f393"],
    a: "12.1"
  }, {
    n: ["man", "student", "graduate", "man student"],
    u: "1f468-200d-1f393",
    v: ["1f468-1f3fb-200d-1f393", "1f468-1f3fc-200d-1f393", "1f468-1f3fd-200d-1f393", "1f468-1f3fe-200d-1f393", "1f468-1f3ff-200d-1f393"],
    a: "4"
  }, {
    n: ["woman", "student", "graduate", "woman student"],
    u: "1f469-200d-1f393",
    v: ["1f469-1f3fb-200d-1f393", "1f469-1f3fc-200d-1f393", "1f469-1f3fd-200d-1f393", "1f469-1f3fe-200d-1f393", "1f469-1f3ff-200d-1f393"],
    a: "4"
  }, {
    n: ["teacher", "lecturer", "professor", "instructor"],
    u: "1f9d1-200d-1f3eb",
    v: ["1f9d1-1f3fb-200d-1f3eb", "1f9d1-1f3fc-200d-1f3eb", "1f9d1-1f3fd-200d-1f3eb", "1f9d1-1f3fe-200d-1f3eb", "1f9d1-1f3ff-200d-1f3eb"],
    a: "12.1"
  }, {
    n: ["man", "teacher", "lecturer", "professor", "instructor", "man teacher"],
    u: "1f468-200d-1f3eb",
    v: ["1f468-1f3fb-200d-1f3eb", "1f468-1f3fc-200d-1f3eb", "1f468-1f3fd-200d-1f3eb", "1f468-1f3fe-200d-1f3eb", "1f468-1f3ff-200d-1f3eb"],
    a: "4"
  }, {
    n: ["woman", "teacher", "lecturer", "professor", "instructor", "woman teacher"],
    u: "1f469-200d-1f3eb",
    v: ["1f469-1f3fb-200d-1f3eb", "1f469-1f3fc-200d-1f3eb", "1f469-1f3fd-200d-1f3eb", "1f469-1f3fe-200d-1f3eb", "1f469-1f3ff-200d-1f3eb"],
    a: "4"
  }, {
    n: ["law", "judge", "scales", "justice"],
    u: "1f9d1-200d-2696-fe0f",
    v: ["1f9d1-1f3fb-200d-2696-fe0f", "1f9d1-1f3fc-200d-2696-fe0f", "1f9d1-1f3fd-200d-2696-fe0f", "1f9d1-1f3fe-200d-2696-fe0f", "1f9d1-1f3ff-200d-2696-fe0f"],
    a: "12.1"
  }, {
    n: ["law", "man", "judge", "scales", "justice", "man judge"],
    u: "1f468-200d-2696-fe0f",
    v: ["1f468-1f3fb-200d-2696-fe0f", "1f468-1f3fc-200d-2696-fe0f", "1f468-1f3fd-200d-2696-fe0f", "1f468-1f3fe-200d-2696-fe0f", "1f468-1f3ff-200d-2696-fe0f"],
    a: "4"
  }, {
    n: ["law", "judge", "woman", "scales", "justice", "woman judge"],
    u: "1f469-200d-2696-fe0f",
    v: ["1f469-1f3fb-200d-2696-fe0f", "1f469-1f3fc-200d-2696-fe0f", "1f469-1f3fd-200d-2696-fe0f", "1f469-1f3fe-200d-2696-fe0f", "1f469-1f3ff-200d-2696-fe0f"],
    a: "4"
  }, {
    n: ["farmer", "rancher", "gardener"],
    u: "1f9d1-200d-1f33e",
    v: ["1f9d1-1f3fb-200d-1f33e", "1f9d1-1f3fc-200d-1f33e", "1f9d1-1f3fd-200d-1f33e", "1f9d1-1f3fe-200d-1f33e", "1f9d1-1f3ff-200d-1f33e"],
    a: "12.1"
  }, {
    n: ["man", "farmer", "rancher", "gardener", "man farmer"],
    u: "1f468-200d-1f33e",
    v: ["1f468-1f3fb-200d-1f33e", "1f468-1f3fc-200d-1f33e", "1f468-1f3fd-200d-1f33e", "1f468-1f3fe-200d-1f33e", "1f468-1f3ff-200d-1f33e"],
    a: "4"
  }, {
    n: ["woman", "farmer", "rancher", "gardener", "woman farmer"],
    u: "1f469-200d-1f33e",
    v: ["1f469-1f3fb-200d-1f33e", "1f469-1f3fc-200d-1f33e", "1f469-1f3fd-200d-1f33e", "1f469-1f3fe-200d-1f33e", "1f469-1f3ff-200d-1f33e"],
    a: "4"
  }, {
    n: ["cook", "chef"],
    u: "1f9d1-200d-1f373",
    v: ["1f9d1-1f3fb-200d-1f373", "1f9d1-1f3fc-200d-1f373", "1f9d1-1f3fd-200d-1f373", "1f9d1-1f3fe-200d-1f373", "1f9d1-1f3ff-200d-1f373"],
    a: "12.1"
  }, {
    n: ["man", "chef", "cook", "man cook"],
    u: "1f468-200d-1f373",
    v: ["1f468-1f3fb-200d-1f373", "1f468-1f3fc-200d-1f373", "1f468-1f3fd-200d-1f373", "1f468-1f3fe-200d-1f373", "1f468-1f3ff-200d-1f373"],
    a: "4"
  }, {
    n: ["chef", "cook", "woman", "woman cook"],
    u: "1f469-200d-1f373",
    v: ["1f469-1f3fb-200d-1f373", "1f469-1f3fc-200d-1f373", "1f469-1f3fd-200d-1f373", "1f469-1f3fe-200d-1f373", "1f469-1f3ff-200d-1f373"],
    a: "4"
  }, {
    n: ["plumber", "mechanic", "electrician", "tradesperson"],
    u: "1f9d1-200d-1f527",
    v: ["1f9d1-1f3fb-200d-1f527", "1f9d1-1f3fc-200d-1f527", "1f9d1-1f3fd-200d-1f527", "1f9d1-1f3fe-200d-1f527", "1f9d1-1f3ff-200d-1f527"],
    a: "12.1"
  }, {
    n: ["man", "plumber", "mechanic", "electrician", "man mechanic", "tradesperson"],
    u: "1f468-200d-1f527",
    v: ["1f468-1f3fb-200d-1f527", "1f468-1f3fc-200d-1f527", "1f468-1f3fd-200d-1f527", "1f468-1f3fe-200d-1f527", "1f468-1f3ff-200d-1f527"],
    a: "4"
  }, {
    n: ["woman", "plumber", "mechanic", "electrician", "tradesperson", "woman mechanic"],
    u: "1f469-200d-1f527",
    v: ["1f469-1f3fb-200d-1f527", "1f469-1f3fc-200d-1f527", "1f469-1f3fd-200d-1f527", "1f469-1f3fe-200d-1f527", "1f469-1f3ff-200d-1f527"],
    a: "4"
  }, {
    n: ["worker", "factory", "assembly", "industrial", "factory worker"],
    u: "1f9d1-200d-1f3ed",
    v: ["1f9d1-1f3fb-200d-1f3ed", "1f9d1-1f3fc-200d-1f3ed", "1f9d1-1f3fd-200d-1f3ed", "1f9d1-1f3fe-200d-1f3ed", "1f9d1-1f3ff-200d-1f3ed"],
    a: "12.1"
  }, {
    n: ["man", "worker", "factory", "assembly", "industrial", "man factory worker"],
    u: "1f468-200d-1f3ed",
    v: ["1f468-1f3fb-200d-1f3ed", "1f468-1f3fc-200d-1f3ed", "1f468-1f3fd-200d-1f3ed", "1f468-1f3fe-200d-1f3ed", "1f468-1f3ff-200d-1f3ed"],
    a: "4"
  }, {
    n: ["woman", "worker", "factory", "assembly", "industrial", "woman factory worker"],
    u: "1f469-200d-1f3ed",
    v: ["1f469-1f3fb-200d-1f3ed", "1f469-1f3fc-200d-1f3ed", "1f469-1f3fd-200d-1f3ed", "1f469-1f3fe-200d-1f3ed", "1f469-1f3ff-200d-1f3ed"],
    a: "4"
  }, {
    n: ["manager", "business", "architect", "white collar", "office worker"],
    u: "1f9d1-200d-1f4bc",
    v: ["1f9d1-1f3fb-200d-1f4bc", "1f9d1-1f3fc-200d-1f4bc", "1f9d1-1f3fd-200d-1f4bc", "1f9d1-1f3fe-200d-1f4bc", "1f9d1-1f3ff-200d-1f4bc"],
    a: "12.1"
  }, {
    n: ["man", "manager", "business", "architect", "white collar", "man office worker"],
    u: "1f468-200d-1f4bc",
    v: ["1f468-1f3fb-200d-1f4bc", "1f468-1f3fc-200d-1f4bc", "1f468-1f3fd-200d-1f4bc", "1f468-1f3fe-200d-1f4bc", "1f468-1f3ff-200d-1f4bc"],
    a: "4"
  }, {
    n: ["woman", "manager", "business", "architect", "white collar", "woman office worker"],
    u: "1f469-200d-1f4bc",
    v: ["1f469-1f3fb-200d-1f4bc", "1f469-1f3fc-200d-1f4bc", "1f469-1f3fd-200d-1f4bc", "1f469-1f3fe-200d-1f4bc", "1f469-1f3ff-200d-1f4bc"],
    a: "4"
  }, {
    n: ["chemist", "engineer", "scientist", "biologist", "physicist"],
    u: "1f9d1-200d-1f52c",
    v: ["1f9d1-1f3fb-200d-1f52c", "1f9d1-1f3fc-200d-1f52c", "1f9d1-1f3fd-200d-1f52c", "1f9d1-1f3fe-200d-1f52c", "1f9d1-1f3ff-200d-1f52c"],
    a: "12.1"
  }, {
    n: ["man", "chemist", "engineer", "biologist", "physicist", "scientist", "man scientist"],
    u: "1f468-200d-1f52c",
    v: ["1f468-1f3fb-200d-1f52c", "1f468-1f3fc-200d-1f52c", "1f468-1f3fd-200d-1f52c", "1f468-1f3fe-200d-1f52c", "1f468-1f3ff-200d-1f52c"],
    a: "4"
  }, {
    n: ["woman", "chemist", "engineer", "biologist", "physicist", "scientist", "woman scientist"],
    u: "1f469-200d-1f52c",
    v: ["1f469-1f3fb-200d-1f52c", "1f469-1f3fc-200d-1f52c", "1f469-1f3fd-200d-1f52c", "1f469-1f3fe-200d-1f52c", "1f469-1f3ff-200d-1f52c"],
    a: "4"
  }, {
    n: ["coder", "inventor", "software", "developer", "technologist"],
    u: "1f9d1-200d-1f4bb",
    v: ["1f9d1-1f3fb-200d-1f4bb", "1f9d1-1f3fc-200d-1f4bb", "1f9d1-1f3fd-200d-1f4bb", "1f9d1-1f3fe-200d-1f4bb", "1f9d1-1f3ff-200d-1f4bb"],
    a: "12.1"
  }, {
    n: ["man", "coder", "inventor", "software", "developer", "technologist", "man technologist"],
    u: "1f468-200d-1f4bb",
    v: ["1f468-1f3fb-200d-1f4bb", "1f468-1f3fc-200d-1f4bb", "1f468-1f3fd-200d-1f4bb", "1f468-1f3fe-200d-1f4bb", "1f468-1f3ff-200d-1f4bb"],
    a: "4"
  }, {
    n: ["coder", "woman", "inventor", "software", "developer", "technologist", "woman technologist"],
    u: "1f469-200d-1f4bb",
    v: ["1f469-1f3fb-200d-1f4bb", "1f469-1f3fc-200d-1f4bb", "1f469-1f3fd-200d-1f4bb", "1f469-1f3fe-200d-1f4bb", "1f469-1f3ff-200d-1f4bb"],
    a: "4"
  }, {
    n: ["rock", "star", "actor", "singer", "entertainer"],
    u: "1f9d1-200d-1f3a4",
    v: ["1f9d1-1f3fb-200d-1f3a4", "1f9d1-1f3fc-200d-1f3a4", "1f9d1-1f3fd-200d-1f3a4", "1f9d1-1f3fe-200d-1f3a4", "1f9d1-1f3ff-200d-1f3a4"],
    a: "12.1"
  }, {
    n: ["man", "rock", "star", "actor", "singer", "man singer", "entertainer"],
    u: "1f468-200d-1f3a4",
    v: ["1f468-1f3fb-200d-1f3a4", "1f468-1f3fc-200d-1f3a4", "1f468-1f3fd-200d-1f3a4", "1f468-1f3fe-200d-1f3a4", "1f468-1f3ff-200d-1f3a4"],
    a: "4"
  }, {
    n: ["rock", "star", "actor", "woman", "singer", "entertainer", "woman singer"],
    u: "1f469-200d-1f3a4",
    v: ["1f469-1f3fb-200d-1f3a4", "1f469-1f3fc-200d-1f3a4", "1f469-1f3fd-200d-1f3a4", "1f469-1f3fe-200d-1f3a4", "1f469-1f3ff-200d-1f3a4"],
    a: "4"
  }, {
    n: ["artist", "palette"],
    u: "1f9d1-200d-1f3a8",
    v: ["1f9d1-1f3fb-200d-1f3a8", "1f9d1-1f3fc-200d-1f3a8", "1f9d1-1f3fd-200d-1f3a8", "1f9d1-1f3fe-200d-1f3a8", "1f9d1-1f3ff-200d-1f3a8"],
    a: "12.1"
  }, {
    n: ["man", "artist", "palette", "man artist"],
    u: "1f468-200d-1f3a8",
    v: ["1f468-1f3fb-200d-1f3a8", "1f468-1f3fc-200d-1f3a8", "1f468-1f3fd-200d-1f3a8", "1f468-1f3fe-200d-1f3a8", "1f468-1f3ff-200d-1f3a8"],
    a: "4"
  }, {
    n: ["woman", "artist", "palette", "woman artist"],
    u: "1f469-200d-1f3a8",
    v: ["1f469-1f3fb-200d-1f3a8", "1f469-1f3fc-200d-1f3a8", "1f469-1f3fd-200d-1f3a8", "1f469-1f3fe-200d-1f3a8", "1f469-1f3ff-200d-1f3a8"],
    a: "4"
  }, {
    n: ["pilot", "plane"],
    u: "1f9d1-200d-2708-fe0f",
    v: ["1f9d1-1f3fb-200d-2708-fe0f", "1f9d1-1f3fc-200d-2708-fe0f", "1f9d1-1f3fd-200d-2708-fe0f", "1f9d1-1f3fe-200d-2708-fe0f", "1f9d1-1f3ff-200d-2708-fe0f"],
    a: "12.1"
  }, {
    n: ["man", "pilot", "plane", "man pilot"],
    u: "1f468-200d-2708-fe0f",
    v: ["1f468-1f3fb-200d-2708-fe0f", "1f468-1f3fc-200d-2708-fe0f", "1f468-1f3fd-200d-2708-fe0f", "1f468-1f3fe-200d-2708-fe0f", "1f468-1f3ff-200d-2708-fe0f"],
    a: "4"
  }, {
    n: ["pilot", "plane", "woman", "woman pilot"],
    u: "1f469-200d-2708-fe0f",
    v: ["1f469-1f3fb-200d-2708-fe0f", "1f469-1f3fc-200d-2708-fe0f", "1f469-1f3fd-200d-2708-fe0f", "1f469-1f3fe-200d-2708-fe0f", "1f469-1f3ff-200d-2708-fe0f"],
    a: "4"
  }, {
    n: ["rocket", "astronaut"],
    u: "1f9d1-200d-1f680",
    v: ["1f9d1-1f3fb-200d-1f680", "1f9d1-1f3fc-200d-1f680", "1f9d1-1f3fd-200d-1f680", "1f9d1-1f3fe-200d-1f680", "1f9d1-1f3ff-200d-1f680"],
    a: "12.1"
  }, {
    n: ["man", "rocket", "astronaut", "man astronaut"],
    u: "1f468-200d-1f680",
    v: ["1f468-1f3fb-200d-1f680", "1f468-1f3fc-200d-1f680", "1f468-1f3fd-200d-1f680", "1f468-1f3fe-200d-1f680", "1f468-1f3ff-200d-1f680"],
    a: "4"
  }, {
    n: ["woman", "rocket", "astronaut", "woman astronaut"],
    u: "1f469-200d-1f680",
    v: ["1f469-1f3fb-200d-1f680", "1f469-1f3fc-200d-1f680", "1f469-1f3fd-200d-1f680", "1f469-1f3fe-200d-1f680", "1f469-1f3ff-200d-1f680"],
    a: "4"
  }, {
    n: ["fire", "firetruck", "firefighter"],
    u: "1f9d1-200d-1f692",
    v: ["1f9d1-1f3fb-200d-1f692", "1f9d1-1f3fc-200d-1f692", "1f9d1-1f3fd-200d-1f692", "1f9d1-1f3fe-200d-1f692", "1f9d1-1f3ff-200d-1f692"],
    a: "12.1"
  }, {
    n: ["man", "firetruck", "firefighter", "man firefighter"],
    u: "1f468-200d-1f692",
    v: ["1f468-1f3fb-200d-1f692", "1f468-1f3fc-200d-1f692", "1f468-1f3fd-200d-1f692", "1f468-1f3fe-200d-1f692", "1f468-1f3ff-200d-1f692"],
    a: "4"
  }, {
    n: ["woman", "firetruck", "firefighter", "woman firefighter"],
    u: "1f469-200d-1f692",
    v: ["1f469-1f3fb-200d-1f692", "1f469-1f3fc-200d-1f692", "1f469-1f3fd-200d-1f692", "1f469-1f3fe-200d-1f692", "1f469-1f3ff-200d-1f692"],
    a: "4"
  }, {
    n: ["cop", "police", "officer", "police officer"],
    u: "1f46e",
    v: ["1f46e-1f3fb", "1f46e-1f3fc", "1f46e-1f3fd", "1f46e-1f3fe", "1f46e-1f3ff"],
    a: "0.6"
  }, {
    n: ["cop", "man", "police", "officer", "man police officer"],
    u: "1f46e-200d-2642-fe0f",
    v: ["1f46e-1f3fb-200d-2642-fe0f", "1f46e-1f3fc-200d-2642-fe0f", "1f46e-1f3fd-200d-2642-fe0f", "1f46e-1f3fe-200d-2642-fe0f", "1f46e-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["cop", "woman", "police", "officer", "woman police officer"],
    u: "1f46e-200d-2640-fe0f",
    v: ["1f46e-1f3fb-200d-2640-fe0f", "1f46e-1f3fc-200d-2640-fe0f", "1f46e-1f3fd-200d-2640-fe0f", "1f46e-1f3fe-200d-2640-fe0f", "1f46e-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["spy", "sleuth", "detective"],
    u: "1f575-fe0f",
    v: ["1f575-1f3fb", "1f575-1f3fc", "1f575-1f3fd", "1f575-1f3fe", "1f575-1f3ff"],
    a: "0.7"
  }, {
    n: ["man", "spy", "sleuth", "detective", "man detective"],
    u: "1f575-fe0f-200d-2642-fe0f",
    v: ["1f575-1f3fb-200d-2642-fe0f", "1f575-1f3fc-200d-2642-fe0f", "1f575-1f3fd-200d-2642-fe0f", "1f575-1f3fe-200d-2642-fe0f", "1f575-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["spy", "woman", "sleuth", "detective", "woman detective"],
    u: "1f575-fe0f-200d-2640-fe0f",
    v: ["1f575-1f3fb-200d-2640-fe0f", "1f575-1f3fc-200d-2640-fe0f", "1f575-1f3fd-200d-2640-fe0f", "1f575-1f3fe-200d-2640-fe0f", "1f575-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["guard"],
    u: "1f482",
    v: ["1f482-1f3fb", "1f482-1f3fc", "1f482-1f3fd", "1f482-1f3fe", "1f482-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "guard", "man guard"],
    u: "1f482-200d-2642-fe0f",
    v: ["1f482-1f3fb-200d-2642-fe0f", "1f482-1f3fc-200d-2642-fe0f", "1f482-1f3fd-200d-2642-fe0f", "1f482-1f3fe-200d-2642-fe0f", "1f482-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["guard", "woman", "woman guard"],
    u: "1f482-200d-2640-fe0f",
    v: ["1f482-1f3fb-200d-2640-fe0f", "1f482-1f3fc-200d-2640-fe0f", "1f482-1f3fd-200d-2640-fe0f", "1f482-1f3fe-200d-2640-fe0f", "1f482-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["ninja", "hidden", "fighter", "stealth"],
    u: "1f977",
    v: ["1f977-1f3fb", "1f977-1f3fc", "1f977-1f3fd", "1f977-1f3fe", "1f977-1f3ff"],
    a: "13"
  }, {
    n: ["hat", "worker", "construction", "construction worker"],
    u: "1f477",
    v: ["1f477-1f3fb", "1f477-1f3fc", "1f477-1f3fd", "1f477-1f3fe", "1f477-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "worker", "construction", "man construction worker"],
    u: "1f477-200d-2642-fe0f",
    v: ["1f477-1f3fb-200d-2642-fe0f", "1f477-1f3fc-200d-2642-fe0f", "1f477-1f3fd-200d-2642-fe0f", "1f477-1f3fe-200d-2642-fe0f", "1f477-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["woman", "worker", "construction", "woman construction worker"],
    u: "1f477-200d-2640-fe0f",
    v: ["1f477-1f3fb-200d-2640-fe0f", "1f477-1f3fc-200d-2640-fe0f", "1f477-1f3fd-200d-2640-fe0f", "1f477-1f3fe-200d-2640-fe0f", "1f477-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["noble", "regal", "monarch", "royalty", "person with crown"],
    u: "1fac5",
    v: ["1fac5-1f3fb", "1fac5-1f3fc", "1fac5-1f3fd", "1fac5-1f3fe", "1fac5-1f3ff"],
    a: "14"
  }, {
    n: ["prince"],
    u: "1f934",
    v: ["1f934-1f3fb", "1f934-1f3fc", "1f934-1f3fd", "1f934-1f3fe", "1f934-1f3ff"],
    a: "3"
  }, {
    n: ["fantasy", "princess", "fairy tale"],
    u: "1f478",
    v: ["1f478-1f3fb", "1f478-1f3fc", "1f478-1f3fd", "1f478-1f3fe", "1f478-1f3ff"],
    a: "0.6"
  }, {
    n: ["turban", "person wearing turban"],
    u: "1f473",
    v: ["1f473-1f3fb", "1f473-1f3fc", "1f473-1f3fd", "1f473-1f3fe", "1f473-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "turban", "man wearing turban"],
    u: "1f473-200d-2642-fe0f",
    v: ["1f473-1f3fb-200d-2642-fe0f", "1f473-1f3fc-200d-2642-fe0f", "1f473-1f3fd-200d-2642-fe0f", "1f473-1f3fe-200d-2642-fe0f", "1f473-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["woman", "turban", "woman wearing turban"],
    u: "1f473-200d-2640-fe0f",
    v: ["1f473-1f3fb-200d-2640-fe0f", "1f473-1f3fc-200d-2640-fe0f", "1f473-1f3fd-200d-2640-fe0f", "1f473-1f3fe-200d-2640-fe0f", "1f473-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["cap", "hat", "person", "skullcap", "gua pi mao", "person with skullcap"],
    u: "1f472",
    v: ["1f472-1f3fb", "1f472-1f3fc", "1f472-1f3fd", "1f472-1f3fe", "1f472-1f3ff"],
    a: "0.6"
  }, {
    n: ["hijab", "tichel", "mantilla", "headscarf", "woman with headscarf"],
    u: "1f9d5",
    v: ["1f9d5-1f3fb", "1f9d5-1f3fc", "1f9d5-1f3fd", "1f9d5-1f3fe", "1f9d5-1f3ff"],
    a: "5"
  }, {
    n: ["groom", "person", "tuxedo", "person in tuxedo"],
    u: "1f935",
    v: ["1f935-1f3fb", "1f935-1f3fc", "1f935-1f3fd", "1f935-1f3fe", "1f935-1f3ff"],
    a: "3"
  }, {
    n: ["man", "tuxedo", "man in tuxedo"],
    u: "1f935-200d-2642-fe0f",
    v: ["1f935-1f3fb-200d-2642-fe0f", "1f935-1f3fc-200d-2642-fe0f", "1f935-1f3fd-200d-2642-fe0f", "1f935-1f3fe-200d-2642-fe0f", "1f935-1f3ff-200d-2642-fe0f"],
    a: "13"
  }, {
    n: ["woman", "tuxedo", "woman in tuxedo"],
    u: "1f935-200d-2640-fe0f",
    v: ["1f935-1f3fb-200d-2640-fe0f", "1f935-1f3fc-200d-2640-fe0f", "1f935-1f3fd-200d-2640-fe0f", "1f935-1f3fe-200d-2640-fe0f", "1f935-1f3ff-200d-2640-fe0f"],
    a: "13"
  }, {
    n: ["veil", "bride", "person", "wedding", "person with veil"],
    u: "1f470",
    v: ["1f470-1f3fb", "1f470-1f3fc", "1f470-1f3fd", "1f470-1f3fe", "1f470-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "veil", "man with veil"],
    u: "1f470-200d-2642-fe0f",
    v: ["1f470-1f3fb-200d-2642-fe0f", "1f470-1f3fc-200d-2642-fe0f", "1f470-1f3fd-200d-2642-fe0f", "1f470-1f3fe-200d-2642-fe0f", "1f470-1f3ff-200d-2642-fe0f"],
    a: "13"
  }, {
    n: ["veil", "woman", "woman with veil"],
    u: "1f470-200d-2640-fe0f",
    v: ["1f470-1f3fb-200d-2640-fe0f", "1f470-1f3fc-200d-2640-fe0f", "1f470-1f3fd-200d-2640-fe0f", "1f470-1f3fe-200d-2640-fe0f", "1f470-1f3ff-200d-2640-fe0f"],
    a: "13"
  }, {
    n: ["woman", "pregnant", "pregnant woman"],
    u: "1f930",
    v: ["1f930-1f3fb", "1f930-1f3fc", "1f930-1f3fd", "1f930-1f3fe", "1f930-1f3ff"],
    a: "3"
  }, {
    n: ["full", "belly", "bloated", "pregnant", "pregnant man"],
    u: "1fac3",
    v: ["1fac3-1f3fb", "1fac3-1f3fc", "1fac3-1f3fd", "1fac3-1f3fe", "1fac3-1f3ff"],
    a: "14"
  }, {
    n: ["full", "belly", "bloated", "pregnant", "pregnant person"],
    u: "1fac4",
    v: ["1fac4-1f3fb", "1fac4-1f3fc", "1fac4-1f3fd", "1fac4-1f3fe", "1fac4-1f3ff"],
    a: "14"
  }, {
    n: ["baby", "breast", "nursing", "breast feeding"],
    u: "1f931",
    v: ["1f931-1f3fb", "1f931-1f3fc", "1f931-1f3fd", "1f931-1f3fe", "1f931-1f3ff"],
    a: "5"
  }, {
    n: ["baby", "woman", "feeding", "nursing", "woman feeding baby"],
    u: "1f469-200d-1f37c",
    v: ["1f469-1f3fb-200d-1f37c", "1f469-1f3fc-200d-1f37c", "1f469-1f3fd-200d-1f37c", "1f469-1f3fe-200d-1f37c", "1f469-1f3ff-200d-1f37c"],
    a: "13"
  }, {
    n: ["man", "baby", "feeding", "nursing", "man feeding baby"],
    u: "1f468-200d-1f37c",
    v: ["1f468-1f3fb-200d-1f37c", "1f468-1f3fc-200d-1f37c", "1f468-1f3fd-200d-1f37c", "1f468-1f3fe-200d-1f37c", "1f468-1f3ff-200d-1f37c"],
    a: "13"
  }, {
    n: ["baby", "person", "feeding", "nursing", "person feeding baby"],
    u: "1f9d1-200d-1f37c",
    v: ["1f9d1-1f3fb-200d-1f37c", "1f9d1-1f3fc-200d-1f37c", "1f9d1-1f3fd-200d-1f37c", "1f9d1-1f3fe-200d-1f37c", "1f9d1-1f3ff-200d-1f37c"],
    a: "13"
  }, {
    n: ["baby", "face", "angel", "fantasy", "baby angel", "fairy tale"],
    u: "1f47c",
    v: ["1f47c-1f3fb", "1f47c-1f3fc", "1f47c-1f3fd", "1f47c-1f3fe", "1f47c-1f3ff"],
    a: "0.6"
  }, {
    n: ["claus", "santa", "father", "christmas", "Santa Claus", "celebration"],
    u: "1f385",
    v: ["1f385-1f3fb", "1f385-1f3fc", "1f385-1f3fd", "1f385-1f3fe", "1f385-1f3ff"],
    a: "0.6"
  }, {
    n: ["mrs.", "claus", "mother", "christmas", "Mrs. Claus", "celebration"],
    u: "1f936",
    v: ["1f936-1f3fb", "1f936-1f3fc", "1f936-1f3fd", "1f936-1f3fe", "1f936-1f3ff"],
    a: "3"
  }, {
    n: ["claus", "mx claus", "christmas"],
    u: "1f9d1-200d-1f384",
    v: ["1f9d1-1f3fb-200d-1f384", "1f9d1-1f3fc-200d-1f384", "1f9d1-1f3fd-200d-1f384", "1f9d1-1f3fe-200d-1f384", "1f9d1-1f3ff-200d-1f384"],
    a: "13"
  }, {
    n: ["good", "hero", "heroine", "superhero", "superpower"],
    u: "1f9b8",
    v: ["1f9b8-1f3fb", "1f9b8-1f3fc", "1f9b8-1f3fd", "1f9b8-1f3fe", "1f9b8-1f3ff"],
    a: "11"
  }, {
    n: ["man", "good", "hero", "superpower", "man superhero"],
    u: "1f9b8-200d-2642-fe0f",
    v: ["1f9b8-1f3fb-200d-2642-fe0f", "1f9b8-1f3fc-200d-2642-fe0f", "1f9b8-1f3fd-200d-2642-fe0f", "1f9b8-1f3fe-200d-2642-fe0f", "1f9b8-1f3ff-200d-2642-fe0f"],
    a: "11"
  }, {
    n: ["good", "hero", "woman", "heroine", "superpower", "woman superhero"],
    u: "1f9b8-200d-2640-fe0f",
    v: ["1f9b8-1f3fb-200d-2640-fe0f", "1f9b8-1f3fc-200d-2640-fe0f", "1f9b8-1f3fd-200d-2640-fe0f", "1f9b8-1f3fe-200d-2640-fe0f", "1f9b8-1f3ff-200d-2640-fe0f"],
    a: "11"
  }, {
    n: ["evil", "villain", "criminal", "superpower", "supervillain"],
    u: "1f9b9",
    v: ["1f9b9-1f3fb", "1f9b9-1f3fc", "1f9b9-1f3fd", "1f9b9-1f3fe", "1f9b9-1f3ff"],
    a: "11"
  }, {
    n: ["man", "evil", "villain", "criminal", "superpower", "man supervillain"],
    u: "1f9b9-200d-2642-fe0f",
    v: ["1f9b9-1f3fb-200d-2642-fe0f", "1f9b9-1f3fc-200d-2642-fe0f", "1f9b9-1f3fd-200d-2642-fe0f", "1f9b9-1f3fe-200d-2642-fe0f", "1f9b9-1f3ff-200d-2642-fe0f"],
    a: "11"
  }, {
    n: ["evil", "woman", "villain", "criminal", "superpower", "woman supervillain"],
    u: "1f9b9-200d-2640-fe0f",
    v: ["1f9b9-1f3fb-200d-2640-fe0f", "1f9b9-1f3fc-200d-2640-fe0f", "1f9b9-1f3fd-200d-2640-fe0f", "1f9b9-1f3fe-200d-2640-fe0f", "1f9b9-1f3ff-200d-2640-fe0f"],
    a: "11"
  }, {
    n: ["mage", "witch", "wizard", "sorcerer", "sorceress"],
    u: "1f9d9",
    v: ["1f9d9-1f3fb", "1f9d9-1f3fc", "1f9d9-1f3fd", "1f9d9-1f3fe", "1f9d9-1f3ff"],
    a: "5"
  }, {
    n: ["wizard", "man mage", "sorcerer"],
    u: "1f9d9-200d-2642-fe0f",
    v: ["1f9d9-1f3fb-200d-2642-fe0f", "1f9d9-1f3fc-200d-2642-fe0f", "1f9d9-1f3fd-200d-2642-fe0f", "1f9d9-1f3fe-200d-2642-fe0f", "1f9d9-1f3ff-200d-2642-fe0f"],
    a: "5"
  }, {
    n: ["witch", "sorceress", "woman mage"],
    u: "1f9d9-200d-2640-fe0f",
    v: ["1f9d9-1f3fb-200d-2640-fe0f", "1f9d9-1f3fc-200d-2640-fe0f", "1f9d9-1f3fd-200d-2640-fe0f", "1f9d9-1f3fe-200d-2640-fe0f", "1f9d9-1f3ff-200d-2640-fe0f"],
    a: "5"
  }, {
    n: ["puck", "fairy", "oberon", "titania"],
    u: "1f9da",
    v: ["1f9da-1f3fb", "1f9da-1f3fc", "1f9da-1f3fd", "1f9da-1f3fe", "1f9da-1f3ff"],
    a: "5"
  }, {
    n: ["puck", "oberon", "man fairy"],
    u: "1f9da-200d-2642-fe0f",
    v: ["1f9da-1f3fb-200d-2642-fe0f", "1f9da-1f3fc-200d-2642-fe0f", "1f9da-1f3fd-200d-2642-fe0f", "1f9da-1f3fe-200d-2642-fe0f", "1f9da-1f3ff-200d-2642-fe0f"],
    a: "5"
  }, {
    n: ["titania", "woman fairy"],
    u: "1f9da-200d-2640-fe0f",
    v: ["1f9da-1f3fb-200d-2640-fe0f", "1f9da-1f3fc-200d-2640-fe0f", "1f9da-1f3fd-200d-2640-fe0f", "1f9da-1f3fe-200d-2640-fe0f", "1f9da-1f3ff-200d-2640-fe0f"],
    a: "5"
  }, {
    n: ["undead", "vampire", "dracula"],
    u: "1f9db",
    v: ["1f9db-1f3fb", "1f9db-1f3fc", "1f9db-1f3fd", "1f9db-1f3fe", "1f9db-1f3ff"],
    a: "5"
  }, {
    n: ["undead", "dracula", "man vampire"],
    u: "1f9db-200d-2642-fe0f",
    v: ["1f9db-1f3fb-200d-2642-fe0f", "1f9db-1f3fc-200d-2642-fe0f", "1f9db-1f3fd-200d-2642-fe0f", "1f9db-1f3fe-200d-2642-fe0f", "1f9db-1f3ff-200d-2642-fe0f"],
    a: "5"
  }, {
    n: ["undead", "woman vampire"],
    u: "1f9db-200d-2640-fe0f",
    v: ["1f9db-1f3fb-200d-2640-fe0f", "1f9db-1f3fc-200d-2640-fe0f", "1f9db-1f3fd-200d-2640-fe0f", "1f9db-1f3fe-200d-2640-fe0f", "1f9db-1f3ff-200d-2640-fe0f"],
    a: "5"
  }, {
    n: ["merman", "mermaid", "merwoman", "merperson"],
    u: "1f9dc",
    v: ["1f9dc-1f3fb", "1f9dc-1f3fc", "1f9dc-1f3fd", "1f9dc-1f3fe", "1f9dc-1f3ff"],
    a: "5"
  }, {
    n: ["merman", "triton"],
    u: "1f9dc-200d-2642-fe0f",
    v: ["1f9dc-1f3fb-200d-2642-fe0f", "1f9dc-1f3fc-200d-2642-fe0f", "1f9dc-1f3fd-200d-2642-fe0f", "1f9dc-1f3fe-200d-2642-fe0f", "1f9dc-1f3ff-200d-2642-fe0f"],
    a: "5"
  }, {
    n: ["mermaid", "merwoman"],
    u: "1f9dc-200d-2640-fe0f",
    v: ["1f9dc-1f3fb-200d-2640-fe0f", "1f9dc-1f3fc-200d-2640-fe0f", "1f9dc-1f3fd-200d-2640-fe0f", "1f9dc-1f3fe-200d-2640-fe0f", "1f9dc-1f3ff-200d-2640-fe0f"],
    a: "5"
  }, {
    n: ["elf", "magical"],
    u: "1f9dd",
    v: ["1f9dd-1f3fb", "1f9dd-1f3fc", "1f9dd-1f3fd", "1f9dd-1f3fe", "1f9dd-1f3ff"],
    a: "5"
  }, {
    n: ["man elf", "magical"],
    u: "1f9dd-200d-2642-fe0f",
    v: ["1f9dd-1f3fb-200d-2642-fe0f", "1f9dd-1f3fc-200d-2642-fe0f", "1f9dd-1f3fd-200d-2642-fe0f", "1f9dd-1f3fe-200d-2642-fe0f", "1f9dd-1f3ff-200d-2642-fe0f"],
    a: "5"
  }, {
    n: ["magical", "woman elf"],
    u: "1f9dd-200d-2640-fe0f",
    v: ["1f9dd-1f3fb-200d-2640-fe0f", "1f9dd-1f3fc-200d-2640-fe0f", "1f9dd-1f3fd-200d-2640-fe0f", "1f9dd-1f3fe-200d-2640-fe0f", "1f9dd-1f3ff-200d-2640-fe0f"],
    a: "5"
  }, {
    n: ["genie", "djinn"],
    u: "1f9de",
    a: "5"
  }, {
    n: ["djinn", "man genie"],
    u: "1f9de-200d-2642-fe0f",
    a: "5"
  }, {
    n: ["djinn", "woman genie"],
    u: "1f9de-200d-2640-fe0f",
    a: "5"
  }, {
    n: ["zombie", "undead", "walking dead"],
    u: "1f9df",
    a: "5"
  }, {
    n: ["undead", "man zombie", "walking dead"],
    u: "1f9df-200d-2642-fe0f",
    a: "5"
  }, {
    n: ["undead", "woman zombie", "walking dead"],
    u: "1f9df-200d-2640-fe0f",
    a: "5"
  }, {
    n: ["troll", "fantasy", "monster", "fairy tale"],
    u: "1f9cc",
    a: "14"
  }, {
    n: ["face", "salon", "massage", "person getting massage"],
    u: "1f486",
    v: ["1f486-1f3fb", "1f486-1f3fc", "1f486-1f3fd", "1f486-1f3fe", "1f486-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "face", "massage", "man getting massage"],
    u: "1f486-200d-2642-fe0f",
    v: ["1f486-1f3fb-200d-2642-fe0f", "1f486-1f3fc-200d-2642-fe0f", "1f486-1f3fd-200d-2642-fe0f", "1f486-1f3fe-200d-2642-fe0f", "1f486-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["face", "woman", "massage", "woman getting massage"],
    u: "1f486-200d-2640-fe0f",
    v: ["1f486-1f3fb-200d-2640-fe0f", "1f486-1f3fc-200d-2640-fe0f", "1f486-1f3fd-200d-2640-fe0f", "1f486-1f3fe-200d-2640-fe0f", "1f486-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["barber", "beauty", "parlor", "haircut", "person getting haircut"],
    u: "1f487",
    v: ["1f487-1f3fb", "1f487-1f3fc", "1f487-1f3fd", "1f487-1f3fe", "1f487-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "haircut", "man getting haircut"],
    u: "1f487-200d-2642-fe0f",
    v: ["1f487-1f3fb-200d-2642-fe0f", "1f487-1f3fc-200d-2642-fe0f", "1f487-1f3fd-200d-2642-fe0f", "1f487-1f3fe-200d-2642-fe0f", "1f487-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["woman", "haircut", "woman getting haircut"],
    u: "1f487-200d-2640-fe0f",
    v: ["1f487-1f3fb-200d-2640-fe0f", "1f487-1f3fc-200d-2640-fe0f", "1f487-1f3fd-200d-2640-fe0f", "1f487-1f3fe-200d-2640-fe0f", "1f487-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["hike", "walk", "walking", "person walking"],
    u: "1f6b6",
    v: ["1f6b6-1f3fb", "1f6b6-1f3fc", "1f6b6-1f3fd", "1f6b6-1f3fe", "1f6b6-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "hike", "walk", "man walking"],
    u: "1f6b6-200d-2642-fe0f",
    v: ["1f6b6-1f3fb-200d-2642-fe0f", "1f6b6-1f3fc-200d-2642-fe0f", "1f6b6-1f3fd-200d-2642-fe0f", "1f6b6-1f3fe-200d-2642-fe0f", "1f6b6-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["hike", "walk", "woman", "woman walking"],
    u: "1f6b6-200d-2640-fe0f",
    v: ["1f6b6-1f3fb-200d-2640-fe0f", "1f6b6-1f3fc-200d-2640-fe0f", "1f6b6-1f3fd-200d-2640-fe0f", "1f6b6-1f3fe-200d-2640-fe0f", "1f6b6-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["hike", "walk", "walking", "person walking", "person walking facing right"],
    u: "1f6b6-200d-27a1-fe0f",
    v: ["1f6b6-1f3fb-200d-27a1-fe0f", "1f6b6-1f3fc-200d-27a1-fe0f", "1f6b6-1f3fd-200d-27a1-fe0f", "1f6b6-1f3fe-200d-27a1-fe0f", "1f6b6-1f3ff-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["hike", "walk", "woman", "woman walking", "woman walking facing right"],
    u: "1f6b6-200d-2640-fe0f-200d-27a1-fe0f",
    v: ["1f6b6-1f3fb-200d-2640-fe0f-200d-27a1-fe0f", "1f6b6-1f3fc-200d-2640-fe0f-200d-27a1-fe0f", "1f6b6-1f3fd-200d-2640-fe0f-200d-27a1-fe0f", "1f6b6-1f3fe-200d-2640-fe0f-200d-27a1-fe0f", "1f6b6-1f3ff-200d-2640-fe0f-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["man", "hike", "walk", "man walking", "man walking facing right"],
    u: "1f6b6-200d-2642-fe0f-200d-27a1-fe0f",
    v: ["1f6b6-1f3fb-200d-2642-fe0f-200d-27a1-fe0f", "1f6b6-1f3fc-200d-2642-fe0f-200d-27a1-fe0f", "1f6b6-1f3fd-200d-2642-fe0f-200d-27a1-fe0f", "1f6b6-1f3fe-200d-2642-fe0f-200d-27a1-fe0f", "1f6b6-1f3ff-200d-2642-fe0f-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["stand", "standing", "person standing"],
    u: "1f9cd",
    v: ["1f9cd-1f3fb", "1f9cd-1f3fc", "1f9cd-1f3fd", "1f9cd-1f3fe", "1f9cd-1f3ff"],
    a: "12"
  }, {
    n: ["man", "standing", "man standing"],
    u: "1f9cd-200d-2642-fe0f",
    v: ["1f9cd-1f3fb-200d-2642-fe0f", "1f9cd-1f3fc-200d-2642-fe0f", "1f9cd-1f3fd-200d-2642-fe0f", "1f9cd-1f3fe-200d-2642-fe0f", "1f9cd-1f3ff-200d-2642-fe0f"],
    a: "12"
  }, {
    n: ["woman", "standing", "woman standing"],
    u: "1f9cd-200d-2640-fe0f",
    v: ["1f9cd-1f3fb-200d-2640-fe0f", "1f9cd-1f3fc-200d-2640-fe0f", "1f9cd-1f3fd-200d-2640-fe0f", "1f9cd-1f3fe-200d-2640-fe0f", "1f9cd-1f3ff-200d-2640-fe0f"],
    a: "12"
  }, {
    n: ["kneel", "kneeling", "person kneeling"],
    u: "1f9ce",
    v: ["1f9ce-1f3fb", "1f9ce-1f3fc", "1f9ce-1f3fd", "1f9ce-1f3fe", "1f9ce-1f3ff"],
    a: "12"
  }, {
    n: ["man", "kneeling", "man kneeling"],
    u: "1f9ce-200d-2642-fe0f",
    v: ["1f9ce-1f3fb-200d-2642-fe0f", "1f9ce-1f3fc-200d-2642-fe0f", "1f9ce-1f3fd-200d-2642-fe0f", "1f9ce-1f3fe-200d-2642-fe0f", "1f9ce-1f3ff-200d-2642-fe0f"],
    a: "12"
  }, {
    n: ["woman", "kneeling", "woman kneeling"],
    u: "1f9ce-200d-2640-fe0f",
    v: ["1f9ce-1f3fb-200d-2640-fe0f", "1f9ce-1f3fc-200d-2640-fe0f", "1f9ce-1f3fd-200d-2640-fe0f", "1f9ce-1f3fe-200d-2640-fe0f", "1f9ce-1f3ff-200d-2640-fe0f"],
    a: "12"
  }, {
    n: ["kneel", "kneeling", "person kneeling", "person kneeling facing right"],
    u: "1f9ce-200d-27a1-fe0f",
    v: ["1f9ce-1f3fb-200d-27a1-fe0f", "1f9ce-1f3fc-200d-27a1-fe0f", "1f9ce-1f3fd-200d-27a1-fe0f", "1f9ce-1f3fe-200d-27a1-fe0f", "1f9ce-1f3ff-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["woman", "kneeling", "woman kneeling facing right"],
    u: "1f9ce-200d-2640-fe0f-200d-27a1-fe0f",
    v: ["1f9ce-1f3fb-200d-2640-fe0f-200d-27a1-fe0f", "1f9ce-1f3fc-200d-2640-fe0f-200d-27a1-fe0f", "1f9ce-1f3fd-200d-2640-fe0f-200d-27a1-fe0f", "1f9ce-1f3fe-200d-2640-fe0f-200d-27a1-fe0f", "1f9ce-1f3ff-200d-2640-fe0f-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["man", "kneeling", "man kneeling facing right"],
    u: "1f9ce-200d-2642-fe0f-200d-27a1-fe0f",
    v: ["1f9ce-1f3fb-200d-2642-fe0f-200d-27a1-fe0f", "1f9ce-1f3fc-200d-2642-fe0f-200d-27a1-fe0f", "1f9ce-1f3fd-200d-2642-fe0f-200d-27a1-fe0f", "1f9ce-1f3fe-200d-2642-fe0f-200d-27a1-fe0f", "1f9ce-1f3ff-200d-2642-fe0f-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["blind", "accessibility", "person with white cane"],
    u: "1f9d1-200d-1f9af",
    v: ["1f9d1-1f3fb-200d-1f9af", "1f9d1-1f3fc-200d-1f9af", "1f9d1-1f3fd-200d-1f9af", "1f9d1-1f3fe-200d-1f9af", "1f9d1-1f3ff-200d-1f9af"],
    a: "12.1"
  }, {
    n: ["blind", "accessibility", "person with white cane", "person with white cane facing right"],
    u: "1f9d1-200d-1f9af-200d-27a1-fe0f",
    v: ["1f9d1-1f3fb-200d-1f9af-200d-27a1-fe0f", "1f9d1-1f3fc-200d-1f9af-200d-27a1-fe0f", "1f9d1-1f3fd-200d-1f9af-200d-27a1-fe0f", "1f9d1-1f3fe-200d-1f9af-200d-27a1-fe0f", "1f9d1-1f3ff-200d-1f9af-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["man", "blind", "accessibility", "man with white cane"],
    u: "1f468-200d-1f9af",
    v: ["1f468-1f3fb-200d-1f9af", "1f468-1f3fc-200d-1f9af", "1f468-1f3fd-200d-1f9af", "1f468-1f3fe-200d-1f9af", "1f468-1f3ff-200d-1f9af"],
    a: "12"
  }, {
    n: ["man", "blind", "accessibility", "man with white cane", "man with white cane facing right"],
    u: "1f468-200d-1f9af-200d-27a1-fe0f",
    v: ["1f468-1f3fb-200d-1f9af-200d-27a1-fe0f", "1f468-1f3fc-200d-1f9af-200d-27a1-fe0f", "1f468-1f3fd-200d-1f9af-200d-27a1-fe0f", "1f468-1f3fe-200d-1f9af-200d-27a1-fe0f", "1f468-1f3ff-200d-1f9af-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["blind", "woman", "accessibility", "woman with white cane"],
    u: "1f469-200d-1f9af",
    v: ["1f469-1f3fb-200d-1f9af", "1f469-1f3fc-200d-1f9af", "1f469-1f3fd-200d-1f9af", "1f469-1f3fe-200d-1f9af", "1f469-1f3ff-200d-1f9af"],
    a: "12"
  }, {
    n: ["blind", "woman", "accessibility", "woman with white cane", "woman with white cane facing right"],
    u: "1f469-200d-1f9af-200d-27a1-fe0f",
    v: ["1f469-1f3fb-200d-1f9af-200d-27a1-fe0f", "1f469-1f3fc-200d-1f9af-200d-27a1-fe0f", "1f469-1f3fd-200d-1f9af-200d-27a1-fe0f", "1f469-1f3fe-200d-1f9af-200d-27a1-fe0f", "1f469-1f3ff-200d-1f9af-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["wheelchair", "accessibility", "person in motorized wheelchair"],
    u: "1f9d1-200d-1f9bc",
    v: ["1f9d1-1f3fb-200d-1f9bc", "1f9d1-1f3fc-200d-1f9bc", "1f9d1-1f3fd-200d-1f9bc", "1f9d1-1f3fe-200d-1f9bc", "1f9d1-1f3ff-200d-1f9bc"],
    a: "12.1"
  }, {
    n: ["wheelchair", "accessibility", "person in motorized wheelchair", "person in motorized wheelchair facing right"],
    u: "1f9d1-200d-1f9bc-200d-27a1-fe0f",
    v: ["1f9d1-1f3fb-200d-1f9bc-200d-27a1-fe0f", "1f9d1-1f3fc-200d-1f9bc-200d-27a1-fe0f", "1f9d1-1f3fd-200d-1f9bc-200d-27a1-fe0f", "1f9d1-1f3fe-200d-1f9bc-200d-27a1-fe0f", "1f9d1-1f3ff-200d-1f9bc-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["man", "wheelchair", "accessibility", "man in motorized wheelchair"],
    u: "1f468-200d-1f9bc",
    v: ["1f468-1f3fb-200d-1f9bc", "1f468-1f3fc-200d-1f9bc", "1f468-1f3fd-200d-1f9bc", "1f468-1f3fe-200d-1f9bc", "1f468-1f3ff-200d-1f9bc"],
    a: "12"
  }, {
    n: ["man", "wheelchair", "accessibility", "man in motorized wheelchair", "man in motorized wheelchair facing right"],
    u: "1f468-200d-1f9bc-200d-27a1-fe0f",
    v: ["1f468-1f3fb-200d-1f9bc-200d-27a1-fe0f", "1f468-1f3fc-200d-1f9bc-200d-27a1-fe0f", "1f468-1f3fd-200d-1f9bc-200d-27a1-fe0f", "1f468-1f3fe-200d-1f9bc-200d-27a1-fe0f", "1f468-1f3ff-200d-1f9bc-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["woman", "wheelchair", "accessibility", "woman in motorized wheelchair"],
    u: "1f469-200d-1f9bc",
    v: ["1f469-1f3fb-200d-1f9bc", "1f469-1f3fc-200d-1f9bc", "1f469-1f3fd-200d-1f9bc", "1f469-1f3fe-200d-1f9bc", "1f469-1f3ff-200d-1f9bc"],
    a: "12"
  }, {
    n: ["woman", "wheelchair", "accessibility", "woman in motorized wheelchair", "woman in motorized wheelchair facing right"],
    u: "1f469-200d-1f9bc-200d-27a1-fe0f",
    v: ["1f469-1f3fb-200d-1f9bc-200d-27a1-fe0f", "1f469-1f3fc-200d-1f9bc-200d-27a1-fe0f", "1f469-1f3fd-200d-1f9bc-200d-27a1-fe0f", "1f469-1f3fe-200d-1f9bc-200d-27a1-fe0f", "1f469-1f3ff-200d-1f9bc-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["wheelchair", "accessibility", "person in manual wheelchair"],
    u: "1f9d1-200d-1f9bd",
    v: ["1f9d1-1f3fb-200d-1f9bd", "1f9d1-1f3fc-200d-1f9bd", "1f9d1-1f3fd-200d-1f9bd", "1f9d1-1f3fe-200d-1f9bd", "1f9d1-1f3ff-200d-1f9bd"],
    a: "12.1"
  }, {
    n: ["wheelchair", "accessibility", "person in manual wheelchair", "person in manual wheelchair facing right"],
    u: "1f9d1-200d-1f9bd-200d-27a1-fe0f",
    v: ["1f9d1-1f3fb-200d-1f9bd-200d-27a1-fe0f", "1f9d1-1f3fc-200d-1f9bd-200d-27a1-fe0f", "1f9d1-1f3fd-200d-1f9bd-200d-27a1-fe0f", "1f9d1-1f3fe-200d-1f9bd-200d-27a1-fe0f", "1f9d1-1f3ff-200d-1f9bd-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["man", "wheelchair", "accessibility", "man in manual wheelchair"],
    u: "1f468-200d-1f9bd",
    v: ["1f468-1f3fb-200d-1f9bd", "1f468-1f3fc-200d-1f9bd", "1f468-1f3fd-200d-1f9bd", "1f468-1f3fe-200d-1f9bd", "1f468-1f3ff-200d-1f9bd"],
    a: "12"
  }, {
    n: ["man", "wheelchair", "accessibility", "man in manual wheelchair", "man in manual wheelchair facing right"],
    u: "1f468-200d-1f9bd-200d-27a1-fe0f",
    v: ["1f468-1f3fb-200d-1f9bd-200d-27a1-fe0f", "1f468-1f3fc-200d-1f9bd-200d-27a1-fe0f", "1f468-1f3fd-200d-1f9bd-200d-27a1-fe0f", "1f468-1f3fe-200d-1f9bd-200d-27a1-fe0f", "1f468-1f3ff-200d-1f9bd-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["woman", "wheelchair", "accessibility", "woman in manual wheelchair"],
    u: "1f469-200d-1f9bd",
    v: ["1f469-1f3fb-200d-1f9bd", "1f469-1f3fc-200d-1f9bd", "1f469-1f3fd-200d-1f9bd", "1f469-1f3fe-200d-1f9bd", "1f469-1f3ff-200d-1f9bd"],
    a: "12"
  }, {
    n: ["woman", "wheelchair", "accessibility", "woman in manual wheelchair", "woman in manual wheelchair facing right"],
    u: "1f469-200d-1f9bd-200d-27a1-fe0f",
    v: ["1f469-1f3fb-200d-1f9bd-200d-27a1-fe0f", "1f469-1f3fc-200d-1f9bd-200d-27a1-fe0f", "1f469-1f3fd-200d-1f9bd-200d-27a1-fe0f", "1f469-1f3fe-200d-1f9bd-200d-27a1-fe0f", "1f469-1f3ff-200d-1f9bd-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["running", "marathon", "person running"],
    u: "1f3c3",
    v: ["1f3c3-1f3fb", "1f3c3-1f3fc", "1f3c3-1f3fd", "1f3c3-1f3fe", "1f3c3-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "racing", "running", "marathon", "man running"],
    u: "1f3c3-200d-2642-fe0f",
    v: ["1f3c3-1f3fb-200d-2642-fe0f", "1f3c3-1f3fc-200d-2642-fe0f", "1f3c3-1f3fd-200d-2642-fe0f", "1f3c3-1f3fe-200d-2642-fe0f", "1f3c3-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["woman", "racing", "running", "marathon", "woman running"],
    u: "1f3c3-200d-2640-fe0f",
    v: ["1f3c3-1f3fb-200d-2640-fe0f", "1f3c3-1f3fc-200d-2640-fe0f", "1f3c3-1f3fd-200d-2640-fe0f", "1f3c3-1f3fe-200d-2640-fe0f", "1f3c3-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["running", "marathon", "person running", "person running facing right"],
    u: "1f3c3-200d-27a1-fe0f",
    v: ["1f3c3-1f3fb-200d-27a1-fe0f", "1f3c3-1f3fc-200d-27a1-fe0f", "1f3c3-1f3fd-200d-27a1-fe0f", "1f3c3-1f3fe-200d-27a1-fe0f", "1f3c3-1f3ff-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["woman", "racing", "running", "marathon", "woman running facing right"],
    u: "1f3c3-200d-2640-fe0f-200d-27a1-fe0f",
    v: ["1f3c3-1f3fb-200d-2640-fe0f-200d-27a1-fe0f", "1f3c3-1f3fc-200d-2640-fe0f-200d-27a1-fe0f", "1f3c3-1f3fd-200d-2640-fe0f-200d-27a1-fe0f", "1f3c3-1f3fe-200d-2640-fe0f-200d-27a1-fe0f", "1f3c3-1f3ff-200d-2640-fe0f-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["man", "racing", "running", "marathon", "man running facing right"],
    u: "1f3c3-200d-2642-fe0f-200d-27a1-fe0f",
    v: ["1f3c3-1f3fb-200d-2642-fe0f-200d-27a1-fe0f", "1f3c3-1f3fc-200d-2642-fe0f-200d-27a1-fe0f", "1f3c3-1f3fd-200d-2642-fe0f-200d-27a1-fe0f", "1f3c3-1f3fe-200d-2642-fe0f-200d-27a1-fe0f", "1f3c3-1f3ff-200d-2642-fe0f-200d-27a1-fe0f"],
    a: "15.1"
  }, {
    n: ["dance", "woman", "dancing", "woman dancing"],
    u: "1f483",
    v: ["1f483-1f3fb", "1f483-1f3fc", "1f483-1f3fd", "1f483-1f3fe", "1f483-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "dance", "dancing", "man dancing"],
    u: "1f57a",
    v: ["1f57a-1f3fb", "1f57a-1f3fc", "1f57a-1f3fd", "1f57a-1f3fe", "1f57a-1f3ff"],
    a: "3"
  }, {
    n: ["suit", "person", "business", "person in suit levitating"],
    u: "1f574-fe0f",
    v: ["1f574-1f3fb", "1f574-1f3fc", "1f574-1f3fd", "1f574-1f3fe", "1f574-1f3ff"],
    a: "0.7"
  }, {
    n: ["dancer", "partying", "bunny ear", "people with bunny ears"],
    u: "1f46f",
    a: "0.6"
  }, {
    n: ["men", "dancer", "partying", "bunny ear", "men with bunny ears"],
    u: "1f46f-200d-2642-fe0f",
    a: "4"
  }, {
    n: ["women", "dancer", "partying", "bunny ear", "women with bunny ears"],
    u: "1f46f-200d-2640-fe0f",
    a: "4"
  }, {
    n: ["sauna", "steam room", "person in steamy room"],
    u: "1f9d6",
    v: ["1f9d6-1f3fb", "1f9d6-1f3fc", "1f9d6-1f3fd", "1f9d6-1f3fe", "1f9d6-1f3ff"],
    a: "5"
  }, {
    n: ["sauna", "steam room", "man in steamy room"],
    u: "1f9d6-200d-2642-fe0f",
    v: ["1f9d6-1f3fb-200d-2642-fe0f", "1f9d6-1f3fc-200d-2642-fe0f", "1f9d6-1f3fd-200d-2642-fe0f", "1f9d6-1f3fe-200d-2642-fe0f", "1f9d6-1f3ff-200d-2642-fe0f"],
    a: "5"
  }, {
    n: ["sauna", "steam room", "woman in steamy room"],
    u: "1f9d6-200d-2640-fe0f",
    v: ["1f9d6-1f3fb-200d-2640-fe0f", "1f9d6-1f3fc-200d-2640-fe0f", "1f9d6-1f3fd-200d-2640-fe0f", "1f9d6-1f3fe-200d-2640-fe0f", "1f9d6-1f3ff-200d-2640-fe0f"],
    a: "5"
  }, {
    n: ["climber", "person climbing"],
    u: "1f9d7",
    v: ["1f9d7-1f3fb", "1f9d7-1f3fc", "1f9d7-1f3fd", "1f9d7-1f3fe", "1f9d7-1f3ff"],
    a: "5"
  }, {
    n: ["climber", "man climbing"],
    u: "1f9d7-200d-2642-fe0f",
    v: ["1f9d7-1f3fb-200d-2642-fe0f", "1f9d7-1f3fc-200d-2642-fe0f", "1f9d7-1f3fd-200d-2642-fe0f", "1f9d7-1f3fe-200d-2642-fe0f", "1f9d7-1f3ff-200d-2642-fe0f"],
    a: "5"
  }, {
    n: ["climber", "woman climbing"],
    u: "1f9d7-200d-2640-fe0f",
    v: ["1f9d7-1f3fb-200d-2640-fe0f", "1f9d7-1f3fc-200d-2640-fe0f", "1f9d7-1f3fd-200d-2640-fe0f", "1f9d7-1f3fe-200d-2640-fe0f", "1f9d7-1f3ff-200d-2640-fe0f"],
    a: "5"
  }, {
    n: ["sword", "fencer", "fencing", "person fencing"],
    u: "1f93a",
    a: "3"
  }, {
    n: ["horse", "jockey", "racing", "racehorse", "horse racing"],
    u: "1f3c7",
    v: ["1f3c7-1f3fb", "1f3c7-1f3fc", "1f3c7-1f3fd", "1f3c7-1f3fe", "1f3c7-1f3ff"],
    a: "1"
  }, {
    n: ["ski", "snow", "skier"],
    u: "26f7-fe0f",
    a: "0.7"
  }, {
    n: ["ski", "snow", "snowboard", "snowboarder"],
    u: "1f3c2",
    v: ["1f3c2-1f3fb", "1f3c2-1f3fc", "1f3c2-1f3fd", "1f3c2-1f3fe", "1f3c2-1f3ff"],
    a: "0.6"
  }, {
    n: ["ball", "golf", "person golfing"],
    u: "1f3cc-fe0f",
    v: ["1f3cc-1f3fb", "1f3cc-1f3fc", "1f3cc-1f3fd", "1f3cc-1f3fe", "1f3cc-1f3ff"],
    a: "0.7"
  }, {
    n: ["man", "golf", "man golfing"],
    u: "1f3cc-fe0f-200d-2642-fe0f",
    v: ["1f3cc-1f3fb-200d-2642-fe0f", "1f3cc-1f3fc-200d-2642-fe0f", "1f3cc-1f3fd-200d-2642-fe0f", "1f3cc-1f3fe-200d-2642-fe0f", "1f3cc-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["golf", "woman", "woman golfing"],
    u: "1f3cc-fe0f-200d-2640-fe0f",
    v: ["1f3cc-1f3fb-200d-2640-fe0f", "1f3cc-1f3fc-200d-2640-fe0f", "1f3cc-1f3fd-200d-2640-fe0f", "1f3cc-1f3fe-200d-2640-fe0f", "1f3cc-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["surfing", "person surfing"],
    u: "1f3c4",
    v: ["1f3c4-1f3fb", "1f3c4-1f3fc", "1f3c4-1f3fd", "1f3c4-1f3fe", "1f3c4-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "surfing", "man surfing"],
    u: "1f3c4-200d-2642-fe0f",
    v: ["1f3c4-1f3fb-200d-2642-fe0f", "1f3c4-1f3fc-200d-2642-fe0f", "1f3c4-1f3fd-200d-2642-fe0f", "1f3c4-1f3fe-200d-2642-fe0f", "1f3c4-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["woman", "surfing", "woman surfing"],
    u: "1f3c4-200d-2640-fe0f",
    v: ["1f3c4-1f3fb-200d-2640-fe0f", "1f3c4-1f3fc-200d-2640-fe0f", "1f3c4-1f3fd-200d-2640-fe0f", "1f3c4-1f3fe-200d-2640-fe0f", "1f3c4-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["boat", "rowboat", "person rowing boat"],
    u: "1f6a3",
    v: ["1f6a3-1f3fb", "1f6a3-1f3fc", "1f6a3-1f3fd", "1f6a3-1f3fe", "1f6a3-1f3ff"],
    a: "1"
  }, {
    n: ["man", "boat", "rowboat", "man rowing boat"],
    u: "1f6a3-200d-2642-fe0f",
    v: ["1f6a3-1f3fb-200d-2642-fe0f", "1f6a3-1f3fc-200d-2642-fe0f", "1f6a3-1f3fd-200d-2642-fe0f", "1f6a3-1f3fe-200d-2642-fe0f", "1f6a3-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["boat", "woman", "rowboat", "woman rowing boat"],
    u: "1f6a3-200d-2640-fe0f",
    v: ["1f6a3-1f3fb-200d-2640-fe0f", "1f6a3-1f3fc-200d-2640-fe0f", "1f6a3-1f3fd-200d-2640-fe0f", "1f6a3-1f3fe-200d-2640-fe0f", "1f6a3-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["swim", "person swimming"],
    u: "1f3ca",
    v: ["1f3ca-1f3fb", "1f3ca-1f3fc", "1f3ca-1f3fd", "1f3ca-1f3fe", "1f3ca-1f3ff"],
    a: "0.6"
  }, {
    n: ["man", "swim", "man swimming"],
    u: "1f3ca-200d-2642-fe0f",
    v: ["1f3ca-1f3fb-200d-2642-fe0f", "1f3ca-1f3fc-200d-2642-fe0f", "1f3ca-1f3fd-200d-2642-fe0f", "1f3ca-1f3fe-200d-2642-fe0f", "1f3ca-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["swim", "woman", "woman swimming"],
    u: "1f3ca-200d-2640-fe0f",
    v: ["1f3ca-1f3fb-200d-2640-fe0f", "1f3ca-1f3fc-200d-2640-fe0f", "1f3ca-1f3fd-200d-2640-fe0f", "1f3ca-1f3fe-200d-2640-fe0f", "1f3ca-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["ball", "person bouncing ball"],
    u: "26f9-fe0f",
    v: ["26f9-1f3fb", "26f9-1f3fc", "26f9-1f3fd", "26f9-1f3fe", "26f9-1f3ff"],
    a: "0.7"
  }, {
    n: ["man", "ball", "man bouncing ball"],
    u: "26f9-fe0f-200d-2642-fe0f",
    v: ["26f9-1f3fb-200d-2642-fe0f", "26f9-1f3fc-200d-2642-fe0f", "26f9-1f3fd-200d-2642-fe0f", "26f9-1f3fe-200d-2642-fe0f", "26f9-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["ball", "woman", "woman bouncing ball"],
    u: "26f9-fe0f-200d-2640-fe0f",
    v: ["26f9-1f3fb-200d-2640-fe0f", "26f9-1f3fc-200d-2640-fe0f", "26f9-1f3fd-200d-2640-fe0f", "26f9-1f3fe-200d-2640-fe0f", "26f9-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["lifter", "weight", "person lifting weights"],
    u: "1f3cb-fe0f",
    v: ["1f3cb-1f3fb", "1f3cb-1f3fc", "1f3cb-1f3fd", "1f3cb-1f3fe", "1f3cb-1f3ff"],
    a: "0.7"
  }, {
    n: ["man", "weight lifter", "man lifting weights"],
    u: "1f3cb-fe0f-200d-2642-fe0f",
    v: ["1f3cb-1f3fb-200d-2642-fe0f", "1f3cb-1f3fc-200d-2642-fe0f", "1f3cb-1f3fd-200d-2642-fe0f", "1f3cb-1f3fe-200d-2642-fe0f", "1f3cb-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["woman", "weight lifter", "woman lifting weights"],
    u: "1f3cb-fe0f-200d-2640-fe0f",
    v: ["1f3cb-1f3fb-200d-2640-fe0f", "1f3cb-1f3fc-200d-2640-fe0f", "1f3cb-1f3fd-200d-2640-fe0f", "1f3cb-1f3fe-200d-2640-fe0f", "1f3cb-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["biking", "bicycle", "cyclist", "person biking"],
    u: "1f6b4",
    v: ["1f6b4-1f3fb", "1f6b4-1f3fc", "1f6b4-1f3fd", "1f6b4-1f3fe", "1f6b4-1f3ff"],
    a: "1"
  }, {
    n: ["man", "biking", "bicycle", "cyclist", "man biking"],
    u: "1f6b4-200d-2642-fe0f",
    v: ["1f6b4-1f3fb-200d-2642-fe0f", "1f6b4-1f3fc-200d-2642-fe0f", "1f6b4-1f3fd-200d-2642-fe0f", "1f6b4-1f3fe-200d-2642-fe0f", "1f6b4-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["woman", "biking", "bicycle", "cyclist", "woman biking"],
    u: "1f6b4-200d-2640-fe0f",
    v: ["1f6b4-1f3fb-200d-2640-fe0f", "1f6b4-1f3fc-200d-2640-fe0f", "1f6b4-1f3fd-200d-2640-fe0f", "1f6b4-1f3fe-200d-2640-fe0f", "1f6b4-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["bike", "bicycle", "cyclist", "mountain", "bicyclist", "person mountain biking"],
    u: "1f6b5",
    v: ["1f6b5-1f3fb", "1f6b5-1f3fc", "1f6b5-1f3fd", "1f6b5-1f3fe", "1f6b5-1f3ff"],
    a: "1"
  }, {
    n: ["man", "bike", "bicycle", "cyclist", "mountain", "man mountain biking"],
    u: "1f6b5-200d-2642-fe0f",
    v: ["1f6b5-1f3fb-200d-2642-fe0f", "1f6b5-1f3fc-200d-2642-fe0f", "1f6b5-1f3fd-200d-2642-fe0f", "1f6b5-1f3fe-200d-2642-fe0f", "1f6b5-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["bike", "woman", "biking", "bicycle", "cyclist", "mountain", "woman mountain biking"],
    u: "1f6b5-200d-2640-fe0f",
    v: ["1f6b5-1f3fb-200d-2640-fe0f", "1f6b5-1f3fc-200d-2640-fe0f", "1f6b5-1f3fd-200d-2640-fe0f", "1f6b5-1f3fe-200d-2640-fe0f", "1f6b5-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["cartwheel", "gymnastics", "person cartwheeling"],
    u: "1f938",
    v: ["1f938-1f3fb", "1f938-1f3fc", "1f938-1f3fd", "1f938-1f3fe", "1f938-1f3ff"],
    a: "3"
  }, {
    n: ["man", "cartwheel", "gymnastics", "man cartwheeling"],
    u: "1f938-200d-2642-fe0f",
    v: ["1f938-1f3fb-200d-2642-fe0f", "1f938-1f3fc-200d-2642-fe0f", "1f938-1f3fd-200d-2642-fe0f", "1f938-1f3fe-200d-2642-fe0f", "1f938-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["woman", "cartwheel", "gymnastics", "woman cartwheeling"],
    u: "1f938-200d-2640-fe0f",
    v: ["1f938-1f3fb-200d-2640-fe0f", "1f938-1f3fc-200d-2640-fe0f", "1f938-1f3fd-200d-2640-fe0f", "1f938-1f3fe-200d-2640-fe0f", "1f938-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["wrestle", "wrestler", "people wrestling"],
    u: "1f93c",
    a: "3"
  }, {
    n: ["men", "wrestle", "men wrestling"],
    u: "1f93c-200d-2642-fe0f",
    a: "4"
  }, {
    n: ["women", "wrestle", "women wrestling"],
    u: "1f93c-200d-2640-fe0f",
    a: "4"
  }, {
    n: ["polo", "water", "person playing water polo"],
    u: "1f93d",
    v: ["1f93d-1f3fb", "1f93d-1f3fc", "1f93d-1f3fd", "1f93d-1f3fe", "1f93d-1f3ff"],
    a: "3"
  }, {
    n: ["man", "water polo", "man playing water polo"],
    u: "1f93d-200d-2642-fe0f",
    v: ["1f93d-1f3fb-200d-2642-fe0f", "1f93d-1f3fc-200d-2642-fe0f", "1f93d-1f3fd-200d-2642-fe0f", "1f93d-1f3fe-200d-2642-fe0f", "1f93d-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["woman", "water polo", "woman playing water polo"],
    u: "1f93d-200d-2640-fe0f",
    v: ["1f93d-1f3fb-200d-2640-fe0f", "1f93d-1f3fc-200d-2640-fe0f", "1f93d-1f3fd-200d-2640-fe0f", "1f93d-1f3fe-200d-2640-fe0f", "1f93d-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["ball", "handball", "person playing handball"],
    u: "1f93e",
    v: ["1f93e-1f3fb", "1f93e-1f3fc", "1f93e-1f3fd", "1f93e-1f3fe", "1f93e-1f3ff"],
    a: "3"
  }, {
    n: ["man", "handball", "man playing handball"],
    u: "1f93e-200d-2642-fe0f",
    v: ["1f93e-1f3fb-200d-2642-fe0f", "1f93e-1f3fc-200d-2642-fe0f", "1f93e-1f3fd-200d-2642-fe0f", "1f93e-1f3fe-200d-2642-fe0f", "1f93e-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["woman", "handball", "woman playing handball"],
    u: "1f93e-200d-2640-fe0f",
    v: ["1f93e-1f3fb-200d-2640-fe0f", "1f93e-1f3fc-200d-2640-fe0f", "1f93e-1f3fd-200d-2640-fe0f", "1f93e-1f3fe-200d-2640-fe0f", "1f93e-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["skill", "juggle", "balance", "multitask", "person juggling"],
    u: "1f939",
    v: ["1f939-1f3fb", "1f939-1f3fc", "1f939-1f3fd", "1f939-1f3fe", "1f939-1f3ff"],
    a: "3"
  }, {
    n: ["man", "juggling", "multitask", "man juggling"],
    u: "1f939-200d-2642-fe0f",
    v: ["1f939-1f3fb-200d-2642-fe0f", "1f939-1f3fc-200d-2642-fe0f", "1f939-1f3fd-200d-2642-fe0f", "1f939-1f3fe-200d-2642-fe0f", "1f939-1f3ff-200d-2642-fe0f"],
    a: "4"
  }, {
    n: ["woman", "juggling", "multitask", "woman juggling"],
    u: "1f939-200d-2640-fe0f",
    v: ["1f939-1f3fb-200d-2640-fe0f", "1f939-1f3fc-200d-2640-fe0f", "1f939-1f3fd-200d-2640-fe0f", "1f939-1f3fe-200d-2640-fe0f", "1f939-1f3ff-200d-2640-fe0f"],
    a: "4"
  }, {
    n: ["yoga", "meditation", "person in lotus position"],
    u: "1f9d8",
    v: ["1f9d8-1f3fb", "1f9d8-1f3fc", "1f9d8-1f3fd", "1f9d8-1f3fe", "1f9d8-1f3ff"],
    a: "5"
  }, {
    n: ["yoga", "meditation", "man in lotus position"],
    u: "1f9d8-200d-2642-fe0f",
    v: ["1f9d8-1f3fb-200d-2642-fe0f", "1f9d8-1f3fc-200d-2642-fe0f", "1f9d8-1f3fd-200d-2642-fe0f", "1f9d8-1f3fe-200d-2642-fe0f", "1f9d8-1f3ff-200d-2642-fe0f"],
    a: "5"
  }, {
    n: ["yoga", "meditation", "woman in lotus position"],
    u: "1f9d8-200d-2640-fe0f",
    v: ["1f9d8-1f3fb-200d-2640-fe0f", "1f9d8-1f3fc-200d-2640-fe0f", "1f9d8-1f3fd-200d-2640-fe0f", "1f9d8-1f3fe-200d-2640-fe0f", "1f9d8-1f3ff-200d-2640-fe0f"],
    a: "5"
  }, {
    n: ["bath", "bathtub", "person taking bath"],
    u: "1f6c0",
    v: ["1f6c0-1f3fb", "1f6c0-1f3fc", "1f6c0-1f3fd", "1f6c0-1f3fe", "1f6c0-1f3ff"],
    a: "0.6"
  }, {
    n: ["hotel", "sleep", "good night", "person in bed"],
    u: "1f6cc",
    v: ["1f6cc-1f3fb", "1f6cc-1f3fc", "1f6cc-1f3fd", "1f6cc-1f3fe", "1f6cc-1f3ff"],
    a: "1"
  }, {
    n: ["hand", "hold", "couple", "person", "holding hands", "people holding hands"],
    u: "1f9d1-200d-1f91d-200d-1f9d1",
    v: ["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb", "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc", "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd", "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe", "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff", "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb", "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc", "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd", "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe", "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff", "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb", "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc", "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd", "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe", "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff", "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb", "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc", "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd", "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe", "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff", "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb", "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc", "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd", "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe", "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff"],
    a: "12"
  }, {
    n: ["hand", "women", "couple", "holding hands", "women holding hands"],
    u: "1f46d",
    v: ["1f46d-1f3fb", "1f46d-1f3fc", "1f46d-1f3fd", "1f46d-1f3fe", "1f46d-1f3ff", "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc", "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd", "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe", "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff", "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb", "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd", "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe", "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff", "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb", "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc", "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe", "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff", "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb", "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc", "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd", "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff", "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb", "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc", "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd", "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe"],
    a: "1"
  }, {
    n: ["man", "hand", "hold", "woman", "couple", "holding hands", "woman and man holding hands"],
    u: "1f46b",
    v: ["1f46b-1f3fb", "1f46b-1f3fc", "1f46b-1f3fd", "1f46b-1f3fe", "1f46b-1f3ff", "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc", "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd", "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe", "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff", "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb", "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd", "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe", "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff", "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb", "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc", "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe", "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff", "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb", "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc", "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd", "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff", "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb", "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc", "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd", "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe"],
    a: "0.6"
  }, {
    n: ["man", "men", "twins", "couple", "gemini", "zodiac", "holding hands", "men holding hands"],
    u: "1f46c",
    v: ["1f46c-1f3fb", "1f46c-1f3fc", "1f46c-1f3fd", "1f46c-1f3fe", "1f46c-1f3ff", "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc", "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd", "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe", "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff", "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb", "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd", "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe", "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff", "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb", "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc", "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe", "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff", "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb", "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc", "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd", "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff", "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb", "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc", "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd", "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe"],
    a: "1"
  }, {
    n: ["kiss", "couple"],
    u: "1f48f",
    v: ["1f48f-1f3fb", "1f48f-1f3fc", "1f48f-1f3fd", "1f48f-1f3fe", "1f48f-1f3ff", "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc", "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd", "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe", "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff", "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb", "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd", "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe", "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff", "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb", "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc", "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe", "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff", "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb", "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc", "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd", "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff", "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb", "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc", "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd", "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe"],
    a: "0.6"
  }, {
    n: ["man", "kiss", "woman", "couple", "kiss: woman, man"],
    u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
    v: ["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"],
    a: "2"
  }, {
    n: ["man", "kiss", "couple", "kiss: man, man"],
    u: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
    v: ["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"],
    a: "2"
  }, {
    n: ["kiss", "woman", "couple", "kiss: woman, woman"],
    u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
    v: ["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb", "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc", "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd", "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe", "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff"],
    a: "2"
  }, {
    n: ["love", "couple", "couple with heart"],
    u: "1f491",
    v: ["1f491-1f3fb", "1f491-1f3fc", "1f491-1f3fd", "1f491-1f3fe", "1f491-1f3ff", "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc", "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd", "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe", "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff", "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb", "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd", "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe", "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff", "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb", "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc", "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe", "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff", "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb", "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc", "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd", "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff", "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb", "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc", "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd", "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe"],
    a: "0.6"
  }, {
    n: ["man", "love", "woman", "couple", "couple with heart", "couple with heart: woman, man"],
    u: "1f469-200d-2764-fe0f-200d-1f468",
    v: ["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb", "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc", "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd", "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe", "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff", "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb", "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc", "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd", "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe", "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff", "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb", "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc", "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd", "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe", "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff", "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb", "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc", "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd", "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe", "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff", "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb", "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc", "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd", "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe", "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"],
    a: "2"
  }, {
    n: ["man", "love", "couple", "couple with heart", "couple with heart: man, man"],
    u: "1f468-200d-2764-fe0f-200d-1f468",
    v: ["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb", "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc", "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd", "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe", "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff", "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb", "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc", "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd", "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe", "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff", "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb", "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc", "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd", "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe", "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff", "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb", "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc", "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd", "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe", "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff", "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb", "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc", "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd", "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe", "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"],
    a: "2"
  }, {
    n: ["love", "woman", "couple", "couple with heart", "couple with heart: woman, woman"],
    u: "1f469-200d-2764-fe0f-200d-1f469",
    v: ["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb", "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc", "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd", "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe", "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff", "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb", "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc", "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd", "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe", "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff", "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb", "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc", "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd", "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe", "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff", "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb", "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc", "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd", "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe", "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff", "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb", "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc", "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd", "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe", "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff"],
    a: "2"
  }, {
    n: ["boy", "man", "woman", "family", "family: man, woman, boy"],
    u: "1f468-200d-1f469-200d-1f466",
    a: "2"
  }, {
    n: ["man", "girl", "woman", "family", "family: man, woman, girl"],
    u: "1f468-200d-1f469-200d-1f467",
    a: "2"
  }, {
    n: ["boy", "man", "girl", "woman", "family", "family: man, woman, girl, boy"],
    u: "1f468-200d-1f469-200d-1f467-200d-1f466",
    a: "2"
  }, {
    n: ["boy", "man", "woman", "family", "family: man, woman, boy, boy"],
    u: "1f468-200d-1f469-200d-1f466-200d-1f466",
    a: "2"
  }, {
    n: ["man", "girl", "woman", "family", "family: man, woman, girl, girl"],
    u: "1f468-200d-1f469-200d-1f467-200d-1f467",
    a: "2"
  }, {
    n: ["boy", "man", "family", "family: man, man, boy"],
    u: "1f468-200d-1f468-200d-1f466",
    a: "2"
  }, {
    n: ["man", "girl", "family", "family: man, man, girl"],
    u: "1f468-200d-1f468-200d-1f467",
    a: "2"
  }, {
    n: ["boy", "man", "girl", "family", "family: man, man, girl, boy"],
    u: "1f468-200d-1f468-200d-1f467-200d-1f466",
    a: "2"
  }, {
    n: ["boy", "man", "family", "family: man, man, boy, boy"],
    u: "1f468-200d-1f468-200d-1f466-200d-1f466",
    a: "2"
  }, {
    n: ["man", "girl", "family", "family: man, man, girl, girl"],
    u: "1f468-200d-1f468-200d-1f467-200d-1f467",
    a: "2"
  }, {
    n: ["boy", "woman", "family", "family: woman, woman, boy"],
    u: "1f469-200d-1f469-200d-1f466",
    a: "2"
  }, {
    n: ["girl", "woman", "family", "family: woman, woman, girl"],
    u: "1f469-200d-1f469-200d-1f467",
    a: "2"
  }, {
    n: ["boy", "girl", "woman", "family", "family: woman, woman, girl, boy"],
    u: "1f469-200d-1f469-200d-1f467-200d-1f466",
    a: "2"
  }, {
    n: ["boy", "woman", "family", "family: woman, woman, boy, boy"],
    u: "1f469-200d-1f469-200d-1f466-200d-1f466",
    a: "2"
  }, {
    n: ["girl", "woman", "family", "family: woman, woman, girl, girl"],
    u: "1f469-200d-1f469-200d-1f467-200d-1f467",
    a: "2"
  }, {
    n: ["boy", "man", "family", "family: man, boy"],
    u: "1f468-200d-1f466",
    a: "4"
  }, {
    n: ["boy", "man", "family", "family: man, boy, boy"],
    u: "1f468-200d-1f466-200d-1f466",
    a: "4"
  }, {
    n: ["man", "girl", "family", "family: man, girl"],
    u: "1f468-200d-1f467",
    a: "4"
  }, {
    n: ["boy", "man", "girl", "family", "family: man, girl, boy"],
    u: "1f468-200d-1f467-200d-1f466",
    a: "4"
  }, {
    n: ["man", "girl", "family", "family: man, girl, girl"],
    u: "1f468-200d-1f467-200d-1f467",
    a: "4"
  }, {
    n: ["boy", "woman", "family", "family: woman, boy"],
    u: "1f469-200d-1f466",
    a: "4"
  }, {
    n: ["boy", "woman", "family", "family: woman, boy, boy"],
    u: "1f469-200d-1f466-200d-1f466",
    a: "4"
  }, {
    n: ["girl", "woman", "family", "family: woman, girl"],
    u: "1f469-200d-1f467",
    a: "4"
  }, {
    n: ["boy", "girl", "woman", "family", "family: woman, girl, boy"],
    u: "1f469-200d-1f467-200d-1f466",
    a: "4"
  }, {
    n: ["girl", "woman", "family", "family: woman, girl, girl"],
    u: "1f469-200d-1f467-200d-1f467",
    a: "4"
  }, {
    n: ["face", "head", "speak", "speaking", "silhouette", "speaking head"],
    u: "1f5e3-fe0f",
    a: "0.7"
  }, {
    n: ["bust", "silhouette", "bust in silhouette"],
    u: "1f464",
    a: "0.6"
  }, {
    n: ["bust", "silhouette", "busts in silhouette"],
    u: "1f465",
    a: "1"
  }, {
    n: ["hug", "hello", "thanks", "goodbye", "people hugging"],
    u: "1fac2",
    a: "13"
  }, {
    n: ["family"],
    u: "1f46a",
    a: "0.6"
  }, {
    n: ["family: adult, adult, child"],
    u: "1f9d1-200d-1f9d1-200d-1f9d2",
    a: "15.1"
  }, {
    n: ["family: adult, adult, child, child"],
    u: "1f9d1-200d-1f9d1-200d-1f9d2-200d-1f9d2",
    a: "15.1"
  }, {
    n: ["family: adult, child"],
    u: "1f9d1-200d-1f9d2",
    a: "15.1"
  }, {
    n: ["family: adult, child, child"],
    u: "1f9d1-200d-1f9d2-200d-1f9d2",
    a: "15.1"
  }, {
    n: ["print", "clothing", "footprint", "footprints"],
    u: "1f463",
    a: "0.6"
  }],
  animals_nature: [{
    n: ["face", "monkey", "monkey face"],
    u: "1f435",
    a: "0.6"
  }, {
    n: ["monkey"],
    u: "1f412",
    a: "0.6"
  }, {
    n: ["gorilla"],
    u: "1f98d",
    a: "3"
  }, {
    n: ["ape", "orangutan"],
    u: "1f9a7",
    a: "12"
  }, {
    n: ["dog", "pet", "face", "dog face"],
    u: "1f436",
    a: "0.6"
  }, {
    n: ["dog", "pet"],
    u: "1f415",
    a: "0.7"
  }, {
    n: ["blind", "guide", "guide dog", "accessibility"],
    u: "1f9ae",
    a: "12"
  }, {
    n: ["dog", "service", "assistance", "service dog", "accessibility"],
    u: "1f415-200d-1f9ba",
    a: "12"
  }, {
    n: ["dog", "poodle"],
    u: "1f429",
    a: "0.6"
  }, {
    n: ["wolf", "face"],
    u: "1f43a",
    a: "0.6"
  }, {
    n: ["fox", "face"],
    u: "1f98a",
    a: "3"
  }, {
    n: ["sly", "raccoon", "curious"],
    u: "1f99d",
    a: "11"
  }, {
    n: ["cat", "pet", "face", "cat face"],
    u: "1f431",
    a: "0.6"
  }, {
    n: ["cat", "pet"],
    u: "1f408",
    a: "0.7"
  }, {
    n: ["cat", "black", "unlucky", "black cat"],
    u: "1f408-200d-2b1b",
    a: "13"
  }, {
    n: ["leo", "lion", "face", "zodiac"],
    u: "1f981",
    a: "1"
  }, {
    n: ["face", "tiger", "tiger face"],
    u: "1f42f",
    a: "0.6"
  }, {
    n: ["tiger"],
    u: "1f405",
    a: "1"
  }, {
    n: ["leopard"],
    u: "1f406",
    a: "1"
  }, {
    n: ["face", "horse", "horse face"],
    u: "1f434",
    a: "0.6"
  }, {
    n: ["elk", "moose", "animal", "mammal", "antlers"],
    u: "1face",
    a: "15"
  }, {
    n: ["ass", "mule", "burro", "donkey", "animal", "mammal", "stubborn"],
    u: "1facf",
    a: "15"
  }, {
    n: ["horse", "racing", "racehorse", "equestrian"],
    u: "1f40e",
    a: "0.6"
  }, {
    n: ["face", "unicorn"],
    u: "1f984",
    a: "1"
  }, {
    n: ["zebra", "stripe"],
    u: "1f993",
    a: "5"
  }, {
    n: ["deer"],
    u: "1f98c",
    a: "3"
  }, {
    n: ["herd", "bison", "wisent", "buffalo"],
    u: "1f9ac",
    a: "13"
  }, {
    n: ["cow", "face", "cow face"],
    u: "1f42e",
    a: "0.6"
  }, {
    n: ["ox", "bull", "taurus", "zodiac"],
    u: "1f402",
    a: "1"
  }, {
    n: ["water", "buffalo", "water buffalo"],
    u: "1f403",
    a: "1"
  }, {
    n: ["cow"],
    u: "1f404",
    a: "1"
  }, {
    n: ["pig", "face", "pig face"],
    u: "1f437",
    a: "0.6"
  }, {
    n: ["pig", "sow"],
    u: "1f416",
    a: "1"
  }, {
    n: ["pig", "boar"],
    u: "1f417",
    a: "0.6"
  }, {
    n: ["pig", "face", "nose", "pig nose"],
    u: "1f43d",
    a: "0.6"
  }, {
    n: ["ram", "male", "aries", "sheep", "zodiac"],
    u: "1f40f",
    a: "1"
  }, {
    n: ["ewe", "sheep", "female"],
    u: "1f411",
    a: "0.6"
  }, {
    n: ["goat", "zodiac", "capricorn"],
    u: "1f410",
    a: "1"
  }, {
    n: ["hump", "camel", "dromedary"],
    u: "1f42a",
    a: "1"
  }, {
    n: ["hump", "camel", "bactrian", "two hump camel"],
    u: "1f42b",
    a: "0.6"
  }, {
    n: ["wool", "llama", "alpaca", "vicuña", "guanaco"],
    u: "1f999",
    a: "11"
  }, {
    n: ["spots", "giraffe"],
    u: "1f992",
    a: "5"
  }, {
    n: ["elephant"],
    u: "1f418",
    a: "0.6"
  }, {
    n: ["tusk", "large", "woolly", "mammoth", "extinction"],
    u: "1f9a3",
    a: "13"
  }, {
    n: ["rhinoceros"],
    u: "1f98f",
    a: "3"
  }, {
    n: ["hippo", "hippopotamus"],
    u: "1f99b",
    a: "11"
  }, {
    n: ["face", "mouse", "mouse face"],
    u: "1f42d",
    a: "0.6"
  }, {
    n: ["mouse"],
    u: "1f401",
    a: "1"
  }, {
    n: ["rat"],
    u: "1f400",
    a: "1"
  }, {
    n: ["pet", "face", "hamster"],
    u: "1f439",
    a: "0.6"
  }, {
    n: ["pet", "face", "bunny", "rabbit", "rabbit face"],
    u: "1f430",
    a: "0.6"
  }, {
    n: ["pet", "bunny", "rabbit"],
    u: "1f407",
    a: "1"
  }, {
    n: ["chipmunk", "squirrel"],
    u: "1f43f-fe0f",
    a: "0.7"
  }, {
    n: ["dam", "beaver"],
    u: "1f9ab",
    a: "13"
  }, {
    n: ["spiny", "hedgehog"],
    u: "1f994",
    a: "5"
  }, {
    n: ["bat", "vampire"],
    u: "1f987",
    a: "3"
  }, {
    n: ["bear", "face"],
    u: "1f43b",
    a: "0.6"
  }, {
    n: ["bear", "white", "arctic", "polar bear"],
    u: "1f43b-200d-2744-fe0f",
    a: "13"
  }, {
    n: ["face", "koala", "marsupial"],
    u: "1f428",
    a: "0.6"
  }, {
    n: ["face", "panda"],
    u: "1f43c",
    a: "0.6"
  }, {
    n: ["lazy", "slow", "sloth"],
    u: "1f9a5",
    a: "12"
  }, {
    n: ["otter", "fishing", "playful"],
    u: "1f9a6",
    a: "12"
  }, {
    n: ["skunk", "stink"],
    u: "1f9a8",
    a: "12"
  }, {
    n: ["joey", "jump", "kangaroo", "marsupial"],
    u: "1f998",
    a: "11"
  }, {
    n: ["badger", "pester", "honey badger"],
    u: "1f9a1",
    a: "11"
  }, {
    n: ["paw", "feet", "print", "paw prints"],
    u: "1f43e",
    a: "0.6"
  }, {
    n: ["bird", "turkey"],
    u: "1f983",
    a: "1"
  }, {
    n: ["bird", "chicken"],
    u: "1f414",
    a: "0.6"
  }, {
    n: ["bird", "rooster"],
    u: "1f413",
    a: "1"
  }, {
    n: ["baby", "bird", "chick", "hatching", "hatching chick"],
    u: "1f423",
    a: "0.6"
  }, {
    n: ["baby", "bird", "chick", "baby chick"],
    u: "1f424",
    a: "0.6"
  }, {
    n: ["baby", "bird", "chick", "front facing baby chick"],
    u: "1f425",
    a: "0.6"
  }, {
    n: ["bird"],
    u: "1f426",
    a: "0.6"
  }, {
    n: ["bird", "penguin"],
    u: "1f427",
    a: "0.6"
  }, {
    n: ["fly", "dove", "bird", "peace"],
    u: "1f54a-fe0f",
    a: "0.7"
  }, {
    n: ["bird", "eagle"],
    u: "1f985",
    a: "3"
  }, {
    n: ["duck", "bird"],
    u: "1f986",
    a: "3"
  }, {
    n: ["swan", "bird", "cygnet", "ugly duckling"],
    u: "1f9a2",
    a: "11"
  }, {
    n: ["owl", "bird", "wise"],
    u: "1f989",
    a: "3"
  }, {
    n: ["dodo", "large", "mauritius", "extinction"],
    u: "1f9a4",
    a: "13"
  }, {
    n: ["bird", "light", "flight", "feather", "plumage"],
    u: "1fab6",
    a: "13"
  }, {
    n: ["flamingo", "tropical", "flamboyant"],
    u: "1f9a9",
    a: "12"
  }, {
    n: ["bird", "proud", "peahen", "peacock", "ostentatious"],
    u: "1f99a",
    a: "11"
  }, {
    n: ["bird", "talk", "parrot", "pirate"],
    u: "1f99c",
    a: "11"
  }, {
    n: ["wing", "bird", "flying", "angelic", "aviation", "mythology"],
    u: "1fabd",
    a: "15"
  }, {
    n: ["bird", "crow", "rook", "black", "raven", "black bird"],
    u: "1f426-200d-2b1b",
    a: "15"
  }, {
    n: ["bird", "fowl", "honk", "goose", "silly"],
    u: "1fabf",
    a: "15"
  }, {
    n: ["phoenix", "fantasy", "rebirth", "firebird", "reincarnation"],
    u: "1f426-200d-1f525",
    a: "15.1"
  }, {
    n: ["frog", "face"],
    u: "1f438",
    a: "0.6"
  }, {
    n: ["crocodile"],
    u: "1f40a",
    a: "1"
  }, {
    n: ["turtle", "terrapin", "tortoise"],
    u: "1f422",
    a: "0.6"
  }, {
    n: ["lizard", "reptile"],
    u: "1f98e",
    a: "3"
  }, {
    n: ["snake", "bearer", "zodiac", "serpent", "ophiuchus"],
    u: "1f40d",
    a: "0.6"
  }, {
    n: ["face", "dragon", "fairy tale", "dragon face"],
    u: "1f432",
    a: "0.6"
  }, {
    n: ["dragon", "fairy tale"],
    u: "1f409",
    a: "1"
  }, {
    n: ["sauropod", "diplodocus", "brontosaurus", "brachiosaurus"],
    u: "1f995",
    a: "5"
  }, {
    n: ["T Rex", "t rex", "tyrannosaurus rex"],
    u: "1f996",
    a: "5"
  }, {
    n: ["face", "whale", "spouting", "spouting whale"],
    u: "1f433",
    a: "0.6"
  }, {
    n: ["whale"],
    u: "1f40b",
    a: "1"
  }, {
    n: ["dolphin", "flipper"],
    u: "1f42c",
    a: "0.6"
  }, {
    n: ["seal", "sea lion"],
    u: "1f9ad",
    a: "13"
  }, {
    n: ["fish", "pisces", "zodiac"],
    u: "1f41f",
    a: "0.6"
  }, {
    n: ["fish", "tropical", "tropical fish"],
    u: "1f420",
    a: "0.6"
  }, {
    n: ["fish", "blowfish"],
    u: "1f421",
    a: "0.6"
  }, {
    n: ["fish", "shark"],
    u: "1f988",
    a: "3"
  }, {
    n: ["octopus"],
    u: "1f419",
    a: "0.6"
  }, {
    n: ["shell", "spiral", "spiral shell"],
    u: "1f41a",
    a: "0.6"
  }, {
    n: ["reef", "coral", "ocean"],
    u: "1fab8",
    a: "14"
  }, {
    n: ["burn", "ouch", "jelly", "marine", "stinger", "jellyfish", "invertebrate"],
    u: "1fabc",
    a: "15"
  }, {
    n: ["snail"],
    u: "1f40c",
    a: "0.6"
  }, {
    n: ["insect", "pretty", "butterfly"],
    u: "1f98b",
    a: "3"
  }, {
    n: ["bug", "insect"],
    u: "1f41b",
    a: "0.6"
  }, {
    n: ["ant", "insect"],
    u: "1f41c",
    a: "0.6"
  }, {
    n: ["bee", "insect", "honeybee"],
    u: "1f41d",
    a: "0.6"
  }, {
    n: ["bug", "beetle", "insect"],
    u: "1fab2",
    a: "13"
  }, {
    n: ["beetle", "insect", "ladybug", "ladybird", "lady beetle"],
    u: "1f41e",
    a: "0.6"
  }, {
    n: ["cricket", "grasshopper"],
    u: "1f997",
    a: "5"
  }, {
    n: ["pest", "roach", "insect", "cockroach"],
    u: "1fab3",
    a: "13"
  }, {
    n: ["spider", "insect"],
    u: "1f577-fe0f",
    a: "0.7"
  }, {
    n: ["web", "spider", "spider web"],
    u: "1f578-fe0f",
    a: "0.7"
  }, {
    n: ["zodiac", "scorpio", "scorpion"],
    u: "1f982",
    a: "1"
  }, {
    n: ["pest", "fever", "virus", "disease", "malaria", "mosquito"],
    u: "1f99f",
    a: "11"
  }, {
    n: ["fly", "pest", "maggot", "disease", "rotting"],
    u: "1fab0",
    a: "13"
  }, {
    n: ["worm", "annelid", "parasite", "earthworm"],
    u: "1fab1",
    a: "13"
  }, {
    n: ["virus", "amoeba", "microbe", "bacteria"],
    u: "1f9a0",
    a: "11"
  }, {
    n: ["flower", "bouquet"],
    u: "1f490",
    a: "0.6"
  }, {
    n: ["cherry", "flower", "blossom", "cherry blossom"],
    u: "1f338",
    a: "0.6"
  }, {
    n: ["flower", "white flower"],
    u: "1f4ae",
    a: "0.6"
  }, {
    n: ["lotus", "flower", "purity", "buddhism", "hinduism"],
    u: "1fab7",
    a: "14"
  }, {
    n: ["plant", "rosette"],
    u: "1f3f5-fe0f",
    a: "0.7"
  }, {
    n: ["rose", "flower"],
    u: "1f339",
    a: "0.6"
  }, {
    n: ["flower", "wilted", "wilted flower"],
    u: "1f940",
    a: "3"
  }, {
    n: ["flower", "hibiscus"],
    u: "1f33a",
    a: "0.6"
  }, {
    n: ["sun", "flower", "sunflower"],
    u: "1f33b",
    a: "0.6"
  }, {
    n: ["flower", "blossom"],
    u: "1f33c",
    a: "0.6"
  }, {
    n: ["tulip", "flower"],
    u: "1f337",
    a: "0.6"
  }, {
    n: ["flower", "lupine", "hyacinth", "lavender", "bluebonnet", "snapdragon"],
    u: "1fabb",
    a: "15"
  }, {
    n: ["young", "seedling"],
    u: "1f331",
    a: "0.6"
  }, {
    n: ["grow", "house", "plant", "boring", "useless", "nurturing", "potted plant"],
    u: "1fab4",
    a: "13"
  }, {
    n: ["tree", "evergreen tree"],
    u: "1f332",
    a: "1"
  }, {
    n: ["tree", "shedding", "deciduous", "deciduous tree"],
    u: "1f333",
    a: "1"
  }, {
    n: ["palm", "tree", "palm tree"],
    u: "1f334",
    a: "0.6"
  }, {
    n: ["plant", "cactus"],
    u: "1f335",
    a: "0.6"
  }, {
    n: ["ear", "rice", "grain", "sheaf of rice"],
    u: "1f33e",
    a: "0.6"
  }, {
    n: ["herb", "leaf"],
    u: "1f33f",
    a: "0.6"
  }, {
    n: ["plant", "shamrock"],
    u: "2618-fe0f",
    a: "1"
  }, {
    n: ["4", "four", "leaf", "clover", "four leaf clover"],
    u: "1f340",
    a: "0.6"
  }, {
    n: ["leaf", "maple", "falling", "maple leaf"],
    u: "1f341",
    a: "0.6"
  }, {
    n: ["leaf", "falling", "fallen leaf"],
    u: "1f342",
    a: "0.6"
  }, {
    n: ["blow", "leaf", "wind", "flutter", "leaf fluttering in wind"],
    u: "1f343",
    a: "0.6"
  }, {
    n: ["nesting", "empty nest"],
    u: "1fab9",
    a: "14"
  }, {
    n: ["nesting", "nest with eggs"],
    u: "1faba",
    a: "14"
  }, {
    n: ["mushroom", "toadstool"],
    u: "1f344",
    a: "0.6"
  }],
  food_drink: [{
    n: ["fruit", "grape", "grapes"],
    u: "1f347",
    a: "0.6"
  }, {
    n: ["melon", "fruit"],
    u: "1f348",
    a: "0.6"
  }, {
    n: ["fruit", "watermelon"],
    u: "1f349",
    a: "0.6"
  }, {
    n: ["fruit", "orange", "tangerine"],
    u: "1f34a",
    a: "0.6"
  }, {
    n: ["lemon", "fruit", "citrus"],
    u: "1f34b",
    a: "1"
  }, {
    n: ["lime", "fruit", "citrus", "tropical"],
    u: "1f34b-200d-1f7e9",
    a: "15.1"
  }, {
    n: ["fruit", "banana"],
    u: "1f34c",
    a: "0.6"
  }, {
    n: ["fruit", "pineapple"],
    u: "1f34d",
    a: "0.6"
  }, {
    n: ["mango", "fruit", "tropical"],
    u: "1f96d",
    a: "11"
  }, {
    n: ["red", "apple", "fruit", "red apple"],
    u: "1f34e",
    a: "0.6"
  }, {
    n: ["apple", "fruit", "green", "green apple"],
    u: "1f34f",
    a: "0.6"
  }, {
    n: ["pear", "fruit"],
    u: "1f350",
    a: "1"
  }, {
    n: ["peach", "fruit"],
    u: "1f351",
    a: "0.6"
  }, {
    n: ["red", "fruit", "cherry", "berries", "cherries"],
    u: "1f352",
    a: "0.6"
  }, {
    n: ["berry", "fruit", "strawberry"],
    u: "1f353",
    a: "0.6"
  }, {
    n: ["blue", "berry", "bilberry", "blueberry", "blueberries"],
    u: "1fad0",
    a: "13"
  }, {
    n: ["food", "kiwi", "fruit", "kiwi fruit"],
    u: "1f95d",
    a: "3"
  }, {
    n: ["fruit", "tomato", "vegetable"],
    u: "1f345",
    a: "0.6"
  }, {
    n: ["food", "olive"],
    u: "1fad2",
    a: "13"
  }, {
    n: ["palm", "coconut", "piña colada"],
    u: "1f965",
    a: "5"
  }, {
    n: ["food", "fruit", "avocado"],
    u: "1f951",
    a: "3"
  }, {
    n: ["eggplant", "aubergine", "vegetable"],
    u: "1f346",
    a: "0.6"
  }, {
    n: ["food", "potato", "vegetable"],
    u: "1f954",
    a: "3"
  }, {
    n: ["food", "carrot", "vegetable"],
    u: "1f955",
    a: "3"
  }, {
    n: ["ear", "corn", "maze", "maize", "ear of corn"],
    u: "1f33d",
    a: "0.6"
  }, {
    n: ["hot", "pepper", "hot pepper"],
    u: "1f336-fe0f",
    a: "0.7"
  }, {
    n: ["pepper", "capsicum", "vegetable", "bell pepper"],
    u: "1fad1",
    a: "13"
  }, {
    n: ["food", "pickle", "cucumber", "vegetable"],
    u: "1f952",
    a: "3"
  }, {
    n: ["kale", "cabbage", "lettuce", "bok choy", "leafy green"],
    u: "1f96c",
    a: "11"
  }, {
    n: ["broccoli", "wild cabbage"],
    u: "1f966",
    a: "5"
  }, {
    n: ["garlic", "flavoring"],
    u: "1f9c4",
    a: "12"
  }, {
    n: ["onion", "flavoring"],
    u: "1f9c5",
    a: "12"
  }, {
    n: ["nut", "food", "peanut", "peanuts", "vegetable"],
    u: "1f95c",
    a: "3"
  }, {
    n: ["food", "beans", "kidney", "legume"],
    u: "1fad8",
    a: "14"
  }, {
    n: ["plant", "chestnut"],
    u: "1f330",
    a: "0.6"
  }, {
    n: ["beer", "root", "spice", "ginger root"],
    u: "1fada",
    a: "15"
  }, {
    n: ["pea", "pod", "beans", "legume", "pea pod", "edamame", "vegetable"],
    u: "1fadb",
    a: "15"
  }, {
    n: ["food", "fungus", "nature", "vegetable", "brown mushroom"],
    u: "1f344-200d-1f7eb",
    a: "15.1"
  }, {
    n: ["loaf", "bread"],
    u: "1f35e",
    a: "0.6"
  }, {
    n: ["food", "roll", "bread", "french", "croissant", "breakfast"],
    u: "1f950",
    a: "3"
  }, {
    n: ["food", "bread", "french", "baguette", "baguette bread"],
    u: "1f956",
    a: "3"
  }, {
    n: ["naan", "pita", "arepa", "lavash", "flatbread"],
    u: "1fad3",
    a: "13"
  }, {
    n: ["pretzel", "twisted"],
    u: "1f968",
    a: "5"
  }, {
    n: ["bagel", "bakery", "schmear", "breakfast"],
    u: "1f96f",
    a: "11"
  }, {
    n: ["food", "crêpe", "hotcake", "pancake", "pancakes", "breakfast"],
    u: "1f95e",
    a: "3"
  }, {
    n: ["iron", "waffle", "breakfast", "indecisive"],
    u: "1f9c7",
    a: "12"
  }, {
    n: ["cheese", "cheese wedge"],
    u: "1f9c0",
    a: "1"
  }, {
    n: ["bone", "meat", "meat on bone"],
    u: "1f356",
    a: "0.6"
  }, {
    n: ["leg", "bone", "chicken", "poultry", "drumstick", "poultry leg"],
    u: "1f357",
    a: "0.6"
  }, {
    n: ["chop", "steak", "lambchop", "porkchop", "cut of meat"],
    u: "1f969",
    a: "5"
  }, {
    n: ["food", "meat", "bacon", "breakfast"],
    u: "1f953",
    a: "3"
  }, {
    n: ["burger", "hamburger"],
    u: "1f354",
    a: "0.6"
  }, {
    n: ["fries", "french", "french fries"],
    u: "1f35f",
    a: "0.6"
  }, {
    n: ["pizza", "slice", "cheese"],
    u: "1f355",
    a: "0.6"
  }, {
    n: ["hotdog", "hot dog", "sausage", "frankfurter"],
    u: "1f32d",
    a: "1"
  }, {
    n: ["bread", "sandwich"],
    u: "1f96a",
    a: "5"
  }, {
    n: ["taco", "mexican"],
    u: "1f32e",
    a: "1"
  }, {
    n: ["wrap", "burrito", "mexican"],
    u: "1f32f",
    a: "1"
  }, {
    n: ["tamale", "mexican", "wrapped"],
    u: "1fad4",
    a: "13"
  }, {
    n: ["food", "gyro", "kebab", "falafel", "stuffed", "flatbread", "stuffed flatbread"],
    u: "1f959",
    a: "3"
  }, {
    n: ["falafel", "chickpea", "meatball"],
    u: "1f9c6",
    a: "12"
  }, {
    n: ["egg", "food", "breakfast"],
    u: "1f95a",
    a: "3"
  }, {
    n: ["egg", "pan", "frying", "cooking", "breakfast"],
    u: "1f373",
    a: "0.6"
  }, {
    n: ["pan", "food", "paella", "shallow", "casserole", "shallow pan of food"],
    u: "1f958",
    a: "3"
  }, {
    n: ["pot", "stew", "pot of food"],
    u: "1f372",
    a: "0.6"
  }, {
    n: ["pot", "swiss", "fondue", "cheese", "melted", "chocolate"],
    u: "1fad5",
    a: "13"
  }, {
    n: ["cereal", "congee", "breakfast", "bowl with spoon"],
    u: "1f963",
    a: "5"
  }, {
    n: ["food", "green", "salad", "green salad"],
    u: "1f957",
    a: "3"
  }, {
    n: ["popcorn"],
    u: "1f37f",
    a: "1"
  }, {
    n: ["dairy", "butter"],
    u: "1f9c8",
    a: "12"
  }, {
    n: ["salt", "shaker", "condiment"],
    u: "1f9c2",
    a: "11"
  }, {
    n: ["can", "canned food"],
    u: "1f96b",
    a: "5"
  }, {
    n: ["box", "bento", "bento box"],
    u: "1f371",
    a: "0.6"
  }, {
    n: ["rice", "cracker", "rice cracker"],
    u: "1f358",
    a: "0.6"
  }, {
    n: ["ball", "rice", "japanese", "rice ball"],
    u: "1f359",
    a: "0.6"
  }, {
    n: ["rice", "cooked", "cooked rice"],
    u: "1f35a",
    a: "0.6"
  }, {
    n: ["rice", "curry", "curry rice"],
    u: "1f35b",
    a: "0.6"
  }, {
    n: ["bowl", "ramen", "noodle", "steaming", "steaming bowl"],
    u: "1f35c",
    a: "0.6"
  }, {
    n: ["pasta", "spaghetti"],
    u: "1f35d",
    a: "0.6"
  }, {
    n: ["sweet", "potato", "roasted", "roasted sweet potato"],
    u: "1f360",
    a: "0.6"
  }, {
    n: ["oden", "kebab", "stick", "skewer", "seafood"],
    u: "1f362",
    a: "0.6"
  }, {
    n: ["sushi"],
    u: "1f363",
    a: "0.6"
  }, {
    n: ["fried", "prawn", "shrimp", "tempura", "fried shrimp"],
    u: "1f364",
    a: "0.6"
  }, {
    n: ["cake", "fish", "swirl", "pastry", "fish cake with swirl"],
    u: "1f365",
    a: "0.6"
  }, {
    n: ["autumn", "yuèbǐng", "festival", "moon cake"],
    u: "1f96e",
    a: "11"
  }, {
    n: ["dango", "stick", "sweet", "skewer", "dessert", "japanese"],
    u: "1f361",
    a: "0.6"
  }, {
    n: ["gyōza", "jiaozi", "pierogi", "dumpling", "empanada", "potsticker"],
    u: "1f95f",
    a: "5"
  }, {
    n: ["prophecy", "fortune cookie"],
    u: "1f960",
    a: "5"
  }, {
    n: ["takeout box", "oyster pail"],
    u: "1f961",
    a: "5"
  }, {
    n: ["crab", "cancer", "zodiac"],
    u: "1f980",
    a: "1"
  }, {
    n: ["claws", "bisque", "lobster", "seafood"],
    u: "1f99e",
    a: "11"
  }, {
    n: ["food", "small", "shrimp", "shellfish"],
    u: "1f990",
    a: "3"
  }, {
    n: ["food", "squid", "molusc"],
    u: "1f991",
    a: "3"
  }, {
    n: ["pearl", "oyster", "diving"],
    u: "1f9aa",
    a: "12"
  }, {
    n: ["ice", "soft", "cream", "sweet", "dessert", "icecream", "soft ice cream"],
    u: "1f366",
    a: "0.6"
  }, {
    n: ["ice", "sweet", "shaved", "dessert", "shaved ice"],
    u: "1f367",
    a: "0.6"
  }, {
    n: ["ice", "cream", "sweet", "dessert", "ice cream"],
    u: "1f368",
    a: "0.6"
  }, {
    n: ["donut", "sweet", "dessert", "doughnut", "breakfast"],
    u: "1f369",
    a: "0.6"
  }, {
    n: ["sweet", "cookie", "dessert"],
    u: "1f36a",
    a: "0.6"
  }, {
    n: ["cake", "sweet", "pastry", "dessert", "birthday", "celebration", "birthday cake"],
    u: "1f382",
    a: "0.6"
  }, {
    n: ["cake", "slice", "sweet", "pastry", "dessert", "shortcake"],
    u: "1f370",
    a: "0.6"
  }, {
    n: ["sweet", "bakery", "cupcake"],
    u: "1f9c1",
    a: "11"
  }, {
    n: ["pie", "pastry", "filling"],
    u: "1f967",
    a: "5"
  }, {
    n: ["bar", "sweet", "dessert", "chocolate", "chocolate bar"],
    u: "1f36b",
    a: "0.6"
  }, {
    n: ["candy", "sweet", "dessert"],
    u: "1f36c",
    a: "0.6"
  }, {
    n: ["candy", "sweet", "dessert", "lollipop"],
    u: "1f36d",
    a: "0.6"
  }, {
    n: ["sweet", "custard", "dessert", "pudding"],
    u: "1f36e",
    a: "0.6"
  }, {
    n: ["pot", "honey", "sweet", "honeypot", "honey pot"],
    u: "1f36f",
    a: "0.6"
  }, {
    n: ["baby", "milk", "drink", "bottle", "baby bottle"],
    u: "1f37c",
    a: "1"
  }, {
    n: ["milk", "drink", "glass", "glass of milk"],
    u: "1f95b",
    a: "3"
  }, {
    n: ["hot", "tea", "drink", "coffee", "beverage", "steaming", "hot beverage"],
    u: "2615",
    a: "0.6"
  }, {
    n: ["pot", "tea", "drink", "teapot"],
    u: "1fad6",
    a: "13"
  }, {
    n: ["cup", "tea", "drink", "teacup", "beverage", "teacup without handle"],
    u: "1f375",
    a: "0.6"
  }, {
    n: ["bar", "cup", "sake", "drink", "bottle", "beverage"],
    u: "1f376",
    a: "0.6"
  }, {
    n: ["bar", "cork", "drink", "bottle", "popping", "bottle with popping cork"],
    u: "1f37e",
    a: "1"
  }, {
    n: ["bar", "wine", "drink", "glass", "beverage", "wine glass"],
    u: "1f377",
    a: "0.6"
  }, {
    n: ["bar", "drink", "glass", "cocktail", "cocktail glass"],
    u: "1f378",
    a: "0.6"
  }, {
    n: ["bar", "drink", "tropical", "tropical drink"],
    u: "1f379",
    a: "0.6"
  }, {
    n: ["bar", "mug", "beer", "drink", "beer mug"],
    u: "1f37a",
    a: "0.6"
  }, {
    n: ["bar", "mug", "beer", "clink", "drink", "clinking beer mugs"],
    u: "1f37b",
    a: "0.6"
  }, {
    n: ["clink", "drink", "glass", "celebrate", "clinking glasses"],
    u: "1f942",
    a: "3"
  }, {
    n: ["shot", "glass", "liquor", "whisky", "tumbler", "tumbler glass"],
    u: "1f943",
    a: "3"
  }, {
    n: ["drink", "empty", "glass", "spill", "pouring liquid"],
    u: "1fad7",
    a: "14"
  }, {
    n: ["soda", "juice", "cup with straw"],
    u: "1f964",
    a: "5"
  }, {
    n: ["tea", "milk", "pearl", "bubble", "bubble tea"],
    u: "1f9cb",
    a: "13"
  }, {
    n: ["box", "juice", "straw", "sweet", "beverage", "beverage box"],
    u: "1f9c3",
    a: "12"
  }, {
    n: ["mate", "drink"],
    u: "1f9c9",
    a: "12"
  }, {
    n: ["ice", "cold", "iceberg", "ice cube"],
    u: "1f9ca",
    a: "12"
  }, {
    n: ["hashi", "chopsticks"],
    u: "1f962",
    a: "5"
  }, {
    n: ["fork", "knife", "plate", "cooking", "fork and knife with plate"],
    u: "1f37d-fe0f",
    a: "0.7"
  }, {
    n: ["fork", "knife", "cooking", "cutlery", "fork and knife"],
    u: "1f374",
    a: "0.6"
  }, {
    n: ["spoon", "tableware"],
    u: "1f944",
    a: "3"
  }, {
    n: ["tool", "hocho", "knife", "weapon", "cooking", "kitchen knife"],
    u: "1f52a",
    a: "0.6"
  }, {
    n: ["jar", "empty", "sauce", "store", "condiment", "container"],
    u: "1fad9",
    a: "14"
  }, {
    n: ["jug", "drink", "zodiac", "amphora", "cooking", "aquarius"],
    u: "1f3fa",
    a: "1"
  }],
  travel_places: [{
    n: ["earth", "globe", "world", "africa", "europe", "globe showing Europe Africa", "globe showing europe africa"],
    u: "1f30d",
    a: "0.7"
  }, {
    n: ["earth", "globe", "world", "americas", "globe showing Americas", "globe showing americas"],
    u: "1f30e",
    a: "0.7"
  }, {
    n: ["asia", "earth", "globe", "world", "australia", "globe showing Asia Australia", "globe showing asia australia"],
    u: "1f30f",
    a: "0.6"
  }, {
    n: ["earth", "globe", "world", "meridians", "globe with meridians"],
    u: "1f310",
    a: "1"
  }, {
    n: ["map", "world", "world map"],
    u: "1f5fa-fe0f",
    a: "0.7"
  }, {
    n: ["map", "japan", "map of Japan", "map of japan"],
    u: "1f5fe",
    a: "0.6"
  }, {
    n: ["compass", "magnetic", "navigation", "orienteering"],
    u: "1f9ed",
    a: "11"
  }, {
    n: ["cold", "snow", "mountain", "snow capped mountain"],
    u: "1f3d4-fe0f",
    a: "0.7"
  }, {
    n: ["mountain"],
    u: "26f0-fe0f",
    a: "0.7"
  }, {
    n: ["volcano", "eruption", "mountain"],
    u: "1f30b",
    a: "0.6"
  }, {
    n: ["fuji", "mountain", "mount fuji"],
    u: "1f5fb",
    a: "0.6"
  }, {
    n: ["camping"],
    u: "1f3d5-fe0f",
    a: "0.7"
  }, {
    n: ["beach", "umbrella", "beach with umbrella"],
    u: "1f3d6-fe0f",
    a: "0.7"
  }, {
    n: ["desert"],
    u: "1f3dc-fe0f",
    a: "0.7"
  }, {
    n: ["desert", "island", "desert island"],
    u: "1f3dd-fe0f",
    a: "0.7"
  }, {
    n: ["park", "national park"],
    u: "1f3de-fe0f",
    a: "0.7"
  }, {
    n: ["stadium"],
    u: "1f3df-fe0f",
    a: "0.7"
  }, {
    n: ["classical", "classical building"],
    u: "1f3db-fe0f",
    a: "0.7"
  }, {
    n: ["construction", "building construction"],
    u: "1f3d7-fe0f",
    a: "0.7"
  }, {
    n: ["clay", "wall", "brick", "bricks", "mortar"],
    u: "1f9f1",
    a: "11"
  }, {
    n: ["rock", "heavy", "solid", "stone", "boulder"],
    u: "1faa8",
    a: "13"
  }, {
    n: ["log", "wood", "lumber", "timber"],
    u: "1fab5",
    a: "13"
  }, {
    n: ["hut", "yurt", "house", "roundhouse"],
    u: "1f6d6",
    a: "13"
  }, {
    n: ["houses"],
    u: "1f3d8-fe0f",
    a: "0.7"
  }, {
    n: ["house", "derelict", "derelict house"],
    u: "1f3da-fe0f",
    a: "0.7"
  }, {
    n: ["home", "house"],
    u: "1f3e0",
    a: "0.6"
  }, {
    n: ["home", "house", "garden", "house with garden"],
    u: "1f3e1",
    a: "0.6"
  }, {
    n: ["building", "office building"],
    u: "1f3e2",
    a: "0.6"
  }, {
    n: ["post", "japanese", "Japanese post office", "japanese post office"],
    u: "1f3e3",
    a: "0.6"
  }, {
    n: ["post", "european", "post office"],
    u: "1f3e4",
    a: "1"
  }, {
    n: ["doctor", "hospital", "medicine"],
    u: "1f3e5",
    a: "0.6"
  }, {
    n: ["bank", "building"],
    u: "1f3e6",
    a: "0.6"
  }, {
    n: ["hotel", "building"],
    u: "1f3e8",
    a: "0.6"
  }, {
    n: ["love", "hotel", "love hotel"],
    u: "1f3e9",
    a: "0.6"
  }, {
    n: ["store", "convenience", "convenience store"],
    u: "1f3ea",
    a: "0.6"
  }, {
    n: ["school", "building"],
    u: "1f3eb",
    a: "0.6"
  }, {
    n: ["store", "department", "department store"],
    u: "1f3ec",
    a: "0.6"
  }, {
    n: ["factory", "building"],
    u: "1f3ed",
    a: "0.6"
  }, {
    n: ["castle", "japanese", "Japanese castle"],
    u: "1f3ef",
    a: "0.6"
  }, {
    n: ["castle", "european"],
    u: "1f3f0",
    a: "0.6"
  }, {
    n: ["chapel", "wedding", "romance"],
    u: "1f492",
    a: "0.6"
  }, {
    n: ["tokyo", "tower", "Tokyo tower"],
    u: "1f5fc",
    a: "0.6"
  }, {
    n: ["statue", "liberty", "Statue of Liberty", "statue of liberty"],
    u: "1f5fd",
    a: "0.6"
  }, {
    n: ["cross", "church", "religion", "christian"],
    u: "26ea",
    a: "0.6"
  }, {
    n: ["islam", "mosque", "muslim", "religion"],
    u: "1f54c",
    a: "1"
  }, {
    n: ["hindu", "temple", "hindu temple"],
    u: "1f6d5",
    a: "12"
  }, {
    n: ["jew", "jewish", "temple", "religion", "synagogue"],
    u: "1f54d",
    a: "1"
  }, {
    n: ["shinto", "shrine", "religion", "shinto shrine"],
    u: "26e9-fe0f",
    a: "0.7"
  }, {
    n: ["kaaba", "islam", "muslim", "religion"],
    u: "1f54b",
    a: "1"
  }, {
    n: ["fountain"],
    u: "26f2",
    a: "0.6"
  }, {
    n: ["tent", "camping"],
    u: "26fa",
    a: "0.6"
  }, {
    n: ["fog", "foggy"],
    u: "1f301",
    a: "0.6"
  }, {
    n: ["star", "night", "night with stars"],
    u: "1f303",
    a: "0.6"
  }, {
    n: ["city", "cityscape"],
    u: "1f3d9-fe0f",
    a: "0.7"
  }, {
    n: ["sun", "morning", "sunrise", "mountain", "sunrise over mountains"],
    u: "1f304",
    a: "0.6"
  }, {
    n: ["sun", "sunrise", "morning"],
    u: "1f305",
    a: "0.6"
  }, {
    n: ["city", "dusk", "sunset", "evening", "landscape", "cityscape at dusk"],
    u: "1f306",
    a: "0.6"
  }, {
    n: ["sun", "dusk", "sunset"],
    u: "1f307",
    a: "0.6"
  }, {
    n: ["night", "bridge", "bridge at night"],
    u: "1f309",
    a: "0.6"
  }, {
    n: ["hot", "springs", "steaming", "hotsprings", "hot springs"],
    u: "2668-fe0f",
    a: "0.6"
  }, {
    n: ["horse", "carousel", "carousel horse"],
    u: "1f3a0",
    a: "0.6"
  }, {
    n: ["play", "theme park", "amusement park", "playground slide"],
    u: "1f6dd",
    a: "14"
  }, {
    n: ["wheel", "ferris", "theme park", "ferris wheel", "amusement park"],
    u: "1f3a1",
    a: "0.6"
  }, {
    n: ["roller", "coaster", "theme park", "roller coaster", "amusement park"],
    u: "1f3a2",
    a: "0.6"
  }, {
    n: ["pole", "barber", "haircut", "barber pole"],
    u: "1f488",
    a: "0.6"
  }, {
    n: ["tent", "circus", "circus tent"],
    u: "1f3aa",
    a: "0.6"
  }, {
    n: ["steam", "train", "engine", "railway", "locomotive"],
    u: "1f682",
    a: "1"
  }, {
    n: ["car", "tram", "train", "railway", "electric", "trolleybus", "railway car"],
    u: "1f683",
    a: "0.6"
  }, {
    n: ["speed", "train", "railway", "shinkansen", "high speed train"],
    u: "1f684",
    a: "0.6"
  }, {
    n: ["speed", "train", "bullet", "railway", "shinkansen", "bullet train"],
    u: "1f685",
    a: "0.6"
  }, {
    n: ["train", "railway"],
    u: "1f686",
    a: "1"
  }, {
    n: ["metro", "subway"],
    u: "1f687",
    a: "0.6"
  }, {
    n: ["railway", "light rail"],
    u: "1f688",
    a: "1"
  }, {
    n: ["train", "station", "railway"],
    u: "1f689",
    a: "0.6"
  }, {
    n: ["tram", "trolleybus"],
    u: "1f68a",
    a: "1"
  }, {
    n: ["vehicle", "monorail"],
    u: "1f69d",
    a: "1"
  }, {
    n: ["car", "railway", "mountain", "mountain railway"],
    u: "1f69e",
    a: "1"
  }, {
    n: ["car", "tram", "tram car", "trolleybus"],
    u: "1f68b",
    a: "1"
  }, {
    n: ["bus", "vehicle"],
    u: "1f68c",
    a: "0.6"
  }, {
    n: ["bus", "oncoming", "oncoming bus"],
    u: "1f68d",
    a: "0.7"
  }, {
    n: ["bus", "tram", "trolley", "trolleybus"],
    u: "1f68e",
    a: "1"
  }, {
    n: ["bus", "minibus"],
    u: "1f690",
    a: "1"
  }, {
    n: ["vehicle", "ambulance"],
    u: "1f691",
    a: "0.6"
  }, {
    n: ["fire", "truck", "engine", "fire engine"],
    u: "1f692",
    a: "0.6"
  }, {
    n: ["car", "patrol", "police", "police car"],
    u: "1f693",
    a: "0.6"
  }, {
    n: ["car", "police", "oncoming", "oncoming police car"],
    u: "1f694",
    a: "0.7"
  }, {
    n: ["taxi", "vehicle"],
    u: "1f695",
    a: "0.6"
  }, {
    n: ["taxi", "oncoming", "oncoming taxi"],
    u: "1f696",
    a: "1"
  }, {
    n: ["car", "automobile"],
    u: "1f697",
    a: "0.6"
  }, {
    n: ["car", "oncoming", "automobile", "oncoming automobile"],
    u: "1f698",
    a: "0.7"
  }, {
    n: ["recreational", "sport utility", "sport utility vehicle"],
    u: "1f699",
    a: "0.6"
  }, {
    n: ["truck", "pickup", "pick up", "pickup truck"],
    u: "1f6fb",
    a: "13"
  }, {
    n: ["truck", "delivery", "delivery truck"],
    u: "1f69a",
    a: "0.6"
  }, {
    n: ["semi", "lorry", "truck", "articulated lorry"],
    u: "1f69b",
    a: "1"
  }, {
    n: ["tractor", "vehicle"],
    u: "1f69c",
    a: "1"
  }, {
    n: ["car", "racing", "racing car"],
    u: "1f3ce-fe0f",
    a: "0.7"
  }, {
    n: ["racing", "motorcycle"],
    u: "1f3cd-fe0f",
    a: "0.7"
  }, {
    n: ["motor", "scooter", "motor scooter"],
    u: "1f6f5",
    a: "3"
  }, {
    n: ["accessibility", "manual wheelchair"],
    u: "1f9bd",
    a: "12"
  }, {
    n: ["accessibility", "motorized wheelchair"],
    u: "1f9bc",
    a: "12"
  }, {
    n: ["tuk tuk", "auto rickshaw"],
    u: "1f6fa",
    a: "12"
  }, {
    n: ["bike", "bicycle"],
    u: "1f6b2",
    a: "0.6"
  }, {
    n: ["kick", "scooter", "kick scooter"],
    u: "1f6f4",
    a: "3"
  }, {
    n: ["board", "skateboard"],
    u: "1f6f9",
    a: "11"
  }, {
    n: ["skate", "roller", "roller skate"],
    u: "1f6fc",
    a: "13"
  }, {
    n: ["bus", "stop", "bus stop"],
    u: "1f68f",
    a: "0.6"
  }, {
    n: ["road", "highway", "motorway"],
    u: "1f6e3-fe0f",
    a: "0.7"
  }, {
    n: ["train", "railway", "railway track"],
    u: "1f6e4-fe0f",
    a: "0.7"
  }, {
    n: ["oil", "drum", "oil drum"],
    u: "1f6e2-fe0f",
    a: "0.7"
  }, {
    n: ["gas", "fuel", "pump", "diesel", "station", "fuelpump", "fuel pump"],
    u: "26fd",
    a: "0.6"
  }, {
    n: ["tire", "turn", "wheel", "circle"],
    u: "1f6de",
    a: "14"
  }, {
    n: ["car", "light", "beacon", "police", "revolving", "police car light"],
    u: "1f6a8",
    a: "0.6"
  }, {
    n: ["light", "signal", "traffic", "horizontal traffic light"],
    u: "1f6a5",
    a: "0.6"
  }, {
    n: ["light", "signal", "traffic", "vertical traffic light"],
    u: "1f6a6",
    a: "1"
  }, {
    n: ["sign", "stop", "stop sign", "octagonal"],
    u: "1f6d1",
    a: "3"
  }, {
    n: ["barrier", "construction"],
    u: "1f6a7",
    a: "0.6"
  }, {
    n: ["ship", "tool", "anchor"],
    u: "2693",
    a: "0.6"
  }, {
    n: ["float", "rescue", "safety", "ring buoy", "life saver", "life preserver"],
    u: "1f6df",
    a: "14"
  }, {
    n: ["sea", "boat", "yacht", "resort", "sailboat"],
    u: "26f5",
    a: "0.6"
  }, {
    n: ["boat", "canoe"],
    u: "1f6f6",
    a: "3"
  }, {
    n: ["boat", "speedboat"],
    u: "1f6a4",
    a: "0.6"
  }, {
    n: ["ship", "passenger", "passenger ship"],
    u: "1f6f3-fe0f",
    a: "0.7"
  }, {
    n: ["boat", "ferry", "passenger"],
    u: "26f4-fe0f",
    a: "0.7"
  }, {
    n: ["boat", "motorboat", "motor boat"],
    u: "1f6e5-fe0f",
    a: "0.7"
  }, {
    n: ["ship", "boat", "passenger"],
    u: "1f6a2",
    a: "0.6"
  }, {
    n: ["airplane", "aeroplane"],
    u: "2708-fe0f",
    a: "0.6"
  }, {
    n: ["airplane", "aeroplane", "small airplane"],
    u: "1f6e9-fe0f",
    a: "0.7"
  }, {
    n: ["airplane", "check in", "aeroplane", "departure", "departures", "airplane departure"],
    u: "1f6eb",
    a: "1"
  }, {
    n: ["landing", "airplane", "arrivals", "arriving", "aeroplane", "airplane arrival"],
    u: "1f6ec",
    a: "1"
  }, {
    n: ["skydive", "parasail", "parachute", "hang glide"],
    u: "1fa82",
    a: "12"
  }, {
    n: ["seat", "chair"],
    u: "1f4ba",
    a: "0.6"
  }, {
    n: ["vehicle", "helicopter"],
    u: "1f681",
    a: "1"
  }, {
    n: ["railway", "suspension", "suspension railway"],
    u: "1f69f",
    a: "1"
  }, {
    n: ["cable", "gondola", "mountain", "mountain cableway"],
    u: "1f6a0",
    a: "1"
  }, {
    n: ["car", "cable", "aerial", "gondola", "tramway", "aerial tramway"],
    u: "1f6a1",
    a: "1"
  }, {
    n: ["space", "satellite"],
    u: "1f6f0-fe0f",
    a: "0.7"
  }, {
    n: ["space", "rocket"],
    u: "1f680",
    a: "0.6"
  }, {
    n: ["ufo", "flying saucer"],
    u: "1f6f8",
    a: "5"
  }, {
    n: ["bell", "hotel", "bellhop", "bellhop bell"],
    u: "1f6ce-fe0f",
    a: "0.7"
  }, {
    n: ["travel", "luggage", "packing"],
    u: "1f9f3",
    a: "11"
  }, {
    n: ["sand", "timer", "hourglass done"],
    u: "231b",
    a: "0.6"
  }, {
    n: ["sand", "timer", "hourglass", "hourglass not done"],
    u: "23f3",
    a: "0.6"
  }, {
    n: ["watch", "clock"],
    u: "231a",
    a: "0.6"
  }, {
    n: ["alarm", "clock", "alarm clock"],
    u: "23f0",
    a: "0.6"
  }, {
    n: ["clock", "stopwatch"],
    u: "23f1-fe0f",
    a: "1"
  }, {
    n: ["clock", "timer", "timer clock"],
    u: "23f2-fe0f",
    a: "1"
  }, {
    n: ["clock", "mantelpiece clock"],
    u: "1f570-fe0f",
    a: "0.7"
  }, {
    n: ["00", "12", "12:00", "clock", "twelve", "o’clock", "twelve o’clock"],
    u: "1f55b",
    a: "0.6"
  }, {
    n: ["12", "12:30", "clock", "thirty", "twelve", "twelve thirty"],
    u: "1f567",
    a: "0.7"
  }, {
    n: ["1", "00", "one", "1:00", "clock", "o’clock", "one o’clock"],
    u: "1f550",
    a: "0.6"
  }, {
    n: ["1", "one", "1:30", "clock", "thirty", "one thirty"],
    u: "1f55c",
    a: "0.7"
  }, {
    n: ["2", "00", "two", "2:00", "clock", "o’clock", "two o’clock"],
    u: "1f551",
    a: "0.6"
  }, {
    n: ["2", "two", "2:30", "clock", "thirty", "two thirty"],
    u: "1f55d",
    a: "0.7"
  }, {
    n: ["3", "00", "3:00", "clock", "three", "o’clock", "three o’clock"],
    u: "1f552",
    a: "0.6"
  }, {
    n: ["3", "3:30", "clock", "three", "thirty", "three thirty"],
    u: "1f55e",
    a: "0.7"
  }, {
    n: ["4", "00", "4:00", "four", "clock", "o’clock", "four o’clock"],
    u: "1f553",
    a: "0.6"
  }, {
    n: ["4", "4:30", "four", "clock", "thirty", "four thirty"],
    u: "1f55f",
    a: "0.7"
  }, {
    n: ["5", "00", "5:00", "five", "clock", "o’clock", "five o’clock"],
    u: "1f554",
    a: "0.6"
  }, {
    n: ["5", "5:30", "five", "clock", "thirty", "five thirty"],
    u: "1f560",
    a: "0.7"
  }, {
    n: ["6", "00", "six", "6:00", "clock", "o’clock", "six o’clock"],
    u: "1f555",
    a: "0.6"
  }, {
    n: ["6", "six", "6:30", "clock", "thirty", "six thirty"],
    u: "1f561",
    a: "0.7"
  }, {
    n: ["7", "00", "7:00", "clock", "seven", "o’clock", "seven o’clock"],
    u: "1f556",
    a: "0.6"
  }, {
    n: ["7", "7:30", "clock", "seven", "thirty", "seven thirty"],
    u: "1f562",
    a: "0.7"
  }, {
    n: ["8", "00", "8:00", "clock", "eight", "o’clock", "eight o’clock"],
    u: "1f557",
    a: "0.6"
  }, {
    n: ["8", "8:30", "clock", "eight", "thirty", "eight thirty"],
    u: "1f563",
    a: "0.7"
  }, {
    n: ["9", "00", "9:00", "nine", "clock", "o’clock", "nine o’clock"],
    u: "1f558",
    a: "0.6"
  }, {
    n: ["9", "9:30", "nine", "clock", "thirty", "nine thirty"],
    u: "1f564",
    a: "0.7"
  }, {
    n: ["00", "10", "ten", "10:00", "clock", "o’clock", "ten o’clock"],
    u: "1f559",
    a: "0.6"
  }, {
    n: ["10", "ten", "10:30", "clock", "thirty", "ten thirty"],
    u: "1f565",
    a: "0.7"
  }, {
    n: ["00", "11", "11:00", "clock", "eleven", "o’clock", "eleven o’clock"],
    u: "1f55a",
    a: "0.6"
  }, {
    n: ["11", "11:30", "clock", "eleven", "thirty", "eleven thirty"],
    u: "1f566",
    a: "0.7"
  }, {
    n: ["dark", "moon", "new moon"],
    u: "1f311",
    a: "0.6"
  }, {
    n: ["moon", "waxing", "crescent", "waxing crescent moon"],
    u: "1f312",
    a: "1"
  }, {
    n: ["moon", "quarter", "first quarter moon"],
    u: "1f313",
    a: "0.6"
  }, {
    n: ["moon", "waxing", "gibbous", "waxing gibbous moon"],
    u: "1f314",
    a: "0.6"
  }, {
    n: ["full", "moon", "full moon"],
    u: "1f315",
    a: "0.6"
  }, {
    n: ["moon", "waning", "gibbous", "waning gibbous moon"],
    u: "1f316",
    a: "1"
  }, {
    n: ["moon", "quarter", "last quarter moon"],
    u: "1f317",
    a: "1"
  }, {
    n: ["moon", "waning", "crescent", "waning crescent moon"],
    u: "1f318",
    a: "1"
  }, {
    n: ["moon", "crescent", "crescent moon"],
    u: "1f319",
    a: "0.6"
  }, {
    n: ["face", "moon", "new moon face"],
    u: "1f31a",
    a: "1"
  }, {
    n: ["face", "moon", "quarter", "first quarter moon face"],
    u: "1f31b",
    a: "0.6"
  }, {
    n: ["face", "moon", "quarter", "last quarter moon face"],
    u: "1f31c",
    a: "0.7"
  }, {
    n: ["weather", "thermometer"],
    u: "1f321-fe0f",
    a: "0.7"
  }, {
    n: ["sun", "rays", "sunny", "bright"],
    u: "2600-fe0f",
    a: "0.6"
  }, {
    n: ["face", "full", "moon", "bright", "full moon face"],
    u: "1f31d",
    a: "1"
  }, {
    n: ["sun", "face", "bright", "sun with face"],
    u: "1f31e",
    a: "1"
  }, {
    n: ["saturn", "saturnine", "ringed planet"],
    u: "1fa90",
    a: "12"
  }, {
    n: ["star"],
    u: "2b50",
    a: "0.6"
  }, {
    n: ["glow", "star", "shining", "sparkle", "glittery", "glowing star"],
    u: "1f31f",
    a: "0.6"
  }, {
    n: ["star", "falling", "shooting", "shooting star"],
    u: "1f320",
    a: "0.6"
  }, {
    n: ["space", "milky way"],
    u: "1f30c",
    a: "0.6"
  }, {
    n: ["cloud", "weather"],
    u: "2601-fe0f",
    a: "0.6"
  }, {
    n: ["sun", "cloud", "sun behind cloud"],
    u: "26c5",
    a: "0.6"
  }, {
    n: ["rain", "cloud", "thunder", "cloud with lightning and rain"],
    u: "26c8-fe0f",
    a: "0.7"
  }, {
    n: ["sun", "cloud", "sun behind small cloud"],
    u: "1f324-fe0f",
    a: "0.7"
  }, {
    n: ["sun", "cloud", "sun behind large cloud"],
    u: "1f325-fe0f",
    a: "0.7"
  }, {
    n: ["sun", "rain", "cloud", "sun behind rain cloud"],
    u: "1f326-fe0f",
    a: "0.7"
  }, {
    n: ["rain", "cloud", "cloud with rain"],
    u: "1f327-fe0f",
    a: "0.7"
  }, {
    n: ["cold", "snow", "cloud", "cloud with snow"],
    u: "1f328-fe0f",
    a: "0.7"
  }, {
    n: ["cloud", "lightning", "cloud with lightning"],
    u: "1f329-fe0f",
    a: "0.7"
  }, {
    n: ["cloud", "tornado", "whirlwind"],
    u: "1f32a-fe0f",
    a: "0.7"
  }, {
    n: ["fog", "cloud"],
    u: "1f32b-fe0f",
    a: "0.7"
  }, {
    n: ["blow", "face", "wind", "cloud", "wind face"],
    u: "1f32c-fe0f",
    a: "0.7"
  }, {
    n: ["dizzy", "cyclone", "twister", "typhoon", "hurricane"],
    u: "1f300",
    a: "0.6"
  }, {
    n: ["rain", "rainbow"],
    u: "1f308",
    a: "0.6"
  }, {
    n: ["rain", "clothing", "umbrella", "closed umbrella"],
    u: "1f302",
    a: "0.6"
  }, {
    n: ["rain", "umbrella", "clothing"],
    u: "2602-fe0f",
    a: "0.7"
  }, {
    n: ["drop", "rain", "clothing", "umbrella", "umbrella with rain drops"],
    u: "2614",
    a: "0.6"
  }, {
    n: ["sun", "rain", "umbrella", "umbrella on ground"],
    u: "26f1-fe0f",
    a: "0.7"
  }, {
    n: ["zap", "danger", "voltage", "electric", "lightning", "high voltage"],
    u: "26a1",
    a: "0.6"
  }, {
    n: ["cold", "snow", "snowflake"],
    u: "2744-fe0f",
    a: "0.6"
  }, {
    n: ["cold", "snow", "snowman"],
    u: "2603-fe0f",
    a: "0.7"
  }, {
    n: ["cold", "snow", "snowman", "snowman without snow"],
    u: "26c4",
    a: "0.6"
  }, {
    n: ["comet", "space"],
    u: "2604-fe0f",
    a: "1"
  }, {
    n: ["fire", "tool", "flame"],
    u: "1f525",
    a: "0.6"
  }, {
    n: ["cold", "drop", "comic", "sweat", "droplet"],
    u: "1f4a7",
    a: "0.6"
  }, {
    n: ["wave", "ocean", "water", "water wave"],
    u: "1f30a",
    a: "0.6"
  }],
  activities: [{
    n: ["jack", "lantern", "halloween", "celebration", "jack o lantern"],
    u: "1f383",
    a: "0.6"
  }, {
    n: ["tree", "christmas", "celebration", "Christmas tree"],
    u: "1f384",
    a: "0.6"
  }, {
    n: ["fireworks", "celebration"],
    u: "1f386",
    a: "0.6"
  }, {
    n: ["sparkle", "sparkler", "fireworks", "celebration"],
    u: "1f387",
    a: "0.6"
  }, {
    n: ["dynamite", "explosive", "fireworks", "firecracker"],
    u: "1f9e8",
    a: "11"
  }, {
    n: ["*", "star", "sparkle", "sparkles"],
    u: "2728",
    a: "0.6"
  }, {
    n: ["balloon", "celebration"],
    u: "1f388",
    a: "0.6"
  }, {
    n: ["tada", "party", "popper", "celebration", "party popper"],
    u: "1f389",
    a: "0.6"
  }, {
    n: ["ball", "confetti", "celebration", "confetti ball"],
    u: "1f38a",
    a: "0.6"
  }, {
    n: ["tree", "banner", "japanese", "celebration", "tanabata tree"],
    u: "1f38b",
    a: "0.6"
  }, {
    n: ["pine", "bamboo", "japanese", "celebration", "pine decoration"],
    u: "1f38d",
    a: "0.6"
  }, {
    n: ["doll", "festival", "japanese", "celebration", "Japanese dolls", "japanese dolls"],
    u: "1f38e",
    a: "0.6"
  }, {
    n: ["carp", "streamer", "celebration", "carp streamer"],
    u: "1f38f",
    a: "0.6"
  }, {
    n: ["bell", "wind", "chime", "wind chime", "celebration"],
    u: "1f390",
    a: "0.6"
  }, {
    n: ["moon", "ceremony", "celebration", "moon viewing ceremony"],
    u: "1f391",
    a: "0.6"
  }, {
    n: ["gift", "money", "hóngbāo", "lai see", "good luck", "red envelope"],
    u: "1f9e7",
    a: "11"
  }, {
    n: ["ribbon", "celebration"],
    u: "1f380",
    a: "0.6"
  }, {
    n: ["box", "gift", "present", "wrapped", "celebration", "wrapped gift"],
    u: "1f381",
    a: "0.6"
  }, {
    n: ["ribbon", "reminder", "celebration", "reminder ribbon"],
    u: "1f397-fe0f",
    a: "0.7"
  }, {
    n: ["ticket", "admission", "admission tickets"],
    u: "1f39f-fe0f",
    a: "0.7"
  }, {
    n: ["ticket", "admission"],
    u: "1f3ab",
    a: "0.6"
  }, {
    n: ["medal", "military", "celebration", "military medal"],
    u: "1f396-fe0f",
    a: "0.7"
  }, {
    n: ["prize", "trophy"],
    u: "1f3c6",
    a: "0.6"
  }, {
    n: ["medal", "sports medal"],
    u: "1f3c5",
    a: "1"
  }, {
    n: ["gold", "first", "medal", "1st place medal"],
    u: "1f947",
    a: "3"
  }, {
    n: ["medal", "second", "silver", "2nd place medal"],
    u: "1f948",
    a: "3"
  }, {
    n: ["medal", "third", "bronze", "3rd place medal"],
    u: "1f949",
    a: "3"
  }, {
    n: ["ball", "soccer", "football", "soccer ball"],
    u: "26bd",
    a: "0.6"
  }, {
    n: ["ball", "baseball"],
    u: "26be",
    a: "0.6"
  }, {
    n: ["ball", "glove", "softball", "underarm"],
    u: "1f94e",
    a: "11"
  }, {
    n: ["ball", "hoop", "basketball"],
    u: "1f3c0",
    a: "0.6"
  }, {
    n: ["ball", "game", "volleyball"],
    u: "1f3d0",
    a: "1"
  }, {
    n: ["ball", "american", "football", "american football"],
    u: "1f3c8",
    a: "0.6"
  }, {
    n: ["ball", "rugby", "football", "rugby football"],
    u: "1f3c9",
    a: "1"
  }, {
    n: ["ball", "tennis", "racquet"],
    u: "1f3be",
    a: "0.6"
  }, {
    n: ["ultimate", "flying disc"],
    u: "1f94f",
    a: "11"
  }, {
    n: ["ball", "game", "bowling"],
    u: "1f3b3",
    a: "0.6"
  }, {
    n: ["bat", "ball", "game", "cricket game"],
    u: "1f3cf",
    a: "1"
  }, {
    n: ["ball", "game", "field", "stick", "hockey", "field hockey"],
    u: "1f3d1",
    a: "1"
  }, {
    n: ["ice", "game", "puck", "stick", "hockey", "ice hockey"],
    u: "1f3d2",
    a: "1"
  }, {
    n: ["ball", "goal", "stick", "lacrosse"],
    u: "1f94d",
    a: "11"
  }, {
    n: ["bat", "ball", "game", "paddle", "ping pong", "table tennis"],
    u: "1f3d3",
    a: "1"
  }, {
    n: ["game", "birdie", "racquet", "badminton", "shuttlecock"],
    u: "1f3f8",
    a: "1"
  }, {
    n: ["glove", "boxing", "boxing glove"],
    u: "1f94a",
    a: "3"
  }, {
    n: ["judo", "karate", "uniform", "taekwondo", "martial arts", "martial arts uniform"],
    u: "1f94b",
    a: "3"
  }, {
    n: ["net", "goal", "goal net"],
    u: "1f945",
    a: "3"
  }, {
    n: ["golf", "hole", "flag in hole"],
    u: "26f3",
    a: "0.6"
  }, {
    n: ["ice", "skate", "ice skate"],
    u: "26f8-fe0f",
    a: "0.7"
  }, {
    n: ["fish", "pole", "fishing pole"],
    u: "1f3a3",
    a: "0.6"
  }, {
    n: ["scuba", "diving", "snorkeling", "diving mask"],
    u: "1f93f",
    a: "12"
  }, {
    n: ["sash", "shirt", "running", "athletics", "running shirt"],
    u: "1f3bd",
    a: "0.6"
  }, {
    n: ["ski", "skis", "snow"],
    u: "1f3bf",
    a: "0.6"
  }, {
    n: ["sled", "sledge", "sleigh"],
    u: "1f6f7",
    a: "5"
  }, {
    n: ["game", "rock", "curling stone"],
    u: "1f94c",
    a: "5"
  }, {
    n: ["hit", "dart", "game", "target", "bullseye", "direct hit"],
    u: "1f3af",
    a: "0.6"
  }, {
    n: ["toy", "yo yo", "fluctuate"],
    u: "1fa80",
    a: "12"
  }, {
    n: ["fly", "kite", "soar"],
    u: "1fa81",
    a: "12"
  }, {
    n: ["gun", "tool", "water", "pistol", "weapon", "handgun", "revolver", "water pistol"],
    u: "1f52b",
    a: "0.6"
  }, {
    n: ["8", "ball", "game", "eight", "billiard", "pool 8 ball"],
    u: "1f3b1",
    a: "0.6"
  }, {
    n: ["ball", "tool", "crystal", "fantasy", "fortune", "fairy tale", "crystal ball"],
    u: "1f52e",
    a: "0.6"
  }, {
    n: ["magic", "witch", "wizard", "magic wand"],
    u: "1fa84",
    a: "13"
  }, {
    n: ["game", "video game", "controller"],
    u: "1f3ae",
    a: "0.6"
  }, {
    n: ["game", "joystick", "video game"],
    u: "1f579-fe0f",
    a: "0.7"
  }, {
    n: ["game", "slot", "slot machine"],
    u: "1f3b0",
    a: "0.6"
  }, {
    n: ["die", "dice", "game", "game die"],
    u: "1f3b2",
    a: "0.6"
  }, {
    n: ["clue", "piece", "jigsaw", "puzzle", "puzzle piece", "interlocking"],
    u: "1f9e9",
    a: "11"
  }, {
    n: ["toy", "plush", "stuffed", "plaything", "teddy bear"],
    u: "1f9f8",
    a: "11"
  }, {
    n: ["party", "piñata", "celebration"],
    u: "1fa85",
    a: "13"
  }, {
    n: ["dance", "disco", "party", "glitter", "mirror ball"],
    u: "1faa9",
    a: "14"
  }, {
    n: ["doll", "russia", "nesting", "nesting dolls"],
    u: "1fa86",
    a: "13"
  }, {
    n: ["card", "game", "spade suit"],
    u: "2660-fe0f",
    a: "0.6"
  }, {
    n: ["card", "game", "heart suit"],
    u: "2665-fe0f",
    a: "0.6"
  }, {
    n: ["card", "game", "diamond suit"],
    u: "2666-fe0f",
    a: "0.6"
  }, {
    n: ["card", "game", "club suit"],
    u: "2663-fe0f",
    a: "0.6"
  }, {
    n: ["dupe", "chess", "chess pawn", "expendable"],
    u: "265f-fe0f",
    a: "11"
  }, {
    n: ["card", "game", "joker", "wildcard"],
    u: "1f0cf",
    a: "0.6"
  }, {
    n: ["red", "game", "mahjong", "mahjong red dragon"],
    u: "1f004",
    a: "0.6"
  }, {
    n: ["card", "game", "flower", "playing", "japanese", "flower playing cards"],
    u: "1f3b4",
    a: "0.6"
  }, {
    n: ["art", "mask", "theater", "theatre", "performing", "performing arts"],
    u: "1f3ad",
    a: "0.6"
  }, {
    n: ["art", "frame", "museum", "picture", "painting", "framed picture"],
    u: "1f5bc-fe0f",
    a: "0.7"
  }, {
    n: ["art", "museum", "palette", "painting", "artist palette"],
    u: "1f3a8",
    a: "0.6"
  }, {
    n: ["spool", "thread", "needle", "sewing", "string"],
    u: "1f9f5",
    a: "11"
  }, {
    n: ["needle", "sewing", "sutures", "stitches", "tailoring", "embroidery", "sewing needle"],
    u: "1faa1",
    a: "13"
  }, {
    n: ["yarn", "ball", "knit", "crochet"],
    u: "1f9f6",
    a: "11"
  }, {
    n: ["tie", "knot", "rope", "twine", "twist", "tangled"],
    u: "1faa2",
    a: "13"
  }],
  objects: [{
    n: ["eye", "glasses", "eyewear", "clothing", "eyeglasses"],
    u: "1f453",
    a: "0.6"
  }, {
    n: ["eye", "dark", "eyewear", "glasses", "sunglasses"],
    u: "1f576-fe0f",
    a: "0.7"
  }, {
    n: ["goggles", "welding", "swimming", "eye protection"],
    u: "1f97d",
    a: "11"
  }, {
    n: ["doctor", "lab coat", "scientist", "experiment"],
    u: "1f97c",
    a: "11"
  }, {
    n: ["vest", "safety", "emergency", "safety vest"],
    u: "1f9ba",
    a: "12"
  }, {
    n: ["tie", "necktie", "clothing"],
    u: "1f454",
    a: "0.6"
  }, {
    n: ["shirt", "tshirt", "t shirt", "clothing"],
    u: "1f455",
    a: "0.6"
  }, {
    n: ["jeans", "pants", "clothing", "trousers"],
    u: "1f456",
    a: "0.6"
  }, {
    n: ["neck", "scarf"],
    u: "1f9e3",
    a: "5"
  }, {
    n: ["hand", "gloves"],
    u: "1f9e4",
    a: "5"
  }, {
    n: ["coat", "jacket"],
    u: "1f9e5",
    a: "5"
  }, {
    n: ["socks", "stocking"],
    u: "1f9e6",
    a: "5"
  }, {
    n: ["dress", "clothing"],
    u: "1f457",
    a: "0.6"
  }, {
    n: ["kimono", "clothing"],
    u: "1f458",
    a: "0.6"
  }, {
    n: ["sari", "dress", "clothing"],
    u: "1f97b",
    a: "12"
  }, {
    n: ["bathing suit", "one piece swimsuit"],
    u: "1fa71",
    a: "12"
  }, {
    n: ["briefs", "swimsuit", "one piece", "underwear", "bathing suit"],
    u: "1fa72",
    a: "12"
  }, {
    n: ["pants", "shorts", "underwear", "bathing suit"],
    u: "1fa73",
    a: "12"
  }, {
    n: ["swim", "bikini", "clothing"],
    u: "1f459",
    a: "0.6"
  }, {
    n: ["woman", "clothing", "woman’s clothes"],
    u: "1f45a",
    a: "0.6"
  }, {
    n: ["fan", "hot", "shy", "dance", "cooling", "flutter", "folding hand fan"],
    u: "1faad",
    a: "15"
  }, {
    n: ["coin", "purse", "clothing"],
    u: "1f45b",
    a: "0.6"
  }, {
    n: ["bag", "purse", "handbag", "clothing"],
    u: "1f45c",
    a: "0.6"
  }, {
    n: ["bag", "pouch", "clothing", "clutch bag"],
    u: "1f45d",
    a: "0.6"
  }, {
    n: ["bag", "hotel", "shopping", "shopping bags"],
    u: "1f6cd-fe0f",
    a: "0.7"
  }, {
    n: ["bag", "school", "satchel", "backpack", "rucksack"],
    u: "1f392",
    a: "0.6"
  }, {
    n: ["zōri", "thongs", "sandals", "thong sandal", "beach sandals", "thong sandals"],
    u: "1fa74",
    a: "13"
  }, {
    n: ["man", "shoe", "clothing", "man’s shoe"],
    u: "1f45e",
    a: "0.6"
  }, {
    n: ["shoe", "sneaker", "athletic", "clothing", "running shoe"],
    u: "1f45f",
    a: "0.6"
  }, {
    n: ["boot", "hiking", "camping", "hiking boot", "backpacking"],
    u: "1f97e",
    a: "11"
  }, {
    n: ["slip on", "slipper", "flat shoe", "ballet flat"],
    u: "1f97f",
    a: "11"
  }, {
    n: ["heel", "shoe", "woman", "clothing", "high heeled shoe"],
    u: "1f460",
    a: "0.6"
  }, {
    n: ["shoe", "woman", "sandal", "clothing", "woman’s sandal"],
    u: "1f461",
    a: "0.6"
  }, {
    n: ["dance", "ballet", "ballet shoes"],
    u: "1fa70",
    a: "12"
  }, {
    n: ["boot", "shoe", "woman", "clothing", "woman’s boot"],
    u: "1f462",
    a: "0.6"
  }, {
    n: ["afro", "comb", "hair", "pick", "hair pick"],
    u: "1faae",
    a: "15"
  }, {
    n: ["king", "crown", "queen", "clothing"],
    u: "1f451",
    a: "0.6"
  }, {
    n: ["hat", "woman", "clothing", "woman’s hat"],
    u: "1f452",
    a: "0.6"
  }, {
    n: ["hat", "top", "tophat", "top hat", "clothing"],
    u: "1f3a9",
    a: "0.6"
  }, {
    n: ["cap", "hat", "clothing", "graduation", "celebration", "graduation cap"],
    u: "1f393",
    a: "0.6"
  }, {
    n: ["billed cap", "baseball cap"],
    u: "1f9e2",
    a: "5"
  }, {
    n: ["army", "helmet", "soldier", "warrior", "military", "military helmet"],
    u: "1fa96",
    a: "13"
  }, {
    n: ["aid", "hat", "face", "cross", "helmet", "rescue worker’s helmet"],
    u: "26d1-fe0f",
    a: "0.7"
  }, {
    n: ["beads", "prayer", "clothing", "necklace", "religion", "prayer beads"],
    u: "1f4ff",
    a: "1"
  }, {
    n: ["makeup", "lipstick", "cosmetics"],
    u: "1f484",
    a: "0.6"
  }, {
    n: ["ring", "diamond"],
    u: "1f48d",
    a: "0.6"
  }, {
    n: ["gem", "jewel", "diamond", "gem stone"],
    u: "1f48e",
    a: "0.6"
  }, {
    n: ["mute", "quiet", "silent", "speaker", "muted speaker"],
    u: "1f507",
    a: "1"
  }, {
    n: ["soft", "speaker low volume"],
    u: "1f508",
    a: "0.7"
  }, {
    n: ["medium", "speaker medium volume"],
    u: "1f509",
    a: "1"
  }, {
    n: ["loud", "speaker high volume"],
    u: "1f50a",
    a: "0.6"
  }, {
    n: ["loud", "loudspeaker", "public address"],
    u: "1f4e2",
    a: "0.6"
  }, {
    n: ["cheering", "megaphone"],
    u: "1f4e3",
    a: "0.6"
  }, {
    n: ["horn", "post", "postal", "postal horn"],
    u: "1f4ef",
    a: "1"
  }, {
    n: ["bell"],
    u: "1f514",
    a: "0.6"
  }, {
    n: ["bell", "mute", "quiet", "silent", "forbidden", "bell with slash"],
    u: "1f515",
    a: "1"
  }, {
    n: ["music", "score", "musical score"],
    u: "1f3bc",
    a: "0.6"
  }, {
    n: ["note", "music", "musical note"],
    u: "1f3b5",
    a: "0.6"
  }, {
    n: ["note", "music", "notes", "musical notes"],
    u: "1f3b6",
    a: "0.6"
  }, {
    n: ["mic", "music", "studio", "microphone", "studio microphone"],
    u: "1f399-fe0f",
    a: "0.7"
  }, {
    n: ["level", "music", "slider", "level slider"],
    u: "1f39a-fe0f",
    a: "0.7"
  }, {
    n: ["knobs", "music", "control", "control knobs"],
    u: "1f39b-fe0f",
    a: "0.7"
  }, {
    n: ["mic", "karaoke", "microphone"],
    u: "1f3a4",
    a: "0.6"
  }, {
    n: ["earbud", "headphone"],
    u: "1f3a7",
    a: "0.6"
  }, {
    n: ["radio", "video"],
    u: "1f4fb",
    a: "0.6"
  }, {
    n: ["sax", "music", "saxophone", "instrument"],
    u: "1f3b7",
    a: "0.6"
  }, {
    n: ["accordion", "concertina", "squeeze box"],
    u: "1fa97",
    a: "13"
  }, {
    n: ["music", "guitar", "instrument"],
    u: "1f3b8",
    a: "0.6"
  }, {
    n: ["music", "piano", "keyboard", "instrument", "musical keyboard"],
    u: "1f3b9",
    a: "0.6"
  }, {
    n: ["music", "trumpet", "instrument"],
    u: "1f3ba",
    a: "0.6"
  }, {
    n: ["music", "violin", "instrument"],
    u: "1f3bb",
    a: "0.6"
  }, {
    n: ["banjo", "music", "stringed"],
    u: "1fa95",
    a: "12"
  }, {
    n: ["drum", "music", "drumsticks"],
    u: "1f941",
    a: "3"
  }, {
    n: ["beat", "drum", "conga", "rhythm", "long drum"],
    u: "1fa98",
    a: "13"
  }, {
    n: ["music", "shake", "rattle", "maracas", "instrument", "percussion"],
    u: "1fa87",
    a: "15"
  }, {
    n: ["fife", "pipe", "flute", "music", "recorder", "woodwind"],
    u: "1fa88",
    a: "15"
  }, {
    n: ["cell", "phone", "mobile", "telephone", "mobile phone"],
    u: "1f4f1",
    a: "0.6"
  }, {
    n: ["cell", "arrow", "phone", "mobile", "receive", "mobile phone with arrow"],
    u: "1f4f2",
    a: "0.6"
  }, {
    n: ["phone", "telephone"],
    u: "260e-fe0f",
    a: "0.6"
  }, {
    n: ["phone", "receiver", "telephone", "telephone receiver"],
    u: "1f4de",
    a: "0.6"
  }, {
    n: ["pager"],
    u: "1f4df",
    a: "0.6"
  }, {
    n: ["fax", "fax machine"],
    u: "1f4e0",
    a: "0.6"
  }, {
    n: ["battery"],
    u: "1f50b",
    a: "0.6"
  }, {
    n: ["electronic", "low energy", "low battery"],
    u: "1faab",
    a: "14"
  }, {
    n: ["plug", "electric", "electricity", "electric plug"],
    u: "1f50c",
    a: "0.6"
  }, {
    n: ["pc", "laptop", "computer", "personal"],
    u: "1f4bb",
    a: "0.6"
  }, {
    n: ["desktop", "computer", "desktop computer"],
    u: "1f5a5-fe0f",
    a: "0.7"
  }, {
    n: ["printer", "computer"],
    u: "1f5a8-fe0f",
    a: "0.7"
  }, {
    n: ["keyboard", "computer"],
    u: "2328-fe0f",
    a: "1"
  }, {
    n: ["computer", "computer mouse"],
    u: "1f5b1-fe0f",
    a: "0.7"
  }, {
    n: ["computer", "trackball"],
    u: "1f5b2-fe0f",
    a: "0.7"
  }, {
    n: ["disk", "optical", "computer", "minidisk", "computer disk"],
    u: "1f4bd",
    a: "0.6"
  }, {
    n: ["disk", "floppy", "computer", "floppy disk"],
    u: "1f4be",
    a: "0.6"
  }, {
    n: ["cd", "disk", "optical", "computer", "optical disk"],
    u: "1f4bf",
    a: "0.6"
  }, {
    n: ["dvd", "disk", "blu ray", "optical", "computer"],
    u: "1f4c0",
    a: "0.6"
  }, {
    n: ["abacus", "calculation"],
    u: "1f9ee",
    a: "11"
  }, {
    n: ["movie", "camera", "cinema", "movie camera"],
    u: "1f3a5",
    a: "0.6"
  }, {
    n: ["film", "movie", "cinema", "frames", "film frames"],
    u: "1f39e-fe0f",
    a: "0.7"
  }, {
    n: ["film", "movie", "video", "cinema", "projector", "film projector"],
    u: "1f4fd-fe0f",
    a: "0.7"
  }, {
    n: ["movie", "clapper", "clapper board"],
    u: "1f3ac",
    a: "0.6"
  }, {
    n: ["tv", "video", "television"],
    u: "1f4fa",
    a: "0.6"
  }, {
    n: ["video", "camera"],
    u: "1f4f7",
    a: "0.6"
  }, {
    n: ["flash", "video", "camera", "camera with flash"],
    u: "1f4f8",
    a: "1"
  }, {
    n: ["video", "camera", "video camera"],
    u: "1f4f9",
    a: "0.6"
  }, {
    n: ["vhs", "tape", "video", "videocassette"],
    u: "1f4fc",
    a: "0.6"
  }, {
    n: ["tool", "glass", "search", "magnifying", "magnifying glass tilted left"],
    u: "1f50d",
    a: "0.6"
  }, {
    n: ["tool", "glass", "search", "magnifying", "magnifying glass tilted right"],
    u: "1f50e",
    a: "0.6"
  }, {
    n: ["light", "candle"],
    u: "1f56f-fe0f",
    a: "0.7"
  }, {
    n: ["bulb", "idea", "comic", "light", "electric", "light bulb"],
    u: "1f4a1",
    a: "0.6"
  }, {
    n: ["tool", "light", "torch", "electric", "flashlight"],
    u: "1f526",
    a: "0.6"
  }, {
    n: ["bar", "red", "light", "lantern", "red paper lantern"],
    u: "1f3ee",
    a: "0.6"
  }, {
    n: ["oil", "diya", "lamp", "diya lamp"],
    u: "1fa94",
    a: "12"
  }, {
    n: ["book", "cover", "notebook", "decorated", "notebook with decorative cover"],
    u: "1f4d4",
    a: "0.6"
  }, {
    n: ["book", "closed", "closed book"],
    u: "1f4d5",
    a: "0.6"
  }, {
    n: ["book", "open", "open book"],
    u: "1f4d6",
    a: "0.6"
  }, {
    n: ["book", "green", "green book"],
    u: "1f4d7",
    a: "0.6"
  }, {
    n: ["blue", "book", "blue book"],
    u: "1f4d8",
    a: "0.6"
  }, {
    n: ["book", "orange", "orange book"],
    u: "1f4d9",
    a: "0.6"
  }, {
    n: ["book", "books"],
    u: "1f4da",
    a: "0.6"
  }, {
    n: ["notebook"],
    u: "1f4d3",
    a: "0.6"
  }, {
    n: ["ledger", "notebook"],
    u: "1f4d2",
    a: "0.6"
  }, {
    n: ["curl", "page", "document", "page with curl"],
    u: "1f4c3",
    a: "0.6"
  }, {
    n: ["paper", "scroll"],
    u: "1f4dc",
    a: "0.6"
  }, {
    n: ["page", "document", "page facing up"],
    u: "1f4c4",
    a: "0.6"
  }, {
    n: ["news", "paper", "newspaper"],
    u: "1f4f0",
    a: "0.6"
  }, {
    n: ["news", "paper", "rolled", "newspaper", "rolled up newspaper"],
    u: "1f5de-fe0f",
    a: "0.7"
  }, {
    n: ["mark", "tabs", "marker", "bookmark", "bookmark tabs"],
    u: "1f4d1",
    a: "0.6"
  }, {
    n: ["mark", "bookmark"],
    u: "1f516",
    a: "0.6"
  }, {
    n: ["label"],
    u: "1f3f7-fe0f",
    a: "0.7"
  }, {
    n: ["bag", "money", "dollar", "moneybag", "money bag"],
    u: "1f4b0",
    a: "0.6"
  }, {
    n: ["coin", "gold", "metal", "money", "silver", "treasure"],
    u: "1fa99",
    a: "13"
  }, {
    n: ["yen", "bill", "note", "money", "banknote", "currency", "yen banknote"],
    u: "1f4b4",
    a: "0.6"
  }, {
    n: ["bill", "note", "money", "dollar", "banknote", "currency", "dollar banknote"],
    u: "1f4b5",
    a: "0.6"
  }, {
    n: ["bill", "euro", "note", "money", "banknote", "currency", "euro banknote"],
    u: "1f4b6",
    a: "1"
  }, {
    n: ["bill", "note", "money", "pound", "banknote", "currency", "pound banknote"],
    u: "1f4b7",
    a: "1"
  }, {
    n: ["fly", "bill", "money", "wings", "banknote", "money with wings"],
    u: "1f4b8",
    a: "0.6"
  }, {
    n: ["card", "money", "credit", "credit card"],
    u: "1f4b3",
    a: "0.6"
  }, {
    n: ["proof", "receipt", "evidence", "accounting", "bookkeeping"],
    u: "1f9fe",
    a: "11"
  }, {
    n: ["yen", "chart", "graph", "money", "growth", "chart increasing with yen"],
    u: "1f4b9",
    a: "0.6"
  }, {
    n: ["email", "letter", "envelope"],
    u: "2709-fe0f",
    a: "0.6"
  }, {
    n: ["mail", "email", "e mail", "letter"],
    u: "1f4e7",
    a: "0.6"
  }, {
    n: ["email", "e mail", "letter", "receive", "envelope", "incoming", "incoming envelope"],
    u: "1f4e8",
    a: "0.6"
  }, {
    n: ["arrow", "email", "e mail", "envelope", "outgoing", "envelope with arrow"],
    u: "1f4e9",
    a: "0.6"
  }, {
    n: ["box", "mail", "sent", "tray", "letter", "outbox", "outbox tray"],
    u: "1f4e4",
    a: "0.6"
  }, {
    n: ["box", "mail", "tray", "inbox", "letter", "receive", "inbox tray"],
    u: "1f4e5",
    a: "0.6"
  }, {
    n: ["box", "parcel", "package"],
    u: "1f4e6",
    a: "0.6"
  }, {
    n: ["mail", "closed", "mailbox", "postbox", "closed mailbox with raised flag"],
    u: "1f4eb",
    a: "0.6"
  }, {
    n: ["mail", "closed", "lowered", "mailbox", "postbox", "closed mailbox with lowered flag"],
    u: "1f4ea",
    a: "0.6"
  }, {
    n: ["mail", "open", "mailbox", "postbox", "open mailbox with raised flag"],
    u: "1f4ec",
    a: "0.7"
  }, {
    n: ["mail", "open", "lowered", "mailbox", "postbox", "open mailbox with lowered flag"],
    u: "1f4ed",
    a: "0.7"
  }, {
    n: ["mail", "postbox", "mailbox"],
    u: "1f4ee",
    a: "0.6"
  }, {
    n: ["box", "ballot", "ballot box with ballot"],
    u: "1f5f3-fe0f",
    a: "0.7"
  }, {
    n: ["pencil"],
    u: "270f-fe0f",
    a: "0.6"
  }, {
    n: ["nib", "pen", "black nib"],
    u: "2712-fe0f",
    a: "0.6"
  }, {
    n: ["pen", "fountain", "fountain pen"],
    u: "1f58b-fe0f",
    a: "0.7"
  }, {
    n: ["pen", "ballpoint"],
    u: "1f58a-fe0f",
    a: "0.7"
  }, {
    n: ["painting", "paintbrush"],
    u: "1f58c-fe0f",
    a: "0.7"
  }, {
    n: ["crayon"],
    u: "1f58d-fe0f",
    a: "0.7"
  }, {
    n: ["memo", "pencil"],
    u: "1f4dd",
    a: "0.6"
  }, {
    n: ["briefcase"],
    u: "1f4bc",
    a: "0.6"
  }, {
    n: ["file", "folder", "file folder"],
    u: "1f4c1",
    a: "0.6"
  }, {
    n: ["file", "open", "folder", "open file folder"],
    u: "1f4c2",
    a: "0.6"
  }, {
    n: ["card", "index", "dividers", "card index dividers"],
    u: "1f5c2-fe0f",
    a: "0.7"
  }, {
    n: ["date", "calendar"],
    u: "1f4c5",
    a: "0.6"
  }, {
    n: ["calendar", "tear off calendar"],
    u: "1f4c6",
    a: "0.6"
  }, {
    n: ["pad", "note", "spiral", "spiral notepad"],
    u: "1f5d2-fe0f",
    a: "0.7"
  }, {
    n: ["pad", "spiral", "calendar", "spiral calendar"],
    u: "1f5d3-fe0f",
    a: "0.7"
  }, {
    n: ["card", "index", "rolodex", "card index"],
    u: "1f4c7",
    a: "0.6"
  }, {
    n: ["chart", "graph", "trend", "growth", "upward", "chart increasing"],
    u: "1f4c8",
    a: "0.6"
  }, {
    n: ["down", "chart", "graph", "trend", "chart decreasing"],
    u: "1f4c9",
    a: "0.6"
  }, {
    n: ["bar", "chart", "graph", "bar chart"],
    u: "1f4ca",
    a: "0.6"
  }, {
    n: ["clipboard"],
    u: "1f4cb",
    a: "0.6"
  }, {
    n: ["pin", "pushpin"],
    u: "1f4cc",
    a: "0.6"
  }, {
    n: ["pin", "pushpin", "round pushpin"],
    u: "1f4cd",
    a: "0.6"
  }, {
    n: ["paperclip"],
    u: "1f4ce",
    a: "0.6"
  }, {
    n: ["link", "paperclip", "linked paperclips"],
    u: "1f587-fe0f",
    a: "0.7"
  }, {
    n: ["ruler", "straight edge", "straight ruler"],
    u: "1f4cf",
    a: "0.6"
  }, {
    n: ["set", "ruler", "triangle", "triangular ruler"],
    u: "1f4d0",
    a: "0.6"
  }, {
    n: ["tool", "cutting", "scissors"],
    u: "2702-fe0f",
    a: "0.6"
  }, {
    n: ["box", "card", "file", "card file box"],
    u: "1f5c3-fe0f",
    a: "0.7"
  }, {
    n: ["file", "filing", "cabinet", "file cabinet"],
    u: "1f5c4-fe0f",
    a: "0.7"
  }, {
    n: ["wastebasket"],
    u: "1f5d1-fe0f",
    a: "0.7"
  }, {
    n: ["locked", "closed"],
    u: "1f512",
    a: "0.6"
  }, {
    n: ["lock", "open", "unlock", "unlocked"],
    u: "1f513",
    a: "0.6"
  }, {
    n: ["ink", "nib", "pen", "lock", "privacy", "locked with pen"],
    u: "1f50f",
    a: "0.6"
  }, {
    n: ["key", "lock", "closed", "secure", "locked with key"],
    u: "1f510",
    a: "0.6"
  }, {
    n: ["key", "lock", "password"],
    u: "1f511",
    a: "0.6"
  }, {
    n: ["key", "old", "clue", "lock", "old key"],
    u: "1f5dd-fe0f",
    a: "0.7"
  }, {
    n: ["tool", "hammer"],
    u: "1f528",
    a: "0.6"
  }, {
    n: ["axe", "chop", "wood", "split", "hatchet"],
    u: "1fa93",
    a: "12"
  }, {
    n: ["pick", "tool", "mining"],
    u: "26cf-fe0f",
    a: "0.7"
  }, {
    n: ["pick", "tool", "hammer", "hammer and pick"],
    u: "2692-fe0f",
    a: "1"
  }, {
    n: ["tool", "hammer", "wrench", "spanner", "hammer and wrench"],
    u: "1f6e0-fe0f",
    a: "0.7"
  }, {
    n: ["knife", "dagger", "weapon"],
    u: "1f5e1-fe0f",
    a: "0.7"
  }, {
    n: ["swords", "weapon", "crossed", "crossed swords"],
    u: "2694-fe0f",
    a: "1"
  }, {
    n: ["bomb", "comic"],
    u: "1f4a3",
    a: "0.6"
  }, {
    n: ["rebound", "boomerang", "repercussion"],
    u: "1fa83",
    a: "13"
  }, {
    n: ["bow", "arrow", "archer", "zodiac", "sagittarius", "bow and arrow"],
    u: "1f3f9",
    a: "1"
  }, {
    n: ["shield", "weapon"],
    u: "1f6e1-fe0f",
    a: "0.7"
  }, {
    n: ["saw", "tool", "lumber", "carpenter", "carpentry saw"],
    u: "1fa9a",
    a: "13"
  }, {
    n: ["tool", "wrench", "spanner"],
    u: "1f527",
    a: "0.6"
  }, {
    n: ["tool", "screw", "screwdriver"],
    u: "1fa9b",
    a: "13"
  }, {
    n: ["nut", "bolt", "tool", "nut and bolt"],
    u: "1f529",
    a: "0.6"
  }, {
    n: ["cog", "gear", "tool", "cogwheel"],
    u: "2699-fe0f",
    a: "1"
  }, {
    n: ["tool", "vice", "clamp", "compress"],
    u: "1f5dc-fe0f",
    a: "0.7"
  }, {
    n: ["libra", "scale", "zodiac", "balance", "justice", "balance scale"],
    u: "2696-fe0f",
    a: "1"
  }, {
    n: ["blind", "white cane", "accessibility"],
    u: "1f9af",
    a: "12"
  }, {
    n: ["link"],
    u: "1f517",
    a: "0.6"
  }, {
    n: ["break", "chain", "cuffs", "freedom", "breaking", "broken chain"],
    u: "26d3-fe0f-200d-1f4a5",
    a: "15.1"
  }, {
    n: ["chain", "chains"],
    u: "26d3-fe0f",
    a: "0.7"
  }, {
    n: ["hook", "catch", "crook", "curve", "ensnare", "selling point"],
    u: "1fa9d",
    a: "13"
  }, {
    n: ["tool", "chest", "toolbox", "mechanic"],
    u: "1f9f0",
    a: "11"
  }, {
    n: ["magnet", "magnetic", "horseshoe", "attraction"],
    u: "1f9f2",
    a: "11"
  }, {
    n: ["rung", "step", "climb", "ladder"],
    u: "1fa9c",
    a: "13"
  }, {
    n: ["tool", "alembic", "chemistry"],
    u: "2697-fe0f",
    a: "1"
  }, {
    n: ["lab", "chemist", "science", "test tube", "chemistry", "experiment"],
    u: "1f9ea",
    a: "11"
  }, {
    n: ["lab", "biology", "culture", "bacteria", "biologist", "petri dish"],
    u: "1f9eb",
    a: "11"
  }, {
    n: ["dna", "gene", "life", "genetics", "biologist", "evolution"],
    u: "1f9ec",
    a: "11"
  }, {
    n: ["tool", "science", "microscope"],
    u: "1f52c",
    a: "1"
  }, {
    n: ["tool", "science", "telescope"],
    u: "1f52d",
    a: "1"
  }, {
    n: ["dish", "antenna", "satellite", "satellite antenna"],
    u: "1f4e1",
    a: "0.6"
  }, {
    n: ["shot", "sick", "needle", "syringe", "medicine"],
    u: "1f489",
    a: "0.6"
  }, {
    n: ["bleed", "injury", "medicine", "menstruation", "drop of blood", "blood donation"],
    u: "1fa78",
    a: "12"
  }, {
    n: ["pill", "sick", "doctor", "medicine"],
    u: "1f48a",
    a: "0.6"
  }, {
    n: ["bandage", "adhesive bandage"],
    u: "1fa79",
    a: "12"
  }, {
    n: ["cane", "hurt", "stick", "crutch", "disability", "mobility aid"],
    u: "1fa7c",
    a: "14"
  }, {
    n: ["heart", "doctor", "medicine", "stethoscope"],
    u: "1fa7a",
    a: "12"
  }, {
    n: ["x ray", "bones", "doctor", "medical", "skeleton"],
    u: "1fa7b",
    a: "14"
  }, {
    n: ["door"],
    u: "1f6aa",
    a: "0.6"
  }, {
    n: ["lift", "hoist", "elevator", "accessibility"],
    u: "1f6d7",
    a: "13"
  }, {
    n: ["mirror", "speculum", "reflector", "reflection"],
    u: "1fa9e",
    a: "13"
  }, {
    n: ["view", "frame", "window", "opening", "fresh air", "transparent"],
    u: "1fa9f",
    a: "13"
  }, {
    n: ["bed", "hotel", "sleep"],
    u: "1f6cf-fe0f",
    a: "0.7"
  }, {
    n: ["lamp", "couch", "hotel", "couch and lamp"],
    u: "1f6cb-fe0f",
    a: "0.7"
  }, {
    n: ["sit", "seat", "chair"],
    u: "1fa91",
    a: "12"
  }, {
    n: ["toilet"],
    u: "1f6bd",
    a: "0.6"
  }, {
    n: ["toilet", "plunger", "plumber", "suction", "force cup"],
    u: "1faa0",
    a: "13"
  }, {
    n: ["water", "shower"],
    u: "1f6bf",
    a: "1"
  }, {
    n: ["bath", "bathtub"],
    u: "1f6c1",
    a: "1"
  }, {
    n: ["bait", "trap", "snare", "mousetrap", "mouse trap"],
    u: "1faa4",
    a: "13"
  }, {
    n: ["razor", "sharp", "shave"],
    u: "1fa92",
    a: "12"
  }, {
    n: ["lotion", "shampoo", "sunscreen", "moisturizer", "lotion bottle"],
    u: "1f9f4",
    a: "11"
  }, {
    n: ["diaper", "punk rock", "safety pin"],
    u: "1f9f7",
    a: "11"
  }, {
    n: ["broom", "witch", "cleaning", "sweeping"],
    u: "1f9f9",
    a: "11"
  }, {
    n: ["basket", "picnic", "farming", "laundry"],
    u: "1f9fa",
    a: "11"
  }, {
    n: ["paper towels", "toilet paper", "roll of paper"],
    u: "1f9fb",
    a: "11"
  }, {
    n: ["vat", "cask", "pail", "bucket"],
    u: "1faa3",
    a: "13"
  }, {
    n: ["bar", "soap", "lather", "bathing", "cleaning", "soapdish"],
    u: "1f9fc",
    a: "11"
  }, {
    n: ["burp", "soap", "clean", "bubbles", "underwater"],
    u: "1fae7",
    a: "14"
  }, {
    n: ["brush", "clean", "teeth", "dental", "hygiene", "bathroom", "toothbrush"],
    u: "1faa5",
    a: "13"
  }, {
    n: ["sponge", "porous", "cleaning", "absorbing"],
    u: "1f9fd",
    a: "11"
  }, {
    n: ["fire", "quench", "extinguish", "fire extinguisher"],
    u: "1f9ef",
    a: "11"
  }, {
    n: ["cart", "trolley", "shopping", "shopping cart"],
    u: "1f6d2",
    a: "3"
  }, {
    n: ["smoking", "cigarette"],
    u: "1f6ac",
    a: "0.6"
  }, {
    n: ["death", "coffin"],
    u: "26b0-fe0f",
    a: "1"
  }, {
    n: ["grave", "cemetery", "headstone", "graveyard", "tombstone"],
    u: "1faa6",
    a: "13"
  }, {
    n: ["urn", "ashes", "death", "funeral", "funeral urn"],
    u: "26b1-fe0f",
    a: "1"
  }, {
    n: ["bead", "charm", "nazar", "evil eye", "talisman", "nazar amulet"],
    u: "1f9ff",
    a: "11"
  }, {
    n: ["hand", "mary", "hamsa", "amulet", "fatima", "miriam", "protection"],
    u: "1faac",
    a: "14"
  }, {
    n: ["moai", "face", "moyai", "statue"],
    u: "1f5ff",
    a: "0.6"
  }, {
    n: ["sign", "picket", "placard", "protest", "demonstration"],
    u: "1faa7",
    a: "13"
  }, {
    n: ["id", "license", "security", "credentials", "identification card"],
    u: "1faaa",
    a: "14"
  }],
  symbols: [{
    n: ["atm", "bank", "teller", "ATM sign", "atm sign", "automated"],
    u: "1f3e7",
    a: "0.6"
  }, {
    n: ["litter", "litter bin", "litter in bin sign"],
    u: "1f6ae",
    a: "1"
  }, {
    n: ["water", "potable", "drinking", "potable water"],
    u: "1f6b0",
    a: "1"
  }, {
    n: ["access", "wheelchair symbol"],
    u: "267f",
    a: "0.6"
  }, {
    n: ["wc", "man", "toilet", "bathroom", "lavatory", "restroom", "men’s room"],
    u: "1f6b9",
    a: "0.6"
  }, {
    n: ["wc", "woman", "toilet", "bathroom", "lavatory", "restroom", "women’s room"],
    u: "1f6ba",
    a: "0.6"
  }, {
    n: ["wc", "toilet", "restroom", "bathroom", "lavatory"],
    u: "1f6bb",
    a: "0.6"
  }, {
    n: ["baby", "changing", "baby symbol"],
    u: "1f6bc",
    a: "0.6"
  }, {
    n: ["wc", "water", "closet", "toilet", "bathroom", "lavatory", "restroom", "water closet"],
    u: "1f6be",
    a: "0.6"
  }, {
    n: ["control", "passport", "passport control"],
    u: "1f6c2",
    a: "1"
  }, {
    n: ["customs"],
    u: "1f6c3",
    a: "1"
  }, {
    n: ["claim", "baggage", "baggage claim"],
    u: "1f6c4",
    a: "1"
  }, {
    n: ["locker", "baggage", "luggage", "left luggage"],
    u: "1f6c5",
    a: "1"
  }, {
    n: ["warning"],
    u: "26a0-fe0f",
    a: "0.6"
  }, {
    n: ["child", "traffic", "crossing", "pedestrian", "children crossing"],
    u: "1f6b8",
    a: "1"
  }, {
    n: ["no", "not", "entry", "traffic", "no entry", "forbidden", "prohibited"],
    u: "26d4",
    a: "0.6"
  }, {
    n: ["no", "not", "entry", "forbidden", "prohibited"],
    u: "1f6ab",
    a: "0.6"
  }, {
    n: ["no", "bike", "bicycle", "forbidden", "prohibited", "no bicycles"],
    u: "1f6b3",
    a: "1"
  }, {
    n: ["no", "not", "smoking", "forbidden", "no smoking", "prohibited"],
    u: "1f6ad",
    a: "0.6"
  }, {
    n: ["no", "not", "litter", "forbidden", "prohibited", "no littering"],
    u: "1f6af",
    a: "1"
  }, {
    n: ["water", "non potable", "non drinking", "non potable water"],
    u: "1f6b1",
    a: "1"
  }, {
    n: ["no", "not", "forbidden", "pedestrian", "prohibited", "no pedestrians"],
    u: "1f6b7",
    a: "1"
  }, {
    n: ["no", "cell", "phone", "mobile", "forbidden", "no mobile phones"],
    u: "1f4f5",
    a: "1"
  }, {
    n: ["18", "eighteen", "underage", "prohibited", "age restriction", "no one under eighteen"],
    u: "1f51e",
    a: "0.6"
  }, {
    n: ["sign", "radioactive"],
    u: "2622-fe0f",
    a: "1"
  }, {
    n: ["sign", "biohazard"],
    u: "2623-fe0f",
    a: "1"
  }, {
    n: ["arrow", "north", "up arrow", "cardinal", "direction"],
    u: "2b06-fe0f",
    a: "0.6"
  }, {
    n: ["arrow", "direction", "northeast", "intercardinal", "up right arrow"],
    u: "2197-fe0f",
    a: "0.6"
  }, {
    n: ["east", "arrow", "cardinal", "direction", "right arrow"],
    u: "27a1-fe0f",
    a: "0.6"
  }, {
    n: ["arrow", "direction", "southeast", "intercardinal", "down right arrow"],
    u: "2198-fe0f",
    a: "0.6"
  }, {
    n: ["down", "arrow", "south", "cardinal", "direction", "down arrow"],
    u: "2b07-fe0f",
    a: "0.6"
  }, {
    n: ["arrow", "direction", "southwest", "intercardinal", "down left arrow"],
    u: "2199-fe0f",
    a: "0.6"
  }, {
    n: ["west", "arrow", "cardinal", "direction", "left arrow"],
    u: "2b05-fe0f",
    a: "0.6"
  }, {
    n: ["arrow", "direction", "northwest", "up left arrow", "intercardinal"],
    u: "2196-fe0f",
    a: "0.6"
  }, {
    n: ["arrow", "up down arrow"],
    u: "2195-fe0f",
    a: "0.6"
  }, {
    n: ["arrow", "left right arrow"],
    u: "2194-fe0f",
    a: "0.6"
  }, {
    n: ["arrow", "right arrow curving left"],
    u: "21a9-fe0f",
    a: "0.6"
  }, {
    n: ["arrow", "left arrow curving right"],
    u: "21aa-fe0f",
    a: "0.6"
  }, {
    n: ["arrow", "right arrow curving up"],
    u: "2934-fe0f",
    a: "0.6"
  }, {
    n: ["down", "arrow", "right arrow curving down"],
    u: "2935-fe0f",
    a: "0.6"
  }, {
    n: ["arrow", "reload", "clockwise", "clockwise vertical arrows"],
    u: "1f503",
    a: "0.6"
  }, {
    n: ["arrow", "withershins", "anticlockwise", "counterclockwise", "counterclockwise arrows button"],
    u: "1f504",
    a: "1"
  }, {
    n: ["back", "arrow", "BACK arrow"],
    u: "1f519",
    a: "0.6"
  }, {
    n: ["end", "arrow", "END arrow"],
    u: "1f51a",
    a: "0.6"
  }, {
    n: ["on", "on!", "mark", "arrow", "ON! arrow"],
    u: "1f51b",
    a: "0.6"
  }, {
    n: ["soon", "arrow", "SOON arrow"],
    u: "1f51c",
    a: "0.6"
  }, {
    n: ["up", "top", "arrow", "TOP arrow"],
    u: "1f51d",
    a: "0.6"
  }, {
    n: ["worship", "religion", "place of worship"],
    u: "1f6d0",
    a: "1"
  }, {
    n: ["atom", "atheist", "atom symbol"],
    u: "269b-fe0f",
    a: "1"
  }, {
    n: ["om", "hindu", "religion"],
    u: "1f549-fe0f",
    a: "0.7"
  }, {
    n: ["jew", "star", "david", "jewish", "religion", "star of David", "star of david"],
    u: "2721-fe0f",
    a: "0.7"
  }, {
    n: ["wheel", "dharma", "buddhist", "religion", "wheel of dharma"],
    u: "2638-fe0f",
    a: "0.7"
  }, {
    n: ["tao", "yin", "yang", "taoist", "yin yang", "religion"],
    u: "262f-fe0f",
    a: "0.7"
  }, {
    n: ["cross", "religion", "christian", "latin cross"],
    u: "271d-fe0f",
    a: "0.7"
  }, {
    n: ["cross", "religion", "christian", "orthodox cross"],
    u: "2626-fe0f",
    a: "1"
  }, {
    n: ["islam", "muslim", "religion", "star and crescent"],
    u: "262a-fe0f",
    a: "0.7"
  }, {
    n: ["peace", "peace symbol"],
    u: "262e-fe0f",
    a: "1"
  }, {
    n: ["menorah", "religion", "candelabrum", "candlestick"],
    u: "1f54e",
    a: "1"
  }, {
    n: ["star", "fortune", "dotted six pointed star"],
    u: "1f52f",
    a: "0.6"
  }, {
    n: ["sikh", "khanda", "religion"],
    u: "1faaf",
    a: "15"
  }, {
    n: ["ram", "Aries", "aries", "zodiac"],
    u: "2648",
    a: "0.6"
  }, {
    n: ["ox", "bull", "Taurus", "taurus", "zodiac"],
    u: "2649",
    a: "0.6"
  }, {
    n: ["twins", "Gemini", "gemini", "zodiac"],
    u: "264a",
    a: "0.6"
  }, {
    n: ["crab", "Cancer", "cancer", "zodiac"],
    u: "264b",
    a: "0.6"
  }, {
    n: ["Leo", "leo", "lion", "zodiac"],
    u: "264c",
    a: "0.6"
  }, {
    n: ["Virgo", "virgo", "zodiac"],
    u: "264d",
    a: "0.6"
  }, {
    n: ["Libra", "libra", "scales", "zodiac", "balance", "justice"],
    u: "264e",
    a: "0.6"
  }, {
    n: ["zodiac", "Scorpio", "scorpio", "scorpion", "scorpius"],
    u: "264f",
    a: "0.6"
  }, {
    n: ["archer", "zodiac", "Sagittarius", "sagittarius"],
    u: "2650",
    a: "0.6"
  }, {
    n: ["goat", "zodiac", "Capricorn", "capricorn"],
    u: "2651",
    a: "0.6"
  }, {
    n: ["water", "bearer", "zodiac", "Aquarius", "aquarius"],
    u: "2652",
    a: "0.6"
  }, {
    n: ["fish", "Pisces", "pisces", "zodiac"],
    u: "2653",
    a: "0.6"
  }, {
    n: ["snake", "bearer", "zodiac", "serpent", "Ophiuchus", "ophiuchus"],
    u: "26ce",
    a: "0.6"
  }, {
    n: ["arrow", "crossed", "shuffle tracks button"],
    u: "1f500",
    a: "1"
  }, {
    n: ["arrow", "repeat", "clockwise", "repeat button"],
    u: "1f501",
    a: "1"
  }, {
    n: ["once", "arrow", "clockwise", "repeat single button"],
    u: "1f502",
    a: "1"
  }, {
    n: ["play", "arrow", "right", "triangle", "play button"],
    u: "25b6-fe0f",
    a: "0.6"
  }, {
    n: ["fast", "arrow", "double", "forward", "fast forward button"],
    u: "23e9",
    a: "0.6"
  }, {
    n: ["arrow", "triangle", "next scene", "next track", "next track button"],
    u: "23ed-fe0f",
    a: "0.7"
  }, {
    n: ["play", "arrow", "pause", "right", "triangle", "play or pause button"],
    u: "23ef-fe0f",
    a: "1"
  }, {
    n: ["left", "arrow", "reverse", "triangle", "reverse button"],
    u: "25c0-fe0f",
    a: "0.6"
  }, {
    n: ["arrow", "double", "rewind", "fast reverse button"],
    u: "23ea",
    a: "0.6"
  }, {
    n: ["arrow", "triangle", "previous scene", "previous track", "last track button"],
    u: "23ee-fe0f",
    a: "0.7"
  }, {
    n: ["arrow", "button", "upwards button"],
    u: "1f53c",
    a: "0.6"
  }, {
    n: ["arrow", "double", "fast up button"],
    u: "23eb",
    a: "0.6"
  }, {
    n: ["down", "arrow", "button", "downwards button"],
    u: "1f53d",
    a: "0.6"
  }, {
    n: ["down", "arrow", "double", "fast down button"],
    u: "23ec",
    a: "0.6"
  }, {
    n: ["bar", "pause", "double", "vertical", "pause button"],
    u: "23f8-fe0f",
    a: "0.7"
  }, {
    n: ["stop", "square", "stop button"],
    u: "23f9-fe0f",
    a: "0.7"
  }, {
    n: ["circle", "record", "record button"],
    u: "23fa-fe0f",
    a: "0.7"
  }, {
    n: ["eject", "eject button"],
    u: "23cf-fe0f",
    a: "1"
  }, {
    n: ["film", "movie", "cinema", "camera"],
    u: "1f3a6",
    a: "0.6"
  }, {
    n: ["dim", "low", "dim button", "brightness"],
    u: "1f505",
    a: "1"
  }, {
    n: ["bright", "brightness", "bright button"],
    u: "1f506",
    a: "1"
  }, {
    n: ["bar", "cell", "phone", "mobile", "antenna", "antenna bars"],
    u: "1f4f6",
    a: "0.6"
  }, {
    n: ["wifi", "wi fi", "network", "wireless", "computer", "internet"],
    u: "1f6dc",
    a: "15"
  }, {
    n: ["cell", "mode", "phone", "mobile", "telephone", "vibration", "vibration mode"],
    u: "1f4f3",
    a: "0.6"
  }, {
    n: ["off", "cell", "phone", "mobile", "telephone", "mobile phone off"],
    u: "1f4f4",
    a: "0.6"
  }, {
    n: ["woman", "female sign"],
    u: "2640-fe0f",
    a: "4"
  }, {
    n: ["man", "male sign"],
    u: "2642-fe0f",
    a: "4"
  }, {
    n: ["transgender", "transgender symbol"],
    u: "26a7-fe0f",
    a: "13"
  }, {
    n: ["x", "×", "sign", "cancel", "multiply", "multiplication"],
    u: "2716-fe0f",
    a: "0.6"
  }, {
    n: ["+", "plus", "math", "sign"],
    u: "2795",
    a: "0.6"
  }, {
    n: [" ", "−", "math", "sign", "minus"],
    u: "2796",
    a: "0.6"
  }, {
    n: ["÷", "math", "sign", "divide", "division"],
    u: "2797",
    a: "0.6"
  }, {
    n: ["math", "equality", "heavy equals sign"],
    u: "1f7f0",
    a: "14"
  }, {
    n: ["forever", "infinity", "unbounded", "universal"],
    u: "267e-fe0f",
    a: "11"
  }, {
    n: ["!", "!!", "mark", "bangbang", "exclamation", "double exclamation mark"],
    u: "203c-fe0f",
    a: "0.6"
  }, {
    n: ["!", "?", "!?", "mark", "question", "exclamation", "interrobang", "punctuation", "exclamation question mark"],
    u: "2049-fe0f",
    a: "0.6"
  }, {
    n: ["?", "mark", "question", "punctuation", "red question mark"],
    u: "2753",
    a: "0.6"
  }, {
    n: ["?", "mark", "outlined", "question", "punctuation", "white question mark"],
    u: "2754",
    a: "0.6"
  }, {
    n: ["!", "mark", "outlined", "exclamation", "punctuation", "white exclamation mark"],
    u: "2755",
    a: "0.6"
  }, {
    n: ["!", "mark", "exclamation", "punctuation", "red exclamation mark"],
    u: "2757",
    a: "0.6"
  }, {
    n: ["dash", "wavy", "wavy dash", "punctuation"],
    u: "3030-fe0f",
    a: "0.6"
  }, {
    n: ["bank", "money", "currency", "exchange", "currency exchange"],
    u: "1f4b1",
    a: "0.6"
  }, {
    n: ["money", "dollar", "currency", "heavy dollar sign"],
    u: "1f4b2",
    a: "0.6"
  }, {
    n: ["staff", "medicine", "aesculapius", "medical symbol"],
    u: "2695-fe0f",
    a: "4"
  }, {
    n: ["recycle", "recycling symbol"],
    u: "267b-fe0f",
    a: "0.6"
  }, {
    n: ["fleur de lis"],
    u: "269c-fe0f",
    a: "1"
  }, {
    n: ["ship", "tool", "anchor", "emblem", "trident", "trident emblem"],
    u: "1f531",
    a: "0.6"
  }, {
    n: ["name", "badge", "name badge"],
    u: "1f4db",
    a: "0.6"
  }, {
    n: ["leaf", "chevron", "beginner", "japanese", "Japanese symbol for beginner", "japanese symbol for beginner"],
    u: "1f530",
    a: "0.6"
  }, {
    n: ["o", "red", "large", "circle", "hollow red circle"],
    u: "2b55",
    a: "0.6"
  }, {
    n: ["✓", "mark", "check", "button", "check mark button"],
    u: "2705",
    a: "0.6"
  }, {
    n: ["✓", "box", "check", "check box with check"],
    u: "2611-fe0f",
    a: "0.6"
  }, {
    n: ["✓", "mark", "check", "check mark"],
    u: "2714-fe0f",
    a: "0.6"
  }, {
    n: ["x", "×", "mark", "cross", "cancel", "multiply", "cross mark", "multiplication"],
    u: "274c",
    a: "0.6"
  }, {
    n: ["x", "×", "mark", "square", "cross mark button"],
    u: "274e",
    a: "0.6"
  }, {
    n: ["curl", "loop", "curly loop"],
    u: "27b0",
    a: "0.6"
  }, {
    n: ["curl", "loop", "double", "double curly loop"],
    u: "27bf",
    a: "1"
  }, {
    n: ["mark", "part", "part alternation mark"],
    u: "303d-fe0f",
    a: "0.6"
  }, {
    n: ["*", "asterisk", "eight spoked asterisk"],
    u: "2733-fe0f",
    a: "0.6"
  }, {
    n: ["*", "star", "eight pointed star"],
    u: "2734-fe0f",
    a: "0.6"
  }, {
    n: ["*", "sparkle"],
    u: "2747-fe0f",
    a: "0.6"
  }, {
    n: ["c", "copyright"],
    u: "00a9-fe0f",
    a: "0.6"
  }, {
    n: ["r", "registered"],
    u: "00ae-fe0f",
    a: "0.6"
  }, {
    n: ["tm", "mark", "trademark", "trade mark"],
    u: "2122-fe0f",
    a: "0.6"
  }, {
    n: ["keycap", "keycap: #"],
    u: "0023-fe0f-20e3",
    a: "0.6"
  }, {
    n: ["keycap", "keycap: *"],
    u: "002a-fe0f-20e3",
    a: "2"
  }, {
    n: ["keycap", "keycap: 0"],
    u: "0030-fe0f-20e3",
    a: "0.6"
  }, {
    n: ["keycap", "keycap: 1"],
    u: "0031-fe0f-20e3",
    a: "0.6"
  }, {
    n: ["keycap", "keycap: 2"],
    u: "0032-fe0f-20e3",
    a: "0.6"
  }, {
    n: ["keycap", "keycap: 3"],
    u: "0033-fe0f-20e3",
    a: "0.6"
  }, {
    n: ["keycap", "keycap: 4"],
    u: "0034-fe0f-20e3",
    a: "0.6"
  }, {
    n: ["keycap", "keycap: 5"],
    u: "0035-fe0f-20e3",
    a: "0.6"
  }, {
    n: ["keycap", "keycap: 6"],
    u: "0036-fe0f-20e3",
    a: "0.6"
  }, {
    n: ["keycap", "keycap: 7"],
    u: "0037-fe0f-20e3",
    a: "0.6"
  }, {
    n: ["keycap", "keycap: 8"],
    u: "0038-fe0f-20e3",
    a: "0.6"
  }, {
    n: ["keycap", "keycap: 9"],
    u: "0039-fe0f-20e3",
    a: "0.6"
  }, {
    n: ["keycap", "keycap: 10"],
    u: "1f51f",
    a: "0.6"
  }, {
    n: ["abcd", "input", "latin", "letters", "uppercase", "input latin uppercase"],
    u: "1f520",
    a: "0.6"
  }, {
    n: ["abcd", "input", "latin", "letters", "lowercase", "input latin lowercase"],
    u: "1f521",
    a: "0.6"
  }, {
    n: ["1234", "input", "numbers", "input numbers"],
    u: "1f522",
    a: "0.6"
  }, {
    n: ["〒♪&%", "input", "input symbols"],
    u: "1f523",
    a: "0.6"
  }, {
    n: ["abc", "input", "latin", "letters", "alphabet", "input latin letters"],
    u: "1f524",
    a: "0.6"
  }, {
    n: ["a", "blood type", "A button (blood type)", "a button (blood type)"],
    u: "1f170-fe0f",
    a: "0.6"
  }, {
    n: ["ab", "blood type", "AB button (blood type)", "ab button (blood type)"],
    u: "1f18e",
    a: "0.6"
  }, {
    n: ["b", "blood type", "B button (blood type)", "b button (blood type)"],
    u: "1f171-fe0f",
    a: "0.6"
  }, {
    n: ["cl", "CL button", "cl button"],
    u: "1f191",
    a: "0.6"
  }, {
    n: ["cool", "COOL button", "cool button"],
    u: "1f192",
    a: "0.6"
  }, {
    n: ["free", "FREE button", "free button"],
    u: "1f193",
    a: "0.6"
  }, {
    n: ["i", "information"],
    u: "2139-fe0f",
    a: "0.6"
  }, {
    n: ["id", "identity", "ID button", "id button"],
    u: "1f194",
    a: "0.6"
  }, {
    n: ["m", "circle", "circled M", "circled m"],
    u: "24c2-fe0f",
    a: "0.6"
  }, {
    n: ["new", "NEW button", "new button"],
    u: "1f195",
    a: "0.6"
  }, {
    n: ["ng", "NG button", "ng button"],
    u: "1f196",
    a: "0.6"
  }, {
    n: ["o", "blood type", "O button (blood type)", "o button (blood type)"],
    u: "1f17e-fe0f",
    a: "0.6"
  }, {
    n: ["ok", "OK button", "ok button"],
    u: "1f197",
    a: "0.6"
  }, {
    n: ["p", "parking", "P button", "p button"],
    u: "1f17f-fe0f",
    a: "0.6"
  }, {
    n: ["sos", "help", "SOS button", "sos button"],
    u: "1f198",
    a: "0.6"
  }, {
    n: ["up", "up!", "mark", "UP! button", "up! button"],
    u: "1f199",
    a: "0.6"
  }, {
    n: ["vs", "versus", "VS button", "vs button"],
    u: "1f19a",
    a: "0.6"
  }, {
    n: ["ココ", "“here”", "japanese", "katakana", "Japanese “here” button", "japanese “here” button"],
    u: "1f201",
    a: "0.6"
  }, {
    n: ["サ", "japanese", "katakana", "“service charge”", "Japanese “service charge” button", "japanese “service charge” button"],
    u: "1f202-fe0f",
    a: "0.6"
  }, {
    n: ["月", "japanese", "ideograph", "“monthly amount”", "Japanese “monthly amount” button", "japanese “monthly amount” button"],
    u: "1f237-fe0f",
    a: "0.6"
  }, {
    n: ["有", "japanese", "ideograph", "“not free of charge”", "Japanese “not free of charge” button", "japanese “not free of charge” button"],
    u: "1f236",
    a: "0.6"
  }, {
    n: ["指", "japanese", "ideograph", "“reserved”", "Japanese “reserved” button", "japanese “reserved” button"],
    u: "1f22f",
    a: "0.6"
  }, {
    n: ["得", "japanese", "ideograph", "“bargain”", "Japanese “bargain” button", "japanese “bargain” button"],
    u: "1f250",
    a: "0.6"
  }, {
    n: ["割", "japanese", "ideograph", "“discount”", "Japanese “discount” button", "japanese “discount” button"],
    u: "1f239",
    a: "0.6"
  }, {
    n: ["無", "japanese", "ideograph", "“free of charge”", "Japanese “free of charge” button", "japanese “free of charge” button"],
    u: "1f21a",
    a: "0.6"
  }, {
    n: ["禁", "japanese", "ideograph", "“prohibited”", "Japanese “prohibited” button", "japanese “prohibited” button"],
    u: "1f232",
    a: "0.6"
  }, {
    n: ["可", "japanese", "ideograph", "“acceptable”", "Japanese “acceptable” button", "japanese “acceptable” button"],
    u: "1f251",
    a: "0.6"
  }, {
    n: ["申", "japanese", "ideograph", "“application”", "Japanese “application” button", "japanese “application” button"],
    u: "1f238",
    a: "0.6"
  }, {
    n: ["合", "japanese", "ideograph", "“passing grade”", "Japanese “passing grade” button", "japanese “passing grade” button"],
    u: "1f234",
    a: "0.6"
  }, {
    n: ["空", "japanese", "ideograph", "“vacancy”", "Japanese “vacancy” button", "japanese “vacancy” button"],
    u: "1f233",
    a: "0.6"
  }, {
    n: ["祝", "japanese", "ideograph", "“congratulations”", "Japanese “congratulations” button", "japanese “congratulations” button"],
    u: "3297-fe0f",
    a: "0.6"
  }, {
    n: ["秘", "japanese", "“secret”", "ideograph", "Japanese “secret” button", "japanese “secret” button"],
    u: "3299-fe0f",
    a: "0.6"
  }, {
    n: ["営", "japanese", "ideograph", "“open for business”", "Japanese “open for business” button", "japanese “open for business” button"],
    u: "1f23a",
    a: "0.6"
  }, {
    n: ["満", "japanese", "ideograph", "“no vacancy”", "Japanese “no vacancy” button", "japanese “no vacancy” button"],
    u: "1f235",
    a: "0.6"
  }, {
    n: ["red", "circle", "geometric", "red circle"],
    u: "1f534",
    a: "0.6"
  }, {
    n: ["circle", "orange", "orange circle"],
    u: "1f7e0",
    a: "12"
  }, {
    n: ["circle", "yellow", "yellow circle"],
    u: "1f7e1",
    a: "12"
  }, {
    n: ["green", "circle", "green circle"],
    u: "1f7e2",
    a: "12"
  }, {
    n: ["blue", "circle", "geometric", "blue circle"],
    u: "1f535",
    a: "0.6"
  }, {
    n: ["circle", "purple", "purple circle"],
    u: "1f7e3",
    a: "12"
  }, {
    n: ["brown", "circle", "brown circle"],
    u: "1f7e4",
    a: "12"
  }, {
    n: ["circle", "geometric", "black circle"],
    u: "26ab",
    a: "0.6"
  }, {
    n: ["circle", "geometric", "white circle"],
    u: "26aa",
    a: "0.6"
  }, {
    n: ["red", "square", "red square"],
    u: "1f7e5",
    a: "12"
  }, {
    n: ["orange", "square", "orange square"],
    u: "1f7e7",
    a: "12"
  }, {
    n: ["square", "yellow", "yellow square"],
    u: "1f7e8",
    a: "12"
  }, {
    n: ["green", "square", "green square"],
    u: "1f7e9",
    a: "12"
  }, {
    n: ["blue", "square", "blue square"],
    u: "1f7e6",
    a: "12"
  }, {
    n: ["purple", "square", "purple square"],
    u: "1f7ea",
    a: "12"
  }, {
    n: ["brown", "square", "brown square"],
    u: "1f7eb",
    a: "12"
  }, {
    n: ["square", "geometric", "black large square"],
    u: "2b1b",
    a: "0.6"
  }, {
    n: ["square", "geometric", "white large square"],
    u: "2b1c",
    a: "0.6"
  }, {
    n: ["square", "geometric", "black medium square"],
    u: "25fc-fe0f",
    a: "0.6"
  }, {
    n: ["square", "geometric", "white medium square"],
    u: "25fb-fe0f",
    a: "0.6"
  }, {
    n: ["square", "geometric", "black medium small square"],
    u: "25fe",
    a: "0.6"
  }, {
    n: ["square", "geometric", "white medium small square"],
    u: "25fd",
    a: "0.6"
  }, {
    n: ["square", "geometric", "black small square"],
    u: "25aa-fe0f",
    a: "0.6"
  }, {
    n: ["square", "geometric", "white small square"],
    u: "25ab-fe0f",
    a: "0.6"
  }, {
    n: ["orange", "diamond", "geometric", "large orange diamond"],
    u: "1f536",
    a: "0.6"
  }, {
    n: ["blue", "diamond", "geometric", "large blue diamond"],
    u: "1f537",
    a: "0.6"
  }, {
    n: ["orange", "diamond", "geometric", "small orange diamond"],
    u: "1f538",
    a: "0.6"
  }, {
    n: ["blue", "diamond", "geometric", "small blue diamond"],
    u: "1f539",
    a: "0.6"
  }, {
    n: ["red", "geometric", "red triangle pointed up"],
    u: "1f53a",
    a: "0.6"
  }, {
    n: ["red", "down", "geometric", "red triangle pointed down"],
    u: "1f53b",
    a: "0.6"
  }, {
    n: ["comic", "inside", "diamond", "geometric", "diamond with a dot"],
    u: "1f4a0",
    a: "0.6"
  }, {
    n: ["radio", "button", "geometric", "radio button"],
    u: "1f518",
    a: "0.6"
  }, {
    n: ["button", "square", "outlined", "geometric", "white square button"],
    u: "1f533",
    a: "0.6"
  }, {
    n: ["button", "square", "geometric", "black square button"],
    u: "1f532",
    a: "0.6"
  }],
  flags: [{
    n: ["racing", "checkered", "chequered", "chequered flag"],
    u: "1f3c1",
    a: "0.6"
  }, {
    n: ["post", "triangular flag"],
    u: "1f6a9",
    a: "0.6"
  }, {
    n: ["cross", "crossed", "japanese", "celebration", "crossed flags"],
    u: "1f38c",
    a: "0.6"
  }, {
    n: ["waving", "black flag"],
    u: "1f3f4",
    a: "1"
  }, {
    n: ["waving", "white flag"],
    u: "1f3f3-fe0f",
    a: "0.7"
  }, {
    n: ["pride", "rainbow", "rainbow flag"],
    u: "1f3f3-fe0f-200d-1f308",
    a: "4"
  }, {
    n: ["flag", "pink", "white", "light blue", "transgender", "transgender flag"],
    u: "1f3f3-fe0f-200d-26a7-fe0f",
    a: "13"
  }, {
    n: ["pirate", "plunder", "treasure", "pirate flag", "jolly roger"],
    u: "1f3f4-200d-2620-fe0f",
    a: "11"
  }, {
    n: ["AC", "flag", "flag: Ascension Island", "flag: ascension island"],
    u: "1f1e6-1f1e8",
    a: "2"
  }, {
    n: ["AD", "flag", "flag: Andorra", "flag: andorra"],
    u: "1f1e6-1f1e9",
    a: "2"
  }, {
    n: ["AE", "flag", "flag: United Arab Emirates", "flag: united arab emirates"],
    u: "1f1e6-1f1ea",
    a: "2"
  }, {
    n: ["AF", "flag", "flag: Afghanistan", "flag: afghanistan"],
    u: "1f1e6-1f1eb",
    a: "2"
  }, {
    n: ["AG", "flag", "flag: Antigua & Barbuda", "flag: antigua & barbuda"],
    u: "1f1e6-1f1ec",
    a: "2"
  }, {
    n: ["AI", "flag", "flag: Anguilla", "flag: anguilla"],
    u: "1f1e6-1f1ee",
    a: "2"
  }, {
    n: ["AL", "flag", "flag: Albania", "flag: albania"],
    u: "1f1e6-1f1f1",
    a: "2"
  }, {
    n: ["AM", "flag", "flag: Armenia", "flag: armenia"],
    u: "1f1e6-1f1f2",
    a: "2"
  }, {
    n: ["AO", "flag", "flag: Angola", "flag: angola"],
    u: "1f1e6-1f1f4",
    a: "2"
  }, {
    n: ["AQ", "flag", "flag: Antarctica", "flag: antarctica"],
    u: "1f1e6-1f1f6",
    a: "2"
  }, {
    n: ["AR", "flag", "flag: Argentina", "flag: argentina"],
    u: "1f1e6-1f1f7",
    a: "2"
  }, {
    n: ["AS", "flag", "flag: American Samoa", "flag: american samoa"],
    u: "1f1e6-1f1f8",
    a: "2"
  }, {
    n: ["AT", "flag", "flag: Austria", "flag: austria"],
    u: "1f1e6-1f1f9",
    a: "2"
  }, {
    n: ["AU", "flag", "flag: Australia", "flag: australia"],
    u: "1f1e6-1f1fa",
    a: "2"
  }, {
    n: ["AW", "flag", "flag: Aruba", "flag: aruba"],
    u: "1f1e6-1f1fc",
    a: "2"
  }, {
    n: ["AX", "flag", "flag: Åland Islands", "flag: åland islands"],
    u: "1f1e6-1f1fd",
    a: "2"
  }, {
    n: ["AZ", "flag", "flag: Azerbaijan", "flag: azerbaijan"],
    u: "1f1e6-1f1ff",
    a: "2"
  }, {
    n: ["BA", "flag", "flag: Bosnia & Herzegovina", "flag: bosnia & herzegovina"],
    u: "1f1e7-1f1e6",
    a: "2"
  }, {
    n: ["BB", "flag", "flag: Barbados", "flag: barbados"],
    u: "1f1e7-1f1e7",
    a: "2"
  }, {
    n: ["BD", "flag", "flag: Bangladesh", "flag: bangladesh"],
    u: "1f1e7-1f1e9",
    a: "2"
  }, {
    n: ["BE", "flag", "flag: Belgium", "flag: belgium"],
    u: "1f1e7-1f1ea",
    a: "2"
  }, {
    n: ["BF", "flag", "flag: Burkina Faso", "flag: burkina faso"],
    u: "1f1e7-1f1eb",
    a: "2"
  }, {
    n: ["BG", "flag", "flag: Bulgaria", "flag: bulgaria"],
    u: "1f1e7-1f1ec",
    a: "2"
  }, {
    n: ["BH", "flag", "flag: Bahrain", "flag: bahrain"],
    u: "1f1e7-1f1ed",
    a: "2"
  }, {
    n: ["BI", "flag", "flag: Burundi", "flag: burundi"],
    u: "1f1e7-1f1ee",
    a: "2"
  }, {
    n: ["BJ", "flag", "flag: Benin", "flag: benin"],
    u: "1f1e7-1f1ef",
    a: "2"
  }, {
    n: ["BL", "flag", "flag: St. Barthélemy", "flag: st. barthélemy"],
    u: "1f1e7-1f1f1",
    a: "2"
  }, {
    n: ["BM", "flag", "flag: Bermuda", "flag: bermuda"],
    u: "1f1e7-1f1f2",
    a: "2"
  }, {
    n: ["BN", "flag", "flag: Brunei", "flag: brunei"],
    u: "1f1e7-1f1f3",
    a: "2"
  }, {
    n: ["BO", "flag", "flag: Bolivia", "flag: bolivia"],
    u: "1f1e7-1f1f4",
    a: "2"
  }, {
    n: ["BQ", "flag", "flag: Caribbean Netherlands", "flag: caribbean netherlands"],
    u: "1f1e7-1f1f6",
    a: "2"
  }, {
    n: ["BR", "flag", "flag: Brazil", "flag: brazil"],
    u: "1f1e7-1f1f7",
    a: "2"
  }, {
    n: ["BS", "flag", "flag: Bahamas", "flag: bahamas"],
    u: "1f1e7-1f1f8",
    a: "2"
  }, {
    n: ["BT", "flag", "flag: Bhutan", "flag: bhutan"],
    u: "1f1e7-1f1f9",
    a: "2"
  }, {
    n: ["BV", "flag", "flag: Bouvet Island", "flag: bouvet island"],
    u: "1f1e7-1f1fb",
    a: "2"
  }, {
    n: ["BW", "flag", "flag: Botswana", "flag: botswana"],
    u: "1f1e7-1f1fc",
    a: "2"
  }, {
    n: ["BY", "flag", "flag: Belarus", "flag: belarus"],
    u: "1f1e7-1f1fe",
    a: "2"
  }, {
    n: ["BZ", "flag", "flag: Belize", "flag: belize"],
    u: "1f1e7-1f1ff",
    a: "2"
  }, {
    n: ["CA", "flag", "flag: Canada", "flag: canada"],
    u: "1f1e8-1f1e6",
    a: "2"
  }, {
    n: ["CC", "flag", "flag: Cocos (Keeling) Islands", "flag: cocos (keeling) islands"],
    u: "1f1e8-1f1e8",
    a: "2"
  }, {
    n: ["CD", "flag", "flag: Congo   Kinshasa", "flag: congo   kinshasa"],
    u: "1f1e8-1f1e9",
    a: "2"
  }, {
    n: ["CF", "flag", "flag: Central African Republic", "flag: central african republic"],
    u: "1f1e8-1f1eb",
    a: "2"
  }, {
    n: ["CG", "flag", "flag: Congo   Brazzaville", "flag: congo   brazzaville"],
    u: "1f1e8-1f1ec",
    a: "2"
  }, {
    n: ["CH", "flag", "flag: Switzerland", "flag: switzerland"],
    u: "1f1e8-1f1ed",
    a: "2"
  }, {
    n: ["CI", "flag", "flag: Côte d’Ivoire", "flag: côte d’ivoire"],
    u: "1f1e8-1f1ee",
    a: "2"
  }, {
    n: ["CK", "flag", "flag: Cook Islands", "flag: cook islands"],
    u: "1f1e8-1f1f0",
    a: "2"
  }, {
    n: ["CL", "flag", "flag: Chile", "flag: chile"],
    u: "1f1e8-1f1f1",
    a: "2"
  }, {
    n: ["CM", "flag", "flag: Cameroon", "flag: cameroon"],
    u: "1f1e8-1f1f2",
    a: "2"
  }, {
    n: ["CN", "flag", "flag: China", "flag: china"],
    u: "1f1e8-1f1f3",
    a: "0.6"
  }, {
    n: ["CO", "flag", "flag: Colombia", "flag: colombia"],
    u: "1f1e8-1f1f4",
    a: "2"
  }, {
    n: ["CP", "flag", "flag: Clipperton Island", "flag: clipperton island"],
    u: "1f1e8-1f1f5",
    a: "2"
  }, {
    n: ["CR", "flag", "flag: Costa Rica", "flag: costa rica"],
    u: "1f1e8-1f1f7",
    a: "2"
  }, {
    n: ["CU", "flag", "flag: Cuba", "flag: cuba"],
    u: "1f1e8-1f1fa",
    a: "2"
  }, {
    n: ["CV", "flag", "flag: Cape Verde", "flag: cape verde"],
    u: "1f1e8-1f1fb",
    a: "2"
  }, {
    n: ["CW", "flag", "flag: Curaçao", "flag: curaçao"],
    u: "1f1e8-1f1fc",
    a: "2"
  }, {
    n: ["CX", "flag", "flag: Christmas Island", "flag: christmas island"],
    u: "1f1e8-1f1fd",
    a: "2"
  }, {
    n: ["CY", "flag", "flag: Cyprus", "flag: cyprus"],
    u: "1f1e8-1f1fe",
    a: "2"
  }, {
    n: ["CZ", "flag", "flag: Czechia", "flag: czechia"],
    u: "1f1e8-1f1ff",
    a: "2"
  }, {
    n: ["DE", "flag", "flag: Germany", "flag: germany"],
    u: "1f1e9-1f1ea",
    a: "0.6"
  }, {
    n: ["DG", "flag", "flag: Diego Garcia", "flag: diego garcia"],
    u: "1f1e9-1f1ec",
    a: "2"
  }, {
    n: ["DJ", "flag", "flag: Djibouti", "flag: djibouti"],
    u: "1f1e9-1f1ef",
    a: "2"
  }, {
    n: ["DK", "flag", "flag: Denmark", "flag: denmark"],
    u: "1f1e9-1f1f0",
    a: "2"
  }, {
    n: ["DM", "flag", "flag: Dominica", "flag: dominica"],
    u: "1f1e9-1f1f2",
    a: "2"
  }, {
    n: ["DO", "flag", "flag: Dominican Republic", "flag: dominican republic"],
    u: "1f1e9-1f1f4",
    a: "2"
  }, {
    n: ["DZ", "flag", "flag: Algeria", "flag: algeria"],
    u: "1f1e9-1f1ff",
    a: "2"
  }, {
    n: ["EA", "flag", "flag: Ceuta & Melilla", "flag: ceuta & melilla"],
    u: "1f1ea-1f1e6",
    a: "2"
  }, {
    n: ["EC", "flag", "flag: Ecuador", "flag: ecuador"],
    u: "1f1ea-1f1e8",
    a: "2"
  }, {
    n: ["EE", "flag", "flag: Estonia", "flag: estonia"],
    u: "1f1ea-1f1ea",
    a: "2"
  }, {
    n: ["EG", "flag", "flag: Egypt", "flag: egypt"],
    u: "1f1ea-1f1ec",
    a: "2"
  }, {
    n: ["EH", "flag", "flag: Western Sahara", "flag: western sahara"],
    u: "1f1ea-1f1ed",
    a: "2"
  }, {
    n: ["ER", "flag", "flag: Eritrea", "flag: eritrea"],
    u: "1f1ea-1f1f7",
    a: "2"
  }, {
    n: ["ES", "flag", "flag: Spain", "flag: spain"],
    u: "1f1ea-1f1f8",
    a: "0.6"
  }, {
    n: ["ET", "flag", "flag: Ethiopia", "flag: ethiopia"],
    u: "1f1ea-1f1f9",
    a: "2"
  }, {
    n: ["EU", "flag", "flag: European Union", "flag: european union"],
    u: "1f1ea-1f1fa",
    a: "2"
  }, {
    n: ["FI", "flag", "flag: Finland", "flag: finland"],
    u: "1f1eb-1f1ee",
    a: "2"
  }, {
    n: ["FJ", "flag", "flag: Fiji", "flag: fiji"],
    u: "1f1eb-1f1ef",
    a: "2"
  }, {
    n: ["FK", "flag", "flag: Falkland Islands", "flag: falkland islands"],
    u: "1f1eb-1f1f0",
    a: "2"
  }, {
    n: ["FM", "flag", "flag: Micronesia", "flag: micronesia"],
    u: "1f1eb-1f1f2",
    a: "2"
  }, {
    n: ["FO", "flag", "flag: Faroe Islands", "flag: faroe islands"],
    u: "1f1eb-1f1f4",
    a: "2"
  }, {
    n: ["FR", "flag", "flag: France", "flag: france"],
    u: "1f1eb-1f1f7",
    a: "0.6"
  }, {
    n: ["GA", "flag", "flag: Gabon", "flag: gabon"],
    u: "1f1ec-1f1e6",
    a: "2"
  }, {
    n: ["GB", "flag", "flag: United Kingdom", "flag: united kingdom"],
    u: "1f1ec-1f1e7",
    a: "0.6"
  }, {
    n: ["GD", "flag", "flag: Grenada", "flag: grenada"],
    u: "1f1ec-1f1e9",
    a: "2"
  }, {
    n: ["GE", "flag", "flag: Georgia", "flag: georgia"],
    u: "1f1ec-1f1ea",
    a: "2"
  }, {
    n: ["GF", "flag", "flag: French Guiana", "flag: french guiana"],
    u: "1f1ec-1f1eb",
    a: "2"
  }, {
    n: ["GG", "flag", "flag: Guernsey", "flag: guernsey"],
    u: "1f1ec-1f1ec",
    a: "2"
  }, {
    n: ["GH", "flag", "flag: Ghana", "flag: ghana"],
    u: "1f1ec-1f1ed",
    a: "2"
  }, {
    n: ["GI", "flag", "flag: Gibraltar", "flag: gibraltar"],
    u: "1f1ec-1f1ee",
    a: "2"
  }, {
    n: ["GL", "flag", "flag: Greenland", "flag: greenland"],
    u: "1f1ec-1f1f1",
    a: "2"
  }, {
    n: ["GM", "flag", "flag: Gambia", "flag: gambia"],
    u: "1f1ec-1f1f2",
    a: "2"
  }, {
    n: ["GN", "flag", "flag: Guinea", "flag: guinea"],
    u: "1f1ec-1f1f3",
    a: "2"
  }, {
    n: ["GP", "flag", "flag: Guadeloupe", "flag: guadeloupe"],
    u: "1f1ec-1f1f5",
    a: "2"
  }, {
    n: ["GQ", "flag", "flag: Equatorial Guinea", "flag: equatorial guinea"],
    u: "1f1ec-1f1f6",
    a: "2"
  }, {
    n: ["GR", "flag", "flag: Greece", "flag: greece"],
    u: "1f1ec-1f1f7",
    a: "2"
  }, {
    n: ["GS", "flag", "flag: South Georgia & South Sandwich Islands", "flag: south georgia & south sandwich islands"],
    u: "1f1ec-1f1f8",
    a: "2"
  }, {
    n: ["GT", "flag", "flag: Guatemala", "flag: guatemala"],
    u: "1f1ec-1f1f9",
    a: "2"
  }, {
    n: ["GU", "flag", "flag: Guam", "flag: guam"],
    u: "1f1ec-1f1fa",
    a: "2"
  }, {
    n: ["GW", "flag", "flag: Guinea Bissau", "flag: guinea bissau"],
    u: "1f1ec-1f1fc",
    a: "2"
  }, {
    n: ["GY", "flag", "flag: Guyana", "flag: guyana"],
    u: "1f1ec-1f1fe",
    a: "2"
  }, {
    n: ["HK", "flag", "flag: Hong Kong SAR China", "flag: hong kong sar china"],
    u: "1f1ed-1f1f0",
    a: "2"
  }, {
    n: ["HM", "flag", "flag: Heard & McDonald Islands", "flag: heard & mcdonald islands"],
    u: "1f1ed-1f1f2",
    a: "2"
  }, {
    n: ["HN", "flag", "flag: Honduras", "flag: honduras"],
    u: "1f1ed-1f1f3",
    a: "2"
  }, {
    n: ["HR", "flag", "flag: Croatia", "flag: croatia"],
    u: "1f1ed-1f1f7",
    a: "2"
  }, {
    n: ["HT", "flag", "flag: Haiti", "flag: haiti"],
    u: "1f1ed-1f1f9",
    a: "2"
  }, {
    n: ["HU", "flag", "flag: Hungary", "flag: hungary"],
    u: "1f1ed-1f1fa",
    a: "2"
  }, {
    n: ["IC", "flag", "flag: Canary Islands", "flag: canary islands"],
    u: "1f1ee-1f1e8",
    a: "2"
  }, {
    n: ["ID", "flag", "flag: Indonesia", "flag: indonesia"],
    u: "1f1ee-1f1e9",
    a: "2"
  }, {
    n: ["IE", "flag", "flag: Ireland", "flag: ireland"],
    u: "1f1ee-1f1ea",
    a: "2"
  }, {
    n: ["IL", "flag", "flag: Israel", "flag: israel"],
    u: "1f1ee-1f1f1",
    a: "2"
  }, {
    n: ["IM", "flag", "flag: Isle of Man", "flag: isle of man"],
    u: "1f1ee-1f1f2",
    a: "2"
  }, {
    n: ["IN", "flag", "flag: India", "flag: india"],
    u: "1f1ee-1f1f3",
    a: "2"
  }, {
    n: ["IO", "flag", "flag: British Indian Ocean Territory", "flag: british indian ocean territory"],
    u: "1f1ee-1f1f4",
    a: "2"
  }, {
    n: ["IQ", "flag", "flag: Iraq", "flag: iraq"],
    u: "1f1ee-1f1f6",
    a: "2"
  }, {
    n: ["IR", "flag", "flag: Iran", "flag: iran"],
    u: "1f1ee-1f1f7",
    a: "2"
  }, {
    n: ["IS", "flag", "flag: Iceland", "flag: iceland"],
    u: "1f1ee-1f1f8",
    a: "2"
  }, {
    n: ["IT", "flag", "flag: Italy", "flag: italy"],
    u: "1f1ee-1f1f9",
    a: "0.6"
  }, {
    n: ["JE", "flag", "flag: Jersey", "flag: jersey"],
    u: "1f1ef-1f1ea",
    a: "2"
  }, {
    n: ["JM", "flag", "flag: Jamaica", "flag: jamaica"],
    u: "1f1ef-1f1f2",
    a: "2"
  }, {
    n: ["JO", "flag", "flag: Jordan", "flag: jordan"],
    u: "1f1ef-1f1f4",
    a: "2"
  }, {
    n: ["JP", "flag", "flag: Japan", "flag: japan"],
    u: "1f1ef-1f1f5",
    a: "0.6"
  }, {
    n: ["KE", "flag", "flag: Kenya", "flag: kenya"],
    u: "1f1f0-1f1ea",
    a: "2"
  }, {
    n: ["KG", "flag", "flag: Kyrgyzstan", "flag: kyrgyzstan"],
    u: "1f1f0-1f1ec",
    a: "2"
  }, {
    n: ["KH", "flag", "flag: Cambodia", "flag: cambodia"],
    u: "1f1f0-1f1ed",
    a: "2"
  }, {
    n: ["KI", "flag", "flag: Kiribati", "flag: kiribati"],
    u: "1f1f0-1f1ee",
    a: "2"
  }, {
    n: ["KM", "flag", "flag: Comoros", "flag: comoros"],
    u: "1f1f0-1f1f2",
    a: "2"
  }, {
    n: ["KN", "flag", "flag: St. Kitts & Nevis", "flag: st. kitts & nevis"],
    u: "1f1f0-1f1f3",
    a: "2"
  }, {
    n: ["KP", "flag", "flag: North Korea", "flag: north korea"],
    u: "1f1f0-1f1f5",
    a: "2"
  }, {
    n: ["KR", "flag", "flag: South Korea", "flag: south korea"],
    u: "1f1f0-1f1f7",
    a: "0.6"
  }, {
    n: ["KW", "flag", "flag: Kuwait", "flag: kuwait"],
    u: "1f1f0-1f1fc",
    a: "2"
  }, {
    n: ["KY", "flag", "flag: Cayman Islands", "flag: cayman islands"],
    u: "1f1f0-1f1fe",
    a: "2"
  }, {
    n: ["KZ", "flag", "flag: Kazakhstan", "flag: kazakhstan"],
    u: "1f1f0-1f1ff",
    a: "2"
  }, {
    n: ["LA", "flag", "flag: Laos", "flag: laos"],
    u: "1f1f1-1f1e6",
    a: "2"
  }, {
    n: ["LB", "flag", "flag: Lebanon", "flag: lebanon"],
    u: "1f1f1-1f1e7",
    a: "2"
  }, {
    n: ["LC", "flag", "flag: St. Lucia", "flag: st. lucia"],
    u: "1f1f1-1f1e8",
    a: "2"
  }, {
    n: ["LI", "flag", "flag: Liechtenstein", "flag: liechtenstein"],
    u: "1f1f1-1f1ee",
    a: "2"
  }, {
    n: ["LK", "flag", "flag: Sri Lanka", "flag: sri lanka"],
    u: "1f1f1-1f1f0",
    a: "2"
  }, {
    n: ["LR", "flag", "flag: Liberia", "flag: liberia"],
    u: "1f1f1-1f1f7",
    a: "2"
  }, {
    n: ["LS", "flag", "flag: Lesotho", "flag: lesotho"],
    u: "1f1f1-1f1f8",
    a: "2"
  }, {
    n: ["LT", "flag", "flag: Lithuania", "flag: lithuania"],
    u: "1f1f1-1f1f9",
    a: "2"
  }, {
    n: ["LU", "flag", "flag: Luxembourg", "flag: luxembourg"],
    u: "1f1f1-1f1fa",
    a: "2"
  }, {
    n: ["LV", "flag", "flag: Latvia", "flag: latvia"],
    u: "1f1f1-1f1fb",
    a: "2"
  }, {
    n: ["LY", "flag", "flag: Libya", "flag: libya"],
    u: "1f1f1-1f1fe",
    a: "2"
  }, {
    n: ["MA", "flag", "flag: Morocco", "flag: morocco"],
    u: "1f1f2-1f1e6",
    a: "2"
  }, {
    n: ["MC", "flag", "flag: Monaco", "flag: monaco"],
    u: "1f1f2-1f1e8",
    a: "2"
  }, {
    n: ["MD", "flag", "flag: Moldova", "flag: moldova"],
    u: "1f1f2-1f1e9",
    a: "2"
  }, {
    n: ["ME", "flag", "flag: Montenegro", "flag: montenegro"],
    u: "1f1f2-1f1ea",
    a: "2"
  }, {
    n: ["MF", "flag", "flag: St. Martin", "flag: st. martin"],
    u: "1f1f2-1f1eb",
    a: "2"
  }, {
    n: ["MG", "flag", "flag: Madagascar", "flag: madagascar"],
    u: "1f1f2-1f1ec",
    a: "2"
  }, {
    n: ["MH", "flag", "flag: Marshall Islands", "flag: marshall islands"],
    u: "1f1f2-1f1ed",
    a: "2"
  }, {
    n: ["MK", "flag", "flag: North Macedonia", "flag: north macedonia"],
    u: "1f1f2-1f1f0",
    a: "2"
  }, {
    n: ["ML", "flag", "flag: Mali", "flag: mali"],
    u: "1f1f2-1f1f1",
    a: "2"
  }, {
    n: ["MM", "flag", "flag: Myanmar (Burma)", "flag: myanmar (burma)"],
    u: "1f1f2-1f1f2",
    a: "2"
  }, {
    n: ["MN", "flag", "flag: Mongolia", "flag: mongolia"],
    u: "1f1f2-1f1f3",
    a: "2"
  }, {
    n: ["MO", "flag", "flag: Macao SAR China", "flag: macao sar china"],
    u: "1f1f2-1f1f4",
    a: "2"
  }, {
    n: ["MP", "flag", "flag: Northern Mariana Islands", "flag: northern mariana islands"],
    u: "1f1f2-1f1f5",
    a: "2"
  }, {
    n: ["MQ", "flag", "flag: Martinique", "flag: martinique"],
    u: "1f1f2-1f1f6",
    a: "2"
  }, {
    n: ["MR", "flag", "flag: Mauritania", "flag: mauritania"],
    u: "1f1f2-1f1f7",
    a: "2"
  }, {
    n: ["MS", "flag", "flag: Montserrat", "flag: montserrat"],
    u: "1f1f2-1f1f8",
    a: "2"
  }, {
    n: ["MT", "flag", "flag: Malta", "flag: malta"],
    u: "1f1f2-1f1f9",
    a: "2"
  }, {
    n: ["MU", "flag", "flag: Mauritius", "flag: mauritius"],
    u: "1f1f2-1f1fa",
    a: "2"
  }, {
    n: ["MV", "flag", "flag: Maldives", "flag: maldives"],
    u: "1f1f2-1f1fb",
    a: "2"
  }, {
    n: ["MW", "flag", "flag: Malawi", "flag: malawi"],
    u: "1f1f2-1f1fc",
    a: "2"
  }, {
    n: ["MX", "flag", "flag: Mexico", "flag: mexico"],
    u: "1f1f2-1f1fd",
    a: "2"
  }, {
    n: ["MY", "flag", "flag: Malaysia", "flag: malaysia"],
    u: "1f1f2-1f1fe",
    a: "2"
  }, {
    n: ["MZ", "flag", "flag: Mozambique", "flag: mozambique"],
    u: "1f1f2-1f1ff",
    a: "2"
  }, {
    n: ["NA", "flag", "flag: Namibia", "flag: namibia"],
    u: "1f1f3-1f1e6",
    a: "2"
  }, {
    n: ["NC", "flag", "flag: New Caledonia", "flag: new caledonia"],
    u: "1f1f3-1f1e8",
    a: "2"
  }, {
    n: ["NE", "flag", "flag: Niger", "flag: niger"],
    u: "1f1f3-1f1ea",
    a: "2"
  }, {
    n: ["NF", "flag", "flag: Norfolk Island", "flag: norfolk island"],
    u: "1f1f3-1f1eb",
    a: "2"
  }, {
    n: ["NG", "flag", "flag: Nigeria", "flag: nigeria"],
    u: "1f1f3-1f1ec",
    a: "2"
  }, {
    n: ["NI", "flag", "flag: Nicaragua", "flag: nicaragua"],
    u: "1f1f3-1f1ee",
    a: "2"
  }, {
    n: ["NL", "flag", "flag: Netherlands", "flag: netherlands"],
    u: "1f1f3-1f1f1",
    a: "2"
  }, {
    n: ["NO", "flag", "flag: Norway", "flag: norway"],
    u: "1f1f3-1f1f4",
    a: "2"
  }, {
    n: ["NP", "flag", "flag: Nepal", "flag: nepal"],
    u: "1f1f3-1f1f5",
    a: "2"
  }, {
    n: ["NR", "flag", "flag: Nauru", "flag: nauru"],
    u: "1f1f3-1f1f7",
    a: "2"
  }, {
    n: ["NU", "flag", "flag: Niue", "flag: niue"],
    u: "1f1f3-1f1fa",
    a: "2"
  }, {
    n: ["NZ", "flag", "flag: New Zealand", "flag: new zealand"],
    u: "1f1f3-1f1ff",
    a: "2"
  }, {
    n: ["OM", "flag", "flag: Oman", "flag: oman"],
    u: "1f1f4-1f1f2",
    a: "2"
  }, {
    n: ["PA", "flag", "flag: Panama", "flag: panama"],
    u: "1f1f5-1f1e6",
    a: "2"
  }, {
    n: ["PE", "flag", "flag: Peru", "flag: peru"],
    u: "1f1f5-1f1ea",
    a: "2"
  }, {
    n: ["PF", "flag", "flag: French Polynesia", "flag: french polynesia"],
    u: "1f1f5-1f1eb",
    a: "2"
  }, {
    n: ["PG", "flag", "flag: Papua New Guinea", "flag: papua new guinea"],
    u: "1f1f5-1f1ec",
    a: "2"
  }, {
    n: ["PH", "flag", "flag: Philippines", "flag: philippines"],
    u: "1f1f5-1f1ed",
    a: "2"
  }, {
    n: ["PK", "flag", "flag: Pakistan", "flag: pakistan"],
    u: "1f1f5-1f1f0",
    a: "2"
  }, {
    n: ["PL", "flag", "flag: Poland", "flag: poland"],
    u: "1f1f5-1f1f1",
    a: "2"
  }, {
    n: ["PM", "flag", "flag: St. Pierre & Miquelon", "flag: st. pierre & miquelon"],
    u: "1f1f5-1f1f2",
    a: "2"
  }, {
    n: ["PN", "flag", "flag: Pitcairn Islands", "flag: pitcairn islands"],
    u: "1f1f5-1f1f3",
    a: "2"
  }, {
    n: ["PR", "flag", "flag: Puerto Rico", "flag: puerto rico"],
    u: "1f1f5-1f1f7",
    a: "2"
  }, {
    n: ["PS", "flag", "flag: Palestinian Territories", "flag: palestinian territories"],
    u: "1f1f5-1f1f8",
    a: "2"
  }, {
    n: ["PT", "flag", "flag: Portugal", "flag: portugal"],
    u: "1f1f5-1f1f9",
    a: "2"
  }, {
    n: ["PW", "flag", "flag: Palau", "flag: palau"],
    u: "1f1f5-1f1fc",
    a: "2"
  }, {
    n: ["PY", "flag", "flag: Paraguay", "flag: paraguay"],
    u: "1f1f5-1f1fe",
    a: "2"
  }, {
    n: ["QA", "flag", "flag: Qatar", "flag: qatar"],
    u: "1f1f6-1f1e6",
    a: "2"
  }, {
    n: ["RE", "flag", "flag: Réunion", "flag: réunion"],
    u: "1f1f7-1f1ea",
    a: "2"
  }, {
    n: ["RO", "flag", "flag: Romania", "flag: romania"],
    u: "1f1f7-1f1f4",
    a: "2"
  }, {
    n: ["RS", "flag", "flag: Serbia", "flag: serbia"],
    u: "1f1f7-1f1f8",
    a: "2"
  }, {
    n: ["RU", "flag", "flag: Russia", "flag: russia"],
    u: "1f1f7-1f1fa",
    a: "0.6"
  }, {
    n: ["RW", "flag", "flag: Rwanda", "flag: rwanda"],
    u: "1f1f7-1f1fc",
    a: "2"
  }, {
    n: ["SA", "flag", "flag: Saudi Arabia", "flag: saudi arabia"],
    u: "1f1f8-1f1e6",
    a: "2"
  }, {
    n: ["SB", "flag", "flag: Solomon Islands", "flag: solomon islands"],
    u: "1f1f8-1f1e7",
    a: "2"
  }, {
    n: ["SC", "flag", "flag: Seychelles", "flag: seychelles"],
    u: "1f1f8-1f1e8",
    a: "2"
  }, {
    n: ["SD", "flag", "flag: Sudan", "flag: sudan"],
    u: "1f1f8-1f1e9",
    a: "2"
  }, {
    n: ["SE", "flag", "flag: Sweden", "flag: sweden"],
    u: "1f1f8-1f1ea",
    a: "2"
  }, {
    n: ["SG", "flag", "flag: Singapore", "flag: singapore"],
    u: "1f1f8-1f1ec",
    a: "2"
  }, {
    n: ["SH", "flag", "flag: St. Helena", "flag: st. helena"],
    u: "1f1f8-1f1ed",
    a: "2"
  }, {
    n: ["SI", "flag", "flag: Slovenia", "flag: slovenia"],
    u: "1f1f8-1f1ee",
    a: "2"
  }, {
    n: ["SJ", "flag", "flag: Svalbard & Jan Mayen", "flag: svalbard & jan mayen"],
    u: "1f1f8-1f1ef",
    a: "2"
  }, {
    n: ["SK", "flag", "flag: Slovakia", "flag: slovakia"],
    u: "1f1f8-1f1f0",
    a: "2"
  }, {
    n: ["SL", "flag", "flag: Sierra Leone", "flag: sierra leone"],
    u: "1f1f8-1f1f1",
    a: "2"
  }, {
    n: ["SM", "flag", "flag: San Marino", "flag: san marino"],
    u: "1f1f8-1f1f2",
    a: "2"
  }, {
    n: ["SN", "flag", "flag: Senegal", "flag: senegal"],
    u: "1f1f8-1f1f3",
    a: "2"
  }, {
    n: ["SO", "flag", "flag: Somalia", "flag: somalia"],
    u: "1f1f8-1f1f4",
    a: "2"
  }, {
    n: ["SR", "flag", "flag: Suriname", "flag: suriname"],
    u: "1f1f8-1f1f7",
    a: "2"
  }, {
    n: ["SS", "flag", "flag: South Sudan", "flag: south sudan"],
    u: "1f1f8-1f1f8",
    a: "2"
  }, {
    n: ["ST", "flag", "flag: São Tomé & Príncipe", "flag: são tomé & príncipe"],
    u: "1f1f8-1f1f9",
    a: "2"
  }, {
    n: ["SV", "flag", "flag: El Salvador", "flag: el salvador"],
    u: "1f1f8-1f1fb",
    a: "2"
  }, {
    n: ["SX", "flag", "flag: Sint Maarten", "flag: sint maarten"],
    u: "1f1f8-1f1fd",
    a: "2"
  }, {
    n: ["SY", "flag", "flag: Syria", "flag: syria"],
    u: "1f1f8-1f1fe",
    a: "2"
  }, {
    n: ["SZ", "flag", "flag: Eswatini", "flag: eswatini"],
    u: "1f1f8-1f1ff",
    a: "2"
  }, {
    n: ["TA", "flag", "flag: Tristan da Cunha", "flag: tristan da cunha"],
    u: "1f1f9-1f1e6",
    a: "2"
  }, {
    n: ["TC", "flag", "flag: Turks & Caicos Islands", "flag: turks & caicos islands"],
    u: "1f1f9-1f1e8",
    a: "2"
  }, {
    n: ["TD", "flag", "flag: Chad", "flag: chad"],
    u: "1f1f9-1f1e9",
    a: "2"
  }, {
    n: ["TF", "flag", "flag: French Southern Territories", "flag: french southern territories"],
    u: "1f1f9-1f1eb",
    a: "2"
  }, {
    n: ["TG", "flag", "flag: Togo", "flag: togo"],
    u: "1f1f9-1f1ec",
    a: "2"
  }, {
    n: ["TH", "flag", "flag: Thailand", "flag: thailand"],
    u: "1f1f9-1f1ed",
    a: "2"
  }, {
    n: ["TJ", "flag", "flag: Tajikistan", "flag: tajikistan"],
    u: "1f1f9-1f1ef",
    a: "2"
  }, {
    n: ["TK", "flag", "flag: Tokelau", "flag: tokelau"],
    u: "1f1f9-1f1f0",
    a: "2"
  }, {
    n: ["TL", "flag", "flag: Timor Leste", "flag: timor leste"],
    u: "1f1f9-1f1f1",
    a: "2"
  }, {
    n: ["TM", "flag", "flag: Turkmenistan", "flag: turkmenistan"],
    u: "1f1f9-1f1f2",
    a: "2"
  }, {
    n: ["TN", "flag", "flag: Tunisia", "flag: tunisia"],
    u: "1f1f9-1f1f3",
    a: "2"
  }, {
    n: ["TO", "flag", "flag: Tonga", "flag: tonga"],
    u: "1f1f9-1f1f4",
    a: "2"
  }, {
    n: ["TR", "flag", "flag: Türkiye", "flag: türkiye"],
    u: "1f1f9-1f1f7",
    a: "2"
  }, {
    n: ["TT", "flag", "flag: Trinidad & Tobago", "flag: trinidad & tobago"],
    u: "1f1f9-1f1f9",
    a: "2"
  }, {
    n: ["TV", "flag", "flag: Tuvalu", "flag: tuvalu"],
    u: "1f1f9-1f1fb",
    a: "2"
  }, {
    n: ["TW", "flag", "flag: Taiwan", "flag: taiwan"],
    u: "1f1f9-1f1fc",
    a: "2"
  }, {
    n: ["TZ", "flag", "flag: Tanzania", "flag: tanzania"],
    u: "1f1f9-1f1ff",
    a: "2"
  }, {
    n: ["UA", "flag", "flag: Ukraine", "flag: ukraine"],
    u: "1f1fa-1f1e6",
    a: "2"
  }, {
    n: ["UG", "flag", "flag: Uganda", "flag: uganda"],
    u: "1f1fa-1f1ec",
    a: "2"
  }, {
    n: ["UM", "flag", "flag: U.S. Outlying Islands", "flag: u.s. outlying islands"],
    u: "1f1fa-1f1f2",
    a: "2"
  }, {
    n: ["UN", "flag", "flag: United Nations", "flag: united nations"],
    u: "1f1fa-1f1f3",
    a: "4"
  }, {
    n: ["US", "flag", "flag: United States", "flag: united states"],
    u: "1f1fa-1f1f8",
    a: "0.6"
  }, {
    n: ["UY", "flag", "flag: Uruguay", "flag: uruguay"],
    u: "1f1fa-1f1fe",
    a: "2"
  }, {
    n: ["UZ", "flag", "flag: Uzbekistan", "flag: uzbekistan"],
    u: "1f1fa-1f1ff",
    a: "2"
  }, {
    n: ["VA", "flag", "flag: Vatican City", "flag: vatican city"],
    u: "1f1fb-1f1e6",
    a: "2"
  }, {
    n: ["VC", "flag", "flag: St. Vincent & Grenadines", "flag: st. vincent & grenadines"],
    u: "1f1fb-1f1e8",
    a: "2"
  }, {
    n: ["VE", "flag", "flag: Venezuela", "flag: venezuela"],
    u: "1f1fb-1f1ea",
    a: "2"
  }, {
    n: ["VG", "flag", "flag: British Virgin Islands", "flag: british virgin islands"],
    u: "1f1fb-1f1ec",
    a: "2"
  }, {
    n: ["VI", "flag", "flag: U.S. Virgin Islands", "flag: u.s. virgin islands"],
    u: "1f1fb-1f1ee",
    a: "2"
  }, {
    n: ["VN", "flag", "flag: Vietnam", "flag: vietnam"],
    u: "1f1fb-1f1f3",
    a: "2"
  }, {
    n: ["VU", "flag", "flag: Vanuatu", "flag: vanuatu"],
    u: "1f1fb-1f1fa",
    a: "2"
  }, {
    n: ["WF", "flag", "flag: Wallis & Futuna", "flag: wallis & futuna"],
    u: "1f1fc-1f1eb",
    a: "2"
  }, {
    n: ["WS", "flag", "flag: Samoa", "flag: samoa"],
    u: "1f1fc-1f1f8",
    a: "2"
  }, {
    n: ["XK", "flag", "flag: Kosovo", "flag: kosovo"],
    u: "1f1fd-1f1f0",
    a: "2"
  }, {
    n: ["YE", "flag", "flag: Yemen", "flag: yemen"],
    u: "1f1fe-1f1ea",
    a: "2"
  }, {
    n: ["YT", "flag", "flag: Mayotte", "flag: mayotte"],
    u: "1f1fe-1f1f9",
    a: "2"
  }, {
    n: ["ZA", "flag", "flag: South Africa", "flag: south africa"],
    u: "1f1ff-1f1e6",
    a: "2"
  }, {
    n: ["ZM", "flag", "flag: Zambia", "flag: zambia"],
    u: "1f1ff-1f1f2",
    a: "2"
  }, {
    n: ["ZW", "flag", "flag: Zimbabwe", "flag: zimbabwe"],
    u: "1f1ff-1f1fc",
    a: "2"
  }, {
    n: ["flag", "gbeng", "flag: England", "flag: england"],
    u: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
    a: "5"
  }, {
    n: ["flag", "gbsct", "flag: Scotland", "flag: scotland"],
    u: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
    a: "5"
  }, {
    n: ["flag", "gbwls", "flag: Wales", "flag: wales"],
    u: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
    a: "5"
  }]
};
var defaultEmojiData = {
  categories: categories,
  emojis: emojis
};
var SUGGESTED_LS_KEY = 'epr_suggested';
function getSuggested(mode) {
  try {
    var _window, _window$localStorage$, _window2;
    if (!((_window = window) != null && _window.localStorage)) {
      return [];
    }
    var recent = JSON.parse((_window$localStorage$ = (_window2 = window) == null ? void 0 : _window2.localStorage.getItem(SUGGESTED_LS_KEY)) != null ? _window$localStorage$ : '[]');
    if (mode === SuggestionMode.FREQUENT) {
      return recent.sort(function (a, b) {
        return b.count - a.count;
      });
    }
    return recent;
  } catch (_unused) {
    return [];
  }
}
function setSuggested(emoji, skinTone) {
  var recent = getSuggested();
  var unified = emojiUnified$1(emoji, skinTone);
  var originalUnified = emojiUnified$1(emoji);
  var existing = recent.find(function (_ref) {
    var u = _ref.unified;
    return u === unified;
  });
  var nextList;
  if (existing) {
    nextList = [existing].concat(recent.filter(function (i) {
      return i !== existing;
    }));
  } else {
    existing = {
      unified: unified,
      original: originalUnified,
      count: 0
    };
    nextList = [existing].concat(recent);
  }
  existing.count++;
  nextList.length = Math.min(nextList.length, 14);
  try {
    var _window3;
    (_window3 = window) == null ? void 0 : _window3.localStorage.setItem(SUGGESTED_LS_KEY, JSON.stringify(nextList));
    // Prevents the change from being seen immediately.
  } catch (_unused2) {
    // ignore
  }
}
function emojiNames$1(emoji) {
  var _emoji$EmojiPropertie;
  return (_emoji$EmojiPropertie = emoji[EmojiProperties.name]) != null ? _emoji$EmojiPropertie : [];
}
function emojiName$1(emoji) {
  if (!emoji) {
    return '';
  }
  var names = emojiNames$1(emoji);
  return names[names.length - 1];
}
function unifiedWithoutSkinTone$1(unified) {
  var splat = unified.split('-');
  var _splat$splice = splat.splice(1, 1),
    skinTone = _splat$splice[0];
  if (skinTonesMapped[skinTone]) {
    return splat.join('-');
  }
  return unified;
}
function emojiUnified$1(emoji, skinTone) {
  var _emojiVariationUnifie;
  var unified = emoji[EmojiProperties.unified];
  if (!skinTone || !emojiHasVariations$1(emoji)) {
    return unified;
  }
  return (_emojiVariationUnifie = emojiVariationUnified$1(emoji, skinTone)) != null ? _emojiVariationUnifie : unified;
}
function useGetEmojisByCategory() {
  var suggestedEmojisModeConfig = useSuggestedEmojisModeConfig();
  var _useUpdateSuggested = useUpdateSuggested(),
    suggestedUpdated = _useUpdateSuggested[0];
  var suggested = React$2.useMemo(function () {
    var _getSuggested;
    var suggested = (_getSuggested = getSuggested(suggestedEmojisModeConfig)) != null ? _getSuggested : [];
    return suggested.map(function (s) {
      return emojiByUnified(s.unified);
    }).filter(Boolean);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [suggestedUpdated, suggestedEmojisModeConfig]);
  return function getEmojisByCategory(category) {
    var _emojis$emojis$catego;
    if (category === Categories.SUGGESTED) {
      return suggested;
    }
    // @ts-ignore
    return (_emojis$emojis$catego = defaultEmojiData.emojis[category]) != null ? _emojis$emojis$catego : [];
  };
}
function emojiVariations$1(emoji) {
  var _emoji$EmojiPropertie2;
  return (_emoji$EmojiPropertie2 = emoji[EmojiProperties.variations]) != null ? _emoji$EmojiPropertie2 : [];
}
function emojiHasVariations$1(emoji) {
  return emojiVariations$1(emoji).length > 0;
}
function emojiVariationUnified$1(emoji, skinTone) {
  return skinTone ? emojiVariations$1(emoji).find(function (variation) {
    return variation.includes(skinTone);
  }) : emojiUnified$1(emoji);
}
function emojiByUnified(unified) {
  if (!unified) {
    return;
  }
  if (allEmojisByUnified[unified]) {
    return allEmojisByUnified[unified];
  }
  var withoutSkinTone = unifiedWithoutSkinTone$1(unified);
  return allEmojisByUnified[withoutSkinTone];
}
var allEmojis = /*#__PURE__*/Object.values(defaultEmojiData.emojis).flat();
var allEmojisByUnified = {};
allEmojis.reduce(function (allEmojis, Emoji) {
  allEmojis[emojiUnified$1(Emoji)] = Emoji;
  if (emojiHasVariations$1(Emoji)) {
    emojiVariations$1(Emoji).forEach(function (variation) {
      allEmojis[variation] = Emoji;
    });
  }
  return allEmojis;
}, allEmojisByUnified);
function activeVariationFromUnified$1(unified) {
  var _unified$split = unified.split('-'),
    suspectedSkinTone = _unified$split[1];
  return skinToneVariations.includes(suspectedSkinTone) ? suspectedSkinTone : null;
}
var PickerDataContext = /*#__PURE__*/React$2.createContext({
  emojiData: {},
  allEmojis: [],
  allEmojisByUnified: {},
  searchIndex: {},
  emojiByUnified: emojiByUnified,
  activeVariationFromUnified: function activeVariationFromUnified() {
    return null;
  }
});
function PickerDataProvider(_ref) {
  var children = _ref.children;
  var _usePickerConfig = usePickerConfig(),
    customEmojis = _usePickerConfig.customEmojis,
    genericEmojiData = _usePickerConfig.emojiData;
  var data = React$2.useMemo(function () {
    var emojiData = genericEmojiData || defaultEmojiData;
    // Clone to avoid mutation of shared source
    var newData = JSON.parse(JSON.stringify(emojiData));
    if (customEmojis && customEmojis.length > 0) {
      newData.emojis[Categories.CUSTOM] = customEmojis.map(customToRegularEmoji);
    }
    var emojis = newData.emojis || {};
    var allEmojis = Object.values(emojis).flat();
    var allEmojisByUnified = {};
    var searchIndex = {};
    allEmojis.forEach(function (emoji) {
      var unified = emoji[EmojiProperties.unified];
      allEmojisByUnified[unified] = emoji;
      if (emoji[EmojiProperties.variations]) {
        var _emoji$Keys$variation;
        (_emoji$Keys$variation = emoji[EmojiProperties.variations]) == null ? void 0 : _emoji$Keys$variation.forEach(function (variation) {
          allEmojisByUnified[variation] = emoji;
        });
      }
      // Index for search
      // Re-implement indexEmoji logic here to be local
      var joinedNameString = (emoji[EmojiProperties.name] || []).join('').toLowerCase().split('');
      joinedNameString.forEach(function (_char) {
        var _searchIndex$_char;
        searchIndex[_char] = (_searchIndex$_char = searchIndex[_char]) != null ? _searchIndex$_char : {};
        searchIndex[_char][unified] = emoji;
      });
    });
    return {
      emojiData: newData,
      allEmojis: allEmojis,
      allEmojisByUnified: allEmojisByUnified,
      searchIndex: searchIndex
    };
  }, [genericEmojiData, customEmojis]);
  var emojiByUnified = React$2.useCallback(function (unified) {
    var _data$allEmojisByUnif;
    if (!unified) return undefined;
    var result = (_data$allEmojisByUnif = data.allEmojisByUnified[unified]) != null ? _data$allEmojisByUnif : data.allEmojisByUnified[unifiedWithoutSkinTone(unified)];
    return result;
  }, [data.allEmojisByUnified]);
  return React$2.createElement(PickerDataContext.Provider, {
    value: _extends({}, data, {
      emojiByUnified: emojiByUnified,
      activeVariationFromUnified: activeVariationFromUnified
    })
  }, children);
}
function usePickerDataContext() {
  return React$2.useContext(PickerDataContext);
}
function useGetEmojisByCategory$1() {
  var _usePickerDataContext = usePickerDataContext(),
    emojiData = _usePickerDataContext.emojiData,
    emojiByUnified = _usePickerDataContext.emojiByUnified;
  var suggestedEmojisModeConfig = useSuggestedEmojisModeConfig();
  var _useUpdateSuggested = useUpdateSuggested(),
    suggestedUpdated = _useUpdateSuggested[0];
  var suggested = React$2.useMemo(function () {
    var _getSuggested;
    var suggested = (_getSuggested = getSuggested(suggestedEmojisModeConfig)) != null ? _getSuggested : [];
    return suggested.map(function (s) {
      var _extends2;
      var emoji = emojiByUnified(s.unified);
      if (!emoji) return undefined;
      return _extends({}, emoji, (_extends2 = {}, _extends2[EmojiProperties.unified] = s.unified, _extends2));
    }).filter(Boolean);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suggestedUpdated, suggestedEmojisModeConfig, emojiByUnified]);
  return function getEmojisByCategory(category) {
    var _emojiData$emojis$cat, _emojiData$emojis;
    if (category === Categories.SUGGESTED) {
      return suggested;
    }
    return (_emojiData$emojis$cat = (_emojiData$emojis = emojiData.emojis) == null ? void 0 : _emojiData$emojis[category]) != null ? _emojiData$emojis$cat : [];
  };
}
function customToRegularEmoji(emoji) {
  var _ref2;
  return _ref2 = {}, _ref2[EmojiProperties.name] = emoji.names.map(function (name) {
    return name.toLowerCase();
  }), _ref2[EmojiProperties.unified] = emoji.id.toLowerCase(), _ref2[EmojiProperties.added_in] = '0', _ref2[EmojiProperties.imgUrl] = emoji.imgUrl, _ref2;
}
function useIsUnicodeHidden() {
  var unicodeToHide = useUnicodeToHide();
  return function (emojiUnified) {
    return unicodeToHide.has(emojiUnified);
  };
}
function useDisallowedEmojis() {
  var DisallowedEmojisRef = useRef({});
  var emojiVersionConfig = useEmojiVersionConfig();
  var _usePickerDataContext = usePickerDataContext(),
    allEmojis = _usePickerDataContext.allEmojis;
  return useMemo(function () {
    var emojiVersion = parseFloat("" + emojiVersionConfig);
    if (!emojiVersionConfig || Number.isNaN(emojiVersion)) {
      return DisallowedEmojisRef.current;
    }
    return allEmojis.reduce(function (disallowedEmojis, emoji) {
      if (addedInNewerVersion(emoji, emojiVersion)) {
        disallowedEmojis[emojiUnified(emoji)] = true;
      }
      return disallowedEmojis;
    }, DisallowedEmojisRef.current);
  }, [emojiVersionConfig, allEmojis]);
}
function useIsEmojiDisallowed() {
  var disallowedEmojis = useDisallowedEmojis();
  var isUnicodeHidden = useIsUnicodeHidden();
  return function isEmojiDisallowed(emoji) {
    var unified = unifiedWithoutSkinTone(emojiUnified(emoji));
    return Boolean(disallowedEmojis[unified] || isUnicodeHidden(unified));
  };
}
function addedInNewerVersion(emoji, supportedLevel) {
  return addedIn(emoji) > supportedLevel;
}
function useMarkInitialLoad(dispatch) {
  useEffect(function () {
    dispatch(true);
  }, [dispatch]);
}
function PickerContextProvider(_ref) {
  var children = _ref.children;
  var disallowedEmojis = useDisallowedEmojis();
  var defaultSkinTone = useDefaultSkinToneConfig();
  var reactionsDefaultOpen = useReactionsOpenConfig();
  var _usePickerDataContext = usePickerDataContext(),
    searchIndex = _usePickerDataContext.searchIndex;
  // Initialize the filter with the inititial dictionary
  var filterRef = useRef(searchIndex);
  useEffect(function () {
    filterRef.current = searchIndex;
  }, [searchIndex]);
  var disallowClickRef = useRef(false);
  var disallowMouseRef = useRef(false);
  var disallowedEmojisRef = useRef(disallowedEmojis);
  var suggestedUpdateState = useDebouncedState(Date.now(), 200);
  var searchTerm = useDebouncedState('', 100);
  var skinToneFanOpenState = useState(false);
  var activeSkinTone = useState(defaultSkinTone);
  var activeCategoryState = useState(null);
  var emojisThatFailedToLoadState = useState(new Set());
  var emojiVariationPickerState = useState(null);
  var reactionsModeState = useState(reactionsDefaultOpen);
  var _useState = useState(false),
    isPastInitialLoad = _useState[0],
    setIsPastInitialLoad = _useState[1];
  var visibleCategoriesState = useState([]);
  var emojiSizeState = useState(null);
  useMarkInitialLoad(setIsPastInitialLoad);
  return createElement(PickerContext.Provider, {
    value: {
      activeCategoryState: activeCategoryState,
      activeSkinTone: activeSkinTone,
      disallowClickRef: disallowClickRef,
      disallowMouseRef: disallowMouseRef,
      disallowedEmojisRef: disallowedEmojisRef,
      emojiVariationPickerState: emojiVariationPickerState,
      emojisThatFailedToLoadState: emojisThatFailedToLoadState,
      filterRef: filterRef,
      isPastInitialLoad: isPastInitialLoad,
      searchTerm: searchTerm,
      skinToneFanOpenState: skinToneFanOpenState,
      suggestedUpdateState: suggestedUpdateState,
      reactionsModeState: reactionsModeState,
      visibleCategoriesState: visibleCategoriesState,
      emojiSizeState: emojiSizeState
    }
  }, children);
}
var PickerContext = /*#__PURE__*/createContext({
  activeCategoryState: [null, function () {}],
  activeSkinTone: [SkinTones.NEUTRAL, function () {}],
  disallowClickRef: {
    current: false
  },
  disallowMouseRef: {
    current: false
  },
  disallowedEmojisRef: {
    current: {}
  },
  emojiVariationPickerState: [null, function () {}],
  emojisThatFailedToLoadState: [/*#__PURE__*/new Set(), function () {}],
  filterRef: {
    current: {}
  },
  isPastInitialLoad: true,
  searchTerm: ['', function () {
    return new Promise(function () {
      return undefined;
    });
  }],
  skinToneFanOpenState: [false, function () {}],
  suggestedUpdateState: [/*#__PURE__*/Date.now(), function () {}],
  reactionsModeState: [false, function () {}],
  visibleCategoriesState: [[], function () {
    return [];
  }],
  emojiSizeState: [null, function () {}]
});
function useFilterRef() {
  var _React$useContext = useContext(PickerContext),
    filterRef = _React$useContext.filterRef;
  return filterRef;
}
function useDisallowClickRef() {
  var _React$useContext2 = useContext(PickerContext),
    disallowClickRef = _React$useContext2.disallowClickRef;
  return disallowClickRef;
}
function useDisallowMouseRef() {
  var _React$useContext3 = useContext(PickerContext),
    disallowMouseRef = _React$useContext3.disallowMouseRef;
  return disallowMouseRef;
}
function useReactionsModeState() {
  var _React$useContext4 = useContext(PickerContext),
    reactionsModeState = _React$useContext4.reactionsModeState;
  return reactionsModeState;
}
function useSearchTermState() {
  var _React$useContext5 = useContext(PickerContext),
    searchTerm = _React$useContext5.searchTerm;
  return searchTerm;
}
function useActiveSkinToneState() {
  var _React$useContext6 = useContext(PickerContext),
    activeSkinTone = _React$useContext6.activeSkinTone;
  return activeSkinTone;
}
function useEmojisThatFailedToLoadState() {
  var _React$useContext7 = useContext(PickerContext),
    emojisThatFailedToLoadState = _React$useContext7.emojisThatFailedToLoadState;
  return emojisThatFailedToLoadState;
}
function useEmojiVariationPickerState() {
  var _React$useContext9 = useContext(PickerContext),
    emojiVariationPickerState = _React$useContext9.emojiVariationPickerState;
  return emojiVariationPickerState;
}
function useSkinToneFanOpenState() {
  var _React$useContext0 = useContext(PickerContext),
    skinToneFanOpenState = _React$useContext0.skinToneFanOpenState;
  return skinToneFanOpenState;
}
function useVisibleCategoriesState() {
  var _React$useContext10 = useContext(PickerContext),
    visibleCategoriesState = _React$useContext10.visibleCategoriesState;
  return visibleCategoriesState;
}
function useEmojiSizeState() {
  var _React$useContext11 = useContext(PickerContext),
    emojiSizeState = _React$useContext11.emojiSizeState;
  return emojiSizeState;
}
function useUpdateSuggested() {
  var _React$useContext12 = useContext(PickerContext),
    suggestedUpdateState = _React$useContext12.suggestedUpdateState;
  var suggestedUpdated = suggestedUpdateState[0],
    setsuggestedUpdate = suggestedUpdateState[1];
  return [suggestedUpdated, function updateSuggested() {
    setsuggestedUpdate(Date.now());
  }];
}
var MutableConfigContext = /*#__PURE__*/React$2.createContext({});
function useMutableConfig() {
  var mutableConfig = React$2.useContext(MutableConfigContext);
  return mutableConfig;
}
function useDefineMutableConfig(config) {
  var MutableConfigRef = React$2.useRef({
    onEmojiClick: config.onEmojiClick || emptyFunc,
    onReactionClick: config.onReactionClick || config.onEmojiClick,
    onSkinToneChange: config.onSkinToneChange || emptyFunc
  });
  React$2.useEffect(function () {
    MutableConfigRef.current.onEmojiClick = config.onEmojiClick || emptyFunc;
    MutableConfigRef.current.onReactionClick = config.onReactionClick || config.onEmojiClick;
  }, [config.onEmojiClick, config.onReactionClick]);
  React$2.useEffect(function () {
    MutableConfigRef.current.onSkinToneChange = config.onSkinToneChange || emptyFunc;
  }, [config.onSkinToneChange]);
  return MutableConfigRef;
}
function emptyFunc() {}
var MOUSE_EVENT_SOURCE;
(function (MOUSE_EVENT_SOURCE) {
  MOUSE_EVENT_SOURCE["REACTIONS"] = "reactions";
  MOUSE_EVENT_SOURCE["PICKER"] = "picker";
})(MOUSE_EVENT_SOURCE || (MOUSE_EVENT_SOURCE = {}));
function useSearchPlaceHolderConfig() {
  var _find;
  var _usePickerConfig = usePickerConfig(),
    searchPlaceHolder = _usePickerConfig.searchPlaceHolder,
    searchPlaceholder = _usePickerConfig.searchPlaceholder;
  return (_find = [searchPlaceHolder, searchPlaceholder].find(function (p) {
    return p !== DEFAULT_SEARCH_PLACEHOLDER;
  })) != null ? _find : DEFAULT_SEARCH_PLACEHOLDER;
}
function useSearchClearButtonLabelConfig() {
  var _usePickerConfig2 = usePickerConfig(),
    searchClearButtonLabel = _usePickerConfig2.searchClearButtonLabel;
  return searchClearButtonLabel != null ? searchClearButtonLabel : DEFAULT_SEARCH_CLEAR_BUTTON_LABEL;
}
function useDefaultSkinToneConfig() {
  var _usePickerConfig3 = usePickerConfig(),
    defaultSkinTone = _usePickerConfig3.defaultSkinTone;
  return defaultSkinTone;
}
function useAllowExpandReactions() {
  var _usePickerConfig4 = usePickerConfig(),
    allowExpandReactions = _usePickerConfig4.allowExpandReactions;
  return allowExpandReactions;
}
function useSkinTonesDisabledConfig() {
  var _usePickerConfig5 = usePickerConfig(),
    skinTonesDisabled = _usePickerConfig5.skinTonesDisabled;
  return skinTonesDisabled;
}
function useEmojiStyleConfig() {
  var _usePickerConfig6 = usePickerConfig(),
    emojiStyle = _usePickerConfig6.emojiStyle;
  return emojiStyle;
}
function useAutoFocusSearchConfig() {
  var _usePickerConfig7 = usePickerConfig(),
    autoFocusSearch = _usePickerConfig7.autoFocusSearch;
  return autoFocusSearch;
}
function useCategoriesConfig() {
  var _usePickerConfig8 = usePickerConfig(),
    categories = _usePickerConfig8.categories;
  return categories;
}
function useCategoryIconsConfig() {
  var _usePickerConfig9 = usePickerConfig(),
    categoryIcons = _usePickerConfig9.categoryIcons;
  return categoryIcons;
}
function useCustomEmojisConfig() {
  var _usePickerConfig0 = usePickerConfig(),
    customEmojis = _usePickerConfig0.customEmojis;
  return customEmojis;
}
function useOpenConfig() {
  var _usePickerConfig1 = usePickerConfig(),
    open = _usePickerConfig1.open;
  return open;
}
function useOnEmojiClickConfig(mouseEventSource) {
  var _useMutableConfig = useMutableConfig(),
    current = _useMutableConfig.current;
  var _useReactionsModeStat = useReactionsModeState(),
    setReactionsOpen = _useReactionsModeStat[1];
  var handler = current.onEmojiClick || function () {};
  var onReactionClick = current.onReactionClick;
  if (mouseEventSource === MOUSE_EVENT_SOURCE.REACTIONS && onReactionClick) {
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return onReactionClick.apply(void 0, args.concat([{
        collapseToReactions: function collapseToReactions() {
          setReactionsOpen(function (o) {
            return o;
          });
        }
      }]));
    };
  }
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    handler.apply(void 0, args.concat([{
      collapseToReactions: function collapseToReactions() {
        setReactionsOpen(true);
      }
    }]));
  };
}
function useOnSkinToneChangeConfig() {
  var _useMutableConfig2 = useMutableConfig(),
    current = _useMutableConfig2.current;
  return current.onSkinToneChange || function () {};
}
function usePreviewConfig() {
  var _usePickerConfig10 = usePickerConfig(),
    previewConfig = _usePickerConfig10.previewConfig;
  return previewConfig;
}
function useThemeConfig() {
  var _usePickerConfig11 = usePickerConfig(),
    theme = _usePickerConfig11.theme;
  return theme;
}
function useSuggestedEmojisModeConfig() {
  var _usePickerConfig12 = usePickerConfig(),
    suggestedEmojisMode = _usePickerConfig12.suggestedEmojisMode;
  return suggestedEmojisMode;
}
function useLazyLoadEmojisConfig() {
  var _usePickerConfig13 = usePickerConfig(),
    lazyLoadEmojis = _usePickerConfig13.lazyLoadEmojis;
  return lazyLoadEmojis;
}
function useClassNameConfig() {
  var _usePickerConfig14 = usePickerConfig(),
    className = _usePickerConfig14.className;
  return className;
}
function useStyleConfig() {
  var _usePickerConfig15 = usePickerConfig(),
    height = _usePickerConfig15.height,
    width = _usePickerConfig15.width,
    style = _usePickerConfig15.style;
  return _extends({
    height: getDimension(height),
    width: getDimension(width)
  }, style);
}
function useReactionsOpenConfig() {
  var _usePickerConfig16 = usePickerConfig(),
    reactionsDefaultOpen = _usePickerConfig16.reactionsDefaultOpen;
  return reactionsDefaultOpen;
}
function useEmojiVersionConfig() {
  var _usePickerConfig17 = usePickerConfig(),
    emojiVersion = _usePickerConfig17.emojiVersion;
  return emojiVersion;
}
function useSearchDisabledConfig() {
  var _usePickerConfig18 = usePickerConfig(),
    searchDisabled = _usePickerConfig18.searchDisabled;
  return searchDisabled;
}
function useSkinTonePickerLocationConfig() {
  var _usePickerConfig19 = usePickerConfig(),
    skinTonePickerLocation = _usePickerConfig19.skinTonePickerLocation;
  return skinTonePickerLocation;
}
function useUnicodeToHide() {
  var _usePickerConfig20 = usePickerConfig(),
    unicodeToHide = _usePickerConfig20.unicodeToHide;
  return unicodeToHide;
}
function useReactionsConfig() {
  var _usePickerConfig21 = usePickerConfig(),
    reactions = _usePickerConfig21.reactions;
  return reactions;
}
function useGetEmojiUrlConfig() {
  var _usePickerConfig22 = usePickerConfig(),
    getEmojiUrl = _usePickerConfig22.getEmojiUrl;
  return getEmojiUrl;
}
function getDimension(dimensionConfig) {
  return typeof dimensionConfig === 'number' ? dimensionConfig + "px" : dimensionConfig;
}
function useSearchResultsConfig(searchResultsCount) {
  var hasResults = searchResultsCount > 0;
  var isPlural = searchResultsCount > 1;
  if (hasResults) {
    return isPlural ? SEARCH_RESULTS_MULTIPLE_RESULTS_FOUND.replace('%n', searchResultsCount.toString()) : SEARCH_RESULTS_ONE_RESULT_FOUND;
  }
  return SEARCH_RESULTS_NO_RESULTS_FOUND;
}
function useIsSearchMode() {
  var _useSearchTermState = useSearchTermState(),
    searchTerm = _useSearchTermState[0];
  return !!searchTerm;
}
function focusElement(element) {
  if (!element) {
    return;
  }
  requestAnimationFrame(function () {
    element.focus();
  });
}
function focusPrevElementSibling(element) {
  if (!element) return;
  var prev = element.previousElementSibling;
  focusElement(prev);
}
function focusNextElementSibling(element) {
  if (!element) return;
  var next = element.nextElementSibling;
  focusElement(next);
}
function focusFirstElementChild(element) {
  if (!element) return;
  var first = element.firstElementChild;
  focusElement(first);
}
function getActiveElement() {
  return document.activeElement;
}
function ElementRefContextProvider(_ref) {
  var children = _ref.children;
  var PickerMainRef = useRef(null);
  var AnchoredEmojiRef = useRef(null);
  var BodyRef = useRef(null);
  var EmojiListRef = useRef(null);
  var SearchInputRef = useRef(null);
  var SkinTonePickerRef = useRef(null);
  var CategoryNavigationRef = useRef(null);
  var VariationPickerRef = useRef(null);
  var ReactionsRef = useRef(null);
  return createElement(ElementRefContext.Provider, {
    value: {
      AnchoredEmojiRef: AnchoredEmojiRef,
      BodyRef: BodyRef,
      EmojiListRef: EmojiListRef,
      CategoryNavigationRef: CategoryNavigationRef,
      PickerMainRef: PickerMainRef,
      SearchInputRef: SearchInputRef,
      SkinTonePickerRef: SkinTonePickerRef,
      VariationPickerRef: VariationPickerRef,
      ReactionsRef: ReactionsRef
    }
  }, children);
}
var ElementRefContext = /*#__PURE__*/createContext({
  AnchoredEmojiRef: /*#__PURE__*/createRef(),
  BodyRef: /*#__PURE__*/createRef(),
  CategoryNavigationRef: /*#__PURE__*/createRef(),
  EmojiListRef: /*#__PURE__*/createRef(),
  PickerMainRef: /*#__PURE__*/createRef(),
  SearchInputRef: /*#__PURE__*/createRef(),
  SkinTonePickerRef: /*#__PURE__*/createRef(),
  VariationPickerRef: /*#__PURE__*/createRef(),
  ReactionsRef: /*#__PURE__*/createRef()
});
function useElementRef() {
  return useContext(ElementRefContext);
}
function useEmojiListRef() {
  return useElementRef()['EmojiListRef'];
}
function usePickerMainRef() {
  return useElementRef()['PickerMainRef'];
}
function useAnchoredEmojiRef() {
  return useElementRef()['AnchoredEmojiRef'];
}
function useSetAnchoredEmojiRef() {
  var AnchoredEmojiRef = useAnchoredEmojiRef();
  return function (target) {
    if (target === null && AnchoredEmojiRef.current !== null) {
      focusElement(AnchoredEmojiRef.current);
    }
    AnchoredEmojiRef.current = target;
  };
}
function useBodyRef() {
  return useElementRef()['BodyRef'];
}
function useReactionsRef() {
  return useElementRef()['ReactionsRef'];
}
function useSearchInputRef() {
  return useElementRef()['SearchInputRef'];
}
function useSkinTonePickerRef() {
  return useElementRef()['SkinTonePickerRef'];
}
function useCategoryNavigationRef() {
  return useElementRef()['CategoryNavigationRef'];
}
function useVariationPickerRef() {
  return useElementRef()['VariationPickerRef'];
}
function scrollTo(root, top) {
  if (top === void 0) {
    top = 0;
  }
  var $eprBody = queryScrollBody(root);
  if (!$eprBody) {
    return;
  }
  requestAnimationFrame(function () {
    $eprBody.scrollTop = top;
  });
}
function scrollBy(root, by) {
  var $eprBody = queryScrollBody(root);
  if (!$eprBody) {
    return;
  }
  requestAnimationFrame(function () {
    $eprBody.scrollTop = $eprBody.scrollTop + by;
  });
}
function useScrollTo() {
  var BodyRef = useBodyRef();
  return useCallback(function (top) {
    requestAnimationFrame(function () {
      if (BodyRef.current) {
        BodyRef.current.scrollTop = top;
      }
    });
  }, [BodyRef]);
}
function scrollEmojiAboveLabel(emoji) {
  if (!emoji || !isEmojiBehindLabel(emoji)) {
    return;
  }
  if (emoji.closest(asSelectors(ClassNames.variationPicker))) {
    return;
  }
  var scrollBody = closestScrollBody(emoji);
  var by = emojiDistanceFromScrollTop(emoji);
  scrollBy(scrollBody, -(categoryLabelHeight(closestCategory(emoji)) - by));
}
function focusFirstVisibleEmoji(parent) {
  var emoji = firstVisibleEmoji(parent);
  focusElement(emoji);
  scrollEmojiAboveLabel(emoji);
}
function focusAndClickFirstVisibleEmoji(parent) {
  var firstEmoji = firstVisibleEmoji(parent);
  focusElement(firstEmoji);
  firstEmoji == null ? void 0 : firstEmoji.click();
}
function focusLastVisibleEmoji(parent) {
  focusElement(lastVisibleEmoji(parent));
}
function focusNextVisibleEmoji(element) {
  if (!element) {
    return;
  }
  var next = nextVisibleEmoji(element);
  if (!next) {
    return focusFirstVisibleEmoji(nextCategory(element));
  }
  focusElement(next);
  scrollEmojiAboveLabel(next);
}
function focusPrevVisibleEmoji(element) {
  if (!element) {
    return;
  }
  var prev = prevVisibleEmoji(element);
  if (!prev) {
    return focusLastVisibleEmoji(prevCategory(element));
  }
  focusElement(prev);
  scrollEmojiAboveLabel(prev);
}
function focusVisibleEmojiOneRowUp(element, exitUp) {
  if (!element) {
    return;
  }
  var prev = visibleEmojiOneRowUp(element);
  if (!prev) {
    return exitUp();
  }
  focusElement(prev);
  scrollEmojiAboveLabel(prev);
}
function focusVisibleEmojiOneRowDown(element) {
  if (!element) {
    return;
  }
  var next = visibleEmojiOneRowDown(element);
  return focusElement(next);
}
function visibleEmojiOneRowUp(element) {
  if (!element) {
    return null;
  }
  var categoryContent = closestCategoryContent(element);
  var category = closestCategory(categoryContent);
  var countInRow = elementCountInRow(categoryContent, element);
  var emojisInCurrentCategory = allVisibleEmojis(category);
  var currentEmojiIndex = emojisInCurrentCategory.indexOf(element);
  var indexInRow = currentEmojiIndex % countInRow;
  if (currentEmojiIndex === -1) {
    return null;
  }
  if (emojisInCurrentCategory[currentEmojiIndex - countInRow]) {
    return emojisInCurrentCategory[currentEmojiIndex - countInRow];
  }
  var prevVisibleCategory = prevCategory(category);
  if (!prevVisibleCategory) {
    return null;
  }
  var allPrevEmojis = allVisibleEmojis(prevVisibleCategory);
  // if there is an emoji in the same index of `indexInRow` in the previous category, return it
  // for this we need to find the last emoji in the previous category that shares the same indexInRow
  // this is by using the % operator to find the last emoji that matches
  var lastIndexInRow = allPrevEmojis.length % countInRow - 1;
  if (indexInRow > lastIndexInRow) {
    return allPrevEmojis.at(-1);
  }
  // otherwise, return the last emoji that shares the same indexInRow
  for (var i = allPrevEmojis.length - 1; i >= 0; i--) {
    if (i % countInRow === indexInRow) {
      return allPrevEmojis[i];
    }
  }
  return allPrevEmojis.at(-1);
}
function visibleEmojiOneRowDown(element) {
  var _emojisInNextCategory;
  if (!element) {
    return null;
  }
  var categoryContent = closestCategoryContent(element);
  var category = closestCategory(categoryContent);
  var countInRow = elementCountInRow(categoryContent, element);
  var emojisInCurrentCategory = allVisibleEmojis(category);
  var currentEmojiIndex = emojisInCurrentCategory.indexOf(element);
  if (currentEmojiIndex === -1) {
    return null;
  }
  // the remainder until the end of the row
  var remainder = countInRow - currentEmojiIndex % countInRow - 1;
  var firstInNextRow = currentEmojiIndex + remainder + 1;
  if (emojisInCurrentCategory[firstInNextRow]) {
    // if we have a next row, search in the next row for the last available emoji
    for (var p = currentEmojiIndex + countInRow; p % countInRow >= 0; p--) {
      if (emojisInCurrentCategory[p]) {
        return emojisInCurrentCategory[p];
      }
    }
  }
  var indexInRow = currentEmojiIndex % countInRow;
  var nextVisibleCategory = nextCategory(category);
  var emojisInNextCategory = allVisibleEmojis(nextVisibleCategory);
  if (emojisInNextCategory[indexInRow]) {
    return emojisInNextCategory[indexInRow];
  }
  return (_emojisInNextCategory = emojisInNextCategory.at(0)) != null ? _emojisInNextCategory : null;
}
function useCloseAllOpenToggles() {
  var _useEmojiVariationPic = useEmojiVariationPickerState(),
    variationPicker = _useEmojiVariationPic[0],
    setVariationPicker = _useEmojiVariationPic[1];
  var _useSkinToneFanOpenSt = useSkinToneFanOpenState(),
    skinToneFanOpen = _useSkinToneFanOpenSt[0],
    setSkinToneFanOpen = _useSkinToneFanOpenSt[1];
  var closeAllOpenToggles = useCallback(function () {
    if (variationPicker) {
      setVariationPicker(null);
    }
    if (skinToneFanOpen) {
      setSkinToneFanOpen(false);
    }
  }, [variationPicker, skinToneFanOpen, setVariationPicker, setSkinToneFanOpen]);
  return closeAllOpenToggles;
}
function useHasOpenToggles() {
  var _useEmojiVariationPic2 = useEmojiVariationPickerState(),
    variationPicker = _useEmojiVariationPic2[0];
  var _useSkinToneFanOpenSt2 = useSkinToneFanOpenState(),
    skinToneFanOpen = _useSkinToneFanOpenSt2[0];
  return function hasOpenToggles() {
    return !!variationPicker || skinToneFanOpen;
  };
}
function useDisallowMouseMove() {
  var DisallowMouseRef = useDisallowMouseRef();
  return function disallowMouseMove() {
    DisallowMouseRef.current = true;
  };
}
function useAllowMouseMove() {
  var DisallowMouseRef = useDisallowMouseRef();
  return function allowMouseMove() {
    DisallowMouseRef.current = false;
  };
}
function useIsMouseDisallowed() {
  var DisallowMouseRef = useDisallowMouseRef();
  return function isMouseDisallowed() {
    return DisallowMouseRef.current;
  };
}
function useOnMouseMove() {
  var BodyRef = useBodyRef();
  var allowMouseMove = useAllowMouseMove();
  var isMouseDisallowed = useIsMouseDisallowed();
  useEffect(function () {
    var bodyRef = BodyRef.current;
    bodyRef == null ? void 0 : bodyRef.addEventListener('mousemove', onMouseMove, {
      passive: true
    });
    function onMouseMove() {
      if (isMouseDisallowed()) {
        allowMouseMove();
      }
    }
    return function () {
      bodyRef == null ? void 0 : bodyRef.removeEventListener('mousemove', onMouseMove);
    };
  }, [BodyRef, allowMouseMove, isMouseDisallowed]);
}
function useFocusSearchInput() {
  var SearchInputRef = useSearchInputRef();
  return useCallback(function () {
    focusElement(SearchInputRef.current);
  }, [SearchInputRef]);
}
function useFocusSkinTonePicker() {
  var SkinTonePickerRef = useSkinTonePickerRef();
  return useCallback(function () {
    if (!SkinTonePickerRef.current) {
      return;
    }
    focusFirstElementChild(SkinTonePickerRef.current);
  }, [SkinTonePickerRef]);
}
function useFocusCategoryNavigation() {
  var CategoryNavigationRef = useCategoryNavigationRef();
  return useCallback(function () {
    if (!CategoryNavigationRef.current) {
      return;
    }
    focusFirstElementChild(CategoryNavigationRef.current);
  }, [CategoryNavigationRef]);
}
function useSetFilterRef() {
  var filterRef = useFilterRef();
  return function setFilter(setter) {
    if (typeof setter === 'function') {
      return setFilter(setter(filterRef.current));
    }
    filterRef.current = setter;
  };
}
function useClearSearch() {
  var applySearch = useApplySearch();
  var SearchInputRef = useSearchInputRef();
  var focusSearchInput = useFocusSearchInput();
  return function clearSearch() {
    if (SearchInputRef.current) {
      SearchInputRef.current.value = '';
    }
    applySearch('');
    focusSearchInput();
  };
}
function useAppendSearch() {
  var SearchInputRef = useSearchInputRef();
  var applySearch = useApplySearch();
  return function appendSearch(str) {
    if (SearchInputRef.current) {
      SearchInputRef.current.value = "" + SearchInputRef.current.value + str;
      applySearch(getNormalizedSearchTerm(SearchInputRef.current.value));
    } else {
      applySearch(getNormalizedSearchTerm(str));
    }
  };
}
function useFilter() {
  var SearchInputRef = useSearchInputRef();
  var filterRef = useFilterRef();
  var setFilterRef = useSetFilterRef();
  var applySearch = useApplySearch();
  var _useSearchTermState = useSearchTermState(),
    searchTerm = _useSearchTermState[0];
  var statusSearchResults = getStatusSearchResults(filterRef.current, searchTerm);
  return {
    onChange: onChange,
    searchTerm: searchTerm,
    SearchInputRef: SearchInputRef,
    statusSearchResults: statusSearchResults
  };
  function onChange(inputValue) {
    var filter = filterRef.current;
    var nextValue = inputValue.toLowerCase();
    if (filter != null && filter[nextValue] || nextValue.length <= 1) {
      return applySearch(nextValue);
    }
    var longestMatch = findLongestMatch(nextValue, filter);
    if (!longestMatch) {
      // Can we even get here?
      // If so, we need to search among all emojis
      return applySearch(nextValue);
    }
    setFilterRef(function (current) {
      var _Object$assign;
      return Object.assign(current, (_Object$assign = {}, _Object$assign[nextValue] = filterEmojiObjectByKeyword(longestMatch, nextValue), _Object$assign));
    });
    applySearch(nextValue);
  }
}
function useApplySearch() {
  var _useSearchTermState2 = useSearchTermState(),
    setSearchTerm = _useSearchTermState2[1];
  var PickerMainRef = usePickerMainRef();
  return function applySearch(searchTerm) {
    requestAnimationFrame(function () {
      setSearchTerm(searchTerm ? searchTerm == null ? void 0 : searchTerm.toLowerCase() : searchTerm).then(function () {
        scrollTo(PickerMainRef.current, 0);
      });
    });
  };
}
function filterEmojiObjectByKeyword(emojis, keyword) {
  var filtered = {};
  for (var unified in emojis) {
    var emoji = emojis[unified];
    if (hasMatch(emoji, keyword)) {
      filtered[unified] = emoji;
    }
  }
  return filtered;
}
function hasMatch(emoji, keyword) {
  return emojiNames(emoji).some(function (name) {
    return name.includes(keyword);
  });
}
function useIsEmojiFiltered() {
  var _useFilterRef = useFilterRef(),
    filter = _useFilterRef.current;
  var _useSearchTermState3 = useSearchTermState(),
    searchTerm = _useSearchTermState3[0];
  return function (unified) {
    return isEmojiFilteredBySearchTerm(unified, filter, searchTerm);
  };
}
function isEmojiFilteredBySearchTerm(unified, filter, searchTerm) {
  var _filter$searchTerm;
  if (!filter || !searchTerm) {
    return false;
  }
  return !((_filter$searchTerm = filter[searchTerm]) != null && _filter$searchTerm[unified]);
}
function findLongestMatch(keyword, dict) {
  if (!dict) {
    return null;
  }
  if (dict[keyword]) {
    return dict[keyword];
  }
  var longestMatchingKey = Object.keys(dict).sort(function (a, b) {
    return b.length - a.length;
  }).find(function (key) {
    return keyword.includes(key);
  });
  if (longestMatchingKey) {
    return dict[longestMatchingKey];
  }
  return null;
}
function getNormalizedSearchTerm(str) {
  if (!str || typeof str !== 'string') {
    return '';
  }
  return str.trim().toLowerCase();
}
function getStatusSearchResults(filterState, searchTerm) {
  var _Object$entries;
  if (!(filterState != null && filterState[searchTerm])) return '';
  var searchResultsCount = ((_Object$entries = Object.entries(filterState == null ? void 0 : filterState[searchTerm])) == null ? void 0 : _Object$entries.length) || 0;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useSearchResultsConfig(searchResultsCount);
}
function useSetVariationPicker() {
  var setAnchoredEmojiRef = useSetAnchoredEmojiRef();
  var _useEmojiVariationPic = useEmojiVariationPickerState(),
    setEmojiVariationPicker = _useEmojiVariationPic[1];
  return function setVariationPicker(element) {
    var _emojiFromElement = emojiFromElement(element),
      emoji = _emojiFromElement[0];
    if (emoji) {
      setAnchoredEmojiRef(element);
      setEmojiVariationPicker(emoji);
    }
  };
}
function useIsSkinToneInSearch() {
  var skinTonePickerLocationConfig = useSkinTonePickerLocationConfig();
  return skinTonePickerLocationConfig === SkinTonePickerLocation.SEARCH;
}
function useIsSkinToneInPreview() {
  var skinTonePickerLocationConfig = useSkinTonePickerLocationConfig();
  return skinTonePickerLocationConfig === SkinTonePickerLocation.PREVIEW;
}
var KeyboardEvents;
(function (KeyboardEvents) {
  KeyboardEvents["ArrowDown"] = "ArrowDown";
  KeyboardEvents["ArrowUp"] = "ArrowUp";
  KeyboardEvents["ArrowLeft"] = "ArrowLeft";
  KeyboardEvents["ArrowRight"] = "ArrowRight";
  KeyboardEvents["Escape"] = "Escape";
  KeyboardEvents["Enter"] = "Enter";
  KeyboardEvents["Space"] = " ";
})(KeyboardEvents || (KeyboardEvents = {}));
function useKeyboardNavigation() {
  usePickerMainKeyboardEvents();
  useSearchInputKeyboardEvents();
  useSkinTonePickerKeyboardEvents();
  useCategoryNavigationKeyboardEvents();
  useBodyKeyboardEvents();
}
function usePickerMainKeyboardEvents() {
  var PickerMainRef = usePickerMainRef();
  var clearSearch = useClearSearch();
  var scrollTo = useScrollTo();
  var SearchInputRef = useSearchInputRef();
  var focusSearchInput = useFocusSearchInput();
  var hasOpenToggles = useHasOpenToggles();
  var disallowMouseMove = useDisallowMouseMove();
  var closeAllOpenToggles = useCloseAllOpenToggles();
  var onKeyDown = useMemo(function () {
    return function onKeyDown(event) {
      var key = event.key;
      disallowMouseMove();
      switch (key) {
        // eslint-disable-next-line no-fallthrough
        case KeyboardEvents.Escape:
          event.preventDefault();
          if (hasOpenToggles()) {
            closeAllOpenToggles();
            return;
          }
          clearSearch();
          scrollTo(0);
          focusSearchInput();
          break;
      }
    };
  }, [scrollTo, clearSearch, closeAllOpenToggles, focusSearchInput, hasOpenToggles, disallowMouseMove]);
  useEffect(function () {
    var current = PickerMainRef.current;
    if (!current) {
      return;
    }
    current.addEventListener('keydown', onKeyDown);
    return function () {
      current.removeEventListener('keydown', onKeyDown);
    };
  }, [PickerMainRef, SearchInputRef, scrollTo, onKeyDown]);
}
function useSearchInputKeyboardEvents() {
  var focusSkinTonePicker = useFocusSkinTonePicker();
  var PickerMainRef = usePickerMainRef();
  var BodyRef = useBodyRef();
  var SearchInputRef = useSearchInputRef();
  var _useSkinToneFanOpenSt = useSkinToneFanOpenState(),
    setSkinToneFanOpenState = _useSkinToneFanOpenSt[1];
  var goDownFromSearchInput = useGoDownFromSearchInput();
  var isSkinToneInSearch = useIsSkinToneInSearch();
  var onKeyDown = useMemo(function () {
    return function onKeyDown(event) {
      var key = event.key;
      switch (key) {
        case KeyboardEvents.ArrowRight:
          if (!isSkinToneInSearch) {
            return;
          }
          event.preventDefault();
          setSkinToneFanOpenState(true);
          focusSkinTonePicker();
          break;
        case KeyboardEvents.ArrowDown:
          event.preventDefault();
          goDownFromSearchInput();
          break;
        case KeyboardEvents.Enter:
          event.preventDefault();
          focusAndClickFirstVisibleEmoji(BodyRef.current);
          break;
      }
    };
  }, [focusSkinTonePicker, goDownFromSearchInput, setSkinToneFanOpenState, BodyRef, isSkinToneInSearch]);
  useEffect(function () {
    var current = SearchInputRef.current;
    if (!current) {
      return;
    }
    current.addEventListener('keydown', onKeyDown);
    return function () {
      current.removeEventListener('keydown', onKeyDown);
    };
  }, [PickerMainRef, SearchInputRef, onKeyDown]);
}
function useSkinTonePickerKeyboardEvents() {
  var SkinTonePickerRef = useSkinTonePickerRef();
  var focusSearchInput = useFocusSearchInput();
  var SearchInputRef = useSearchInputRef();
  var goDownFromSearchInput = useGoDownFromSearchInput();
  var _useSkinToneFanOpenSt2 = useSkinToneFanOpenState(),
    isOpen = _useSkinToneFanOpenSt2[0],
    setIsOpen = _useSkinToneFanOpenSt2[1];
  var isSkinToneInPreview = useIsSkinToneInPreview();
  var isSkinToneInSearch = useIsSkinToneInSearch();
  var onType = useOnType();
  var onKeyDown = useMemo(function () {
    return (
      // eslint-disable-next-line complexity
      function onKeyDown(event) {
        var key = event.key;
        if (isSkinToneInSearch) {
          switch (key) {
            case KeyboardEvents.ArrowLeft:
              event.preventDefault();
              if (!isOpen) {
                return focusSearchInput();
              }
              focusNextSkinTone(focusSearchInput);
              break;
            case KeyboardEvents.ArrowRight:
              event.preventDefault();
              if (!isOpen) {
                return focusSearchInput();
              }
              focusPrevSkinTone();
              break;
            case KeyboardEvents.ArrowDown:
              event.preventDefault();
              if (isOpen) {
                setIsOpen(false);
              }
              goDownFromSearchInput();
              break;
            default:
              onType(event);
              break;
          }
        }
        if (isSkinToneInPreview) {
          switch (key) {
            case KeyboardEvents.ArrowUp:
              event.preventDefault();
              if (!isOpen) {
                return focusSearchInput();
              }
              focusNextSkinTone(focusSearchInput);
              break;
            case KeyboardEvents.ArrowDown:
              event.preventDefault();
              if (!isOpen) {
                return focusSearchInput();
              }
              focusPrevSkinTone();
              break;
            default:
              onType(event);
              break;
          }
        }
      }
    );
  }, [isOpen, focusSearchInput, setIsOpen, goDownFromSearchInput, onType, isSkinToneInPreview, isSkinToneInSearch]);
  useEffect(function () {
    var current = SkinTonePickerRef.current;
    if (!current) {
      return;
    }
    current.addEventListener('keydown', onKeyDown);
    return function () {
      current.removeEventListener('keydown', onKeyDown);
    };
  }, [SkinTonePickerRef, SearchInputRef, isOpen, onKeyDown]);
}
function useCategoryNavigationKeyboardEvents() {
  var focusSearchInput = useFocusSearchInput();
  var CategoryNavigationRef = useCategoryNavigationRef();
  var BodyRef = useBodyRef();
  var onType = useOnType();
  var onKeyDown = useMemo(function () {
    return function onKeyDown(event) {
      var key = event.key;
      switch (key) {
        case KeyboardEvents.ArrowUp:
          event.preventDefault();
          focusSearchInput();
          break;
        case KeyboardEvents.ArrowRight:
          event.preventDefault();
          focusNextElementSibling(getActiveElement());
          break;
        case KeyboardEvents.ArrowLeft:
          event.preventDefault();
          focusPrevElementSibling(getActiveElement());
          break;
        case KeyboardEvents.ArrowDown:
          event.preventDefault();
          focusFirstVisibleEmoji(BodyRef.current);
          break;
        default:
          onType(event);
          break;
      }
    };
  }, [BodyRef, focusSearchInput, onType]);
  useEffect(function () {
    var current = CategoryNavigationRef.current;
    if (!current) {
      return;
    }
    current.addEventListener('keydown', onKeyDown);
    return function () {
      current.removeEventListener('keydown', onKeyDown);
    };
  }, [CategoryNavigationRef, BodyRef, onKeyDown]);
}
function useBodyKeyboardEvents() {
  var BodyRef = useBodyRef();
  var goUpFromBody = useGoUpFromBody();
  var setVariationPicker = useSetVariationPicker();
  var hasOpenToggles = useHasOpenToggles();
  var closeAllOpenToggles = useCloseAllOpenToggles();
  var onType = useOnType();
  var onKeyDown = useMemo(function () {
    return (
      // eslint-disable-next-line complexity
      function onKeyDown(event) {
        var key = event.key;
        var activeElement = buttonFromTarget(getActiveElement());
        switch (key) {
          case KeyboardEvents.ArrowRight:
            event.preventDefault();
            focusNextVisibleEmoji(activeElement);
            break;
          case KeyboardEvents.ArrowLeft:
            event.preventDefault();
            focusPrevVisibleEmoji(activeElement);
            break;
          case KeyboardEvents.ArrowDown:
            event.preventDefault();
            if (hasOpenToggles()) {
              closeAllOpenToggles();
              break;
            }
            focusVisibleEmojiOneRowDown(activeElement);
            break;
          case KeyboardEvents.ArrowUp:
            event.preventDefault();
            if (hasOpenToggles()) {
              closeAllOpenToggles();
              break;
            }
            focusVisibleEmojiOneRowUp(activeElement, goUpFromBody);
            break;
          case KeyboardEvents.Space:
            event.preventDefault();
            setVariationPicker(event.target);
            break;
          default:
            onType(event);
            break;
        }
      }
    );
  }, [goUpFromBody, onType, setVariationPicker, hasOpenToggles, closeAllOpenToggles]);
  useEffect(function () {
    var current = BodyRef.current;
    if (!current) {
      return;
    }
    current.addEventListener('keydown', onKeyDown);
    return function () {
      current.removeEventListener('keydown', onKeyDown);
    };
  }, [BodyRef, onKeyDown]);
}
function useGoDownFromSearchInput() {
  var focusCategoryNavigation = useFocusCategoryNavigation();
  var isSearchMode = useIsSearchMode();
  var BodyRef = useBodyRef();
  return useCallback(function goDownFromSearchInput() {
    if (isSearchMode) {
      return focusFirstVisibleEmoji(BodyRef.current);
    }
    return focusCategoryNavigation();
  }, [BodyRef, focusCategoryNavigation, isSearchMode]);
}
function useGoUpFromBody() {
  var focusSearchInput = useFocusSearchInput();
  var focusCategoryNavigation = useFocusCategoryNavigation();
  var isSearchMode = useIsSearchMode();
  return useCallback(function goUpFromEmoji() {
    if (isSearchMode) {
      return focusSearchInput();
    }
    return focusCategoryNavigation();
  }, [focusSearchInput, isSearchMode, focusCategoryNavigation]);
}
function focusNextSkinTone(exitLeft) {
  var currentSkinTone = getActiveElement();
  if (!currentSkinTone) {
    return;
  }
  if (!hasNextElementSibling(currentSkinTone)) {
    exitLeft();
  }
  focusNextElementSibling(currentSkinTone);
}
function focusPrevSkinTone() {
  var currentSkinTone = getActiveElement();
  if (!currentSkinTone) {
    return;
  }
  focusPrevElementSibling(currentSkinTone);
}
function useOnType() {
  var appendSearch = useAppendSearch();
  var focusSearchInput = useFocusSearchInput();
  var searchDisabled = useSearchDisabledConfig();
  var closeAllOpenToggles = useCloseAllOpenToggles();
  return function onType(event) {
    var key = event.key;
    if (hasModifier(event) || searchDisabled) {
      return;
    }
    if (key.match(/(^[a-zA-Z0-9]$){1}/)) {
      event.preventDefault();
      closeAllOpenToggles();
      focusSearchInput();
      appendSearch(key);
    }
  };
}
function hasModifier(event) {
  var metaKey = event.metaKey,
    ctrlKey = event.ctrlKey,
    altKey = event.altKey;
  return metaKey || ctrlKey || altKey;
}

// eslint-disable-next-line max-params
function preloadEmojiIfNeeded(emoji, emojiStyles, scrollTop, clientHeight, topOffset, style, dimensions, getEmojiUrl) {
  if (!emoji) {
    return;
  }
  if (emojiStyles === EmojiStyle.NATIVE) {
    return;
  }
  var unified = emojiUnified(emoji);
  if (preloadedEmojs.has(unified)) {
    return;
  }
  // preload only if the emoji is a few rows below the viewport
  if (!style || !dimensions) {
    return;
  }
  setTimeout(function () {
    var emojiTop = topOffset + style.top;
    var viewportBottom = scrollTop + clientHeight;
    var isJustBelowViewport = emojiTop >= viewportBottom && emojiTop < viewportBottom + dimensions.emojiSize * 2;
    if (isJustBelowViewport) {
      preloadEmoji(getEmojiUrl, emoji, emojiStyles);
    }
  });
}
function preloadEmoji(getEmojiUrl, emoji, emojiStyle) {
  if (!emoji) {
    return;
  }
  var unified = emojiUnified(emoji);
  if (preloadedEmojs.has(unified)) {
    return;
  }
  preloadedEmojs.add(unified);
  emojiVariations(emoji).concat(unified).forEach(function (variation) {
    var emojiUrl = getEmojiUrl(variation, emojiStyle);
    preloadImage(emojiUrl);
  });
}
var preloadedEmojs = /*#__PURE__*/new Set();
function preloadImage(url) {
  var image = new Image();
  image.src = url;
}
function useOnFocus() {
  var BodyRef = useBodyRef();
  var emojiStyle = useEmojiStyleConfig();
  var getEmojiUrl = useGetEmojiUrlConfig();
  useEffect(function () {
    if (emojiStyle === EmojiStyle.NATIVE) {
      return;
    }
    var bodyRef = BodyRef.current;
    bodyRef == null ? void 0 : bodyRef.addEventListener('focusin', onFocus);
    return function () {
      bodyRef == null ? void 0 : bodyRef.removeEventListener('focusin', onFocus);
    };
    function onFocus(event) {
      var button = buttonFromTarget(event.target);
      if (!button) {
        return;
      }
      var _emojiFromElement = emojiFromElement(button),
        emoji = _emojiFromElement[0];
      if (!emoji) {
        return;
      }
      if (emojiHasVariations$1(emoji)) {
        preloadEmoji(getEmojiUrl, emoji, emojiStyle);
      }
    }
  }, [BodyRef, emojiStyle, getEmojiUrl]);
}
var _excluded$1 = ["width", "height"];
var DEFAULT_LABEL_HEIGHT = 40;
function PickerMain(_ref) {
  var children = _ref.children;
  return createElement(PickerContextProvider, null, createElement(PickerRootElement, null, children));
}
function PickerRootElement(_ref2) {
  var _cx;
  var children = _ref2.children;
  var _useReactionsModeStat = useReactionsModeState(),
    reactionsMode = _useReactionsModeStat[0];
  var theme = useThemeConfig();
  var searchModeActive = useIsSearchMode();
  var PickerMainRef = usePickerMainRef();
  var className = useClassNameConfig();
  var style = useStyleConfig();
  useKeyboardNavigation();
  useOnFocus();
  var _ref3 = style || {},
    width = _ref3.width,
    height = _ref3.height,
    styleProps = _objectWithoutPropertiesLoose(_ref3, _excluded$1);
  return createElement("aside", {
    className: cx(styles$5.main, styles$5.baseVariables, theme === Theme.DARK && styles$5.darkTheme, theme === Theme.AUTO && styles$5.autoThemeDark, (_cx = {}, _cx[ClassNames.searchActive] = searchModeActive, _cx), reactionsMode && styles$5.reactionsMenu, className),
    ref: PickerMainRef,
    style: _extends({}, styleProps, !reactionsMode && {
      height: height,
      width: width
    })
  }, children);
}
var DarkTheme = {
  '--epr-emoji-variation-picker-bg-color': 'var(--epr-dark-emoji-variation-picker-bg-color)',
  '--epr-hover-bg-color-reduced-opacity': 'var(--epr-dark-hover-bg-color-reduced-opacity)',
  '--epr-highlight-color': 'var(--epr-dark-highlight-color)',
  '--epr-text-color': 'var(--epr-dark-text-color)',
  '--epr-hover-bg-color': 'var(--epr-dark-hover-bg-color)',
  '--epr-focus-bg-color': 'var(--epr-dark-focus-bg-color)',
  '--epr-search-input-bg-color': 'var(--epr-dark-search-input-bg-color)',
  '--epr-category-label-bg-color': 'var(--epr-dark-category-label-bg-color)',
  '--epr-picker-border-color': 'var(--epr-dark-picker-border-color)',
  '--epr-bg-color': 'var(--epr-dark-bg-color)',
  '--epr-reactions-bg-color': 'var(--epr-dark-reactions-bg-color)',
  '--epr-search-input-bg-color-active': 'var(--epr-dark-search-input-bg-color-active)',
  '--epr-emoji-variation-indicator-color': 'var(--epr-dark-emoji-variation-indicator-color)',
  '--epr-category-icon-active-color': 'var(--epr-dark-category-icon-active-color)',
  '--epr-skin-tone-picker-menu-color': 'var(--epr-dark-skin-tone-picker-menu-color)',
  '--epr-skin-tone-outer-border-color': 'var(--epr-dark-skin-tone-outer-border-color)',
  '--epr-skin-tone-inner-border-color': 'var(--epr-dark-skin-tone-inner-border-color)'
};
var styles$5 = /*#__PURE__*/stylesheet.create({
  main: {
    '.': ['epr-main', ClassNames.emojiPicker],
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: 'var(--epr-picker-border-radius)',
    borderColor: 'var(--epr-picker-border-color)',
    backgroundColor: 'var(--epr-bg-color)',
    overflow: 'hidden',
    transition: 'height 0.3s ease-in-out, background-color 0.1s ease-in-out',
    '*': {
      boxSizing: 'border-box',
      fontFamily: 'sans-serif'
    }
  },
  baseVariables: {
    '--': {
      '--epr-highlight-color': '#007aeb',
      '--epr-hover-bg-color': '#e5f0fa',
      '--epr-hover-bg-color-reduced-opacity': '#e5f0fa80',
      '--epr-focus-bg-color': '#e0f0ff',
      '--epr-text-color': '#858585',
      '--epr-search-input-bg-color': '#f6f6f6',
      '--epr-picker-border-color': '#e7e7e7',
      '--epr-bg-color': '#fff',
      '--epr-reactions-bg-color': '#ffffff90',
      '--epr-category-icon-active-color': '#6aa8de',
      '--epr-skin-tone-picker-menu-color': '#ffffff95',
      '--epr-skin-tone-outer-border-color': '#555555',
      '--epr-skin-tone-inner-border-color': 'var(--epr-bg-color)',
      '--epr-horizontal-padding': '10px',
      '--epr-picker-border-radius': '8px',
      /* Header */
      '--epr-header-padding': '15px var(--epr-horizontal-padding)',
      /* Skin Tone Picker */
      '--epr-active-skin-tone-indicator-border-color': 'var(--epr-highlight-color)',
      '--epr-active-skin-hover-color': 'var(--epr-hover-bg-color)',
      /* Search */
      '--epr-search-input-bg-color-active': 'var(--epr-search-input-bg-color)',
      '--epr-search-input-padding': '0 30px',
      '--epr-search-input-border-radius': '8px',
      '--epr-search-input-height': '40px',
      '--epr-search-input-text-color': 'var(--epr-text-color)',
      '--epr-search-input-placeholder-color': 'var(--epr-text-color)',
      '--epr-search-bar-inner-padding': 'var(--epr-horizontal-padding)',
      '--epr-search-border-color': 'var(--epr-search-input-bg-color)',
      '--epr-search-border-color-active': 'var(--epr-highlight-color)',
      /*  Category Navigation */
      '--epr-category-navigation-button-size': '30px',
      /* Variation Picker */
      '--epr-emoji-variation-picker-height': '45px',
      '--epr-emoji-variation-picker-bg-color': 'var(--epr-bg-color)',
      /*  Preview */
      '--epr-preview-height': '70px',
      '--epr-preview-text-size': '14px',
      '--epr-preview-text-padding': '0 var(--epr-horizontal-padding)',
      '--epr-preview-border-color': 'var(--epr-picker-border-color)',
      '--epr-preview-text-color': 'var(--epr-text-color)',
      /* Category */
      '--epr-category-padding': '0 var(--epr-horizontal-padding)',
      /*  Category Label */
      '--epr-category-label-bg-color': '#ffffffe6',
      '--epr-category-label-text-color': 'var(--epr-text-color)',
      '--epr-category-label-padding': '0 var(--epr-horizontal-padding)',
      '--epr-category-label-height': DEFAULT_LABEL_HEIGHT + "px",
      /*  Emoji */
      '--epr-emoji-size': '30px',
      '--epr-emoji-padding': '5px',
      '--epr-emoji-fullsize': 'calc(var(--epr-emoji-size) + var(--epr-emoji-padding) * 2)',
      '--epr-emoji-hover-color': 'var(--epr-hover-bg-color)',
      '--epr-emoji-variation-indicator-color': 'var(--epr-picker-border-color)',
      '--epr-emoji-variation-indicator-color-hover': 'var(--epr-text-color)',
      /* Z-Index */
      '--epr-header-overlay-z-index': '3',
      '--epr-emoji-variations-indictator-z-index': '1',
      '--epr-category-label-z-index': '2',
      '--epr-skin-variation-picker-z-index': '5',
      '--epr-preview-z-index': '6',
      /* Dark Theme Variables */
      '--epr-dark': '#000',
      '--epr-dark-emoji-variation-picker-bg-color': 'var(--epr-dark)',
      '--epr-dark-highlight-color': '#c0c0c0',
      '--epr-dark-text-color': 'var(--epr-highlight-color)',
      '--epr-dark-hover-bg-color': '#363636f6',
      '--epr-dark-hover-bg-color-reduced-opacity': '#36363680',
      '--epr-dark-focus-bg-color': '#474747',
      '--epr-dark-search-input-bg-color': '#333333',
      '--epr-dark-category-label-bg-color': '#222222e6',
      '--epr-dark-picker-border-color': '#151617',
      '--epr-dark-bg-color': '#222222',
      '--epr-dark-reactions-bg-color': '#22222290',
      '--epr-dark-search-input-bg-color-active': 'var(--epr-dark)',
      '--epr-dark-emoji-variation-indicator-color': '#444',
      '--epr-dark-category-icon-active-color': '#3271b7',
      '--epr-dark-skin-tone-picker-menu-color': '#22222295',
      '--epr-dark-skin-tone-outer-border-color': 'var(--epr-dark-picker-border-color)',
      '--epr-dark-skin-tone-inner-border-color': '#00000000'
    }
  },
  autoThemeDark: {
    '.': ClassNames.autoTheme,
    '@media (prefers-color-scheme: dark)': {
      '--': DarkTheme
    }
  },
  darkTheme: {
    '.': ClassNames.darkTheme,
    '--': DarkTheme
  },
  reactionsMenu: {
    '.': 'epr-reactions',
    height: '50px',
    display: 'inline-flex',
    backgroundColor: 'var(--epr-reactions-bg-color)',
    // @ts-ignore - backdropFilter is not recognized.
    backdropFilter: 'blur(8px)',
    '--': {
      '--epr-picker-border-radius': '50px'
    }
  }
});
function elementCountInRow(parent, element) {
  if (!parent || !element) {
    return 0;
  }
  var parentWidth = parent.getBoundingClientRect().width;
  var elementWidth = element.getBoundingClientRect().width;
  return Math.floor(parentWidth / elementWidth);
}
function firstVisibleElementInContainer(parent, elements, maxVisibilityDiffThreshold) {
  if (maxVisibilityDiffThreshold === void 0) {
    maxVisibilityDiffThreshold = 0;
  }
  if (!parent || !elements.length) {
    return null;
  }
  var parentTop = parent.getBoundingClientRect().top;
  var parentBottom = parent.getBoundingClientRect().bottom;
  var parentTopWithLabel = parentTop + getLabelHeight(parent);
  var visibleElements = elements.find(function (element) {
    var elementTop = element.getBoundingClientRect().top;
    var elementBottom = element.getBoundingClientRect().bottom;
    var maxVisibilityDiffPixels = element.clientHeight * maxVisibilityDiffThreshold;
    var elementTopWithAllowedDiff = elementTop + maxVisibilityDiffPixels;
    var elementBottomWithAllowedDiff = elementBottom - maxVisibilityDiffPixels;
    if (elementTopWithAllowedDiff < parentTopWithLabel) {
      return false;
    }
    return elementTopWithAllowedDiff >= parentTop && elementTopWithAllowedDiff <= parentBottom || elementBottomWithAllowedDiff >= parentTop && elementBottomWithAllowedDiff <= parentBottom;
  });
  return visibleElements || null;
}
function hasNextElementSibling(element) {
  return !!element.nextElementSibling;
}
function getLabelHeight(parentNode) {
  if (!parentNode) {
    return DEFAULT_LABEL_HEIGHT;
  }
  var label = parentNode.querySelector(asSelectors(ClassNames.label));
  if (label) {
    var height = label.getBoundingClientRect().height;
    if (height > 0) {
      return height;
    }
  }
  // fallback to default
  return DEFAULT_LABEL_HEIGHT;
}
var EmojiButtonSelector = "button" + /*#__PURE__*/asSelectors(ClassNames.emoji);
var VisibleEmojiSelector = /*#__PURE__*/[EmojiButtonSelector, asSelectors(ClassNames.visible), ":not(" + asSelectors(ClassNames.hidden) + ")"].join('');
function buttonFromTarget(emojiElement) {
  var _emojiElement$closest;
  return (_emojiElement$closest = emojiElement == null ? void 0 : emojiElement.closest(EmojiButtonSelector)) != null ? _emojiElement$closest : null;
}
function emojiFromElement(element) {
  var originalUnified = originalUnifiedFromEmojiElement(element);
  var unified = unifiedFromEmojiElement(element);
  if (!originalUnified) {
    return [];
  }
  var emoji = emojiByUnified(unified != null ? unified : originalUnified);
  if (!emoji) {
    return [];
  }
  return [emoji, unified];
}
function isEmojiElement(element) {
  var _element$parentElemen;
  return Boolean((element == null ? void 0 : element.matches(EmojiButtonSelector)) || (element == null ? void 0 : (_element$parentElemen = element.parentElement) == null ? void 0 : _element$parentElemen.matches(EmojiButtonSelector)));
}
function elementHeight(element) {
  var _element$clientHeight;
  return (_element$clientHeight = element == null ? void 0 : element.clientHeight) != null ? _element$clientHeight : 0;
}
function emojiTrueOffsetTop(element) {
  if (!element) {
    return 0;
  }
  var button = buttonFromTarget(element);
  var category = closestCategory(button);
  // compensate for the label height
  var labelHeight = categoryLabelHeight(category);
  return elementOffsetTop(button) + elementOffsetTop(category) + labelHeight;
}
function categoryLabelHeight(category) {
  var _category$clientHeigh, _categoryWithoutLabel;
  if (!category) {
    return 0;
  }
  var categoryWithoutLabel = category.querySelector(asSelectors(ClassNames.categoryContent));
  return ((_category$clientHeigh = category == null ? void 0 : category.clientHeight) != null ? _category$clientHeigh : 0) - ((_categoryWithoutLabel = categoryWithoutLabel == null ? void 0 : categoryWithoutLabel.clientHeight) != null ? _categoryWithoutLabel : 0);
}
function isEmojiBehindLabel(emoji) {
  if (!emoji) {
    return false;
  }
  return emojiDistanceFromScrollTop(emoji) < categoryLabelHeight(closestCategory(emoji));
}
function queryScrollBody(root) {
  if (!root) return null;
  return root.matches(asSelectors(ClassNames.scrollBody)) ? root : root.querySelector(asSelectors(ClassNames.scrollBody));
}
function emojiDistanceFromScrollTop(emoji) {
  var _closestScrollBody$sc, _closestScrollBody;
  if (!emoji) {
    return 0;
  }
  return emojiTrueOffsetTop(emoji) - ((_closestScrollBody$sc = (_closestScrollBody = closestScrollBody(emoji)) == null ? void 0 : _closestScrollBody.scrollTop) != null ? _closestScrollBody$sc : 0);
}
function closestScrollBody(element) {
  var _element$closest;
  if (!element) {
    return null;
  }
  return (_element$closest = element.closest(asSelectors(ClassNames.scrollBody))) != null ? _element$closest : null;
}
function emojiTruOffsetLeft(element) {
  var button = buttonFromTarget(element);
  var category = closestCategory(button);
  return elementOffsetLeft(button) + elementOffsetLeft(category);
}
function elementOffsetTop(element) {
  var _element$offsetTop;
  return (_element$offsetTop = element == null ? void 0 : element.offsetTop) != null ? _element$offsetTop : 0;
}
function elementOffsetLeft(element) {
  var _element$offsetLeft;
  return (_element$offsetLeft = element == null ? void 0 : element.offsetLeft) != null ? _element$offsetLeft : 0;
}
function unifiedFromEmojiElement(emoji) {
  var _elementDataSetKey;
  return (_elementDataSetKey = elementDataSetKey(buttonFromTarget(emoji), 'unified')) != null ? _elementDataSetKey : null;
}
function originalUnifiedFromEmojiElement(emoji) {
  var unified = unifiedFromEmojiElement(emoji);
  if (unified) {
    return unifiedWithoutSkinTone$1(unified);
  }
  return null;
}
function allUnifiedFromEmojiElement(emoji) {
  if (!emoji) {
    return {
      unified: null,
      originalUnified: null
    };
  }
  return {
    unified: unifiedFromEmojiElement(emoji),
    originalUnified: originalUnifiedFromEmojiElement(emoji)
  };
}
function elementDataSetKey(element, key) {
  var _elementDataSet$key;
  return (_elementDataSet$key = elementDataSet(element)[key]) != null ? _elementDataSet$key : null;
}
function elementDataSet(element) {
  var _element$dataset;
  return (_element$dataset = element == null ? void 0 : element.dataset) != null ? _element$dataset : {};
}
function isVisibleEmoji(element) {
  return element.classList.contains(ClassNames.visible);
}
function isHidden(element) {
  if (!element) return true;
  return element.classList.contains(ClassNames.hidden);
}
function allVisibleEmojis(parent) {
  if (!parent) {
    return [];
  }
  return Array.from(parent.querySelectorAll(VisibleEmojiSelector));
}
function lastVisibleEmoji(element) {
  if (!element) return null;
  var allEmojis = allVisibleEmojis(element);
  var _allEmojis$slice = allEmojis.slice(-1),
    last = _allEmojis$slice[0];
  if (!last) {
    return null;
  }
  if (!isVisibleEmoji(last)) {
    return prevVisibleEmoji(last);
  }
  return last;
}
function nextVisibleEmoji(element) {
  var next = element.nextElementSibling;
  if (!next) {
    return firstVisibleEmoji(nextCategory(element));
  }
  if (!isVisibleEmoji(next)) {
    return nextVisibleEmoji(next);
  }
  return next;
}
function prevVisibleEmoji(element) {
  var prev = element.previousElementSibling;
  if (!prev) {
    return lastVisibleEmoji(prevCategory(element));
  }
  if (!isVisibleEmoji(prev)) {
    return prevVisibleEmoji(prev);
  }
  return prev;
}
function firstVisibleEmoji(parent) {
  if (!parent) {
    return null;
  }
  var allEmojis = allVisibleEmojis(parent);
  return firstVisibleElementInContainer(parent, allEmojis, 0.1);
}
function prevCategory(element) {
  var category = closestCategory(element);
  if (!category) {
    return null;
  }
  var prev = category.previousElementSibling;
  if (!prev) {
    return null;
  }
  if (isHidden(prev)) {
    return prevCategory(prev);
  }
  return prev;
}
function nextCategory(element) {
  var category = closestCategory(element);
  if (!category) {
    return null;
  }
  var next = category.nextElementSibling;
  if (!next) {
    return null;
  }
  if (isHidden(next)) {
    return nextCategory(next);
  }
  return next;
}
function closestCategory(element) {
  if (!element) {
    return null;
  }
  return element.closest(asSelectors(ClassNames.category));
}
function closestCategoryContent(element) {
  if (!element) {
    return null;
  }
  return element.closest(asSelectors(ClassNames.categoryContent));
}
function parseNativeEmoji(unified) {
  return unified.split('-').map(function (hex) {
    return String.fromCodePoint(parseInt(hex, 16));
  }).join('');
}
function isCustomCategory(category) {
  return category.category === Categories.CUSTOM;
}
function isCustomEmoji(emoji) {
  return emoji.imgUrl !== undefined;
}
function useMouseDownHandlers(ContainerRef, mouseEventSource) {
  var mouseDownTimerRef = useRef();
  var setVariationPicker = useSetVariationPicker();
  var disallowClickRef = useDisallowClickRef();
  var _useEmojiVariationPic = useEmojiVariationPickerState(),
    setEmojiVariationPicker = _useEmojiVariationPic[1];
  var closeAllOpenToggles = useCloseAllOpenToggles();
  var _useActiveSkinToneSta = useActiveSkinToneState(),
    activeSkinTone = _useActiveSkinToneSta[0];
  var onEmojiClick = useOnEmojiClickConfig(mouseEventSource);
  var _useUpdateSuggested = useUpdateSuggested(),
    updateSuggested = _useUpdateSuggested[1];
  var getEmojiUrl = useGetEmojiUrlConfig();
  var activeEmojiStyle = useEmojiStyleConfig();
  var _usePickerDataContext = usePickerDataContext(),
    emojiByUnified = _usePickerDataContext.emojiByUnified;
  var onClick = useCallback(function onClick(event) {
    if (disallowClickRef.current) {
      return;
    }
    closeAllOpenToggles();
    var _emojiFromEvent = emojiFromEvent(event, emojiByUnified),
      emoji = _emojiFromEvent[0],
      unified = _emojiFromEvent[1];
    if (!emoji || !unified) {
      return;
    }
    var skinToneToUse = activeVariationFromUnified$1(unified) || activeSkinTone;
    updateSuggested();
    setSuggested(emoji, skinToneToUse);
    onEmojiClick(emojiClickOutput(emoji, skinToneToUse, activeEmojiStyle, getEmojiUrl), event);
  }, [activeSkinTone, closeAllOpenToggles, disallowClickRef, emojiByUnified, onEmojiClick, updateSuggested, getEmojiUrl, activeEmojiStyle]);
  var onMouseDown = useCallback(function onMouseDown(event) {
    var _window;
    if (mouseDownTimerRef.current) {
      clearTimeout(mouseDownTimerRef.current);
    }
    var _emojiFromEvent2 = emojiFromEvent(event, emojiByUnified),
      emoji = _emojiFromEvent2[0];
    if (!emoji || !emojiHasVariations$1(emoji)) {
      return;
    }
    mouseDownTimerRef.current = (_window = window) == null ? void 0 : _window.setTimeout(function () {
      disallowClickRef.current = true;
      mouseDownTimerRef.current = undefined;
      closeAllOpenToggles();
      setVariationPicker(event.target);
      setEmojiVariationPicker(emoji);
    }, 500);
  }, [disallowClickRef, emojiByUnified, closeAllOpenToggles, setVariationPicker, setEmojiVariationPicker]);
  var onMouseUp = useCallback(function onMouseUp() {
    if (mouseDownTimerRef.current) {
      clearTimeout(mouseDownTimerRef.current);
      mouseDownTimerRef.current = undefined;
    } else if (disallowClickRef.current) {
      // The problem we're trying to overcome here
      // is that the emoji has both mouseup and click events
      // and when releasing a mouseup event
      // the click gets triggered too
      // So we're disallowing the click event for a short time
      requestAnimationFrame(function () {
        disallowClickRef.current = false;
      });
    }
  }, [disallowClickRef]);
  useEffect(function () {
    if (!ContainerRef.current) {
      return;
    }
    var confainerRef = ContainerRef.current;
    confainerRef.addEventListener('click', onClick, {
      passive: true
    });
    confainerRef.addEventListener('mousedown', onMouseDown, {
      passive: true
    });
    confainerRef.addEventListener('mouseup', onMouseUp, {
      passive: true
    });
    return function () {
      confainerRef == null ? void 0 : confainerRef.removeEventListener('click', onClick);
      confainerRef == null ? void 0 : confainerRef.removeEventListener('mousedown', onMouseDown);
      confainerRef == null ? void 0 : confainerRef.removeEventListener('mouseup', onMouseUp);
    };
  }, [ContainerRef, onClick, onMouseDown, onMouseUp]);
}
function emojiFromEvent(event, lookupEmojiByUnified) {
  var target = event == null ? void 0 : event.target;
  if (!isEmojiElement(target)) {
    return [];
  }
  var _allUnifiedFromEmojiE = allUnifiedFromEmojiElement(target),
    unified = _allUnifiedFromEmojiE.unified,
    originalUnified = _allUnifiedFromEmojiE.originalUnified;
  var resolvedUnified = unified != null ? unified : originalUnified;
  if (!resolvedUnified) {
    return [];
  }
  var emoji = lookupEmojiByUnified(resolvedUnified);
  if (!emoji) {
    return [];
  }
  return [emoji, unified != null ? unified : resolvedUnified];
}
function emojiClickOutput(emoji, activeSkinTone, activeEmojiStyle, getEmojiUrl) {
  var names = emojiNames$1(emoji);
  if (isCustomEmoji(emoji)) {
    var _unified = emojiUnified$1(emoji);
    return {
      activeSkinTone: activeSkinTone,
      emoji: _unified,
      getImageUrl: function getImageUrl() {
        return emoji.imgUrl;
      },
      imageUrl: emoji.imgUrl,
      isCustom: true,
      names: names,
      unified: _unified,
      unifiedWithoutSkinTone: _unified
    };
  }
  var unified = emojiUnified$1(emoji, activeSkinTone);
  return {
    activeSkinTone: activeSkinTone,
    emoji: parseNativeEmoji(unified),
    getImageUrl: function getImageUrl(emojiStyle) {
      if (emojiStyle === void 0) {
        emojiStyle = activeEmojiStyle != null ? activeEmojiStyle : EmojiStyle.APPLE;
      }
      return getEmojiUrl(unified, emojiStyle);
    },
    imageUrl: getEmojiUrl(unified, activeEmojiStyle != null ? activeEmojiStyle : EmojiStyle.APPLE),
    isCustom: false,
    names: names,
    unified: unified,
    unifiedWithoutSkinTone: emojiUnified$1(emoji)
  };
}
function Button(props) {
  return createElement("button", Object.assign({
    type: "button"
  }, props, {
    className: cx(styles$1$1.button, props.className)
  }), props.children);
}
var styles$1$1 = /*#__PURE__*/stylesheet.create({
  button: {
    '.': 'epr-btn',
    cursor: 'pointer',
    border: '0',
    background: 'none',
    outline: 'none'
  }
});
function ClickableEmojiButton(_ref) {
  var _cx;
  var emojiNames = _ref.emojiNames,
    unified = _ref.unified,
    hidden = _ref.hidden,
    hiddenOnSearch = _ref.hiddenOnSearch,
    _ref$showVariations = _ref.showVariations,
    showVariations = _ref$showVariations === void 0 ? true : _ref$showVariations,
    hasVariations = _ref.hasVariations,
    children = _ref.children,
    className = _ref.className,
    _ref$noBackground = _ref.noBackground,
    noBackground = _ref$noBackground === void 0 ? false : _ref$noBackground,
    style = _ref.style;
  return createElement(Button, {
    className: cx(styles$2$1.emoji, hidden && commonStyles.hidden, hiddenOnSearch && commonInteractionStyles.hiddenOnSearch, (_cx = {}, _cx[ClassNames.visible] = !hidden && !hiddenOnSearch, _cx), !!(hasVariations && showVariations) && styles$2$1.hasVariations, noBackground && styles$2$1.noBackground, className),
    "data-unified": unified,
    "aria-label": getAriaLabel(emojiNames),
    "data-full-name": emojiNames,
    style: style
  }, children);
}
function getAriaLabel(emojiNames) {
  return emojiNames[emojiNames.length - 1];
}
var styles$2$1 = /*#__PURE__*/stylesheet.create({
  emoji: {
    '.': ClassNames.emoji,
    position: 'relative',
    width: 'var(--epr-emoji-fullsize)',
    height: 'var(--epr-emoji-fullsize)',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 'var(--epr-emoji-fullsize)',
    maxHeight: 'var(--epr-emoji-fullsize)',
    borderRadius: '8px',
    overflow: 'hidden',
    transition: 'background-color 0.2s',
    ':hover': {
      backgroundColor: 'var(--epr-emoji-hover-color)'
    },
    ':focus': {
      backgroundColor: 'var(--epr-focus-bg-color)'
    }
  },
  noBackground: {
    background: 'none',
    ':hover': {
      backgroundColor: 'transparent',
      background: 'none'
    },
    ':focus': {
      backgroundColor: 'transparent',
      background: 'none'
    }
  },
  hasVariations: {
    '.': ClassNames.emojiHasVariations,
    ':after': {
      content: '',
      display: 'block',
      width: '0',
      height: '0',
      right: '0px',
      bottom: '1px',
      position: 'absolute',
      borderLeft: '4px solid transparent',
      borderRight: '4px solid transparent',
      transform: 'rotate(135deg)',
      borderBottom: '4px solid var(--epr-emoji-variation-indicator-color)',
      zIndex: 'var(--epr-emoji-variations-indictator-z-index)'
    },
    ':hover:after': {
      borderBottom: '4px solid var(--epr-emoji-variation-indicator-color-hover)'
    }
  }
});
var emojiStyles = /*#__PURE__*/stylesheet.create({
  external: {
    '.': ClassNames.external,
    fontSize: '0'
  },
  common: {
    alignSelf: 'center',
    justifySelf: 'center',
    display: 'block'
  }
});
function EmojiImg(_ref) {
  var emojiName = _ref.emojiName,
    style = _ref.style,
    _ref$lazyLoad = _ref.lazyLoad,
    lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad,
    imgUrl = _ref.imgUrl,
    onError = _ref.onError,
    className = _ref.className;
  return createElement("img", {
    src: imgUrl,
    alt: emojiName,
    className: cx(styles$3$1.emojiImag, emojiStyles.external, emojiStyles.common, className),
    loading: lazyLoad ? 'lazy' : 'eager',
    onError: onError,
    style: style
  });
}
var styles$3$1 = /*#__PURE__*/stylesheet.create({
  emojiImag: {
    '.': 'epr-emoji-img',
    maxWidth: 'var(--epr-emoji-fullsize)',
    maxHeight: 'var(--epr-emoji-fullsize)',
    minWidth: 'var(--epr-emoji-fullsize)',
    minHeight: 'var(--epr-emoji-fullsize)',
    padding: 'var(--epr-emoji-padding)'
  }
});
function NativeEmoji(_ref) {
  var unified = _ref.unified,
    style = _ref.style,
    className = _ref.className;
  return createElement("span", {
    className: cx(styles$4$1.nativeEmoji, emojiStyles.common, emojiStyles.external, className),
    "data-unified": unified,
    style: style
  }, parseNativeEmoji(unified));
}
var styles$4$1 = /*#__PURE__*/stylesheet.create({
  nativeEmoji: {
    '.': 'epr-emoji-native',
    fontFamily: '"Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "EmojiOne Color", "Android Emoji"!important',
    position: 'relative',
    lineHeight: '100%',
    fontSize: 'var(--epr-emoji-size)',
    textAlign: 'center',
    alignSelf: 'center',
    justifySelf: 'center',
    letterSpacing: '0',
    padding: 'var(--epr-emoji-padding)'
  }
});
function ViewOnlyEmoji(_ref) {
  var emoji = _ref.emoji,
    unified = _ref.unified,
    emojiStyle = _ref.emojiStyle,
    size = _ref.size,
    lazyLoad = _ref.lazyLoad,
    _ref$getEmojiUrl = _ref.getEmojiUrl,
    getEmojiUrl = _ref$getEmojiUrl === void 0 ? emojiUrlByUnified : _ref$getEmojiUrl,
    className = _ref.className;
  var _useEmojisThatFailedT = useEmojisThatFailedToLoadState(),
    setEmojisThatFailedToLoad = _useEmojisThatFailedT[1];
  var _usePickerDataContext = usePickerDataContext(),
    emojiByUnified = _usePickerDataContext.emojiByUnified;
  var style = {};
  if (size) {
    style.width = style.height = style.fontSize = size + "px";
  }
  var emojiToRender = emoji ? emoji : emojiByUnified(unified);
  if (!emojiToRender) {
    return null;
  }
  if (isCustomEmoji(emojiToRender)) {
    return createElement(EmojiImg, {
      style: style,
      emojiName: unified,
      emojiStyle: EmojiStyle.NATIVE,
      lazyLoad: lazyLoad,
      imgUrl: emojiToRender.imgUrl,
      onError: onError,
      className: className
    });
  }
  return createElement(Fragment, null, emojiStyle === EmojiStyle.NATIVE ? createElement(NativeEmoji, {
    unified: unified,
    style: style,
    className: className
  }) : createElement(EmojiImg, {
    style: style,
    emojiName: emojiName(emojiToRender),
    emojiStyle: emojiStyle,
    lazyLoad: lazyLoad,
    imgUrl: getEmojiUrl(unified, emojiStyle),
    onError: onError,
    className: className
  }));
  function onError() {
    setEmojisThatFailedToLoad(function (prev) {
      return new Set(prev).add(unified);
    });
  }
}
function ClickableEmoji(_ref) {
  var emoji = _ref.emoji,
    unified = _ref.unified,
    hidden = _ref.hidden,
    hiddenOnSearch = _ref.hiddenOnSearch,
    emojiStyle = _ref.emojiStyle,
    _ref$showVariations = _ref.showVariations,
    showVariations = _ref$showVariations === void 0 ? true : _ref$showVariations,
    size = _ref.size,
    lazyLoad = _ref.lazyLoad,
    getEmojiUrl = _ref.getEmojiUrl,
    className = _ref.className,
    _ref$noBackground = _ref.noBackground,
    noBackground = _ref$noBackground === void 0 ? false : _ref$noBackground,
    style = _ref.style;
  var hasVariations = emojiHasVariations$1(emoji);
  return createElement(ClickableEmojiButton, {
    hasVariations: hasVariations,
    showVariations: showVariations,
    hidden: hidden,
    hiddenOnSearch: hiddenOnSearch,
    emojiNames: emojiNames$1(emoji),
    unified: unified,
    noBackground: noBackground,
    style: style
  }, createElement(ViewOnlyEmoji, {
    unified: unified,
    emoji: emoji,
    size: size,
    emojiStyle: emojiStyle,
    lazyLoad: lazyLoad,
    getEmojiUrl: getEmojiUrl,
    className: className
  }));
}
var Plus = 'data:image/svg+xml;base64,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';
function BtnPlus() {
  var _useReactionsModeStat = useReactionsModeState(),
    setReactionsMode = _useReactionsModeStat[1];
  return createElement(Button, {
    "aria-label": "Show all Emojis",
    title: "Show all Emojis",
    tabIndex: 0,
    className: cx(styles$5$1.plusSign),
    onClick: function onClick() {
      return setReactionsMode(false);
    }
  });
}
var styles$5$1 = /*#__PURE__*/stylesheet.create(/*#__PURE__*/_extends({
  plusSign: {
    fontSize: '20px',
    padding: '17px',
    color: 'var(--epr-text-color)',
    borderRadius: '50%',
    textAlign: 'center',
    lineHeight: '100%',
    width: '20px',
    height: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'background-color 0.2s ease-in-out',
    ':after': {
      content: '',
      minWidth: '20px',
      minHeight: '20px',
      backgroundImage: "url(" + Plus + ")",
      backgroundColor: 'transparent',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '20px',
      backgroundPositionY: '0'
    },
    ':hover': {
      color: 'var(--epr-highlight-color)',
      backgroundColor: 'var(--epr-hover-bg-color-reduced-opacity)',
      ':after': {
        backgroundPositionY: '-20px'
      }
    },
    ':focus': {
      color: 'var(--epr-highlight-color)',
      backgroundColor: 'var(--epr-hover-bg-color-reduced-opacity)',
      ':after': {
        backgroundPositionY: '-40px'
      }
    }
  }
}, /*#__PURE__*/darkMode('plusSign', {
  ':after': {
    backgroundPositionY: '-40px'
  },
  ':hover:after': {
    backgroundPositionY: '-60px'
  }
})));
function Reactions() {
  var _useReactionsModeStat = useReactionsModeState(),
    reactionsOpen = _useReactionsModeStat[0];
  var ReactionsRef = useReactionsRef();
  var reactions = useReactionsConfig();
  useMouseDownHandlers(ReactionsRef, MOUSE_EVENT_SOURCE.REACTIONS);
  var emojiStyle = useEmojiStyleConfig();
  var allowExpandReactions = useAllowExpandReactions();
  var getEmojiUrl = useGetEmojiUrlConfig();
  if (!reactionsOpen) {
    return null;
  }
  return createElement("ul", {
    className: cx(styles$6.list, !reactionsOpen && commonStyles.hidden),
    ref: ReactionsRef,
    "aria-label": "Reactions"
  }, reactions.map(function (reaction) {
    var emoji = emojiByUnified(reaction);
    if (!emoji) {
      return null;
    }
    return createElement("li", {
      key: reaction
    }, createElement(ClickableEmoji, {
      emoji: emoji,
      emojiStyle: emojiStyle,
      unified: reaction,
      showVariations: false,
      className: cx(styles$6.emojiButton),
      noBackground: true,
      getEmojiUrl: getEmojiUrl
    }));
  }), allowExpandReactions ? createElement("li", null, createElement(BtnPlus, null)) : null);
}
var styles$6 = /*#__PURE__*/stylesheet.create({
  list: {
    listStyle: 'none',
    margin: '0',
    padding: '0 5px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%'
  },
  emojiButton: {
    ':hover': {
      transform: 'scale(1.2)'
    },
    ':focus': {
      transform: 'scale(1.2)'
    },
    ':active': {
      transform: 'scale(1.1)'
    },
    transition: 'transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.5)'
  }
});
function useOnScroll(BodyRef) {
  var closeAllOpenToggles = useCloseAllOpenToggles();
  var _useState = useState(0),
    scrollTop = _useState[0],
    setScrollTop = _useState[1];
  useEffect(function () {
    var bodyRef = BodyRef.current;
    if (!bodyRef) {
      return;
    }
    bodyRef.addEventListener('scroll', onScroll, {
      passive: true
    });
    function onScroll() {
      var _bodyRef$scrollTop;
      setScrollTop((_bodyRef$scrollTop = bodyRef == null ? void 0 : bodyRef.scrollTop) != null ? _bodyRef$scrollTop : 0);
      closeAllOpenToggles();
    }
    return function () {
      bodyRef == null ? void 0 : bodyRef.removeEventListener('scroll', onScroll);
    };
  }, [BodyRef, closeAllOpenToggles]);
  return scrollTop;
}
function shouldVirtualize(_ref) {
  var scrollTop = _ref.scrollTop,
    clientHeight = _ref.clientHeight,
    topOffset = _ref.topOffset,
    style = _ref.style,
    dimensions = _ref.dimensions;
  if (!style || !dimensions) {
    return false;
  }
  var emojiTop = topOffset + style.top;
  var emojiBottom = emojiTop + dimensions.emojiSize;
  var isVisible = emojiBottom + dimensions.emojiSize * 2 >= scrollTop && emojiTop <= scrollTop + clientHeight + dimensions.emojiSize;
  return !isVisible;
}
function getEmojiPositionStyle(dimensions, index) {
  return dimensions ? {
    top: Math.floor(index / dimensions.emojisPerRow) * dimensions.emojiSize,
    left: index % dimensions.emojisPerRow * dimensions.emojiSize
  } : undefined;
}
var EMOJI_SIZE_DEFAULT = 40;
function useCategoryHeight(emojiCount) {
  var EmojiListRef = useEmojiListRef();
  var _useReactionsModeStat = useReactionsModeState(),
    isReactionsMode = _useReactionsModeStat[0];
  var PickerMainRef = usePickerMainRef();
  var emojiSizeRef = useRef();
  var _useVisibleCategories = useVisibleCategoriesState(),
    visibleCategories = _useVisibleCategories[0];
  var _useEmojiSizeState = useEmojiSizeState(),
    emojiSizeFromContext = _useEmojiSizeState[0];
  var _React$useState = useState(),
    dimensions = _React$useState[0],
    setDimensions = _React$useState[1];
  // Helper to compute and store dimensions based on current DOM
  var computeAndSetDimensions = useCallback(function () {
    var listEl = EmojiListRef.current;
    if (!listEl) return;
    var emojiElement = listEl.querySelector(EmojiButtonSelector);
    var measured = emojiElement == null ? void 0 : emojiElement.clientHeight;
    if (measured) {
      emojiSizeRef.current = measured;
    }
    var emojiSize = emojiSizeFromContext || measured || emojiSizeRef.current || EMOJI_SIZE_DEFAULT;
    var pickerWidth = listEl.clientWidth;
    if (pickerWidth === 0 || emojiSize === 0) return;
    var emojisPerRow = Math.max(1, Math.floor(pickerWidth / emojiSize));
    var rowCount = Math.ceil(emojiCount / emojisPerRow);
    var categoryHeight = rowCount * emojiSize;
    setDimensions({
      categoryHeight: categoryHeight,
      emojisPerRow: emojisPerRow,
      emojiSize: emojiSize
    });
  }, [EmojiListRef, emojiCount, emojiSizeFromContext]);
  // Recompute on data-count changes and when reactions mode toggles
  useEffect(function () {
    computeAndSetDimensions();
  }, [emojiCount, isReactionsMode, computeAndSetDimensions, visibleCategories.length]);
  // Listen to transitionend on the picker root (where height transition occurs)
  useEffect(function () {
    var rootEl = PickerMainRef.current;
    if (!rootEl) return;
    var handler = function handler(e) {
      var te = e;
      var prop = te.propertyName;
      if (prop === 'width' || prop === 'max-width' || prop === 'min-width' || prop === 'height' || prop === 'max-height' || prop === 'min-height') {
        if (typeof queueMicrotask === 'function') {
          queueMicrotask(function () {
            return computeAndSetDimensions();
          });
        } else {
          requestAnimationFrame(function () {
            return computeAndSetDimensions();
          });
        }
      }
    };
    rootEl.addEventListener('transitionend', handler, {
      passive: true
    });
    return function () {
      rootEl.removeEventListener('transitionend', handler);
    };
  }, [PickerMainRef, computeAndSetDimensions]);
  return dimensions;
}
function useIsEmojiHidden() {
  var _useEmojisThatFailedT = useEmojisThatFailedToLoadState(),
    emojisThatFailedToLoad = _useEmojisThatFailedT[0];
  var isEmojiFiltered = useIsEmojiFiltered();
  return function (emoji) {
    var unified = emojiUnified(emoji);
    var failedToLoad = emojisThatFailedToLoad.has(unified);
    var filteredOut = isEmojiFiltered(unified);
    return {
      failedToLoad: failedToLoad,
      filteredOut: filteredOut,
      hidden: failedToLoad || filteredOut
    };
  };
}
function useEmojiVirtualization(_ref) {
  var categoryEmojis = _ref.categoryEmojis,
    topOffset = _ref.topOffset,
    onHeightReady = _ref.onHeightReady,
    scrollTop = _ref.scrollTop,
    isCategoryVisible = _ref.isCategoryVisible;
  var isEmojiHidden = useIsEmojiHidden();
  var lazyLoadEmojis = useLazyLoadEmojisConfig();
  var emojiStyle = useEmojiStyleConfig();
  var _useActiveSkinToneSta = useActiveSkinToneState(),
    activeSkinTone = _useActiveSkinToneSta[0];
  var isEmojiDisallowed = useIsEmojiDisallowed();
  var getEmojiUrl = useGetEmojiUrlConfig();
  var showVariations = !useSkinTonesDisabledConfig();
  var BodyRef = useBodyRef();
  var virtualizedCounter = 0;
  var emojisToPush = categoryEmojis.filter(function (emoji) {
    var isDisallowed = isEmojiDisallowed(emoji);
    var _isEmojiHidden = isEmojiHidden(emoji),
      failedToLoad = _isEmojiHidden.failedToLoad,
      filteredOut = _isEmojiHidden.filteredOut,
      hidden = _isEmojiHidden.hidden;
    return !failedToLoad && !filteredOut && !hidden && !isDisallowed;
  });
  var dimensions = useCategoryHeight(emojisToPush.length);
  useEffect(function () {
    if (dimensions) {
      onHeightReady(dimensions.categoryHeight);
    }
  }, [dimensions, onHeightReady, emojisToPush.length]);
  var isVirtualized = function isVirtualized(style) {
    var _BodyRef$current$clie, _BodyRef$current;
    return dimensions && BodyRef.current && shouldVirtualize({
      scrollTop: scrollTop,
      clientHeight: (_BodyRef$current$clie = (_BodyRef$current = BodyRef.current) == null ? void 0 : _BodyRef$current.clientHeight) != null ? _BodyRef$current$clie : 0,
      topOffset: topOffset,
      style: style,
      dimensions: dimensions
    });
  };
  var emojis = emojisToPush.reduce(function (accumulator, emoji, index) {
    var unified = emojiUnified(emoji, activeSkinTone);
    var style = getEmojiPositionStyle(dimensions, index);
    if (isVirtualized(style)) {
      var _BodyRef$current$clie2, _BodyRef$current2;
      virtualizedCounter++;
      preloadEmojiIfNeeded(emoji, emojiStyle, scrollTop, (_BodyRef$current$clie2 = (_BodyRef$current2 = BodyRef.current) == null ? void 0 : _BodyRef$current2.clientHeight) != null ? _BodyRef$current$clie2 : 0, topOffset, style, dimensions, getEmojiUrl);
      return accumulator;
    }
    if (!isCategoryVisible) {
      virtualizedCounter++;
      return accumulator;
    }
    accumulator.push(createElement(ClickableEmoji, {
      showVariations: showVariations,
      key: unified,
      emoji: emoji,
      unified: unified,
      emojiStyle: emojiStyle,
      lazyLoad: lazyLoadEmojis,
      getEmojiUrl: getEmojiUrl,
      style: _extends({}, style, {
        position: 'absolute'
      })
    }));
    return accumulator;
  }, []);
  return {
    virtualizedCounter: virtualizedCounter,
    emojis: emojis,
    dimensions: dimensions
  };
}
function EmojiCategory(_ref) {
  var categoryConfig = _ref.categoryConfig,
    children = _ref.children,
    hidden = _ref.hidden,
    hiddenOnSearch = _ref.hiddenOnSearch,
    height = _ref.height;
  var category = categoryFromCategoryConfig(categoryConfig);
  var categoryName = categoryNameFromCategoryConfig(categoryConfig);
  return createElement("li", {
    className: cx(styles$7.category, hidden && commonStyles.hidden, hiddenOnSearch && commonInteractionStyles.hiddenOnSearch),
    "data-name": category,
    "aria-label": categoryName
  }, createElement("h2", {
    className: cx(styles$7.label)
  }, categoryName), createElement("div", {
    className: cx(styles$7.categoryContent),
    style: {
      height: height
    }
  }, children));
}
var styles$7 = /*#__PURE__*/stylesheet.create({
  category: {
    '.': ClassNames.category,
    minHeight: 'calc(var(--epr-emoji-fullsize) + var(--epr-category-label-height))',
    position: 'relative'
  },
  categoryContent: {
    '.': ClassNames.categoryContent,
    display: 'grid',
    gridGap: '0',
    gridTemplateColumns: 'repeat(auto-fill, var(--epr-emoji-fullsize))',
    justifyContent: 'space-between',
    margin: 'var(--epr-category-padding)',
    position: 'relative'
  },
  label: {
    '.': ClassNames.label,
    alignItems: 'center',
    // @ts-ignore - backdropFilter is not recognized.
    backdropFilter: 'blur(3px)',
    backgroundColor: 'var(--epr-category-label-bg-color)',
    color: 'var(--epr-category-label-text-color)',
    display: 'flex',
    fontSize: '16px',
    fontWeight: 'bold',
    height: 'var(--epr-category-label-height)',
    margin: '0',
    padding: 'var(--epr-category-label-padding)',
    position: 'sticky',
    textTransform: 'capitalize',
    top: '0',
    width: '100%',
    zIndex: 'var(--epr-category-label-z-index)'
  }
});
function MeasureEmoji() {
  var categories = useCategoriesConfig();
  var getEmojisByCategory = useGetEmojisByCategory();
  var emojiStyle = useEmojiStyleConfig();
  var getEmojiUrl = useGetEmojiUrlConfig();
  var lazyLoadEmojis = useLazyLoadEmojisConfig();
  var _useActiveSkinToneSta = useActiveSkinToneState(),
    activeSkinTone = _useActiveSkinToneSta[0];
  var _useEmojiSizeState = useEmojiSizeState(),
    emojiSize = _useEmojiSizeState[0],
    setEmojiSize = _useEmojiSizeState[1];
  var ref = useRef(null);
  useLayoutEffect(function () {
    if (ref.current) {
      setEmojiSize(ref.current.clientHeight);
    }
  });
  if (emojiSize) {
    return null;
  }
  var firstCategory = categories[0];
  var dummyEmoji = getEmojisByCategory(categoryFromCategoryConfig(firstCategory))[0];
  var unified = dummyEmoji ? emojiUnified$1(dummyEmoji, activeSkinTone) : '';
  if (!dummyEmoji) {
    return null;
  }
  return createElement("div", {
    ref: ref
  }, createElement(ClickableEmoji, {
    emoji: dummyEmoji,
    unified: unified,
    emojiStyle: emojiStyle,
    getEmojiUrl: getEmojiUrl,
    lazyLoad: lazyLoadEmojis,
    showVariations: false,
    hidden: false,
    style: {
      opacity: 0,
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: -1,
      height: 'var(--epr-emoji-fullsize)',
      width: 'var(--epr-emoji-fullsize)'
    }
  }));
}
function EmojiList(_ref) {
  var scrollTop = _ref.scrollTop;
  var categories = useCategoriesConfig();
  var _React$useState = useState({}),
    categoryHeights = _React$useState[0],
    setCategoryHeights = _React$useState[1];
  var EmojiListRef = useEmojiListRef();
  var getEmojisByCategory = useGetEmojisByCategory$1();
  var labelHeight = getLabelHeight(EmojiListRef.current);
  var topOffset = 0;
  return createElement("ul", {
    className: cx(styles$8.emojiList),
    ref: EmojiListRef
  }, createElement(MeasureEmoji, null), categories.map(function (categoryConfig) {
    var category = categoryFromCategoryConfig(categoryConfig);
    var currentOffset = topOffset;
    var categoryHeight = categoryHeights[category];
    if (categoryHeight) {
      topOffset += categoryHeight + labelHeight;
    }
    return createElement(Suspense, {
      key: category
    }, createElement(RenderCategory, {
      categoryEmojis: getEmojisByCategory(category),
      categoryConfig: categoryConfig,
      topOffset: currentOffset,
      onHeightReady: function onHeightReady(height) {
        if (categoryHeights[category] !== height) {
          setCategoryHeights(function (prev) {
            var _extends2;
            return _extends({}, prev, (_extends2 = {}, _extends2[category] = height, _extends2));
          });
        }
      },
      scrollTop: scrollTop
    }));
  }));
}
function RenderCategory(_ref2) {
  var categoryEmojis = _ref2.categoryEmojis,
    categoryConfig = _ref2.categoryConfig,
    topOffset = _ref2.topOffset,
    onHeightReady = _ref2.onHeightReady,
    scrollTop = _ref2.scrollTop;
  var _useVisibleCategories = useVisibleCategoriesState(),
    visibleCategories = _useVisibleCategories[0];
  var _useEmojiVirtualizati = useEmojiVirtualization({
      categoryEmojis: categoryEmojis,
      topOffset: topOffset,
      onHeightReady: onHeightReady,
      scrollTop: scrollTop,
      isCategoryVisible: visibleCategories.includes(categoryConfig.category)
    }),
    virtualizedCounter = _useEmojiVirtualizati.virtualizedCounter,
    emojis = _useEmojiVirtualizati.emojis,
    dimensions = _useEmojiVirtualizati.dimensions;
  return createElement(EmojiCategory, {
    categoryConfig: categoryConfig,
    height: dimensions == null ? void 0 : dimensions.categoryHeight,
    // Indicates that there are no visible emojis
    // Hence, the category should be hidden
    hidden: !emojis.length && virtualizedCounter === 0
  }, emojis);
}
var styles$8 = /*#__PURE__*/stylesheet.create({
  emojiList: {
    '.': ClassNames.emojiList,
    listStyle: 'none',
    margin: '0',
    padding: '0'
  }
});
var SVGTriangle = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI1MHB4IgoJIGhlaWdodD0iMTVweCIgdmlld0JveD0iMCAwIDUwIDE1IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MCAxNSIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnIGlkPSJMYXllcl8xIj4KPC9nPgo8ZyBpZD0iTGF5ZXJfMiI+Cgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBzdHJva2U9IiNFOEU3RTciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTEuODYtMC40M2w5LjgzLDExLjUzYzAuNTksMC42OSwxLjU2LDAuNjksMi4xNCwwbDkuODMtMTEuNTMiLz4KCTxwYXRoIGZpbGw9IiMwMTAyMDIiIHN0cm9rZT0iIzE1MTYxNyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMjYuODYtMC40M2w5LjgzLDExLjUzYzAuNTksMC42OSwxLjU2LDAuNjksMi4xNCwwbDkuODMtMTEuNTMiLz4KPC9nPgo8L3N2Zz4=';
var Direction;
(function (Direction) {
  Direction[Direction["Up"] = 0] = "Up";
  Direction[Direction["Down"] = 1] = "Down";
})(Direction || (Direction = {}));
// eslint-disable-next-line complexity
function EmojiVariationPicker() {
  var AnchoredEmojiRef = useAnchoredEmojiRef();
  var VariationPickerRef = useVariationPickerRef();
  var _useEmojiVariationPic = useEmojiVariationPickerState(),
    emoji = _useEmojiVariationPic[0];
  var emojiStyle = useEmojiStyleConfig();
  var _useVariationPickerTo = useVariationPickerTop(VariationPickerRef),
    getTop = _useVariationPickerTo.getTop,
    getMenuDirection = _useVariationPickerTo.getMenuDirection;
  var setAnchoredEmojiRef = useSetAnchoredEmojiRef();
  var getPointerStyle = usePointerStyle(VariationPickerRef);
  var getEmojiUrl = useGetEmojiUrlConfig();
  var button = buttonFromTarget(AnchoredEmojiRef.current);
  var visible = Boolean(emoji && button && emojiHasVariations$1(emoji) && button.classList.contains(ClassNames.emojiHasVariations));
  useEffect(function () {
    if (!visible) {
      return;
    }
    focusFirstVisibleEmoji(VariationPickerRef.current);
  }, [VariationPickerRef, visible, AnchoredEmojiRef]);
  var top, pointerStyle;
  if (!visible && AnchoredEmojiRef.current) {
    setAnchoredEmojiRef(null);
  } else {
    top = getTop();
    pointerStyle = getPointerStyle();
  }
  return createElement("div", {
    ref: VariationPickerRef,
    className: cx(styles$9.variationPicker, getMenuDirection() === Direction.Down && styles$9.pointingUp, visible && styles$9.visible),
    style: {
      top: top
    }
  }, visible && emoji ? [emojiUnified$1(emoji)].concat(emojiVariations$1(emoji)).slice(0, 6).map(function (unified) {
    return createElement(ClickableEmoji, {
      key: unified,
      emoji: emoji,
      unified: unified,
      emojiStyle: emojiStyle,
      showVariations: false,
      getEmojiUrl: getEmojiUrl
    });
  }) : null, createElement("div", {
    className: cx(styles$9.pointer),
    style: pointerStyle
  }));
}
function usePointerStyle(VariationPickerRef) {
  var AnchoredEmojiRef = useAnchoredEmojiRef();
  return function getPointerStyle() {
    var style = {};
    if (!VariationPickerRef.current) {
      return style;
    }
    if (AnchoredEmojiRef.current) {
      var button = buttonFromTarget(AnchoredEmojiRef.current);
      var offsetLeft = emojiTruOffsetLeft(button);
      if (!button) {
        return style;
      }
      // half of the button
      style.left = offsetLeft + (button == null ? void 0 : button.clientWidth) / 2;
    }
    return style;
  };
}
function useVariationPickerTop(VariationPickerRef) {
  var AnchoredEmojiRef = useAnchoredEmojiRef();
  var BodyRef = useBodyRef();
  var direction = Direction.Up;
  return {
    getMenuDirection: getMenuDirection,
    getTop: getTop
  };
  function getMenuDirection() {
    return direction;
  }
  function getTop() {
    direction = Direction.Up;
    var emojiOffsetTop = 0;
    if (!VariationPickerRef.current) {
      return 0;
    }
    var height = elementHeight(VariationPickerRef.current);
    if (AnchoredEmojiRef.current) {
      var _bodyRef$scrollTop;
      var bodyRef = BodyRef.current;
      var button = buttonFromTarget(AnchoredEmojiRef.current);
      var buttonHeight = elementHeight(button);
      emojiOffsetTop = emojiTrueOffsetTop(button);
      var scrollTop = (_bodyRef$scrollTop = bodyRef == null ? void 0 : bodyRef.scrollTop) != null ? _bodyRef$scrollTop : 0;
      if (scrollTop > emojiOffsetTop - height) {
        direction = Direction.Down;
        emojiOffsetTop += buttonHeight + height;
      }
    }
    return emojiOffsetTop - height;
  }
}
var styles$9 = /*#__PURE__*/stylesheet.create(/*#__PURE__*/_extends({
  variationPicker: {
    '.': ClassNames.variationPicker,
    position: 'absolute',
    right: '15px',
    left: '15px',
    padding: '5px',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
    borderRadius: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    top: '-100%',
    border: '1px solid var(--epr-picker-border-color)',
    height: 'var(--epr-emoji-variation-picker-height)',
    zIndex: 'var(--epr-skin-variation-picker-z-index)',
    background: 'var(--epr-emoji-variation-picker-bg-color)',
    transform: 'scale(0.9)',
    transition: 'transform 0.1s ease-out, opacity 0.2s ease-out'
  },
  visible: {
    opacity: '1',
    visibility: 'visible',
    pointerEvents: 'all',
    transform: 'scale(1)'
  },
  pointingUp: {
    '.': 'pointing-up',
    transformOrigin: 'center 0%',
    transform: 'scale(0.9)'
  },
  '.pointing-up': {
    pointer: {
      top: '0',
      transform: 'rotate(180deg) translateY(100%) translateX(18px)'
    }
  },
  pointer: {
    '.': 'epr-emoji-pointer',
    content: '',
    position: 'absolute',
    width: '25px',
    height: '15px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0 0',
    backgroundSize: '50px 15px',
    top: '100%',
    transform: 'translateX(-18px)',
    backgroundImage: "url(" + SVGTriangle + ")"
  }
}, /*#__PURE__*/darkMode('pointer', {
  backgroundPosition: '-25px 0'
})));
function Body() {
  var BodyRef = useBodyRef();
  var scrollTop = useOnScroll(BodyRef);
  useMouseDownHandlers(BodyRef, MOUSE_EVENT_SOURCE.PICKER);
  useOnMouseMove();
  return createElement("div", {
    className: cx(styles$a.body, commonInteractionStyles.hiddenOnReactions),
    ref: BodyRef
  }, createElement(EmojiVariationPicker, null), createElement(EmojiList, {
    scrollTop: scrollTop
  }));
}
var styles$a = /*#__PURE__*/stylesheet.create({
  body: {
    '.': ClassNames.scrollBody,
    flex: '1',
    overflowY: 'scroll',
    overflowX: 'hidden',
    position: 'relative'
  }
});
function detectEmojyPartiallyBelowFold(button, bodyRef) {
  if (!button || !bodyRef) {
    return 0;
  }
  var buttonRect = button.getBoundingClientRect();
  var bodyRect = bodyRef.getBoundingClientRect();
  // If the element is obscured by at least half of its size
  return bodyRect.height - (buttonRect.y - bodyRect.y);
}
function useEmojiPreviewEvents(allow, setPreviewEmoji) {
  var BodyRef = useBodyRef();
  var isMouseDisallowed = useIsMouseDisallowed();
  var allowMouseMove = useAllowMouseMove();
  useEffect(function () {
    if (!allow) {
      return;
    }
    var bodyRef = BodyRef.current;
    bodyRef == null ? void 0 : bodyRef.addEventListener('keydown', onEscape, {
      passive: true
    });
    bodyRef == null ? void 0 : bodyRef.addEventListener('mouseover', onMouseOver, true);
    bodyRef == null ? void 0 : bodyRef.addEventListener('focus', onEnter, true);
    bodyRef == null ? void 0 : bodyRef.addEventListener('mouseout', onLeave, {
      passive: true
    });
    bodyRef == null ? void 0 : bodyRef.addEventListener('blur', onLeave, true);
    function onEnter(e) {
      var button = buttonFromTarget(e.target);
      if (!button) {
        return onLeave();
      }
      var _allUnifiedFromEmojiE = allUnifiedFromEmojiElement(button),
        unified = _allUnifiedFromEmojiE.unified,
        originalUnified = _allUnifiedFromEmojiE.originalUnified;
      if (!unified || !originalUnified) {
        return onLeave();
      }
      setPreviewEmoji({
        unified: unified,
        originalUnified: originalUnified
      });
    }
    function onLeave(e) {
      if (e) {
        var relatedTarget = e.relatedTarget;
        if (!buttonFromTarget(relatedTarget)) {
          return setPreviewEmoji(null);
        }
      }
      setPreviewEmoji(null);
    }
    function onEscape(e) {
      if (e.key === 'Escape') {
        setPreviewEmoji(null);
      }
    }
    function onMouseOver(e) {
      if (isMouseDisallowed()) {
        return;
      }
      var button = buttonFromTarget(e.target);
      if (button) {
        var belowFoldByPx = detectEmojyPartiallyBelowFold(button, bodyRef);
        var buttonHeight = button.getBoundingClientRect().height;
        if (belowFoldByPx < buttonHeight) {
          return handlePartiallyVisibleElementFocus(button, setPreviewEmoji);
        }
        focusElement(button);
      }
    }
    return function () {
      bodyRef == null ? void 0 : bodyRef.removeEventListener('mouseover', onMouseOver);
      bodyRef == null ? void 0 : bodyRef.removeEventListener('mouseout', onLeave);
      bodyRef == null ? void 0 : bodyRef.removeEventListener('focus', onEnter, true);
      bodyRef == null ? void 0 : bodyRef.removeEventListener('blur', onLeave, true);
      bodyRef == null ? void 0 : bodyRef.removeEventListener('keydown', onEscape);
    };
  }, [BodyRef, allow, setPreviewEmoji, isMouseDisallowed, allowMouseMove]);
}
function handlePartiallyVisibleElementFocus(button, setPreviewEmoji) {
  var _document$activeEleme;
  var _allUnifiedFromEmojiE2 = allUnifiedFromEmojiElement(button),
    unified = _allUnifiedFromEmojiE2.unified,
    originalUnified = _allUnifiedFromEmojiE2.originalUnified;
  if (!unified || !originalUnified) {
    return;
  }
  (_document$activeEleme = document.activeElement) == null ? void 0 : _document$activeEleme.blur == null ? void 0 : _document$activeEleme.blur();
  setPreviewEmoji({
    unified: unified,
    originalUnified: originalUnified
  });
}
var _stylesheet$create;
var FlexDirection;
(function (FlexDirection) {
  FlexDirection["ROW"] = "FlexRow";
  FlexDirection["COLUMN"] = "FlexColumn";
})(FlexDirection || (FlexDirection = {}));
function Flex(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? FlexDirection.ROW : _ref$direction;
  return createElement("div", {
    style: _extends({}, style),
    className: cx(styles$b.flex, className, styles$b[direction])
  }, children);
}
var styles$b = /*#__PURE__*/stylesheet.create((_stylesheet$create = {
  flex: {
    display: 'flex'
  }
}, _stylesheet$create[FlexDirection.ROW] = {
  flexDirection: 'row'
}, _stylesheet$create[FlexDirection.COLUMN] = {
  flexDirection: 'column'
}, _stylesheet$create));
function Space(_ref) {
  var className = _ref.className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return createElement("div", {
    style: _extends({
      flex: 1
    }, style),
    className: cx(className)
  });
}
function Absolute(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style;
  return createElement("div", {
    style: _extends({}, style, {
      position: 'absolute'
    }),
    className: className
  }, children);
}
function Relative(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style;
  return createElement("div", {
    style: _extends({}, style, {
      position: 'relative'
    }),
    className: className
  }, children);
}

// eslint-disable-next-line complexity
function BtnSkinToneVariation(_ref) {
  var isOpen = _ref.isOpen,
    onClick = _ref.onClick,
    isActive = _ref.isActive,
    skinToneVariation = _ref.skinToneVariation,
    style = _ref.style;
  return createElement(Button, {
    style: style,
    onClick: onClick,
    className: cx("epr-tone-" + skinToneVariation, styles$c.tone, !isOpen && styles$c.closedTone, isActive && styles$c.active),
    "aria-pressed": isActive,
    "aria-label": "Skin tone " + skinTonesNamed[skinToneVariation]
  });
}
var styles$c = /*#__PURE__*/stylesheet.create({
  closedTone: {
    opacity: '0',
    zIndex: '0'
  },
  active: {
    '.': 'epr-active',
    zIndex: '1',
    opacity: '1'
  },
  tone: {
    '.': 'epr-tone',
    width: 'var(--epr-skin-tone-size)',
    display: 'block',
    cursor: 'pointer',
    borderRadius: '4px',
    height: 'var(--epr-skin-tone-size)',
    position: 'absolute',
    right: '0',
    transition: 'transform 0.3s ease-in-out, opacity 0.35s ease-in-out',
    zIndex: '0',
    border: '1px solid var(--epr-skin-tone-outer-border-color)',
    boxShadow: 'inset 0px 0px 0 1px var(--epr-skin-tone-inner-border-color)',
    ':hover': {
      boxShadow: '0 0 0 3px var(--epr-active-skin-hover-color), inset 0px 0px 0 1px var(--epr-skin-tone-inner-border-color)'
    },
    ':focus': {
      boxShadow: '0 0 0 3px var(--epr-focus-bg-color)'
    },
    '&.epr-tone-neutral': {
      backgroundColor: '#ffd225'
    },
    '&.epr-tone-1f3fb': {
      backgroundColor: '#ffdfbd'
    },
    '&.epr-tone-1f3fc': {
      backgroundColor: '#e9c197'
    },
    '&.epr-tone-1f3fd': {
      backgroundColor: '#c88e62'
    },
    '&.epr-tone-1f3fe': {
      backgroundColor: '#a86637'
    },
    '&.epr-tone-1f3ff': {
      backgroundColor: '#60463a'
    }
  }
});

/* eslint-disable complexity */
var ITEM_SIZE = 28;
function SkinTonePickerMenu() {
  return createElement(Relative, {
    style: {
      height: ITEM_SIZE
    }
  }, createElement(Absolute, {
    style: {
      bottom: 0,
      right: 0
    }
  }, createElement(SkinTonePicker, {
    direction: SkinTonePickerDirection.VERTICAL
  })));
}
function SkinTonePicker(_ref) {
  var _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? SkinTonePickerDirection.HORIZONTAL : _ref$direction;
  var SkinTonePickerRef = useSkinTonePickerRef();
  var isDisabled = useSkinTonesDisabledConfig();
  var _useSkinToneFanOpenSt = useSkinToneFanOpenState(),
    isOpen = _useSkinToneFanOpenSt[0],
    setIsOpen = _useSkinToneFanOpenSt[1];
  var _useActiveSkinToneSta = useActiveSkinToneState(),
    activeSkinTone = _useActiveSkinToneSta[0],
    setActiveSkinTone = _useActiveSkinToneSta[1];
  var onSkinToneChange = useOnSkinToneChangeConfig();
  var closeAllOpenToggles = useCloseAllOpenToggles();
  var focusSearchInput = useFocusSearchInput();
  if (isDisabled) {
    return null;
  }
  var fullWidth = ITEM_SIZE * skinToneVariations.length + "px";
  var expandedSize = isOpen ? fullWidth : ITEM_SIZE + 'px';
  var vertical = direction === SkinTonePickerDirection.VERTICAL;
  return createElement(Relative, {
    className: cx(styles$d.skinTones, vertical && styles$d.vertical, isOpen && styles$d.open, vertical && isOpen && styles$d.verticalShadow),
    style: vertical ? {
      flexBasis: expandedSize,
      height: expandedSize
    } : {
      flexBasis: expandedSize
    }
  }, createElement("div", {
    className: cx(styles$d.select),
    ref: SkinTonePickerRef
  }, skinToneVariations.map(function (skinToneVariation, i) {
    var active = skinToneVariation === activeSkinTone;
    return createElement(BtnSkinToneVariation, {
      key: skinToneVariation,
      skinToneVariation: skinToneVariation,
      isOpen: isOpen,
      style: {
        transform: cx(vertical ? "translateY(-" + i * (isOpen ? ITEM_SIZE : 0) + "px)" : "translateX(-" + i * (isOpen ? ITEM_SIZE : 0) + "px)", isOpen && active && 'scale(1.3)')
      },
      isActive: active,
      onClick: function onClick() {
        if (isOpen) {
          setActiveSkinTone(skinToneVariation);
          onSkinToneChange(skinToneVariation);
          focusSearchInput();
        } else {
          setIsOpen(true);
        }
        closeAllOpenToggles();
      }
    });
  })));
}
var SkinTonePickerDirection;
(function (SkinTonePickerDirection) {
  SkinTonePickerDirection["VERTICAL"] = "epr-vertical";
  SkinTonePickerDirection["HORIZONTAL"] = "epr-horizontal";
})(SkinTonePickerDirection || (SkinTonePickerDirection = {}));
var styles$d = /*#__PURE__*/stylesheet.create({
  skinTones: {
    '.': 'epr-skin-tones',
    '--': {
      '--epr-skin-tone-size': '15px'
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    transition: 'all 0.3s ease-in-out',
    padding: '10px 0'
  },
  vertical: {
    padding: '9px',
    alignItems: 'flex-end',
    flexDirection: 'column',
    borderRadius: '6px',
    border: '1px solid var(--epr-bg-color)'
  },
  verticalShadow: {
    boxShadow: '0px 0 7px var(--epr-picker-border-color)'
  },
  open: {
    // @ts-ignore - backdropFilter is not recognized.
    backdropFilter: 'blur(5px)',
    background: 'var(--epr-skin-tone-picker-menu-color)',
    '.epr-active': {
      border: '1px solid var(--epr-active-skin-tone-indicator-border-color)'
    }
  },
  select: {
    '.': 'epr-skin-tone-select',
    position: 'relative',
    width: 'var(--epr-skin-tone-size)',
    height: 'var(--epr-skin-tone-size)'
  }
});
function Preview() {
  var previewConfig = usePreviewConfig();
  var isSkinToneInPreview = useIsSkinToneInPreview();
  var _useReactionsModeStat = useReactionsModeState(),
    reactionsOpen = _useReactionsModeStat[0];
  if (!previewConfig.showPreview) {
    return null;
  }
  return createElement(Flex, {
    className: cx(styles$e.preview, commonInteractionStyles.hiddenOnReactions, reactionsOpen && styles$e.hideOnReactions)
  }, createElement(PreviewBody, null), createElement(Space, null), isSkinToneInPreview ? createElement(SkinTonePickerMenu, null) : null);
}
function PreviewBody() {
  var _previewEmoji$unified;
  var previewConfig = usePreviewConfig();
  var _useState = useState(null),
    previewEmoji = _useState[0],
    setPreviewEmoji = _useState[1];
  var emojiStyle = useEmojiStyleConfig();
  var _useEmojiVariationPic = useEmojiVariationPickerState(),
    variationPickerEmoji = _useEmojiVariationPic[0];
  var getEmojiUrl = useGetEmojiUrlConfig();
  var _usePickerDataContext = usePickerDataContext(),
    emojiByUnified = _usePickerDataContext.emojiByUnified;
  useEmojiPreviewEvents(previewConfig.showPreview, setPreviewEmoji);
  var emoji = emojiByUnified((_previewEmoji$unified = previewEmoji == null ? void 0 : previewEmoji.unified) != null ? _previewEmoji$unified : previewEmoji == null ? void 0 : previewEmoji.originalUnified);
  var show = emoji != null && previewEmoji != null;
  return createElement(PreviewContent, null);
  function PreviewContent() {
    var defaultEmoji = variationPickerEmoji != null ? variationPickerEmoji : emojiByUnified(previewConfig.defaultEmoji);
    if (!defaultEmoji) {
      return null;
    }
    var defaultText = variationPickerEmoji ? emojiName$1(variationPickerEmoji) : previewConfig.defaultCaption;
    return createElement(Fragment, null, createElement("div", null, show ? createElement(ViewOnlyEmoji, {
      unified: previewEmoji == null ? void 0 : previewEmoji.unified,
      emoji: emoji,
      emojiStyle: emojiStyle,
      size: 45,
      getEmojiUrl: getEmojiUrl,
      className: cx(styles$e.emoji)
    }) : defaultEmoji ? createElement(ViewOnlyEmoji, {
      unified: emojiUnified$1(defaultEmoji),
      emoji: defaultEmoji,
      emojiStyle: emojiStyle,
      size: 45,
      getEmojiUrl: getEmojiUrl,
      className: cx(styles$e.emoji)
    }) : null), createElement("div", {
      className: cx(styles$e.label)
    }, show ? emojiName$1(emoji) : defaultText));
  }
}
var styles$e = /*#__PURE__*/stylesheet.create({
  preview: {
    alignItems: 'center',
    borderTop: '1px solid var(--epr-preview-border-color)',
    height: 'var(--epr-preview-height)',
    padding: '0 var(--epr-horizontal-padding)',
    position: 'relative',
    zIndex: 'var(--epr-preview-z-index)'
  },
  label: {
    color: 'var(--epr-preview-text-color)',
    fontSize: 'var(--epr-preview-text-size)',
    padding: 'var(--epr-preview-text-padding)',
    textTransform: 'capitalize'
  },
  emoji: {
    padding: '0'
  },
  hideOnReactions: {
    opacity: '0',
    transition: 'opacity 0.5s ease-in-out'
  }
});
function categoryNameFromDom($category) {
  var _$category$getAttribu;
  return (_$category$getAttribu = $category == null ? void 0 : $category.getAttribute('data-name')) != null ? _$category$getAttribu : null;
}
function useActiveCategoryScrollDetection(_ref) {
  var setActiveCategory = _ref.setActiveCategory,
    setVisibleCategories = _ref.setVisibleCategories;
  var BodyRef = useBodyRef();
  useEffect(function () {
    var visibleCategories = new Map();
    var intersectingCategories = new Map();
    var bodyRef = BodyRef.current;
    var observer = new IntersectionObserver(function (entries) {
      if (!bodyRef) {
        return;
      }
      for (var _iterator = _createForOfIteratorHelperLoose(entries), _step; !(_step = _iterator()).done;) {
        var entry = _step.value;
        var _id = categoryNameFromDom(entry.target);
        if (!_id) {
          continue;
        }
        visibleCategories.set(_id, entry.intersectionRatio);
        intersectingCategories.set(_id, entry.isIntersecting);
      }
      var ratios = Array.from(visibleCategories);
      var visibleCats = ratios.filter(function (_ref2) {
        var id = _ref2[0],
          ratio = _ref2[1];
        return ratio > 0 || intersectingCategories.get(id);
      }).map(function (_ref3) {
        var id = _ref3[0];
        return id;
      });
      setVisibleCategories(visibleCats);
      var lastCategory = ratios[ratios.length - 1];
      if ((lastCategory == null ? void 0 : lastCategory[1]) == 1) {
        return setActiveCategory(lastCategory[0]);
      }
      for (var _i = 0, _ratios = ratios; _i < _ratios.length; _i++) {
        var _ratios$_i = _ratios[_i],
          id = _ratios$_i[0],
          ratio = _ratios$_i[1];
        if (ratio) {
          setActiveCategory(id);
          break;
        }
      }
    }, {
      root: bodyRef,
      threshold: [0, 1]
    });
    bodyRef == null ? void 0 : bodyRef.querySelectorAll(asSelectors(ClassNames.category)).forEach(function (el) {
      observer.observe(el);
    });
    return function () {
      observer.disconnect();
    };
  }, [BodyRef, setActiveCategory, setVisibleCategories]);
}
function useScrollCategoryIntoView() {
  var BodyRef = useBodyRef();
  var PickerMainRef = usePickerMainRef();
  return function scrollCategoryIntoView(category) {
    var _BodyRef$current;
    if (!BodyRef.current) {
      return;
    }
    var $category = (_BodyRef$current = BodyRef.current) == null ? void 0 : _BodyRef$current.querySelector("[data-name=\"" + category + "\"]");
    if (!$category) {
      return;
    }
    var offsetTop = $category.offsetTop || 0;
    scrollTo(PickerMainRef.current, offsetTop);
  };
}
function useShouldHideCustomEmojis() {
  var customCategoryConfig = useCustomEmojisConfig();
  if (!customCategoryConfig) {
    return false;
  }
  return customCategoryConfig.length === 0;
}
var SVGNavigation = 'data:image/svg+xml;base64,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';
function CategoryButton(_ref) {
  var _categoryConfig$icon, _cx;
  var isActiveCategory = _ref.isActiveCategory,
    category = _ref.category,
    allowNavigation = _ref.allowNavigation,
    categoryConfig = _ref.categoryConfig,
    onClick = _ref.onClick,
    customIcon = _ref.customIcon;
  // Priority: categoryConfig.icon > customIcon prop (from categoryIcons)
  var icon = (_categoryConfig$icon = categoryConfig.icon) != null ? _categoryConfig$icon : customIcon;
  var hasCustomIcon = icon != null;
  return createElement(Button, {
    tabIndex: allowNavigation ? 0 : -1,
    className: cx(styles$f.catBtn, commonInteractionStyles.categoryBtn, hasCustomIcon ? styles$f.customIcon : "epr-icn-" + category, (_cx = {}, _cx[ClassNames.active] = isActiveCategory, _cx)),
    onClick: onClick,
    "aria-label": categoryNameFromCategoryConfig(categoryConfig),
    "aria-selected": isActiveCategory,
    role: "tab",
    "aria-controls": "epr-category-nav-id"
  }, hasCustomIcon ? icon : null);
}
var DarkActivePositionY = {
  backgroundPositionY: 'calc(var(--epr-category-navigation-button-size) * 3)'
};
var DarkPositionY = {
  backgroundPositionY: 'calc(var(--epr-category-navigation-button-size) * 2)'
};
var DarkInactivePosition = {
  ':not(.epr-search-active)': {
    catBtn: {
      ':hover': DarkActivePositionY,
      '&.epr-active': DarkActivePositionY
    }
  }
};
var styles$f = /*#__PURE__*/stylesheet.create(/*#__PURE__*/_extends({
  catBtn: {
    '.': 'epr-cat-btn',
    display: 'inline-block',
    transition: 'opacity 0.2s ease-in-out',
    position: 'relative',
    height: 'var(--epr-category-navigation-button-size)',
    width: 'var(--epr-category-navigation-button-size)',
    backgroundSize: 'calc(var(--epr-category-navigation-button-size) * 10)',
    outline: 'none',
    backgroundPosition: '0 0',
    backgroundImage: "url(" + SVGNavigation + ")",
    ':focus:before': {
      content: '',
      position: 'absolute',
      top: '-2px',
      left: '-2px',
      right: '-2px',
      bottom: '-2px',
      border: '2px solid var(--epr-category-icon-active-color)',
      borderRadius: '50%'
    },
    '&.epr-icn-suggested': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -8)'
    },
    '&.epr-icn-custom': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -9)'
    },
    '&.epr-icn-activities': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -4)'
    },
    '&.epr-icn-animals_nature': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -1)'
    },
    '&.epr-icn-flags': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -7)'
    },
    '&.epr-icn-food_drink': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -2)'
    },
    '&.epr-icn-objects': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -5)'
    },
    '&.epr-icn-smileys_people': {
      backgroundPositionX: '0px'
    },
    '&.epr-icn-symbols': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -6)'
    },
    '&.epr-icn-travel_places': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -3)'
    }
  },
  customIcon: {
    '.': 'epr-cat-btn-custom-icon',
    backgroundImage: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}, /*#__PURE__*/darkMode('catBtn', DarkPositionY), {
  '.epr-dark-theme': /*#__PURE__*/_extends({}, DarkInactivePosition),
  '.epr-auto-theme': /*#__PURE__*/_extends({}, DarkInactivePosition)
}));
function CategoryNavigation() {
  var _useState = useState(null),
    activeCategory = _useState[0],
    setActiveCategory = _useState[1];
  var _useVisibleCategories = useVisibleCategoriesState(),
    setVisibleCategories = _useVisibleCategories[1];
  var scrollCategoryIntoView = useScrollCategoryIntoView();
  useActiveCategoryScrollDetection({
    setActiveCategory: setActiveCategory,
    setVisibleCategories: setVisibleCategories
  });
  var isSearchMode = useIsSearchMode();
  var categoriesConfig = useCategoriesConfig();
  var categoryIcons = useCategoryIconsConfig();
  var CategoryNavigationRef = useCategoryNavigationRef();
  var hideCustomCategory = useShouldHideCustomEmojis();
  return createElement("div", {
    className: cx(styles$g.nav),
    role: "tablist",
    "aria-label": "Category navigation",
    id: "epr-category-nav-id",
    ref: CategoryNavigationRef
  }, categoriesConfig.map(function (categoryConfig) {
    var category = categoryFromCategoryConfig(categoryConfig);
    var isActiveCategory = category === activeCategory;
    if (isCustomCategory(categoryConfig) && hideCustomCategory) {
      return null;
    }
    var allowNavigation = !isSearchMode && !isActiveCategory;
    return createElement(CategoryButton, {
      key: category,
      category: category,
      isActiveCategory: isActiveCategory,
      allowNavigation: allowNavigation,
      categoryConfig: categoryConfig,
      customIcon: categoryIcons[category],
      onClick: function onClick() {
        scrollCategoryIntoView(category);
        setTimeout(function () {
          setActiveCategory(category);
        }, 10);
      }
    });
  }));
}
var styles$g = /*#__PURE__*/stylesheet.create({
  nav: {
    '.': 'epr-category-nav',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    padding: 'var(--epr-header-padding)'
  },
  '.epr-search-active': {
    nav: {
      opacity: '0.3',
      cursor: 'default',
      pointerEvents: 'none'
    }
  },
  '.epr-main:has(input:not(:placeholder-shown))': {
    nav: {
      opacity: '0.3',
      cursor: 'default',
      pointerEvents: 'none'
    }
  }
});
var SVGTimes = 'data:image/svg+xml;base64,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';
function BtnClearSearch() {
  var clearSearch = useClearSearch();
  var searchClearButtonLabel = useSearchClearButtonLabelConfig();
  return createElement(Button, {
    className: cx(styles$h.btnClearSearch, commonInteractionStyles.visibleOnSearchOnly),
    onClick: clearSearch,
    "aria-label": searchClearButtonLabel,
    title: searchClearButtonLabel
  }, createElement("div", {
    className: cx(styles$h.icnClearnSearch)
  }));
}
var HoverDark = {
  ':hover': {
    '> .epr-icn-clear-search': {
      backgroundPositionY: '-60px'
    }
  }
};
var styles$h = /*#__PURE__*/stylesheet.create(/*#__PURE__*/_extends({
  btnClearSearch: {
    '.': 'epr-btn-clear-search',
    position: 'absolute',
    right: 'var(--epr-search-bar-inner-padding)',
    height: '30px',
    width: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: '50%',
    transform: 'translateY(-50%)',
    padding: '0',
    borderRadius: '50%',
    ':hover': {
      background: 'var(--epr-hover-bg-color)'
    },
    ':focus': {
      background: 'var(--epr-hover-bg-color)'
    }
  },
  icnClearnSearch: {
    '.': 'epr-icn-clear-search',
    backgroundColor: 'transparent',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '20px',
    height: '20px',
    width: '20px',
    backgroundImage: "url(" + SVGTimes + ")",
    ':hover': {
      backgroundPositionY: '-20px'
    },
    ':focus': {
      backgroundPositionY: '-20px'
    }
  }
}, /*#__PURE__*/darkMode('icnClearnSearch', {
  backgroundPositionY: '-40px'
}), /*#__PURE__*/darkMode('btnClearSearch', HoverDark)));
var SVGMagnifier = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIyMHB4IiBoZWlnaHQ9IjQwcHgiIHZpZXdCb3g9IjAgMCAyMCA0MCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjAgNDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzg2ODY4NiIgZD0iTTEyLDguODFjMCwyLjA4LTEuNjgsMy43Ni0zLjc2LDMuNzZjLTIuMDgsMC0zLjc2LTEuNjgtMy43Ni0zLjc2CgljMC0yLjA4LDEuNjgtMy43NiwzLjc2LTMuNzZDMTAuMzIsNS4wNSwxMiw2LjczLDEyLDguODF6IE0xMS4yMywxMi43MmMtMC44MywwLjY0LTEuODcsMS4wMS0yLjk5LDEuMDFjLTIuNzIsMC00LjkyLTIuMi00LjkyLTQuOTIKCWMwLTIuNzIsMi4yLTQuOTIsNC45Mi00LjkyYzIuNzIsMCw0LjkyLDIuMiw0LjkyLDQuOTJjMCwxLjEzLTAuMzgsMi4xNi0xLjAxLDIuOTlsMy45NCwzLjkzYzAuMjUsMC4yNSwwLjI1LDAuNjYsMCwwLjkyCgljLTAuMjUsMC4yNS0wLjY2LDAuMjUtMC45MiwwTDExLjIzLDEyLjcyeiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI0MwQzBCRiIgZD0iTTEyLDI4LjgxYzAsMi4wOC0xLjY4LDMuNzYtMy43NiwzLjc2Yy0yLjA4LDAtMy43Ni0xLjY4LTMuNzYtMy43NgoJYzAtMi4wOCwxLjY4LTMuNzYsMy43Ni0zLjc2QzEwLjMyLDI1LjA1LDEyLDI2LjczLDEyLDI4LjgxeiBNMTEuMjMsMzIuNzJjLTAuODMsMC42NC0xLjg3LDEuMDEtMi45OSwxLjAxCgljLTIuNzIsMC00LjkyLTIuMi00LjkyLTQuOTJjMC0yLjcyLDIuMi00LjkyLDQuOTItNC45MmMyLjcyLDAsNC45MiwyLjIsNC45Miw0LjkyYzAsMS4xMy0wLjM4LDIuMTYtMS4wMSwyLjk5bDMuOTQsMy45MwoJYzAuMjUsMC4yNSwwLjI1LDAuNjYsMCwwLjkyYy0wLjI1LDAuMjUtMC42NiwwLjI1LTAuOTIsMEwxMS4yMywzMi43MnoiLz4KPC9zdmc+';
function IcnSearch() {
  return createElement("div", {
    className: cx(styles$i.icnSearch)
  });
}
var styles$i = /*#__PURE__*/stylesheet.create(/*#__PURE__*/_extends({
  icnSearch: {
    '.': 'epr-icn-search',
    content: '',
    position: 'absolute',
    top: '50%',
    left: 'var(--epr-search-bar-inner-padding)',
    transform: 'translateY(-50%)',
    width: '20px',
    height: '20px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0 0',
    backgroundSize: '20px',
    backgroundImage: "url(" + SVGMagnifier + ")"
  }
}, /*#__PURE__*/darkMode('icnSearch', {
  backgroundPositionY: '-20px'
})));
function SearchContainer() {
  var searchDisabled = useSearchDisabledConfig();
  var isSkinToneInSearch = useIsSkinToneInSearch();
  if (searchDisabled) {
    return null;
  }
  return createElement(Flex, {
    className: cx(styles$j.overlay)
  }, createElement(Search, null), isSkinToneInSearch ? createElement(SkinTonePicker, null) : null);
}
function Search() {
  var closeAllOpenToggles = useCloseAllOpenToggles();
  var SearchInputRef = useSearchInputRef();
  var placeholder = useSearchPlaceHolderConfig();
  var autoFocus = useAutoFocusSearchConfig();
  var _useFilter = useFilter(),
    statusSearchResults = _useFilter.statusSearchResults,
    searchTerm = _useFilter.searchTerm,
    _onChange = _useFilter.onChange;
  var input = SearchInputRef == null ? void 0 : SearchInputRef.current;
  var value = input == null ? void 0 : input.value;
  return createElement(Relative, {
    className: cx(styles$j.searchContainer)
  }, createElement("input", {
    // eslint-disable-next-line jsx-a11y/no-autofocus
    autoFocus: autoFocus,
    "aria-label": 'Type to search for an emoji',
    onFocus: closeAllOpenToggles,
    className: cx(styles$j.search),
    type: "text",
    "aria-controls": "epr-search-id",
    placeholder: placeholder,
    onChange: function onChange(event) {
      var _event$target$value, _event$target;
      _onChange((_event$target$value = event == null ? void 0 : (_event$target = event.target) == null ? void 0 : _event$target.value) != null ? _event$target$value : value);
    },
    ref: SearchInputRef
  }), searchTerm ? createElement("div", {
    role: "status",
    className: cx('epr-status-search-results', styles$j.visuallyHidden),
    "aria-live": "polite",
    id: "epr-search-id",
    "aria-atomic": "true"
  }, statusSearchResults) : null, createElement(IcnSearch, null), createElement(BtnClearSearch, null));
}
var styles$j = /*#__PURE__*/stylesheet.create(/*#__PURE__*/_extends({
  overlay: {
    padding: 'var(--epr-header-padding)',
    zIndex: 'var(--epr-header-overlay-z-index)'
  },
  searchContainer: {
    '.': 'epr-search-container',
    flex: '1',
    display: 'block',
    minWidth: '0'
  },
  visuallyHidden: {
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  },
  search: {
    outline: 'none',
    transition: 'all 0.2s ease-in-out',
    color: 'var(--epr-search-input-text-color)',
    borderRadius: 'var(--epr-search-input-border-radius)',
    padding: 'var(--epr-search-input-padding)',
    height: 'var(--epr-search-input-height)',
    backgroundColor: 'var(--epr-search-input-bg-color)',
    border: '1px solid var(--epr-search-border-color)',
    width: '100%',
    ':focus': {
      backgroundColor: 'var(--epr-search-input-bg-color-active)',
      border: '1px solid var(--epr-search-border-color-active)'
    },
    '::placeholder': {
      color: 'var(--epr-search-input-placeholder-color)'
    }
  },
  btnClearSearch: {
    '.': 'epr-btn-clear-search',
    position: 'absolute',
    right: 'var(--epr-search-bar-inner-padding)',
    height: '30px',
    width: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: '50%',
    transform: 'translateY(-50%)',
    padding: '0',
    borderRadius: '50%',
    ':hover': {
      background: 'var(--epr-hover-bg-color)'
    },
    ':focus': {
      background: 'var(--epr-hover-bg-color)'
    }
  },
  icnClearnSearch: {
    '.': 'epr-icn-clear-search',
    backgroundColor: 'transparent',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '20px',
    height: '20px',
    width: '20px',
    backgroundImage: "url(" + SVGTimes + ")",
    ':hover': {
      backgroundPositionY: '-20px'
    },
    ':focus': {
      backgroundPositionY: '-20px'
    }
  }
}, /*#__PURE__*/darkMode('icnClearnSearch', {
  backgroundPositionY: '-40px'
}), /*#__PURE__*/darkMode('btnClearSearch', {
  ':hover > .epr-icn-clear-search': {
    backgroundPositionY: '-60px'
  }
})));
function Header() {
  return createElement(Relative, {
    className: cx('epr-header', commonInteractionStyles.hiddenOnReactions)
  }, createElement(SearchContainer, null), createElement(CategoryNavigation, null));
}
function EmojiPicker(props) {
  return createElement(ElementRefContextProvider, null, createElement(PickerStyleTag, {
    nonce: props.nonce
  }), createElement(PickerConfigProvider, Object.assign({}, props), createElement(PickerDataProvider, null, createElement(ContentControl, null))));
}
function ContentControl() {
  var _useReactionsModeStat = useReactionsModeState(),
    reactionsDefaultOpen = _useReactionsModeStat[0];
  var allowExpandReactions = useAllowExpandReactions();
  var _React$useState = useState(!reactionsDefaultOpen),
    renderAll = _React$useState[0],
    setRenderAll = _React$useState[1];
  var isOpen = useOpenConfig();
  useEffect(function () {
    if (reactionsDefaultOpen && !allowExpandReactions) {
      return;
    }
    if (!renderAll) {
      setRenderAll(true);
    }
  }, [renderAll, allowExpandReactions, reactionsDefaultOpen]);
  if (!isOpen) {
    return null;
  }
  return createElement(PickerMain, null, createElement(Reactions, null), createElement(ExpandedPickerContent, {
    renderAll: renderAll
  }));
}
function ExpandedPickerContent(_ref) {
  var renderAll = _ref.renderAll;
  if (!renderAll) {
    return null;
  }
  return createElement(Fragment, null, createElement(Header, null), createElement(Body, null), createElement(Preview, null));
}
// eslint-disable-next-line complexity
var EmojiPickerReact = /*#__PURE__*/memo(EmojiPicker, compareConfig);
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);
  function ErrorBoundary(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }
  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
    return {
      hasError: true
    };
  };
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('Emoji Picker React failed to render:', error, errorInfo);
  };
  _proto.render = function render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  };
  return ErrorBoundary;
}(Component);
function EmojiPicker$1(props) {
  var MutableConfigRef = useDefineMutableConfig({
    onEmojiClick: props.onEmojiClick,
    onReactionClick: props.onReactionClick,
    onSkinToneChange: props.onSkinToneChange
  });
  return createElement(ErrorBoundary, null, createElement(MutableConfigContext.Provider, {
    value: MutableConfigRef
  }, createElement(EmojiPickerReact, Object.assign({}, props))));
}

/*!
 * mustache.js - Logic-less {{mustache}} templates with JavaScript
 * http://github.com/janl/mustache.js
 */

var objectToString = Object.prototype.toString;
var isArray = Array.isArray || function isArrayPolyfill(object) {
  return objectToString.call(object) === '[object Array]';
};
function isFunction(object) {
  return typeof object === 'function';
}

/**
 * More correct typeof string handling array
 * which normally returns typeof 'object'
 */
function typeStr(obj) {
  return isArray(obj) ? 'array' : typeof obj;
}
function escapeRegExp(string) {
  return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
}

/**
 * Null safe way of checking whether or not an object,
 * including its prototype, has a given property
 */
function hasProperty(obj, propName) {
  return obj != null && typeof obj === 'object' && propName in obj;
}

/**
 * Safe way of detecting whether or not the given thing is a primitive and
 * whether it has the given property
 */
function primitiveHasOwnProperty(primitive, propName) {
  return primitive != null && typeof primitive !== 'object' && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
}

// Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
// See https://github.com/janl/mustache.js/issues/189
var regExpTest = RegExp.prototype.test;
function testRegExp(re, string) {
  return regExpTest.call(re, string);
}
var nonSpaceRe = /\S/;
function isWhitespace(string) {
  return !testRegExp(nonSpaceRe, string);
}
var entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;',
  '`': '&#x60;',
  '=': '&#x3D;'
};
function escapeHtml(string) {
  return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
    return entityMap[s];
  });
}
var whiteRe = /\s*/;
var spaceRe = /\s+/;
var equalsRe = /\s*=/;
var curlyRe = /\s*\}/;
var tagRe = /#|\^|\/|>|\{|&|=|!/;

/**
 * Breaks up the given `template` string into a tree of tokens. If the `tags`
 * argument is given here it must be an array with two string values: the
 * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
 * course, the default is to use mustaches (i.e. mustache.tags).
 *
 * A token is an array with at least 4 elements. The first element is the
 * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
 * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
 * all text that appears outside a symbol this element is "text".
 *
 * The second element of a token is its "value". For mustache tags this is
 * whatever else was inside the tag besides the opening symbol. For text tokens
 * this is the text itself.
 *
 * The third and fourth elements of the token are the start and end indices,
 * respectively, of the token in the original template.
 *
 * Tokens that are the root node of a subtree contain two more elements: 1) an
 * array of tokens in the subtree and 2) the index in the original template at
 * which the closing tag for that section begins.
 *
 * Tokens for partials also contain two more elements: 1) a string value of
 * indendation prior to that tag and 2) the index of that tag on that line -
 * eg a value of 2 indicates the partial is the third tag on this line.
 */
function parseTemplate(template, tags) {
  if (!template) return [];
  var lineHasNonSpace = false;
  var sections = []; // Stack to hold section tokens
  var tokens = []; // Buffer to hold the tokens
  var spaces = []; // Indices of whitespace tokens on the current line
  var hasTag = false; // Is there a {{tag}} on the current line?
  var nonSpace = false; // Is there a non-space char on the current line?
  var indentation = ''; // Tracks indentation for tags that use it
  var tagIndex = 0; // Stores a count of number of tags encountered on a line

  // Strips all whitespace tokens array for the current line
  // if there was a {{#tag}} on it and otherwise only space.
  function stripSpace() {
    if (hasTag && !nonSpace) {
      while (spaces.length) delete tokens[spaces.pop()];
    } else {
      spaces = [];
    }
    hasTag = false;
    nonSpace = false;
  }
  var openingTagRe, closingTagRe, closingCurlyRe;
  function compileTags(tagsToCompile) {
    if (typeof tagsToCompile === 'string') tagsToCompile = tagsToCompile.split(spaceRe, 2);
    if (!isArray(tagsToCompile) || tagsToCompile.length !== 2) throw new Error('Invalid tags: ' + tagsToCompile);
    openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
    closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
    closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
  }
  compileTags(tags || mustache.tags);
  var scanner = new Scanner(template);
  var start, type, value, chr, token, openSection;
  while (!scanner.eos()) {
    start = scanner.pos;

    // Match any text between tags.
    value = scanner.scanUntil(openingTagRe);
    if (value) {
      for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
        chr = value.charAt(i);
        if (isWhitespace(chr)) {
          spaces.push(tokens.length);
          indentation += chr;
        } else {
          nonSpace = true;
          lineHasNonSpace = true;
          indentation += ' ';
        }
        tokens.push(['text', chr, start, start + 1]);
        start += 1;

        // Check for whitespace on the current line.
        if (chr === '\n') {
          stripSpace();
          indentation = '';
          tagIndex = 0;
          lineHasNonSpace = false;
        }
      }
    }

    // Match the opening tag.
    if (!scanner.scan(openingTagRe)) break;
    hasTag = true;

    // Get the tag type.
    type = scanner.scan(tagRe) || 'name';
    scanner.scan(whiteRe);

    // Get the tag value.
    if (type === '=') {
      value = scanner.scanUntil(equalsRe);
      scanner.scan(equalsRe);
      scanner.scanUntil(closingTagRe);
    } else if (type === '{') {
      value = scanner.scanUntil(closingCurlyRe);
      scanner.scan(curlyRe);
      scanner.scanUntil(closingTagRe);
      type = '&';
    } else {
      value = scanner.scanUntil(closingTagRe);
    }

    // Match the closing tag.
    if (!scanner.scan(closingTagRe)) throw new Error('Unclosed tag at ' + scanner.pos);
    if (type == '>') {
      token = [type, value, start, scanner.pos, indentation, tagIndex, lineHasNonSpace];
    } else {
      token = [type, value, start, scanner.pos];
    }
    tagIndex++;
    tokens.push(token);
    if (type === '#' || type === '^') {
      sections.push(token);
    } else if (type === '/') {
      // Check section nesting.
      openSection = sections.pop();
      if (!openSection) throw new Error('Unopened section "' + value + '" at ' + start);
      if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
    } else if (type === 'name' || type === '{' || type === '&') {
      nonSpace = true;
    } else if (type === '=') {
      // Set the tags for the next time around.
      compileTags(value);
    }
  }
  stripSpace();

  // Make sure there are no open sections when we're done.
  openSection = sections.pop();
  if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
  return nestTokens(squashTokens(tokens));
}

/**
 * Combines the values of consecutive text tokens in the given `tokens` array
 * to a single token.
 */
function squashTokens(tokens) {
  var squashedTokens = [];
  var token, lastToken;
  for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
    token = tokens[i];
    if (token) {
      if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
        lastToken[1] += token[1];
        lastToken[3] = token[3];
      } else {
        squashedTokens.push(token);
        lastToken = token;
      }
    }
  }
  return squashedTokens;
}

/**
 * Forms the given array of `tokens` into a nested tree structure where
 * tokens that represent a section have two additional items: 1) an array of
 * all tokens that appear in that section and 2) the index in the original
 * template that represents the end of that section.
 */
function nestTokens(tokens) {
  var nestedTokens = [];
  var collector = nestedTokens;
  var sections = [];
  var token, section;
  for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
    token = tokens[i];
    switch (token[0]) {
      case '#':
      case '^':
        collector.push(token);
        sections.push(token);
        collector = token[4] = [];
        break;
      case '/':
        section = sections.pop();
        section[5] = token[2];
        collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
        break;
      default:
        collector.push(token);
    }
  }
  return nestedTokens;
}

/**
 * A simple string scanner that is used by the template parser to find
 * tokens in template strings.
 */
function Scanner(string) {
  this.string = string;
  this.tail = string;
  this.pos = 0;
}

/**
 * Returns `true` if the tail is empty (end of string).
 */
Scanner.prototype.eos = function eos() {
  return this.tail === '';
};

/**
 * Tries to match the given regular expression at the current position.
 * Returns the matched text if it can match, the empty string otherwise.
 */
Scanner.prototype.scan = function scan(re) {
  var match = this.tail.match(re);
  if (!match || match.index !== 0) return '';
  var string = match[0];
  this.tail = this.tail.substring(string.length);
  this.pos += string.length;
  return string;
};

/**
 * Skips all text until the given regular expression can be matched. Returns
 * the skipped string, which is the entire tail if no match can be made.
 */
Scanner.prototype.scanUntil = function scanUntil(re) {
  var index = this.tail.search(re),
    match;
  switch (index) {
    case -1:
      match = this.tail;
      this.tail = '';
      break;
    case 0:
      match = '';
      break;
    default:
      match = this.tail.substring(0, index);
      this.tail = this.tail.substring(index);
  }
  this.pos += match.length;
  return match;
};

/**
 * Represents a rendering context by wrapping a view object and
 * maintaining a reference to the parent context.
 */
function Context(view, parentContext) {
  this.view = view;
  this.cache = {
    '.': this.view
  };
  this.parent = parentContext;
}

/**
 * Creates a new context using the given view with this context
 * as the parent.
 */
Context.prototype.push = function push(view) {
  return new Context(view, this);
};

/**
 * Returns the value of the given name in this context, traversing
 * up the context hierarchy if the value is absent in this context's view.
 */
Context.prototype.lookup = function lookup(name) {
  var cache = this.cache;
  var value;
  if (cache.hasOwnProperty(name)) {
    value = cache[name];
  } else {
    var context = this,
      intermediateValue,
      names,
      index,
      lookupHit = false;
    while (context) {
      if (name.indexOf('.') > 0) {
        intermediateValue = context.view;
        names = name.split('.');
        index = 0;

        /**
         * Using the dot notion path in `name`, we descend through the
         * nested objects.
         *
         * To be certain that the lookup has been successful, we have to
         * check if the last object in the path actually has the property
         * we are looking for. We store the result in `lookupHit`.
         *
         * This is specially necessary for when the value has been set to
         * `undefined` and we want to avoid looking up parent contexts.
         *
         * In the case where dot notation is used, we consider the lookup
         * to be successful even if the last "object" in the path is
         * not actually an object but a primitive (e.g., a string, or an
         * integer), because it is sometimes useful to access a property
         * of an autoboxed primitive, such as the length of a string.
         **/
        while (intermediateValue != null && index < names.length) {
          if (index === names.length - 1) lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
          intermediateValue = intermediateValue[names[index++]];
        }
      } else {
        intermediateValue = context.view[name];

        /**
         * Only checking against `hasProperty`, which always returns `false` if
         * `context.view` is not an object. Deliberately omitting the check
         * against `primitiveHasOwnProperty` if dot notation is not used.
         *
         * Consider this example:
         * ```
         * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
         * ```
         *
         * If we were to check also against `primitiveHasOwnProperty`, as we do
         * in the dot notation case, then render call would return:
         *
         * "The length of a football field is 9."
         *
         * rather than the expected:
         *
         * "The length of a football field is 100 yards."
         **/
        lookupHit = hasProperty(context.view, name);
      }
      if (lookupHit) {
        value = intermediateValue;
        break;
      }
      context = context.parent;
    }
    cache[name] = value;
  }
  if (isFunction(value)) value = value.call(this.view);
  return value;
};

/**
 * A Writer knows how to take a stream of tokens and render them to a
 * string, given a context. It also maintains a cache of templates to
 * avoid the need to parse the same template twice.
 */
function Writer() {
  this.templateCache = {
    _cache: {},
    set: function set(key, value) {
      this._cache[key] = value;
    },
    get: function get(key) {
      return this._cache[key];
    },
    clear: function clear() {
      this._cache = {};
    }
  };
}

/**
 * Clears all cached templates in this writer.
 */
Writer.prototype.clearCache = function clearCache() {
  if (typeof this.templateCache !== 'undefined') {
    this.templateCache.clear();
  }
};

/**
 * Parses and caches the given `template` according to the given `tags` or
 * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
 * that is generated from the parse.
 */
Writer.prototype.parse = function parse(template, tags) {
  var cache = this.templateCache;
  var cacheKey = template + ':' + (tags || mustache.tags).join(':');
  var isCacheEnabled = typeof cache !== 'undefined';
  var tokens = isCacheEnabled ? cache.get(cacheKey) : undefined;
  if (tokens == undefined) {
    tokens = parseTemplate(template, tags);
    isCacheEnabled && cache.set(cacheKey, tokens);
  }
  return tokens;
};

/**
 * High-level method that is used to render the given `template` with
 * the given `view`.
 *
 * The optional `partials` argument may be an object that contains the
 * names and templates of partials that are used in the template. It may
 * also be a function that is used to load partial templates on the fly
 * that takes a single argument: the name of the partial.
 *
 * If the optional `config` argument is given here, then it should be an
 * object with a `tags` attribute or an `escape` attribute or both.
 * If an array is passed, then it will be interpreted the same way as
 * a `tags` attribute on a `config` object.
 *
 * The `tags` attribute of a `config` object must be an array with two
 * string values: the opening and closing tags used in the template (e.g.
 * [ "<%", "%>" ]). The default is to mustache.tags.
 *
 * The `escape` attribute of a `config` object must be a function which
 * accepts a string as input and outputs a safely escaped string.
 * If an `escape` function is not provided, then an HTML-safe string
 * escaping function is used as the default.
 */
Writer.prototype.render = function render(template, view, partials, config) {
  var tags = this.getConfigTags(config);
  var tokens = this.parse(template, tags);
  var context = view instanceof Context ? view : new Context(view, undefined);
  return this.renderTokens(tokens, context, partials, template, config);
};

/**
 * Low-level method that renders the given array of `tokens` using
 * the given `context` and `partials`.
 *
 * Note: The `originalTemplate` is only ever used to extract the portion
 * of the original template that was contained in a higher-order section.
 * If the template doesn't use higher-order sections, this argument may
 * be omitted.
 */
Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
  var buffer = '';
  var token, symbol, value;
  for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
    value = undefined;
    token = tokens[i];
    symbol = token[0];
    if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate, config);else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate, config);else if (symbol === '>') value = this.renderPartial(token, context, partials, config);else if (symbol === '&') value = this.unescapedValue(token, context);else if (symbol === 'name') value = this.escapedValue(token, context, config);else if (symbol === 'text') value = this.rawValue(token);
    if (value !== undefined) buffer += value;
  }
  return buffer;
};
Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
  var self = this;
  var buffer = '';
  var value = context.lookup(token[1]);

  // This function is used to render an arbitrary template
  // in the current context by higher-order sections.
  function subRender(template) {
    return self.render(template, context, partials, config);
  }
  if (!value) return;
  if (isArray(value)) {
    for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
      buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
    }
  } else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') {
    buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
  } else if (isFunction(value)) {
    if (typeof originalTemplate !== 'string') throw new Error('Cannot use higher-order sections without the original template');

    // Extract the portion of the original template that the section contains.
    value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
    if (value != null) buffer += value;
  } else {
    buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
  }
  return buffer;
};
Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
  var value = context.lookup(token[1]);

  // Use JavaScript's definition of falsy. Include empty arrays.
  // See https://github.com/janl/mustache.js/issues/186
  if (!value || isArray(value) && value.length === 0) return this.renderTokens(token[4], context, partials, originalTemplate, config);
};
Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
  var filteredIndentation = indentation.replace(/[^ \t]/g, '');
  var partialByNl = partial.split('\n');
  for (var i = 0; i < partialByNl.length; i++) {
    if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) {
      partialByNl[i] = filteredIndentation + partialByNl[i];
    }
  }
  return partialByNl.join('\n');
};
Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
  if (!partials) return;
  var tags = this.getConfigTags(config);
  var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
  if (value != null) {
    var lineHasNonSpace = token[6];
    var tagIndex = token[5];
    var indentation = token[4];
    var indentedValue = value;
    if (tagIndex == 0 && indentation) {
      indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
    }
    var tokens = this.parse(indentedValue, tags);
    return this.renderTokens(tokens, context, partials, indentedValue, config);
  }
};
Writer.prototype.unescapedValue = function unescapedValue(token, context) {
  var value = context.lookup(token[1]);
  if (value != null) return value;
};
Writer.prototype.escapedValue = function escapedValue(token, context, config) {
  var escape = this.getConfigEscape(config) || mustache.escape;
  var value = context.lookup(token[1]);
  if (value != null) return typeof value === 'number' && escape === mustache.escape ? String(value) : escape(value);
};
Writer.prototype.rawValue = function rawValue(token) {
  return token[1];
};
Writer.prototype.getConfigTags = function getConfigTags(config) {
  if (isArray(config)) {
    return config;
  } else if (config && typeof config === 'object') {
    return config.tags;
  } else {
    return undefined;
  }
};
Writer.prototype.getConfigEscape = function getConfigEscape(config) {
  if (config && typeof config === 'object' && !isArray(config)) {
    return config.escape;
  } else {
    return undefined;
  }
};
var mustache = {
  name: 'mustache.js',
  version: '4.2.0',
  tags: ['{{', '}}'],
  clearCache: undefined,
  escape: undefined,
  parse: undefined,
  render: undefined,
  Scanner: undefined,
  Context: undefined,
  Writer: undefined,
  /**
   * Allows a user to override the default caching strategy, by providing an
   * object with set, get and clear methods. This can also be used to disable
   * the cache by setting it to the literal `undefined`.
   */
  set templateCache(cache) {
    defaultWriter.templateCache = cache;
  },
  /**
   * Gets the default or overridden caching object from the default writer.
   */
  get templateCache() {
    return defaultWriter.templateCache;
  }
};

// All high-level mustache.* functions use this writer.
var defaultWriter = new Writer();

/**
 * Clears all cached templates in the default writer.
 */
mustache.clearCache = function clearCache() {
  return defaultWriter.clearCache();
};

/**
 * Parses and caches the given template in the default writer and returns the
 * array of tokens it contains. Doing this ahead of time avoids the need to
 * parse templates on the fly as they are rendered.
 */
mustache.parse = function parse(template, tags) {
  return defaultWriter.parse(template, tags);
};

/**
 * Renders the `template` with the given `view`, `partials`, and `config`
 * using the default writer.
 */
mustache.render = function render(template, view, partials, config) {
  if (typeof template !== 'string') {
    throw new TypeError('Invalid template! Template should be a "string" ' + 'but "' + typeStr(template) + '" was given as the first ' + 'argument for mustache#render(template, view, partials)');
  }
  return defaultWriter.render(template, view, partials, config);
};

// Export the escaping function so that the user may override it.
// See https://github.com/janl/mustache.js/issues/244
mustache.escape = escapeHtml;

// Export these mainly for testing, but also for advanced usage.
mustache.Scanner = Scanner;
mustache.Context = Context;
mustache.Writer = Writer;
var styles$4 = {
  "hoverAnim": "emoji-module_hoverAnim__KPvgD",
  "faded": "emoji-module_faded__HDF1H"
};
var Emoji = function Emoji(_ref119) {
  var value = _ref119.value,
    _onClick4 = _ref119.onClick,
    _ref119$size = _ref119.size,
    size = _ref119$size === void 0 ? '20px' : _ref119$size,
    _ref119$disabled = _ref119.disabled,
    disabled = _ref119$disabled === void 0 ? false : _ref119$disabled;
  return React$2.createElement("div", {
    style: {
      width: size,
      height: size
    },
    onClick: function onClick(e) {
      e.stopPropagation();
      if (_onClick4 && !disabled) {
        _onClick4(value);
      }
    },
    className: classnames(_defineProperty2(_defineProperty2({}, styles$4.hoverAnim, !disabled), styles$4.faded, disabled))
  }, React$2.createElement("svg", {
    viewBox: "-50 -50 100 100",
    preserveAspectRatio: "xMidYMid meet"
  }, React$2.createElement("text", {
    fontSize: "100",
    textAnchor: "middle",
    dominantBaseline: "middle",
    dy: "10"
  }, value)));
};
var addReactionAsset = "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url%28%23clip0_401_1693%29%22%3E%3Cpath%20d%3D%22M20.8892%2010.5921C21.1928%2012.5092%2020.8686%2014.473%2019.9648%2016.1907C19.061%2017.9085%2017.6261%2019.288%2015.8742%2020.1235C14.1222%2020.959%2012.1471%2021.2057%2010.2435%2020.8269C8.33985%2020.4481%206.60968%2019.464%205.31106%2018.0215C4.01245%2016.5789%203.215%2014.7552%203.03765%2012.8223C2.8603%2010.8895%203.31256%208.95109%204.32698%207.2963C5.34139%205.64152%206.8636%204.35901%208.66652%203.6401C10.4694%202.92119%2012.4565%202.8044%2014.3312%203.30716%22%20stroke%3D%22black%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M16%205H22M19%202V8%22%20stroke%3D%22black%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M9%209H9.01%22%20stroke%3D%22black%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M15%209H15.01%22%20stroke%3D%22black%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8%2013C8%2014.0609%208.42143%2015.0783%209.17157%2015.8284C9.92172%2016.5786%2010.9391%2017%2012%2017C13.0609%2017%2014.0783%2016.5786%2014.8284%2015.8284C15.5786%2015.0783%2016%2014.0609%2016%2013M16%2013H8%22%20stroke%3D%22black%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_401_1693%22%3E%3Crect%20width%3D%2224%22%20height%3D%2224%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";
var styles$3 = {
  "selected": "emoji-picker-button-module_selected__R--Y8",
  "addReactionContainer": "emoji-picker-button-module_addReactionContainer__28IWL"
};
var EmojiPickerButton = function EmojiPickerButton(_ref120) {
  var _onClick5 = _ref120.onClick,
    _ref120$isOpen = _ref120.isOpen,
    isOpen = _ref120$isOpen === void 0 ? false : _ref120$isOpen;
  return React$2.createElement("div", {
    className: classnames(styles$3.addReactionContainer, _defineProperty2({}, styles$3.selected, isOpen))
  }, React$2.createElement("img", {
    src: addReactionAsset,
    onClick: function onClick() {
      if (_onClick5) {
        _onClick5();
      }
    }
  }));
};
var styles$2 = {
  "container": "emoji-control-module_container__JuBlN",
  "soloPicked": "emoji-control-module_soloPicked__fSnm1",
  "loader": "emoji-control-module_loader__OTsO0",
  "soloLoader": "emoji-control-module_soloLoader__A5XEU",
  "solo": "emoji-control-module_solo__mt-rI",
  "main": "emoji-control-module_main__pmbC8",
  "selectedPaddingTop": "emoji-control-module_selectedPaddingTop__keloO",
  "message": "emoji-control-module_message__m7txV",
  "pickerRow": "emoji-control-module_pickerRow__F6jY-",
  "pickerCopy": "emoji-control-module_pickerCopy__aRo3Z",
  "quickEmojiBar": "emoji-control-module_quickEmojiBar__tTGTT",
  "largeEmojiBar": "emoji-control-module_largeEmojiBar__s9roj",
  "emojiBarContainer": "emoji-control-module_emojiBarContainer__045h2",
  "error": "emoji-control-module_error__-VtOY",
  "picker": "emoji-control-module_picker__9bTrJ",
  "showPicker": "emoji-control-module_showPicker__1cINs",
  "hidden": "emoji-control-module_hidden__YajaS"
};
var EmojiControl = function EmojiControl(_ref121) {
  var value = _ref121.value,
    onEmojiSelected = _ref121.onEmojiSelected,
    _ref121$sender = _ref121.sender,
    sender = _ref121$sender === void 0 ? '' : _ref121$sender,
    _ref121$solo = _ref121.solo,
    solo = _ref121$solo === void 0 ? false : _ref121$solo,
    _ref121$loading = _ref121.loading,
    loading = _ref121$loading === void 0 ? false : _ref121$loading,
    _ref121$error = _ref121.error,
    error = _ref121$error === void 0 ? '' : _ref121$error;
  var _useThemeContext23 = useThemeContext(),
    reaction = _useThemeContext23.reaction;
  var ref = createRef();
  var _useState48 = useState(false),
    _useState49 = _slicedToArray(_useState48, 2),
    showPicker = _useState49[0],
    setShowPicker = _useState49[1];
  var hasPickedEmoji = Boolean(value);
  var onOutsideClick = function onOutsideClick(e) {
    var node = ref.current;
    var active = document.activeElement;
    if ((active === null || active === void 0 ? void 0 : active.classList.contains('epr-search')) || (active === null || active === void 0 ? void 0 : active.classList.contains('epr-btn'))) {
      return;
    }
    if (!(node === null || node === void 0 ? void 0 : node.contains(e.target))) {
      setShowPicker(false);
    }
  };
  useEffect(function () {
    document.addEventListener('click', onOutsideClick, true);
    return function () {
      document.removeEventListener('click', onOutsideClick, true);
    };
  }, []);
  var heading = useMemo(function () {
    return sender ? mustache.render(reaction.copy.heading.template, {
      sender: sender
    }) : reaction.copy.heading.static;
  }, [reaction.copy.heading, sender]);
  var pickerSubtitle = useMemo(function () {
    return sender ? mustache.render(reaction.copy.picker.subtitle.template, {
      sender: sender
    }) : reaction.copy.picker.subtitle.static;
  }, [reaction.copy.picker.subtitle.template, sender]);
  var renderQuickEmojiBar = function renderQuickEmojiBar() {
    return React$2.createElement("div", {
      className: styles$2.emojiBarContainer
    }, React$2.createElement("div", {
      className: classnames(styles$2.quickEmojiBar, _defineProperty2({}, styles$2.largeEmojiBar, solo))
    }, reaction.quickEmojis.map(function (emoji, index) {
      return React$2.createElement(Emoji, {
        key: "".concat(emoji).concat(index),
        value: emoji,
        disabled: showPicker,
        onClick: onEmojiSelected
      });
    }), React$2.createElement(EmojiPickerButton, {
      isOpen: showPicker,
      onClick: function onClick() {
        setShowPicker(!showPicker);
      }
    })), React$2.createElement(FormError, {
      className: styles$2.error
    }, error));
  };
  var renderEmojiPicker = function renderEmojiPicker() {
    return React$2.createElement("div", {
      className: classnames(styles$2.picker, _defineProperty2({}, styles$2.showPicker, showPicker))
    }, React$2.createElement("div", {
      className: styles$2.pickerCopy
    }, React$2.createElement(Body_4, null, reaction.copy.picker.title), React$2.createElement(Small_1, null, pickerSubtitle)), React$2.createElement(EmojiPicker$1, {
      emojiStyle: EmojiStyle.NATIVE,
      previewConfig: {
        showPreview: false
      },
      width: 264,
      onEmojiClick: function onEmojiClick(_ref122) {
        var emoji = _ref122.emoji;
        onEmojiSelected(emoji);
        setShowPicker(false);
      }
    }));
  };
  var renderSelectedEmoji = function renderSelectedEmoji() {
    return React$2.createElement("div", {
      className: styles$2.selectedEmoji
    }, React$2.createElement(Emoji, {
      value: String(value),
      size: "32px"
    }));
  };
  return React$2.createElement("div", {
    ref: ref,
    style: {
      width: 'fit-content'
    }
  }, React$2.createElement(Body_2, {
    className: classnames(styles$2.container, _defineProperty2(_defineProperty2({}, styles$2.soloPicked, solo && hasPickedEmoji), styles$2.solo, solo))
  }, loading && React$2.createElement(Loader, {
    className: classnames(styles$2.loader, _defineProperty2({}, styles$2.soloLoader, solo))
  }), React$2.createElement("div", {
    className: classnames(styles$2.main, _defineProperty2(_defineProperty2({}, styles$2.selectedPaddingTop, solo && hasPickedEmoji), styles$2.hidden, loading))
  }, !hasPickedEmoji && React$2.createElement(Small_1, {
    className: styles$2.message
  }, heading), React$2.createElement("div", {
    className: styles$2.pickerRow
  }, hasPickedEmoji ? renderSelectedEmoji() : renderQuickEmojiBar())), renderEmojiPicker()));
};
var styles$1 = {
  "container": "reactable-message-module_container__FqB8B",
  "withMessage": "reactable-message-module_withMessage__CKe5O",
  "title": "reactable-message-module_title__tYKQ1",
  "bottomPadding": "reactable-message-module_bottomPadding__aNjwk",
  "margins": "reactable-message-module_margins__5Ie2f",
  "control": "reactable-message-module_control__K4KZ1",
  "offset": "reactable-message-module_offset__AsoQl",
  "showControl": "reactable-message-module_showControl__eqO0G",
  "reactedWithNoMessage": "reactable-message-module_reactedWithNoMessage__E4RrF"
};
var ReactableMessage = function ReactableMessage(_ref123) {
  var _ref123$message = _ref123.message,
    message = _ref123$message === void 0 ? '' : _ref123$message,
    _ref123$senderName = _ref123.senderName,
    senderName = _ref123$senderName === void 0 ? '' : _ref123$senderName,
    _ref123$animate = _ref123.animate,
    animate = _ref123$animate === void 0 ? true : _ref123$animate,
    onEmojiReaction = _ref123.onEmojiReaction,
    onAnimationComplete = _ref123.onAnimationComplete,
    emoji = _ref123.emoji,
    title = _ref123.title,
    _ref123$loading = _ref123.loading,
    loading = _ref123$loading === void 0 ? false : _ref123$loading,
    _ref123$error = _ref123.error,
    error = _ref123$error === void 0 ? '' : _ref123$error,
    _ref123$reactionDisab = _ref123.reactionDisabled,
    reactionDisabled = _ref123$reactionDisab === void 0 ? false : _ref123$reactionDisab;
  var _useState50 = useState(0),
    _useState51 = _slicedToArray(_useState50, 2),
    animationPhase = _useState51[0],
    setAnimationPhase = _useState51[1];
  var _useState52 = useState(Boolean(emoji)),
    _useState53 = _slicedToArray(_useState52, 2),
    hasPickedEmoji = _useState53[0],
    setHasPickedEmoji = _useState53[1];
  useEffect(function () {
    setHasPickedEmoji(Boolean(emoji));
  }, [emoji]);
  useEffect(function () {
    if (animationPhase === 1) {
      var timer = setTimeout(function () {
        if (onAnimationComplete) {
          onAnimationComplete();
        }
      }, 500);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [animationPhase]);
  var hasFinishedAnimation = !animate || !message || animationPhase === 1;
  var onEmojiSelected = function onEmojiSelected(selectedEmoji) {
    onEmojiReaction(selectedEmoji);
  };
  var _useThemeContext24 = useThemeContext(),
    themeEnabled = _useThemeContext24.reaction.enabled;
  var enabled = themeEnabled && !reactionDisabled;
  return React$2.createElement(React$2.Fragment, null, React$2.createElement(Heading_3, {
    className: styles$1.title
  }, title), React$2.createElement("div", {
    className: classnames(styles$1.container, _defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({}, styles$1.withMessage, enabled && message), styles$1.reactedWithNoMessage, !message && hasPickedEmoji), styles$1.margins, enabled && !message), styles$1.bottomPadding, !hasFinishedAnimation || !enabled))
  }, message && React$2.createElement(MessageBubble, {
    message: message,
    animate: animate,
    onAnimationComplete: function onAnimationComplete() {
      setAnimationPhase(1);
    },
    extraHeight: hasFinishedAnimation && enabled ? '20px' : '0px'
  }), enabled && React$2.createElement("div", {
    className: classnames(styles$1.control, _defineProperty2(_defineProperty2({}, styles$1.showControl, hasFinishedAnimation), styles$1.offset, Boolean(message)))
  }, hasFinishedAnimation && React$2.createElement(EmojiControl, {
    loading: loading,
    value: emoji,
    onEmojiSelected: onEmojiSelected,
    onEmojiEdit: function onEmojiEdit() {
      setHasPickedEmoji(false);
    },
    sender: senderName,
    solo: !message,
    error: error
  }))));
};
var styles = {
  "container": "reaction-comment-module_container__yByOj",
  "border": "reaction-comment-module_border__Sg4dG",
  "form": "reaction-comment-module_form__qZ-t-",
  "bubble": "reaction-comment-module_bubble__kQTjH",
  "error": "reaction-comment-module_error__DaOxo"
};

// Values from the form boundary retain native string coercion.
var displayFormValue = function displayFormValue(value) {
  return String(value);
};
var ReactionComment = function ReactionComment(_ref124) {
  var _onConfirm = _ref124.onConfirm,
    _ref124$loading = _ref124.loading,
    loading = _ref124$loading === void 0 ? false : _ref124$loading,
    _ref124$value = _ref124.value,
    value = _ref124$value === void 0 ? '' : _ref124$value,
    _ref124$error = _ref124.error,
    error = _ref124$error === void 0 ? '' : _ref124$error;
  var _useThemeContext25 = useThemeContext(),
    comment = _useThemeContext25.reaction.copy.comment;
  var renderValue = function renderValue() {
    return React$2.createElement("div", {
      className: styles.bubble
    }, React$2.createElement(MessageBubble, {
      animate: false,
      fromSelf: true,
      message: value
    }));
  };
  var renderForm = function renderForm() {
    return React$2.createElement("div", {
      className: styles.border
    }, React$2.createElement(Heading_3, null, comment.heading), React$2.createElement("div", {
      className: styles.form
    }, React$2.createElement(FormBody, {
      model: [{
        name: 'message',
        elementType: ElementType.TextArea,
        placeholder: comment.labels.message,
        optional: true,
        displayOptional: true
      }, {
        name: 'name',
        elementType: ElementType.String,
        placeholder: comment.labels.name,
        optional: true,
        displayOptional: true
      }],
      buttonCopy: comment.button,
      onConfirm: function onConfirm(_ref125) {
        var _ref125$message = _ref125.message,
          message = _ref125$message === void 0 ? '' : _ref125$message,
          _ref125$name = _ref125.name,
          name = _ref125$name === void 0 ? '' : _ref125$name;
        _onConfirm(displayFormValue(message), displayFormValue(name));
      }
    }), React$2.createElement(FormError, {
      className: styles.error
    }, error)));
  };
  if (loading) {
    return React$2.createElement("div", {
      className: styles.container
    }, React$2.createElement(Loader, null));
  }
  return React$2.createElement("div", {
    className: styles.container
  }, value ? renderValue() : renderForm());
};
export { Accordion, Arrow, Body_1, Body_2, Body_3, Body_4, Button$1 as Button, ButtonArrowState, ButtonType, Carousel, CarouselButtonType, Checkmark, CloseCross, ConfirmationGate, CookieConsentContextProvider, DefaultFormModel, DefaultOperatorModel, DefaultThemeModel, Divider, ErrorAlert, FontFamily, Footer_1, Footer_2, Form, FormBody, FormError, GiftWrap, Heading_1, Heading_2, Heading_3, Heading_4, Help, InfoAlert, Lede, Link, Loader, Logo, Markdown, MessageBubble, Modal, Notice, Panel, PrimaryButton, ReactableMessage, ReactionComment, SecondaryButton, Small_1, Small_2, StandardAlert, SuccessAlert, TertiaryButton, ThemeContextProvider, Title, Toggle, Typography, WarningAlert, useCookieConsentContext, useThemeContext };